export default [
  {
    name: "Roddy Ricch",
    image: "https://i.scdn.co/image/020e997fb003cf666859a90b57ca0519df769d30",
    spotify: "757aE44tKEUQEqRuT6GnEB",
    genre: "melodic rap,rap",
    popularity: "93",
  },
  {
    name: "Chris Brown",
    image: "https://i.scdn.co/image/e153d6448b17ce97b2a79da70d64b89230c67053",
    spotify: "7bXgB6jMjp9ATFy66eO08Z",
    genre: "dance pop,pop,pop rap,r&b,rap",
    popularity: "91",
  },
  {
    name: "Lil Uzi Vert",
    image: "https://i.scdn.co/image/271c672ac7a84a95f3c557177a29b8936923d152",
    spotify: "4O15NlyKLIASxsJ0PrXPfz",
    genre: "melodic rap,philly rap,rap",
    popularity: "91",
  },
  {
    name: "Tyga",
    image: "https://i.scdn.co/image/c498995c045e4ecff35e3f22e4950a82b5b781d4",
    spotify: "5LHRHt1k9lMyONurDHEdrp",
    genre: "hip hop,pop rap,rap,trap",
    popularity: "89",
  },
  {
    name: "Tory Lanez",
    image: "https://i.scdn.co/image/de0fd96b002bba9f13e90fd986c6dbf647f78e7c",
    spotify: "2jku7tDXc6XoB6MO2hFuqg",
    genre: "canadian hip hop,melodic rap,pop rap,rap,toronto rap,trap",
    popularity: "88",
  },
  {
    name: "Avicii",
    image: "https://i.scdn.co/image/81b19a403109c4fe528ee3972137127b85be9519",
    spotify: "1vCWHaC5f2uS3yhpwWbIA6",
    genre: "big room,dance pop,edm,pop",
    popularity: "85",
  },
  {
    name: "Robin Schulz",
    image: "https://i.scdn.co/image/79c91f7ea8d3141f1cf763e92be9a48f2641afe8",
    spotify: "3t5xRXzsuZmMDkQzgOX35S",
    genre:
      "dance pop,deep euro house,deep house,edm,german dance,pop,tropical house",
    popularity: "84",
  },
  {
    name: "Martin Garrix",
    image: "https://i.scdn.co/image/19b193e731a99776449d2b06742942e1e1f58fb2",
    spotify: "60d24wfXkVzDSfLS6hyCjZ",
    genre: "big room,edm,electro house,pop,progressive house,tropical house",
    popularity: "83",
  },
  {
    name: "R3HAB",
    image: "https://i.scdn.co/image/a157c6e13ffffd135f1465d18103c774d20d053b",
    spotify: "6cEuCEZu7PAE9ZSzLLc2oQ",
    genre:
      "big room,dutch house,edm,electro house,pop,progressive electro house,tropical house",
    popularity: "83",
  },
  {
    name: "Topic",
    image: "https://i.scdn.co/image/33b6c42382fcc9bceda7bbc9c89b77465bdc7a0d",
    spotify: "0u6GtibW46tFX7koQ6uNJZ",
    genre: "german dance,pop edm,tropical house",
    popularity: "83",
  },
  {
    name: "Sean Paul",
    image: "https://i.scdn.co/image/e15025ccdfab6e62b9c2b391e4e5f44bac36a3db",
    spotify: "3Isy6kedDrgPYoTS1dazA9",
    genre: "dance pop,dancehall,pop,pop rap",
    popularity: "82",
  },
  {
    name: "Rick Ross",
    image: "https://i.scdn.co/image/d385491147314cbbe2826da3a379902891f97213",
    spotify: "1sBkRIssrMs1AbVkOJbc7a",
    genre:
      "dirty south rap,gangster rap,hip hop,pop rap,rap,southern hip hop,trap",
    popularity: "82",
  },
  {
    name: "French Montana",
    image: "https://i.scdn.co/image/14443f9c4ab806e91aee7feaad4f90b91f29f7b6",
    spotify: "6vXTefBL93Dj5IqAWq6OTv",
    genre: "hip hop,pop rap,rap,southern hip hop,trap",
    popularity: "82",
  },
  {
    name: "Major Lazer",
    image: "https://i.scdn.co/image/093b23f613441e9b90070939795f3109386edbb4",
    spotify: "738wLrAtLtCtFOLvQBXOXp",
    genre: "dance pop,edm,electro house,moombahton,pop,pop rap",
    popularity: "82",
  },
  {
    name: "Alok",
    image: "https://i.scdn.co/image/339b4f2b8fa072d2130ad69cd603919e6279258e",
    spotify: "0NGAZxHanS9e0iNHpR8f2W",
    genre: "brazilian edm,electro house,pop nacional",
    popularity: "81",
  },
  {
    name: "Jeremih",
    image: "https://i.scdn.co/image/48e38236955edc0ac5dbe291992dbf82a90e6d6d",
    spotify: "3KV3p5EY4AvKxOlhGHORLg",
    genre:
      "chicago rap,dance pop,pop,pop rap,r&b,southern hip hop,trap,urban contemporary",
    popularity: "81",
  },
  {
    name: "T-Pain",
    image: "https://i.scdn.co/image/90890e95f26516915b4862f2b399739bb394239f",
    spotify: "3aQeKQSyrW4qWr35idm0cy",
    genre:
      "dance pop,hip hop,pop,pop rap,r&b,rap,southern hip hop,trap,urban contemporary",
    popularity: "81",
  },
  {
    name: "Sam Feldt",
    image: "https://i.scdn.co/image/7d85234afc83df9951394e9d6cb76d1fe983e0fb",
    spotify: "20gsENnposVs2I4rQ5kvrf",
    genre: "dance pop,edm,pop,pop edm,tropical house",
    popularity: "80",
  },
  {
    name: "Becky Hill",
    image: "https://i.scdn.co/image/ebe548ef0f5881921687fb88c854461ffb755861",
    spotify: "4EPJlUEBy49EX1wuFOvtjK",
    genre: "dance pop,house,pop,pop house,tropical house,uk dance,uk pop",
    popularity: "80",
  },
  {
    name: "Steve Aoki",
    image: "https://i.scdn.co/image/bd878e687c252c80424d3dfd3758032f59447211",
    spotify: "77AiFEVeAVj2ORpC85QVJs",
    genre: "big room,dance pop,edm,electro house,tropical house",
    popularity: "80",
  },
  {
    name: "bbno$",
    image: "https://i.scdn.co/image/a84b5c64405a28e3102c4b98397be9ad403e2c49",
    spotify: "41X1TR6hrK8Q2ZCpp2EqCz",
    genre: "canadian hip hop,dark trap,vapor trap",
    popularity: "80",
  },
  {
    name: "Armin van Buuren",
    image: "https://i.scdn.co/image/4c6dab89eacc99971af32ab6fe0df0553531fbda",
    spotify: "0SfsnGyD8FpIN4U4WCkBZ5",
    genre: "dutch trance,edm,progressive house,trance",
    popularity: "78",
  },
  {
    name: "Dimitri Vegas & Like Mike",
    image: "https://i.scdn.co/image/89cbcebacfb4706f5adc8fe1a409f4f433a15412",
    spotify: "73jBynjsVtofjRpdpRAJGk",
    genre:
      "belgian dance,belgian edm,big room,edm,electro house,progressive electro house,tropical house",
    popularity: "78",
  },
  {
    name: "Boef",
    image: "https://i.scdn.co/image/2efa5ebb01e3f0449c71c91587f6959aa23bf9c3",
    spotify: "0Jsk5iYMr5aNjHury7blm1",
    genre: "dutch hip hop",
    popularity: "78",
  },
  {
    name: "Alesso",
    image: "https://i.scdn.co/image/2b365693847177310dcb17992156c0a31fd4a925",
    spotify: "4AVFqumd2ogHFlRbKIjp1t",
    genre:
      "big room,dance pop,edm,electro house,pop,progressive electro house,tropical house",
    popularity: "78",
  },
  {
    name: "Vintage Culture",
    image: "https://i.scdn.co/image/9a233a247eae51dad87a44c94dcb8874b91f8f02",
    spotify: "28uJnu5EsrGml2tBd7y8ts",
    genre: "brazilian edm",
    popularity: "77",
  },
  {
    name: "Martin Jensen",
    image: "https://i.scdn.co/image/aa7eacb7370cb7d8dfbf054d3e9bfb3f8926d65d",
    spotify: "4ehtJnVumNf6xzSCDk8aLB",
    genre:
      "big room,dance pop,danish electronic,edm,electro house,pop,pop edm,tropical house",
    popularity: "77",
  },
  {
    name: "Wale",
    image: "https://i.scdn.co/image/20a2669aad3e87270699534ed03546ff87b20df2",
    spotify: "67nwj3Y5sZQLl72VNUHEYE",
    genre:
      "dance pop,hip hop,pop,pop rap,r&b,rap,southern hip hop,trap,urban contemporary",
    popularity: "77",
  },
  {
    name: "Nelly",
    image: "https://i.scdn.co/image/3677690af58abb70a5c5fd58d69db4d1ad705d4f",
    spotify: "2gBjLmx6zQnFGQJCAQpRgw",
    genre:
      "dance pop,hip hop,pop,pop rap,rap,southern hip hop,st louis rap,urban contemporary",
    popularity: "77",
  },
  {
    name: "Trey Songz",
    image: "https://i.scdn.co/image/24d2af9d7f807fe744a157018cf0e0e9f9391f53",
    spotify: "2iojnBLj0qIMiKPvVhLnsH",
    genre: "dance pop,pop,r&b,southern hip hop,urban contemporary",
    popularity: "77",
  },
  {
    name: "Sigala",
    image: "https://i.scdn.co/image/a695b7c23e8f6ab695129491ed18d0fe6c6c1846",
    spotify: "1IueXOQyABrMOprrzwQJWN",
    genre: "dance pop,edm,pop,tropical house",
    popularity: "77",
  },
  {
    name: "Don Diablo",
    image: "https://i.scdn.co/image/8e300462ea539531b1640897fed77380cb7e14e0",
    spotify: "1l2ekx5skC4gJH8djERwh1",
    genre:
      "big room,deep big room,edm,electro house,future house,house,pop,pop edm,progressive electro house,tropical house",
    popularity: "76",
  },
  {
    name: "Lost Frequencies",
    image: "https://i.scdn.co/image/f1939ac538352cc77c43f24db2d9ce5fa1ac0e3b",
    spotify: "7f5Zgnp2spUuuzKplmRkt7",
    genre: "belgian edm,edm,pop,tropical house",
    popularity: "76",
  },
  {
    name: "Afrojack",
    image: "https://i.scdn.co/image/903c3b850a41b7b8bfaa47625ea1d6477875f984",
    spotify: "4D75GcNG95ebPtNvoNVXhz",
    genre:
      "big room,dance pop,deep big room,dutch house,edm,electro house,pop,progressive electro house,progressive house,tropical house",
    popularity: "76",
  },
  {
    name: "TINI",
    image: "https://i.scdn.co/image/db832eb62d8278ed0ee617421e08e98f90703fa6",
    spotify: "7vXDAI8JwjW531ouMGbfcp",
    genre: "latin pop,pop argentino",
    popularity: "76",
  },
  {
    name: "B.o.B",
    image: "https://i.scdn.co/image/8f6d0d95d98fe8ceaf275f51b97674fb1f148c12",
    spotify: "5ndkK3dpZLKtBklKjxNQwT",
    genre: "atl hip hop,dance pop,hip hop,pop,pop rap,rap,southern hip hop",
    popularity: "76",
  },
  {
    name: "Skepta",
    image: "https://i.scdn.co/image/c2fc72a70dcc094844aaf02ad945fbbd0aeab777",
    spotify: "2p1fiYHYiXz9qi0JJyxBzN",
    genre: "birmingham grime,grime,instrumental grime,rap",
    popularity: "76",
  },
  {
    name: "Dolly Parton",
    image: "https://i.scdn.co/image/9945a66856dfa6876ec466f9825242a3d044808b",
    spotify: "32vWCbZh0xZ4o9gkz4PsEU",
    genre: "classic country pop,country,country dawn",
    popularity: "76",
  },
  {
    name: "Oliver Heldens",
    image: "https://i.scdn.co/image/f233c7454b078c7b9192c24d8f954e9cb0edcbbe",
    spotify: "5nki7yRhxgM509M5ADlN1p",
    genre:
      "big room,edm,electro house,future house,house,progressive electro house,progressive house,tropical house",
    popularity: "75",
  },
  {
    name: "Timmy Trumpet",
    image: "https://i.scdn.co/image/19f3fac006358960cd5ded1fcdb93847c5a8c7be",
    spotify: "0CbeG1224FS58EUx4tPevZ",
    genre:
      "australian dance,catstep,edm,melbourne bounce,melbourne bounce international",
    popularity: "75",
  },
  {
    name: "Jacquees",
    image: "https://i.scdn.co/image/4cfee7105792cf70d10d6c41572edacdba4aad40",
    spotify: "4tMm1dU6Gn04VAZ9ClHcIZ",
    genre:
      "atl hip hop,dance pop,deep pop r&b,pop,pop rap,r&b,rap,urban contemporary",
    popularity: "75",
  },
  {
    name: "Martin Solveig",
    image: "https://i.scdn.co/image/da3f8c4933a8ec02db2d97546660a12059cacded",
    spotify: "1bj5GrcLom5gZFF5t949Xl",
    genre:
      "big room,dance pop,disco house,edm,electro house,filter house,house,pop,tropical house,vocal house",
    popularity: "74",
  },
  {
    name: "The Score",
    image: "https://i.scdn.co/image/234287517385e6db043f11ad6316138e473c00aa",
    spotify: "2q3GG88dVwuQPF4FmySr9I",
    genre: "modern alternative rock,modern rock",
    popularity: "74",
  },
  {
    name: "Kid Ink",
    image: "https://i.scdn.co/image/92a89311631851defbc80ebcdff44ba3e78922cc",
    spotify: "6KZDXtSj0SzGOV705nNeh3",
    genre: "dance pop,hip hop,pop rap,rap,southern hip hop,trap",
    popularity: "74",
  },
  {
    name: "NIKI",
    image: "https://i.scdn.co/image/754813da52352d800786ff70623658a0885b107d",
    spotify: "2kxP07DLgs4xlWz8YHlvfh",
    genre: "indie r&b,indonesian r&b,pop",
    popularity: "74",
  },
  {
    name: "Ghostemane",
    image: "https://i.scdn.co/image/9e218c81e37501e76d252e1b614e5bd7740e4187",
    spotify: "3uL4UpqShC4p2x1dJutoRW",
    genre: "dark trap,emo rap,florida rap,underground hip hop",
    popularity: "74",
  },
  {
    name: "Mr Eazi",
    image: "https://i.scdn.co/image/4f9a778985687f9d7d38a6147f7a2e951452beeb",
    spotify: "4TAoP0f9OuWZUesao43xUW",
    genre:
      "afro dancehall,afropop,dancehall,ghanaian hip hop,nigerian pop,swedish dancehall",
    popularity: "73",
  },
  {
    name: "Sean Kingston",
    image: "https://i.scdn.co/image/ce0a4412aa74a2b7e591b23380e7b238678a1df3",
    spotify: "6S0dmVVn4udvppDhZIWxCr",
    genre: "dance pop,miami hip hop,pop,post-teen pop,urban contemporary",
    popularity: "73",
  },
  {
    name: "Purple Disco Machine",
    image: "https://i.scdn.co/image/266a53375f5a8ea2f3c3110476d8d2f630d433b1",
    spotify: "2WBJQGf1bT1kxuoqziH5g4",
    genre: "deep house,disco house,house,tropical house",
    popularity: "73",
  },
  {
    name: "Vicetone",
    image: "https://i.scdn.co/image/3c1198e4562b46733b2286986b29f311205a33f0",
    spotify: "0daugAjUgbJSqdlyYNwIbT",
    genre:
      "big room,catstep,edm,electro house,gaming edm,pop edm,progressive electro house,tropical house",
    popularity: "73",
  },
  {
    name: "Conor Maynard",
    image: "https://i.scdn.co/image/e1678c7ab4c18f772ab4d32da3ab11c9d5191d8d",
    spotify: "6mU8ucezzms5I2kNH6HNlu",
    genre: "dance pop,pop,post-teen pop,uk pop,viral pop",
    popularity: "73",
  },
  {
    name: "Mon Laferte",
    image: "https://i.scdn.co/image/b35c2a4cdc4d1abfdb6609bf901a3bde50f42a00",
    spotify: "4boI7bJtmB1L3b1cuL75Zr",
    genre: "latin,latin alternative,latin pop",
    popularity: "73",
  },
  {
    name: "Hardwell",
    image: "https://i.scdn.co/image/e05412842611fdfaf64b65acfd5d46a7da265b46",
    spotify: "6BrvowZBreEkXzJQMpL174",
    genre:
      "big room,dance pop,deep big room,dutch house,edm,electro house,progressive electro house,progressive house,tropical house",
    popularity: "72",
  },
  {
    name: "Lucas & Steve",
    image: "https://i.scdn.co/image/728781546e0f341d6efe3b965599e66191e39bcb",
    spotify: "5wwneIFdawNgQ7GvKK29Z3",
    genre: "big room,dance pop,edm,electro house,pop,pop edm,tropical house",
    popularity: "72",
  },
  {
    name: "Alle Farben",
    image: "https://i.scdn.co/image/315016388b88303a90251b1f8bb96b8b6de234f5",
    spotify: "61ipISvUVa5LkJlKZnm3Oo",
    genre: "deep euro house,edm,german dance,tropical house",
    popularity: "72",
  },
  {
    name: "Jonna Fraser",
    image: "https://i.scdn.co/image/858e891b5a1c5b21093c75e95ab186acfff9758c",
    spotify: "5adKMaYrGOMyOfnbiLPuHg",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "72",
  },
  {
    name: "Lil Kleine",
    image: "https://i.scdn.co/image/9494efefaf6e58d2e32d259911986facbeee68d6",
    spotify: "3AlRiyjMywTVNzTcHbf9QT",
    genre: "dutch hip hop,dutch pop",
    popularity: "72",
  },
  {
    name: "Tungevaag",
    image: "https://i.scdn.co/image/38961e1eb350e7fdd24afbb48ebb743513d9c9ac",
    spotify: "49CE2ffZ6Z3zeYSDauSKck",
    genre:
      "dance pop,deep pop edm,edm,nordic house,norwegian pop,tropical house",
    popularity: "72",
  },
  {
    name: "FISHER",
    image: "https://i.scdn.co/image/ff4068733156653f72e1af5aa66e1f207d1f9440",
    spotify: "1VJ0briNOlXRtJUAzoUJdt",
    genre: "australian house,house",
    popularity: "72",
  },
  {
    name: "Elderbrook",
    image: "https://i.scdn.co/image/8095e1d3c421a9e783d3d33dff9651c39194f604",
    spotify: "2vf4pRsEY6LpL5tKmqWb64",
    genre: "house,new french touch,tropical house",
    popularity: "72",
  },
  {
    name: "KSHMR",
    image: "https://i.scdn.co/image/827aa43e7c4ff41408c93a4598db908a34778309",
    spotify: "2wX6xSig4Rig5kZU6ePlWe",
    genre: "big room,deep big room,edm,electro house,indian edm,tropical house",
    popularity: "72",
  },
  {
    name: "Night Lovell",
    image: "https://i.scdn.co/image/0726cd2e06e65dfc76c2e1162cea25a288ed3c39",
    spotify: "2y246nnP9pQT0E6v3ZMMOO",
    genre: "canadian hip hop,dark trap,emo rap,ottawa rap,underground hip hop",
    popularity: "72",
  },
  {
    name: "James Taylor",
    image: "https://i.scdn.co/image/44733cccadc8a5045e35f638c6f852ceb581e13b",
    spotify: "0vn7UBvSQECKJm2817Yf1P",
    genre:
      "classic rock,folk,folk rock,mellow gold,rock,singer-songwriter,soft rock",
    popularity: "72",
  },
  {
    name: "Lisa",
    image: "https://i.scdn.co/image/2c297bc72fc48f1c1cfe7131d145550ff90d5455",
    spotify: "0blbVefuxOGltDBa00dspv",
    genre: "anime rock,j-pixie,otacore",
    popularity: "72",
  },
  {
    name: "Sofi Tukker",
    image: "https://i.scdn.co/image/b59dea5562ef9b32fa4d5fd981c05d473fadbfd4",
    spotify: "586uxXMyD5ObPuzjtrzO1Q",
    genre: "electropop",
    popularity: "72",
  },
  {
    name: "Bizzey",
    image: "https://i.scdn.co/image/0832c2b4c8df60a36e2ba13f72ac11e55a36f7cb",
    spotify: "5GIcOzVFTNnzArytjmTkW8",
    genre: "dutch hip hop,dutch pop",
    popularity: "71",
  },
  {
    name: "Mike Williams",
    image: "https://i.scdn.co/image/673913702289099037f91f934344cea311385a55",
    spotify: "3IpvVrP3VLhruTmnququq7",
    genre:
      "big room,deep big room,edm,electro house,future house,house,pop,pop edm,tropical house",
    popularity: "71",
  },
  {
    name: "Snelle",
    image: "https://i.scdn.co/image/ab6f7545786bf16444d36119d700eba3c126aa0e",
    spotify: "3E31HqA00iCX9nRhesw6LD",
    genre: "dutch hip hop,dutch pop",
    popularity: "71",
  },
  {
    name: "Ronnie Flex",
    image: "https://i.scdn.co/image/53fa38a74375175080449e8b763b1667f3544c07",
    spotify: "5eir5zFJpES4j7gsymbVyl",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "71",
  },
  {
    name: "Frenna",
    image: "https://i.scdn.co/image/e710702d47c7b2a697e8a99d4993a93bd62ca465",
    spotify: "6m1LYS5NQonxjOcQFPQOb5",
    genre: "dutch hip hop,dutch pop",
    popularity: "71",
  },
  {
    name: "Puri",
    image: "https://i.scdn.co/image/70278589ad9eb03cd0c19ef3f6eed2ae620d6bf1",
    spotify: "3ADyFy1orEwODaiHmRRMQp",
    genre: "basshall",
    popularity: "71",
  },
  {
    name: "Dopebwoy",
    image: "https://i.scdn.co/image/cdf39ae7a87da7493960fd77ed844619779d47bf",
    spotify: "6OQggpm01CmAB717TKtDCr",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "71",
  },
  {
    name: "Bruno Martini",
    image: "https://i.scdn.co/image/75f63af0a75ef59725ae91d827e1e11dbad33a92",
    spotify: "5veVxxPm1vzgi6pO2iVA8L",
    genre: "brazilian edm,pop nacional",
    popularity: "71",
  },
  {
    name: "Jhorrmountain",
    image: "https://i.scdn.co/image/c70486188e67a5ff72d1b94e61b2ac17875178ec",
    spotify: "3aAX2y0amckZ7WcWoz2f2o",
    genre: "dutch hip hop",
    popularity: "71",
  },
  {
    name: "Young Dolph",
    image: "https://i.scdn.co/image/499ac9895d3ce557f13ad231795fd42d7995a098",
    spotify: "3HiuzBlSW7pGDXlSFMhO2g",
    genre: "gangster rap,hip hop,rap,southern hip hop,tennessee hip hop,trap",
    popularity: "71",
  },
  {
    name: "CamelPhat",
    image: "https://i.scdn.co/image/d2b47332d3c7e04bbf9a0570c564cb9c3dadd7f9",
    spotify: "240wlM8vDrf6S4zCyzGj2W",
    genre:
      "deep tech house,disco house,edm,house,progressive house,tropical house",
    popularity: "71",
  },
  {
    name: "Kaskade",
    image: "https://i.scdn.co/image/97d416a8ffb59ec86022434ce323ee01f5c8e265",
    spotify: "6TQj5BFPooTa08A7pk8AQ1",
    genre:
      "big room,chicago house,edm,electro house,electropop,house,pop,progressive house,tropical house,vocal house",
    popularity: "71",
  },
  {
    name: "Elodie",
    image: "https://i.scdn.co/image/63989ec84a2500f369997c0344c568c3cd9f77e9",
    spotify: "7GgpsUpkj3olseoaTY7TEY",
    genre: "italian arena pop,italian pop",
    popularity: "71",
  },
  {
    name: "August Alsina",
    image: "https://i.scdn.co/image/d09701a6cc6e3126c611b4170599c26bc58a9a52",
    spotify: "19Fi1Rj7kk8kyiwxpXy3yM",
    genre: "dance pop,deep pop r&b,pop,pop rap,r&b,trap,urban contemporary",
    popularity: "71",
  },
  {
    name: "Manu Chao",
    image: "https://i.scdn.co/image/1f4dbd46881519c862e033f3a689ce4ec32be6f2",
    spotify: "6wH6iStAh4KIaWfuhf0NYM",
    genre: "latin alternative,world",
    popularity: "71",
  },
  {
    name: "Sevn Alias",
    image: "https://i.scdn.co/image/7c4e4cf1d0b928ca36deacaba3a2ff9037f5a18f",
    spotify: "0HDMwoCS316xhKCZlJPBnc",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "71",
  },
  {
    name: "Nicky Romero",
    image: "https://i.scdn.co/image/f74f42d086a625f39f5d5884857110dcccacfc59",
    spotify: "5ChF3i92IPZHduM7jN3dpg",
    genre:
      "big room,deep big room,dutch edm,edm,electro house,pop edm,progressive electro house,progressive house,tropical house",
    popularity: "70",
  },
  {
    name: "Kris Kross Amsterdam",
    image: "https://i.scdn.co/image/d943d0f77d7a22a680063c44fb097b1890f59273",
    spotify: "4LcUpNlXFEleaLlelmkv2R",
    genre: "dutch house,dutch pop,tropical house",
    popularity: "70",
  },
  {
    name: "HUGEL",
    image: "https://i.scdn.co/image/7c9f47a4d8f6e9cc4b15dff67977be467ffc5256",
    spotify: "5PlfkPxwCpRRWQJBxCa0By",
    genre: "deep house,tropical house",
    popularity: "70",
  },
  {
    name: "Josylvio",
    image: "https://i.scdn.co/image/446df1a27ebe38281141ba7f51c58ee080d6f223",
    spotify: "1wFoE1RwBMWoWkXcFrCgsx",
    genre: "dutch hip hop",
    popularity: "70",
  },
  {
    name: "Ofenbach",
    image: "https://i.scdn.co/image/41005876244f8656279dc9900aa26f0f97d06aa2",
    spotify: "4AKwRarlmsUlLjIwt38NLw",
    genre: "new french touch,tropical house",
    popularity: "70",
  },
  {
    name: "Blondie",
    image: "https://i.scdn.co/image/dbd371b220a054a542279f499fc024044bece495",
    spotify: "4tpUmLEVLCGFr93o8hFFIB",
    genre:
      "candy pop,dance rock,new wave,new wave pop,permanent wave,power pop,rock",
    popularity: "70",
  },
  {
    name: "Steve Void",
    image: "https://i.scdn.co/image/ab869897641127ef79a74eb171d4ad41e4e0a0ff",
    spotify: "3WSK3JppX3N41XHVwQp7Gt",
    genre: "pop edm",
    popularity: "70",
  },
  {
    name: "SLANDER",
    image: "https://i.scdn.co/image/e8b64102ee7b4fde6dded0e16be6e099d9a874a4",
    spotify: "20DZAfCuP1TKZl5KcY7z3Q",
    genre: "brostep,edm,electro house,electronic trap,pop edm",
    popularity: "70",
  },
  {
    name: "M Huncho",
    image: "https://i.scdn.co/image/f1126f1780bc6293302f4f7f98be3bfb9b395527",
    spotify: "491U1PrV1EoQuhM0aUCn9r",
    genre: "uk hip hop",
    popularity: "70",
  },
  {
    name: "KitschKrieg",
    image: "https://i.scdn.co/image/d92947196753b1bd747893dd39c8776a6667d703",
    spotify: "5tHiL8SKSaZGMBUPIiSmX4",
    genre: "german hip hop,hamburg hip hop",
    popularity: "70",
  },
  {
    name: "Yellow Claw",
    image: "https://i.scdn.co/image/971b176993dd8a72bbce14ac1cc50fa8fb8db9e1",
    spotify: "47z7ZrgFoBvVpCnElCE3Zh",
    genre: "bass trap,brostep,edm,electro house,electronic trap",
    popularity: "69",
  },
  {
    name: "Bakermat",
    image: "https://i.scdn.co/image/4c46805193470bdfc9e448df6c13be526a59c7a7",
    spotify: "3MyFDtqB80WZvbtCZRsekM",
    genre:
      "deep euro house,deep house,deep tropical house,minimal tech house,new french touch,tropical house",
    popularity: "69",
  },
  {
    name: "Afro Bros",
    image: "https://i.scdn.co/image/7e4ef29a30400772d1032192e81dfd5c67fc879e",
    spotify: "3wtMPMvPtiFylbnNXF6CAj",
    genre: "basshall,dutch hip hop,dutch house,dutch trap pop",
    popularity: "69",
  },
  {
    name: "Cat Dealers",
    image: "https://i.scdn.co/image/d18676d797cb12e08bbee92a8a3d3a080c87ffb3",
    spotify: "3q2dSq7VZnj8TmoJUyRm40",
    genre: "brazilian edm,funk carioca",
    popularity: "69",
  },
  {
    name: "Chivv",
    image: "https://i.scdn.co/image/5cd80a5ae3753805d0958fbe1c49f00648985790",
    spotify: "2hBfmHHnM4dS4pJgEJENCg",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "69",
  },
  {
    name: "Riton",
    image: "https://i.scdn.co/image/e1048ed5f0d547fa50b281a9d374ddc8dc9c693a",
    spotify: "7i9j813KFoSBMldGqlh2Z1",
    genre: "house,uk dance",
    popularity: "69",
  },
  {
    name: "Bryan Mg",
    image: "https://i.scdn.co/image/a9e8bae5dc2316ad7da44e3fef54fc2218cf7b85",
    spotify: "1PyToLP6F2rzV0ZSR71lgl",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "69",
  },
  {
    name: "Jay Sean",
    image: "https://i.scdn.co/image/5802cbd4236451a2ae39d213fd087fa925bfca1c",
    spotify: "4pADjHPWyrlAF0FA7joK2H",
    genre: "dance pop,pop,pop rap,post-teen pop,urban contemporary",
    popularity: "69",
  },
  {
    name: "Tujamo",
    image: "https://i.scdn.co/image/3750d0a24b696ffa03ec2e319dcecfbd6bb42962",
    spotify: "2vVNxGBvKRQMWwI5c8KmYh",
    genre:
      "big room,dance pop,edm,electro house,progressive electro house,tropical house",
    popularity: "69",
  },
  {
    name: "OMI",
    image: "https://i.scdn.co/image/2777a98213ec412317ea177edc8615e2fdee8be5",
    spotify: "5MouCg6ta7zAxsfMEbc1uh",
    genre: "dance pop,tropical house",
    popularity: "69",
  },
  {
    name: "Far East Movement",
    image: "https://i.scdn.co/image/93b2785adf676fad08b852122e6e48753c3d966b",
    spotify: "698hF4vcwHwPy8ltmXermq",
    genre: "asian american hip hop,dance pop,edm,pop,pop rap",
    popularity: "69",
  },
  {
    name: "Set It Off",
    image: "https://i.scdn.co/image/ac00cb9dfe6a04aeffb042fa6f0521ecd64f7585",
    spotify: "06bDwgCHeMAwhgI8il4Y5k",
    genre: "electropowerpop,modern rock,otacore,pixie,pop punk,rock",
    popularity: "69",
  },
  {
    name: "Princess Nokia",
    image: "https://i.scdn.co/image/017dd2cb4be7ded45076a720bc4fe4612016a483",
    spotify: "6lay1nwbE6hTx1jivysUAL",
    genre: "escape room,lgbtq+ hip hop,pop,trap queen",
    popularity: "69",
  },
  {
    name: "Eric Bellinger",
    image: "https://i.scdn.co/image/0a355d37d911e5004ce1500a58a738597abc3879",
    spotify: "7ibAWtDtmEfaVhc1FJ3Vl9",
    genre: "dance pop,deep pop r&b,pop,pop rap,r&b,rap,trap,urban contemporary",
    popularity: "69",
  },
  {
    name: "Quintino",
    image: "https://i.scdn.co/image/58099662cf68958afcb9c880e48b1f2ee4feedf9",
    spotify: "1V3VTM7VspiQjcmRhC010n",
    genre:
      "big room,deep big room,dutch edm,dutch house,edm,electro house,electronic trap,progressive electro house,progressive house",
    popularity: "68",
  },
  {
    name: "Kungs",
    image: "https://i.scdn.co/image/4cb2f80570390781aa74fe3df6724a5cee9d2fa0",
    spotify: "7keGfmQR4X5w0two1xKZ7d",
    genre: "deep tropical house,edm,new french touch,tropical house",
    popularity: "68",
  },
  {
    name: "Showtek",
    image: "https://i.scdn.co/image/b22ef360494de5f32bdacdc8f8a40401df311bce",
    spotify: "3gk0OYeLFWYupGFRHqLSR7",
    genre:
      "big room,classic hardstyle,deep big room,edm,electro house,euphoric hardstyle,progressive electro house,progressive house",
    popularity: "68",
  },
  {
    name: "KVSH",
    image: "https://i.scdn.co/image/af12458aac160876051004d8b7b37e16d1021a19",
    spotify: "2uGKgNuq7MnKksXiSO6HjB",
    genre: "brazilian edm,trance brasileiro",
    popularity: "68",
  },
  {
    name: "Zonderling",
    image: "https://i.scdn.co/image/bf3bd895bd9f61470e9486d068ae4056bc826d3d",
    spotify: "0bMKf3lIYR9GaNTdFKkTOr",
    genre:
      "big room,deep big room,edm,electro house,house,pop edm,progressive electro house,progressive house",
    popularity: "68",
  },
  {
    name: "Brennan Heart",
    image: "https://i.scdn.co/image/154466007a17c391d9471ebfc8ca378c30ad0350",
    spotify: "5QySqc6yAFDx9m7fedFZmC",
    genre: "classic hardstyle,euphoric hardstyle,rawstyle",
    popularity: "68",
  },
  {
    name: "Yves V",
    image: "https://i.scdn.co/image/9e94112ddf3e1299ff719a56b2149d7c02db180a",
    spotify: "47BEc2RoW53owMyxacXWdV",
    genre:
      "belgian edm,big room,brazilian edm,deep big room,edm,electro house,house,pop edm,progressive electro house,progressive house,tropical house",
    popularity: "68",
  },
  {
    name: "Benny Benassi",
    image: "https://i.scdn.co/image/0a8ca53d47fcbad4b44e563a87608d5b993b1a6f",
    spotify: "4Ws2otunReOa6BbwxxpCt6",
    genre: "big room,disco house,edm,electro house",
    popularity: "68",
  },
  {
    name: "DVBBS",
    image: "https://i.scdn.co/image/c71b972e66c7cdfe1415605c9aa18f8c8b92db8d",
    spotify: "5X4LWwbUFNzPkEas04uU82",
    genre:
      "big room,canadian electronic,deep big room,edm,electro house,tropical house",
    popularity: "68",
  },
  {
    name: "Henkie T",
    image: "https://i.scdn.co/image/0ec806edd89da9b734239a9cd646be8a1d788c2d",
    spotify: "3n51Vz9Zb9aFmoXmXZ50El",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "68",
  },
  {
    name: "Cedric Gervais",
    image: "https://i.scdn.co/image/aa8b799ffde6cc2c8fd9d8d5b7d138ee01c83ac9",
    spotify: "4Wjf8diP59VmPG7fi4y724",
    genre:
      "big room,edm,electro house,house,progressive electro house,progressive house",
    popularity: "68",
  },
  {
    name: "Trettmann",
    image: "https://i.scdn.co/image/39807918551b3150f79536d883c3f7b6e52c1cf9",
    spotify: "6QzzeKV0VcnT2vJMYDPuL4",
    genre: "german cloud rap,german hip hop,hamburg hip hop",
    popularity: "68",
  },
  {
    name: "Matt Simons",
    image: "https://i.scdn.co/image/5b04228ef891f34ff9d2cfa2668ec307ba78e8c5",
    spotify: "1g0fXhQMHAxlRyIBkCbuE7",
    genre: "dutch pop,neo mellow,neo-singer-songwriter,pop,tropical house",
    popularity: "68",
  },
  {
    name: "Bob Sinclar",
    image: "https://i.scdn.co/image/9e869d33c04f06ecb51db3b34f0135f4e131b5e0",
    spotify: "5YFS41yoX0YuFY39fq21oN",
    genre: "dance pop,disco house,edm,electro house,filter house,vocal house",
    popularity: "68",
  },
  {
    name: "Coolio",
    image: "https://i.scdn.co/image/bdf1030866c0daf84db845d41c25e738fd7d7bdd",
    spotify: "3y24n3XhZ96wgwRXjvS17T",
    genre: "g funk,gangster rap,hip hop,rap,west coast rap",
    popularity: "68",
  },
  {
    name: "Claptone",
    image: "https://i.scdn.co/image/0e3c784c126afb8fbdf2f645e3b2fa1c1561f68c",
    spotify: "4mncDFjVLUa3s025Tct3Ry",
    genre:
      "deep disco house,german house,german techno,house,progressive house,tropical house",
    popularity: "67",
  },
  {
    name: "Bassjackers",
    image: "https://i.scdn.co/image/acdd5fb2979f90ea04b5b4c10a339cbbfa19aa78",
    spotify: "6xQvQwZQQuq9R3TdPNbcR8",
    genre:
      "bass trap,big room,dance pop,deep big room,dutch house,edm,electro house,progressive electro house,progressive house",
    popularity: "67",
  },
  {
    name: "Da Tweekaz",
    image: "https://i.scdn.co/image/9f87766f1cb40faaaaeeba16ddeabed8cd74411c",
    spotify: "6UOk7DmvqlzWmo6gjhZvn6",
    genre: "classic hardstyle,euphoric hardstyle,rawstyle",
    popularity: "67",
  },
  {
    name: "Sonny Fodera",
    image: "https://i.scdn.co/image/77d8d0bfd7ab6b706e95c756b605682a58b77592",
    spotify: "39B7ChWwrWDs7zXlsu3MoP",
    genre:
      "deep groove house,deep house,disco house,house,tropical house,uk dance",
    popularity: "67",
  },
  {
    name: "Michael Schulte",
    image: "https://i.scdn.co/image/37d365a768dfd331123db43bd22ffcc4945856ec",
    spotify: "21aa4pj9BvbFB2iT8kRpnq",
    genre: "german pop,indie cafe pop,pop,viral pop",
    popularity: "67",
  },
  {
    name: "Chris Lake",
    image: "https://i.scdn.co/image/b5a5ac37867b209a77e5448152b2861e1ff0a333",
    spotify: "5Igpc9iLZ3YGtKeYfSrrOE",
    genre:
      "bass house,edm,electro house,house,melbourne bounce,progressive house",
    popularity: "67",
  },
  {
    name: "Vini Vici",
    image: "https://i.scdn.co/image/23963c9659b939168e82089148fe457fbb4d3804",
    spotify: "29zsVzEH33dD5QqxeL8dvy",
    genre: "progressive uplifting trance",
    popularity: "67",
  },
  {
    name: "Novo Amor",
    image: "https://i.scdn.co/image/c44a35114aa47e04856b02c79e95054f2aede892",
    spotify: "0rZp7G3gIH6WkyeXbrZnGi",
    genre: "ambient folk,chamber pop,indie folk,stomp and holler",
    popularity: "67",
  },
  {
    name: "Nora En Pure",
    image: "https://i.scdn.co/image/4a4a6a7fe0d8bdf117b9acb183e765689ea726d7",
    spotify: "24DO0PijjITGIEWsO8XaPs",
    genre:
      "deep house,deep tropical house,electra,house,new french touch,progressive house,swiss pop,tropical house",
    popularity: "67",
  },
  {
    name: "Octavian",
    image: "https://i.scdn.co/image/46d5c73fec93fee7c84cda2331ab28a8bac85a33",
    spotify: "5zfEatKLDdRkgbw6sdLBAQ",
    genre: "afroswing,grime,london rap,uk alternative hip hop,uk hip hop",
    popularity: "67",
  },
  {
    name: "Slow Motion",
    image: "https://i.scdn.co/image/a667f35c1bbf83e669db990c1dd1343a186b5655",
    spotify: "6jmHuLfbWlq34KedQ7mA5I",
    genre: "relaxative",
    popularity: "67",
  },
  {
    name: "Maribou State",
    image: "https://i.scdn.co/image/1294a548ccadf00500f3524e7fa64434cf2fa6f5",
    spotify: "7zrkALJ9ayRjzysp4QYoEg",
    genre: "electronica,future garage,indie soul",
    popularity: "67",
  },
  {
    name: "Parcels",
    image: "https://i.scdn.co/image/9e20d50cff0790eb63482da56b1405968d105593",
    spotify: "3oKRxpszQKUjjaHz388fVA",
    genre: "aussietronica,indie soul",
    popularity: "67",
  },
  {
    name: "Numidia",
    image: "https://i.scdn.co/image/59954bb9409f8c6c3eb0432b305c66c38347812e",
    spotify: "3OMZaRPVE5OI1IkDbZFBFU",
    genre: "dutch pop,dutch trap pop",
    popularity: "67",
  },
  {
    name: "MoTrip",
    image: "https://i.scdn.co/image/93452150fbae80d43f140a9bbcd640c431bd636a",
    spotify: "69u5rPwWBKP7pJHpCGB9O5",
    genre: "german alternative rap,german hip hop,german pop",
    popularity: "67",
  },
  {
    name: "NGHTMRE",
    image: "https://i.scdn.co/image/e534c6c6ce6489ab1390bd898d79c4c510d681ed",
    spotify: "76M2Ekj8bG8W7X2nbx2CpF",
    genre: "bass trap,brostep,edm,electro house,electronic trap",
    popularity: "67",
  },
  {
    name: "FiNCH ASOZiAL",
    image: "https://i.scdn.co/image/14b74bd0fdaeb6a05039603eb1245fd546eed868",
    spotify: "1ZyqnbV7Brg5LgyS4EZCUD",
    genre: "german hip hop,indie deutschrap,partyschlager,tekk",
    popularity: "67",
  },
  {
    name: "Our Last Night",
    image: "https://i.scdn.co/image/a11baa74ee50560a67de3b445a1da8fbffd21171",
    spotify: "00YTqRClk82aMchQQpYMd5",
    genre: "metalcore,pop punk,post-screamo,screamo",
    popularity: "67",
  },
  {
    name: "Klingande",
    image: "https://i.scdn.co/image/3102001f6cc07aef6e0624ac27e25f7d3d75e971",
    spotify: "1L9i6qZYIGQedgM9QLSyzb",
    genre:
      "deep house,deep tropical house,edm,new french touch,pop,tropical house",
    popularity: "67",
  },
  {
    name: "Alphaville",
    image: "https://i.scdn.co/image/93e317c59735e28e4e812ab25bf8f045feb4170e",
    spotify: "0xliTEbFfy5HQHvsTknTkX",
    genre:
      "dance rock,europop,new romantic,new wave,new wave pop,soft rock,synthpop",
    popularity: "67",
  },
  {
    name: "King Gizzard & The Lizard Wizard",
    image: "https://i.scdn.co/image/9c6df626efc509fb870a518918c7b77d808ad482",
    spotify: "6XYvaoDGE0VmRt83Jss9Sn",
    genre: "australian indie,australian psych,neo-psychedelic",
    popularity: "67",
  },
  {
    name: "ILIRA",
    image: "https://i.scdn.co/image/5408301962cf41de85ae18728bf7ede1bf2fed72",
    spotify: "6mzs66iVW15C5iLt0JLt41",
    genre: "albanian pop",
    popularity: "67",
  },
  {
    name: "Ramirez",
    image: "https://i.scdn.co/image/6e5d984a265ca3a4cb3de6ee2f8c64201f3ae820",
    spotify: "3H6CaRooDAoCeRCpYwOXj2",
    genre: "dark trap,phonk,underground hip hop",
    popularity: "67",
  },
  {
    name: "EDX",
    image: "https://i.scdn.co/image/d18870aee44613591f68514f755e22868cc4b970",
    spotify: "7GMot9WvBYqhhJz92vhBp6",
    genre:
      "big room,deep groove house,deep house,deep tropical house,edm,electro house,house,pop edm,progressive electro house,progressive house,swiss pop,tropical house",
    popularity: "67",
  },
  {
    name: "Rhye",
    image: "https://i.scdn.co/image/a2d54b386192e30963a6108613e9afee275a9d70",
    spotify: "2AcUPzkVWo81vumdzeLLRN",
    genre: "downtempo,indie soul,indietronica,shimmer pop",
    popularity: "67",
  },
  {
    name: "Fedde Le Grand",
    image: "https://i.scdn.co/image/f05967e94ab087907dfd067c1b9a07969cf86c1b",
    spotify: "7dc6hUwyuIhrZdh80eaCEE",
    genre:
      "big room,deep big room,disco house,dutch house,edm,electro house,house,progressive electro house,progressive house,tech house,tropical house",
    popularity: "66",
  },
  {
    name: "San Holo",
    image: "https://i.scdn.co/image/6469320d75d068f0f5060bb61c3bbae71e8c3701",
    spotify: "0jNDKefhfSbLR9sFvcPLHo",
    genre:
      "edm,electro house,electronic trap,electropop,future bass,pop edm,tropical house,vapor twitch",
    popularity: "66",
  },
  {
    name: "Boris Brejcha",
    image: "https://i.scdn.co/image/e6cf51883caf619c1d51cfb56381e7b9ec7a1f56",
    spotify: "6caPJFLv1wesmM7gwK1ACy",
    genre: "german house,german techno,minimal techno,tech house",
    popularity: "66",
  },
  {
    name: "Ummet Ozcan",
    image: "https://i.scdn.co/image/1a6d2f220a8831edaf33f50bf72ab007b8154d3a",
    spotify: "7e1BNCygl2Gf7CX8LrByPv",
    genre:
      "big room,deep big room,edm,electro house,progressive electro house,progressive house",
    popularity: "66",
  },
  {
    name: "Jebroer",
    image: "https://i.scdn.co/image/dc7ecd2184eff0c7695c98c3f40e84d418dc0186",
    spotify: "7jp5R1aY7kmwBYX3jIu9yk",
    genre: "nederlandse hardstyle,tekk",
    popularity: "66",
  },
  {
    name: "Hayden James",
    image: "https://i.scdn.co/image/9b31f618bb49598f9e21aca9f87f372e707f11e9",
    spotify: "4csQIMQm6vI2A2SCVDuM2z",
    genre: "aussietronica,australian pop,edm,gauze pop,house,tropical house",
    popularity: "66",
  },
  {
    name: "Adje",
    image: "https://i.scdn.co/image/c6c89e9c0de1540ac367d5dd1b8389408995bbf2",
    spotify: "5erZiBCKPxe9FaTiXHO00m",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "66",
  },
  {
    name: "Chico Rose",
    image: "https://i.scdn.co/image/d46af9c3f231e47f466e83760ecd22371b13bb7d",
    spotify: "5OdVywqKqyCWwfE2fZb7IX",
    genre: "deep big room,edm,pop edm",
    popularity: "66",
  },
  {
    name: "Midland",
    image: "https://i.scdn.co/image/95a54fffb8fa546e80b40b8e42d3c9a8e7edfa93",
    spotify: "1DTZRmlVZBxx2wRQBtx6yi",
    genre: "contemporary country,neo-traditional country,texas country",
    popularity: "66",
  },
  {
    name: "Ashafar",
    image: "https://i.scdn.co/image/f3d97df03b6dbed83ed01c8c4ae009bf8fa83edf",
    spotify: "438nTuoZFCZCyBl33jE9dU",
    genre: "dutch hip hop",
    popularity: "66",
  },
  {
    name: "MORTEN",
    image: "https://i.scdn.co/image/51cad59adf73bf0f300b2eaa967347ddd6c50e8f",
    spotify: "19HFRWmRCl27kTk6LeqAO8",
    genre: "danish electronic,scandipop",
    popularity: "66",
  },
  {
    name: "Daði Freyr",
    image: "https://i.scdn.co/image/bc947a18eb3c96639c44ba15f7ca5c26b5e35a6d",
    spotify: "3Hb64DQZIhDCgyHKrzBXOL",
    genre: "icelandic pop",
    popularity: "66",
  },
  {
    name: "SOMI",
    image: "https://i.scdn.co/image/57c469f5f6d882c7218531509f30d1c32820d94d",
    spotify: "7zYj9S9SdIunYCfSm7vzAR",
    genre: "k-pop",
    popularity: "66",
  },
  {
    name: "Billie Holiday",
    image: "https://i.scdn.co/image/4efa6b6871a0f672b78b3d16fd5a03c6cd212d58",
    spotify: "1YzCsTRb22dQkh9lghPIrp",
    genre:
      "adult standards,harlem renaissance,jazz blues,lounge,soul,torch song,vocal jazz",
    popularity: "66",
  },
  {
    name: "Carnage",
    image: "https://i.scdn.co/image/47017bb5c5d0123f22f6d66d0ecbf142461ae2d3",
    spotify: "7CCjtD0hCK005Bvg2WG1a7",
    genre:
      "edm,electro house,electronic trap,pop rap,rap,southern hip hop,trap,underground hip hop",
    popularity: "66",
  },
  {
    name: "Laidback Luke",
    image: "https://i.scdn.co/image/4d7d545db40c88023f488b9e14dccb59375fa22d",
    spotify: "53cQZtWDwDJwVCNZlfJ6Qk",
    genre:
      "big room,dance pop,deep big room,disco house,dutch edm,dutch house,edm,electro house,house,pop edm,progressive electro house,progressive house",
    popularity: "65",
  },
  {
    name: "Broederliefde",
    image: "https://i.scdn.co/image/8e514d7b91a30db537fa14043d9f4eacf65d6f24",
    spotify: "5GvMLzUp6tMBpaCbr903RN",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "65",
  },
  {
    name: "Joe Stone",
    image: "https://i.scdn.co/image/35b0e9c790c72bd9cc4260c315af9b9c4495a470",
    spotify: "4kwEd1P9j15ZqUVP5zK7Pv",
    genre:
      "deep groove house,disco house,edm,electro house,house,pop edm,tropical house",
    popularity: "65",
  },
  {
    name: "Will Sparks",
    image: "https://i.scdn.co/image/195aa70dc63ff7e6733041e36faf6dfcb0824733",
    spotify: "1u7OVFmWah4wQhOPIbUb8U",
    genre:
      "big room,deep big room,edm,electro house,melbourne bounce,melbourne bounce international",
    popularity: "65",
  },
  {
    name: "Deepend",
    image: "https://i.scdn.co/image/6031606d45647d861c7b56489d910aa94dab5f94",
    spotify: "0uGApGjjFXKwUOAqYBeX7B",
    genre:
      "deep house,deep tropical house,new french touch,pop edm,tropical house",
    popularity: "65",
  },
  {
    name: "Within Temptation",
    image: "https://i.scdn.co/image/c9d02ed548ef662d9613b329e500763274059650",
    spotify: "3hE8S8ohRErocpkY7uJW4a",
    genre:
      "dutch metal,gothic metal,gothic symphonic metal,power metal,symphonic metal",
    popularity: "65",
  },
  {
    name: "Tabitha",
    image: "https://i.scdn.co/image/ce08f477debfbc5387418a9ae3fd942bdd72097d",
    spotify: "7iBY1RLWDV5zX9NDNQxurm",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "65",
  },
  {
    name: "Mesto",
    image: "https://i.scdn.co/image/ec98f690c5e0b131556277149f31ccff8b3db7e4",
    spotify: "0RViEWnZO2VhmY4oI0PhF9",
    genre:
      "big room,deep big room,dutch edm,edm,electro house,future house,pop edm",
    popularity: "65",
  },
  {
    name: "Armand Van Helden",
    image: "https://i.scdn.co/image/91c7e6de22c5303257295bc8f3faa7609222ed8a",
    spotify: "3cQA9WH8liZfeja1DxcDYE",
    genre:
      "deep groove house,deep house,disco house,house,speed garage,tech house,vocal house",
    popularity: "65",
  },
  {
    name: "Moguai",
    image: "https://i.scdn.co/image/5edf37c203d91ccc96ad967ecab906af3394fb30",
    spotify: "4xgFgBZ7CRtgtHcziClOwQ",
    genre:
      "big room,edm,electro house,german techno,house,progressive electro house,progressive house,tech house",
    popularity: "65",
  },
  {
    name: "Tino Martin",
    image: "https://i.scdn.co/image/2ae456a4bbf20d20726aa7e0b5f30668130ba1eb",
    spotify: "0iVHnv2bQN5iee8J6iCVO4",
    genre: "dutch pop",
    popularity: "65",
  },
  {
    name: "Eskimo Callboy",
    image: "https://i.scdn.co/image/d99f21471ddf9f8a669fe9804775a193c1c5ef5b",
    spotify: "1WNoKxsp715jez1Td4vthc",
    genre: "comic metal,german metalcore,trancecore",
    popularity: "65",
  },
  {
    name: "Katja Krasavice",
    image: "https://i.scdn.co/image/47eb912b225ba14cfb066b2d5211d226e5f9579b",
    spotify: "0lFLP59V4TY3XgnrkFIwxK",
    genre: "german pop",
    popularity: "65",
  },
  {
    name: "Klangkarussell",
    image: "https://i.scdn.co/image/caadb8d7c79e05b2d9551fbe1333e592643da4e4",
    spotify: "041iTeoMIwXMlShuQPIVKo",
    genre: "austrian pop,deep tropical house,new french touch,tropical house",
    popularity: "65",
  },
  {
    name: "Party Favor",
    image: "https://i.scdn.co/image/3835b1e99e755f4b55345d616c5b1552469c3d54",
    spotify: "7yPPzu5UdAK7yagQqjEZQm",
    genre: "bass trap,brostep,edm,electro house,electronic trap",
    popularity: "65",
  },
  {
    name: "Laylow",
    image: "https://i.scdn.co/image/187e254ef768f9c383eadf99f531477315ca1450",
    spotify: "0LnhY2fzptb0QEs5Q5gM7S",
    genre: "french hip hop,pop urbaine,rap francais",
    popularity: "65",
  },
  {
    name: "James Hype",
    image: "https://i.scdn.co/image/e517e70f5812b08a3735a9b28394198899786d0e",
    spotify: "43BxCL6t4c73BQnIJtry5v",
    genre: "deep groove house,house,tropical house,uk dance",
    popularity: "65",
  },
  {
    name: "A-Trak",
    image: "https://i.scdn.co/image/f4f74cb677d168c8f06806ad9f59ac95e94a6845",
    spotify: "3TaUSUXn41GixL7zbvrIDt",
    genre: "canadian electronic,edm,electro house,electronic trap,turntablism",
    popularity: "65",
  },
  {
    name: "Sammie",
    image: "https://i.scdn.co/image/8e1cd2d8102a163936d2aff78d762c2f23e36bcb",
    spotify: "4p07QU02SrLsaORo25h2Lg",
    genre: "dance pop,deep pop r&b,hip pop,pop rap,r&b,urban contemporary",
    popularity: "65",
  },
  {
    name: "070 Shake",
    image: "https://i.scdn.co/image/61cafbff53412524e546de0fa5c51e80631be55e",
    spotify: "12Zk1DFhCbHY6v3xep2ZjI",
    genre: "alternative r&b,new jersey rap",
    popularity: "65",
  },
  {
    name: "Amber Run",
    image: "https://i.scdn.co/image/e71b07dc7bbd654c85b3e91850218d9523940b34",
    spotify: "0MmnmsAuQKRFpo6vJElcaU",
    genre:
      "indie anthem-folk,indie cafe pop,indie folk,indie pop,modern alternative rock,modern rock",
    popularity: "65",
  },
  {
    name: "AronChupa",
    image: "https://i.scdn.co/image/6d09c13c132751856fd958edd6e182fd649c1b43",
    spotify: "5vCOdeiQt9LyzdI87kt5Sh",
    genre: "swedish pop",
    popularity: "65",
  },
  {
    name: "Headhunterz",
    image: "https://i.scdn.co/image/c6035f5cf0d79a9e0d3d2204b3700dca77deec04",
    spotify: "6C0KWmCdqrLU2LzzWBPbOy",
    genre:
      "classic hardstyle,edm,euphoric hardstyle,melbourne bounce international,rawstyle",
    popularity: "64",
  },
  {
    name: "Mr. Polska",
    image: "https://i.scdn.co/image/279bd7c69ea34b77560b6099cdbbc2554d160540",
    spotify: "1A6HQzOvtGaCYihOuIKjE6",
    genre: "dutch hip hop",
    popularity: "64",
  },
  {
    name: "SFB",
    image: "https://i.scdn.co/image/76d70c058507622a647b3c81df65c5101083264d",
    spotify: "50mdotNCJ2PcoZiAgsh8dY",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "64",
  },
  {
    name: "Burak Yeter",
    image: "https://i.scdn.co/image/59742a1b45e69a6d621926a85b6409a9ae9591c2",
    spotify: "4ON1ruy5ijE7ZPQthbrkgI",
    genre: "electro house",
    popularity: "64",
  },
  {
    name: "Dio",
    image: "https://i.scdn.co/image/901cfa4b9cffdffc58feee46b2f7dbca9356377b",
    spotify: "2Np3tBLhkFCcJPun4KhrDQ",
    genre: "dutch hip hop,dutch pop",
    popularity: "52",
  },
  {
    name: "WEISS",
    image: "https://i.scdn.co/image/67b0bf3889399288d7336f2fbaf6eeea6da32a58",
    spotify: "0FBRY66KVaAiddGVefikLB",
    genre:
      "deep groove house,deep house,disco house,house,progressive house,tropical house,uk dance,uk house,vocal house",
    popularity: "64",
  },
  {
    name: "Dom Dolla",
    image: "https://i.scdn.co/image/9f2ef5ca8bc4286e1ec4ed9efbe192f85dac9720",
    spotify: "205i7E8fNVfojowcQSfK9m",
    genre: "australian house,deep groove house,edm,house",
    popularity: "64",
  },
  {
    name: "Dakota",
    image: "https://i.scdn.co/image/dcd9247a572e5f4aa884c49c070b4d2891a9b7ef",
    spotify: "2zzpznMuhKlKlqh1ma7Sms",
    genre: "",
    popularity: "64",
  },
  {
    name: "Wilkinson",
    image: "https://i.scdn.co/image/af75a2161b6b8eec0f69243651cfbefe2a06f862",
    spotify: "6m8itYST9ADjBIYevXSb1r",
    genre: "drum and bass,house,liquid funk,tropical house",
    popularity: "64",
  },
  {
    name: "Michael Calfan",
    image: "https://i.scdn.co/image/67c997d0d3e4fde4a7300e69450b15fbbdc30ef9",
    spotify: "4CuipEvwcoQggmCV8jpKF9",
    genre:
      "big room,deep groove house,deep house,deep tropical house,disco house,edm,electro house,house,pop edm,progressive electro house,progressive house,tropical house",
    popularity: "64",
  },
  {
    name: "TroyBoi",
    image: "https://i.scdn.co/image/c4b6c535559698b852be0e01330ef6274ffb7041",
    spotify: "0tvpihdAsKiNnP6sWS3jUI",
    genre: "bass trap,edm,electronic trap",
    popularity: "64",
  },
  {
    name: "Breathe Carolina",
    image: "https://i.scdn.co/image/71643814c59dedbafd7a5c6bd197633498fa1398",
    spotify: "53M4Iv2RkzzxFFvW2B1jhC",
    genre: "edm,electropowerpop,neon pop punk,pop punk,screamo,trancecore",
    popularity: "64",
  },
  {
    name: "Haris",
    image: "https://i.scdn.co/image/99979da6b340381b3873a8a6ffee6149d3d20175",
    spotify: "6tE3YSDrBq015UZTxh9Zki",
    genre: "",
    popularity: "64",
  },
  {
    name: "Tom Rosenthal",
    image: "https://i.scdn.co/image/c3e854339c3d5b4d91fe946ac76dd210e1edca05",
    spotify: "1AgxgADPuRIW1wyaA4OKcB",
    genre: "british singer-songwriter,indie anthem-folk,indie folk",
    popularity: "64",
  },
  {
    name: "Turnpike Troubadours",
    image: "https://i.scdn.co/image/622748dad61a15a52590716eda364756c8473023",
    spotify: "1YSA4byX5AL1zoTsSTlB03",
    genre: "red dirt",
    popularity: "64",
  },
  {
    name: "Example",
    image: "https://i.scdn.co/image/17251ae62465a3f99382597ac87a9b4ab033f281",
    spotify: "6Vh6UDWfu9PUSXSzAaB3CW",
    genre: "dance pop,grime,hip house,house,tropical house,uk dance",
    popularity: "64",
  },
  {
    name: "KREAM",
    image: "https://i.scdn.co/image/b0197ee2e329c1a5bff9363e09db45f39165b48b",
    spotify: "0DdDnziut7wOo6cAYWVZC5",
    genre:
      "big room,dance pop,deep tropical house,edm,electro house,house,pop edm,tropical house",
    popularity: "64",
  },
  {
    name: "Gareth Emery",
    image: "https://i.scdn.co/image/42efd63d01eb2314e2e6a6bf37869d672e929214",
    spotify: "0hprEC0nsWuQPSHag1O2Vi",
    genre:
      "big room,edm,progressive electro house,progressive house,trance,uplifting trance",
    popularity: "64",
  },
  {
    name: "10cc",
    image: "https://i.scdn.co/image/bd85e05d8bb8ad24515a232174cbe20925048566",
    spotify: "6i6WlGzQtXtz7GcC5H5st5",
    genre:
      "album rock,art rock,classic rock,classic uk pop,dance rock,folk rock,glam rock,mellow gold,rock,soft rock,symphonic rock,yacht rock",
    popularity: "64",
  },
  {
    name: "Tropkillaz",
    image: "https://i.scdn.co/image/0bb10b41b08df5b985f764b04e9b33d90041f4b2",
    spotify: "5bzWtCkjIAMgN93gLt56SO",
    genre:
      "afrofuturismo brasileiro,baile pop,bass trap,electronic trap,funk carioca,pop nacional",
    popularity: "64",
  },
  {
    name: "Silverstein",
    image: "https://i.scdn.co/image/08db3db3a4b07a0414d0fce99f431e0da059f424",
    spotify: "1Tsag5J854qxeOo2apszug",
    genre:
      "canadian post-hardcore,canadian rock,emo,metalcore,pop punk,post-hardcore,screamo",
    popularity: "64",
  },
  {
    name: "Tritonal",
    image: "https://i.scdn.co/image/b1ca22d27009575668b7c46151aec242ec810c57",
    spotify: "521qvhdobR0GzhvU6TFw76",
    genre:
      "big room,edm,electro house,pop edm,progressive electro house,progressive house,progressive trance,trance,tropical house,uplifting trance",
    popularity: "64",
  },
  {
    name: "MAKJ",
    image: "https://i.scdn.co/image/48a0a5a29088dad332117cd319e7c0903b769a14",
    spotify: "3PtCud9dIdOv4exrzdZZ1C",
    genre: "big room,deep big room,edm,electro house,melbourne bounce",
    popularity: "64",
  },
  {
    name: "Beartooth",
    image: "https://i.scdn.co/image/d4b9cfac444b0d4ff513d71cd3d76e51ce60c486",
    spotify: "6vwjIs0tbIiseJMR3pqwiL",
    genre: "metalcore,post-screamo",
    popularity: "64",
  },
  {
    name: "Haze",
    image: "https://i.scdn.co/image/e9610690a8e32a21318c3dd992ce2459e75e5cf5",
    spotify: "77iZVjeYoYSl5P0K9mIiUE",
    genre: "latin pop",
    popularity: "64",
  },
  {
    name: "ARTY",
    image: "https://i.scdn.co/image/0dd9c9e557858859ac5b8051092b94e5d1cd2b7b",
    spotify: "1rSGNXhhYuWoq9BEz5DZGO",
    genre:
      "big room,edm,electro house,pop edm,progressive electro house,progressive house,progressive trance,trance,tropical house,uplifting trance",
    popularity: "64",
  },
  {
    name: "Palaye Royale",
    image: "https://i.scdn.co/image/1104eef77f8fcdf1f403a42df7c5f8bfaa91c4bd",
    spotify: "0hAd6zwEgt9ILuMDY1prcI",
    genre: "modern alternative rock,modern rock,rock,vegas indie",
    popularity: "64",
  },
  {
    name: "DubVision",
    image: "https://i.scdn.co/image/90a81a6b92a7990191474fc7b15e29e05d90ca0e",
    spotify: "3XINWZaloea97SIRiyTJxX",
    genre:
      "big room,deep big room,edm,electro house,pop edm,progressive electro house,progressive house,tropical house",
    popularity: "63",
  },
  {
    name: "Blasterjaxx",
    image: "https://i.scdn.co/image/b36f8194b4f70173217e84327a8cadbe88dc0792",
    spotify: "37awA8DFCAnCCL7aqYbDnD",
    genre:
      "big room,deep big room,dutch house,edm,electro house,progressive electro house",
    popularity: "63",
  },
  {
    name: "HOSH",
    image: "https://i.scdn.co/image/53f5fd15bea7997804fcf45620a903d0149661b6",
    spotify: "3qoTlYFOahAlAh9ee3qnbs",
    genre: "hamburg electronic,minimal techno,organic house,tech house",
    popularity: "63",
  },
  {
    name: "Yung Felix",
    image: "https://i.scdn.co/image/f4122ee360a6202e57b9d775b4f62c9da7bcf23a",
    spotify: "6J2bFI9tQDWfPHjoKHKrOu",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "63",
  },
  {
    name: "DROELOE",
    image: "https://i.scdn.co/image/89adfd3c1ea983dc4f0efbf5ff26698252c76b0a",
    spotify: "0u18Cq5stIQLUoIaULzDmA",
    genre:
      "bass trap,edm,electronic trap,electropop,future bass,pop edm,vapor soul,vapor twitch",
    popularity: "63",
  },
  {
    name: "Chris Lorenzo",
    image: "https://i.scdn.co/image/32510a436de159f0f0ab802f172af2034e71c6ff",
    spotify: "7tm9Tuc70geXOOyKhtZHIj",
    genre: "bass house,deep groove house,electro house,house",
    popularity: "63",
  },
  {
    name: "KAAZE",
    image: "https://i.scdn.co/image/26f53b0ddd4c17863782d74aeca77acb444460fe",
    spotify: "6WGE3kO8ULME2ErBcOksSR",
    genre:
      "big room,deep big room,edm,electro house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "63",
  },
  {
    name: "Idaly",
    image: "https://i.scdn.co/image/7530843ad447946cf0f4eca5076ae5a083581208",
    spotify: "1EYdbYpGAuJy6uZo4sVMoM",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "63",
  },
  {
    name: "Wildstylez",
    image: "https://i.scdn.co/image/6444af31a59a664dbdad0150cdf4a5fc40499cf4",
    spotify: "0wr85NuJuAYZsRzP1lJgiV",
    genre: "classic hardstyle,euphoric hardstyle,rawstyle",
    popularity: "63",
  },
  {
    name: "Ilse DeLange",
    image: "https://i.scdn.co/image/d087d14498325ed6e2814c77c125591d0dba8285",
    spotify: "3FTKP1k9VbOng3m1rgnsqx",
    genre: "dutch americana,dutch pop,dutch rock",
    popularity: "63",
  },
  {
    name: "DIVINE",
    image: "https://i.scdn.co/image/d06e8c5da598150b3589dd8056c08dcf4befae3d",
    spotify: "4Ai0pGz6GhQavjzaRhPTvz",
    genre: "desi hip hop,desi pop,hindi hip hop",
    popularity: "63",
  },
  {
    name: "SSIO",
    image: "https://i.scdn.co/image/6902da98807d4d958505c2b03d166d24a6aba099",
    spotify: "3IrUyDPQlQFcB5lMWhPml2",
    genre: "deep german hip hop,german hip hop,hamburg hip hop",
    popularity: "63",
  },
  {
    name: "Dotan",
    image: "https://i.scdn.co/image/4c3ad8f72c92b437bcc87c6c344080911233dd8d",
    spotify: "1cwOthlzLBwN8Imbq7P71H",
    genre: "dutch pop,dutch rock,folk-pop",
    popularity: "63",
  },
  {
    name: "Shift K3Y",
    image: "https://i.scdn.co/image/2b9a8ba3a66334b467df194f947cb077b4357ba5",
    spotify: "26OrZl5U3VNGHU9qUj8EcM",
    genre: "bass house,deep groove house,house,tropical house,uk dance",
    popularity: "63",
  },
  {
    name: "MC Fioti",
    image: "https://i.scdn.co/image/a4117aa493f93153fdef47ebb873b5ff8ff2751c",
    spotify: "2W6kbe0nm96COrHzNmfLLd",
    genre: "funk carioca",
    popularity: "63",
  },
  {
    name: "Hook N Sling",
    image: "https://i.scdn.co/image/7cba94083166ee25ce438cc4aee78da713ad8983",
    spotify: "3iN9k8uvm4WrgdlOigOH8D",
    genre: "australian dance,big room",
    popularity: "63",
  },
  {
    name: "Apashe",
    image: "https://i.scdn.co/image/ea2442405f6288c663298b4437867b99f562b02a",
    spotify: "1fd3fmwlhrDl2U5wbbPQYN",
    genre: "bass trap,traprun",
    popularity: "63",
  },
  {
    name: "Marnik",
    image: "https://i.scdn.co/image/92df7ff6835b56a8ccfa72bafe50dba71c45cee8",
    spotify: "6S3KljEiIOWoLMUyZrkQUc",
    genre: "big room,deep big room,edm,electro house",
    popularity: "63",
  },
  {
    name: "Borgeous",
    image: "https://i.scdn.co/image/92eeeac5c31361d80efea2b83b2ed83a21c0400d",
    spotify: "4uiMn2g0pgTrhN096QJhbp",
    genre:
      "big room,deep big room,edm,electro house,pop edm,progressive electro house,progressive house,tropical house",
    popularity: "63",
  },
  {
    name: "3LAU",
    image: "https://i.scdn.co/image/858a31c68b3379a0e7e64b81b74e6b3362cdddcd",
    spotify: "4YLQaW1UU3mrVetC8gNkg5",
    genre:
      "big room,edm,electro house,electronic trap,electropop,mashup,pop edm,progressive electro house,progressive house,tropical house",
    popularity: "63",
  },
  {
    name: "Txarango",
    image: "https://i.scdn.co/image/656880da96df8a7f9e3d702924832861294101b2",
    spotify: "6XYRpcgPIK9OejoVzA7PbC",
    genre: "cantautor,indie catala,mestissatge,rock catala",
    popularity: "63",
  },
  {
    name: "Tank",
    image: "https://i.scdn.co/image/bbcc2071fc52ddf0863bb37907eabd4c69a4c5f7",
    spotify: "4mwXUEKaW4ftbncf9Hi58l",
    genre: "deep pop r&b,r&b,urban contemporary",
    popularity: "63",
  },
  {
    name: "Bury Tomorrow",
    image: "https://i.scdn.co/image/7120dff280374aa9cb7f11ad3e637550eaa605e0",
    spotify: "6BD4lgmnh4vy6kkCaZRDWt",
    genre: "melodic metalcore,metalcore,uk metalcore,uk post-hardcore",
    popularity: "63",
  },
  {
    name: "Kero Kero Bonito",
    image: "https://i.scdn.co/image/102231ea5a5d013c778c73bbf84d0ce5b6b0d973",
    spotify: "6OqhFYFJDnBBHas02HopPT",
    genre: "escape room,future funk,hyperpop,japanese electropop",
    popularity: "63",
  },
  {
    name: "David Puentez",
    image: "https://i.scdn.co/image/c3cd4e47d3d4c92bf4a6874bd2f2d7dfa2273350",
    spotify: "4gSsv9FQDyXx0GUkZYha7v",
    genre: "progressive electro house",
    popularity: "63",
  },
  {
    name: "Sub Focus",
    image: "https://i.scdn.co/image/33df0193463523f66eb8216aafa1ba6c7aec54be",
    spotify: "0QaSiI5TLA4N7mcsdxShDO",
    genre: "drum and bass,house,liquid funk",
    popularity: "63",
  },
  {
    name: "Saliva",
    image: "https://i.scdn.co/image/32d37a943f0ecccaa366a2b2dbc17b7bf47b6ff2",
    spotify: "5S6hjAxgxjsLylsTtMIimO",
    genre:
      "alternative metal,nu metal,post-grunge,rap metal,rap rock,wrestling",
    popularity: "63",
  },
  {
    name: "VINAI",
    image: "https://i.scdn.co/image/e31d804ad9b452b93a6eb8d668110d276e705315",
    spotify: "4mrBetqy378Jf1y6NLszlx",
    genre:
      "big room,deep big room,edm,electro house,melbourne bounce international,progressive electro house",
    popularity: "63",
  },
  {
    name: "Firebeatz",
    image: "https://i.scdn.co/image/362dd1a7bfe94aeb0177e96fc7f6dd9a999fda52",
    spotify: "53YSn9tHwGJ6bq5P0gGoYo",
    genre:
      "big room,deep big room,dutch edm,dutch house,edm,electro house,house,pop edm,progressive electro house,progressive house",
    popularity: "62",
  },
  {
    name: "Dion",
    image: "https://i.scdn.co/image/28bf7291b822222629d722d8fae7223d9193d597",
    spotify: "15FyiY3ChN0QRspHIQYq0W",
    genre: "adult standards,brill building pop,lounge,rock-and-roll,rockabilly",
    popularity: "62",
  },
  {
    name: "Racoon",
    image: "https://i.scdn.co/image/a5d2a6b64ab71890340f4e43cb95131f80610bf3",
    spotify: "30mNTnmvPn3HwXA5dW1Iza",
    genre: "dutch pop,dutch rock",
    popularity: "62",
  },
  {
    name: "Coone",
    image: "https://i.scdn.co/image/a144f21fbe798d1aefe9079286a42d7bfe6f1b23",
    spotify: "1Wt63OMKtv6v2ivHuQLm2C",
    genre:
      "belgian edm,classic hardstyle,edm,euphoric hardstyle,jumpstyle,rawstyle",
    popularity: "62",
  },
  {
    name: "Gentleman",
    image: "https://i.scdn.co/image/516ceb11eaeaca2781462ccf44bc5a2de72a9e23",
    spotify: "5tlNJfV9UIpgnbWmvUEFu7",
    genre: "german reggae,reggae fusion",
    popularity: "62",
  },
  {
    name: "Good Times Ahead",
    image: "https://i.scdn.co/image/3e02c17888ab1efce84b78e4f677ec77cdde141d",
    spotify: "6M7RdR9ZP52h2mfNLmiHtU",
    genre: "bass trap,brostep,edm,electro house,electronic trap",
    popularity: "62",
  },
  {
    name: "Netsky",
    image: "https://i.scdn.co/image/9fe61e22ead23fa4fdf7365f234495e5bc512ead",
    spotify: "5TgQ66WuWkoQ2xYxaSTnVP",
    genre: "belgian edm,drum and bass,liquid funk",
    popularity: "62",
  },
  {
    name: "Bicep",
    image: "https://i.scdn.co/image/e47198ac4d0f2f5d407b276ca240fd103cd3a7c4",
    spotify: "73A3bLnfnz5BoQjb4gNCga",
    genre: "ambient house,deep house,electronica,house",
    popularity: "62",
  },
  {
    name: "LVNDSCAPE",
    image: "https://i.scdn.co/image/4639e62fcc9c1123cdebbcb565dc0d771419ceff",
    spotify: "2QlwnS23KrBeshXFyK5U6M",
    genre:
      "deep house,deep tropical house,edm,electro house,pop edm,tropical house",
    popularity: "62",
  },
  {
    name: "NERVO",
    image: "https://i.scdn.co/image/37449ac5ef413d87861fd58e75709d2143ffbba6",
    spotify: "4j5KBTO4tk7up54ZirNGvK",
    genre:
      "australian dance,big room,deep big room,edm,electra,electro house,house,pop edm,progressive electro house,progressive house",
    popularity: "62",
  },
  {
    name: "RetroVision",
    image: "https://i.scdn.co/image/b720475c6de43cb4c29835f542765072c97e3240",
    spotify: "6heMlLFM6RDDHRz99uKMqS",
    genre: "big room,deep big room,edm,electro house,gaming edm,pop edm",
    popularity: "62",
  },
  {
    name: "Macky Gee",
    image: "https://i.scdn.co/image/d013b0f5a20d9d51b095d5e46ed5458a5841f7a0",
    spotify: "5EDztvTkyoKtK0ZdEdhOFx",
    genre: "bass house,tekk",
    popularity: "62",
  },
  {
    name: "Johannes Oerding",
    image: "https://i.scdn.co/image/a37d08684658cdc4463753796e6e540529897d6a",
    spotify: "4I7D65YMlr6ZxVEGPb7q2K",
    genre: "german pop,german pop rock",
    popularity: "62",
  },
  {
    name: "Keanu Silva",
    image: "https://i.scdn.co/image/fc97c2505e62987595ec6b576be324bc5f1c1aa0",
    spotify: "1zLMhO4zzzxt5PMV4wMS3y",
    genre: "deep big room,electro house,future house",
    popularity: "62",
  },
  {
    name: "Rezz",
    image: "https://i.scdn.co/image/fb847930393b0f397fc054233c2d7cc6f23d0e39",
    spotify: "4aKdmOXdUKX07HVd3sGgzw",
    genre:
      "brostep,canadian electronic,edm,electra,electro house,electronic trap",
    popularity: "62",
  },
  {
    name: "Otto Knows",
    image: "https://i.scdn.co/image/b671b0f1c228df39811692629cdcfef2634fbed8",
    spotify: "5fahUm8t5c0GIdeTq0ZaG8",
    genre:
      "big room,dance pop,edm,electro house,progressive electro house,tropical house",
    popularity: "62",
  },
  {
    name: "Black Caviar",
    image: "https://i.scdn.co/image/cf8dbb8d50c7f5f02730e257e8f2cca05ab64635",
    spotify: "1wqW0IQWC7V7jktcjVHID6",
    genre: "bass house,edm,electro house,house",
    popularity: "62",
  },
  {
    name: "Mathea",
    image: "https://i.scdn.co/image/c64d36f241ca09b2aa9f1c702e0f1e8e2c1a01d2",
    spotify: "3r5Kc95Oz8lDc8BL9ChO7n",
    genre: "german pop",
    popularity: "62",
  },
  {
    name: "CALVO",
    image: "https://i.scdn.co/image/36d76ad814627aea9960e139d112822511860f20",
    spotify: "3E61SnNA9oqKP7hI0K3vZv",
    genre:
      "big room,deep big room,deep groove house,deep tropical house,edm,electro house,german dance,house,pop edm,tropical house",
    popularity: "62",
  },
  {
    name: "Guts",
    image: "https://i.scdn.co/image/33b74737b2c406c59d5853a74a4481df1bc6cba3",
    spotify: "5mMkUZv8uUrlH0SHX89BeS",
    genre: "bboy,electronica,nu jazz",
    popularity: "62",
  },
  {
    name: "Monolink",
    image: "https://i.scdn.co/image/f11a20a1f6ebd02d2e34a0985bfb44ac2a26c2a6",
    spotify: "2I4hRNCYkPKJQlkoEZKjYx",
    genre: "organic house,tech house",
    popularity: "62",
  },
  {
    name: "Yxng Le",
    image: "https://i.scdn.co/image/6a7f6435860a08fc7eb903a5ec6b972f0ae2faba",
    spotify: "3Ptyea6E1lJgg6W64f0OQa",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "62",
  },
  {
    name: "Audien",
    image: "https://i.scdn.co/image/d84eb58603a7772fbf4e8e8a5bd9ac1f1a31043d",
    spotify: "4xnMDfgEmXZEEDdITKcGuE",
    genre:
      "big room,edm,electro house,pop edm,progressive electro house,progressive house,tropical house",
    popularity: "62",
  },
  {
    name: "Wankelmut",
    image: "https://i.scdn.co/image/7d60ad2505e9a6922973d98fcc958a5742d1e3fc",
    spotify: "01e2lCvLZ4fLUIRy68nptH",
    genre: "deep euro house,tropical house",
    popularity: "62",
  },
  {
    name: "Qlas & Blacka",
    image: "https://i.scdn.co/image/76ee8772b2e9b8a1de42467473bad9f394829bc0",
    spotify: "0ltU5V1lbLkZlgXrnCeGjx",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "62",
  },
  {
    name: "Chingy",
    image: "https://i.scdn.co/image/bcefde6ea47489f646036348f09a260145a20420",
    spotify: "3s2wTjWxK8NOX09dmsvVOh",
    genre:
      "crunk,dance pop,dirty south rap,gangster rap,hip hop,hip pop,pop rap,rap,southern hip hop,urban contemporary",
    popularity: "62",
  },
  {
    name: "Bob Moses",
    image: "https://i.scdn.co/image/98b05a97f1c485980989a0ea1a613a931abdf2df",
    spotify: "6LHsnRBUYhFyt01PdKXAF5",
    genre:
      "canadian electronic,canadian house,indie soul,indietronica,tropical house",
    popularity: "62",
  },
  {
    name: "James Carter",
    image: "https://i.scdn.co/image/741b4b96423dff94bd1375a913d43984f64e4707",
    spotify: "5344K3N7rx7kw1HjO8psuq",
    genre: "tropical house",
    popularity: "62",
  },
  {
    name: "Dr. Peacock",
    image: "https://i.scdn.co/image/f0607a562d286954e0a9b9e909a98a8b430141ab",
    spotify: "4RbUYWWjEBb4umwqakOEd3",
    genre: "frenchcore,tekk,uptempo hardcore",
    popularity: "62",
  },
  {
    name: "Ship Wrek",
    image: "https://i.scdn.co/image/605e628e7ebc745d821e456d289fa622bd11c1f0",
    spotify: "1ic0FHNGIjXZAWH6O6Reif",
    genre: "bass house,bass trap,electro house,gaming edm",
    popularity: "62",
  },
  {
    name: "Jauz",
    image: "https://i.scdn.co/image/d46cc5ae84fbe372ed185ccfa2b06c69e39ceb1c",
    spotify: "5ttgIeUVka6FLyi00Uu5h8",
    genre: "bass house,brostep,edm,electro house,electronic trap,house",
    popularity: "62",
  },
  {
    name: "Fritz Kalkbrenner",
    image: "https://i.scdn.co/image/3ebb8f8298c469965b61d5cff8f67eb008ed8a89",
    spotify: "08Ut1tYxtmgIInVyQqohkM",
    genre:
      "german house,german techno,minimal techno,tech house,tropical house",
    popularity: "62",
  },
  {
    name: "ChildsPlay",
    image: "https://i.scdn.co/image/641a13dd4c4c3f36d3ca6d5b9ea39a33d3653bc5",
    spotify: "6rNu1h2bZtfgDuZC5FWGel",
    genre: "basshall,dutch hip hop,dutch pop,dutch trap pop",
    popularity: "61",
  },
  {
    name: "The Boy Next Door",
    image: "https://i.scdn.co/image/59ce04222dd75765047d499ca260fc4eeffe49f9",
    spotify: "4QfOh8rJ0OddhhXHD5QyWs",
    genre: "basshall",
    popularity: "61",
  },
  {
    name: "Ferreck Dawn",
    image: "https://i.scdn.co/image/5e3f16c5cb8bef84565199008ff2fe1540e5dc8a",
    spotify: "3cnAJv9gydgm52KFIsdvO8",
    genre:
      "deep groove house,deep house,disco house,edm,funky tech house,house,progressive house,tech house,tropical house,vocal house",
    popularity: "61",
  },
  {
    name: "Alison Wonderland",
    image: "https://i.scdn.co/image/6d6a5e32c16012c1afa66c40c4cd39415b5549c9",
    spotify: "11gWrKZMBsGQWmobv3oNfW",
    genre:
      "aussietronica,brostep,edm,electra,electronic trap,escape room,indietronica",
    popularity: "61",
  },
  {
    name: "Sub Zero Project",
    image: "https://i.scdn.co/image/ed64d2fd170722251d2313a3a633f8aea5c892d1",
    spotify: "4f0OXMMSxr0r8Ztx6CdpAl",
    genre: "classic hardstyle,euphoric hardstyle,rawstyle",
    popularity: "61",
  },
  {
    name: "Neelix",
    image: "https://i.scdn.co/image/bcc4fe7eeea3de8f77bde82db2fd2cda3df7a2b6",
    spotify: "5X3rdmEE2Mif6kFQkb2PxB",
    genre: "german techno,progressive psytrance",
    popularity: "61",
  },
  {
    name: "Young Ellens",
    image: "https://i.scdn.co/image/d9d6d76c4258b831fd125c30e722692940241688",
    spotify: "0SuC1Z51R9kleDO1pj3Gub",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "61",
  },
  {
    name: "Throttle",
    image: "https://i.scdn.co/image/447d89501562b2a79205822499232f3c65525fce",
    spotify: "6mPZJXtFVaakznkRxdgWtC",
    genre: "",
    popularity: "61",
  },
  {
    name: "La Pegatina",
    image: "https://i.scdn.co/image/e0a23f142e6ebc5dc8426b6ff84dbda0883f230e",
    spotify: "4xvB67czbtvemGVXGa81oK",
    genre: "rumba catalana,spanish pop",
    popularity: "61",
  },
  {
    name: "257ers",
    image: "https://i.scdn.co/image/0aae11d3106c302c9fca86913494af88063c5522",
    spotify: "6ihLfpY3cmdGyWEnItn30w",
    genre: "antideutsche,deep german hip hop,german hip hop,partyschlager",
    popularity: "61",
  },
  {
    name: "Pegboard Nerds",
    image: "https://i.scdn.co/image/e913ff5c6a3136b5ed85c71d7614aee7d5eb00ef",
    spotify: "0lLY20XpZ9yDobkbHI7u1y",
    genre:
      "bass trap,brostep,catstep,danish electronic,edm,electro house,gaming edm,glitch",
    popularity: "61",
  },
  {
    name: "Nazareth",
    image: "https://i.scdn.co/image/9ab3e0255bee09e6a21ed101fb80800eff568ab3",
    spotify: "6fvN9GmMCVKb5LY0WsnjFP",
    genre: "album rock,blues rock,classic rock,hard rock,metal,rock",
    popularity: "61",
  },
  {
    name: "Apparat",
    image: "https://i.scdn.co/image/2c63d3ca8dcdd65d1758825fe3ebeac72963e2aa",
    spotify: "40Ojab0UtVQFjA76qXr8Ot",
    genre: "ambient pop,electronica,glitch,microhouse,minimal techno",
    popularity: "61",
  },
  {
    name: "Bingo Players",
    image: "https://i.scdn.co/image/0b4a69ab436eaf1128bd89da81a4195bec649c0d",
    spotify: "1pbHrVayIcVpHI9z97u4bK",
    genre:
      "big room,deep big room,disco house,edm,electro house,house,progressive electro house,progressive house",
    popularity: "61",
  },
  {
    name: "Hermitude",
    image: "https://i.scdn.co/image/254bffe84c27e92a2044e28b80976d35b2ed145f",
    spotify: "3fmMaLC5jjf2N4EC2kTx0u",
    genre:
      "australian dance,australian hip hop,downtempo,edm,escape room,indietronica",
    popularity: "61",
  },
  {
    name: "Mandolin Orange",
    image: "https://i.scdn.co/image/56111565a7936f21332f855f3edc7ffaea007e4c",
    spotify: "675tsBPpaZtqyiBwEf3ZEP",
    genre:
      "deep new americana,new americana,progressive bluegrass,stomp and holler",
    popularity: "61",
  },
  {
    name: "JOYRYDE",
    image: "https://i.scdn.co/image/9e8b3ca24279de92ac5b8a0bf2f6d4d77ec8a586",
    spotify: "24neLwyYRyj4ItaGnFeIT0",
    genre: "bass house,brostep,edm,electro house,electronic trap",
    popularity: "61",
  },
  {
    name: "Tez Cadey",
    image: "https://i.scdn.co/image/b2877702d8f7e4e23250e7891859618ae62d2682",
    spotify: "5cBeFQv3kBVP8o15CmPTKb",
    genre: "deep house,deep tropical house,new french touch,tropical house",
    popularity: "61",
  },
  {
    name: "Felly",
    image: "https://i.scdn.co/image/4c9760f3b1beec5e666223b54faa6443140cc5d1",
    spotify: "2848adRcxvgWNRcz1g1tQD",
    genre: "pop rap,underground hip hop",
    popularity: "61",
  },
  {
    name: "ADF Samski",
    image: "https://i.scdn.co/image/bb51cdd9930932bdf06736362e61243413274dbf",
    spotify: "5qeFPM2PZUCzcpkY4e4RC8",
    genre: "dutch hip hop",
    popularity: "61",
  },
  {
    name: "Infected Mushroom",
    image: "https://i.scdn.co/image/f5329a017c099e050a83ea97b5f40601ec5d9896",
    spotify: "6S2tas4z6DyIklBajDqJxI",
    genre: "psychedelic trance",
    popularity: "61",
  },
  {
    name: "Martha Reeves & The Vandellas",
    image: "https://i.scdn.co/image/b73ee3ca9b41ce90e95b94018fb342dd1ac58622",
    spotify: "1Pe5hlKMCTULjosqZ6KanP",
    genre:
      "brill building pop,classic girl group,classic soul,motown,quiet storm,soul",
    popularity: "61",
  },
  {
    name: "Knife Party",
    image: "https://i.scdn.co/image/a8ccad26c518b156798bb7380fb4617f6773af14",
    spotify: "2DuJi13MWHjRHrqRUwk8vH",
    genre:
      "australian dance,big room,brostep,complextro,edm,electro house,moombahton",
    popularity: "61",
  },
  {
    name: "Oliver Koletzki",
    image: "https://i.scdn.co/image/12f375ff5d6e532802c683cc055b37599aa2e4d4",
    spotify: "1WjBIvYAnZTkTh5UiZNwlR",
    genre:
      "electronica,german techno,minimal techno,organic electronic,organic house,tech house",
    popularity: "61",
  },
  {
    name: "Fat Nick",
    image: "https://i.scdn.co/image/4c7aca4cac1f8ca2d8b09d3349011de86f530011",
    spotify: "5dfFr2qhmXQLvHZqg0dynx",
    genre: "dark trap,emo rap,underground hip hop,vapor trap",
    popularity: "61",
  },
  {
    name: "Danny Avila",
    image: "https://i.scdn.co/image/93714db66cce6225be5eced51ca24ca1e5a8876c",
    spotify: "5y3G1B8cpCTaoq0uDgjwzH",
    genre: "big room",
    popularity: "61",
  },
  {
    name: "Elder Island",
    image: "https://i.scdn.co/image/10c5079e0769a271489f94b874c0b94be979c1a2",
    spotify: "3EnbnmqrrvApHJs6FMvYik",
    genre: "electronica,indie soul,indietronica,vapor soul",
    popularity: "61",
  },
  {
    name: "Gyptian",
    image: "https://i.scdn.co/image/aeeccf0926629592a122a6df1a1018dba80976c0",
    spotify: "2JX4h8xm0hNxCB0aNBWzyi",
    genre: "conscious hip hop,dancehall,lovers rock,reggae fusion",
    popularity: "61",
  },
  {
    name: "Maxwell",
    image: "https://i.scdn.co/image/fa3d56e6c4a26d014bde4cb4eb11ef7bed6c35f2",
    spotify: "2AOt5htsbtyaHd5Eq3kl3j",
    genre:
      "dance pop,funk,hip pop,neo soul,new jack swing,quiet storm,r&b,soul,urban contemporary",
    popularity: "61",
  },
  {
    name: "Kah-Lo",
    image: "https://i.scdn.co/image/1f73e50590c508b1aebb8fb3172ca877170e05eb",
    spotify: "59iOp415oyqGlBHyAhu4z3",
    genre: "nigerian pop",
    popularity: "61",
  },
  {
    name: "Don Williams",
    image: "https://i.scdn.co/image/5aceb3683b21109fd793d0e95ebdc6915aec5d48",
    spotify: "4Ti0EKl2PVEms2NRMVGqNe",
    genre: "country,country rock",
    popularity: "61",
  },
  {
    name: "Kings of Convenience",
    image: "https://i.scdn.co/image/672e610fbdc5d7e0782c6866d1e7d315fbbafb92",
    spotify: "41AbNVba2ccpmcc9QtOJE7",
    genre: "bergen indie,melancholia,norwegian indie",
    popularity: "61",
  },
  {
    name: "State Champs",
    image: "https://i.scdn.co/image/9deaf129e22e2da8cbe9791e76794baa95bc8b96",
    spotify: "1qqdO7xMptucPDMopsOdkr",
    genre: "anthem emo,pixie,pop punk",
    popularity: "61",
  },
  {
    name: "Hot Chocolate",
    image: "https://i.scdn.co/image/dd72b50e171fb494dcbca05fe8958bcef84144d5",
    spotify: "72VzFto8DYvKHocaHYNWSi",
    genre: "classic uk pop,disco,mellow gold,motown,new wave pop,soft rock",
    popularity: "61",
  },
  {
    name: "ARTBAT",
    image: "https://i.scdn.co/image/002b83b3f9575d2efa5f9951c3f1020b2fdcb7b1",
    spotify: "3BkRu2TGd2I1uBxZKddfg1",
    genre: "tech house,ukrainian electronic",
    popularity: "60",
  },
  {
    name: "The Him",
    image: "https://i.scdn.co/image/f35313bb31e746f665f9bf6e80ad1353d8c3bc91",
    spotify: "5WdqBAQhGFCrZvBKXiPIu7",
    genre:
      "big room,deep house,deep tropical house,edm,electro house,house,pop edm,progressive electro house,tropical house",
    popularity: "60",
  },
  {
    name: "Sick Individuals",
    image: "https://i.scdn.co/image/21931914837b81d7bac5578314d09325ff68f31f",
    spotify: "0XqFDQJjqW5PfhfBCb53LR",
    genre:
      "big room,deep big room,dutch house,edm,electro house,pop edm,progressive electro house,progressive house,tropical house",
    popularity: "60",
  },
  {
    name: "Tinlicker",
    image: "https://i.scdn.co/image/ea108847837f3f1363d9397100de82a15be378bf",
    spotify: "5EmEZjq8eHEC6qFnT63Lza",
    genre: "edm,progressive house",
    popularity: "60",
  },
  {
    name: "Outsiders",
    image: "https://i.scdn.co/image/4a5beac41407e16f487cccb43736def1bc754500",
    spotify: "0aKXalHKVzkLJ6aeUY3HMf",
    genre: "nederlandse hardstyle",
    popularity: "60",
  },
  {
    name: "Todd Terry",
    image: "https://i.scdn.co/image/f11a2dfb6ef7d5bc7a1eb72f6662ad9d67002a39",
    spotify: "3dE92yGWcrboP1kC5SWyqu",
    genre:
      "chicago house,deep groove house,deep house,disco house,diva house,funky tech house,hip house,house,tech house,tribal house,vocal house",
    popularity: "60",
  },
  {
    name: "le Shuuk",
    image: "https://i.scdn.co/image/c0df3fe715400c2d1a5a11a0d7808222ce62aeb3",
    spotify: "7bH17jyjkwMPMh9AS8EH0u",
    genre: "berlin minimal techno,partyschlager",
    popularity: "60",
  },
  {
    name: "Bokoesam",
    image: "https://i.scdn.co/image/3a6312f7aeadbec7d9aaea1939533fdf9a769fa0",
    spotify: "2NFWbreVmIEJG0iqIvLDOI",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "60",
  },
  {
    name: "Parra for Cuva",
    image: "https://i.scdn.co/image/3f4ab9e911b4edb8590bc946f5586a6690e449e2",
    spotify: "238y1dKPtMeFEpX3Y6H1Vr",
    genre: "downtempo,new french touch,tropical house",
    popularity: "60",
  },
  {
    name: "Steve Edwards",
    image: "https://i.scdn.co/image/ab67616d0000b273834fb354a78f9d4d31d91f69",
    spotify: "2SwhNukah1MYpLR594PnuC",
    genre: "",
    popularity: "60",
  },
  {
    name: "Joris Voorn",
    image: "https://i.scdn.co/image/b6e36dd9cecbe27030042d5022d07c3ac1f4071b",
    spotify: "4jGpKAmwvU263l0tUh4xKU",
    genre:
      "dutch tech house,house,microhouse,minimal techno,progressive house,tech house,tropical house",
    popularity: "60",
  },
  {
    name: "Mahmut Orhan",
    image: "https://i.scdn.co/image/3f17566bcb7448810e14adcbcced7f92bd50c4b3",
    spotify: "3t8WiyalpvnB9AObcMufiE",
    genre: "groove room,turkish edm",
    popularity: "60",
  },
  {
    name: "Christian Löffler",
    image: "https://i.scdn.co/image/bf7d0ecac86f7e3ac329cfc39deb4fecb3b5b6af",
    spotify: "3tSvlEzeDnVbQJBTkIA6nO",
    genre:
      "electronica,hamburg electronic,microhouse,minimal techno,new french touch,organic electronic",
    popularity: "60",
  },
  {
    name: "Fox Stevenson",
    image: "https://i.scdn.co/image/342b880d3ee58eebe347db1e61683b858655a341",
    spotify: "2BQWHuvxG4kMYnfghdaCIy",
    genre: "brostep,catstep,edm",
    popularity: "60",
  },
  {
    name: "HALIENE",
    image: "https://i.scdn.co/image/9b3f15a42f40e49c5b73fe5f8cf618dac5514aef",
    spotify: "1sKIizVYeHkGy7Tjmn9QRj",
    genre: "",
    popularity: "60",
  },
  {
    name: "Fools Garden",
    image: "https://i.scdn.co/image/6e23040970adf3d2b995702d9122ec991f623bed",
    spotify: "0jRqFvRKCDryHOgrgFqsKG",
    genre: "german pop rock",
    popularity: "60",
  },
  {
    name: "ATB",
    image: "https://i.scdn.co/image/8b7ea2fdd6fb1de940ad1a489049c12919dbc28c",
    spotify: "7jZM5w05mGhw6wTB1okhD9",
    genre: "german dance,german techno,german trance,trance",
    popularity: "60",
  },
  {
    name: "Jace",
    image: "https://i.scdn.co/image/7641778b2d39432646abaf440763041c13be68b7",
    spotify: "0vaKiuLwFJLVU664A8GTjE",
    genre: "",
    popularity: "60",
  },
  {
    name: "Peking Duk",
    image: "https://i.scdn.co/image/cfb9226d48f19026c4066894bb14fc14c5b32178",
    spotify: "0UZ1nu3kcdNlCoiKRjmSSY",
    genre:
      "aussietronica,australian electropop,australian indie,australian pop,edm,indietronica",
    popularity: "60",
  },
  {
    name: "Roosevelt",
    image: "https://i.scdn.co/image/1001f2d69c0e2aa9a5c507338c35ab29e6601d26",
    spotify: "4AQrqVz6BYwy29iMxcGtx7",
    genre:
      "alternative dance,athens indie,chillwave,indie emo,indie soul,indietronica,new rave,nu disco,shiver pop,vapor soul",
    popularity: "60",
  },
  {
    name: "Talib Kweli",
    image: "https://i.scdn.co/image/930c589002a86908f3272a65493269e8cf745f03",
    spotify: "0lEssBAxQl2In4RpaB1C2Y",
    genre:
      "alternative hip hop,conscious hip hop,east coast hip hop,hardcore hip hop,hip hop,southern hip hop",
    popularity: "60",
  },
  {
    name: "GZA",
    image: "https://i.scdn.co/image/99b354cef6f088bc6d5400fffee5095b2a038cfe",
    spotify: "6ns6XAOsw4B0nDUIovAOUO",
    genre:
      "alternative hip hop,east coast hip hop,gangster rap,hardcore hip hop,hip hop,rap,southern hip hop",
    popularity: "60",
  },
  {
    name: "Fatoumata Diawara",
    image: "https://i.scdn.co/image/0c83aa94e279575e09b87418ee03dab23b166f80",
    spotify: "4G5ZJny3HvX6Il7eHVfnNC",
    genre: "afropop,desert blues,malian blues,mande pop,wassoulou,world",
    popularity: "60",
  },
  {
    name: "LouiVos",
    image: "https://i.scdn.co/image/e04fbfdca19229a62980cdd41b6b8a917b96284c",
    spotify: "0lzYw5xI9jgMg8O5i4bTre",
    genre: "dutch hip hop,dutch trap pop,ritmo kombina",
    popularity: "60",
  },
  {
    name: "Worakls",
    image: "https://i.scdn.co/image/abc35d3fe5166e67633eeff9272cc9cae7e191ab",
    spotify: "5RPzPJCg4ER1LzQkorZ31p",
    genre: "deep minimal techno,minimal techno,new french touch,tropical house",
    popularity: "60",
  },
  {
    name: "Smash Into Pieces",
    image: "https://i.scdn.co/image/54b04b708c79f0d8bd35a12e1bbb51f4c385c80b",
    spotify: "2vhrwzjf9H3icunkVFi9tq",
    genre: "gymcore,modern alternative rock",
    popularity: "60",
  },
  {
    name: "Shaan",
    image: "https://i.scdn.co/image/e837ef7fac723a1f47640d947fdc92a8f7f594ca",
    spotify: "5cB4d4jPYjMT326sjihQ4m",
    genre: "desi hip hop,desi pop,filmi,indian folk,modern bollywood,sufi",
    popularity: "60",
  },
  {
    name: "Pennywise",
    image: "https://i.scdn.co/image/dc7bbff4f9edd79133095a97deebbf0117ba80b8",
    spotify: "6i0KVTOvm96T55mbp742ks",
    genre: "melodic hardcore,pop punk,punk,skate punk,socal pop punk",
    popularity: "60",
  },
  {
    name: "The Stranglers",
    image: "https://i.scdn.co/image/78818fca4278bc7f51042910b40a2f95df682f59",
    spotify: "0RUEHcBiENFEqxgicqS2ig",
    genre:
      "art rock,dance rock,glam rock,new romantic,new wave,new wave pop,post-punk,protopunk,pub rock,punk,rock,ska,synthpop,zolo",
    popularity: "60",
  },
  {
    name: "Alex Gaudino",
    image: "https://i.scdn.co/image/767b508c4c6be13ee37d52a06e921c3d2f087965",
    spotify: "7vb7VLDqpLTlAy1ctTMR5d",
    genre: "disco house,edm,electro house,vocal house",
    popularity: "60",
  },
  {
    name: "Chromatics",
    image: "https://i.scdn.co/image/cf34d66944f26ff3f0078618d9b4bd030edb7f7c",
    spotify: "4tOVIRjlWWfR1RrAxyRqTE",
    genre:
      "alternative dance,art pop,chillwave,electronica,electropop,indie pop,indietronica,modern dream pop,neo-synthpop,new rave",
    popularity: "60",
  },
  {
    name: "Dabin",
    image: "https://i.scdn.co/image/9fec98d722ed4fe93e9accd98d9c18346b236416",
    spotify: "7lZauDnRoAC3kmaYae2opv",
    genre:
      "canadian electronic,catstep,chillstep,edm,future bass,melodic dubstep,pop edm",
    popularity: "60",
  },
  {
    name: "Liniker e os Caramelows",
    image: "https://i.scdn.co/image/98d40fd69ee9aedd745c9271c49d61a20abdc838",
    spotify: "5ZtyHkAGvYFPSYcWPfmL5n",
    genre: "baile pop,nova mpb,transpop",
    popularity: "60",
  },
  {
    name: "DI-RECT",
    image: "https://i.scdn.co/image/2b3688be5efe0bf99dff5e7ba3b69bb07283bd65",
    spotify: "0d1nFNO90pwRmCeeqjOx2Q",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "59",
  },
  {
    name: "Felguk",
    image: "https://i.scdn.co/image/7e7ef448a57858dc5b580698756aa99d4ec01e59",
    spotify: "3eH2apcLhzhnr3eWmH3VBf",
    genre: "brazilian edm,complextro,electro house,melbourne bounce",
    popularity: "59",
  },
  {
    name: "Maddix",
    image: "https://i.scdn.co/image/5b9c38e4150ed0cf1ff2b88bc4077372f17a79cc",
    spotify: "0RMeG9M8QFzss9bAbq99KA",
    genre: "big room,deep big room,edm,electro house,progressive electro house",
    popularity: "59",
  },
  {
    name: "Dr Phunk",
    image: "https://i.scdn.co/image/ee7f947c7ca654a9940f00d4b133f25d98c95e5d",
    spotify: "1naX4fxuRaDFlj9tGfIUZk",
    genre: "deep big room,hardstyle,jumpstyle",
    popularity: "59",
  },
  {
    name: "SBMG",
    image: "https://i.scdn.co/image/1cdbcd6289c92074e79f6eeb4c6ffed642a4c060",
    spotify: "3HL2hJ9MmM9eazDokIndkr",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "59",
  },
  {
    name: "Latifah",
    image: "https://i.scdn.co/image/2086f5e58f0d204c9a6cfe7a4796600aa02b214e",
    spotify: "1a4DIEh9pp70HzDHgyjioB",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "59",
  },
  {
    name: "Phuture Noize",
    image: "https://i.scdn.co/image/98eec1073745dc99017632db32aa035e018fbc31",
    spotify: "7AGSJihqYPhYy5QzMcwcQT",
    genre:
      "australian dance,classic hardstyle,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "59",
  },
  {
    name: "Hybrid Minds",
    image: "https://i.scdn.co/image/0bfd921a60818bfbfa90e99039fc33184e63ce3e",
    spotify: "05lF0DUkLJqiW5o70SScyR",
    genre: "drum and bass",
    popularity: "59",
  },
  {
    name: "Steff da Campo",
    image: "https://i.scdn.co/image/bb430fd4b99ab9c8af2f34991e939c7aca4ae57f",
    spotify: "7Bo6vpAmmhylCRWoHSBkcZ",
    genre:
      "big room,deep big room,edm,electro house,house,pop edm,progressive electro house,progressive house",
    popularity: "59",
  },
  {
    name: "JoeyAK",
    image: "https://i.scdn.co/image/d4da60bf4acbafa358d3c924d7a5c2fd41ec8ebc",
    spotify: "4iCzh7b2cLbHVsPOwhr8W0",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "59",
  },
  {
    name: "Autograf",
    image: "https://i.scdn.co/image/25400acc2180116a9f76724d0264430d77ca686a",
    spotify: "0FVj4JuzTyudaXAwfqDQ20",
    genre:
      "deep tropical house,edm,electropop,house,indie poptimism,indie soul,indietronica,nu disco,pop edm,tropical house,vapor soul,vapor twitch",
    popularity: "59",
  },
  {
    name: "Bolier",
    image: "https://i.scdn.co/image/7852a55a0df4c48b7996579b72f554c8ca85b49a",
    spotify: "65NscqgsoMPqBtoLbkP3jD",
    genre: "deep house,deep tropical house,tropical house",
    popularity: "59",
  },
  {
    name: "Zaytoven",
    image: "https://i.scdn.co/image/c20e6a3e6b34647f409c92f327b60c4d52a76bed",
    spotify: "1mceaxtjWdEmwoDVAlkC41",
    genre:
      "atl hip hop,atl trap,dirty south rap,gangster rap,melodic rap,rap,southern hip hop,trap,vapor trap",
    popularity: "59",
  },
  {
    name: "Benjamin Francis Leftwich",
    image: "https://i.scdn.co/image/b15b867771206152789b89e4e92fdbaa2144b9ee",
    spotify: "7D5oTJSXSHf51auG0106CQ",
    genre:
      "chamber pop,indie anthem-folk,indie folk,neo mellow,stomp and holler,york indie",
    popularity: "59",
  },
  {
    name: "No Rome",
    image: "https://i.scdn.co/image/251153323685bac254fe36bd7cc845350f5d04d3",
    spotify: "6auWB5YAlcKaHyrbTH66nd",
    genre: "indie pop,indietronica,pinoy indie",
    popularity: "59",
  },
  {
    name: "Mainstreet",
    image: "https://i.scdn.co/image/4295d3f84b8af458d689cac89fbd5a4e4435ffc8",
    spotify: "25XJqeReVV38w0tR04GGBd",
    genre: "trap funk",
    popularity: "59",
  },
  {
    name: "Jairzinho",
    image: "https://i.scdn.co/image/9ebbe9aa97b15ec90b0cc8f7409644d26bb26787",
    spotify: "4owt1GWUqAh4gsXT13roop",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "59",
  },
  {
    name: "Mandragora",
    image: "https://i.scdn.co/image/8e9ee16b28fac0cb80d3acb1cb9fb84fef53fdc6",
    spotify: "2AasvmwafZPTgQANaoLoQY",
    genre: "brazilian edm,mexican edm",
    popularity: "59",
  },
  {
    name: "Borgore",
    image: "https://i.scdn.co/image/46593c5fd39113a43f868b6f95c37273258b613e",
    spotify: "7u160I5qtBYZTQMLEIJmyz",
    genre: "bass trap,brostep,dubstep,edm,electro house,electronic trap",
    popularity: "59",
  },
  {
    name: "Jakob Ogawa",
    image: "https://i.scdn.co/image/3cc26c3f0e03d4cacaa4d9a5c0c103f060073a0c",
    spotify: "4ub2v80S4RIceZRGnlhjTr",
    genre: "indie garage rock",
    popularity: "59",
  },
  {
    name: "Low Steppa",
    image: "https://i.scdn.co/image/577093a5fcf9ab80b340124d0fb54eaa53d9c87d",
    spotify: "5OImcY3khBn9UFjzgaapob",
    genre:
      "deep groove house,deep house,disco house,edm,house,uk dance,vocal house",
    popularity: "59",
  },
  {
    name: "Anouk",
    image: "https://i.scdn.co/image/9076d237876d1277e4a33af47fb8a308a7c0f503",
    spotify: "6ltVunYjAAD70YtVO6rxvX",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "59",
  },
  {
    name: "NERO",
    image: "https://i.scdn.co/image/17362c6b52abbd02cb45ddd25188b63aa5c2b4a8",
    spotify: "4uRYpUQZrNrY5t8tAv3XrD",
    genre: "brostep,drum and bass,edm,electro house,melodic dubstep",
    popularity: "59",
  },
  {
    name: "Ásgeir",
    image: "https://i.scdn.co/image/0fdefe22341702794e7a9b06eb7d5ebe43e14cbb",
    spotify: "7xUZ4069zcyBM4Bn10NQ1c",
    genre: "icelandic folk,icelandic indie,icelandic pop,indie folk",
    popularity: "59",
  },
  {
    name: "GoldFish",
    image: "https://i.scdn.co/image/d4aadf68fd86920b6b776e5d55d21de5342a64cb",
    spotify: "0uRdK8gy7fXJGRywrlmPM7",
    genre: "cape town indie,downtempo,nu jazz,south african pop,tropical house",
    popularity: "59",
  },
  {
    name: "Level 42",
    image: "https://i.scdn.co/image/8ef78093aa9d048ebf1cb9d60509315336dc1337",
    spotify: "0L9xkvBPcEp1nrhDrodxc5",
    genre:
      "art rock,brit funk,dance rock,mellow gold,new romantic,new wave,new wave pop,post-disco,soft rock,synthpop",
    popularity: "59",
  },
  {
    name: "Deniz Koyu",
    image: "https://i.scdn.co/image/399a638fe4f638163d735b1e358e02cc8aa01011",
    spotify: "39PhMWg1aAuuZcph0OXGu6",
    genre:
      "big room,deep big room,edm,electro house,german techno,progressive electro house,progressive house,sky room",
    popularity: "59",
  },
  {
    name: "Jack Wins",
    image: "https://i.scdn.co/image/cb816f614fe9e4e224ba4b5d6589e6db35cd38bf",
    spotify: "5v8ZROs9c26k4yGMxUkebt",
    genre:
      "deep groove house,disco house,edm,electro house,house,pop edm,progressive house,tropical house",
    popularity: "59",
  },
  {
    name: "Broilers",
    image: "https://i.scdn.co/image/cd106e0fed730b152f88b60223304d49f760023d",
    spotify: "2C7RDMSpyGZFyoSnvOeU4J",
    genre: "german rock,german ska",
    popularity: "59",
  },
  {
    name: "Dub Inc.",
    image: "https://i.scdn.co/image/5ae62f3f680e75a76a873d70883cb69903105f19",
    spotify: "0fSuChlRe8ZYtVFYDoG87U",
    genre: "french reggae",
    popularity: "59",
  },
  {
    name: "Nicola Cruz",
    image: "https://i.scdn.co/image/070a0d125f5762753206516780bb29a65a24d3ce",
    spotify: "0OltT51j3hIkgaDJqqPzDn",
    genre: "ecuadorian indie,latintronica,organic electronic",
    popularity: "59",
  },
  {
    name: "Paul van Dyk",
    image: "https://i.scdn.co/image/a9d801852df099ccc8eb5ceee7bd5f33ed80e2bd",
    spotify: "7wU1naftD3lNq7rNsiDvOR",
    genre: "german techno,progressive house,trance,uplifting trance",
    popularity: "58",
  },
  {
    name: "Sander van Doorn",
    image: "https://i.scdn.co/image/24f7d794e4b75887627c676c0a6cdc25e360745b",
    spotify: "22bukBZvUppuwQwmDz75Gz",
    genre:
      "big room,deep big room,dutch trance,edm,electro house,house,progressive electro house,progressive house,trance",
    popularity: "58",
  },
  {
    name: "Andrew Rayel",
    image: "https://i.scdn.co/image/442afd67b501248cca484a14b3d0fdf269d0dfdf",
    spotify: "1UtBjqMZBAmqIPlDrKu7Tr",
    genre:
      "big room,edm,moldovan pop,progressive house,trance,uplifting trance",
    popularity: "58",
  },
  {
    name: "Wolfpack",
    image: "https://i.scdn.co/image/950c3a72fdc3d1cc1342b367ae6b4ebdb64b60c5",
    spotify: "74ycentHh1YZrW5x4PLnox",
    genre: "belgian edm,crust punk,deep big room,electro house",
    popularity: "58",
  },
  {
    name: "Groove Delight",
    image: "https://i.scdn.co/image/636966b53e0c3f5918044ef7d5fca1d6d9821b6d",
    spotify: "1DX1cbeKQkRJClf4TMmXIn",
    genre: "brazilian edm",
    popularity: "58",
  },
  {
    name: "Tensnake",
    image: "https://i.scdn.co/image/5368dc8124e5e8b719c88bfe9069b853c1b4e839",
    spotify: "75nC6MXUalYZSOd7OfNkwq",
    genre:
      "alternative dance,balearic,deep house,disco house,electronica,filter house,german house,hamburg electronic,house,indie soul,new rave,nu disco,vocal house",
    popularity: "58",
  },
  {
    name: "MATTN",
    image: "https://i.scdn.co/image/a5663c4b871567adfcb689a3e22dff7a3fefc342",
    spotify: "1RQ3ZwCNI7KniEKIN5kkio",
    genre: "belgian edm,deep big room,edm,electro house,sky room",
    popularity: "58",
  },
  {
    name: "Glasperlenspiel",
    image: "https://i.scdn.co/image/6bbf04a78c2110519b09a9abb3f2f9281c63e3e2",
    spotify: "2UFKXTZgKtOTHSqMSyAcLO",
    genre: "german pop,metropopolis",
    popularity: "58",
  },
  {
    name: "F1rstman",
    image: "https://i.scdn.co/image/15aa56f5615c8264061a60281f0f44e962384890",
    spotify: "0IA4SdCS8HBDX6oBoOlgaf",
    genre: "basshall,desi pop,dutch hip hop,dutch pop,dutch trap pop",
    popularity: "58",
  },
  {
    name: "Karsu",
    image: "https://i.scdn.co/image/c5ec0d311a126eeb3822d61863828bd9226f54d4",
    spotify: "0rRu3Co1oQ6Ce3yz7btJzB",
    genre: "turkish pop,turkish rock",
    popularity: "58",
  },
  {
    name: "HAEVN",
    image: "https://i.scdn.co/image/d0b080759746e6fad6396744abc8a815bed5dc23",
    spotify: "65Tmt9uAPTYGl1ZhsOeEJ6",
    genre: "dutch pop,dutch rock",
    popularity: "58",
  },
  {
    name: "Eva Simons",
    image: "https://i.scdn.co/image/ccaf524cf62555dcaea0f144d2f8f1752440af46",
    spotify: "2d6W4cnC5XsVOaxtgaj9hA",
    genre: "dutch pop",
    popularity: "58",
  },
  {
    name: "Lugatti & 9ine",
    image: "https://i.scdn.co/image/35c14c12d0331b0d41a9d888119278648a992486",
    spotify: "4eZg2h2Qez5XuD6PQAqGie",
    genre:
      "german alternative rap,german hip hop,german trap,german underground rap,indie deutschrap",
    popularity: "58",
  },
  {
    name: "Lange Frans",
    image: "https://i.scdn.co/image/436baac0f8181dacda8d2e2119b4ffd48c2e126d",
    spotify: "5I2d294l90n7EMWVNUZczE",
    genre: "dutch hip hop,dutch pop,dutch rock",
    popularity: "58",
  },
  {
    name: "Emma Peters",
    image: "https://i.scdn.co/image/ab67616d0000b2737de05ace60da1a9b900d7fa2",
    spotify: "7hefg1huOTuYBnrRghWjMs",
    genre: "",
    popularity: "58",
  },
  {
    name: "SNBRN",
    image: "https://i.scdn.co/image/249b5e40fc56550ca89ed3db33b2a9830d0955c9",
    spotify: "2zJ8chFLjiBHRNchfevMRI",
    genre:
      "bass house,edm,electro house,house,pop edm,progressive house,tropical house",
    popularity: "58",
  },
  {
    name: "Franc Moody",
    image: "https://i.scdn.co/image/4cdf75b3901470af6df6d34d519caf5353ad9042",
    spotify: "10GT4yz8c6xjjnPGtGPI1l",
    genre: "indie soul,new french touch,nu disco",
    popularity: "58",
  },
  {
    name: "The Blues Brothers",
    image: "https://i.scdn.co/image/9a2d7607cc1e3c6640a12b9007ec91d7301a8c53",
    spotify: "1cHFz6lrt7KAsBV8j2Ny1g",
    genre: "blues,blues rock",
    popularity: "58",
  },
  {
    name: "Dirty South",
    image: "https://i.scdn.co/image/2402609391c866ad323605577337110dae8745b6",
    spotify: "1bpzpALZwOoKXzwMg2i8WB",
    genre:
      "australian dance,big room,edm,electro house,house,pop edm,progressive electro house,progressive house,tech house",
    popularity: "58",
  },
  {
    name: "Rehab",
    image: "https://i.scdn.co/image/cf18da12e9b69be61dbaee3d3d366b8597411af3",
    spotify: "1qh1aHXy7LRcb7eyriuJTS",
    genre: "post-grunge,rap rock,redneck",
    popularity: "58",
  },
  {
    name: "Joel Brandenstein",
    image: "https://i.scdn.co/image/02c43f71d589391d12760d03904393d0e345fafb",
    spotify: "0VUeSHZjbneQ8Ti7whkL9A",
    genre: "german pop,german singer-songwriter",
    popularity: "58",
  },
  {
    name: "KRS-One",
    image: "https://i.scdn.co/image/223618117b06176ba9ccc49ed9c3cbf0a07e9fa8",
    spotify: "2gINJ8xw86xawPyGvx1bla",
    genre:
      "alternative hip hop,bronx hip hop,conscious hip hop,east coast hip hop,gangster rap,hardcore hip hop,hip hop,old school hip hop,political hip hop,rap,turntablism",
    popularity: "58",
  },
  {
    name: "Nitti Gritti",
    image: "https://i.scdn.co/image/8ed1fb5159aa95d00932e2568741455dd9c08604",
    spotify: "21AUdblPrTRzkvJn8FGrlk",
    genre: "brostep,electro house,electronic trap",
    popularity: "58",
  },
  {
    name: "Kevin Lyttle",
    image: "https://i.scdn.co/image/60dce21715a5902bdbfee8e5c987f26711a7387a",
    spotify: "1GaBsp1ICIp1e6udgE7fba",
    genre: "soca",
    popularity: "58",
  },
  {
    name: "Boombox Cartel",
    image: "https://i.scdn.co/image/6e3ab68f932a60dd65855162346dcc12bc707032",
    spotify: "4m1yRHUMhvB8gKAJTjK4kO",
    genre: "bass trap,brostep,edm,electro house,electronic trap,vapor twitch",
    popularity: "58",
  },
  {
    name: "Cristoph",
    image: "https://i.scdn.co/image/8f94134364067ca5e1a174d4e1f0624dec6e1c3e",
    spotify: "532SqCIYmJyXEdEiCJLgYG",
    genre: "house,progressive house,tech house",
    popularity: "58",
  },
  {
    name: "Daniel Santacruz",
    image: "https://i.scdn.co/image/a6f279b687ab33e71befa785c5e63f5db3bb01a5",
    spotify: "4tLUnrSgMM7tT0zVs3wX61",
    genre: "bachata,kizomba,latin,tropical",
    popularity: "58",
  },
  {
    name: "LEISURE",
    image: "https://i.scdn.co/image/35e79b0d098e0496175c2117f284d61fd09af54d",
    spotify: "7b04D0yLktCUpvxQBhmG7R",
    genre: "auckland indie,indie soul,indietronica,nu disco,vapor soul",
    popularity: "58",
  },
  {
    name: "Fontaines D.C.",
    image: "https://i.scdn.co/image/b2441594630f5c48296d4f9f748e81d528602de5",
    spotify: "3SXwqSqAoBz9WCI9PDQzY6",
    genre:
      "chamber psych,english indie rock,indie rock,irish indie rock,modern alternative rock",
    popularity: "58",
  },
  {
    name: "Chicane",
    image: "https://i.scdn.co/image/b9e07e59652061f6cc0a51c6a02fc55001ee47ff",
    spotify: "5GxyeQagayzZOg4UwffQlD",
    genre: "disco house,progressive house,trance,uplifting trance",
    popularity: "58",
  },
  {
    name: "Wolf Alice",
    image: "https://i.scdn.co/image/af531125938c7d8cd4625e19e6d73c6bef4b4810",
    spotify: "3btzEQD6sugImIHPMRgkwV",
    genre:
      "english indie rock,indie rock,modern alternative rock,modern rock,rock",
    popularity: "58",
  },
  {
    name: "Ookay",
    image: "https://i.scdn.co/image/6c3dea68e271b708a7b9fab5086a19d098113fb8",
    spotify: "1HQGhla3VNj1dBmKTtVT2t",
    genre: "bass trap,brostep,edm,electro house,electronic trap,vapor twitch",
    popularity: "58",
  },
  {
    name: "Zefanio",
    image: "https://i.scdn.co/image/2620a4748740d9f63168d23a3676f18b6535aa5e",
    spotify: "7KcUsF4LyLu0SIhmwvNSmM",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "58",
  },
  {
    name: "Superorganism",
    image: "https://i.scdn.co/image/ab2d92455e0a0377a44aa364124321ac9824b1ef",
    spotify: "0Wkm45quqfx3NepJpXDvwE",
    genre: "art pop",
    popularity: "58",
  },
  {
    name: "Amtrac",
    image: "https://i.scdn.co/image/ededf4298818e06b54df49c57772dcc171bdb09f",
    spotify: "3ifxHfYz2pqHku0bwx8H5J",
    genre:
      "alternative dance,chillwave,deep house,edm,filter house,house,indie soul,indietronica,new french touch,nu disco,progressive house,tropical house,vapor soul",
    popularity: "58",
  },
  {
    name: "Jay Hardway",
    image: "https://i.scdn.co/image/a45f27ecb8a877067b59aecdd6bb80b3b20b3875",
    spotify: "12SPNXi0aDpFt0rMVbmLrr",
    genre:
      "big room,deep big room,dutch edm,edm,electro house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "57",
  },
  {
    name: "De Jeugd Van Tegenwoordig",
    image: "https://i.scdn.co/image/5c25d668950e1ff982f32600d515276c2e10e071",
    spotify: "1u7uShzlA1tXJeox3jMFPq",
    genre: "dutch hip hop,dutch indie,dutch pop,dutch rock",
    popularity: "57",
  },
  {
    name: "Jayda G",
    image: "https://i.scdn.co/image/6cc6a9e1e0c91580058d83f5dd7aafff61a1c7d4",
    spotify: "3NKVm2Jedcf6ibJr6pMUVx",
    genre: "canadian electronic",
    popularity: "57",
  },
  {
    name: "i_o",
    image: "https://i.scdn.co/image/bd56c0a2aa2c10ab16dac2c1029a777bbda67422",
    spotify: "0y42IQBDFigO5mmEd1bGQG",
    genre: "bass house,edm,electro house",
    popularity: "57",
  },
  {
    name: "Diggy Dex",
    image: "https://i.scdn.co/image/c43cbc896aaba9b1981e78a9c6bf591ce7f7feec",
    spotify: "4XQhU3S4TyPkiPIsSu2hmA",
    genre: "dutch hip hop,dutch pop,dutch rock",
    popularity: "57",
  },
  {
    name: "Famke Louise",
    image: "https://i.scdn.co/image/ffff694607200c2678f5e842f8a05642e97a496b",
    spotify: "4Dm1MX4VPbtLssAQeBhHFo",
    genre: "dutch hip hop,dutch pop",
    popularity: "57",
  },
  {
    name: "Sandro Silva",
    image: "https://i.scdn.co/image/e992cb1a3044df26d5b4a7c719d430bb52d5a392",
    spotify: "53UXMZxwzQyV4j7tZaVF58",
    genre:
      "big room,deep big room,dutch house,edm,electro house,progressive electro house,sky room",
    popularity: "57",
  },
  {
    name: "Gers Pardoel",
    image: "https://i.scdn.co/image/2e1604e3126b6db113255e0d8128a011fe070083",
    spotify: "5AvkVClT6JuPL4LFy7liYN",
    genre: "dutch hip hop,dutch pop,dutch rock",
    popularity: "57",
  },
  {
    name: "Kraak & Smaak",
    image: "https://i.scdn.co/image/6bb3c6662202415cf2859716d5bb385e21cb4ceb",
    spotify: "7c5qu1gNlg8jWDzzmlp89O",
    genre:
      "bboy,deep house,disco house,electronica,indie soul,new french touch,nu disco,nu jazz",
    popularity: "57",
  },
  {
    name: "Redondo",
    image: "https://i.scdn.co/image/c9dc754e270113240c7040089d4cdaa1ba9d3ce7",
    spotify: "3T0HSMgUpuH1hXbT1JPwQF",
    genre:
      "deep groove house,deep tech house,deep tropical house,edm,electro house,house,pop edm,progressive house,tropical house",
    popularity: "57",
  },
  {
    name: "Mr. Belt & Wezol",
    image: "https://i.scdn.co/image/51b05d67b1e6a3ca5c0ba01e9b70a66a354d81fb",
    spotify: "19VDJ9IKyBSUMDJxLsasP6",
    genre:
      "deep groove house,deep house,disco house,dutch edm,edm,electro house,house,progressive house,tropical house",
    popularity: "57",
  },
  {
    name: "Caro Emerald",
    image: "https://i.scdn.co/image/3d335bdea725853f84aa286ac0dc54c039e42318",
    spotify: "492hDmhPyuIjP3MgTcIqgm",
    genre: "dutch pop,electro swing,nu jazz",
    popularity: "57",
  },
  {
    name: "Thomas Gold",
    image: "https://i.scdn.co/image/a23a597d3d26396b63c582cc69046437f57b140c",
    spotify: "1XLjkBxFokuDTlHt0mQkRe",
    genre:
      "big room,deep big room,edm,electro house,german techno,pop edm,progressive electro house,progressive house,sky room",
    popularity: "57",
  },
  {
    name: "Cosmic Gate",
    image: "https://i.scdn.co/image/0617e2a45b26027784c1be3390f6e8dba76ff8b9",
    spotify: "6ySxYu68zTsO5ghsThpGtS",
    genre:
      "edm,german techno,german trance,progressive house,progressive trance,trance,uplifting trance",
    popularity: "57",
  },
  {
    name: "Stadiumx",
    image: "https://i.scdn.co/image/065d35cb6962758b53dd8acf12a22faa67daa7c2",
    spotify: "0DRf6JJDQnRnz0Yp209CmH",
    genre:
      "big room,deep big room,edm,electro house,house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "57",
  },
  {
    name: "Abstract",
    image: "https://i.scdn.co/image/215359f6bb8d84ea3849f38cd1f74c9d82645c6c",
    spotify: "7lkYBcrLM4JmVgeha1xNl6",
    genre: "indie pop rap,pop rap",
    popularity: "57",
  },
  {
    name: "Le Motel",
    image: "https://i.scdn.co/image/6321daa66dd9bab6f2635178c027feda2d884113",
    spotify: "4LLrhUqUv2Mi1NhHz0pjXd",
    genre: "belgian pop",
    popularity: "57",
  },
  {
    name: "Sidney Samson",
    image: "https://i.scdn.co/image/10b4e4270ead3da57cf8b7255ea9af413fb43efb",
    spotify: "3XonXgjEAAXVl0WKLF1Z4g",
    genre:
      "big room,deep big room,dutch house,edm,electro house,progressive electro house",
    popularity: "57",
  },
  {
    name: "Charming Horses",
    image: "https://i.scdn.co/image/fcc34403017059cf404bcde0f60cb8adc83b90db",
    spotify: "5rr0CMtvn1p9Be8ICfkTc3",
    genre: "deep tropical house,german dance,tropical house",
    popularity: "57",
  },
  {
    name: "Dastic",
    image: "https://i.scdn.co/image/30ce044ce10a447c36af2635d3526b860d8a57e0",
    spotify: "1wdU1J2NHzcDYarT7jEU2A",
    genre: "deep big room,electro house,pop edm",
    popularity: "57",
  },
  {
    name: "Lambert",
    image: "https://i.scdn.co/image/b5a6889ee71f952baf17d057b19af57c4f50ed10",
    spotify: "6pSQcy8935ABNiK2qOpOlK",
    genre: "compositional ambient,focus,neo-classical",
    popularity: "57",
  },
  {
    name: "Riff Raff",
    image: "https://i.scdn.co/image/8cc01f18f1c74442ff10a64267de8f36321d85cb",
    spotify: "31IZdHrCZ5pRhLz4zBxN3o",
    genre: "trap",
    popularity: "57",
  },
  {
    name: "Jinjer",
    image: "https://i.scdn.co/image/fb7b7cdff8b8fba5bc9d87ccb6c239f450457fa5",
    spotify: "7o6cOczXTB8ioTAAJTbESf",
    genre: "slayer",
    popularity: "57",
  },
  {
    name: "Raven & Kreyn",
    image: "https://i.scdn.co/image/073ed3d5d1cf8afd8db84ad15ebadd756a5d71d1",
    spotify: "6STjC3QJTieuM5WHHtkGuh",
    genre: "deep big room,electro house,gaming edm,pop edm",
    popularity: "57",
  },
  {
    name: "Haiyti",
    image: "https://i.scdn.co/image/521ccaae28d31adbf99fb158ff7f924b6d8541a1",
    spotify: "3NjbpG6MmFGVLXwbcPXH90",
    genre: "german cloud rap,german hip hop,indie deutschrap",
    popularity: "57",
  },
  {
    name: "Ecologyk",
    image: "https://i.scdn.co/image/84bf12654251f2ff7e9e96b72382e61f7463a1f1",
    spotify: "1mohmQWtxDNZcBGkfxG4eW",
    genre: "r&b brasileiro",
    popularity: "57",
  },
  {
    name: "Mighty Oaks",
    image: "https://i.scdn.co/image/e4734286c10287891bc49c4b3f5eb611ba2baf19",
    spotify: "5AVJt6VYXT4hMRP8D3MRAC",
    genre: "folk-pop,german indie,german indie folk,indie anthem-folk",
    popularity: "57",
  },
  {
    name: "Charley Crockett",
    image: "https://i.scdn.co/image/5e02a0c8d0c8d600d8e1d17b3d697e3956378d0c",
    spotify: "3BJX1nYizKvWpZTY5HOAr4",
    genre:
      "alternative country,deep new americana,new americana,roots americana,roots rock",
    popularity: "57",
  },
  {
    name: "Curbi",
    image: "https://i.scdn.co/image/31b1f0c3578441e6eb6cee3a1c2802cae76e8caa",
    spotify: "2XiiUuK68XNdHaHOAF5hnT",
    genre:
      "bass house,big room,brostep,deep big room,edm,electro house,electronic trap,future house,house,pop edm,progressive electro house,progressive house",
    popularity: "57",
  },
  {
    name: "Virtual Riot",
    image: "https://i.scdn.co/image/19404250b76aa398b4ff81a3117836adb063f311",
    spotify: "4FXGRMSHh2JjHxVwS8dhH1",
    genre:
      "brostep,catstep,complextro,edm,electro house,electronic trap,filthstep,gaming edm,zapstep",
    popularity: "57",
  },
  {
    name: "Christopher Martin",
    image: "https://i.scdn.co/image/105c94c6150705d4d7365ef10f0b28c349fba3ed",
    spotify: "3dXC1YPbnQPsfHPVkm1ipj",
    genre: "dancehall,lovers rock,modern reggae,reggae fusion,soca",
    popularity: "57",
  },
  {
    name: "Langhorne Slim",
    image: "https://i.scdn.co/image/706cb9ea817c8b6fea78364cbd1d60aaa5f0dcf2",
    spotify: "099toTcKJoywTosZr2hHjy",
    genre:
      "anti-folk,deep new americana,indie folk,modern folk rock,new americana,stomp and holler",
    popularity: "57",
  },
  {
    name: "Astrix",
    image: "https://i.scdn.co/image/57d847275782447e9abeb851f8a278d389f0399e",
    spotify: "3dUltShd2gJQc98Kc7Syit",
    genre: "full on,nitzhonot,psychedelic trance",
    popularity: "57",
  },
  {
    name: "The Shapeshifters",
    image: "https://i.scdn.co/image/27ae3ebfa9f0be9641fc750d803fe8075e00d5e2",
    spotify: "60FV7KyxIH9FH1uq7u8inP",
    genre: "deep house,disco house,diva house,house,vocal house",
    popularity: "57",
  },
  {
    name: "Jan Blomqvist",
    image: "https://i.scdn.co/image/cc6e83984210b4af9f6de61c50901cf5bcde0b6b",
    spotify: "5wMlMjOLeJfS5DfxqGfm83",
    genre:
      "deep euro house,electronica,minimal techno,tech house,tropical house",
    popularity: "57",
  },
  {
    name: "George FitzGerald",
    image: "https://i.scdn.co/image/b8ea90b7df65f54aeb3b080d855dcd2327703e96",
    spotify: "3KOHpygRuo1ruQAbEneR3t",
    genre:
      "bass music,deep house,electronica,future garage,indie soul,indietronica,vapor soul",
    popularity: "57",
  },
  {
    name: "Crash Test Dummies",
    image: "https://i.scdn.co/image/e0c0b41b0c42e8488e7a3cd64a7e402c7307cb6a",
    spotify: "1YEGETLT2p8k97LIo3deHL",
    genre: "canadian rock,pop rock",
    popularity: "57",
  },
  {
    name: "Darlingside",
    image: "https://i.scdn.co/image/24bbdc997a95b69f07cc873c434dade167ed5091",
    spotify: "3DkhgIw7lIyxekurpXNTrm",
    genre:
      "boston folk,chamber pop,folk-pop,indie folk,new americana,new england americana,stomp and holler",
    popularity: "57",
  },
  {
    name: "Hands Like Houses",
    image: "https://i.scdn.co/image/c045d47c3d5ce3906f0e54a8e34ce7a4b9823133",
    spotify: "0u3d5PM2FuEuG5QuUdt8mT",
    genre:
      "australian metalcore,australian post-hardcore,metalcore,pop punk,post-screamo,progressive post-hardcore,screamo",
    popularity: "57",
  },
  {
    name: "Procol Harum",
    image: "https://i.scdn.co/image/78ebadcdfb88efeda235ad9e6f49ce8a72e197d5",
    spotify: "0GbqW5TJr7n4is453VOY4C",
    genre:
      "album rock,art rock,blues rock,british invasion,classic rock,folk rock,progressive rock,psychedelic rock,symphonic rock",
    popularity: "57",
  },
  {
    name: "Slum Village",
    image: "https://i.scdn.co/image/c3cc3500cd5100e7be65aef08413f4c804b218db",
    spotify: "1020a42xVklY6c56imNcaa",
    genre: "alternative hip hop,detroit hip hop,hip hop,indie soul,neo soul",
    popularity: "57",
  },
  {
    name: "Snavs",
    image: "https://i.scdn.co/image/a3aa9b2aa9a0b7ac7cced7caf25ff20837ebf7d3",
    spotify: "4xFadP7L1YVwVSjDDfjKjM",
    genre:
      "bass trap,brostep,danish electronic,edm,electro house,electronic trap,pop edm,traprun",
    popularity: "57",
  },
  {
    name: "Wax Motif",
    image: "https://i.scdn.co/image/ece280448dfedd687f572a5a89a14b8d3ad2a812",
    spotify: "7zm3aSdmGiOkTt0aZFSO8R",
    genre: "bass house,brostep,electro house,electronic trap,house",
    popularity: "57",
  },
  {
    name: "Takida",
    image: "https://i.scdn.co/image/6b3c9f3e281d4be9917b66d4113a5fddc6394258",
    spotify: "3E33tPtYu9wX1t1cp8ELAW",
    genre: "swedish alternative rock,swedish pop",
    popularity: "57",
  },
  {
    name: "Plested",
    image: "https://i.scdn.co/image/655d7f4bba2e9a6d8e4982c5ac80dc414dbb29f0",
    spotify: "2nJYGgfTf2846LtVB3AES8",
    genre: "indie anthem-folk,indie cafe pop,uk pop",
    popularity: "57",
  },
  {
    name: "Mushroomhead",
    image: "https://i.scdn.co/image/42550eca6b61ba3043ec0bb95cbc78a162527b47",
    spotify: "18absyD7lQaXUDBXnyzU8M",
    genre:
      "alternative metal,cleveland metal,groove metal,industrial metal,industrial rock,nu metal,post-grunge,rap metal,rap rock",
    popularity: "57",
  },
  {
    name: "DallasK",
    image: "https://i.scdn.co/image/72f2abdeeaecce65931064684a35e4fdc0e5b6f4",
    spotify: "7uas0F5EhsZg6KDJ7yy7rW",
    genre: "complextro,deep big room,electro house,pop edm",
    popularity: "57",
  },
  {
    name: "Luca Schreiner",
    image: "https://i.scdn.co/image/9d1399ad41ae8543e1f9031d7117fe011d49c54f",
    spotify: "5fiYAV2DWASxAUKDq7Gbe9",
    genre: "german dance",
    popularity: "57",
  },
  {
    name: "Julien Clerc",
    image: "https://i.scdn.co/image/2aac40f593270a37b07520420e0f35f8db272220",
    spotify: "7gVzeNvBbUpj6PXX5ekCMs",
    genre: "chanson,french pop",
    popularity: "57",
  },
  {
    name: "Mads Langer",
    image: "https://i.scdn.co/image/f12a872aab0f3ae76e96b578df7f480636c4129e",
    spotify: "028xhPwqtWva4J0MkFHY2x",
    genre: "danish pop,danish pop rock",
    popularity: "57",
  },
  {
    name: "Flosstradamus",
    image: "https://i.scdn.co/image/ba47a2dc1a460dcdd0e8e98fb619f4ae9df8104c",
    spotify: "2FmzVitXZjIkFolH8HXd4j",
    genre: "bass trap,brostep,edm,electro house,electronic trap,mashup",
    popularity: "57",
  },
  {
    name: "Haken",
    image: "https://i.scdn.co/image/f673b393cc9670a18f854f85a24035ed1fe13207",
    spotify: "2SRIVGDkdqQnrQdaXxDkJt",
    genre: "djent,jazz metal,progressive metal,progressive rock,symphonic rock",
    popularity: "57",
  },
  {
    name: "Katchafire",
    image: "https://i.scdn.co/image/f03cf49a3744155d59ff0b803e0ea6e03561a6df",
    spotify: "786hGmAEXHUeCdKPAj3JIa",
    genre: "jawaiian,kiwi rock,nz hip hop,nz reggae,polynesian pop,reggae rock",
    popularity: "57",
  },
  {
    name: "Céu",
    image: "https://i.scdn.co/image/a15cbc34c02028e2b6e15efba34e5ed1de1827b4",
    spotify: "2eFVsaX3yHLPeWpiqvmeFn",
    genre: "baile pop,bossa nova,brazilian indie,mpb,nova mpb",
    popularity: "57",
  },
  {
    name: "Henry Green",
    image: "https://i.scdn.co/image/c953095d757332fa180abc39e8544c20ca572ba0",
    spotify: "0VbDAlm2KUlKI5UhXRBKWp",
    genre: "chamber pop,electropop,indie soul,vapor soul",
    popularity: "57",
  },
  {
    name: "The Partysquad",
    image: "https://i.scdn.co/image/9cdf6ae99d198a4f1c8e9d97cc8bd5e00cf7cae8",
    spotify: "2dQgOfBP52UwjegY8FwJAY",
    genre: "dutch hip hop,dutch pop,moombahton",
    popularity: "56",
  },
  {
    name: "Chocolate Puma",
    image: "https://i.scdn.co/image/2e428b341490cc43e4907f4aa8b7b295d3ebafa0",
    spotify: "5Aw0IGM5JS3FuTgtRsDWGA",
    genre:
      "bass house,big room,deep big room,deep groove house,disco house,dutch edm,edm,electro house,house,progressive electro house,progressive house,sky room,tech house,vocal house",
    popularity: "56",
  },
  {
    name: "Ferry Corsten",
    image: "https://i.scdn.co/image/ea61557d58171a5d0a5e904c88b99ff4395beddd",
    spotify: "2ohlvFf9PBsDELdRstPtlP",
    genre:
      "dutch trance,edm,progressive house,progressive trance,trance,uplifting trance",
    popularity: "56",
  },
  {
    name: "Hermes House Band",
    image: "https://i.scdn.co/image/95113f11caae52bf90508219d033862040111ce0",
    spotify: "75QQAQ1DfmGW500AJZbM0i",
    genre: "bubblegum dance,partyschlager",
    popularity: "56",
  },
  {
    name: "RICCI",
    image: "https://i.scdn.co/image/99e37d2db83caa38af1c4f280c2c3dcaa0c4bed2",
    spotify: "1EUMh6DZo2CfpolG75YQBL",
    genre: "brazilian edm",
    popularity: "56",
  },
  {
    name: "Equalz",
    image: "https://i.scdn.co/image/63bebedc9072e11b2df8aed1e5d39ce95ad5bad0",
    spotify: "57RYqNhEvaNiafuP1X73GS",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "56",
  },
  {
    name: "Jack Curley",
    image: "https://i.scdn.co/image/ed180806e1f87a24e12ad67b7b4aa297b9bad4c3",
    spotify: "1Unwe9Xco0JDlTTwpDVrcK",
    genre: "indie anthem-folk,uk pop",
    popularity: "56",
  },
  {
    name: "Solar",
    image: "https://i.scdn.co/image/ab67616d0000b2731ecc60c0ad785d457bdc0a36",
    spotify: "5cYcI546S8Lf97m4mNdYLD",
    genre: "k-pop",
    popularity: "56",
  },
  {
    name: "GRAACE",
    image: "https://i.scdn.co/image/a54106392adea24978e2c64293fedf3d92969c4d",
    spotify: "4nqqGSsclFchZXaiafOYyV",
    genre: "australian alternative pop,australian pop",
    popularity: "56",
  },
  {
    name: "DJ Isaac",
    image: "https://i.scdn.co/image/3f137ba158746b411e041989956b0b54a55ac05c",
    spotify: "2FmgW6Jee0JQKtb6EnBWCq",
    genre:
      "australian dance,classic hardstyle,euphoric hardstyle,gabba,happy hardcore,hardcore techno,rawstyle",
    popularity: "56",
  },
  {
    name: "Swanky Tunes",
    image: "https://i.scdn.co/image/9c2dd3f98dbcc231d3686b50de8e873b8ddd911c",
    spotify: "06cLuOP0p7VAnBnqil1eWX",
    genre:
      "big room,deep big room,edm,electro house,house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "56",
  },
  {
    name: "Delta Heavy",
    image: "https://i.scdn.co/image/13c87ccecfc5105aee4807ebdabb703514af6c53",
    spotify: "7GvVTb8yFV0ZrdI30Qce6T",
    genre: "brostep,drum and bass,edm,electro house,liquid funk",
    popularity: "56",
  },
  {
    name: "Tora",
    image: "https://i.scdn.co/image/984c63f850d1781f1f9d7855430cc47bba9ad760",
    spotify: "7KGI0OwY8iAL5rI5p47YyK",
    genre: "alternative r&b,indie soul,vapor soul",
    popularity: "56",
  },
  {
    name: "Camo & Krooked",
    image: "https://i.scdn.co/image/fba02ad3f46f2f24f89e961b735ad66aeab6996d",
    spotify: "2N8IPNZTiNo3nj4mreOlHU",
    genre: "austrian dnb,drum and bass,jump up,liquid funk",
    popularity: "56",
  },
  {
    name: "Hot Since 82",
    image: "https://i.scdn.co/image/9b3be426e0a5a3c967a2a73f84986966139b703c",
    spotify: "1tRBmMtER4fGrzrt8O9VpS",
    genre:
      "deep disco house,deep house,house,minimal techno,tech house,uk house",
    popularity: "56",
  },
  {
    name: "Krezip",
    image: "https://i.scdn.co/image/de9c5f577b4e5877840a6dbf2106cd8a043f548a",
    spotify: "0ZLfGbfO9xjpfna1pN8BeX",
    genre: "dutch pop,dutch rock",
    popularity: "56",
  },
  {
    name: "Dimatik",
    image: "https://i.scdn.co/image/1063a41700517f4fa9178733393e0b465ffd5357",
    spotify: "2Zvo5BEkHyaHD1zk180kMz",
    genre: "deep big room,melbourne bounce international",
    popularity: "56",
  },
  {
    name: "Running Touch",
    image: "https://i.scdn.co/image/f77f6720e0064fa7c9fc0f899962c7b03fe81d3f",
    spotify: "5bdwzvp6eirvqh0TwOwjgE",
    genre: "aussietronica,australian indie,australian pop",
    popularity: "56",
  },
  {
    name: "Mausio",
    image: "https://i.scdn.co/image/b5af29b825598b25c7b3c0bae7844709a57b36fc",
    spotify: "5yzLRjAu6ni4Bb3fQDED2q",
    genre: "tekk",
    popularity: "56",
  },
  {
    name: "Matroda",
    image: "https://i.scdn.co/image/438c71fd6d8b08b147bce351ad7262cb401bba60",
    spotify: "45lcbTsX07JWzmTIjcdyBz",
    genre: "bass house,brostep,deep big room,edm,electro house",
    popularity: "56",
  },
  {
    name: "Bilderbuch",
    image: "https://i.scdn.co/image/feb19a35e49b098c2a9f1d8cb47755b89fb61ffb",
    spotify: "2ErWLckuGFl84nGmg5fwyG",
    genre: "austrian pop,german pop,german rock,vienna indie",
    popularity: "56",
  },
  {
    name: "Kap G",
    image: "https://i.scdn.co/image/c4892da0743f5d813c417f1eade071b7b062e277",
    spotify: "6JvU33PZ8MtZyeFTESr09O",
    genre: "atl hip hop,chicano rap,melodic rap,trap,vapor trap",
    popularity: "56",
  },
  {
    name: "Robosonic",
    image: "https://i.scdn.co/image/6d216baa3bb34ac91a45b4b4c9a4608aa7234b57",
    spotify: "2XBuvmyzhH85j6sqv1fV3l",
    genre: "deep house,disco house,house,tech house",
    popularity: "56",
  },
  {
    name: "Carl Cox",
    image: "https://i.scdn.co/image/46f084b6e3f38541fca1641b5689b06ce5b05caf",
    spotify: "19SmlbABtI4bXz864MLqOS",
    genre: "house,minimal techno,schranz,tech house,uk tech house",
    popularity: "56",
  },
  {
    name: "QUIX",
    image: "https://i.scdn.co/image/eb7f39bacfecbcf00dbdb6583df8e679acbb9189",
    spotify: "19EW4WBhl0fvZUQgi7wV5M",
    genre:
      "bass trap,brostep,edm,electro house,electronic trap,vapor twitch,zapstep",
    popularity: "56",
  },
  {
    name: "DePedro",
    image: "https://i.scdn.co/image/e79710c56ea6d31d66c64336c56793c52a4bb28c",
    spotify: "3wpNKcE7grYUIRKCMpmBOb",
    genre: "cantautor,latin rock,spanish indie pop,spanish rock",
    popularity: "56",
  },
  {
    name: "Nicolas Haelg",
    image: "https://i.scdn.co/image/33761639e32e1e5d4915d8fc8ea25b8d904d850e",
    spotify: "0nwid3SFCGyXxnllTHzHPd",
    genre: "deep house,deep tropical house,swiss pop,tropical house",
    popularity: "56",
  },
  {
    name: "SWACQ",
    image: "https://i.scdn.co/image/18b3af1612ff310510a0524feaa32a75b2eee232",
    spotify: "45UHclgIcRavRoRa2MET5i",
    genre: "deep big room,electro house,sky room",
    popularity: "56",
  },
  {
    name: "The Whitest Boy Alive",
    image: "https://i.scdn.co/image/e5cd6f0ab647d86ca8d237439f0e82b030c182a3",
    spotify: "1qcU8NabUQ5efQf8UGW6CV",
    genre:
      "alternative dance,dance-punk,indie pop,indietronica,modern rock,new rave",
    popularity: "56",
  },
  {
    name: "Madeline Juno",
    image: "https://i.scdn.co/image/2586672991dee26c8a9f3e70112a8d8a950be040",
    spotify: "6u8KyY2rfBGDtDejRJ9JaQ",
    genre: "german pop,liedermacher",
    popularity: "56",
  },
  {
    name: "Stefanie Heinzmann",
    image: "https://i.scdn.co/image/5a55dc723e644329f6cb71c7cec4df15e6066b37",
    spotify: "0bm9qSmVJmT9CEukIhhZY5",
    genre: "german pop,swiss indie,swiss pop",
    popularity: "56",
  },
  {
    name: "Alan Fitzpatrick",
    image: "https://i.scdn.co/image/9a7c6056537b1a5172f7d13a7ec5df95ac7bbd3a",
    spotify: "40JyDxGqtYSowWYT2jaive",
    genre: "disco house,house,minimal techno,tech house,techno",
    popularity: "56",
  },
  {
    name: "David Garrett",
    image: "https://i.scdn.co/image/76ca0465ccfe71d7da754b86573c4bc2a2462b83",
    spotify: "33k6kPYIS5TgseAc70LZjy",
    genre: "bow pop,classify,pop violin",
    popularity: "56",
  },
  {
    name: "The Devil Wears Prada",
    image: "https://i.scdn.co/image/1f599e97b65aab93b0bfb470914ae94c0e2a674d",
    spotify: "0NbQe5CNgh4YApOCDuHSjb",
    genre:
      "christian metal,christian metalcore,melodic metalcore,metalcore,post-hardcore",
    popularity: "56",
  },
  {
    name: "Toumani Diabaté",
    image: "https://i.scdn.co/image/06648a582c0b3925d6161da71b62801f580584b6",
    spotify: "2nCACYdIndYchzX4bxLcTW",
    genre:
      "afrobeat,afropop,desert blues,griot,kora,malian blues,mande pop,world",
    popularity: "56",
  },
  {
    name: "Fabian Mazur",
    image: "https://i.scdn.co/image/cccefbeed000ea79a6c8a640d647f4b9e0800723",
    spotify: "5BBBDm18Y0TCRXZggaOnZG",
    genre: "bass trap,danish electronic,electronic trap,traprun",
    popularity: "56",
  },
  {
    name: "Tale Of Us",
    image: "https://i.scdn.co/image/e2e2e8fd3d887e70154c1892bddfec271556c2cd",
    spotify: "1UL813H5aj3e8ekE5RqWqc",
    genre:
      "deep disco house,italian techno,melodic techno,microhouse,minimal tech house",
    popularity: "56",
  },
  {
    name: "Raiden",
    image: "https://i.scdn.co/image/7d89db41b77acd8608f9a821cb0926edc72ae0c2",
    spotify: "4YXNoMVTHRt01jYaKXTumJ",
    genre: "",
    popularity: "56",
  },
  {
    name: "La Femme",
    image: "https://i.scdn.co/image/731265311512fd774a07eed73930198620d87823",
    spotify: "5VTWoYYizcOY3uIKnxeCGI",
    genre: "french indie pop,french indietronica,french rock",
    popularity: "56",
  },
  {
    name: "Amerie",
    image: "https://i.scdn.co/image/91c9bea2e8b07d3af8e3696fcb45e54febeafab6",
    spotify: "08rMCq2ek1YjdDBsCPVH2s",
    genre:
      "alternative r&b,dance pop,deep pop r&b,hip hop,hip pop,neo soul,pop rap,r&b,urban contemporary",
    popularity: "56",
  },
  {
    name: "Deerhunter",
    image: "https://i.scdn.co/image/ef8563081fa5394c1ec53f8e2a87a67fdec7a70d",
    spotify: "38zTZcuN7nFvVJ6auhc6V3",
    genre:
      "alternative dance,alternative rock,art pop,atlanta indie,chillwave,dance-punk,dream pop,experimental rock,freak folk,garage psych,indie pop,indie rock,lo-fi,modern alternative rock,modern rock,neo-psychedelic,new rave,noise pop,noise rock,nu gaze,shoegaze,slowcore",
    popularity: "56",
  },
  {
    name: "Chinese Man",
    image: "https://i.scdn.co/image/4d6503f4c4d34a1570d5d0ea0a713523cfefff96",
    spotify: "6vgw0jwJkUnW2NR1rzsQU3",
    genre: "electro swing,electronica,nu jazz,rap marseille,turntablism",
    popularity: "56",
  },
  {
    name: "Tommy Cash",
    image: "https://i.scdn.co/image/d9bc6e1461060ebd5f023737eee5dda6af9444df",
    spotify: "44XzG6GoJZNtkIGW19hsUK",
    genre: "estonian hip hop",
    popularity: "56",
  },
  {
    name: "Kiasmos",
    image: "https://i.scdn.co/image/5a5e285c48f2352282ea9aa3f93a8eb655875bf3",
    spotify: "6X8lhZ7YaRUBlOsOYimlyD",
    genre: "electronica,icelandic electronic,icelandic pop",
    popularity: "56",
  },
  {
    name: "Stand Atlantic",
    image: "https://i.scdn.co/image/4231dd58189546b084a53f5133fa25aa2493059a",
    spotify: "1W2Fv4YUnjC8hx2qQd6fGh",
    genre: "anthem emo,pixie,pop emo,pop punk",
    popularity: "56",
  },
  {
    name: "Elephante",
    image: "https://i.scdn.co/image/52aa1a843cf4c387bdeb24bb16cfef6f43440d66",
    spotify: "3fjs4zbBFxEFFe8Wyojo0G",
    genre:
      "big room,edm,electro house,electropop,indie poptimism,pop edm,tropical house",
    popularity: "56",
  },
  {
    name: "Crankdat",
    image: "https://i.scdn.co/image/024862ba57651d7161d1fd371c81c45593d15075",
    spotify: "5lCekoJW9jNq01B1wiqdAb",
    genre:
      "bass trap,brostep,catstep,edm,electro house,electronic trap,pop edm,zapstep",
    popularity: "56",
  },
  {
    name: "Nullzweizwei",
    image: "https://i.scdn.co/image/28edfb6a996eabf25679a4cf79d667d812c387e7",
    spotify: "0TVANDORspsd2X7Gg9rhcW",
    genre:
      "deep german hip hop,german cloud rap,german hip hop,german trap,german underground rap",
    popularity: "56",
  },
  {
    name: "Julian Jordan",
    image: "https://i.scdn.co/image/a1d6624fdca270ec5be5472730daceffc3d0552d",
    spotify: "2vUCVkeZjzDcaoX4gagHdV",
    genre:
      "big room,deep big room,dutch edm,edm,electro house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "55",
  },
  {
    name: "Marlo",
    image: "https://i.scdn.co/image/e9d6df1395738915fee18254efe6dade18b91fb9",
    spotify: "2qFmZcrhfzbppEdD6wibAy",
    genre: "atl trap,trap",
    popularity: "55",
  },
  {
    name: "LNY TNZ",
    image: "https://i.scdn.co/image/e8f6c356e12f8763e3fb8d6812c765a9c0fe3088",
    spotify: "1x0ScxgiyFRQDKT4VwcLHa",
    genre: "classic hardstyle,edm,electro house",
    popularity: "55",
  },
  {
    name: "Frontliner",
    image: "https://i.scdn.co/image/dcf3f3ae3310591ada2e489606a481f3241de237",
    spotify: "7momuad2Twkv5O7MY3dODa",
    genre: "classic hardstyle,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "55",
  },
  {
    name: "Moksi",
    image: "https://i.scdn.co/image/a836e1c4bb53d38fc439d16b4beb10f42dfdfa0d",
    spotify: "5jm3x1qIibWdKSEMw2G011",
    genre:
      "bass house,brostep,dutch edm,edm,electro house,electronic trap,house",
    popularity: "55",
  },
  {
    name: "Justin Mylo",
    image: "https://i.scdn.co/image/efae4e4a67cd09f67420bd11001fba0fc7542e88",
    spotify: "7MFJyevu6jq0shwDuVLymu",
    genre: "big room,deep big room,edm,electro house,pop edm,sky room",
    popularity: "55",
  },
  {
    name: "Maurice West",
    image: "https://i.scdn.co/image/b998d46ec67dab39acaa07228b84cf86ccdde30e",
    spotify: "1qF8DC6uIBjskqP0hyw1Gk",
    genre: "big room,deep big room,edm,electro house,sky room",
    popularity: "55",
  },
  {
    name: "The Opposites",
    image: "https://i.scdn.co/image/2c34b7ebe5b0d2fd8dfa4bd2e2f6b25eddd36427",
    spotify: "23951Pg9PiLB8Uza3k12g6",
    genre: "dutch hip hop,dutch pop,dutch rock",
    popularity: "55",
  },
  {
    name: "FS Green",
    image: "https://i.scdn.co/image/53a1e206d95eb6f63eb4b4680b3022276dd3f7a9",
    spotify: "2xjVYIMLS3nR5Y1UOr02Vb",
    genre: "abstract beats",
    popularity: "55",
  },
  {
    name: "Hansie",
    image: "https://i.scdn.co/image/c976ffabbd4e811c76738343731d1e51bdebcdaf",
    spotify: "3Xvu1Rur46ZO8HiE9hBuxl",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "55",
  },
  {
    name: "HVOB",
    image: "https://i.scdn.co/image/d34f0dc41fcb5578bcad1f9d8a2d0caf39fc6190",
    spotify: "6RAx8RRxoHeJIqD2d0EjOa",
    genre: "deep euro house,electronica",
    popularity: "55",
  },
  {
    name: "Chace",
    image: "https://i.scdn.co/image/0633917e135be31947c9337095ef5a4077bc32d6",
    spotify: "5kPhAZL6iV8iDywUmIPC3g",
    genre: "chinese electronic",
    popularity: "55",
  },
  {
    name: "Dante Klein",
    image: "https://i.scdn.co/image/8c9a1c56691b0eb656b72d14a62202a05be28483",
    spotify: "1b4DN8Vj0dnj5cceMFsRYN",
    genre: "deep big room,pop edm",
    popularity: "55",
  },
  {
    name: "Jody Wisternoff",
    image: "https://i.scdn.co/image/6d199f7b50fe76c32afa6fc3cb71bc6731918ec5",
    spotify: "5gTVJRQmuS88nOhhdHqErL",
    genre: "bristol electronic,progressive house,progressive trance house",
    popularity: "55",
  },
  {
    name: "Folamour",
    image: "https://i.scdn.co/image/c8b73ae56afcebb809c8a9259cacfdc4414d2781",
    spotify: "6pJY5At9SiMpAOBrw9YosS",
    genre: "deep house,disco house,float house,indie soul,lo-fi house",
    popularity: "55",
  },
  {
    name: "WhoMadeWho",
    image: "https://i.scdn.co/image/12c1122c3b132d2baa1aeac12176972e613a9d29",
    spotify: "50Lr1puweM1hFsF1LpIZLM",
    genre:
      "alternative dance,dance-punk,danish indie,electronica,experimental pop,indie soul,indietronica,new rave,nu disco",
    popularity: "55",
  },
  {
    name: "Refuzion",
    image: "https://i.scdn.co/image/390411569cae108b2411b954197343fcaebe4d56",
    spotify: "1BpCQRsYuiRg1TXKR2SQe1",
    genre: "classic hardstyle,euphoric hardstyle,hardstyle",
    popularity: "55",
  },
  {
    name: "Victor Lou",
    image: "https://i.scdn.co/image/d28f4264aa006904995d606e0a39f99983ac3313",
    spotify: "063wYkWkHrq5L5YWdrqjEt",
    genre: "brazilian edm",
    popularity: "55",
  },
  {
    name: "Mark Sixma",
    image: "https://i.scdn.co/image/4207429cf83c1ec8ad2725416242e66414b3de50",
    spotify: "3ePCIHipMKD4n8IBXBYWSm",
    genre:
      "big room,dutch trance,edm,progressive house,progressive trance,trance,uplifting trance",
    popularity: "55",
  },
  {
    name: "ValsBezig",
    image: "https://i.scdn.co/image/5d91b5ffe7b5e6d2388fac3664f34a9babaa2af6",
    spotify: "4tGJvDWhLFxzKRi94gc4a4",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "55",
  },
  {
    name: "Tyron Hapi",
    image: "https://i.scdn.co/image/d356497db7776f420da3ede17dc0cf8d6f646e18",
    spotify: "5aSBbBUbArJfyNKDg4KS1I",
    genre: "australian pop,sky room,tropical house",
    popularity: "55",
  },
  {
    name: "Conro",
    image: "https://i.scdn.co/image/fb706339a97ad0679ce21c4ac7b733b1f9958023",
    spotify: "1BAdSa5cdtCNLbvT7gWmtJ",
    genre:
      "canadian electronic,catstep,edm,electro house,future bass,gaming edm,pop edm",
    popularity: "55",
  },
  {
    name: "D Double E",
    image: "https://i.scdn.co/image/9995691ebd8b21f01de1fff5fd113e694007ca64",
    spotify: "6bwkMlweHsBCpI2a0C5nnN",
    genre: "bassline,grime,uk alternative hip hop,uk hip hop",
    popularity: "55",
  },
  {
    name: "Sonny Wilson",
    image: "https://i.scdn.co/image/2a1c724cc6b1f3602d5faffe08a3b75d3e70bd09",
    spotify: "3gTl4XARdQR2Sy59osG0Ia",
    genre: "",
    popularity: "55",
  },
  {
    name: "Icarus",
    image: "https://i.scdn.co/image/93999571d4139a3d4039fb2756b4e7bbc794c281",
    spotify: "0nUF7iT0e6D5xEl743Jfu3",
    genre: "house,progressive house,tropical house",
    popularity: "55",
  },
  {
    name: "Emma Hewitt",
    image: "https://i.scdn.co/image/50109c198baee5324bdd3e9e0086beddffa96f50",
    spotify: "1t65YxEAtU3iii6bCzSGF8",
    genre: "trance,vocal trance",
    popularity: "55",
  },
  {
    name: "Blanks",
    image: "https://i.scdn.co/image/6b8b3ca14af617d7eee8dbdfe0aa6600673f2d81",
    spotify: "7geo7fjTQyp13Wf2ALTZCF",
    genre: "",
    popularity: "55",
  },
  {
    name: "The Flexican",
    image: "https://i.scdn.co/image/01f519c45632aef7adc3a3f4c2602f93c99eef19",
    spotify: "5Z3k52rtOTnOnvFHoKNHEN",
    genre: "dutch hip hop,moombahton",
    popularity: "55",
  },
  {
    name: "Charlotte Haining",
    image: "https://i.scdn.co/image/2162d9f3b3c9730a63e1f4668cf907c7be1aba49",
    spotify: "2XRjIwgD0UiJXtx7Xzfy7w",
    genre: "",
    popularity: "55",
  },
  {
    name: "Lawrence",
    image: "https://i.scdn.co/image/1bac13ad5d8d7898161c9175c948c32c09627908",
    spotify: "5rwUYLyUq8gBsVaOUcUxpE",
    genre: "modern funk,nyc pop,retro soul",
    popularity: "55",
  },
  {
    name: "Lauwtje",
    image: "https://i.scdn.co/image/ed2edb020a7e9fe40481f2fa00ac85ae231986ba",
    spotify: "1yWjbmwKNd1q0PI1V1BuQ7",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "55",
  },
  {
    name: "Tom Staar",
    image: "https://i.scdn.co/image/fc5d4986b859426defb702103fea112b3f73188b",
    spotify: "0iSYvHKAdhWVdZkS1PYK3u",
    genre:
      "big room,edm,electro house,progressive electro house,progressive house",
    popularity: "55",
  },
  {
    name: "Tamino",
    image: "https://i.scdn.co/image/f17ddfa246db1b8e1f681f658be732b0779d7ea2",
    spotify: "3IWdvItNhmdo282Wwp0CwH",
    genre: "belgian indie",
    popularity: "55",
  },
  {
    name: "Sikdope",
    image: "https://i.scdn.co/image/a8c0567ce0429a98867357da15b8a00ba1f8a267",
    spotify: "3EXfNuPuR3OFEdlyoSutcG",
    genre:
      "bass house,brostep,deep big room,edm,electro house,electronic trap,zapstep",
    popularity: "55",
  },
  {
    name: "Maceo Plex",
    image: "https://i.scdn.co/image/62e7290c263dcf4f6e4d5cf0ce9986737b995d0e",
    spotify: "3TXQ1ddouwQAI78hV4hXDj",
    genre:
      "deep disco house,house,latin tech house,melodic techno,microhouse,minimal tech house,minimal techno,tech house",
    popularity: "55",
  },
  {
    name: "Tom Novy",
    image: "https://i.scdn.co/image/d8c23b3c5eb2e2fadefa57dbaa47382cda84b3a6",
    spotify: "1EVpn7mXyF07LuJqgUk6RX",
    genre: "disco house,vocal house",
    popularity: "55",
  },
  {
    name: "Taska Black",
    image: "https://i.scdn.co/image/fd809acf2a735a7b81507d9204a9a8022595195e",
    spotify: "3XFcu2NnGWceLNdxRCfYH3",
    genre:
      "bass trap,edm,electronic trap,electropop,future bass,indie electropop,pop edm,traprun,vapor twitch",
    popularity: "55",
  },
  {
    name: "Kempi",
    image: "https://i.scdn.co/image/c3dad707ad452d22dfef56bcd94122b10689cddf",
    spotify: "0FWWBkIJD4tvlDzB4O8XT7",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "55",
  },
  {
    name: "Pharoahe Monch",
    image: "https://i.scdn.co/image/61fc4e8d2a3eb295a12482ac7cedc242a65366f8",
    spotify: "5DKuVtlpDH0agZQUFDy8O7",
    genre:
      "alternative hip hop,conscious hip hop,east coast hip hop,hardcore hip hop,hip hop,queens hip hop,turntablism",
    popularity: "55",
  },
  {
    name: "Amadou & Mariam",
    image: "https://i.scdn.co/image/1c12c1e29057ac67cc5138cca8b9c9b4ec836de9",
    spotify: "3KH7WsR2JZQ94Ik8SyabU6",
    genre: "afrobeat,afropop,malian blues,mande pop,world",
    popularity: "55",
  },
  {
    name: "Cabu",
    image: "https://i.scdn.co/image/a5682011d16b03e69d02b5171d6ca528c34d6d18",
    spotify: "44hPDOKyTwkFxOL08UzNQE",
    genre: "indie soul",
    popularity: "55",
  },
  {
    name: "Dada Life",
    image: "https://i.scdn.co/image/afa5e4d3d4a5f863c63138689957c6fc9afc63fe",
    spotify: "00sAT5YX8W3xNd1EuqyHw9",
    genre:
      "big room,complextro,dance pop,deep big room,edm,electro house,progressive electro house,progressive house",
    popularity: "55",
  },
  {
    name: "Sevdaliza",
    image: "https://i.scdn.co/image/71f1a3011262920724a4fa15cbb195ec74335ccc",
    spotify: "5MraexJKZDrQYzS98kNwie",
    genre: "art pop,electropop,escape room,indie r&b",
    popularity: "55",
  },
  {
    name: "Paul Oakenfold",
    image: "https://i.scdn.co/image/ffd7d612b8a313078af3b8247ee806c10ff728a4",
    spotify: "5MO2kbaGGA2a8kL4c9qqHq",
    genre: "big beat,progressive house,trance",
    popularity: "55",
  },
  {
    name: "Toby Green",
    image: "https://i.scdn.co/image/32b36099ae83aac499cdb5c92787aee224e75e9e",
    spotify: "7IVgVM49Z4ztdmOqOIxhvP",
    genre:
      "big room,deep big room,edm,electro house,progressive electro house,progressive house,sky room",
    popularity: "55",
  },
  {
    name: "Habstrakt",
    image: "https://i.scdn.co/image/1241f08921a671ca3e09ba10d7249e08485ff845",
    spotify: "1YYJxpOXYk1z1WtqdeLMkn",
    genre:
      "bass house,brostep,catstep,edm,electro house,electronic trap,filthstep,zapstep",
    popularity: "55",
  },
  {
    name: "TOPS",
    image: "https://i.scdn.co/image/ea2fa21d243120eaf34963db680f2090e72a9985",
    spotify: "2SdK1QDmZIP2hk94rSaLl9",
    genre:
      "art pop,chillwave,indie pop,indie rock,indie soul,indietronica,quebec indie,shiver pop",
    popularity: "55",
  },
  {
    name: "Black Flag",
    image: "https://i.scdn.co/image/709f4280eb3e6626bc1ffb55055a28df9c6235a4",
    spotify: "5Mhs3Eu8lU6sRCtRYsmABV",
    genre: "alternative rock,hardcore punk,punk",
    popularity: "55",
  },
  {
    name: "Croatia Squad",
    image: "https://i.scdn.co/image/c804a4fe9745fb1dfa4a4d63f574550c62dc95f5",
    spotify: "3FAUGHLioXySQ1QTnCOWQC",
    genre:
      "deep groove house,edm,electro house,groove room,house,progressive house",
    popularity: "55",
  },
  {
    name: "NAATIONS",
    image: "https://i.scdn.co/image/faa13a45c5cc924eee263345a3cc3842bb8b2db4",
    spotify: "6mpxgK8EZh8VDoe6trGF0f",
    genre: "la pop",
    popularity: "55",
  },
  {
    name: "Al Stewart",
    image: "https://i.scdn.co/image/ccaee5b70c1958b1496e16dcb50d2d6e98356862",
    spotify: "0DW7boyjvbaSP3OJ72sXgC",
    genre:
      "album rock,art rock,classic rock,classic uk pop,country rock,folk,folk rock,mellow gold,progressive rock,soft rock,symphonic rock",
    popularity: "55",
  },
  {
    name: "Beres Hammond",
    image: "https://i.scdn.co/image/09aeab70e7cb8824ff0d9c4be8761b8844f41bfc",
    spotify: "2ruMkdO4e1tJWDHsYSEtxr",
    genre: "lovers rock,old school dancehall,reggae,roots reggae,soca",
    popularity: "55",
  },
  {
    name: "Oddisee",
    image: "https://i.scdn.co/image/610427ca00e097955f0f370a3f22eb0f23f6208e",
    spotify: "72tRiBHei5G9M8it4h4sfC",
    genre: "alternative hip hop,dmv rap,hip hop,sudanese pop",
    popularity: "55",
  },
  {
    name: "Laura Fygi",
    image: "https://i.scdn.co/image/49c979374af5c59b09a8c6caeaaac80bae1c6c0d",
    spotify: "5ETqbIZYRoPMQbly4iVfuB",
    genre: "adult standards,contemporary vocal jazz,lounge,vocal jazz",
    popularity: "55",
  },
  {
    name: "The Faim",
    image: "https://i.scdn.co/image/b043cb50d2d77589f572ce649437691daddf0004",
    spotify: "6VsU92soWFLtVsSP65rkrN",
    genre: "australian alternative rock,modern alternative rock",
    popularity: "55",
  },
  {
    name: "Dion Timmer",
    image: "https://i.scdn.co/image/39ce4ac3a6a6eb2acc65ace0f26c9c0311e13f00",
    spotify: "06VibSJEr3GLxLBBZhRums",
    genre:
      "brostep,catstep,deathstep,edm,electro house,electronic trap,zapstep",
    popularity: "55",
  },
  {
    name: "Gregor Salto",
    image: "https://i.scdn.co/image/542d7fd5c1f92f36c96d2a87344e779994ea842c",
    spotify: "0l59CBSPDfKBXlyHya0pew",
    genre: "electro house,latin house",
    popularity: "55",
  },
  {
    name: "Billy Strings",
    image: "https://i.scdn.co/image/f65ffc77e97e7b8854c3868a695717ea17eb880f",
    spotify: "1ZN1c1qWEGZNX1pGeKCPpf",
    genre: "jam band,jamgrass,progressive bluegrass",
    popularity: "55",
  },
  {
    name: "Everlight",
    image: "https://i.scdn.co/image/ab67616d0000b273a3e35c40bf5bb28249fa42b7",
    spotify: "6RavlD6YjBgKC9iSh3uHgg",
    genre: "background music",
    popularity: "55",
  },
  {
    name: "DIIV",
    image: "https://i.scdn.co/image/cca8cccc1d9b3644bf259887ba01bb5222c188c5",
    spotify: "4OrizGCKhOrW6iDDJHN9xd",
    genre:
      "brooklyn indie,chillwave,indie pop,indie rock,indie surf,modern alternative rock,modern dream pop,modern rock,neo-psychedelic,new rave,nu gaze,shoegaze",
    popularity: "55",
  },
  {
    name: "Alexandra Burke",
    image: "https://i.scdn.co/image/1bb2ab08ac6af3de420375ea6153b55632672f33",
    spotify: "6yZoNdsPrYLviaEOOzbZt8",
    genre: "dance pop,europop,post-teen pop,talent show",
    popularity: "55",
  },
  {
    name: "Sunnery James & Ryan Marciano",
    image: "https://i.scdn.co/image/68bf6d0940e8161c870a5184878d3474e0a5878d",
    spotify: "7kABWMhjA5GIl9PBEasBPt",
    genre:
      "big room,circuit,dutch house,edm,electro house,progressive electro house",
    popularity: "54",
  },
  {
    name: "Be Svendsen",
    image: "https://i.scdn.co/image/f7c1718a778f700fdff1c88ef5fdff04041fe633",
    spotify: "4BaLB5aiExO29BEGVUisru",
    genre: "deep euro house,organic electronic,organic house,tech house",
    popularity: "54",
  },
  {
    name: "AC Slater",
    image: "https://i.scdn.co/image/dea0d6e234d368cab80b87800772603e5b4376c0",
    spotify: "6EqFMCnVGBRNmwPlk2f3Uc",
    genre:
      "bass house,brostep,deep groove house,edm,electro house,electronic trap,fidget house,house",
    popularity: "54",
  },
  {
    name: "Adam Beyer",
    image: "https://i.scdn.co/image/76884940d7663521c8d120ef3c510c21c1645c65",
    spotify: "1btv9qmIpbp7q1ixCYNdHu",
    genre:
      "dark techno,minimal techno,raw techno,schranz,swedish electronic,swedish techno,techno",
    popularity: "54",
  },
  {
    name: "GLOWINTHEDARK",
    image: "https://i.scdn.co/image/3e07feb11e771a5894d453cb92d8c9faf6e473b8",
    spotify: "2gLZZdgHD8ZbSAB2qQkr3P",
    genre: "dutch hip hop,dutch house,dutch pop,dutch trap pop",
    popularity: "54",
  },
  {
    name: "Weval",
    image: "https://i.scdn.co/image/8e91f3979bdd5fb67cb217eff91c53c03bd63622",
    spotify: "12tZvy2xFpWSkuJ3FsfisZ",
    genre:
      "electronica,french indietronica,indie soul,microhouse,minimal techno,new french touch,new rave",
    popularity: "54",
  },
  {
    name: "Evokings",
    image: "https://i.scdn.co/image/ec89c85d40897473e0a0ec8603758e06d7a4ecc5",
    spotify: "2PHZw1JCGqwqxZdZ0tt222",
    genre: "brazilian edm,brazilian house",
    popularity: "54",
  },
  {
    name: "Ross from Friends",
    image: "https://i.scdn.co/image/66212c44acc578f163c52247687d2f07a2f31ed7",
    spotify: "1Ma3pJzPIrAyYPNRkp3SUF",
    genre: "deep house,electronica,float house,indie soul,lo-fi house",
    popularity: "54",
  },
  {
    name: "Reinier Zonneveld",
    image: "https://i.scdn.co/image/edac9ca09673418e46b8e483cbae1f24290bc0e5",
    spotify: "21A7bhIL1m6CNZn8y57PIZ",
    genre: "dark techno",
    popularity: "54",
  },
  {
    name: "MEUTE",
    image: "https://i.scdn.co/image/b1e35619f75700f508ef4d28716ce5bdc94f55b4",
    spotify: "1z5xbcOeFRQXBVDpvRPh8H",
    genre: "german dance,hamburg electronic,livetronica",
    popularity: "54",
  },
  {
    name: "Alain Clark",
    image: "https://i.scdn.co/image/eb75f8525703a5beec598c863bbad45e2da82396",
    spotify: "68tIJ2KGC2bUs1cmIhJ9mW",
    genre: "dutch pop,dutch rock,neo mellow",
    popularity: "54",
  },
  {
    name: "Cubicolor",
    image: "https://i.scdn.co/image/81f1460206c716bdd6c8160fa00ce445870541ec",
    spotify: "4nMIbZxtt1kWqUZ8VNKvjU",
    genre: "progressive house",
    popularity: "54",
  },
  {
    name: "Markus Schulz",
    image: "https://i.scdn.co/image/f20e72e390d366ac6773b6cea688ea333607ee52",
    spotify: "6OO0PboZcIWUWL7j2IyeoL",
    genre: "edm,progressive house,progressive trance,trance,uplifting trance",
    popularity: "54",
  },
  {
    name: "Jacin Trill",
    image: "https://i.scdn.co/image/055b23c55048630c4d3ea5e96dbfee07b43debb0",
    spotify: "4hKoG9QvxsFDLIntc6tZ0g",
    genre: "dutch hip hop",
    popularity: "54",
  },
  {
    name: "Hercules & Love Affair",
    image: "https://i.scdn.co/image/5c1c4a094ca4ae1e25088725873ec12946daaf5c",
    spotify: "1WHoAjAWGx5qLsgzpaOk7W",
    genre:
      "alternative dance,art pop,dance pop,dance-punk,electronica,indietronica,new rave,nu disco",
    popularity: "54",
  },
  {
    name: "Noisia",
    image: "https://i.scdn.co/image/ace22cbd12846cc5dc3fabbde8d3783bc20c2ab4",
    spotify: "4YWj8sohRDjL9deiuRvEEY",
    genre: "breakbeat,brostep,deep dnb,drum and bass,dutch dnb,neurofunk",
    popularity: "54",
  },
  {
    name: "Code Black",
    image: "https://i.scdn.co/image/3a5bd3b2c1c5de1cf22217e819d7a6658aa0570b",
    spotify: "0I5is4tdxHhT3Ft2EzPjlB",
    genre: "classic hardstyle,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "54",
  },
  {
    name: "Feenixpawl",
    image: "https://i.scdn.co/image/92c84cad487f3a38665bc623d0b43bffe1d57121",
    spotify: "5FvlJcXnFIm72pgQtW3Dct",
    genre:
      "australian dance,big room,deep big room,edm,electro house,pop edm,progressive electro house",
    popularity: "54",
  },
  {
    name: "Agoria",
    image: "https://i.scdn.co/image/fe90fd8eebd3ddeca81da27bd47356c7ac89d1b5",
    spotify: "4lu50np3LdTkRL09T7x8UP",
    genre:
      "electronica,microhouse,minimal tech house,minimal techno,new french touch,organic house,tech house",
    popularity: "54",
  },
  {
    name: "Liam Bailey",
    image: "https://i.scdn.co/image/3b0bb4a8b271654079f029be86d84809ed06cf08",
    spotify: "022EiWsch2zvty0qBUksDO",
    genre: "british soul",
    popularity: "54",
  },
  {
    name: "Phaxe",
    image: "https://i.scdn.co/image/02721257bbac8f44646c11088970346dd142a4af",
    spotify: "4Pgbnc1zRPquMFR4iPH3MN",
    genre: "brazilian edm,progressive psytrance,psychedelic trance",
    popularity: "54",
  },
  {
    name: "Pixie Lott",
    image: "https://i.scdn.co/image/cd669ac9fcb7611d62b56fbf5ca2258aae0c226a",
    spotify: "3EBRANWwnViQuBrImN61Z1",
    genre: "dance pop,electropop,europop,post-teen pop",
    popularity: "54",
  },
  {
    name: "Digitalism",
    image: "https://i.scdn.co/image/ebd3d86085c1e467945a7e41b8f63caaca53066a",
    spotify: "2fBURuq7FrlH6z5F92mpOl",
    genre:
      "alternative dance,big beat,dance-punk,disco house,electro house,electronica,indietronica,new rave",
    popularity: "54",
  },
  {
    name: "KOKOROKO",
    image: "https://i.scdn.co/image/09c941dc3d3f6f0b4c3601f92ad218ced920899d",
    spotify: "3u9rbdcmA6CxjxOAkjaeFr",
    genre: "british jazz,indie jazz,indie soul",
    popularity: "54",
  },
  {
    name: "Snarky Puppy",
    image: "https://i.scdn.co/image/8a4f564374809aa34a438a848201e13b65c7012b",
    spotify: "7ENzCHnmJUr20nUjoZ0zZ1",
    genre:
      "contemporary jazz,funk rock,jazz fusion,modern funk,progressive jazz fusion",
    popularity: "54",
  },
  {
    name: "Lagwagon",
    image: "https://i.scdn.co/image/ab6772690000c46c0ddf98512e0e07338dfa0efd",
    spotify: "66riGCPfih1Xqk81dDvpvf",
    genre: "melodic hardcore,pop punk,punk,ska punk,skate punk,socal pop punk",
    popularity: "54",
  },
  {
    name: "Dead Prez",
    image: "https://i.scdn.co/image/f8bff2568480977edada697509e493e9eaeaf78f",
    spotify: "2UBt0GWBuPVXlPisRvWzlD",
    genre:
      "alternative hip hop,conscious hip hop,east coast hip hop,hardcore hip hop,hip hop,political hip hop",
    popularity: "54",
  },
  {
    name: "Buika",
    image: "https://i.scdn.co/image/b072e6410d06a9515e6d35f9d49054fbe77d21a7",
    spotify: "1gbXoccc8bjK8eUh92mILy",
    genre: "flamenco",
    popularity: "54",
  },
  {
    name: "George McCrae",
    image: "https://i.scdn.co/image/fe9b81e113fda9e9594c1be350add321d8eaffea",
    spotify: "6oV3BNm1Gj2GGgpYknc5TN",
    genre: "disco,motown",
    popularity: "54",
  },
  {
    name: "All Them Witches",
    image: "https://i.scdn.co/image/36bd061359f3dec83e3b481f21ef387445d1cda8",
    spotify: "29Wmfm1CojrjQ3aQP0FI65",
    genre:
      "indie rock,modern alternative rock,modern blues rock,modern rock,neo-psychedelic,psychedelic doom,space rock,stoner rock",
    popularity: "54",
  },
  {
    name: "Animals As Leaders",
    image: "https://i.scdn.co/image/60afcaaa50d121e2c5f20e404825dc27084c14d7",
    spotify: "65C6Unk7nhg2aCnVuAPMo8",
    genre:
      "djent,instrumental rock,jazz metal,progressive jazz fusion,progressive metal",
    popularity: "54",
  },
  {
    name: "Cloonee",
    image: "https://i.scdn.co/image/a7b3a8c67c80ae3e187a55efd4f0ed9e2a6918f3",
    spotify: "7MdlXmq2HViAJWo9cf30sR",
    genre: "deep groove house,house",
    popularity: "54",
  },
  {
    name: "Tom Segura",
    image: "https://i.scdn.co/image/3c3c852e4f9b6b80510873d83a167e6957f0da6b",
    spotify: "2hbxpW1A25vEmipIEIM9kY",
    genre: "comedy,comic",
    popularity: "54",
  },
  {
    name: "The Knife",
    image: "https://i.scdn.co/image/bb08ff7de16f02cab97b1a772a5797a017248037",
    spotify: "7eQZTqEMozBcuSubfu52i4",
    genre:
      "alternative dance,art pop,dance-punk,electroclash,electronica,electropop,gothenburg indie,neo-synthpop,new rave,swedish electropop,swedish synthpop",
    popularity: "54",
  },
  {
    name: "Mark With a K",
    image: "https://i.scdn.co/image/00ecdd198fe377921d3aecf03d3367b6cd605343",
    spotify: "4OPaH4YIqua9DUnI7t0fOQ",
    genre: "belgian edm,classic hardstyle,euphoric hardstyle,jumpstyle",
    popularity: "53",
  },
  {
    name: "Monkey Safari",
    image: "https://i.scdn.co/image/6e49f060ec68b60e28c0f391306583e2b15bfc21",
    spotify: "5zovXI5By2gUhdr7EByjLa",
    genre: "deep euro house,organic house,tech house,tropical house",
    popularity: "53",
  },
  {
    name: "Joachim Garraud",
    image: "https://i.scdn.co/image/6c2a6e0414e6c157fb1913b15bbfa0cb16a7ad9d",
    spotify: "4EhiIwwMPecLznwn87sRw2",
    genre: "electro house",
    popularity: "53",
  },
  {
    name: "Miss Montreal",
    image: "https://i.scdn.co/image/5d8e1e480a3e8c60df76570f13f999a3cacd8b6d",
    spotify: "06eTdzI1FA6c2cPQAeVHY2",
    genre: "dutch pop,dutch rock",
    popularity: "53",
  },
  {
    name: "Hard Driver",
    image: "https://i.scdn.co/image/c984cef05a0d3844068d129291d73b05ff462881",
    spotify: "1rpLzYzfrueWdkpcIunZQl",
    genre: "classic hardstyle,hardstyle,rawstyle",
    popularity: "53",
  },
  {
    name: "Justin Prime",
    image: "https://i.scdn.co/image/3694e4c501fd9b5864e47d9218e0aca4536631f7",
    spotify: "0TFdkHvlyUVl9zrb4seHxJ",
    genre: "big room,deep big room,electro house,sky room",
    popularity: "53",
  },
  {
    name: "UMEK",
    image: "https://i.scdn.co/image/366a5d014e340f25cdaa9ecf30c1dad1b8acf6c9",
    spotify: "5Hini2nQyoglzpdKe41cZt",
    genre:
      "dark techno,minimal techno,raw techno,slovenian electronic,tech house,techno",
    popularity: "53",
  },
  {
    name: "Young Franco",
    image: "https://i.scdn.co/image/76d00d0d2b1d585b56826fd3407c20ac10374746",
    spotify: "6mK0vAO13gT8jWYANyoXAl",
    genre: "aussietronica,indie soul",
    popularity: "53",
  },
  {
    name: "$hirak",
    image: "https://i.scdn.co/image/7262e7fc763328a3906289c9c5f659ccc9d15212",
    spotify: "1uUuCEXmWpKN2YLl5xSoT2",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "53",
  },
  {
    name: "Liquid Soul",
    image: "https://i.scdn.co/image/e6981bba1a34c226a5b0ccdfd9b9e5ba4f8a9e4b",
    spotify: "64nL3MP8zmuLqUq8DDaIKS",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "53",
  },
  {
    name: "Badd Dimes",
    image: "https://i.scdn.co/image/942daced858600901bc0bcb00523de267a539d2e",
    spotify: "4ddhmWe0fgEqOyb2kihLWB",
    genre: "deep big room,sky room",
    popularity: "53",
  },
  {
    name: "Lasgo",
    image: "https://i.scdn.co/image/78d3f56a2b402c235118fed0d85156266bcf2ad9",
    spotify: "25Kw8f1zcn9VtUk5Nl3qrp",
    genre: "belgian dance,belgian pop,eurodance,europop",
    popularity: "53",
  },
  {
    name: "Matt Nash",
    image: "https://i.scdn.co/image/619a412505dadf30e7c396d671ebb93e1fe7a114",
    spotify: "0hxW1uZPEjt4wuu9wNDF2y",
    genre:
      "big room,deep big room,edm,electro house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "53",
  },
  {
    name: "Kryder",
    image: "https://i.scdn.co/image/7ee9de7c0f134f3aabf8aee2a4508def36071f39",
    spotify: "1xfLBmx0n8DQri9HxJsq9O",
    genre:
      "big room,edm,electro house,house,progressive electro house,progressive house,tech house",
    popularity: "53",
  },
  {
    name: "Douwe Bob",
    image: "https://i.scdn.co/image/fd00c1b31ea4f58ec305568440dec6ca2c69287f",
    spotify: "6VSZeMeJlVPGoR2nfB6UxD",
    genre: "dutch americana,dutch indie,dutch pop,dutch rock",
    popularity: "53",
  },
  {
    name: "Djodje",
    image: "https://i.scdn.co/image/116fa973cdce3cfe8c0e146322612654b2c8145d",
    spotify: "62huveC2Mmi9nfW0ySqNwo",
    genre: "kizomba,portuguese pop",
    popularity: "53",
  },
  {
    name: "Secondcity",
    image: "https://i.scdn.co/image/fab2c12814f075aa542dd66360390267eb08302d",
    spotify: "2ew9JvyyuOGkhahuwdovDq",
    genre:
      "deep groove house,deep house,disco house,house,uk house,vocal house",
    popularity: "53",
  },
  {
    name: "Fresku",
    image: "https://i.scdn.co/image/3a1aed3a00f49940bee42b3bc9aeb26ff873c7ee",
    spotify: "5m1cLmgZIfEYPLejhLFR10",
    genre: "dutch hip hop",
    popularity: "53",
  },
  {
    name: "Gianluca Vacchi",
    image: "https://i.scdn.co/image/355da09453e5ea9ab05ce54d1b75b5bb5bf281f5",
    spotify: "26XxGE8hLV1t9IYa8872lQ",
    genre: "",
    popularity: "53",
  },
  {
    name: "FTampa",
    image: "https://i.scdn.co/image/0a63cc703abf8237b8a5a0ff619ef6645950ad9c",
    spotify: "6P6fVBXZjnqdgq2z2b8WlO",
    genre: "brazilian edm,complextro,deep big room",
    popularity: "53",
  },
  {
    name: "Kyle Watson",
    image: "https://i.scdn.co/image/f57f57e483b8b73522c8aafa3bd0b20284025a3b",
    spotify: "7LJSAfWhO7jhjnewy6pKyZ",
    genre: "bass house,electro house,fidget house,house",
    popularity: "53",
  },
  {
    name: "Skazi",
    image: "https://i.scdn.co/image/da966931b2fbac2b66164c129bcc4005eb5b2607",
    spotify: "0YAmYesPdjvMPgnLKcDHR3",
    genre: "psychedelic trance",
    popularity: "53",
  },
  {
    name: "Delany",
    image: "https://i.scdn.co/image/9374811d0f1be083cd66fb0c3cbd65f8c0852bc6",
    spotify: "1XTd9ZCFzkRPUoO9yHQAYP",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "53",
  },
  {
    name: "The Hooters",
    image: "https://i.scdn.co/image/c988efd482eb2b73c70192ccd39061f8c9c0a5f6",
    spotify: "7uhvDINTTiD0XBrP9fquN1",
    genre: "album rock,mellow gold,philly indie,soft rock",
    popularity: "53",
  },
  {
    name: "Roberto Surace",
    image: "https://i.scdn.co/image/c132c9405cf9affdc6ab9f3987f220e5b156b845",
    spotify: "4Peqx8CmkLiHHRCfm3HR7G",
    genre:
      "deep groove house,deep house,disco house,house,italian tech house,vocal house",
    popularity: "53",
  },
  {
    name: "Ashley Wallbridge",
    image: "https://i.scdn.co/image/8afc677b3433ba91c7083e25159488c9dbcb6e20",
    spotify: "4hNpdlfPY7R51u4FEkBxJG",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "53",
  },
  {
    name: "Kav Verhouzer",
    image: "https://i.scdn.co/image/bfb12129b3b6a43d3a3c02126cb436b87bfe296d",
    spotify: "1yYBD4cVxCxXQXi4QGZfSo",
    genre: "deep tropical house,tropical house",
    popularity: "53",
  },
  {
    name: "Jonas Aden",
    image: "https://i.scdn.co/image/ff2844383a89cf7c21d49f774ba57398b1fbe326",
    spotify: "1qq5e02CcWNFqZMbmdrIcj",
    genre: "deep big room,edm,electro house,pop edm",
    popularity: "53",
  },
  {
    name: "Gaye Su Akyol",
    image: "https://i.scdn.co/image/7d57f8850701f0f045e409dfa57ede8d7772d717",
    spotify: "0VsS7WKuNEsKGNIWuiwSyZ",
    genre: "turkish jazz,turkish pop,turkish rock",
    popularity: "53",
  },
  {
    name: "4B",
    image: "https://i.scdn.co/image/b89f9ae1820cb3c5fa1fd6929d8783c132934b75",
    spotify: "0LIl9fjMPEZp8UDiL8Yuo4",
    genre: "brostep,electro house,electronic trap",
    popularity: "53",
  },
  {
    name: "Eats Everything",
    image: "https://i.scdn.co/image/31d98c94898677176a657a1ef41dfee253dddec4",
    spotify: "4W991QdgKWX4TO864ypInA",
    genre: "deep disco house,house,raw techno",
    popularity: "53",
  },
  {
    name: "T78",
    image: "https://i.scdn.co/image/68c6cc6ab39bc020ff602dd870ad57cc6b790a58",
    spotify: "5FgLkieOqGXPn01dnbJp9Z",
    genre: "dark techno,german dark minimal techno,italian techno,raw techno",
    popularity: "53",
  },
  {
    name: "Mustasch",
    image: "https://i.scdn.co/image/ce628bedb5801fc3976aff32a3515d42e85f8857",
    spotify: "7ig8pUnno95YNA9MclOveH",
    genre: "stoner metal,swedish alternative rock",
    popularity: "53",
  },
  {
    name: "We Are Loud",
    image: "https://i.scdn.co/image/439f48c14c1885aca1a15204596e800675bdb04a",
    spotify: "2INDI0xc49oGYTZC7fBZjX",
    genre: "deep big room,dutch edm",
    popularity: "53",
  },
  {
    name: "Ezra Furman",
    image: "https://i.scdn.co/image/d44acd5938018a2a3576a213adf3a2f75f2c9677",
    spotify: "1uR7zoLrSRI8bSL43OZ0GY",
    genre: "alternative pop,transpop",
    popularity: "53",
  },
  {
    name: "Clannad",
    image: "https://i.scdn.co/image/7a7044b82412f146ad5bb0571b6df91b3039a17f",
    spotify: "0BkAYxgwF9VQiid4wI07yJ",
    genre: "celtic,celtic rock,new age",
    popularity: "53",
  },
  {
    name: "Tube & Berger",
    image: "https://i.scdn.co/image/008e7c5245d71b5f2b750852865e97a13af47a7d",
    spotify: "32wcuqRxZuBY5HbH1bWa8h",
    genre:
      "deep euro house,dusseldorf electronic,german techno,groove room,house,tech house,tropical house",
    popularity: "53",
  },
  {
    name: "The Baseballs",
    image: "https://i.scdn.co/image/ae7a30f8f1b863175b8f80132126ee54d4f621bc",
    spotify: "3Ek1EdkcbRFvSDJj9j5JXQ",
    genre: "neo-rockabilly",
    popularity: "53",
  },
  {
    name: "Shooter Jennings",
    image: "https://i.scdn.co/image/af213e9ef301aa732289ed3ce79292b23654462e",
    spotify: "0F6yRPhUj9fUzWn0z3ysyr",
    genre:
      "country rock,outlaw country,roots americana,roots rock,texas country",
    popularity: "53",
  },
  {
    name: "Tom Budin",
    image: "https://i.scdn.co/image/548e99d87229cd66a59852320a5801f90daaa04f",
    spotify: "1kwRrQDCpXpVliMDntpxCt",
    genre: "deep groove house,electro house,house,pop edm",
    popularity: "53",
  },
  {
    name: "Dave Winnel",
    image: "https://i.scdn.co/image/c73072cdfce62c474f44ba9b3a638cebd3f67200",
    spotify: "1K80Wcuuo13i28cVd68mxm",
    genre: "edm,electro house",
    popularity: "53",
  },
  {
    name: "Oumou Sangaré",
    image: "https://i.scdn.co/image/b2d17ee3310d510effda344518a8906b4e7ff5cb",
    spotify: "65CKKZilbcSKkAPC9a5Mvh",
    genre: "afrobeat,afropop,malian blues,mande pop,wassoulou,world",
    popularity: "53",
  },
  {
    name: "TNT",
    image: "https://i.scdn.co/image/6cde5fe4e567e74a9c30465d737e7b9e8cfad977",
    spotify: "1CqOLQmjzVWXQTiIN5Wucs",
    genre: "euphoric hardstyle,hardstyle",
    popularity: "53",
  },
  {
    name: "Lavinia Meijer",
    image: "https://i.scdn.co/image/2bc675f538e35f8b99342c954f43ee65f734ccbe",
    spotify: "1QpDFI4PxPwdv2E3iS6pCp",
    genre: "classical harp",
    popularity: "53",
  },
  {
    name: "Stavroz",
    image: "https://i.scdn.co/image/066090a09fb1e0a4277076c9db47d89b2af0ce44",
    spotify: "7su1fG75ZwXHA6ei9Zcy7T",
    genre: "deep euro house,ethnotronica,organic electronic,organic house",
    popularity: "53",
  },
  {
    name: "Crystal Lake",
    image: "https://i.scdn.co/image/43c8690265b73846bdc3554240fee522b220da78",
    spotify: "0A7d0PJxaLO7CGI94ht6PX",
    genre: "japanese metalcore,japanese punk rock,metalcore",
    popularity: "53",
  },
  {
    name: "Adriatique",
    image: "https://i.scdn.co/image/4c1b49714fdf3c0f36f23db4c9ff69fcd595fb8a",
    spotify: "02DWGcShQivFepRvGJ7xhB",
    genre:
      "deep disco house,house,melodic techno,microhouse,organic house,swiss house,tech house",
    popularity: "53",
  },
  {
    name: "Nause",
    image: "https://i.scdn.co/image/a9ad549ca7223135ab8dff2eb0cf78c36d6c5046",
    spotify: "4PVn1b2WnnXdq80C7uaZLZ",
    genre: "edm,progressive electro house,swedish pop",
    popularity: "53",
  },
  {
    name: "Alfa Mist",
    image: "https://i.scdn.co/image/2d439f7dfd746831a33e33129dda0477f56a92f5",
    spotify: "2i1CPudyCUjL50Wqjv8AMI",
    genre: "british jazz,indie jazz,indie soul,neo r&b,uk contemporary jazz",
    popularity: "53",
  },
  {
    name: "Datsik",
    image: "https://i.scdn.co/image/998455c3642542a0d5c4f9eb52c0d5a473828d39",
    spotify: "48q2mPVwlKnlSaCx07i6Ta",
    genre:
      "bass trap,breakbeat,brostep,canadian electronic,edm,electro house,electronic trap,filthstep,zapstep",
    popularity: "53",
  },
  {
    name: "Max Cooper",
    image: "https://i.scdn.co/image/de9e5216b1f1dab4a23c3255e825fbacfe283e5a",
    spotify: "0WSSKmoRbxqLf3MnXInQ2J",
    genre: "electronica,microhouse,minimal techno,modular synth,tech house",
    popularity: "53",
  },
  {
    name: "Tempo Giusto",
    image: "https://i.scdn.co/image/5f807508e545a8f5ec5019e28ae8089776c4d8e6",
    spotify: "0m0RB1rz2K4biPY7teHR6R",
    genre:
      "finnish edm,progressive house,progressive trance,tech trance,trance,uplifting trance",
    popularity: "53",
  },
  {
    name: "The Acacia Strain",
    image: "https://i.scdn.co/image/f2351984a0e20d5dc5996ff82347717c36fb7d2e",
    spotify: "4tDkeVxH0CSkNiLVrsYmQs",
    genre: "deathcore,djent,melodic metalcore,metalcore",
    popularity: "53",
  },
  {
    name: "Lauren Aquilina",
    image: "https://i.scdn.co/image/c69936ee603349bf94800c042b5b3d020694a274",
    spotify: "22qLnGc8B1btqty6d0Qnlm",
    genre: "neo-singer-songwriter,viral pop",
    popularity: "53",
  },
  {
    name: "Kollektiv Turmstrasse",
    image: "https://i.scdn.co/image/764301b40b388e407932b9f95c379434c680ccb2",
    spotify: "1oXiuCd5F0DcnmXH5KaM6N",
    genre:
      "deep euro house,electronica,german techno,hamburg electronic,microhouse,minimal techno,organic electronic,tech house",
    popularity: "53",
  },
  {
    name: "City of the Sun",
    image: "https://i.scdn.co/image/0a549265f478d83958e1e45e1cec5d83b9a832db",
    spotify: "4DkYxtaASIKQnk4Gj0TB7k",
    genre: "american post-rock",
    popularity: "53",
  },
  {
    name: "Westerman",
    image: "https://i.scdn.co/image/59b45a30bb376aba752e17d3a3c16644f6c02294",
    spotify: "09s6bLEw45wioK9ytf3nsA",
    genre: "art pop,chamber pop,indie folk,uk alternative pop",
    popularity: "53",
  },
  {
    name: "JEANS",
    image: "https://i.scdn.co/image/f3c5068388176dd8c174657564d29de38a5ada9c",
    spotify: "4HncQjB1Qpyke5EJtU3e3Y",
    genre: "dance pop,latin,latin arena pop,latin pop,mexican pop",
    popularity: "53",
  },
  {
    name: "twoloud",
    image: "https://i.scdn.co/image/64dfec7d6bada43066a3730e80379818a1b50f32",
    spotify: "6eUtrZgzxqbV7zMxzN3Sz2",
    genre:
      "big room,deep big room,edm,electro house,progressive electro house,progressive house,sky room",
    popularity: "53",
  },
  {
    name: "Leprous",
    image: "https://i.scdn.co/image/b83fd50a2b9cff216d8751a7de299a228bc4e409",
    spotify: "4lgrzShsg2FLA89UM2fdO5",
    genre: "djent,norwegian metal,prog metal,progressive metal",
    popularity: "53",
  },
  {
    name: "Amelie Lens",
    image: "https://i.scdn.co/image/76599630c2dbd6357ffacba9c42398ecf8e5c286",
    spotify: "5Ho1vKl1Uz8bJlk4vbmvmf",
    genre:
      "acid techno,belgian techno,dark techno,electra,minimal techno,tech house",
    popularity: "52",
  },
  {
    name: "Orjan Nilsen",
    image: "https://i.scdn.co/image/4b65e32dd150dfb06e1c5de481018860ab74d289",
    spotify: "1YuNQvsvOsMBm0ahbxB8qM",
    genre:
      "big room,edm,progressive house,progressive trance,trance,uplifting trance",
    popularity: "52",
  },
  {
    name: "Adana Twins",
    image: "https://i.scdn.co/image/492a1bf2ecf99308b549e5977423d90fef9b2e27",
    spotify: "2JnkjHtuUjz83gkEx8QMS4",
    genre:
      "deep disco house,german house,hamburg electronic,house,organic house,tech house",
    popularity: "52",
  },
  {
    name: "Etherwood",
    image: "https://i.scdn.co/image/b208708563ab9ce3f7d26ad1209e07f7698041c7",
    spotify: "3GEUIa3Z0Qlivy3EcJm5RX",
    genre: "chillstep,deep liquid,drum and bass,liquid funk",
    popularity: "52",
  },
  {
    name: "The Martinez Brothers",
    image: "https://i.scdn.co/image/7bbb0d1decca6909341f4e97743e53f59356f9ff",
    spotify: "7B1LLuCQk13H4Mb6CFBftU",
    genre: "minimal tech house",
    popularity: "52",
  },
  {
    name: "Heinz Strunk",
    image: "https://i.scdn.co/image/35d40e3634c185c3b1f71ff25a7f10da9d85664b",
    spotify: "1wMKPEAO71Vj0kTI0SFu8o",
    genre: "hoerspiel,kabarett,reading",
    popularity: "52",
  },
  {
    name: "The Mouse Outfit",
    image: "https://i.scdn.co/image/b26a5b2fc6cf4e2dfd6be7e4cb38453d90659d45",
    spotify: "3fZgTHf9UHEA1oLYLEhnk2",
    genre: "manchester hip hop,uk alternative hip hop",
    popularity: "52",
  },
  {
    name: "Mike Mago",
    image: "https://i.scdn.co/image/4e0cd39e4f9f062aa2aad23dd25eb10744503af8",
    spotify: "5lwT6gFdwV3Wcol07KUiJx",
    genre:
      "deep groove house,deep tropical house,edm,electro house,house,pop edm,tropical house",
    popularity: "52",
  },
  {
    name: "Giuseppe Ottaviani",
    image: "https://i.scdn.co/image/71f3f50192efe45992a542d3dca9888957b8d647",
    spotify: "5B9q1NRokzWYB7nSgnlHyv",
    genre:
      "italian trance,progressive house,progressive trance,trance,uplifting trance",
    popularity: "52",
  },
  {
    name: "BIJOU",
    image: "https://i.scdn.co/image/63b87bde403df4e16c52a6f6c004f4ff3db69f1f",
    spotify: "3abRKajGbb3kLMy9AWzfMA",
    genre: "bass house,electro house",
    popularity: "52",
  },
  {
    name: "Bonaparte",
    image: "https://i.scdn.co/image/70fb19c8109b2079e0fba1f917f9879802dbc14e",
    spotify: "2jwl8DJIsmnFbA5vPdGSCy",
    genre:
      "electronic rock,german alternative rock,german indie,german pop,german rock,swiss indie",
    popularity: "52",
  },
  {
    name: "Ilan Bluestone",
    image: "https://i.scdn.co/image/2f81add8f4621f30b45d81835d06a38e6ec68875",
    spotify: "1yoZuH2j43vVSWsOwYuQyn",
    genre: "edm,progressive house,progressive trance,trance,uplifting trance",
    popularity: "52",
  },
  {
    name: "Manse",
    image: "https://i.scdn.co/image/bdfaeab6489f9c10a9467a6a435c368c5ce52ade",
    spotify: "2jGvmFH6YE352p9LKmuB0y",
    genre:
      "big room,deep big room,edm,electro house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "52",
  },
  {
    name: "Mott The Hoople",
    image: "https://i.scdn.co/image/130b5d335ec440db3d2efce781ab3882c87a0781",
    spotify: "6ysQi6NI88X627t2srsWz6",
    genre:
      "album rock,art rock,blues rock,classic rock,folk rock,glam rock,hard rock,power pop,protopunk,psychedelic rock,pub rock,rock",
    popularity: "52",
  },
  {
    name: "Trijntje Oosterhuis",
    image: "https://i.scdn.co/image/be4356bb6411116e31a738cbf2ed647d50d12035",
    spotify: "7nJtdgCxkhZFvFMPTsHavb",
    genre: "dutch pop,dutch rock",
    popularity: "52",
  },
  {
    name: "Junior Sanchez",
    image: "https://i.scdn.co/image/66f43a58346d7f5b80b090ac822aa417bcf523da",
    spotify: "31ZNfGVEEcI9CyicPVJQni",
    genre: "disco house",
    popularity: "52",
  },
  {
    name: "LGoony",
    image: "https://i.scdn.co/image/fb7dc03e3b57c41698636278cc73e85cb4db655f",
    spotify: "0aZu9zUfF2EgTHyBbZlW1C",
    genre:
      "deep german hip hop,german cloud rap,german hip hop,german trap,indie deutschrap",
    popularity: "52",
  },
  {
    name: "DJ S.K.T",
    image: "https://i.scdn.co/image/e37ff40ff68a50b66d5db74a5d200585799ad4e4",
    spotify: "05z4P0nQO00HG5WeErugd0",
    genre: "deep groove house,house,uk dance",
    popularity: "52",
  },
  {
    name: "Moop Mama",
    image: "https://i.scdn.co/image/0bb87cae127c8bed8a395dd7c682f1f46ad684cd",
    spotify: "49rpD3gtSpIjsZNxdwhuYl",
    genre:
      "antideutsche,german alternative rap,german hip hop,german indie,german pop,german reggae,german rock,volkspop",
    popularity: "52",
  },
  {
    name: "Henrik Schwarz",
    image: "https://i.scdn.co/image/c8b83964e7200bc124d232f3d8e378b1f95f13ca",
    spotify: "1ooAqaFu4Ac3BO2HpL4V2R",
    genre: "german house,microhouse,minimal tech house,minimal techno",
    popularity: "52",
  },
  {
    name: "Aazar",
    image: "https://i.scdn.co/image/bff1e3897377ddba45e5699d528b1b53dbe02752",
    spotify: "7oNtf1MwhHcyXRsYXE1WsG",
    genre: "electro house,electronic trap",
    popularity: "52",
  },
  {
    name: "Eelke Kleijn",
    image: "https://i.scdn.co/image/754058ef4e69e4bf9fa765f1d036e96cb54e1017",
    spotify: "1FY8kqUQKHwjibwLbp5cey",
    genre: "organic house,progressive house,tech house",
    popularity: "52",
  },
  {
    name: "Andhim",
    image: "https://i.scdn.co/image/1bf919faf6637608b462401d0199243934311d39",
    spotify: "6XJeFzmI6vrWyHcdB7EImP",
    genre:
      "deep disco house,deep euro house,german house,minimal tech house,minimal techno,organic house,tech house,tropical house",
    popularity: "52",
  },
  {
    name: "Shapov",
    image: "https://i.scdn.co/image/b4e8dd358fe2d6416995e789bbbc45b01ec575a1",
    spotify: "36VSvhsPFTdsj1CtmatPiQ",
    genre: "big room,progressive electro house",
    popularity: "52",
  },
  {
    name: "BRUCKNER",
    image: "https://i.scdn.co/image/bb2989e51446b0539430bc61738e77d15a058730",
    spotify: "0OKQx5tW0vxtKwYVblZTkq",
    genre: "german indie,german pop",
    popularity: "52",
  },
  {
    name: "Full Crate",
    image: "https://i.scdn.co/image/2d14ef7c9c44deca0188d3772d86a153f0f15f33",
    spotify: "0JeTRYMH7FoBiMcLXg1n8g",
    genre: "alternative r&b,dutch pop,dutch r&b,indie r&b,indie soul",
    popularity: "52",
  },
  {
    name: "Corb Lund",
    image: "https://i.scdn.co/image/4749a09f90b4ce962d7d4286fa97fd9190287bc4",
    spotify: "2dIP3oiEt0xB8CrfSqN9Og",
    genre:
      "alberta country,canadian contemporary country,canadian country,canadian singer-songwriter,cowboy western",
    popularity: "52",
  },
  {
    name: "Inner City",
    image: "https://i.scdn.co/image/d802d704e597aa33763010a6709139fc23b54090",
    spotify: "0vUJ3QLN3MlRfjOc2LjGWp",
    genre:
      "chicago house,deep house,detroit house,disco house,diva house,hardcore techno,hip house,post-disco,techno,vocal house",
    popularity: "52",
  },
  {
    name: "Eliminate",
    image: "https://i.scdn.co/image/95c17a4552bc85dffc04c090d161bcdd834a714e",
    spotify: "6hBrJJrcYoNhvLC6KaFR4b",
    genre: "bass trap,brostep,edm,electro house,electronic trap,zapstep",
    popularity: "52",
  },
  {
    name: "Dennis Cruz",
    image: "https://i.scdn.co/image/d6021540108b54238759be4a246ec026aafd0656",
    spotify: "27mWOSZjlpmtoqsRjRwQyu",
    genre: "house,latin tech house",
    popularity: "52",
  },
  {
    name: "Grum",
    image: "https://i.scdn.co/image/095db307be589b30da183c60bb058a857dbc5618",
    spotify: "3VEqFWRt47xQAZJMBF3duQ",
    genre: "edm,filter house,progressive house,progressive trance",
    popularity: "52",
  },
  {
    name: "Guy Gerber",
    image: "https://i.scdn.co/image/675db84236f1b8cc9e8cc605d11ef55c2713f082",
    spotify: "3bqBkAzdPwEDe1JUvb7ZeC",
    genre:
      "deep disco house,israeli techno,microhouse,minimal tech house,minimal techno,organic electronic,organic house,tech house",
    popularity: "52",
  },
  {
    name: "PAX",
    image: "https://i.scdn.co/image/4a79b27076c2922abe5e8d5152dcb82fc8ad9ccd",
    spotify: "3NYySx3H1V7zHemD9hmsQv",
    genre: "bass house,deep groove house,house",
    popularity: "52",
  },
  {
    name: "Florian Picasso",
    image: "https://i.scdn.co/image/653deb73b4c9046fc3f621efbfa65b91563d1350",
    spotify: "4GWqzTTt2uA9Ms6HfUhWUn",
    genre:
      "big room,deep big room,edm,electro house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "52",
  },
  {
    name: "Toneshifterz",
    image: "https://i.scdn.co/image/e518f7be9b83379d6e0ca87089d767908eea71e7",
    spotify: "4LBa6kTLaQHiONCfTfTaXV",
    genre: "classic hardstyle,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "52",
  },
  {
    name: "Fabian Farell",
    image: "https://i.scdn.co/image/68a4b7c879bce688f670016df173bc59b71f1780",
    spotify: "4IOhVReVZmK8yRqFgcxDvY",
    genre: "",
    popularity: "52",
  },
  {
    name: "Kerala Dust",
    image: "https://i.scdn.co/image/ea80385e03ba8c40aff92df11dd6518dac9ea0b2",
    spotify: "6lK8O3kyFThiTmgowQZGOH",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "52",
  },
  {
    name: "Ladysmith Black Mambazo",
    image: "https://i.scdn.co/image/fc5650c4dbabb3e6bde9fd7f1d02e41313f96f76",
    spotify: "3FdLhnmXynPvZkbILPpB6d",
    genre: "afropop,south african choral,world",
    popularity: "52",
  },
  {
    name: "Wuki",
    image: "https://i.scdn.co/image/abb45705b93b8509df5c422c32a7ffcb99b89079",
    spotify: "6Se1y4vDcu9fVHLqdj1N3q",
    genre: "bass house,electro house,electronic trap",
    popularity: "52",
  },
  {
    name: "Myon",
    image: "https://i.scdn.co/image/a6466afeeecd4925b377bdc692944ca9908caed6",
    spotify: "0nTbVTXLLbBA4xCtn0cFkv",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "52",
  },
  {
    name: "Counterparts",
    image: "https://i.scdn.co/image/51002ea5536f7c1cbd0ccfaf1cc63d79c719d96b",
    spotify: "5LyRnL0rysObxDRxzSfV1z",
    genre:
      "alternative emo,canadian hardcore,canadian metal,deep melodic metalcore,melodic hardcore,melodic metalcore,metalcore",
    popularity: "52",
  },
  {
    name: "Grandbrothers",
    image: "https://i.scdn.co/image/54f0f491a033e99724aa372402304b5cd7fc3104",
    spotify: "62Jwsvqi7hW8TR9rAcfBXY",
    genre:
      "dusseldorf electronic,french indietronica,german house,prepared piano",
    popularity: "52",
  },
  {
    name: "Nicklas Sahl",
    image: "https://i.scdn.co/image/ba250f0213d4ec9e08e4752fc2d3e17f7d4f77e6",
    spotify: "3k785W4GFDnZfTortQlhMA",
    genre: "danish pop",
    popularity: "52",
  },
  {
    name: "Rodriguez Jr.",
    image: "https://i.scdn.co/image/62f68ec4c167618bcb60cc97cde72807b2947c70",
    spotify: "6Th7POyVfZgiHJQ64ddV5Y",
    genre:
      "deep disco house,deep euro house,electronica,french tech house,house,microhouse,minimal tech house,minimal techno,organic house,tech house",
    popularity: "52",
  },
  {
    name: "Boy Harsher",
    image: "https://i.scdn.co/image/1bf3f75c763ffafd7c9c404a0c6ae23592616638",
    spotify: "4iom7VVRU6AHRIu1JUXpLG",
    genre: "dark post-punk,western mass indie",
    popularity: "52",
  },
  {
    name: "Hugo Helmig",
    image: "https://i.scdn.co/image/a80e59d0d8ec0ee4816be342d3758ba3277e4f87",
    spotify: "27eEve8Mu7Zv8DGDIz4peE",
    genre: "danish pop",
    popularity: "52",
  },
  {
    name: "PAWSA",
    image: "https://i.scdn.co/image/57aff6e0adaa1951c4f0139951dd5e3d4e67f4c1",
    spotify: "4E0HD2PMY8kQJIjlShrLUS",
    genre: "house",
    popularity: "52",
  },
  {
    name: "Tirzah",
    image: "https://i.scdn.co/image/98dc65b0acd22cdd2805e9ae50ac2fb20c91ebf1",
    spotify: "6f5lOlSFJw9K79gaNnmWAd",
    genre:
      "alternative r&b,art pop,electra,electropop,escape room,experimental pop,indie r&b,indie soul,uk contemporary r&b",
    popularity: "52",
  },
  {
    name: "Orchestra Baobab",
    image: "https://i.scdn.co/image/22372954eec5c4593cc6f999c71a5d0a40241e55",
    spotify: "7xT0arvCDupDU1YYy0BNv9",
    genre: "afrobeat,afropop,chicha,mande pop,world",
    popularity: "52",
  },
  {
    name: "GoGo Penguin",
    image: "https://i.scdn.co/image/0cb37b06e2c861d16dcf8eb74ab7368ce569f834",
    spotify: "19f2JXwlRU26376TCKmp6L",
    genre:
      "british jazz,contemporary jazz,indie jazz,jazztronica,modern jazz trio,nu jazz,progressive jazz fusion",
    popularity: "52",
  },
  {
    name: "Rampa",
    image: "https://i.scdn.co/image/0a0533c9e47541d32c25cf8a8739a288cd8562b0",
    spotify: "08jywfUS0hp8XYlYs0cvz8",
    genre:
      "deep disco house,deep euro house,house,microhouse,minimal tech house,minimal techno,organic house,tech house",
    popularity: "52",
  },
  {
    name: "Super8 & Tab",
    image: "https://i.scdn.co/image/3bd1c4cc8d5be727c9de625df79a75b10331d685",
    spotify: "3WGxBKuYawiVOmCwR8FIUC",
    genre:
      "edm,finnish edm,progressive house,progressive trance,trance,uplifting trance",
    popularity: "52",
  },
  {
    name: "Tommy Guerrero",
    image: "https://i.scdn.co/image/370ec05a36d7260c1ef6e4e48c4ef408592acd47",
    spotify: "5qnkHpjyS6CUxH1UUy82B7",
    genre: "electronica,funk",
    popularity: "52",
  },
  {
    name: "Dennis Ferrer",
    image: "https://i.scdn.co/image/416fe6fc46bf5df3c2957e5791bbe9b6d0e524d1",
    spotify: "0MGTHZpAGf7isSfw8yMIoi",
    genre:
      "afro house,chicago house,deep house,disco house,house,tribal house,uk funky,vocal house",
    popularity: "52",
  },
  {
    name: "The Coronas",
    image: "https://i.scdn.co/image/4ae12528089ee60380fcf940defdb9941ec81fdd",
    spotify: "2tppd6KkhK4ULAd217Ecq1",
    genre: "indie anthem-folk,irish rock",
    popularity: "52",
  },
  {
    name: "BEXEY",
    image: "https://i.scdn.co/image/973a19eff02617b57398c5b1561c45d42f86b693",
    spotify: "3PXR1cXkJk5aOekoGOtWFA",
    genre: "dark trap,emo rap,underground hip hop",
    popularity: "52",
  },
  {
    name: "Tisoki",
    image: "https://i.scdn.co/image/b22db7326dc0e05fe3656eae1e28844e04185115",
    spotify: "0XW7mqhbaQnRtHmwfAVg64",
    genre: "brostep,electro house,electronic trap,zapstep",
    popularity: "52",
  },
  {
    name: "Black Uhuru",
    image: "https://i.scdn.co/image/aab73e04192115afb9df2c3ec505a1c744e7e64e",
    spotify: "5keeQyPKYRxUCKDMECTXG3",
    genre: "dub,modern reggae,reggae,roots reggae,ska",
    popularity: "52",
  },
  {
    name: "MocroManiac",
    image: "https://i.scdn.co/image/d23465877cc1ce75e5d9178f80ace76775bd1888",
    spotify: "1n34ZpZX4OCwbuyo9mnfU8",
    genre: "dutch hip hop",
    popularity: "52",
  },
  {
    name: "Modeselektor",
    image: "https://i.scdn.co/image/e6441d8878d98c6e09d65e553f8cce7ceb0ecb31",
    spotify: "2jYMYP2SVifgmzNRQJx3SJ",
    genre: "alternative dance,electronica,microhouse,minimal techno,new rave",
    popularity: "52",
  },
  {
    name: "APRIL",
    image: "https://i.scdn.co/image/ab67616d0000b2737ea0b86d92f677bf8e415603",
    spotify: "4cJ99wTjC60pXcfyISL9fa",
    genre: "k-pop,k-pop girl group",
    popularity: "52",
  },
  {
    name: "Kalibwoy",
    image: "https://i.scdn.co/image/77298da3c7953e97812b9cd6153190246420a961",
    spotify: "3xhksfxjNLUAyxUdijvk4x",
    genre: "dutch trap pop",
    popularity: "52",
  },
  {
    name: "Luz",
    image: "https://i.scdn.co/image/4b3a60aee15019eafc06f7bbf38d0e8329a512a9",
    spotify: "3cdI6SvJ24KsOcvYyBwH9c",
    genre: "irish pop",
    popularity: "52",
  },
  {
    name: "Bella Thorne",
    image: "https://i.scdn.co/image/bc703933ce74bc0e847557023d409aa0588cc571",
    spotify: "58AqJv0sDFPFnnBcLT8eeX",
    genre: "post-teen pop,social media pop",
    popularity: "52",
  },
  {
    name: "Dannic",
    image: "https://i.scdn.co/image/8ba461a3267b3b07650a4d3c56cd310cb69570e1",
    spotify: "1PFc84GHTYPL0G12JHh9Mc",
    genre:
      "big room,deep big room,dutch edm,edm,electro house,house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "51",
  },
  {
    name: "Enrico Sangiuliano",
    image: "https://i.scdn.co/image/72f54f2b4399b408e840311475a7dfdc8875b427",
    spotify: "1u7DsNFbakULvxnDGtMm90",
    genre: "dark techno,italian techno,minimal techno,tech house",
    popularity: "51",
  },
  {
    name: "Team Rush Hour",
    image: "https://i.scdn.co/image/e9eab5a36c16b6938aaf7b9709e8dd3bcf135327",
    spotify: "3GV34zJlfaSxsr8YZ1zEbP",
    genre: "basshall,dutch hip hop,dutch pop,dutch trap pop,moombahton",
    popularity: "51",
  },
  {
    name: "Angemi",
    image: "https://i.scdn.co/image/0da5d0bd2fd099ca9633e923746b2e898e804d90",
    spotify: "3q5DAsSH8efMqNxjxbdpGx",
    genre: "deep big room,sky room",
    popularity: "51",
  },
  {
    name: "Ostblockschlampen",
    image: "https://i.scdn.co/image/0dc75d6c37e6168fcfb3ae1e795837958046e27c",
    spotify: "5pT9S3KV5SqnzKHpSYf3ko",
    genre: "",
    popularity: "51",
  },
  {
    name: "Blastoyz",
    image: "https://i.scdn.co/image/86499cdb8d2366550cc4ce552b9117956b15d099",
    spotify: "6WLP1sraOcF3Gaxp7xBa4p",
    genre: "psychedelic trance",
    popularity: "51",
  },
  {
    name: "DJ DYLVN",
    image: "https://i.scdn.co/image/d58ec2b511c06309909b3b7f7f47cca398abffe7",
    spotify: "0UW6JJvOT28AEOnu9H9d5l",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "51",
  },
  {
    name: "Robert Falcon",
    image: "https://i.scdn.co/image/0e5002a4cd7bf1a55b5200d377f5b97760ff87ae",
    spotify: "5CVwY7MrkxGF1aM4f1u6Xk",
    genre: "deep big room,sky room",
    popularity: "51",
  },
  {
    name: "Ben Gold",
    image: "https://i.scdn.co/image/2c0eeb066dbfb27524e595d86c92cba0a69f8042",
    spotify: "4DXcK8M3bJkCFfhHIkudyL",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "51",
  },
  {
    name: "Sarita Lorena",
    image: "https://i.scdn.co/image/cae3212b448a07e043d7c673e5b70c205e4a050f",
    spotify: "5V9JsrZb5RjuvbzvJsA5gp",
    genre: "dutch pop,dutch trap pop",
    popularity: "51",
  },
  {
    name: "Joel Fletcher",
    image: "https://i.scdn.co/image/c9fb2eea4064f7ef0e25cdc11c51cc08c31555bb",
    spotify: "2Z4QqhmV5Xw5vX2ZI70HOR",
    genre:
      "deep minimal techno,melbourne bounce,melbourne bounce international",
    popularity: "51",
  },
  {
    name: "Plastik Funk",
    image: "https://i.scdn.co/image/0f6db20e79275180c3cce62575d76cd1f595ea4e",
    spotify: "7wmCy21VjfmbP8DznMJe8v",
    genre: "pop house",
    popularity: "51",
  },
  {
    name: "JLV",
    image: "https://i.scdn.co/image/0467a651dd76ac89d7096ed340e8b802aa132598",
    spotify: "5CBNhusqki2s2jp4Lo6i2L",
    genre: "deep groove house,edm,house,pop edm,uk dance",
    popularity: "51",
  },
  {
    name: "Erick Morillo",
    image: "https://i.scdn.co/image/509f87a86c9cf5a1d04e6f26dd8fba5959266731",
    spotify: "4DE0cYxMnEEmfKLwDkYwxb",
    genre: "disco house,tech house,tribal house",
    popularity: "51",
  },
  {
    name: "Alli Neumann",
    image: "https://i.scdn.co/image/d10a33c3ed541e0c18ea1a5b85275745554c33ea",
    spotify: "2fUZ5QodNiQntWefUy6Jfh",
    genre: "german indie,hamburg indie",
    popularity: "51",
  },
  {
    name: "Beatenberg",
    image: "https://i.scdn.co/image/7276c8b66aa1798c1581560f26dfb099b28740dc",
    spotify: "3S9sb8w9r1iojdrAL1soiU",
    genre: "cape town indie,south african alternative,south african pop",
    popularity: "51",
  },
  {
    name: "Dope D.O.D.",
    image: "https://i.scdn.co/image/ee8d7ea2239e467af13523ba7b3c10c025772cc3",
    spotify: "64UHlFDUkT8Hx3RCtDUieN",
    genre: "dutch hip hop",
    popularity: "51",
  },
  {
    name: "David Benjamin",
    image: "https://i.scdn.co/image/58fd79db8eae877bfe621a08059dd808ec913475",
    spotify: "5eTeHyszhixBkqm4L9xrjW",
    genre: "dutch pop,dutch singer-songwriter",
    popularity: "51",
  },
  {
    name: "WHIPPED CREAM",
    image: "https://i.scdn.co/image/1f1162e53add1faf1b19d11835daa9ed1dad2ce7",
    spotify: "5CMaNobmJYgXcfiT0zYOwi",
    genre: "canadian electronic,electra,electro house,electronic trap",
    popularity: "51",
  },
  {
    name: "PhaseOne",
    image: "https://i.scdn.co/image/9bce1b396cacef8630474ac9bc92d61b65d0ebfa",
    spotify: "0mO3Yf5XIPHfAbHh8yWLFk",
    genre: "brostep,deathstep,electro house,electronic trap,zapstep",
    popularity: "51",
  },
  {
    name: "Barely Alive",
    image: "https://i.scdn.co/image/6f21a7dbc5a08ae27fe8c22ac91b179405f513ec",
    spotify: "5c3akKV3CUqAVOnGZqf4S3",
    genre: "brostep,complextro,edm,electro house,electronic trap,zapstep",
    popularity: "51",
  },
  {
    name: "Detroit Swindle",
    image: "https://i.scdn.co/image/2782ccb65e8607b0e2d4c735482369a4d38ea4d3",
    spotify: "6hJtgCB3L5cnJSND7sp6GU",
    genre:
      "deep disco house,deep house,disco house,float house,house,indie soul,minimal tech house",
    popularity: "51",
  },
  {
    name: "Peter White",
    image: "https://i.scdn.co/image/6216a0d92061e3987f00655b310895a83bb9d2ec",
    spotify: "4siC0n7Bs9OzoZlB1HKquS",
    genre: "rumba,smooth jazz",
    popularity: "51",
  },
  {
    name: "Sophie Hunger",
    image: "https://i.scdn.co/image/b84eaed60caa930c6c9f9284ed6eb8f8f0112f8c",
    spotify: "3nOQJdlPEzFVhTEzxwcGax",
    genre: "swiss indie,swiss rock",
    popularity: "51",
  },
  {
    name: "Chuckie",
    image: "https://i.scdn.co/image/1cbc13e4131461d8631d527c955ba83dddde099d",
    spotify: "4x7gxsrTH3gThvSKZPPwaQ",
    genre:
      "big room,deep big room,dutch house,edm,electro house,melbourne bounce,progressive electro house",
    popularity: "51",
  },
  {
    name: "Joris Delacroix",
    image: "https://i.scdn.co/image/855c410337b89e709f687f63a35e47027766d605",
    spotify: "3HRRzIZNQFus3xlUx2xKy1",
    genre:
      "deep euro house,minimal techno,new french touch,tech house,tropical house",
    popularity: "51",
  },
  {
    name: "Ed Motta",
    image: "https://i.scdn.co/image/d134558197641f1e05f8b07d9af5972828393824",
    spotify: "19nFjml2GjS4LuL4NrDa7D",
    genre:
      "bossa nova,brazilian modern jazz,brazilian soul,mpb,rock nacional brasileiro,samba",
    popularity: "51",
  },
  {
    name: "Dirtyphonics",
    image: "https://i.scdn.co/image/26194ad25489fb670fb37227161f40a465967e6d",
    spotify: "4zymhxzJ0UJc74tMHGyoWs",
    genre:
      "brostep,catstep,drum and bass,edm,electro house,french dnb,jump up,zapstep",
    popularity: "51",
  },
  {
    name: "HIDDN",
    image: "https://i.scdn.co/image/6ec759ccb11dd6d7ea191be752641ebe2dab03b6",
    spotify: "0wqZ6mvk4DfOvtQUVniOCX",
    genre: "belgian edm",
    popularity: "51",
  },
  {
    name: "Technoboy",
    image: "https://i.scdn.co/image/72456685972a5bd1825125c7c4c2a060f4c7f080",
    spotify: "37jL2LnGjAkadOCszr8v7C",
    genre: "classic hardstyle,euphoric hardstyle,rawstyle",
    popularity: "51",
  },
  {
    name: "Spag Heddy",
    image: "https://i.scdn.co/image/bfdb5663773cbb93f2cd27866b576518993cb27b",
    spotify: "043Bey7ngSGRFpJftAlKpi",
    genre: "brostep,edm,electro house,filthstep,zapstep",
    popularity: "51",
  },
  {
    name: "Wind Rose",
    image: "https://i.scdn.co/image/b4fab2e88a7a32c6526735575838c911d291d1aa",
    spotify: "67ps5pbKVO7V9Fcb4lTIXz",
    genre:
      "folk metal,italian folk metal,italian power metal,middle earth,power metal,tolkien metal",
    popularity: "51",
  },
  {
    name: "Kompany",
    image: "https://i.scdn.co/image/d85583d33400d14f424ded4684c827832cba1d34",
    spotify: "7dtX3ykcuyVmts2HQnWgSP",
    genre: "brostep,electro house,electronic trap,zapstep",
    popularity: "51",
  },
  {
    name: "Pretty Pink",
    image: "https://i.scdn.co/image/a1ee4587e78b578f0809a37e4fd9d90d302cd604",
    spotify: "78GHS9zWXcj8tBke222g5N",
    genre: "german house",
    popularity: "51",
  },
  {
    name: "Stick To Your Guns",
    image: "https://i.scdn.co/image/f1e2ce283d5fd3ed77b011c2ea629fa4bb48a785",
    spotify: "2sqrupqcoipb7UzVKApEnJ",
    genre: "melodic hardcore,melodic metalcore,metalcore",
    popularity: "51",
  },
  {
    name: "Black Tiger Sex Machine",
    image: "https://i.scdn.co/image/31bc8702d04707ce6f9fc12cb0c92501d984fc3a",
    spotify: "0o9qzOHuHkGZ3xMFKpMFkC",
    genre:
      "brostep,canadian electronic,complextro,edm,electro house,electro trash,electronic trap,zapstep",
    popularity: "51",
  },
  {
    name: "Prince Fox",
    image: "https://i.scdn.co/image/1d78901dec2ffaa974f0ff47d4dbdd2474072697",
    spotify: "1nf5yEVCfMbqm1OCYpntBT",
    genre: "electropop,indie electropop,nyc pop,pop edm",
    popularity: "51",
  },
  {
    name: "Tuneboy",
    image: "https://i.scdn.co/image/cf1f2f9e3c07b3d8636a72b0b952a678aefd6aa1",
    spotify: "3mZnhzeAyjpFhO3cIepzBr",
    genre: "classic hardstyle",
    popularity: "51",
  },
  {
    name: "Super Flu",
    image: "https://i.scdn.co/image/5b6a5145e2af809f4243a1044bc0ea01d997ae84",
    spotify: "1iZiG82D4w7FLHvOUUj4zW",
    genre:
      "deep euro house,electronica,german house,microhouse,minimal tech house,minimal techno,organic house,tech house",
    popularity: "51",
  },
  {
    name: "MYRNE",
    image: "https://i.scdn.co/image/86cdc1f02440e33868fc32b39f380b8735247fe0",
    spotify: "41DKMtAnhVo7aDeluAHDJg",
    genre:
      "bass trap,catstep,edm,electro house,future bass,gaming edm,melodic dubstep,pop edm,singaporean electronic,singaporean pop,vapor twitch",
    popularity: "51",
  },
  {
    name: "Duskus",
    image: "https://i.scdn.co/image/04c8639f802a87503ce959375b804ed76c7b9dd5",
    spotify: "59MDSNIYoOY0WRYuodzJPD",
    genre: "electronic trap,future bass,vapor twitch",
    popularity: "51",
  },
  {
    name: "Bart Skils",
    image: "https://i.scdn.co/image/777dbb56beb44f1db125f5d965a933e6468c56f8",
    spotify: "6iWBjg4b4ll4jLiParnWXT",
    genre: "minimal techno,tech house",
    popularity: "51",
  },
  {
    name: "Glen Faria",
    image: "https://i.scdn.co/image/f0c066d10fc54e1a4cf93285c38c7db7c3f51e29",
    spotify: "0O0Hr8JCTPqXyPLdN6kzdC",
    genre: "dutch pop",
    popularity: "51",
  },
  {
    name: "Ezra Collective",
    image: "https://i.scdn.co/image/fd32a0bcc9c87a415d86af89d6f25c1e794c9377",
    spotify: "5BRAUN0yN8557PLRZIr02W",
    genre: "british jazz,indie jazz,indie soul,uk contemporary jazz",
    popularity: "51",
  },
  {
    name: "Novaa",
    image: "https://i.scdn.co/image/2572b7bfcb074e789475f9efd00eadf27270fdf7",
    spotify: "3PMqVecYp6tFBk7d7SDlPm",
    genre: "vapor soul",
    popularity: "51",
  },
  {
    name: "Mike Dunn",
    image: "https://i.scdn.co/image/ab67616d0000b2735b074d4b0824fafd9eb7bf18",
    spotify: "55UOywvWbUD9c6C3NSGdft",
    genre: "chicago house,deep house,disco house,hip house,vocal house",
    popularity: "51",
  },
  {
    name: "Sugar MMFK",
    image: "https://i.scdn.co/image/16c122ea1e139d55859c3cb961b8381feff21efa",
    spotify: "5TfpwNDNvEPPjWk65OrtmV",
    genre: "german cloud rap,german hip hop,german underground rap",
    popularity: "51",
  },
  {
    name: "Horace Andy",
    image: "https://i.scdn.co/image/94f0d0478c8216c77f37034cd8efa471baa245a4",
    spotify: "2ieAXAuLe6qQ3RJsqCxpoC",
    genre: "dub,reggae,rock steady,roots reggae,ska",
    popularity: "51",
  },
  {
    name: "Tinariwen",
    image: "https://i.scdn.co/image/19f389d68ec256139a330922b5674421b7d7b2ad",
    spotify: "2sf2owtFSCvz2MLfxmNdkb",
    genre:
      "afrobeat,afropop,desert blues,malian blues,mande pop,musique touareg,tuareg guitar,western saharan folk,world",
    popularity: "51",
  },
  {
    name: "The Blockparty",
    image: "https://i.scdn.co/image/4acfd823b25722d56391ff53f37b2d425364852d",
    spotify: "1zmmIiBBODh2QxbdUqYbdU",
    genre: "dutch trap pop",
    popularity: "51",
  },
  {
    name: "Sondaschule",
    image: "https://i.scdn.co/image/fdf95557f9e1437ffb8a7c31b7aecd8972f8ecda",
    spotify: "0HqXpSKyNcTg8a1xg6hDQk",
    genre: "antideutsche,german punk,german punk rock,german rock,german ska",
    popularity: "51",
  },
  {
    name: "Black Marble",
    image: "https://i.scdn.co/image/d462d12c1e635a7b2f53bc1e882916d406b56795",
    spotify: "6Nii4K84ZzBZS8X2MP8c9t",
    genre: "art pop,chillwave,dark post-punk,nu gaze",
    popularity: "51",
  },
  {
    name: "IAMX",
    image: "https://i.scdn.co/image/20081b4fe2cc1ed22f69cb1d96f6fee1c6d5aa4f",
    spotify: "223iUzG0kb5V166FJP9ovD",
    genre: "",
    popularity: "51",
  },
  {
    name: "Estikay",
    image: "https://i.scdn.co/image/4a8ec64db55a974818915377ca24a8483c4265f4",
    spotify: "4DMzvwya65eu1LsYZ3BLV6",
    genre:
      "deep german hip hop,german cloud rap,german hip hop,german underground rap,hamburg hip hop",
    popularity: "51",
  },
  {
    name: "Nick Lowe",
    image: "https://i.scdn.co/image/5933eb0060b546f3ed10f44daf80a8157329d301",
    spotify: "3BqaUtuQmqIHg7B5Bc7fP7",
    genre:
      "alternative country,art rock,country rock,folk,folk rock,lilith,mellow gold,power pop,pub rock,roots rock,singer-songwriter,traditional folk",
    popularity: "51",
  },
  {
    name: "John Christian",
    image: "https://i.scdn.co/image/27da9f762d0e92d87355b1de75386243f6003232",
    spotify: "4I4ZRmxuOEADKSea0rNq3h",
    genre: "deep big room",
    popularity: "51",
  },
  {
    name: "Caleb Calloway",
    image: "https://i.scdn.co/image/845ec63c795f332b2a18550e20058971b93f84b4",
    spotify: "11usEAQkFE6UJwsyAKkchi",
    genre: "",
    popularity: "51",
  },
  {
    name: "Global Deejays",
    image: "https://i.scdn.co/image/1001af156705716fc597cea74e62c2998433d472",
    spotify: "5M0Y6NBi3Wfwo2H1gtPl1L",
    genre: "pop house",
    popularity: "51",
  },
  {
    name: "Yes-R",
    image: "https://i.scdn.co/image/0203899c921e2f9106d2f4c3415601756e3938b7",
    spotify: "26W6sq5yZeIhzfO6d8g9NJ",
    genre: "dutch hip hop,dutch pop",
    popularity: "51",
  },
  {
    name: "HI-LO",
    image: "https://i.scdn.co/image/6082e1b17d8fdb4ce3a92698455291f8ac5b88c7",
    spotify: "0ETJQforv5OXgDgidQv9qd",
    genre: "edm,electro house,house,progressive house",
    popularity: "51",
  },
  {
    name: "John Mayall & The Bluesbreakers",
    image: "https://i.scdn.co/image/ab67616d0000b273c40ff56a16cebb8f30af1f66",
    spotify: "2ScuQMRWThcifBRIvNDFDC",
    genre:
      "blues,blues rock,british blues,british invasion,classic rock,country rock,electric blues,modern blues,psychedelic rock",
    popularity: "51",
  },
  {
    name: "Murs",
    image: "https://i.scdn.co/image/0abc21fefa22683c126d6cd03e9276e6dda5b877",
    spotify: "2dWF6m2ksP9GN75fufFp16",
    genre: "abstract hip hop,alternative hip hop,hip hop,underground rap",
    popularity: "51",
  },
  {
    name: "Lulleaux",
    image: "https://i.scdn.co/image/83a5734a6ad299a63ffb0a2a808769a300f087c0",
    spotify: "6bA8L82JXU9CQa2nyUnLDh",
    genre: "deep tropical house,pop edm,tropical house",
    popularity: "51",
  },
  {
    name: "Set Mo",
    image: "https://i.scdn.co/image/552f92a346aa23f4a9294b8e8bfd7696dd0e6c3a",
    spotify: "2rv8IrcIQiFKkdvQAgUTZj",
    genre: "aussietronica",
    popularity: "51",
  },
  {
    name: "Big Daddy Kane",
    image: "https://i.scdn.co/image/a00659b168ab52f7d60f257b39572f47e6ff9e8f",
    spotify: "6futYSDVulYR2PktBjTB5W",
    genre:
      "east coast hip hop,electro,gangster rap,hardcore hip hop,hip hop,old school hip hop,rap",
    popularity: "51",
  },
  {
    name: "Cassian",
    image: "https://i.scdn.co/image/27fe4233e4b459366853958896c44e433a546b65",
    spotify: "1ChtRJ3f4rbv4vtz87i6CD",
    genre: "nu disco",
    popularity: "51",
  },
  {
    name: "The Four Owls",
    image: "https://i.scdn.co/image/283960b143bf7d047882bf417e7bdfec4ccf7276",
    spotify: "0W2ZH8knJiOzH0ZwXnsgox",
    genre: "uk alternative hip hop,uk hip hop",
    popularity: "51",
  },
  {
    name: "Salvador Sobral",
    image: "https://i.scdn.co/image/eef1d173f092903c9ab3422f542a85dbcdcf60b1",
    spotify: "0GfYO21pue5u0sVEYk9HZO",
    genre: "portuguese pop",
    popularity: "51",
  },
  {
    name: "Odd Nordstoga",
    image: "https://i.scdn.co/image/2de589c23135f5bdc3c05c1925a2b755df110b86",
    spotify: "64zdCzD7lOFBTIpQBSH8Uv",
    genre: "classic norwegian pop,norwegian indie,norwegian pop,norwegian rock",
    popularity: "51",
  },
  {
    name: "Far Caspian",
    image: "https://i.scdn.co/image/739e5786bce80bc77f79a32458fda1f6cf5cb726",
    spotify: "0EzsHuJxUDcfqSqvoPhKG4",
    genre: "leeds indie",
    popularity: "51",
  },
  {
    name: "Ivan Gough",
    image: "https://i.scdn.co/image/ab67616d0000b27346685bdc62ae93c8f6ffcee8",
    spotify: "5aBWZE8TOaaA9O50ENS3EM",
    genre: "big room",
    popularity: "51",
  },
  {
    name: "Satori",
    image: "https://i.scdn.co/image/ee4f6854514f154133739d997702c2f2305ab9fa",
    spotify: "5nri3hyKmKBGAfvjBi0mK0",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "50",
  },
  {
    name: "Dyro",
    image: "https://i.scdn.co/image/3a66a8124fa42ab507ecd421c3359557301682bf",
    spotify: "03MVmfitJTVJIxYmObhQn9",
    genre:
      "big room,deep big room,dutch edm,dutch house,edm,electro house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "50",
  },
  {
    name: "Cesqeaux",
    image: "https://i.scdn.co/image/f81833aaed2891bca14f34f39e5547f04d1d3634",
    spotify: "1EAFXic0Cfiwpe7nSuTrGL",
    genre: "bass trap,brostep,electro house,electronic trap",
    popularity: "50",
  },
  {
    name: "Zanger Kafke",
    image: "https://i.scdn.co/image/9bcc9c9b25bcd0d8bff589b3247dac22ad826fbc",
    spotify: "0nC1zkioNJaPntz8XAeLx9",
    genre: "carnaval,nederlandse hardstyle",
    popularity: "50",
  },
  {
    name: "Joyhauser",
    image: "https://i.scdn.co/image/a8823a8ed3986a505fe2a14012ae0f394c99809c",
    spotify: "59a1Bp0JQfL2mGnpL0lW2Y",
    genre: "belgian techno,dark techno,minimal techno,raw techno,tech house",
    popularity: "50",
  },
  {
    name: "Ronald Goedemondt",
    image: "https://i.scdn.co/image/16532ed172d462a7f3f3bddd22c00e413e2a2734",
    spotify: "5nBRhKUrDHDuTW7MIbR2IB",
    genre: "dutch cabaret",
    popularity: "50",
  },
  {
    name: "Naaz",
    image: "https://i.scdn.co/image/a8e99edc90565aca3504d47d9711d4cb60f8f8c9",
    spotify: "736HGQRGr9rjG4VmmSpkz8",
    genre: "dutch pop",
    popularity: "50",
  },
  {
    name: "Bougenvilla",
    image: "https://i.scdn.co/image/300d7b39d9a89e8998a44bc1849ee21e98c575fa",
    spotify: "1I5pYXplsbqmHaVWlAEhla",
    genre:
      "big room,deep big room,edm,electro house,house,pop edm,progressive house",
    popularity: "50",
  },
  {
    name: "Altin Gün",
    image: "https://i.scdn.co/image/36a9951750758285834e644965f989275d1e1cf5",
    spotify: "37PL04N8kBWWW69jdrMMWT",
    genre: "dutch indie,turkish psych",
    popularity: "50",
  },
  {
    name: "CMC$",
    image: "https://i.scdn.co/image/430ca913249f877b7ac21288890238290609c957",
    spotify: "78DWNk8gFHU30TGITAgbM7",
    genre: "deep big room,pop edm,vapor twitch",
    popularity: "50",
  },
  {
    name: "Dominik Eulberg",
    image: "https://i.scdn.co/image/6999bbc6259c5951b5f57b569f626d8fdc0100ba",
    spotify: "44zcDDVZOY0ck7KECNUPK1",
    genre:
      "deep euro house,electronica,german techno,microhouse,minimal techno,tech house",
    popularity: "50",
  },
  {
    name: "Urbandawn",
    image: "https://i.scdn.co/image/dc36cd33d3c1123f52bbfeaa7fd7829117a8e150",
    spotify: "4Kjl91bg9I6TuhrEC0NQgX",
    genre: "liquid funk",
    popularity: "50",
  },
  {
    name: "Solarstone",
    image: "https://i.scdn.co/image/c5c4566de73173df618e83c57646645e77573d80",
    spotify: "1PfOXooPSLQhOTNZGrXM90",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "50",
  },
  {
    name: "Sephyx",
    image: "https://i.scdn.co/image/f3cbcea152e88817789b11042a8b778010322e2f",
    spotify: "7MXzeG7zoG8pKpqKCOqcZL",
    genre: "classic hardstyle,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "50",
  },
  {
    name: "Olly James",
    image: "https://i.scdn.co/image/cdfd8c74d388e40744dfb268451bc3ef1ea59c6b",
    spotify: "04Ze9i5w3NXno5DdMNpJZC",
    genre:
      "big room,deep big room,edm,electro house,progressive electro house,sky room",
    popularity: "50",
  },
  {
    name: "Oceanvs Orientalis",
    image: "https://i.scdn.co/image/3d39cf22b8df517cbd4486df6dc091d8b976bd05",
    spotify: "3gNEIgLeknpwkNViU8WAhg",
    genre: "ethnotronica,organic electronic,organic house,turkish electronic",
    popularity: "50",
  },
  {
    name: "Fred V",
    image: "https://i.scdn.co/image/3897635eb96480a01d7790e5edafe3246692fa0d",
    spotify: "0k3dnuEr9LghUE4jxS0PT4",
    genre: "drum and bass,liquid funk",
    popularity: "50",
  },
  {
    name: "X-TOF",
    image: "https://i.scdn.co/image/ab900dd47759910265bee2bbaa18c28197c6e625",
    spotify: "04XgEt5RkgdF4EM9lZyKCE",
    genre: "belgian edm",
    popularity: "50",
  },
  {
    name: "Grafix",
    image: "https://i.scdn.co/image/2ae3726c1e4022ddb124f07ac6677e4007a74423",
    spotify: "27YdXZOMLqvxI2pB5GyqyY",
    genre: "deep liquid,drum and bass,liquid funk",
    popularity: "50",
  },
  {
    name: "Fickle Friends",
    image: "https://i.scdn.co/image/cb7be2db3ef723cd2c5e299c0222982e1d201779",
    spotify: "1nhSLEYdoBHG6cJ8NDwoF1",
    genre:
      "gauze pop,hopebeat,indie electropop,indie pop,indie poptimism,indietronica,shimmer pop,uk pop,vapor soul",
    popularity: "50",
  },
  {
    name: "SXTEEN",
    image: "https://i.scdn.co/image/ceec9e9edefbc949543f19e7fad0720e088458ce",
    spotify: "3vioxUBsBBi7pmXx4KG5Vg",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "50",
  },
  {
    name: "Dana Winner",
    image: "https://i.scdn.co/image/4a599ebaba0d4d9eb415bfcf1b87e3a9809dfa0e",
    spotify: "6pmObcotPmooyBYA0PbxPW",
    genre: "classic belgian pop,nederpop",
    popularity: "50",
  },
  {
    name: "12th Planet",
    image: "https://i.scdn.co/image/1723e8bf906657f16bf7f68fedf9cb45b48a86af",
    spotify: "3V1h3kAdiVDBiwlY2i6dJz",
    genre: "brostep,edm,electro house,electronic trap,filthstep,zapstep",
    popularity: "50",
  },
  {
    name: "Yung Nnelg",
    image: "https://i.scdn.co/image/17b45db2aa3b61873aca5a3a114f21b8718142e7",
    spotify: "7bbzOJyYWRp0cef7NpIClP",
    genre: "dutch hip hop",
    popularity: "50",
  },
  {
    name: "ShockOne",
    image: "https://i.scdn.co/image/680463ad45e506efc39bd574c7bd87db56c8c352",
    spotify: "1yShtQaHjChbToQboKRzgH",
    genre:
      "australian dance,catstep,drum and bass,electro house,jump up,liquid funk",
    popularity: "50",
  },
  {
    name: "Tommy Theo",
    image: "https://i.scdn.co/image/4d1fe6aad23836cd3ce0fda2fff5b84d4da7735b",
    spotify: "3FIKR274tI6Xk3uw9Dqu5B",
    genre: "",
    popularity: "50",
  },
  {
    name: "Kikagaku Moyo",
    image: "https://i.scdn.co/image/1fd50a92bc58c8744dd15eaae64c0bb292a23639",
    spotify: "0hrb5WRiNlj8vh3WnCgXFq",
    genre:
      "instrumental stoner rock,japanese psychedelic,japanese psychedelic rock,neo-psychedelic",
    popularity: "50",
  },
  {
    name: "Jules Ahoi",
    image: "https://i.scdn.co/image/8a456adf05a0132030e04e853096b8197475076e",
    spotify: "2l1xTBTIBaAiJhekoLM8mk",
    genre: "german indie,german indie folk,swiss indie",
    popularity: "50",
  },
  {
    name: "KYTES",
    image: "https://i.scdn.co/image/d72d7336f46e00165b3e4e8e1406aeb4f9af244f",
    spotify: "1q8H46YhdCtAO8tXHIWe2d",
    genre: "german indie,german indie pop,german pop,german rock,munich indie",
    popularity: "50",
  },
  {
    name: "Jewelz & Sparks",
    image: "https://i.scdn.co/image/979dfbbb17a1ff0a7c1df6de5e40902c7f04ac47",
    spotify: "50kceDjknh0CjwOko7kx7V",
    genre:
      "big room,deep big room,edm,electro house,progressive electro house,sky room",
    popularity: "50",
  },
  {
    name: "Karate Andi",
    image: "https://i.scdn.co/image/d1cbc12d7e9f31f75c43414d227bb38f3bd09c16",
    spotify: "52JDGHEmHKktNs1lN7HCl8",
    genre:
      "deep german hip hop,german hip hop,german underground rap,indie deutschrap",
    popularity: "50",
  },
  {
    name: "New World Sound",
    image: "https://i.scdn.co/image/24f3b44a9bc89b2555a790fe6717c990afdef5e5",
    spotify: "4RQQEu24E1oQAQXvkxsLxE",
    genre: "big room,electro house,melbourne bounce international",
    popularity: "50",
  },
  {
    name: "Jo Nesbø",
    image: "https://i.scdn.co/image/ab67616d0000b27344b9ad157821b5d6d8dc0e58",
    spotify: "1KcYLo3wUtAqUsLfhZ5iA4",
    genre: "",
    popularity: "50",
  },
  {
    name: "Pieter de Graaf",
    image: "https://i.scdn.co/image/71f5b74113fe138fdf2cbe1c5158a6708a7c3867",
    spotify: "387mxb1p13O8OdJ6r8pc2q",
    genre: "neo-classical",
    popularity: "50",
  },
  {
    name: "Ian van Dahl",
    image: "https://i.scdn.co/image/79ce8c2faaf880d000c0a2453e95645178aa74c2",
    spotify: "27IuDZNaLuEtupD8QZftiZ",
    genre: "bubble trance,eurodance",
    popularity: "50",
  },
  {
    name: "Diquenza",
    image: "https://i.scdn.co/image/39562e5269af4c744b0024845992d451698a59c4",
    spotify: "3DIhZ8xOvMa1KpXPV6BZXV",
    genre: "",
    popularity: "50",
  },
  {
    name: "MC Bomber",
    image: "https://i.scdn.co/image/649ff6864395dd80bfc7feaff3e78b7d5c9dbd47",
    spotify: "4nAhut2dR1EdnpKHFq3EYD",
    genre:
      "german alternative rap,german hip hop,german underground rap,indie deutschrap",
    popularity: "50",
  },
  {
    name: "Glennis Grace",
    image: "https://i.scdn.co/image/011d7dfeed85e0d06d8c25e802d8a2d7b5e2983f",
    spotify: "3J85lWF7GZWWWLyBPMMX7h",
    genre: "dutch pop,dutch rock",
    popularity: "50",
  },
  {
    name: "Adrian Lux",
    image: "https://i.scdn.co/image/cdf2f082be4ae82e10a2a1db87ebe7b4eec1f463",
    spotify: "5kp9Qhzri9LrDkzrtjt5Sh",
    genre: "big room,edm,progressive electro house",
    popularity: "50",
  },
  {
    name: "Tanita Tikaram",
    image: "https://i.scdn.co/image/78867c85a637200ae4ec02b269974f1cdc3066d1",
    spotify: "2gTl60Ao3u7bljVnAqxPh8",
    genre: "new wave pop",
    popularity: "50",
  },
  {
    name: "Dusty Kid",
    image: "https://i.scdn.co/image/1aa7874a99d5c712ec9e22b145c8446963186060",
    spotify: "6JGLndnzrQrIFkd8NFha3C",
    genre: "minimal techno,tech house",
    popularity: "50",
  },
  {
    name: "Geike",
    image: "https://i.scdn.co/image/a3f280a0be573e37d1ba5cb2380be513e66ec731",
    spotify: "5mkzx9Hq5mYTx1LZ0CUGiP",
    genre: "belgian rock",
    popularity: "50",
  },
  {
    name: "Sofie Winterson",
    image: "https://i.scdn.co/image/c2bfe01c1d2d5e04fb2d940d2606e21619f7d865",
    spotify: "5pKrorYHoVt088MOxEhNLg",
    genre: "",
    popularity: "50",
  },
  {
    name: "Deine Freunde",
    image: "https://i.scdn.co/image/45b7af126bc251842cb4fac4a585692a14b2718b",
    spotify: "5e7w4jeuld5367jaczHkng",
    genre: "",
    popularity: "50",
  },
  {
    name: "Noah Guthrie",
    image: "https://i.scdn.co/image/baca902b5c29c06a9e9f51c4b95adb1a6c02cb3a",
    spotify: "6b0Wy4mw8ePj9w2EX3s4V3",
    genre: "",
    popularity: "50",
  },
  {
    name: "TR/ST",
    image: "https://i.scdn.co/image/a0e537e6d98652ca0dde6192ae75ade00297b8e6",
    spotify: "64NhyHqRKYhV0IZylrElWu",
    genre:
      "alternative dance,art pop,canadian electropop,electronica,electropop,new rave",
    popularity: "50",
  },
  {
    name: "Ahzumjot",
    image: "https://i.scdn.co/image/49bef26d89c3a565c57c34301335cbec9fec0f9b",
    spotify: "64Agvz8sfVYGFmX7yCwj32",
    genre:
      "german alternative rap,german cloud rap,german hip hop,indie deutschrap",
    popularity: "50",
  },
  {
    name: "Sophie Hutchings",
    image: "https://i.scdn.co/image/98fa8762e5e4b5a92b9eba7609ebcd6b21eda485",
    spotify: "54MsweggxTxlfYUbhZNIQ0",
    genre: "compositional ambient,focus,neo-classical",
    popularity: "50",
  },
  {
    name: "Tokyo Jetz",
    image: "https://i.scdn.co/image/dbbd967bebdd2a286679e19ebe18413a176e334c",
    spotify: "3KT0gxRAAb4WbAfOGMq4Lf",
    genre: "deep pop r&b,trap queen",
    popularity: "50",
  },
  {
    name: "Paul Cauthen",
    image: "https://i.scdn.co/image/73ff02e7b0943952f8c5903a3b3954707023e23d",
    spotify: "6yHM0XQEdu9sIlbILMaKBp",
    genre: "indie folk,new americana,roots americana",
    popularity: "50",
  },
  {
    name: "Claude VonStroke",
    image: "https://i.scdn.co/image/741d29d6aa3727f028107197662fc1b488acba75",
    spotify: "5CYAFhywQTXdZmppCp0ukd",
    genre:
      "bass house,deep disco house,electro house,house,microhouse,minimal techno",
    popularity: "50",
  },
  {
    name: "JETFIRE",
    image: "https://i.scdn.co/image/ac96f9c20a2eb524afc53a6b06416e27b0c0c2c3",
    spotify: "1flYnVP7znbiEcL0ELwwTt",
    genre:
      "belgian edm,big room,deep big room,electro house,progressive electro house,sky room",
    popularity: "50",
  },
  {
    name: "Adam Port",
    image: "https://i.scdn.co/image/dd44dda6d3b63fe3e61a2c94ecfb6fcea006aa0f",
    spotify: "2loEsOijJ6XiGzWYFXMIRk",
    genre: "deep disco house",
    popularity: "50",
  },
  {
    name: "Kamaal Williams",
    image: "https://i.scdn.co/image/a1239d30b324e694113606941d2aaa65a0766314",
    spotify: "01mXk9IDlVczWwZvVHAiIS",
    genre: "indie jazz,indie soul,uk contemporary jazz",
    popularity: "50",
  },
  {
    name: "Young Fathers",
    image: "https://i.scdn.co/image/c16bc25dd714a4f38f70deff1de0e7b01f461e5f",
    spotify: "5mZC7ndY6oGMxJentRwsuV",
    genre: "abstract hip hop,chamber psych,ninja,scottish hip hop",
    popularity: "50",
  },
  {
    name: "IDER",
    image: "https://i.scdn.co/image/568842cf5e90a6dfe8f1c0f6cd2cc0207761b342",
    spotify: "2LOwKJMjuv7VsprtYaFzl0",
    genre: "electropop,vapor soul",
    popularity: "50",
  },
  {
    name: "Bishop Nehru",
    image: "https://i.scdn.co/image/ecbe96dec3e8d35ed048fdcf41c6c5e898faef51",
    spotify: "1b5fazYV5ecKkQHKTlwLG8",
    genre: "alternative hip hop,underground hip hop",
    popularity: "50",
  },
  {
    name: "Kai Wachi",
    image: "https://i.scdn.co/image/99c38869de167483c1e5e908c441fbde15b1e17b",
    spotify: "2fNr4ldujwq97v1jWeqs8K",
    genre:
      "bass trap,brostep,deathstep,edm,electro house,electronic trap,zapstep",
    popularity: "50",
  },
  {
    name: "Tantric",
    image: "https://i.scdn.co/image/c3296d83792c5f524c19f62bb0f0f701dcaa4d4b",
    spotify: "4tMZahYVKJdjbC1GHVtNnV",
    genre: "alternative metal,nu metal,post-grunge,rap rock",
    popularity: "50",
  },
  {
    name: "Veldhuis & Kemper",
    image: "https://i.scdn.co/image/265ba726608d84cd27081532beb77cf7bd8aa53b",
    spotify: "7GGgxLSNIydPOKgmijBy5U",
    genre: "dutch cabaret,dutch pop,dutch rock",
    popularity: "49",
  },
  {
    name: "Johnny 500",
    image: "https://i.scdn.co/image/cfa649f5d2fe05482888a42a1373952d29041b62",
    spotify: "53phw2rwTqJEtpZ1LgsPgj",
    genre: "basshall,dutch hip hop,dutch pop,dutch trap pop",
    popularity: "49",
  },
  {
    name: "Lady Bee",
    image: "https://i.scdn.co/image/73b2ae4d8962eb56fcb1bd45e567a2dda37a345f",
    spotify: "5WuoHUDzojO8oto22ahnwN",
    genre: "bass trap,moombahton",
    popularity: "49",
  },
  {
    name: "Freddy Moreira",
    image: "https://i.scdn.co/image/f79335410749193019a140da7dd76437a8f7ecae",
    spotify: "2CU1lH3DaaajH9Cm2S2tPk",
    genre: "basshall,dutch pop,dutch trap pop",
    popularity: "49",
  },
  {
    name: "Tony Junior",
    image: "https://i.scdn.co/image/d45314e0f61099d8f335c08f62f9cd40a79b5478",
    spotify: "17esEoE9uEHFKuzkar2UL0",
    genre:
      "big room,deep big room,dutch house,edm,electro house,progressive electro house,sky room",
    popularity: "49",
  },
  {
    name: "Honey Dijon",
    image: "https://i.scdn.co/image/3f7674d51be6834179fba417af8c3e70e7cc64db",
    spotify: "0XfQBWgzisaS9ltDV9bXAS",
    genre: "",
    popularity: "49",
  },
  {
    name: "Breaking Beattz",
    image: "https://i.scdn.co/image/5eebd3b671c2f347f96094dfd7e94abe6e86b63c",
    spotify: "0eRxVzLBxZGMZcsSoMESfX",
    genre: "brazilian edm",
    popularity: "49",
  },
  {
    name: "Thomas Newson",
    image: "https://i.scdn.co/image/b713b8148e377d2d36cf956f1b72124ee1748483",
    spotify: "66MrdPDHTjnnMOTBmC81q5",
    genre:
      "big room,deep big room,edm,electro house,progressive electro house,sky room",
    popularity: "49",
  },
  {
    name: "Visage",
    image: "https://i.scdn.co/image/dcd325dfde342ad2fb931e49c29c3e7541d075d3",
    spotify: "0EPf9vAXPdFV5Ezp1sMX8B",
    genre:
      "dance rock,early synthpop,new romantic,new wave,new wave pop,synthpop",
    popularity: "49",
  },
  {
    name: "Unglued",
    image: "https://i.scdn.co/image/dbff8f58f9930d8fef154072501b332bc74537b2",
    spotify: "3AXcevvp1Kd1KEyHiUEsrC",
    genre: "uk dnb",
    popularity: "49",
  },
  {
    name: "Sophie Francis",
    image: "https://i.scdn.co/image/704e86e723e8f43fcd9978d83d15e3390b816408",
    spotify: "0NQJm4Wlz3rrDJGlQ28L81",
    genre: "deep big room,electro house,pop edm",
    popularity: "49",
  },
  {
    name: "Tom Swoon",
    image: "https://i.scdn.co/image/e080f2e24b5e6ed18cfe53a5d8014190f7a838fd",
    spotify: "2OFEXARoSZyZLR6S0oV2R7",
    genre:
      "big room,deep big room,edm,electro house,pop edm,progressive electro house,progressive house,sky room",
    popularity: "49",
  },
  {
    name: "BCee",
    image: "https://i.scdn.co/image/69dd4323b00283508cfba0692d066b09317bd567",
    spotify: "3wdwWQXJbqpJJbMdp7KfEJ",
    genre: "drum and bass,liquid funk",
    popularity: "49",
  },
  {
    name: "Ace Ventura",
    image: "https://i.scdn.co/image/cb2cadb6cf2d2782d413aab838e723ceac09d265",
    spotify: "7bSyjB4y9NAhoUDrZTpYt4",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "49",
  },
  {
    name: "Hania Rani",
    image: "https://i.scdn.co/image/7939f7e3a6d06168eaeedada387fd919ced0acb6",
    spotify: "14YzutUdMwS9yTnI0IFBaD",
    genre: "neo-classical,polish alternative",
    popularity: "49",
  },
  {
    name: "Spencer Brown",
    image: "https://i.scdn.co/image/9092c84c86bc29efbac8df3d00a8dfb812aa2ff9",
    spotify: "4L9PX6lwPWo2NeuXL9kyJK",
    genre: "edm,progressive house,progressive trance",
    popularity: "49",
  },
  {
    name: "Julian Calor",
    image: "https://i.scdn.co/image/71394227518474ed93ad8ecfec82abd8be37e778",
    spotify: "2y8eOaQNjiIuITkz6zGfgL",
    genre:
      "big room,catstep,deep big room,edm,electro house,progressive electro house,sky room",
    popularity: "49",
  },
  {
    name: "Felix Da Housecat",
    image: "https://i.scdn.co/image/67db6e41705dc3de8662ce4c4ebf635eb88b863e",
    spotify: "4rC8J4M4aOqsQSCP4yoyJI",
    genre:
      "acid house,alternative dance,chicago house,electroclash,electronica,new rave",
    popularity: "49",
  },
  {
    name: "Ahzee",
    image: "https://i.scdn.co/image/9dd0d6f0b2b4dc06c194d67c8c73eb38025756d5",
    spotify: "4J1SxSh3FGBAMAkuiY5sye",
    genre: "",
    popularity: "49",
  },
  {
    name: "Mitch Crown",
    image: "https://i.scdn.co/image/ab67616d0000b2734e5597dfcd1239836c06f71a",
    spotify: "4m5bANP6wwn3O6xmjYxhTm",
    genre: "",
    popularity: "49",
  },
  {
    name: "De-Phazz",
    image: "https://i.scdn.co/image/d3ec4cc9faf3838fd93d78cc0d8e7322378588a1",
    spotify: "0WLS16S6MJvMgWXrUezleN",
    genre:
      "downtempo,electro jazz,electro swing,electronica,jazztronica,nu jazz,trip hop",
    popularity: "49",
  },
  {
    name: "Richard Durand",
    image: "https://i.scdn.co/image/7a30804a524ac6338fc98f1858dace4909f78889",
    spotify: "7wne8sUhTAJdIsnuO4GjnR",
    genre:
      "dutch trance,progressive house,progressive trance,trance,uplifting trance",
    popularity: "49",
  },
  {
    name: "Herobust",
    image: "https://i.scdn.co/image/35134a14af27b485ef3809dffaaa2173569f2fce",
    spotify: "43tAs3kRWvyu1B7eZOv2pp",
    genre: "bass trap,brostep,electro house,electronic trap,zapstep",
    popularity: "49",
  },
  {
    name: "Luca Lush",
    image: "https://i.scdn.co/image/13f200f78a6933652dd77b40968a1f968b42350c",
    spotify: "5oAjLXTvB7VDWn3Up9LYcQ",
    genre: "vapor twitch",
    popularity: "49",
  },
  {
    name: "Norman Doray",
    image: "https://i.scdn.co/image/6995a6fd7a536ac1e58ac535de2fe644a53f76cd",
    spotify: "1UmLUPNgy8HS6oI05zdGjD",
    genre: "progressive electro house",
    popularity: "49",
  },
  {
    name: "Wh0",
    image: "https://i.scdn.co/image/1707a91a0a01ea29718b626c76bcc8105769ef4d",
    spotify: "132Hhe61bhvXtkygENHZHA",
    genre: "uk dance",
    popularity: "49",
  },
  {
    name: "Genix",
    image: "https://i.scdn.co/image/1ae33f2e049bc78ef2cd15d50e1c5ad0048d25a1",
    spotify: "5WWUkLXiAbmGwtELcfvB2w",
    genre: "edm,progressive house,progressive trance,trance,uplifting trance",
    popularity: "49",
  },
  {
    name: "Ben Lee",
    image: "https://i.scdn.co/image/a4f0a40128b2fb79eaae5817be242cc3f5067c9e",
    spotify: "06y1hH4hu3rcTUXHJevPCf",
    genre:
      "australian alternative rock,australian pop,australian rock,pop rock",
    popularity: "49",
  },
  {
    name: "Keizer",
    image: "https://i.scdn.co/image/43295c5c854e96794cbe5d2d35f54c5c2b59a8dd",
    spotify: "2CiOpBO55td0YHJVZYT2KW",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "49",
  },
  {
    name: "Dimmi",
    image: "https://i.scdn.co/image/7f46b8b35aeb04dbffa84d388537c7e68bf6f296",
    spotify: "7HIN94LvSDgxN5RoOLi3E5",
    genre: "deep tropical house,tropical house",
    popularity: "49",
  },
  {
    name: "Robbie Rivera",
    image: "https://i.scdn.co/image/f81da37adadd94232ef4e9ffba61148a80aa138e",
    spotify: "4bYwbb6k4ujHD2NXRxSwRP",
    genre:
      "big room,circuit,disco house,edm,electro house,funky tech house,house,progressive electro house,progressive house,tech house,tribal house,vocal house",
    popularity: "49",
  },
  {
    name: "D.O.D",
    image: "https://i.scdn.co/image/9bf7134dfcf9b436afd39c9acad3be258449e792",
    spotify: "0Cs47vvRsPgEfliBU9KDiB",
    genre: "big room,deep big room,edm,electro house,progressive electro house",
    popularity: "49",
  },
  {
    name: "Jarami",
    image: "https://i.scdn.co/image/5933261878c287dc76b6cd70ae054bd6c666f887",
    spotify: "1iwseab2dozTUHoF5taAdf",
    genre: "scandipop",
    popularity: "49",
  },
  {
    name: "Sickmode",
    image: "https://i.scdn.co/image/d9fafdb6430db28417b1ff69bc1b61df26bb7af8",
    spotify: "5PbgCU02dfdBCAzpOaNmYW",
    genre: "rawstyle,uptempo hardcore",
    popularity: "49",
  },
  {
    name: "OVERWERK",
    image: "https://i.scdn.co/image/f5a0a6280b629cd686ad672fc719bfaeac830e01",
    spotify: "2f9PTWJfMMDTAFZcvHy1Z5",
    genre: "canadian electronic,catstep,complextro,edm,electro house",
    popularity: "49",
  },
  {
    name: "Marcus Santoro",
    image: "https://i.scdn.co/image/24755ccca84726f22f97c57f3680d8fa60efd3de",
    spotify: "0cIOMm0D5wSyXMTcvnElUz",
    genre: "progressive trance",
    popularity: "49",
  },
  {
    name: "Defano Holwijn",
    image: "https://i.scdn.co/image/9c55bc901c937484dfbc0838c091cd928ef9c03b",
    spotify: "5pGeI9pmfUEoHGn9w3NjqM",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "49",
  },
  {
    name: "Nienke Plas",
    image: "https://i.scdn.co/image/8e29ed8bda72d50595d4ed698a42fd65eb6dfe38",
    spotify: "5rAvD7H6mxJut208JT5KI4",
    genre: "dutch pop",
    popularity: "49",
  },
  {
    name: "OK KID",
    image: "https://i.scdn.co/image/de2b4d96ab6a8d698c45d572473ae23d2f63f7eb",
    spotify: "5syyAQTWJ2BaLtjOKE99MK",
    genre:
      "cologne indie,german alternative rap,german indie,german pop,german rock",
    popularity: "49",
  },
  {
    name: "Horrorshow",
    image: "https://i.scdn.co/image/3c2ed3dcd95b755270d5c3d08453272d201f8330",
    spotify: "4sL6dLwItg7ppqj4NwEQr6",
    genre: "australian hip hop,australian trap,australian underground hip hop",
    popularity: "49",
  },
  {
    name: "Being As An Ocean",
    image: "https://i.scdn.co/image/b398cdec5df3c36949ed789c8137ee81fd7562d3",
    spotify: "7ML9AQvVVE3c5m0sx1PlmP",
    genre: "melodic hardcore,melodic metalcore,metalcore",
    popularity: "49",
  },
  {
    name: "3JS",
    image: "https://i.scdn.co/image/5170dbc709ff4bb27e6438aa676dee1cecea2d3f",
    spotify: "2ZulgXPozVBLNaJPXR8MnV",
    genre: "dutch pop,dutch rock,levenslied",
    popularity: "49",
  },
  {
    name: "1788-L",
    image: "https://i.scdn.co/image/bc3b299e48a9e8d05b45f2955e91cca236df1a1c",
    spotify: "7oB4pCSzvvRtZka6DxXUfN",
    genre: "brostep,edm,electro house,zapstep",
    popularity: "49",
  },
  {
    name: "Open Mike Eagle",
    image: "https://i.scdn.co/image/471156a8347e5874a7e9c2b728f41a66f83f9d39",
    spotify: "5CuU6SRJjbbZL926nSGGxX",
    genre: "abstract hip hop,alternative hip hop,escape room",
    popularity: "49",
  },
  {
    name: "Black Lips",
    image: "https://i.scdn.co/image/0cdb37cb22237741c49c0bc7cb1e1112a25e9cd8",
    spotify: "35C0NSLogAwImm8HAMqEmG",
    genre:
      "atlanta indie,freak folk,garage pop,garage rock,indie garage rock,indie rock,neo-psychedelic,punk blues",
    popularity: "49",
  },
  {
    name: "Bear Grillz",
    image: "https://i.scdn.co/image/40be5d0ec43b881bd4fa55bcc943e75bffe2e329",
    spotify: "04vdWVjgi45nrMAxeCEVQe",
    genre: "brostep,edm,electro house,electronic trap,zapstep",
    popularity: "49",
  },
  {
    name: "Clubbers",
    image: "https://i.scdn.co/image/a0af4fab2ebe43d37bd56b9ccb5865ebfbec613b",
    spotify: "0mKfkzDXQzYEa1qXH6AAWf",
    genre: "brazilian edm",
    popularity: "49",
  },
  {
    name: "Futurebirds",
    image: "https://i.scdn.co/image/4700364cb4110f1c9aad93327cefeb3adcb35ec8",
    spotify: "4Ait1vX2ZaWPrkua8Z664O",
    genre:
      "alternative country,athens indie,deep new americana,indie folk,new americana,roots rock,stomp and holler",
    popularity: "49",
  },
  {
    name: "josh pan",
    image: "https://i.scdn.co/image/29c9c1cd4c76f31503b3d938f91d2945c79926e4",
    spotify: "2sfSQ1BOzaFQa3LZj6OGwD",
    genre: "electronic trap,vapor twitch",
    popularity: "49",
  },
  {
    name: "Death In Vegas",
    image: "https://i.scdn.co/image/46839d01138aba0c5c27f67f6dccfbe03d052907",
    spotify: "5aj3LEYRbuaabjjHkj5oE1",
    genre: "alternative dance,big beat,electronica,new rave,techno,trip hop",
    popularity: "49",
  },
  {
    name: "Ten Walls",
    image: "https://i.scdn.co/image/63fa3e154f4008d97c0811b0a0e5ef3938b47fb8",
    spotify: "4veIvBHKoUacjuoMOm3vsg",
    genre: "lithuanian electronic",
    popularity: "49",
  },
  {
    name: "Rings of Saturn",
    image: "https://i.scdn.co/image/58817df9b4119007684bfab3d5fd7b5865d18550",
    spotify: "67Zm35qXdPzYfl1c3M0toJ",
    genre: "deathcore,djent,melodic metalcore,technical deathcore",
    popularity: "49",
  },
  {
    name: "Dan Deacon",
    image: "https://i.scdn.co/image/ed52f5cca567bf7499cf8b14d6779de3d35cfa33",
    spotify: "5Z3IWpvwOvoaWodujHw7xh",
    genre:
      "art pop,baltimore indie,chamber pop,chillwave,dance-punk,experimental pop,freak folk,indie rock,indietronica",
    popularity: "49",
  },
  {
    name: "A*S*Y*S",
    image: "https://i.scdn.co/image/954c720ea6f877af57c2cd882b2f179ad55268a7",
    spotify: "4xfA60YoR4UbBxuOn9WXJq",
    genre: "dark techno,raw techno",
    popularity: "49",
  },
  {
    name: "Joy Denalane",
    image: "https://i.scdn.co/image/fd754cfc5e9c97efeb8f46fa9776cacb1f2d5cd3",
    spotify: "5vP3nmsaGrondXXS5BvrSH",
    genre: "neo soul",
    popularity: "49",
  },
  {
    name: "Tony Romera",
    image: "https://i.scdn.co/image/58c92ff3a22ec41a61030726a6b29c5df936556d",
    spotify: "7GQsOji7pfixzkLt63awo5",
    genre: "bass house,catstep,electro house",
    popularity: "49",
  },
  {
    name: "Jai Waetford",
    image: "https://i.scdn.co/image/5852b5c4566ad90781196ff96bb09fc68a5fbf4d",
    spotify: "65eKzckWWGA123QUyi2Qo3",
    genre: "australian pop,australian talent show,social media pop,teen pop",
    popularity: "49",
  },
  {
    name: "Sleaford Mods",
    image: "https://i.scdn.co/image/8d5080495af5d4d29225209c1b6b8b92c0fa5e85",
    spotify: "0otAqZw8htTsGHfqR491Yh",
    genre: "chamber psych,nottingham indie",
    popularity: "49",
  },
  {
    name: "Musical Youth",
    image: "https://i.scdn.co/image/fca0c7f6230d9a303a484223c32246aa4e480b72",
    spotify: "2CuzDPkRD6BJBvdWqCrt2I",
    genre: "uk reggae",
    popularity: "49",
  },
  {
    name: "Teenage Bottlerocket",
    image: "https://i.scdn.co/image/ab6772690000c46c4fc5cb789608728d6e4fd593",
    spotify: "0mGyXXKzoR5KAAh4Mkef2W",
    genre:
      "melodic hardcore,orgcore,power-pop punk,punk,skate punk,wyoming indie",
    popularity: "49",
  },
  {
    name: "B-Brave",
    image: "https://i.scdn.co/image/b1c5cf75bb59385cdefe6e0fd57bd83fa814a198",
    spotify: "6m9HyOTTtMQ8fFrLeJyuNV",
    genre: "dutch pop",
    popularity: "49",
  },
  {
    name: "Alex Cameron",
    image: "https://i.scdn.co/image/c42d9148120c0ff14e26722c078314beea9bfe82",
    spotify: "6kGMx9MqwnbKR2EYvZvvrG",
    genre: "australian alternative rock",
    popularity: "49",
  },
  {
    name: "Virus Syndicate",
    image: "https://i.scdn.co/image/e72b9d6edfd33a03adf8877a7ce93ed74cdfdba1",
    spotify: "0NV5eY4Jzg4ldg2ikGnV4n",
    genre: "brostep,grime,zapstep",
    popularity: "49",
  },
  {
    name: "Rochelle",
    image: "https://i.scdn.co/image/5bfdbd4f498f7e714bbb323b41cb5d195f593948",
    spotify: "55RKbZHb1yAXuvEHTIyaxJ",
    genre: "dutch r&b",
    popularity: "49",
  },
  {
    name: "Plusmacher",
    image: "https://i.scdn.co/image/1e0e45d5aae89e2db35bd63699b198edd577877a",
    spotify: "1tkiSPJsPAkFYVLBEgDABY",
    genre:
      "deep german hip hop,german cloud rap,german hip hop,german underground rap,indie deutschrap",
    popularity: "49",
  },
  {
    name: "Junip",
    image: "https://i.scdn.co/image/1ab6f94d26cc9e1a0512e76588479667b45ad2d8",
    spotify: "7HcipAIJatVGT4U6HQrnFW",
    genre: "stomp and holler,swedish indie rock",
    popularity: "49",
  },
  {
    name: "Eva Shaw",
    image: "https://i.scdn.co/image/1751c2084f2981c8eb8a54bde1f0590998715cae",
    spotify: "638CPU1xRHUo6AmfZe3F2c",
    genre: "deep big room",
    popularity: "49",
  },
  {
    name: "Thornhill",
    image: "https://i.scdn.co/image/36e2affd2146c5f7adc84fa604ca154de5463260",
    spotify: "2dE5audbkV3o5cKxvM7lBD",
    genre: "australian metalcore,australian post-hardcore,metalcore",
    popularity: "49",
  },
  {
    name: "Pongo",
    image: "https://i.scdn.co/image/0932fe2b0d286454b1aa471ad3ee21867b84c6b8",
    spotify: "17MjqHVqjHRfIKAKen6o34",
    genre: "african electronic",
    popularity: "49",
  },
  {
    name: "Hot Water Music",
    image: "https://i.scdn.co/image/83e66598b1b8a064d28bdc85afbed4f574496361",
    spotify: "4dmaYARGTCpChLhHBdr3ff",
    genre: "emo,emo punk,folk punk,melodic hardcore,orgcore,punk,skate punk",
    popularity: "49",
  },
  {
    name: "Gigi Masin",
    image: "https://i.scdn.co/image/c55f21c495a005e294b7de52eee9c51484bf64b7",
    spotify: "0dCVhSVXD9JhJh2bTySJZx",
    genre: "ambient,art pop,float house,fourth world,microhouse",
    popularity: "49",
  },
  {
    name: "Raised Fist",
    image: "https://i.scdn.co/image/520906128d6325afbcc16a7560d60720dd88dbb0",
    spotify: "7ik758oYwkKmQtbZtAdOOm",
    genre: "skate punk,swedish alternative rock,swedish hardcore",
    popularity: "49",
  },
  {
    name: "Cattle Decapitation",
    image: "https://i.scdn.co/image/2e7deb86e329e05363329af156a3621b92be6cba",
    spotify: "67ZMMtA88DDO0gTuRrzGjn",
    genre:
      "brutal death metal,death metal,deathgrind,goregrind,grindcore,technical death metal,technical grindcore",
    popularity: "49",
  },
  {
    name: "Watermät",
    image: "https://i.scdn.co/image/eb41500b761737cfae4fb395135e9e6cc6d7b1f0",
    spotify: "4a9sClW4YpYQE5jUMAWx5W",
    genre: "progressive house,tropical house",
    popularity: "49",
  },
  {
    name: "Boy George",
    image: "https://i.scdn.co/image/6aaa9c3f2fd19247aaf26a02b56bf984fa3c7220",
    spotify: "2BWfZGPtsjRlRp7JTDqI45",
    genre: "dance rock,new romantic,new wave,new wave pop",
    popularity: "49",
  },
  {
    name: "John Dahlbäck",
    image: "https://i.scdn.co/image/c429088b416bbc0058954e0a1b2c3cc4f6121dc7",
    spotify: "15xvsJMf8phaNa1LYvL9Qv",
    genre:
      "big room,deep big room,edm,electro house,house,pop edm,progressive electro house,progressive house,swedish house,tech house",
    popularity: "49",
  },
  {
    name: "Fytch",
    image: "https://i.scdn.co/image/3530a15151e5f65a0ffe81fb38971f507bb22d5b",
    spotify: "4A18NGfdKU0HrkmvVlPO7I",
    genre: "bass trap,filthstep,traprun",
    popularity: "49",
  },
  {
    name: "I am Aisha",
    image: "https://i.scdn.co/image/f47aec7e063b913599b5a38f300d72ae3cb2a20e",
    spotify: "1fTPAgBH6gCQZU9bBWVaOf",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "49",
  },
  {
    name: "FEATHERED SUN",
    image: "https://i.scdn.co/image/ab67616d0000b2738a638c37ee946aa6fc8a7c18",
    spotify: "7bfe7ceWNJ3OjzmnzcMpdu",
    genre: "organic electronic,organic house",
    popularity: "49",
  },
  {
    name: "Luke Bond",
    image: "https://i.scdn.co/image/3aff7d588269c53848c6ea4cb5605ffd66560474",
    spotify: "13jm4r5O79Vxjy3zzZ51j0",
    genre:
      "deep uplifting trance,progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "49",
  },
  {
    name: "The View",
    image: "https://i.scdn.co/image/1cf6048133cc2eab5d3b62103e308f800f9f480b",
    spotify: "1fy3AQc7grjf5LnCd7snSg",
    genre:
      "british indie rock,britpop,celtic rock,dundee indie,modern rock,scottish indie rock,scottish rock",
    popularity: "49",
  },
  {
    name: "Alcest",
    image: "https://i.scdn.co/image/4c106ec022e645089b4bbf5942312964a3f21171",
    spotify: "0d5ZwMtCer8dQdOPAgWhe7",
    genre:
      "atmospheric black metal,blackgaze,french black metal,french metal,french shoegaze,post-black metal,post-metal,shoegaze",
    popularity: "49",
  },
  {
    name: "Masked Wolf",
    image: "https://i.scdn.co/image/554010b8b8c01ee9544cf342311fe6afc7d43ac9",
    spotify: "1uU7g3DNSbsu0QjSEqZtEd",
    genre: "australian hip hop",
    popularity: "49",
  },
  {
    name: "Marek Hemmann",
    image: "https://i.scdn.co/image/46cf625aa23a1b86b4d85706f7794fae3492f218",
    spotify: "7tL5UmgvPx6TqKyf0Sjjw6",
    genre:
      "deep euro house,german tech house,german techno,minimal tech house,minimal techno,tech house",
    popularity: "49",
  },
  {
    name: "Focus",
    image: "https://i.scdn.co/image/375c4ab6e3f64b8269993b6cbcec8f8b644d654c",
    spotify: "0ifzzRKdmtgaHy9cfnnyCR",
    genre:
      "album rock,art rock,canterbury scene,dutch prog,hard rock,jazz fusion,nederpop,progressive rock,symphonic rock",
    popularity: "49",
  },
  {
    name: "Franky Rizardo",
    image: "https://i.scdn.co/image/eae0ed6e0ace7844f265c9b09c136cb5f930a1eb",
    spotify: "2UgphhGSlC9QWgaZWUOCkl",
    genre:
      "circuit,deep groove house,deep house,disco house,dutch house,dutch tech house,funky tech house,house,tech house",
    popularity: "48",
  },
  {
    name: "Dirtcaps",
    image: "https://i.scdn.co/image/6a2ecc3f1b9e4406ed3986ef3cdee2700abe6f0b",
    spotify: "2PC3QVYzOPekKLIppjFUoi",
    genre: "dutch house,electronic trap",
    popularity: "48",
  },
  {
    name: "Jochem Myjer",
    image: "https://i.scdn.co/image/9cd52a19820b794d4295ee6e0bb44f3c4dc6dbf7",
    spotify: "2OrGVDwIP5mxA6vKDEAlj9",
    genre: "dutch cabaret,dutch pop,dutch rock",
    popularity: "48",
  },
  {
    name: "Rocksted",
    image: "https://i.scdn.co/image/fb1fb68b0cf2b929968d564f2fde85a4ac169a9a",
    spotify: "1XrH962P4m9qarMwaveb6H",
    genre: "brazilian edm",
    popularity: "48",
  },
  {
    name: "Keeno",
    image: "https://i.scdn.co/image/253420755f6aab8527d080d26f1f3176b46e3b36",
    spotify: "6r54QO0889i9vqaeuruUSn",
    genre: "chillstep,drum and bass,liquid funk,vocaloid",
    popularity: "48",
  },
  {
    name: "Spinvis",
    image: "https://i.scdn.co/image/e5a86bf770739c6cfc37b3606aa5063cfcccdf1d",
    spotify: "1Vxc40v4VtLpSWTF2bn8Y4",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "48",
  },
  {
    name: "N-Vitral",
    image: "https://i.scdn.co/image/74cb52660e98ce83237741fa02b3ed1572803eff",
    spotify: "5yirHkilaq4YSjO9BY6oy3",
    genre:
      "doomcore,gabba,happy hardcore,hardcore techno,industrial hardcore,rawstyle,uptempo hardcore",
    popularity: "48",
  },
  {
    name: "Basto",
    image: "https://i.scdn.co/image/2e6c61164ac2c71caa78c56df0c4c5b5c6ebe14a",
    spotify: "2BJTwV4IpFe2gWL46KKlji",
    genre: "belgian edm,big room,edm,electro house,progressive electro house",
    popularity: "48",
  },
  {
    name: "Ben Nicky",
    image: "https://i.scdn.co/image/3bf28b315baf3ae20308ce20baed1f5325cba7a4",
    spotify: "3Bd1phrOZJuCev9U0bzdtA",
    genre: "",
    popularity: "48",
  },
  {
    name: "Riva Starr",
    image: "https://i.scdn.co/image/f8a51003376f4b1a976f79d374d6909615fd8380",
    spotify: "1TRFAJu3Cw64APToZaGk9D",
    genre:
      "deep house,disco house,funky tech house,house,tech house,tribal house",
    popularity: "48",
  },
  {
    name: "Bongeziwe Mabandla",
    image: "https://i.scdn.co/image/69d2f543f7ad4c96a2822963b53473fc20ee9d0a",
    spotify: "5upKpIk1pv0hh0u2gwblwy",
    genre: "south african alternative,south african pop",
    popularity: "48",
  },
  {
    name: "Taiki Nulight",
    image: "https://i.scdn.co/image/7fc783caf1263de99d45b22f16c0eaad0f6b3bcc",
    spotify: "4QWmN97HRZya55JvxN3I5a",
    genre: "bass house,deep groove house,doujin,electro house",
    popularity: "48",
  },
  {
    name: "Alex M.O.R.P.H.",
    image: "https://i.scdn.co/image/4fe9a5035ff601c96077c55e7503079c5e6556ab",
    spotify: "478tAnskSff0wa0XxnpwmW",
    genre:
      "german techno,german trance,progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "48",
  },
  {
    name: "Finntroll",
    image: "https://i.scdn.co/image/8b4ee8808f9e720379219e13ab129db5d1a974d5",
    spotify: "4ZgkHVHmGPXuRy8zd26ZJX",
    genre:
      "finnish metal,folk metal,melodic death metal,metal,power metal,symphonic black metal,viking metal",
    popularity: "48",
  },
  {
    name: "Kris Berry",
    image: "https://i.scdn.co/image/afe490dc37db56fef5d0153898547d2123ff468a",
    spotify: "0IIPgITtEO4JJfipw57KGv",
    genre: "dutch pop",
    popularity: "48",
  },
  {
    name: "Janne Schra",
    image: "https://i.scdn.co/image/0961cc8a0749c528ca8bedad60459a011137b7cf",
    spotify: "7IGk0iXhaPjqvQF4Zi2R2K",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "48",
  },
  {
    name: "Nijntje",
    image: "https://i.scdn.co/image/ab67616d0000b273fb6618686c3b1103ee3da8f8",
    spotify: "3Jr5VVvMRw3ZmWSqmtHS5c",
    genre: "muziek voor kinderen",
    popularity: "48",
  },
  {
    name: "Tocotronic",
    image: "https://i.scdn.co/image/17e665c671235317febf9e266fe3e2888667ba9e",
    spotify: "4WOaecAM3RMMmrbZzNx0vu",
    genre:
      "antideutsche,german indie,german pop,german rock,hamburg indie,hamburger schule,liedermacher",
    popularity: "48",
  },
  {
    name: "Shiba San",
    image: "https://i.scdn.co/image/a36dcd54a0d3e92e170681659c66fccf077c545b",
    spotify: "7Hr9bE0u9Rl5n6QahVNRnc",
    genre: "bass house,electro house,french tech house,house",
    popularity: "48",
  },
  {
    name: "Aether",
    image: "https://i.scdn.co/image/0b17b8276ae3872506adf879b54e642dc8b83d05",
    spotify: "5UyjnQfu4OsLGiOi3sIoEN",
    genre: "chillstep,vapor twitch,wave",
    popularity: "48",
  },
  {
    name: "Thomas Oliver",
    image: "https://i.scdn.co/image/30727bbbc8063ad2fff4531ef9f731678af30e8b",
    spotify: "5ZwD9tfnJ04kM0qgPSMzgy",
    genre: "nz pop",
    popularity: "48",
  },
  {
    name: "Ana Moura",
    image: "https://i.scdn.co/image/2fedd49c9a5f2e5c64ddae08334fafad9b9d9826",
    spotify: "5HjL8Wcg8TdKTABDci2mB7",
    genre: "fado,portuguese pop",
    popularity: "48",
  },
  {
    name: "Yasmine",
    image: "https://i.scdn.co/image/ab67616d0000b273f7b2acf442f4888a7843ad10",
    spotify: "1E1m4bwOYgSMH4Q8o7DJYr",
    genre: "portuguese pop",
    popularity: "48",
  },
  {
    name: "Broken Minds",
    image: "https://i.scdn.co/image/e209a37f5820e5656be2ee3d548f1ceaa73a6962",
    spotify: "0b2rM3fXiBkA4c1SpSkoqE",
    genre: "uptempo hardcore",
    popularity: "48",
  },
  {
    name: "Jaytech",
    image: "https://i.scdn.co/image/b66f85bc400f5451d0bdf3b867605a0e317ab64a",
    spotify: "5mpJ1Z8BYEOG0rrdO4a2nG",
    genre:
      "progressive house,progressive trance,progressive trance house,trance,uplifting trance",
    popularity: "48",
  },
  {
    name: "Nekrogoblikon",
    image: "https://i.scdn.co/image/5ef9f0435b1c8fb93f027c50e857063d48aa0459",
    spotify: "3FILKvtNoiEfCJO9qVNCNF",
    genre: "folk metal,viking metal",
    popularity: "48",
  },
  {
    name: "Fatima Yamaha",
    image: "https://i.scdn.co/image/c6bdf88c1f8f913137a5b0aa90b2946b99c84232",
    spotify: "7eZRt08LoDy0nfIS6OwyMP",
    genre: "electro house",
    popularity: "48",
  },
  {
    name: "Mayhem",
    image: "https://i.scdn.co/image/f4e8feac493ce71b2edf847b287b0baebbeb8b66",
    spotify: "0dR10i73opHXuRuLbgxltM",
    genre: "black metal,metal,norwegian black metal,symphonic black metal",
    popularity: "48",
  },
  {
    name: "Rise Of The Northstar",
    image: "https://i.scdn.co/image/2b017cd401887f0cb1ecb93b2a3bbe7ea324390c",
    spotify: "5vDfbSPkurKQxpVVXALJ4K",
    genre: "beatdown",
    popularity: "48",
  },
  {
    name: "Jungle Brothers",
    image: "https://i.scdn.co/image/3d5e5e09f573a528d888fd6c34e0f79b91b89aa4",
    spotify: "2iclO3rlyF0YVNE46ctYRj",
    genre:
      "alternative hip hop,east coast hip hop,hardcore hip hop,hip hop,hip house,jazz rap,old school hip hop,rap,turntablism",
    popularity: "48",
  },
  {
    name: "Lionheart",
    image: "https://i.scdn.co/image/ab67616d0000b2731317419fb575b552b7f6b7d6",
    spotify: "7sHTXnqmYqCECjKKb2iqWS",
    genre: "background music",
    popularity: "48",
  },
  {
    name: "God Is An Astronaut",
    image: "https://i.scdn.co/image/394dd4e91f6f9b491edd39113eea7a1830f4eda3",
    spotify: "079svMEXkbT5nGU2kfoqO2",
    genre: "cosmic post-rock,instrumental post-rock,post-rock",
    popularity: "48",
  },
  {
    name: "Miss Kittin",
    image: "https://i.scdn.co/image/d1e129d8271949e8b811c54040e770bd3ebcc4a5",
    spotify: "3QhNv79NoIvarU6N57GBzL",
    genre:
      "alternative dance,dance-punk,electra,electroclash,electronica,electropop,french techno,new rave",
    popularity: "48",
  },
  {
    name: "Nina Kraviz",
    image: "https://i.scdn.co/image/54f1aa3b666f6389172d433d6fcb9704b105ded2",
    spotify: "1oZmFNkGAT93yD1xX4vTRE",
    genre: "electra,minimal techno,russian electronic,russian techno",
    popularity: "48",
  },
  {
    name: "Viagra Boys",
    image: "https://i.scdn.co/image/642df559652fded1aa1f0d9213b57356a6e84721",
    spotify: "2nAKP6etu8wXNnezKXgqgg",
    genre: "chamber psych,stockholm indie",
    popularity: "48",
  },
  {
    name: "Stanley Clarke",
    image: "https://i.scdn.co/image/30f9cccc684a0e723db3fc941a202bb707c01464",
    spotify: "1lGt9WgdYGpMnmwGkcCm05",
    genre: "electric bass,jazz funk,jazz fusion",
    popularity: "48",
  },
  {
    name: "Elias",
    image: "https://i.scdn.co/image/add33527e50ee4dc5f45513c4013728c529eaacb",
    spotify: "0UCLbPGOhtnYf29U7qbfLf",
    genre: "",
    popularity: "48",
  },
  {
    name: "OG Maco",
    image: "https://i.scdn.co/image/06c92b0aacdd52bec7f16eb948bb8b19163a59e3",
    spotify: "0nvvVQhPQGkYTJlThLbJeu",
    genre: "atl hip hop,trap,underground hip hop",
    popularity: "48",
  },
  {
    name: "Causes",
    image: "https://i.scdn.co/image/de7b4184d7fdf75320712213314c2a883f02550d",
    spotify: "1l48rGyg7MMLBbmP8MyFj3",
    genre: "dutch pop",
    popularity: "48",
  },
  {
    name: "Harry Romero",
    image: "https://i.scdn.co/image/89a885cc9a02aedcea38af190f0e2d660b99dc1a",
    spotify: "36AJmodiIrwV9U3QOiLMYM",
    genre:
      "chicago house,deep house,disco house,funky tech house,house,tech house,tribal house,vocal house",
    popularity: "48",
  },
  {
    name: "Heather Nova",
    image: "https://i.scdn.co/image/5eb46a69c23f4ee0df86352d2278947ac2cfad78",
    spotify: "76oeXwztPqAxVg9oqozK3z",
    genre: "lilith,new wave pop,pop rock",
    popularity: "48",
  },
  {
    name: "Fairport Convention",
    image: "https://i.scdn.co/image/f08b61d2f289195b7f29035056f7743935e87e60",
    spotify: "2LIdnZDzySb04oH40be1fR",
    genre:
      "british folk,country rock,folk,folk rock,psychedelic rock,roots rock,traditional folk",
    popularity: "48",
  },
  {
    name: "Raz Ohara",
    image: "https://i.scdn.co/image/f3b57a738f783db5d90c5994abfd955df098a9c7",
    spotify: "2FMUJIX6cW1Pby7my21xBO",
    genre: "",
    popularity: "48",
  },
  {
    name: "Evil Needle",
    image: "https://i.scdn.co/image/195d37616ea7bea148d4efb15ca58b45eb04f580",
    spotify: "37nE9g0LRDhDSIejDuPKPS",
    genre: "chillhop,vapor twitch",
    popularity: "48",
  },
  {
    name: "Ian Noe",
    image: "https://i.scdn.co/image/6372a6df441287af80d289b5577556d557f9574c",
    spotify: "2TEpPi5SFalflhpcQHq3lB",
    genre:
      "alternative country,deep new americana,indie folk,kentucky indie,new americana,roots americana",
    popularity: "48",
  },
  {
    name: "Pomo",
    image: "https://i.scdn.co/image/6567cc95ee55c9f347263a43a33f59586862c31c",
    spotify: "6YtlR8MLfO6azxwOKAvEi3",
    genre: "canadian electronic,indie soul,new french touch",
    popularity: "48",
  },
  {
    name: "Averro",
    image: "https://i.scdn.co/image/108bec4363fa8d42ca1411215568857521d824c3",
    spotify: "3PTNHymcsvmbSrlF7tTK74",
    genre: "",
    popularity: "48",
  },
  {
    name: "The Murlocs",
    image: "https://i.scdn.co/image/1c9f573530faa5981a6a8df8ef30ec703c4ed3c0",
    spotify: "0rH93aHDYyJfMAcPB9OKus",
    genre: "australian garage punk,indie garage rock,neo-psychedelic",
    popularity: "48",
  },
  {
    name: "Napalm Death",
    image: "https://i.scdn.co/image/c96c6837b4882de575ed85f0c2078f1197015d1e",
    spotify: "3UqRgrDIQ208yNGiWKRMNt",
    genre:
      "alternative metal,birmingham metal,british death metal,british grindcore,brutal death metal,death metal,deathgrind,grindcore,metal",
    popularity: "48",
  },
  {
    name: "DJ Seinfeld",
    image: "https://i.scdn.co/image/5480554e3401c0e369765b872b2169378a2f5740",
    spotify: "37YzpfBeFju8QRZ3g0Ha1Q",
    genre: "deep house,float house,lo-fi house",
    popularity: "48",
  },
  {
    name: "Laura Mvula",
    image: "https://i.scdn.co/image/eb915513533b7797188ad1a117b73fcae6923d83",
    spotify: "0Dy94lW3txJhWQHqNXP1BT",
    genre: "afrofuturism,british soul,neo soul",
    popularity: "48",
  },
  {
    name: "Los Van Van",
    image: "https://i.scdn.co/image/10f10015d3c9cb4a9cb34cf39c6b109215bd8ce6",
    spotify: "4B5PkQ1wMjo1siTN9yD9Ds",
    genre: "cuban rumba,latin jazz,salsa,salsa cubana,tropical",
    popularity: "48",
  },
  {
    name: "Christian Burns",
    image: "https://i.scdn.co/image/81cea212b2fdfad4aebabe0d787ff7bdd78fdbce",
    spotify: "1hu8RDN5gKsi2YYvWTOAqY",
    genre: "",
    popularity: "48",
  },
  {
    name: "Kyson",
    image: "https://i.scdn.co/image/143aca3f3be3e2150521f7574667a6c1baf93491",
    spotify: "1ysHnRqLx1sIFxUlahQftx",
    genre: "ambient idm,vapor soul",
    popularity: "48",
  },
  {
    name: "Shapeshifter",
    image: "https://i.scdn.co/image/40d2c1ea9cf0ee0d75d12b26f353d0cb9189700a",
    spotify: "4whp3jSWWaITn36r9D4ZLf",
    genre: "drum and bass,kiwi rock,liquid funk,nz dnb,nz electronic",
    popularity: "48",
  },
  {
    name: "FDVM",
    image: "https://i.scdn.co/image/41e8c158997a16b1188bd96d2cec029544b74cc6",
    spotify: "6J0Y4CoGMKL5RyeozHnVKl",
    genre: "deep house,deep tropical house,new french touch,tropical house",
    popularity: "48",
  },
  {
    name: "Branko",
    image: "https://i.scdn.co/image/3a031ecd2a93989cac4c44803292a2e3e8fd3c5d",
    spotify: "1lEBJGJgdoevi1Clv9CqLT",
    genre: "moombahton",
    popularity: "48",
  },
  {
    name: "La Fuente",
    image: "https://i.scdn.co/image/1b934d9504d7539d2dd6256215aa0713d875d97f",
    spotify: "0vhJymgsCubfAfFjEGVsoD",
    genre: "dutch edm",
    popularity: "47",
  },
  {
    name: "Ruben de Ronde",
    image: "https://i.scdn.co/image/ef1dd8dd3ef369776c7952c73d08cbcdf363463b",
    spotify: "3q7BRw9D1DupXTONJdr94m",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "47",
  },
  {
    name: "FeestDJRuud",
    image: "https://i.scdn.co/image/1502284a384bc27fb4ca1da66e190452a18100da",
    spotify: "0IId5Ktyl22C7W9PtisEXD",
    genre: "carnaval",
    popularity: "47",
  },
  {
    name: "16BL",
    image: "https://i.scdn.co/image/da790886554c09b664fd25a9dbfe6e73f48eeaa7",
    spotify: "0u2qG4roqULELVVO9fMgSG",
    genre: "progressive house,progressive trance house,tech house",
    popularity: "47",
  },
  {
    name: "Shermanology",
    image: "https://i.scdn.co/image/46c0860c7ebaf80ca546c4354ac7f1f9b6b7a1a2",
    spotify: "4Siyzg8kWayQfPQsPSl6JI",
    genre: "dutch house",
    popularity: "47",
  },
  {
    name: "Mike Cervello",
    image: "https://i.scdn.co/image/eba30e446add29c12a4b3ff4d6da9a0195fd509d",
    spotify: "4zYX8Aa744hQ5O2hpAYQI3",
    genre: "deep big room,dutch edm,electro house,electronic trap",
    popularity: "47",
  },
  {
    name: "Wiwek",
    image: "https://i.scdn.co/image/72c12b773942b15d2a481e75a874e9c736b2d0a4",
    spotify: "4b2v3PBjJJCF2BX14lIAsT",
    genre: "brostep,deep big room,electro house,electronic trap,moombahton",
    popularity: "47",
  },
  {
    name: "Shapeless",
    image: "https://i.scdn.co/image/1d23687a77bfeeec91a5526d894d1d606f4848cf",
    spotify: "01056gItT5lFJEvQnFOByX",
    genre: "brazilian edm",
    popularity: "47",
  },
  {
    name: "Jerome Isma-Ae",
    image: "https://i.scdn.co/image/8b05993311524b8cc858f5d480251e0004300990",
    spotify: "4GEIawzVZxWGdtl9OOdgeA",
    genre: "munich electronic,progressive house,progressive trance,trance",
    popularity: "47",
  },
  {
    name: "KAS:ST",
    image: "https://i.scdn.co/image/589d121bddd69647a260577cd678568d70262361",
    spotify: "7orlzf5LTqSnCzURkZFebN",
    genre: "minimal dub",
    popularity: "47",
  },
  {
    name: "Jeangu Macrooy",
    image: "https://i.scdn.co/image/d2ddd119dde8c00b3cb50e747d8fedd0409bb693",
    spotify: "3t9HafA5eFHM992s4GZ0Gr",
    genre: "dutch pop",
    popularity: "47",
  },
  {
    name: "Brainpower",
    image: "https://i.scdn.co/image/1bd73c9f5ab181623a0aa77fa828f8fc8ce47ddb",
    spotify: "6LfIVTnSSc9zNqjpfVPs1w",
    genre: "dutch hip hop,dutch pop,dutch rock,old school nederhop",
    popularity: "47",
  },
  {
    name: "Pleasurekraft",
    image: "https://i.scdn.co/image/3596230fcac34c88728316c8825fbc2f404ed3fd",
    spotify: "4ipS3ZbqP46bs124yqp9N4",
    genre: "dark techno,deep minimal techno,minimal techno,tech house",
    popularity: "47",
  },
  {
    name: "Greazy Puzzy Fuckerz",
    image: "https://i.scdn.co/image/8c1ec0cbb241e52c7f62cc743ff848ac92216bf2",
    spotify: "4OoHneMX97SjUXKWgsyrP4",
    genre: "tekk,uptempo hardcore",
    popularity: "47",
  },
  {
    name: "Malifoo",
    image: "https://i.scdn.co/image/db6926ce04eaf1a95009e6df1e9a0a2e205e4e46",
    spotify: "6Mt8or6ZkKPJSSECpY7Pu5",
    genre: "brazilian edm,brazilian house",
    popularity: "47",
  },
  {
    name: "Tim Green",
    image: "https://i.scdn.co/image/36880195e1573a600afc92dc413dd2639badfd34",
    spotify: "68vO4fkFxLbWPxTSHosxsB",
    genre: "deep disco house,minimal tech house,organic house,tech house",
    popularity: "47",
  },
  {
    name: "Son Mieux",
    image: "https://i.scdn.co/image/c8c902d034f1f03cbede26d05a1c895279ddaffe",
    spotify: "1BCBAzjX8J0qpvNTPRDCLc",
    genre: "dutch indie,dutch pop,dutch rock,folk-pop",
    popularity: "47",
  },
  {
    name: "Suyano",
    image: "https://i.scdn.co/image/e165411ce5466586b8d9957a58a4df3ea9bf0a19",
    spotify: "6ydu7uQ1zZeWUA7FuKnTWG",
    genre: "big room,deep big room,electro house,sky room",
    popularity: "47",
  },
  {
    name: "Jimi Jules",
    image: "https://i.scdn.co/image/43e78e013949b72c38ee055a8998379dc5806686",
    spotify: "6RsLLSkSTcL4YrvgRcBTQd",
    genre: "swiss house",
    popularity: "47",
  },
  {
    name: "Jacqueline Govaert",
    image: "https://i.scdn.co/image/640a9a527adb2c6044969af6ef615ff5e4240838",
    spotify: "7LTI9KZLhnMbrDojlJK7Li",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "47",
  },
  {
    name: "Komodo",
    image: "https://i.scdn.co/image/9b41f6fbeeecf01fd763c26397867044927055dc",
    spotify: "1lmjruOcvyQRZNIKUOlf68",
    genre: "",
    popularity: "47",
  },
  {
    name: "Mat.Joe",
    image: "https://i.scdn.co/image/7d42e62ca64eef052ab749d167b4ff9b958dedf2",
    spotify: "38jpuy3yt3QIxQ8Fn1HTeJ",
    genre:
      "deep disco house,deep groove house,deep house,disco house,funky tech house,house,tech house",
    popularity: "47",
  },
  {
    name: "Van Dik Hout",
    image: "https://i.scdn.co/image/48af96d265d2403480928876e14a41319e50c83e",
    spotify: "7t1YgV4PxSjBg9P8ZqE4Vo",
    genre: "dutch cabaret,dutch indie,dutch pop,dutch rock,nederpop",
    popularity: "47",
  },
  {
    name: "Kim Kaey",
    image: "https://i.scdn.co/image/bfdd0473cc8c88a68f0b82ccd7b565a9eaa72ca7",
    spotify: "29c2vtSHCC1QvGh29zEfpy",
    genre: "",
    popularity: "47",
  },
  {
    name: "DJ BORING",
    image: "https://i.scdn.co/image/89be1fcaf6336fe42462b8c5bb79845df2f01fdc",
    spotify: "3MkIU5jhXTMK9pYQTRVI6p",
    genre: "deep house,float house,lo-fi house",
    popularity: "47",
  },
  {
    name: "Dodge & Fuski",
    image: "https://i.scdn.co/image/fddeec905a83ce5304237f02be18f7ae937ed324",
    spotify: "6SJnjpekgnONgNtxKeMP8m",
    genre:
      "bass trap,brostep,catstep,complextro,edm,electro house,electronic trap,filthstep,zapstep",
    popularity: "47",
  },
  {
    name: "Purple Haze",
    image: "https://i.scdn.co/image/87ea2b73f3f3edfb974b82437c23ebaebb93c9e6",
    spotify: "35ClM9mD81Evb2EIuYq5en",
    genre: "",
    popularity: "47",
  },
  {
    name: "Susto",
    image: "https://i.scdn.co/image/def532ef2fc49c320c0b124a1fbe80d2294c7c96",
    spotify: "7foyQbi7GKriLiv1GPVEwt",
    genre:
      "deep new americana,indie folk,new americana,roots rock,south carolina indie,stomp and holler",
    popularity: "47",
  },
  {
    name: "Oliver Smith",
    image: "https://i.scdn.co/image/4781f2499c4c5f0de909daba050fa71599374885",
    spotify: "2Npo4Cfm48M2uKlvxiXMic",
    genre:
      "edm,progressive house,progressive trance,progressive trance house,trance,uplifting trance",
    popularity: "47",
  },
  {
    name: "Federico Albanese",
    image: "https://i.scdn.co/image/0cd13dca80e8f8721fac3ca21367871fdb1f928e",
    spotify: "75DsjkCdxGmvitG1tqqBkL",
    genre: "compositional ambient,focus,neo-classical",
    popularity: "47",
  },
  {
    name: "Oliver Huntemann",
    image: "https://i.scdn.co/image/2b39bdc5cf5810017000485a403a7df0b6ffc6e2",
    spotify: "0NBGssQpgDczTsVEp4pCbR",
    genre:
      "dark techno,german techno,hamburg electronic,minimal techno,tech house",
    popularity: "47",
  },
  {
    name: "DOLF",
    image: "https://i.scdn.co/image/5a2386e2866cfbb618c8dbdd65fca331400c25d7",
    spotify: "3Xq2UDTRsQqQnfR3FIGoFG",
    genre: "dutch edm,pop edm",
    popularity: "47",
  },
  {
    name: "Eliades Ochoa",
    image: "https://i.scdn.co/image/4133fdbe867a887a9775eb6bda58021ac26181cb",
    spotify: "0hXHTWhBUEpkyHJ0GnghEH",
    genre: "latin jazz,son cubano",
    popularity: "47",
  },
  {
    name: "EC Twins",
    image: "https://i.scdn.co/image/c25407a0ac5e823a657fe60fa03a93e4f1244059",
    spotify: "6QACkIioo2Na2EKEwJzCKK",
    genre: "",
    popularity: "47",
  },
  {
    name: "Sagan",
    image: "https://i.scdn.co/image/32847b3f69600dff358c768052a878cf6ee9ec9a",
    spotify: "5JHw3zW4kgwIZlh33geR1K",
    genre: "deep big room,edm,electro house,future house,pop edm,sky room",
    popularity: "47",
  },
  {
    name: "Recondite",
    image: "https://i.scdn.co/image/0b893d0b7372110c44c53e299375cffc4cb1ccd8",
    spotify: "1doQgXssRfKnLx70adszbK",
    genre: "ambient techno,deep techno,electronica,microhouse,minimal techno",
    popularity: "47",
  },
  {
    name: "Blond:ish",
    image: "https://i.scdn.co/image/8c4591cdb1d49041c14f450e0e76877b464cca3d",
    spotify: "6zsJjoCtL1WByG0VsuFWzR",
    genre: "deep disco house,ethnotronica,organic house",
    popularity: "47",
  },
  {
    name: "Chelou",
    image: "https://i.scdn.co/image/7b2e43389e359386f7c40bd0c7a3df97dbcbee46",
    spotify: "2RwfRD2vlkdztGtVXENShq",
    genre: "uk alternative pop",
    popularity: "47",
  },
  {
    name: "American Aquarium",
    image: "https://i.scdn.co/image/74dbf57aae05caa605716a4f49310bbad3f14d1a",
    spotify: "7nSYcucRT6IGiMepEmiZgT",
    genre:
      "alternative country,deep new americana,modern southern rock,new americana,roots americana,roots rock,southern americana,stomp and holler,texas country",
    popularity: "47",
  },
  {
    name: "Jelle van Dael",
    image: "https://i.scdn.co/image/cc70e2c6fff68ba978ec699bc59162f8f1899b45",
    spotify: "4CBytrQX85XtpfDzvdL3DI",
    genre: "",
    popularity: "47",
  },
  {
    name: "Loathe",
    image: "https://i.scdn.co/image/01f5cbf80e2ad4bf755b7ca4407da62eaf13a88f",
    spotify: "4G9wSdX0klmoHfjm9i6DLd",
    genre: "metalcore,nu-metalcore,progressive metalcore,uk metalcore",
    popularity: "47",
  },
  {
    name: "Di Derre",
    image: "https://i.scdn.co/image/f9989734256b5102cd62fafb97fa248ec92947cb",
    spotify: "3xhyJwgAUGZSE162fJXRJY",
    genre: "classic norwegian pop,danseband,norwegian pop,norwegian rock",
    popularity: "47",
  },
  {
    name: "Soufiane Eddyani",
    image: "https://i.scdn.co/image/d8ae3ed0868784e1598972857d6f2119a73e3bf7",
    spotify: "3g6GiVVg4ynji0D8f93bHZ",
    genre: "belgian hip hop,dutch hip hop",
    popularity: "47",
  },
  {
    name: "Hanne Mjøen",
    image: "https://i.scdn.co/image/bfbd8877297c0ecf545eb0b650105d76d76d9dd2",
    spotify: "2xDZ8qyyE2Ti4wL1Ob1T7V",
    genre: "melodipop",
    popularity: "47",
  },
  {
    name: "Wayne Snow",
    image: "https://i.scdn.co/image/9190447c882f4a03b16b1c01f6c8e5a53ff4e71d",
    spotify: "4f44GWlEQdXaWl8gQ9sPBC",
    genre: "indie jazz,indie soul",
    popularity: "47",
  },
  {
    name: "Crussen",
    image: "https://i.scdn.co/image/ab67616d0000b2735063192f62cbfbdbcc680d9d",
    spotify: "79OTUKSZMGMmmR32RWG2ig",
    genre: "ethnotronica,organic house",
    popularity: "47",
  },
  {
    name: "Swingrowers",
    image: "https://i.scdn.co/image/ef70d8307128483250a24c278f28034a793a5c4f",
    spotify: "3mp5zzEz1qTq7X5a2yOS2B",
    genre: "electro swing,nu jazz",
    popularity: "47",
  },
  {
    name: "Little Boots",
    image: "https://i.scdn.co/image/ec09d8fdd1461cf7aa7273aebb3444ec539ad03c",
    spotify: "0MoXIHcFwhIWnFgBfdvQ30",
    genre:
      "alternative dance,dance pop,electroclash,electropop,indietronica,neo-synthpop,new rave,strut",
    popularity: "47",
  },
  {
    name: "The Thrillseekers",
    image: "https://i.scdn.co/image/2f5d8dd21371b312f0ed898073b848a39f679378",
    spotify: "1RYDKWzJnJtbTPYNsDswD5",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "47",
  },
  {
    name: "Cuebrick",
    image: "https://i.scdn.co/image/5694427b7cf6d3453045bd3be5a62560350c1049",
    spotify: "2ONoOunWxnWn1DikA6rjBM",
    genre: "big room,deep big room,pop edm,progressive electro house,sky room",
    popularity: "47",
  },
  {
    name: "Megaherz",
    image: "https://i.scdn.co/image/0bc82f44643294683d292923528295261a7515de",
    spotify: "4tM8qmqg5cEZPHNLNQwHeb",
    genre: "industrial metal,medieval rock,neue deutsche harte",
    popularity: "47",
  },
  {
    name: "Gideon",
    image: "https://i.scdn.co/image/65e427b15b3ec6d555122fc25ba7e541d62319f4",
    spotify: "3Zj2B8yAi8gHoR8vpsPatZ",
    genre:
      "alabama metal,american metalcore,christian hardcore,christian metal,christian metalcore,deathcore,melodic hardcore,melodic metalcore,metalcore",
    popularity: "47",
  },
  {
    name: "Stoltenhoff",
    image: "https://i.scdn.co/image/cf18d47616157a61fb9112abb1b38c1210335f63",
    spotify: "6HKR0MHpgba3ZRBXYfPiq0",
    genre: "",
    popularity: "47",
  },
  {
    name: "Chris James",
    image: "https://i.scdn.co/image/ab67616d0000b273bb5c6889f8248aa3f70ec1fd",
    spotify: "36tYUHvwOqvoVtpDscFUHw",
    genre: "",
    popularity: "47",
  },
  {
    name: "Any Given Day",
    image: "https://i.scdn.co/image/30a4141a205a3c42d4e4802075eddc82f05c71be",
    spotify: "4p6RoajGbtqLSfYZpFxHyU",
    genre: "german metalcore,german post-hardcore,melodic metalcore,metalcore",
    popularity: "47",
  },
  {
    name: "Stam1na",
    image: "https://i.scdn.co/image/b57f184ed242803f902eea58349f96759c80d8e6",
    spotify: "41nB823nb3wxEI25UeGHqG",
    genre: "finnish metal,finnish punk,progressive thrash,suomi rock",
    popularity: "47",
  },
  {
    name: "Omiki",
    image: "https://i.scdn.co/image/98bb9d6ea2de7b8b9a73b5abc1fcfcec89f02bde",
    spotify: "7pHwBqsYULdAdHgSwf1q9f",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "47",
  },
  {
    name: "Technikore",
    image: "https://i.scdn.co/image/3c064c480dc12a0056aae09128b243d39f9193f2",
    spotify: "45mQUJrPyctvf2IhkVE0ym",
    genre: "bouncy house,deep happy hardcore,happy hardcore,hardstyle",
    popularity: "47",
  },
  {
    name: "Dubioza kolektiv",
    image: "https://i.scdn.co/image/4d4d3364e73ae54728222ae56bbbe0d12b0e5b5c",
    spotify: "02IFYoziC7CpQRK8fbehUY",
    genre: "bosnian indie,yugoslav rock",
    popularity: "47",
  },
  {
    name: "Noga Erez",
    image: "https://i.scdn.co/image/1d7ce9c26fb762cd71e13b90396b8dbc1bd250c9",
    spotify: "5VwCIS8jdx9ZHjApLFNrTZ",
    genre: "israeli hip hop,israeli indie",
    popularity: "47",
  },
  {
    name: "Alexander Popov",
    image: "https://i.scdn.co/image/251bc89a6c6b809b72067ccb742fe1b0df9ae2e6",
    spotify: "4zNhfG6i4QlfUuzt1hBGu2",
    genre:
      "progressive house,progressive trance,russian trance,trance,uplifting trance",
    popularity: "47",
  },
  {
    name: "Zeal & Ardor",
    image: "https://i.scdn.co/image/c0801383347774f4ec9ec21951a1eb9aa6ace598",
    spotify: "6yCjbLFZ9qAnWfsy9ujm5Y",
    genre: "avant-garde metal,swiss metal",
    popularity: "47",
  },
  {
    name: "Kevcody",
    image: "https://i.scdn.co/image/980e2b87c20aaac952aef36e89680454969d7ae1",
    spotify: "3heGIV1KV0B4c4MW7H2mey",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "47",
  },
  {
    name: "Sorry",
    image: "https://i.scdn.co/image/c7b1adb28d841e18ef010f0d88ef29fe62273ee1",
    spotify: "5eUda4BaWhUQWWJiP1ml5v",
    genre:
      "art pop,chamber psych,english indie rock,garage psych,modern alternative rock,uk post-punk revival",
    popularity: "47",
  },
  {
    name: "Connect",
    image: "https://i.scdn.co/image/ab67616d0000b2730d9bc3f39b0051a66f19aa15",
    spotify: "5ZwkiUKKUk0daaLqPicRua",
    genre: "croatian hip hop,turbo folk",
    popularity: "47",
  },
  {
    name: "Crossfaith",
    image: "https://i.scdn.co/image/45d6a326abfdf2a0a11be7cb3fbfbd87e95305ff",
    spotify: "3gfA40vRbx6YX8oCDXDCDh",
    genre:
      "idol rock,j-metal,j-rock,japanese metalcore,japanese punk rock,metalcore,trancecore",
    popularity: "47",
  },
  {
    name: "Eunique",
    image: "https://i.scdn.co/image/be7eff11885d0c798d610e8ef25c47abb47cf496",
    spotify: "7MSwVATA5fRIxRA6Z0BmTe",
    genre: "german cloud rap,german hip hop",
    popularity: "47",
  },
  {
    name: "Trash Boat",
    image: "https://i.scdn.co/image/afb74f55385e7545c89646794842ad9e4a484d38",
    spotify: "0XGJ3GUPwslwFJ66yNbHeh",
    genre: "alternative emo,anthem emo,easycore,pop punk,uk pop punk",
    popularity: "47",
  },
  {
    name: "Austra",
    image: "https://i.scdn.co/image/88c8bba11f9f2692d7c8dfb969a5cc8833ccad99",
    spotify: "1o43SzzuLoyOxqThmp7s0g",
    genre:
      "alternative dance,art pop,canadian electropop,chamber psych,chillwave,electroclash,electronica,electropop,indietronica,metropopolis,new rave,shimmer pop",
    popularity: "47",
  },
  {
    name: "Sweater Beats",
    image: "https://i.scdn.co/image/487ca71d711258d74e00d755583a877504bdb6e2",
    spotify: "62Jfwxon19ZOT9eSL6bvtY",
    genre: "gauze pop,vapor twitch",
    popularity: "47",
  },
  {
    name: "Oxia",
    image: "https://i.scdn.co/image/500ffb8e692e208b58ddbafc9363f73991443d5f",
    spotify: "2zgFYHwSEYOc1KnldGsBXK",
    genre: "french tech house,minimal techno,tech house",
    popularity: "47",
  },
  {
    name: "The Darkraver",
    image: "https://i.scdn.co/image/71d40f5b3d37f59e5d0edc0cae2ca2f533840d59",
    spotify: "3Lu9zTGOtzT2MZpfxdaHJv",
    genre: "gabba,happy hardcore",
    popularity: "46",
  },
  {
    name: "Downlink",
    image: "https://i.scdn.co/image/f14c59c000c229904c5240cf611acd79102744b8",
    spotify: "6ynSq3csnauyqZeQgfuWWt",
    genre: "brostep,canadian electronic,filthstep,zapstep",
    popularity: "46",
  },
  {
    name: "Estiva",
    image: "https://i.scdn.co/image/08f5161391fd2b75fc0f9ebcfb416fb34ebfd7fd",
    spotify: "1ltDgA6tV4utKM6y1BOYIE",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "46",
  },
  {
    name: "Devochka",
    image: "https://i.scdn.co/image/a773e75bfe77b6fd0021a6cce445bbf63a3e1a32",
    spotify: "02xYwCW4WypA3nRQv6qEcX",
    genre: "brazilian edm",
    popularity: "46",
  },
  {
    name: "DJ Lag",
    image: "https://i.scdn.co/image/6ee3f5fc3a8e96035065f053641687d8539535ba",
    spotify: "1svX5cMlY22N60RxwzeJNO",
    genre: "gqom",
    popularity: "46",
  },
  {
    name: "London Elektricity",
    image: "https://i.scdn.co/image/d63f172d542e94c527621650fc53f5fba1b2c1ba",
    spotify: "4CbuwI3bEF7gQOwpxBKtal",
    genre: "drum and bass,liquid funk,uk dnb",
    popularity: "46",
  },
  {
    name: "LOOPERS",
    image: "https://i.scdn.co/image/3cade00ddb72a600d4c4e33fcac8fc70045a7cd0",
    spotify: "0Aemly9h57T2sLKpkNq409",
    genre:
      "big room,deep big room,dutch house,electro house,progressive electro house,sky room",
    popularity: "46",
  },
  {
    name: "Extrawelt",
    image: "https://i.scdn.co/image/0e520865ba05ab197e692ddd66378419eea7bf6a",
    spotify: "3VRvi42U8SsiT4YKP5LNCB",
    genre:
      "electronica,german techno,hamburg electronic,microhouse,minimal techno,tech house",
    popularity: "46",
  },
  {
    name: "Roxeanne Hazes",
    image: "https://i.scdn.co/image/a9e3549e70aa8ba2b3de42feb87a2aae2f719782",
    spotify: "1GWpddfwL9bVovOzCtNQN6",
    genre: "dutch pop",
    popularity: "46",
  },
  {
    name: "Mashd N Kutcher",
    image: "https://i.scdn.co/image/58d25724639de8562b82bb78dd4b75db7d7dd98d",
    spotify: "0G5lZVxoMwoY8oV6zR8E7k",
    genre: "",
    popularity: "46",
  },
  {
    name: "RUGGED",
    image: "https://i.scdn.co/image/9b1213cdff1f7daba51cbc73e1e4da4aa46b6a9b",
    spotify: "7HVtSgsv5Ye0Y6ntC97jbW",
    genre: "dutch trap pop",
    popularity: "46",
  },
  {
    name: "Billy Kenny",
    image: "https://i.scdn.co/image/d399f56b43cebd2019c1b2b8f4bd8b8eace5aee7",
    spotify: "4vOWtH59x00IhY805tdf74",
    genre: "bass house,deep groove house,electro house,house",
    popularity: "46",
  },
  {
    name: "Dither",
    image: "https://i.scdn.co/image/03d890cb676e6a17ff81edde4c2c9ef20710601a",
    spotify: "2CTPZndAY5BwdgHk8AX0B7",
    genre:
      "abstract idm,hardcore techno,industrial hardcore,rawstyle,uptempo hardcore",
    popularity: "46",
  },
  {
    name: "Tunnelvisions",
    image: "https://i.scdn.co/image/5f639a26a1e6e459c25ec453d8088ccc54c7472b",
    spotify: "0IhfJZiFjHqE9mJ9INjp7x",
    genre: "ethnotronica,organic house,tech house",
    popularity: "46",
  },
  {
    name: "Drunken Masters",
    image: "https://i.scdn.co/image/030fce35931d44e5ae0093db4ee5c3aa13ba328f",
    spotify: "0cUMeX7DFLIvLy0q8uqp6q",
    genre: "jump up",
    popularity: "46",
  },
  {
    name: "DJ Licious",
    image: "https://i.scdn.co/image/71e875882bb55b3c0d02f8d09c42007547e0f8a1",
    spotify: "30SUNrTLW7OZeDALH3sWzH",
    genre: "belgian edm",
    popularity: "46",
  },
  {
    name: "L D R U",
    image: "https://i.scdn.co/image/322ef38354e6dfe70be8a54fd958377cebcba4b7",
    spotify: "2RnDmyX1zzOkK5Cj9QPhMq",
    genre: "australian dance,australian hip hop",
    popularity: "46",
  },
  {
    name: "Shkoon",
    image: "https://i.scdn.co/image/1b3d8d85ed472d80b328b1acc5dc33d3198d4d08",
    spotify: "3CdsJ9u53uPu3dScKypLVv",
    genre:
      "arab electronic,ethnotronica,hamburg electronic,organic electronic,organic house",
    popularity: "46",
  },
  {
    name: "TV Noise",
    image: "https://i.scdn.co/image/78d00db4048d1f9104f3d1574d80c7824a169044",
    spotify: "32Aw9aJJoXXC1Vn3zqzJbQ",
    genre:
      "big room,deep big room,dutch edm,electro house,electronic trap,sky room",
    popularity: "46",
  },
  {
    name: "FJAAK",
    image: "https://i.scdn.co/image/70fe11f610c2936851c846ed5bd5ffe9f3831993",
    spotify: "4qG1qjeHfkASTdyRGbLWbV",
    genre: "minimal dub,techno",
    popularity: "46",
  },
  {
    name: "Floorplan",
    image: "https://i.scdn.co/image/24fd2b803fd0b2e14497da1ef275e44d3a562500",
    spotify: "0RBnTX5xoVa1bDYt9Qbies",
    genre: "chicago house,deep house,disco house,float house,tech house,techno",
    popularity: "46",
  },
  {
    name: "LARI LUKE",
    image: "https://i.scdn.co/image/7df2173ed01d8fb92877facf900a1413a26e0102",
    spotify: "4CTjrUu7zgqHjGDjFKYTAm",
    genre: "",
    popularity: "46",
  },
  {
    name: "Sunny Lax",
    image: "https://i.scdn.co/image/bbb0f019136e9b4fea7792805f71656e1f4f1437",
    spotify: "0cCOt2mcZfspvOOhY8TdmD",
    genre:
      "edm,progressive house,progressive trance,progressive trance house,trance,uplifting trance",
    popularity: "46",
  },
  {
    name: "Gare Du Nord",
    image: "https://i.scdn.co/image/ab67616d0000b27324fc93f3102d6a3d7405971c",
    spotify: "0fvpn2k7FymYHxEx5U5FpP",
    genre: "dutch pop,dutch rock,electro jazz,nu jazz",
    popularity: "46",
  },
  {
    name: "Bali Bandits",
    image: "https://i.scdn.co/image/4ecb96eaeb921a551ee9d57d9bfc6523327f8545",
    spotify: "1GcKPo3HglflWJSV683pHx",
    genre:
      "big room,deep big room,dutch edm,electro house,future house,sky room",
    popularity: "46",
  },
  {
    name: "Dirty Audio",
    image: "https://i.scdn.co/image/6174bbf4b7d3ae794de124aca9759b64e2904def",
    spotify: "1WGex9YdmT4TZjmmMirZA8",
    genre: "bass trap,brostep,catstep,electro house,electronic trap,zapstep",
    popularity: "46",
  },
  {
    name: "ESG",
    image: "https://i.scdn.co/image/bc69899a0130abfbd16adff2c10ee36ca1fe5358",
    spotify: "4EF5vIcCYKMM61oYOG2Tqa",
    genre: "dance rock,dance-punk,experimental,no wave,post-punk",
    popularity: "46",
  },
  {
    name: "Prins Thomas",
    image: "https://i.scdn.co/image/7d48f884b779d49fcb339151405b33d733d278e5",
    spotify: "4rsEVNO1tGTY0beCnsnHi6",
    genre: "balearic,float house,microhouse,norwegian space disco,nu disco",
    popularity: "46",
  },
  {
    name: "Too Many Zooz",
    image: "https://i.scdn.co/image/fc295b5c5ad8af7e112f7ade473adca1631bbcd1",
    spotify: "72rZmJbRFSY6IFJAysfOdr",
    genre: "brass band",
    popularity: "46",
  },
  {
    name: "Charlie Parr",
    image: "https://i.scdn.co/image/0fb2dffc8c74e4e3c55cb43d68b2c8f20ee3fbd6",
    spotify: "2OOAWkt15smEKXtNNLtaNG",
    genre:
      "alternative country,deep new americana,duluth indie,folk,new americana,piedmont blues,progressive bluegrass,roots rock,stomp and holler,traditional folk",
    popularity: "46",
  },
  {
    name: "The Vision",
    image: "https://i.scdn.co/image/cffdcd5db342839e98a0b27679c3b370db221939",
    spotify: "33nwA09TKiO0nWmUrI3E1I",
    genre: "deep house,disco house,vocal house",
    popularity: "46",
  },
  {
    name: "Lina Ice",
    image: "https://i.scdn.co/image/231af8f55124c7a7728a739e3b21209cd5e94e84",
    spotify: "12E9KrxnskvuhWQymejsPm",
    genre: "basshall,dutch hip hop,dutch pop,dutch trap pop",
    popularity: "46",
  },
  {
    name: "Fejká",
    image: "https://i.scdn.co/image/06e00e7028d110feb1da215d82cef6947c01691d",
    spotify: "0VWvUvjaHaW1OeXtcVISu9",
    genre: "ambient house",
    popularity: "46",
  },
  {
    name: "Darius Syrossian",
    image: "https://i.scdn.co/image/26ad686d7d4f13deda6f41530893f074e369ff6b",
    spotify: "6PDUdAoMV9dMy0wOt09Rsf",
    genre:
      "deep disco house,deep groove house,deep house,disco house,funky tech house,house,minimal tech house,tech house,tribal house,uk tech house",
    popularity: "46",
  },
  {
    name: "Okke Punt",
    image: "https://i.scdn.co/image/60737df144d1bbe1443262fce3ab40b3b0f8ef12",
    spotify: "62eGoLRCLKqObqDkLfYDVP",
    genre: "pop folk",
    popularity: "46",
  },
  {
    name: "Stafford Brothers",
    image: "https://i.scdn.co/image/8845cfe851c303b2fb8cf8bf4d21b5acecff1058",
    spotify: "1dnbud9cuozLQ86MtrDPFr",
    genre: "australian dance",
    popularity: "46",
  },
  {
    name: "Becca Mancari",
    image: "https://i.scdn.co/image/0faa080545dcc6b50067665bc185fb78b90bf12e",
    spotify: "5n9jfCRA7AFY1JfYc5ZYK5",
    genre: "nashville indie,nashville singer-songwriter",
    popularity: "46",
  },
  {
    name: "Blinders",
    image: "https://i.scdn.co/image/15023cf91328ac924d34be866f3e5651f35df582",
    spotify: "26JVnujQQ3lEML8t9p3X1J",
    genre:
      "big room,deep big room,electro house,louisville indie,progressive electro house,sky room",
    popularity: "46",
  },
  {
    name: "YOOKiE",
    image: "https://i.scdn.co/image/9b19070a02ac17819511edb770d952b207f20b5d",
    spotify: "26RHyTSsP5JoS4udf8txU5",
    genre: "electronic trap",
    popularity: "46",
  },
  {
    name: "Rebourne",
    image: "https://i.scdn.co/image/058b4b7cf81dc2f0fdfc263411d71e26928b0498",
    spotify: "7ikySCCJo3shAEZsoKEtVK",
    genre:
      "australian dance,classic hardstyle,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "46",
  },
  {
    name: "Carlos Cipa",
    image: "https://i.scdn.co/image/a58961dfcc4d07a0dcbd2a5dfb9af37ca432e913",
    spotify: "23Yv6j1axUmPPo5M6u6erO",
    genre: "compositional ambient,focus,neo-classical",
    popularity: "46",
  },
  {
    name: "Project Pablo",
    image: "https://i.scdn.co/image/a9c07e1746fbbc061e7c37e36ef13c94e13dad97",
    spotify: "2OHzpRiwkpxGE7IA0hnSko",
    genre:
      "canadian electronic,canadian house,deep house,electronica,float house,indie soul,lo-fi house,tech house",
    popularity: "46",
  },
  {
    name: "Trobeats",
    image: "https://i.scdn.co/image/39b879eb2a81ba3939ae30ee565ddc36257ad942",
    spotify: "7dh6G6qILmRpUtZU4ZSD4D",
    genre: "",
    popularity: "46",
  },
  {
    name: "Lange",
    image: "https://i.scdn.co/image/198f55cccee0981a9faac8e0032c8b21f1c33a70",
    spotify: "0zgmzl8NLEOsqYNOQcSmAA",
    genre:
      "deep uplifting trance,progressive house,progressive trance,trance,uplifting trance",
    popularity: "46",
  },
  {
    name: "islandman",
    image: "https://i.scdn.co/image/4f0a91be749694608413685db364a9260e81b0bc",
    spotify: "3So3vlAfrEh2FbpvG7sxO4",
    genre: "ethnotronica,organic house,turkish electronic",
    popularity: "46",
  },
  {
    name: "Stray From The Path",
    image: "https://i.scdn.co/image/668f04e0b8c707a05b88f3109eab797f5574df12",
    spotify: "5tGG1slV9pkcydU5eQSIvm",
    genre: "melodic hardcore,melodic metalcore,metalcore",
    popularity: "46",
  },
  {
    name: "Bongo Botrako",
    image: "https://i.scdn.co/image/3559578cc6e4cf1d7ebb3c48ade5dbea8e87b0bc",
    spotify: "6XcqNunmoXrhbq6rAYgFxJ",
    genre: "reggae catala,ska catala",
    popularity: "46",
  },
  {
    name: "Twin Bandit",
    image: "https://i.scdn.co/image/d44e7ab8657d8ea07176849955f37a8e450cfe3b",
    spotify: "0PFFKJfJZU5TbgQXIw8cBr",
    genre: "canadian folk",
    popularity: "46",
  },
  {
    name: "Justice Toch",
    image: "https://i.scdn.co/image/7ee3a1d0765748e4645e1bdd2b32a92c13e78274",
    spotify: "3B4UCLYCwiQTr6bmtpGnIa",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "46",
  },
  {
    name: "Kill Paris",
    image: "https://i.scdn.co/image/ee5f48c16aa6fa43641de2449297d9c9be2ecb87",
    spotify: "6BNaPZdAIZAJnbgJRiZz2w",
    genre:
      "brostep,catstep,chillstep,complextro,edm,electro house,electronic trap,filthstep,future bass,pop edm,vapor twitch",
    popularity: "46",
  },
  {
    name: "GANZ",
    image: "https://i.scdn.co/image/5104854b62d5b0af927fa4f8b48fe8c51dd51670",
    spotify: "6sUbCA1obWzdoJ1FM3I9Ks",
    genre: "electronic trap,vapor twitch",
    popularity: "46",
  },
  {
    name: "Grandtheft",
    image: "https://i.scdn.co/image/5a7b02e3da492d1b2a612396da324fb97cce8ebf",
    spotify: "4R0EwsTKt1LIFcdezmuezM",
    genre: "bass trap,electronic trap",
    popularity: "46",
  },
  {
    name: "Niklas Ibach",
    image: "https://i.scdn.co/image/17707166bcbe2f026038a8658a1ff89f74e808f5",
    spotify: "2LyxhWXFqUt5Zbe0KSW38j",
    genre: "german dance",
    popularity: "46",
  },
  {
    name: "Jorn Van Deynhoven",
    image: "https://i.scdn.co/image/92e61600a694fb1205af8edaf67755753b118ac8",
    spotify: "6NuXlqTU1RF0aIoyD46z5v",
    genre:
      "progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "46",
  },
  {
    name: "Elvenking",
    image: "https://i.scdn.co/image/fea03b617083289dcb5d699ac4dd06795f5fa1b2",
    spotify: "09b5OcuIELTdD7FfzQzcdB",
    genre:
      "folk metal,italian folk metal,italian metal,italian power metal,melodic metal,neo classical metal,power metal,progressive metal,speed metal,tolkien metal",
    popularity: "46",
  },
  {
    name: "Ye Banished Privateers",
    image: "https://i.scdn.co/image/168f271c21ee23dae1f1633dbfe50fb6fc3d72c5",
    spotify: "16f8bHHqNwQWgqWMYyS9ij",
    genre: "pirate",
    popularity: "46",
  },
  {
    name: "David Ramirez",
    image: "https://i.scdn.co/image/d3f4b32fdbe9d450c4d409e19319f3e5987c411c",
    spotify: "4MBIFx8pthemIVuEJSgAxb",
    genre:
      "acoustic pop,austin americana,deep new americana,indie folk,new americana,stomp and holler",
    popularity: "46",
  },
  {
    name: "Ellen Allien",
    image: "https://i.scdn.co/image/a1d56516f9ccfe42b57f3f1d13e38b93463ff8b7",
    spotify: "5lsC3H1vh9YSRQckyGv0Up",
    genre:
      "electra,electroclash,electronica,german techno,microhouse,minimal techno,tech house",
    popularity: "46",
  },
  {
    name: "Blind Channel",
    image: "https://i.scdn.co/image/99ff63e0299ffe1faa62d90056f6ca59aa2f3443",
    spotify: "3L58J6a7f0jyy2p6f3MSAs",
    genre: "finnish metal,gymcore,oulu metal,post-screamo,trancecore",
    popularity: "46",
  },
  {
    name: "Delta Spirit",
    image: "https://i.scdn.co/image/181ad27ecc853644cb642cf9c265eb02a670f8ce",
    spotify: "1xVWSPiw5B0OduIC0DSu3V",
    genre: "indie folk,indie rock,modern folk rock,piano rock,stomp and holler",
    popularity: "46",
  },
  {
    name: "Gentlemens Club",
    image: "https://i.scdn.co/image/6e213f62bea0082af8f16ed26a8e4c7208f528e1",
    spotify: "58MEqEE2029jp6KTWTt1hO",
    genre: "brostep,electro house,electronic trap,zapstep",
    popularity: "46",
  },
  {
    name: "Fossa Beats",
    image: "https://i.scdn.co/image/898489e8fccf0b8994d1e652e17727f77800bfc0",
    spotify: "2J7Bw3q4TQwPwSjNPmASKt",
    genre: "",
    popularity: "46",
  },
  {
    name: "Agnostic Front",
    image: "https://i.scdn.co/image/b93108c1275ae6b8a959f7b38dd24224a6c9e0cc",
    spotify: "3zDvanHxaETiHltPkKKYhT",
    genre:
      "chicano punk,crossover thrash,hardcore,hardcore punk,nyhc,old school thrash,punk,straight edge",
    popularity: "46",
  },
  {
    name: "The Protomen",
    image: "https://i.scdn.co/image/c26a9afebe4fefcea8dae9854090e66e8d2ed44b",
    spotify: "2rVDi66o7gdeUq1OHUzM0W",
    genre: "comic,nightrun",
    popularity: "46",
  },
  {
    name: "Scott Stapp",
    image: "https://i.scdn.co/image/9ba080566a5231f2af388eb8c8ffb81237008344",
    spotify: "6HySSUk2KthFj3bd9R61ql",
    genre: "alternative metal,post-grunge",
    popularity: "46",
  },
  {
    name: "Christian Steiffen",
    image: "https://i.scdn.co/image/3d1107b0d705d6b7352915aebb5c79b9ae75b706",
    spotify: "1N95fid08AC5KUQrkuaikD",
    genre: "",
    popularity: "46",
  },
  {
    name: "Lisa Stokke",
    image: "https://i.scdn.co/image/ab67616d0000b273391318f773c1d998a7d09109",
    spotify: "0DyCLBI4KZ9ouXQRBFvHL2",
    genre: "hollywood",
    popularity: "46",
  },
  {
    name: "Ray Fuego",
    image: "https://i.scdn.co/image/f89269e1e0ade48fde901c155280220496b9200a",
    spotify: "3UYgneqZCePK5PhrHE8E9U",
    genre: "dutch hip hop",
    popularity: "46",
  },
  {
    name: "Black Sun Empire",
    image: "https://i.scdn.co/image/fc1e59f51d25fa792d9d6f16cb0d254bfffae2ec",
    spotify: "3PAXvY08KxX5HmCsmKw4x8",
    genre: "darkstep,drill and bass,drum and bass,dutch dnb,neurofunk",
    popularity: "46",
  },
  {
    name: "GAIA",
    image: "https://i.scdn.co/image/4899925ee743da174057f15909100756b873df11",
    spotify: "3Jkc5q9qBSNOTf3IvAyJW9",
    genre: "progressive house,trance,uplifting trance",
    popularity: "46",
  },
  {
    name: "Pusher",
    image: "https://i.scdn.co/image/94a428237fe25e5b4c0b1fdd6558eeebb9c10042",
    spotify: "2exudSjTjUksRJhnF5JZYn",
    genre: "kawaii future bass",
    popularity: "46",
  },
  {
    name: "Témé Tan",
    image: "https://i.scdn.co/image/e0886f469850be8d7fa8dbb3e202362597766feb",
    spotify: "257G4gJ7XVp8Ec8TrjGyMW",
    genre: "belgian pop",
    popularity: "46",
  },
  {
    name: "Princess Chelsea",
    image: "https://i.scdn.co/image/8823583f3135bac616d2672d7e6e06471318b6ab",
    spotify: "6SrA4711bML5NvPO13Tr6t",
    genre: "auckland indie,baroque pop,nz pop",
    popularity: "46",
  },
  {
    name: "Jam Baxter",
    image: "https://i.scdn.co/image/1d03905bd672bf19a7acb712933ca90bd4599281",
    spotify: "6ST2sHlQoWYjxkIVnuW2mr",
    genre: "uk alternative hip hop,uk hip hop",
    popularity: "46",
  },
  {
    name: "Way Out West",
    image: "https://i.scdn.co/image/4013ae434f886f2ae91c7df6831b00030055cf6b",
    spotify: "3HghjRl8Mo6OJWG0WElY2z",
    genre:
      "classic progressive house,nu skool breaks,progressive house,progressive trance house,tech house,trance",
    popularity: "46",
  },
  {
    name: "Anna Lunoe",
    image: "https://i.scdn.co/image/36f55c90c841ac0cdc103122e663830d1c2ffde3",
    spotify: "7d96RW5Vix23AiCHr3mf3D",
    genre: "bass house,electra,nu disco",
    popularity: "46",
  },
  {
    name: "Kurt Elling",
    image: "https://i.scdn.co/image/f5b0712364f67440d842a88ec122e7cc81021217",
    spotify: "1UhC1mCcd9SFXLibHhMX61",
    genre: "adult standards,contemporary vocal jazz,vocal jazz",
    popularity: "46",
  },
  {
    name: "La Yegros",
    image: "https://i.scdn.co/image/0bf54f4ee9494591d18cc81bb4bb49692e553403",
    spotify: "4TkLUhcEmk9Wod6RcEVAi7",
    genre: "chicha,nu-cumbia,nuevo folklore argentino",
    popularity: "46",
  },
  {
    name: "Novastar",
    image: "https://i.scdn.co/image/d4170da0fbcd6d1856eec0dbe7e8f570498c11dc",
    spotify: "3r2qdoM2Ryp8aBb3S3qIG1",
    genre: "belgian rock,dutch indie,dutch pop,dutch rock",
    popularity: "46",
  },
  {
    name: "Teddy Cream",
    image: "https://i.scdn.co/image/a915bdcc9925c2bc69fcfb20e70c5e179cc3414d",
    spotify: "5piMnm6faQpIVYaFfaZSKf",
    genre: "",
    popularity: "46",
  },
  {
    name: "Mudhoney",
    image: "https://i.scdn.co/image/4c1857b80a12ed9eaddf024c823d533c4092a93b",
    spotify: "7LuYiSXiWs86rwWJjEEgB9",
    genre: "alternative rock,grunge,post-grunge,post-hardcore,punk",
    popularity: "46",
  },
  {
    name: "tyDi",
    image: "https://i.scdn.co/image/f1c9f0d38c81d7c4eee4f55250cfe9bf9c9ae5ee",
    spotify: "7tOUuyCplrFWLXCZuhE3C4",
    genre: "australian dance,progressive house,trance,uplifting trance",
    popularity: "46",
  },
  {
    name: "Caspian",
    image: "https://i.scdn.co/image/47f8096d41586c6fe8a906c3b6c73e09385992db",
    spotify: "4SXj7TVoA3bgfR8AVssACa",
    genre:
      "american post-rock,boston rock,compositional ambient,instrumental post-rock,post-rock",
    popularity: "46",
  },
  {
    name: "Molly Tuttle",
    image: "https://i.scdn.co/image/3cdd3163ce1dbfe42d4485366e93c80f66b0a6a2",
    spotify: "4LX0KCPnH7gvxEbVXqXmAE",
    genre: "new americana",
    popularity: "46",
  },
  {
    name: "Adept",
    image: "https://i.scdn.co/image/824f555115d912a7422ca54395ce7729c78ffa07",
    spotify: "1TsgX8DlUvpk9mrUqxmOZu",
    genre: "melodic metalcore,metalcore,screamo,swedish metalcore",
    popularity: "46",
  },
  {
    name: "Buku",
    image: "https://i.scdn.co/image/48023b4c711b8b87ed9283e688c6ade9b7abd38f",
    spotify: "0w2QFhEnPG6tLIvkogHbUi",
    genre: "bass trap,brostep,electronic trap,zapstep",
    popularity: "46",
  },
  {
    name: "At The Gates",
    image: "https://i.scdn.co/image/de3a0d6ea14ca80297d873b0db4bc37f9e477274",
    spotify: "6YXarbjg36ODFPez0PnOlD",
    genre:
      "death metal,gothenburg metal,melodic death metal,metal,swedish death metal,swedish metal",
    popularity: "46",
  },
  {
    name: "David Keenan",
    image: "https://i.scdn.co/image/344f51bb586211a2f1e65fe0d88079214ae74bc8",
    spotify: "4RhFWLvAR5H5uXvjWVmxMG",
    genre: "indie folk,irish singer-songwriter",
    popularity: "46",
  },
  {
    name: "Pan-Pot",
    image: "https://i.scdn.co/image/5d82fcf49a06db0414854ba84a425c947582a1ad",
    spotify: "6OQOvP7RAdmAKVXXQqD0Se",
    genre:
      "german techno,microhouse,minimal techno,raw techno,tech house,techno",
    popularity: "45",
  },
  {
    name: "Klangkuenstler",
    image: "https://i.scdn.co/image/c83922ff121e35542ac183f1ba591465c67b4e69",
    spotify: "6H77vD9YyhyxHBTkRpbMBk",
    genre: "dark techno,deep euro house,hard techno,raw techno,tech house",
    popularity: "45",
  },
  {
    name: "Sébastien Léger",
    image: "https://i.scdn.co/image/7ad43d0e674c7b6ac4b7cc71533a997ce5774255",
    spotify: "17j0kFtqn9Fss3D916jSlp",
    genre: "organic house,tech house",
    popularity: "45",
  },
  {
    name: "Cuartero",
    image: "https://i.scdn.co/image/a14005e1a561fe51177393773b358dddf09e7aeb",
    spotify: "3k9XSew0mrAQytiYyIXf18",
    genre: "deep tech house,latin tech house",
    popularity: "45",
  },
  {
    name: "Ann Clue",
    image: "https://i.scdn.co/image/837b5dcb48c5508eef667ee1e78f07a8c866fb11",
    spotify: "5fasubnSIOTRYlIZA17ong",
    genre: "minimal techno",
    popularity: "45",
  },
  {
    name: "LOVRA",
    image: "https://i.scdn.co/image/923161cfcc6e269e6c78eee6e3f2ac595c1e6e4f",
    spotify: "4fIPBdK4awAR1W14u3v1J5",
    genre: "german dance",
    popularity: "45",
  },
  {
    name: "Jeremy Olander",
    image: "https://i.scdn.co/image/177717cc55c59f7f789932f19bd7f5c0d3e0b4e9",
    spotify: "5vdjF79d5d2m12FOkJhxHB",
    genre:
      "organic house,progressive electro house,progressive house,swedish electronic,tech house",
    popularity: "45",
  },
  {
    name: "Marie Davidson",
    image: "https://i.scdn.co/image/181e7f89a4707a0b2028066109d46e18fef911e8",
    spotify: "7xJVICbAWizNBKBD3mRWjF",
    genre: "canadian electronic,electra",
    popularity: "45",
  },
  {
    name: "Artistic Raw",
    image: "https://i.scdn.co/image/4d57baf527862f82bf802689cab46574b2d93a47",
    spotify: "2bPh6UXbS7wZ7tyN35kFEG",
    genre: "dutch house",
    popularity: "45",
  },
  {
    name: "Captain Hook",
    image: "https://i.scdn.co/image/41eefc19bd2a09f232fc88a3f6dffa32f4ff459d",
    spotify: "5xnZNDl118VvPTvthujxpx",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "45",
  },
  {
    name: "Nic Fanciulli",
    image: "https://i.scdn.co/image/2dfa0a2300e1886d95c042b2f0d5a35d3861ec27",
    spotify: "7btR5VXutQv39SDEzcfXEk",
    genre: "funky tech house,house,minimal techno,tech house,tribal house",
    popularity: "45",
  },
  {
    name: "Emil Landman",
    image: "https://i.scdn.co/image/464da22631e9c504f9b3f0fd01b1183bc27a059e",
    spotify: "0TaelSp6OIZw6mzikDmDrB",
    genre: "dutch indie,folk-pop",
    popularity: "45",
  },
  {
    name: "Miguel Campbell",
    image: "https://i.scdn.co/image/90e3b81fe1dd5770a5f56bc24245fbcee6d0ab1d",
    spotify: "4uZJDUKi3NXQsuMKP3rOeC",
    genre: "deep disco house",
    popularity: "45",
  },
  {
    name: "Vato Gonzalez",
    image: "https://i.scdn.co/image/52c0d032450846946007e8afbf0b2e3ba44a2e82",
    spotify: "4mDTB962RcRuArrhQazgOG",
    genre: "dutch house,electro house",
    popularity: "45",
  },
  {
    name: "Carta",
    image: "https://i.scdn.co/image/cb36542f2f594dc71966e7b16faccc1215dd70f0",
    spotify: "3MTk6MUbUmV5X0N04N56JF",
    genre: "deep big room,electro house,sky room",
    popularity: "45",
  },
  {
    name: "Wishbone Ash",
    image: "https://i.scdn.co/image/ab6772690000c46c541691c5deff70c190f9a7c9",
    spotify: "77zwstbi3x1IxnbDFg6uns",
    genre:
      "album rock,art rock,blues rock,british blues,classic rock,hard rock,progressive rock,psychedelic rock,rock,symphonic rock",
    popularity: "45",
  },
  {
    name: "Demuja",
    image: "https://i.scdn.co/image/2d73adcf7a85c1955d5e5d5cf20e042906dace50",
    spotify: "1LfqhJiCiHfVzrBOVaBXc1",
    genre: "deep house,float house,lo-fi house",
    popularity: "45",
  },
  {
    name: "Calyx & TeeBee",
    image: "https://i.scdn.co/image/d0c25c75cdb0e0206d27a80c2e173c7787217253",
    spotify: "5AXHArSOd9lplw0Y5Qt5Eg",
    genre: "drum and bass,jump up,liquid funk,neurofunk",
    popularity: "45",
  },
  {
    name: "Gabriel Ananda",
    image: "https://i.scdn.co/image/84bf99fe6293cd803f1486613650f97ce644aa46",
    spotify: "3YpEUCjdLuPmBspkmoPYnX",
    genre: "german house,german techno,minimal techno,tech house",
    popularity: "45",
  },
  {
    name: "Lera Lynn",
    image: "https://i.scdn.co/image/8a65688c7a382534052f3a8d6efdde436a4ba4ed",
    spotify: "2iul6etLF5hjjpxo43rzz7",
    genre: "alternative country,new americana",
    popularity: "45",
  },
  {
    name: "Gidge",
    image: "https://i.scdn.co/image/7c4e6c37a2b75e62641d05d888e60d6bfec9bb6e",
    spotify: "7aibxFH8hIlSUlXgshCgAP",
    genre: "electronica,italian electronica",
    popularity: "45",
  },
  {
    name: "Arno Cost",
    image: "https://i.scdn.co/image/8aa93f542332ac293eb1e8d94259b1616dac7664",
    spotify: "0BMhfbeiOrNMBzjELzbyNg",
    genre:
      "big room,disco house,edm,electro house,progressive electro house,progressive house,tech house",
    popularity: "45",
  },
  {
    name: "The Allergies",
    image: "https://i.scdn.co/image/8c5d260a6c8c1fe3776ad343f7b75fad555ac2b2",
    spotify: "2v2cdjqYIpT8ZBpflNTttY",
    genre: "bboy,big beat",
    popularity: "45",
  },
  {
    name: "Cari Cari",
    image: "https://i.scdn.co/image/d3872439297e87c8296bfc2814b39c8fa95c4ff1",
    spotify: "0ey6crPk5fXQWkq21iPTMV",
    genre: "austrian pop,swiss indie",
    popularity: "45",
  },
  {
    name: "Jonathan Bree",
    image: "https://i.scdn.co/image/46e70a1ba4c224a2a9791935669892d42f65cd02",
    spotify: "2IlTe9Gm5w5qrt2kKdOvAh",
    genre: "nz indie",
    popularity: "45",
  },
  {
    name: "Monxx",
    image: "https://i.scdn.co/image/5b22048fc41e52b5d44121a1ae5c36a3ff4032c4",
    spotify: "2FJC1Wce3SiCCbIoYwVWq0",
    genre: "brostep,electro house,zapstep",
    popularity: "45",
  },
  {
    name: "Qrion",
    image: "https://i.scdn.co/image/db57aa4560f0252d8f5f388c320d24dc91b26564",
    spotify: "0bGDTQ78MVgI5Snqo9KJZw",
    genre: "progressive house",
    popularity: "45",
  },
  {
    name: "Akwasi",
    image: "https://i.scdn.co/image/d8ab6de5a5507486b1238c567b6e27f41283cdb8",
    spotify: "31REX4WGmuDvtihynSCvly",
    genre: "dutch hip hop,dutch pop",
    popularity: "45",
  },
  {
    name: "After Party",
    image: "https://i.scdn.co/image/ab67616d0000b273b11910c3de0fb23f8c5b9282",
    spotify: "16IE8lpWA2U3bfB4kumGzW",
    genre: "disco polo",
    popularity: "45",
  },
  {
    name: "Deez Nuts",
    image: "https://i.scdn.co/image/e96e580af59877d767209ea3404e5e83c1e0ec1a",
    spotify: "2w0Dmj9GV9ZrokNRcnRwav",
    genre: "melodic hardcore,melodic metalcore",
    popularity: "45",
  },
  {
    name: "Charmes",
    image: "https://i.scdn.co/image/39f4f4c4325203e3e7dfaff91e3135d5f7dffcba",
    spotify: "3Lat1XFXy1jjal8bckU6ZQ",
    genre: "dutch house,electro house",
    popularity: "45",
  },
  {
    name: "Sam Gellaitry",
    image: "https://i.scdn.co/image/ab67616d0000b273abf60462d2c407dace25c303",
    spotify: "07UJz804RJxqNvxFXC3h9H",
    genre: "electronic trap,future bass,scottish electronic,vapor twitch",
    popularity: "45",
  },
  {
    name: "Seth Hills",
    image: "https://i.scdn.co/image/0a8105df0cd8cab110baca5595ddf4636c7dc85e",
    spotify: "5nFt7a5Du2MkdAr1KniXh7",
    genre: "big room,deep big room,electro house,sky room",
    popularity: "45",
  },
  {
    name: "Johnny Osbourne",
    image: "https://i.scdn.co/image/ab67616d0000b27325ac698ce6a2340c6c755350",
    spotify: "5TUTGRG0FlRoYTZ4GEdOVO",
    genre:
      "dub,lovers rock,old school dancehall,reggae,rock steady,roots reggae,ska",
    popularity: "45",
  },
  {
    name: "Enno Bunger",
    image: "https://i.scdn.co/image/65133a979f328dfb3345c523bd4e0a69ecd43c23",
    spotify: "0aiAgFPJcZggIkSUGDFdkD",
    genre:
      "german indie,german indie folk,german pop,german rock,german singer-songwriter",
    popularity: "45",
  },
  {
    name: "Death Angel",
    image: "https://i.scdn.co/image/608e65dbf9493194abfccff4ee0dced13fe6bdf7",
    spotify: "6KVc8Llznru8n9LVCYe9dz",
    genre: "death metal,hard rock,metal,old school thrash,thrash metal",
    popularity: "45",
  },
  {
    name: "Ignite",
    image: "https://i.scdn.co/image/08dd5a443691c9eabccf9af40ba6cba899c129be",
    spotify: "48ErVeccMDF5UiHA4TdGWr",
    genre: "hardcore,melodic hardcore,punk,skate punk",
    popularity: "45",
  },
  {
    name: "Firelite",
    image: "https://i.scdn.co/image/c7d3ced97dbd837a917b274c86e1943cef53bb44",
    spotify: "7FTQICqfx93tZdwZJb3wt2",
    genre: "euphoric hardstyle,hardstyle",
    popularity: "45",
  },
  {
    name: "Buzz Low",
    image: "https://i.scdn.co/image/0de27cb09fbff961e85cdc5af431ae9f3919cbe9",
    spotify: "0tytC9SBvhGJFUA0MPHucY",
    genre: "",
    popularity: "45",
  },
  {
    name: "Axel Boman",
    image: "https://i.scdn.co/image/b705e4ce1f4cce2d04d726a87d220a4456514414",
    spotify: "59qo8jHDlC1i30HVjQQW3O",
    genre:
      "balearic,deep disco house,deep house,deep soul house,electronica,float house,microhouse,minimal tech house,minimal techno,swedish electronic,swedish house,tech house",
    popularity: "45",
  },
  {
    name: "Novelists FR",
    image: "https://i.scdn.co/image/a82c16059f38e8ebf4d7ff32be7d967fff40be63",
    spotify: "6o8sDniHcZPM1SixvjKiYS",
    genre: "metalcore",
    popularity: "45",
  },
  {
    name: "Nina June",
    image: "https://i.scdn.co/image/dde51393c5cd5f658a3256fa24bfbd4e87c1bb12",
    spotify: "1YyIIzRWYsa0kIJpqoSTRZ",
    genre: "dutch pop,dutch singer-songwriter",
    popularity: "45",
  },
  {
    name: "Eva Lazarus",
    image: "https://i.scdn.co/image/b62d0bd0d74cafd66715728e051545bdc7c36346",
    spotify: "68eE2HHE6By6hOsOcsArcp",
    genre: "",
    popularity: "45",
  },
  {
    name: "Wally Lopez",
    image: "https://i.scdn.co/image/7e523f3554445af5feaacf2d2cfa2cce102318bf",
    spotify: "52qx8aMzSqi7JTJUI2dJqZ",
    genre: "electro latino,tribal house",
    popularity: "45",
  },
  {
    name: "Madball",
    image: "https://i.scdn.co/image/ab6772690000c46cc16fe88dbe1d072483b5802d",
    spotify: "1qh6ppVtiFTKMyta0NXsjf",
    genre: "hardcore,nyhc,straight edge",
    popularity: "45",
  },
  {
    name: "Amyl and The Sniffers",
    image: "https://i.scdn.co/image/b8cbdd31297c2995ddb6db28fb279bb6d70defd6",
    spotify: "3NqV2DJoAWsjl787bWaHW7",
    genre: "australian garage punk",
    popularity: "45",
  },
  {
    name: "Stepherd",
    image: "https://i.scdn.co/image/715cae042508ed0c0605d37600311e7f0533b951",
    spotify: "7pryKhNYemTWyd5gtHL1yf",
    genre: "dutch hip hop",
    popularity: "45",
  },
  {
    name: "Songhoy Blues",
    image: "https://i.scdn.co/image/260f65b8ab96dcac7af8381b22514071756f6dc8",
    spotify: "5fpQ5Qt2BKgoVBSMw4Z17Z",
    genre: "afropop,malian blues,world",
    popularity: "45",
  },
  {
    name: "No Mana",
    image: "https://i.scdn.co/image/6dcd01cb3f559d0e0b6b0522baee0d430fd8a3a5",
    spotify: "20yuGdfbRkW0HH3OfG1Nkg",
    genre: "complextro,edm,electro house,progressive house",
    popularity: "45",
  },
  {
    name: "NanowaR of Steel",
    image: "https://i.scdn.co/image/e5a48748077e450fe2e71c5b7afbc40ce93f7d28",
    spotify: "7jw9vF1hFRp1k8dDRNRiC5",
    genre: "comic metal,italian metal,power metal",
    popularity: "45",
  },
  {
    name: "Wooden Shjips",
    image: "https://i.scdn.co/image/645dd20fa063e9c8977c56c5835e28d98d930305",
    spotify: "35rFgnhlSSYflP4HpC3JM0",
    genre:
      "chamber psych,freak folk,neo-psychedelic,nu gaze,psychedelic space rock,space rock",
    popularity: "45",
  },
  {
    name: "Mind Against",
    image: "https://i.scdn.co/image/745b86aafdf86fee317330321cb28f8e7b7874d6",
    spotify: "48LWLoeY0dhwaiX1FRsn72",
    genre: "deep techno,italian techno,melodic techno",
    popularity: "45",
  },
  {
    name: "Bishu",
    image: "https://i.scdn.co/image/ae2a459cc065b41c85b4826e531ab6bb05346bd7",
    spotify: "1DzQInbDVhE9Lh5s6T0DUL",
    genre: "bass trap,catstep,electro house,pop edm,traprun",
    popularity: "45",
  },
  {
    name: "Mosimann",
    image: "https://i.scdn.co/image/2c528279ec89c43b15770028e5142554c0702582",
    spotify: "7sAqpkrQBaOkddsv1Tz1XK",
    genre: "french pop",
    popularity: "45",
  },
  {
    name: "Madison McFerrin",
    image: "https://i.scdn.co/image/9741ec7ead3f6ef2732df3dc25ad08640e03eb6e",
    spotify: "02zPEtdzUWnPToEVLRiQ7e",
    genre: "a cappella,alternative r&b,indie jazz,indie r&b,indie soul,neo r&b",
    popularity: "45",
  },
  {
    name: "The Herbaliser",
    image: "https://i.scdn.co/image/f59e928ec9b7373ffab12c8cbf762257126cf7f7",
    spotify: "1O7aMVbDeSXY2LiVBhb13w",
    genre: "big beat,downtempo,electronica,ninja,nu jazz,trip hop,turntablism",
    popularity: "45",
  },
  {
    name: "Jakuzi",
    image: "https://i.scdn.co/image/e73a7c8fcfcd0b569a60eee6174c78acf6fc49e2",
    spotify: "0xeyL5pfnTtx7LGpqLo4PG",
    genre: "turkish alternative rock",
    popularity: "45",
  },
  {
    name: "Stimming",
    image: "https://i.scdn.co/image/50945cece3a52be37c781961baf57ea8a5af6b72",
    spotify: "2yPveJtn9DpeN0CgNJHvAQ",
    genre:
      "electronica,german techno,hamburg electronic,microhouse,minimal tech house,minimal techno,organic house,tech house",
    popularity: "45",
  },
  {
    name: "Joshua Aaron",
    image: "https://i.scdn.co/image/64c7e3866630f09f3ae3cd6f39c5895dbb1de829",
    spotify: "7hR5qFME3Zu6i775XdrKEv",
    genre: "messianic praise",
    popularity: "45",
  },
  {
    name: "Andy McKee",
    image: "https://i.scdn.co/image/41cd652aacc0204dae3ce8cb01e54c5aaf188485",
    spotify: "59T0qdTmDGZ1g0slfSbPfy",
    genre: "fingerstyle,instrumental bluegrass",
    popularity: "45",
  },
  {
    name: "L.A. Salami",
    image: "https://i.scdn.co/image/423fb3c2cb070819ca60b9b524694cbb74a9ad02",
    spotify: "23HG5wQ67P2pMksEMTbkur",
    genre: "london indie",
    popularity: "45",
  },
  {
    name: "Reija Lee",
    image: "https://i.scdn.co/image/cf20fac81b61a76655501bb12726857d91953ff0",
    spotify: "19Lu0quNl0YH77llcXOiDB",
    genre: "",
    popularity: "45",
  },
  {
    name: "Rampue",
    image: "https://i.scdn.co/image/3a9baef79e8eb1287c745928aac129de9e3dd562",
    spotify: "3YRLUjgMJ1xg1TIcknIxlv",
    genre:
      "elektropunk,german house,german indie,organic electronic,organic house",
    popularity: "45",
  },
  {
    name: "SNFU",
    image: "https://i.scdn.co/image/b909d7fa69ded6fdc0248ef07a1f8d0c7c3583f6",
    spotify: "47gDsI3zhRtZPGK7Hv3uxm",
    genre:
      "canadian hardcore,canadian punk,hardcore punk,melodic hardcore,punk,skate punk,vancouver punk",
    popularity: "45",
  },
  {
    name: "Warkings",
    image: "https://i.scdn.co/image/f876fb40b43a48969b0ef4fec39d343702b1bd9e",
    spotify: "7DXUeaMULtMVFmmaKFzH3E",
    genre: "melodic metal",
    popularity: "45",
  },
  {
    name: "ATLiens",
    image: "https://i.scdn.co/image/223ae90a0ccbc8754cf585856d08435577a400e0",
    spotify: "74RET4rCZPTGzhsLjD0i3g",
    genre: "brostep,electro house,electronic trap,zapstep",
    popularity: "45",
  },
  {
    name: "Martin Jondo",
    image: "https://i.scdn.co/image/da2baeb46ca3da832a74a762b0541d9085ae7920",
    spotify: "0rjQs0BXlxtEniNqvD3zNQ",
    genre: "german reggae",
    popularity: "45",
  },
  {
    name: "Steve Hackett",
    image: "https://i.scdn.co/image/d1f34085572168dd28905da9de83180e7bdf59de",
    spotify: "4vs7NIU7kZc2Efh6yOGKEZ",
    genre:
      "album rock,art rock,canterbury scene,instrumental rock,jazz fusion,neo-progressive,progressive rock,symphonic rock",
    popularity: "45",
  },
  {
    name: "Coals",
    image: "https://i.scdn.co/image/d8ae0f5420bd193f90de7c30860c705081532243",
    spotify: "6epDO0nPVXpbXBUt4Otiik",
    genre: "polish alternative,polish electronica",
    popularity: "45",
  },
  {
    name: "Talla 2XLC",
    image: "https://i.scdn.co/image/b13d1f9b177f05ed0bc639552bdd4e19bd5bff67",
    spotify: "4cc7cII4mEQqKtczWKQVjJ",
    genre:
      "bubble trance,frankfurt electronic,german techno,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "45",
  },
  {
    name: "Spyro Gyra",
    image: "https://i.scdn.co/image/6dc18b2eeed3ef659d287b7d3fb03f1bad940044",
    spotify: "1Be36RHAlqJpfUt3tsmUQD",
    genre: "jazz funk,jazz fusion,progressive jazz fusion,smooth jazz",
    popularity: "45",
  },
  {
    name: "Yves Berendse",
    image: "https://i.scdn.co/image/4e57a245ed5a1de93fc569897b4fdf0f3c81e7d1",
    spotify: "7wGBPJk6sHwRCozFfhU09F",
    genre: "carnaval,dutch pop",
    popularity: "45",
  },
  {
    name: "Marco V",
    image: "https://i.scdn.co/image/a8b18ec80386ef23324152ed0b28df4620b06f75",
    spotify: "24xpaWFyBOwoB8lBBolWzv",
    genre:
      "bubble trance,dutch trance,progressive house,trance,uplifting trance",
    popularity: "44",
  },
  {
    name: "Dubfire",
    image: "https://i.scdn.co/image/2c3d66c0bb6499f1766528d780746a1e4ed6b973",
    spotify: "3bVYqr2NfmwmL4YJisWhJI",
    genre: "deep minimal techno,minimal techno,tech house",
    popularity: "44",
  },
  {
    name: "Roni Size",
    image: "https://i.scdn.co/image/a2a3a76aa238ba704f45d5ce1261b198d0b03626",
    spotify: "5UjqeSp9dX6Nrge7WdDukr",
    genre:
      "big beat,breakbeat,drum and bass,electronica,hardcore techno,jungle,liquid funk",
    popularity: "44",
  },
  {
    name: "Nafthaly Ramona",
    image: "https://i.scdn.co/image/f0067496883b9c821d95a9b9779d196ad1dd6f46",
    spotify: "7LSenG6ZaZyQGNNQSIRNTf",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "44",
  },
  {
    name: "Destructive Tendencies",
    image: "https://i.scdn.co/image/6c5f59e45e874184dd8a56f2835734e5ce575659",
    spotify: "1Yc03TvBp08WN2oHVuvewX",
    genre:
      "frenchcore,gabba,happy hardcore,hardcore techno,rawstyle,uptempo hardcore",
    popularity: "44",
  },
  {
    name: "Nubya Garcia",
    image: "https://i.scdn.co/image/59365f5bef7135bb32d9f7a23add29d9de6654bb",
    spotify: "6O5k8LLRfDK8v9jj1GazAQ",
    genre: "british jazz,indie jazz,uk contemporary jazz",
    popularity: "44",
  },
  {
    name: "Chus & Ceballos",
    image: "https://i.scdn.co/image/0c191283f5c9f065b5712e9076d49e484d4d216f",
    spotify: "3yjqxf3d3aCOFrrsxIl326",
    genre:
      "funky tech house,house,latin tech house,tech house,tribal house,vocal house",
    popularity: "44",
  },
  {
    name: "Michael Prins",
    image: "https://i.scdn.co/image/5ca785e98beaa65d7fa1a4e296ad063924b510f7",
    spotify: "02uBraNVAgl8ue5bG8B87m",
    genre: "dutch americana,dutch pop,dutch singer-songwriter",
    popularity: "44",
  },
  {
    name: "Alessandro Cortini",
    image: "https://i.scdn.co/image/00637647275ed987be694e4d684b8dd5f2ac5fe7",
    spotify: "6cGVZq9WhCCRkTnn4cJYOg",
    genre:
      "ambient,drone,italian experimental,italian occult psychedelia,modular synth",
    popularity: "44",
  },
  {
    name: "Dylan LeBlanc",
    image: "https://i.scdn.co/image/35e5dfdf36f3710d0b9e0a41401852787f789433",
    spotify: "60rNO7ymhlxcYxrdkDYq1k",
    genre: "modern folk rock,new americana",
    popularity: "44",
  },
  {
    name: "Bombino",
    image: "https://i.scdn.co/image/0364b6935c4305e73bbe2ced2995cb6032dbb7f7",
    spotify: "7s4I6rDvTcdBDKElVbtsAN",
    genre: "afropop,desert blues,tuareg guitar,world",
    popularity: "44",
  },
  {
    name: "Prok & Fitch",
    image: "https://i.scdn.co/image/8c6ed173306a6fe4cfc105e6e36ab7d035f15fcc",
    spotify: "62akbR2hpk0ArA98zOYNys",
    genre: "funky tech house,house,tech house",
    popularity: "44",
  },
  {
    name: "Akala",
    image: "https://i.scdn.co/image/ab67616d0000b27376a91f022309d9859eb76cf9",
    spotify: "58LTO4K7E3WUtztMK2BCkB",
    genre: "conscious hip hop,grime,political hip hop",
    popularity: "44",
  },
  {
    name: "Da Mouth of Madness",
    image: "https://i.scdn.co/image/52a0f4910d1cb20785b5393ecfb93a5122fa44f6",
    spotify: "3QUpjXKcTee8KscFqpkSfv",
    genre: "",
    popularity: "44",
  },
  {
    name: "Trollphace",
    image: "https://i.scdn.co/image/035841dce5b972ac5d7391dd9400e259bcb9af8d",
    spotify: "0OJ5ViZQUFL6ileg5HvKKy",
    genre: "deathstep",
    popularity: "44",
  },
  {
    name: "Todd Helder",
    image: "https://i.scdn.co/image/75a9049f337480d6b0f29a33f3dc4e53b7a53e93",
    spotify: "6nhsSK9KbToX3Brq0xeWbV",
    genre: "electronic trap",
    popularity: "44",
  },
  {
    name: "Ed Struijlaart",
    image: "https://i.scdn.co/image/a09e602e7b9fe5c96637ea977de2e5da3b746918",
    spotify: "08cpwYrPWo8Xkxl9qdiDP2",
    genre: "dutch singer-songwriter",
    popularity: "44",
  },
  {
    name: "Lee Burridge",
    image: "https://i.scdn.co/image/354e9b71b0471e2bb4c3dbc539d8a5fe15615f3b",
    spotify: "0334oJHhRSKJRHKpE9i62h",
    genre: "organic house,tech house",
    popularity: "44",
  },
  {
    name: "Marino Canal",
    image: "https://i.scdn.co/image/bdb93b8a625d29c7943c049ecbbb8612e6272fd4",
    spotify: "6qdVbTc8Uvy0VJyDZbYTd8",
    genre: "organic house",
    popularity: "44",
  },
  {
    name: "Andrew Combs",
    image: "https://i.scdn.co/image/09fb38316bc6266faa90a144c81351d79575ed8e",
    spotify: "4ONwFcI8RGvYMG1vEIdS11",
    genre: "deep new americana,indie folk,nashville americana,new americana",
    popularity: "44",
  },
  {
    name: "Pablo Fierro",
    image: "https://i.scdn.co/image/1aacdcbdf5982e8fa86af0dd52dd70bcbc1e0fbb",
    spotify: "5N7gp2n04e1TJ6MaKyvrbI",
    genre: "afro house,deep deep house",
    popularity: "44",
  },
  {
    name: "Detlef",
    image: "https://i.scdn.co/image/a4898d60de60d85d7d9003cd129a1621c50db36a",
    spotify: "5lZ8HC92jRDlyeq0vSxGeI",
    genre: "house,latvian pop,tech house",
    popularity: "44",
  },
  {
    name: "Kenn Colt",
    image: "https://i.scdn.co/image/4f772a7f9facfb18ae2b099165e0d4ded2a88698",
    spotify: "0vSNFAo2h20zd3HOBcM8BX",
    genre: "belgian edm",
    popularity: "44",
  },
  {
    name: "SASASAS",
    image: "https://i.scdn.co/image/c893ea455dae14893e91eff189158845693948bb",
    spotify: "7CKAyjXz7Z7se4oGh07mGe",
    genre: "bass house",
    popularity: "44",
  },
  {
    name: "Tenashar",
    image: "https://i.scdn.co/image/46843e9ac438f83e00a3e989474cfa9ef644f31b",
    spotify: "2ni13kSln5vxS0x7v3tJZw",
    genre: "",
    popularity: "44",
  },
  {
    name: "Aslove",
    image: "https://i.scdn.co/image/5e6216cd4b88e77e771ddcf13ad1553cccdc5e7b",
    spotify: "1EnscKRqKyq19bQ2bl642c",
    genre: "deep tropical house,new french touch",
    popularity: "44",
  },
  {
    name: "NWYR",
    image: "https://i.scdn.co/image/de5938d67ef07c823bbea6a53ee727d2ac722fb7",
    spotify: "558dSyN1mMqsKrEBcKJ2p0",
    genre: "big room,deep big room,edm,electro house,progressive house,trance",
    popularity: "44",
  },
  {
    name: "Fischer-Z",
    image: "https://i.scdn.co/image/47c3ee3fa52a9636b7bf2c794d5c8dace11d7c12",
    spotify: "3fRV5Jo7lNKhRSx4C3sLMZ",
    genre: "german rock,new romantic,zolo",
    popularity: "44",
  },
  {
    name: "Dosem",
    image: "https://i.scdn.co/image/f818212b1c3c9afdf0068c76427f53fb66db297c",
    spotify: "0zmnkCTbAxYsZAMIqXEzfS",
    genre:
      "funky tech house,house,latin tech house,minimal techno,organic house,progressive house,spanish techno,tech house",
    popularity: "44",
  },
  {
    name: "Visions of Atlantis",
    image: "https://i.scdn.co/image/05bb1ca78feadd80f78491ec92b54a1e874ac664",
    spotify: "5kanN1nKzrkW1m2gZmo82x",
    genre:
      "austrian metal,gothic metal,gothic symphonic metal,melodic metal,neo classical metal,power metal,progressive metal,slayer,symphonic metal",
    popularity: "44",
  },
  {
    name: "Viken Arman",
    image: "https://i.scdn.co/image/1544f3f2b220f29177a7fd89756db504b2d67e7f",
    spotify: "1xQVwAdSzsF8DO76NsZpMK",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "44",
  },
  {
    name: "Kid Simius",
    image: "https://i.scdn.co/image/9552b40a4fa1a75624278fbb329df9fb2aa0afcc",
    spotify: "36y7VzGBD47ymYb40a7JkE",
    genre: "",
    popularity: "44",
  },
  {
    name: "NATTY",
    image: "https://i.scdn.co/image/ab67616d0000b273a7a9370dd7b4511ca416493d",
    spotify: "1Y3klzPXyHrinIk3tQ20Se",
    genre: "k-pop",
    popularity: "44",
  },
  {
    name: "Frank Wilson",
    image: "https://i.scdn.co/image/ab67616d0000b273bf736763fcf23eb99ce7aff8",
    spotify: "7Emrl5SyjpneJuRdHqBKRN",
    genre: "motown,northern soul",
    popularity: "44",
  },
  {
    name: "Dutch Movement",
    image: "https://i.scdn.co/image/667a82b9697ee90baf168bcfc5f30a0ff7ebc6c2",
    spotify: "5fnGunxiUsH78nYIEAHBiO",
    genre: "nederlandse hardstyle",
    popularity: "44",
  },
  {
    name: "Owl Eyes",
    image: "https://i.scdn.co/image/ef0b7325654af6cfa2bf0129ac1dcf3253adf3fd",
    spotify: "3it7AeHVfXdby9tbwEwE3f",
    genre:
      "australian alternative pop,australian indie,australian pop,shimmer pop",
    popularity: "44",
  },
  {
    name: "Maribelle",
    image: "https://i.scdn.co/image/0504a10ec1823a600f5868987599229e0bb68c47",
    spotify: "21943SyDN6jvPKcwyV5WnN",
    genre: "australian electropop",
    popularity: "44",
  },
  {
    name: "Booze & Glory",
    image: "https://i.scdn.co/image/0d9584c10d97767d0e23822e6631380d2fd0fdbc",
    spotify: "4gVommn6B9vUqdsfSwVaiv",
    genre: "oi",
    popularity: "44",
  },
  {
    name: "Zoey Dollaz",
    image: "https://i.scdn.co/image/e21645719f83a73c8df9a045a3b50c5fd5700295",
    spotify: "39Uhf21aJFjMLus1j0YGT8",
    genre: "miami hip hop",
    popularity: "44",
  },
  {
    name: "LANDMVRKS",
    image: "https://i.scdn.co/image/c2c780b560d5b3d2f6ccb79b0cf95e733eed59a8",
    spotify: "6G43CiunIxMwb2tQ12vNP6",
    genre: "melodic metalcore,metalcore",
    popularity: "44",
  },
  {
    name: "Mary Gauthier",
    image: "https://i.scdn.co/image/41cff44f4c2f2720eac636dee7d1ee288edd5f5f",
    spotify: "4SK1IgkcWWc5HC1TOBq1VS",
    genre: "",
    popularity: "44",
  },
  {
    name: "Andrew Strong",
    image: "https://i.scdn.co/image/ab67616d0000b273c02fb56543e1fcae59d78c45",
    spotify: "7MdthKITrvbzo6v1PG80Te",
    genre: "",
    popularity: "44",
  },
  {
    name: "Nicole Bus",
    image: "https://i.scdn.co/image/1c0727ff33f71cee206d46292b494375028b6cb4",
    spotify: "0IeB4swNmNetlaZUgdHqBX",
    genre: "dutch pop,dutch r&b",
    popularity: "44",
  },
  {
    name: "Acid Arab",
    image: "https://i.scdn.co/image/8c1794d0c7154433de9f6fa82b9b870c2b03e8a1",
    spotify: "3ShO8tPKqXUUpOA0urOWW7",
    genre: "arab electronic,arab groove",
    popularity: "44",
  },
  {
    name: "Chuck Ragan",
    image: "https://i.scdn.co/image/8713d2bd938a9299f4d62e59fd64f1b33d7f26d5",
    spotify: "6iU0naWn1UgiTReoiXqPXI",
    genre: "acoustic punk,folk punk,orgcore",
    popularity: "44",
  },
  {
    name: "Moon Duo",
    image: "https://i.scdn.co/image/1c9671d307de74e6f9f130d4fb7464914df8287d",
    spotify: "4ipKeGoyPCcpEblETS4qLu",
    genre:
      "chamber psych,freak folk,garage psych,neo-kraut,neo-psychedelic,nu gaze,space rock",
    popularity: "44",
  },
  {
    name: "Thomas Azier",
    image: "https://i.scdn.co/image/6c946246c59ea2b9f720e5f3dcd5ad33f056bfb1",
    spotify: "6AE7CSJUwDMnTXV4yKVLLv",
    genre: "dutch indie,dutch pop",
    popularity: "44",
  },
  {
    name: "Mazare",
    image: "https://i.scdn.co/image/d48b66cc7a30e5c87a9740cd556e5d0272c22499",
    spotify: "4yzZdtb9UicgY2M23eEtL9",
    genre: "catstep,electro house",
    popularity: "44",
  },
  {
    name: "Sick Of It All",
    image: "https://i.scdn.co/image/9e42b743ccd2e48b76e38367e254b83f68684d6f",
    spotify: "1Px6nQCyIRM4Gj0tyvZ1TU",
    genre: "hardcore,melodic hardcore,nyhc,punk,skate punk,straight edge",
    popularity: "44",
  },
  {
    name: "Sola Rosa",
    image: "https://i.scdn.co/image/42ce644318c689b86dcc9e6c52dd7ada6414f031",
    spotify: "5IppRAquE7RQdE9YmCKJ52",
    genre: "electronica,nu jazz",
    popularity: "44",
  },
  {
    name: "Vieux Farka Touré",
    image: "https://i.scdn.co/image/c626a401a3a20812b6f3e065af05e745b3497e94",
    spotify: "4PmxbsWP1u0TnvqcrIA9ze",
    genre: "afropop,malian blues,mande pop,world",
    popularity: "44",
  },
  {
    name: "Pablo Bolivar",
    image: "https://i.scdn.co/image/601e73e410de4196cff085925e28a6bf080f7d71",
    spotify: "13NhdveBzN2Yh2elbf1rLs",
    genre:
      "dub techno,microhouse,minimal tech house,minimal techno,organic house,tech house",
    popularity: "44",
  },
  {
    name: "Unearth",
    image: "https://i.scdn.co/image/0f5124ec49fbf5b161aae3bf2caa65e13ba67b46",
    spotify: "44wJRGNtWywCUJZug8FJg3",
    genre: "boston metal,deathcore,melodic metalcore,metalcore,nu metal",
    popularity: "44",
  },
  {
    name: "Sidney Charles",
    image: "https://i.scdn.co/image/a74e88a6f6387b7b960030f5b9dccb5b6e48ed61",
    spotify: "0J6ZEXmLQfZMeHBoa4JZTH",
    genre:
      "deep disco house,deep house,deep tech house,hamburg electronic,house,minimal tech house,minimal techno,tech house",
    popularity: "44",
  },
  {
    name: "Ncrypta",
    image: "https://i.scdn.co/image/91c9566ce9aebdcf3f7845efd51368c3653e70de",
    spotify: "598i9uHpVAukdj6QRUEaq6",
    genre: "hardstyle,rawstyle,uptempo hardcore,xtra raw",
    popularity: "44",
  },
  {
    name: "Xiu Xiu",
    image: "https://i.scdn.co/image/14365e117237348f0a9cff6d302f66a6736e9885",
    spotify: "5JLqvjW3Nyom2OsRUyFsS9",
    genre:
      "alternative rock,anti-folk,art pop,bay area indie,chamber pop,escape room,experimental,experimental pop,experimental rock,freak folk,grave wave,noise pop,slowcore",
    popularity: "44",
  },
  {
    name: "Ciaran McAuley",
    image: "https://i.scdn.co/image/4983da7a88a9f02907ed2d3c4a3f1205908824be",
    spotify: "4tTgD3KLaNlHg2nxAgGaRi",
    genre: "irish electronic,uplifting trance",
    popularity: "44",
  },
  {
    name: "Sara Tavares",
    image: "https://i.scdn.co/image/ab67616d0000b2735aee6e5da96268f78a0f9d8b",
    spotify: "57zZoaRDFEjqRwq6FlT0va",
    genre: "afropop,morna,portuguese pop",
    popularity: "44",
  },
  {
    name: "Frida Gold",
    image: "https://i.scdn.co/image/db6b0e9ebca1e7a4bf2bd38d75a85751a5d4ab50",
    spotify: "1Q229kIsASlkUb3VBeQmIL",
    genre: "german pop",
    popularity: "44",
  },
  {
    name: "Jacob Groening",
    image: "https://i.scdn.co/image/a0cc33c97737de1f217ed0ae03dc9e970b84da17",
    spotify: "4Mlxc3DHm3Qr5XTaEXHT6f",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "44",
  },
  {
    name: "Eyes Set To Kill",
    image: "https://i.scdn.co/image/f3e5fbfd68422fc0fec2a6dd604917ca988c3106",
    spotify: "7omnn7IRrrxdMwSwchVxNP",
    genre: "metalcore,pixie,pop emo,screamo",
    popularity: "44",
  },
  {
    name: "Washington",
    image: "https://i.scdn.co/image/5f527706a0aeed951a8a875aeaa1041b3c3935a0",
    spotify: "5AHMfr68CzfjKxMU7MQAeZ",
    genre: "australian indie",
    popularity: "44",
  },
  {
    name: "Matthew Dear",
    image: "https://i.scdn.co/image/04afe9f4caeaf93c29893cc37de2ddbe71c2c874",
    spotify: "2GLf7iaOOujAem5R87xwto",
    genre:
      "alternative dance,electronica,experimental pop,microhouse,minimal techno,new rave",
    popularity: "44",
  },
  {
    name: "black midi",
    image: "https://i.scdn.co/image/2c70cb0cbfccab295d47294e15dc121016a61341",
    spotify: "7Hvq85OU8T7Hsd63zNBwaL",
    genre:
      "chamber psych,modern alternative rock,noise rock,uk noise rock,uk post-punk revival",
    popularity: "44",
  },
  {
    name: "KOAN Sound",
    image: "https://i.scdn.co/image/d1a6f7945a836ddae00ca3a966552950350c8ef5",
    spotify: "1NCLweIUpq8knzemBwAwoo",
    genre: "brostep,complextro,edm,electro house,filthstep,glitch",
    popularity: "44",
  },
  {
    name: "Pugh Rogefeldt",
    image: "https://i.scdn.co/image/9d928c0a84c4bd761a242728bdb1fb55cf61832c",
    spotify: "22Wo43V44RtrpJZsjeI9EA",
    genre: "classic swedish pop,svensk progg",
    popularity: "44",
  },
  {
    name: "Trampa",
    image: "https://i.scdn.co/image/a882901f5fcc9e3ad8b4eb23510a0d4caf9a8936",
    spotify: "31DUXycJt0YIBoMXLI5UdV",
    genre: "brostep,deathstep,electro house,electronic trap,filthstep,zapstep",
    popularity: "44",
  },
  {
    name: "Aubrie Sellers",
    image: "https://i.scdn.co/image/0d8a6be6eb02bb7972c0a50c58f1c499b64f7793",
    spotify: "27IiEYV6p8fs5j8n39Pk1u",
    genre: "contemporary country,country pop,indie folk",
    popularity: "44",
  },
  {
    name: "Jengi",
    image: "https://i.scdn.co/image/4d75c70bbbefd662786badb4e6428b606965f8f5",
    spotify: "4lgrPvofm0IT605L9OrOTN",
    genre: "dutch pop,new french touch",
    popularity: "44",
  },
  {
    name: "Erika de Casier",
    image: "https://i.scdn.co/image/b3d312438dd5952bdc423859bf35fc71baa01832",
    spotify: "1nIJEqPyIj5qutlgWNmQB0",
    genre: "indie r&b,scandinavian r&b",
    popularity: "44",
  },
  {
    name: "Denis Sulta",
    image: "https://i.scdn.co/image/1cfbe7c3d6bffd662480e6461f3b713a0a3d9a5e",
    spotify: "7cDu9zG1gVQrMdSGBAhzvn",
    genre: "deep house,house,scottish electronic",
    popularity: "44",
  },
  {
    name: "Asleep At The Wheel",
    image: "https://i.scdn.co/image/7e2a842f248961e94ce1939895a8d45e0bc7422e",
    spotify: "54tWKkrjv4bQgKrQrNlecm",
    genre: "country rock,texas country",
    popularity: "44",
  },
  {
    name: "DJ Jean",
    image: "https://i.scdn.co/image/ab67616d0000b2738591410064d18374943c5eeb",
    spotify: "73MDPnjHtoqOexpBNe4FPl",
    genre: "dutch trance,happy hardcore",
    popularity: "43",
  },
  {
    name: "Matador",
    image: "https://i.scdn.co/image/f12f66055e09c066983cc1ab8d78a1d8ac5211c2",
    spotify: "1UcYY5JDPe05nqjODiVkx1",
    genre:
      "deep minimal techno,irish electronic,irish techno,minimal techno,tech house",
    popularity: "43",
  },
  {
    name: "Bart B More",
    image: "https://i.scdn.co/image/f2dd7b01c9d7d93b6df646b33a7748daa857c280",
    spotify: "1eOOXqRHILTxqrEUAYyQU0",
    genre: "dutch edm,electro house",
    popularity: "43",
  },
  {
    name: "Chris Stussy",
    image: "https://i.scdn.co/image/23744913ed560ca3b1ba5bedc1dc282c2b79aad1",
    spotify: "3BxjasMelf9pKaE4f7Y0So",
    genre: "dutch tech house,minimal tech house",
    popularity: "43",
  },
  {
    name: "KhoMha",
    image: "https://i.scdn.co/image/d6ff3907e12c483479c0b1b0151dd65cbdb991e5",
    spotify: "4ngwbMFTQKrLkLfREBYrvW",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "43",
  },
  {
    name: "Willie Wartaal",
    image: "https://i.scdn.co/image/169608a76a5e8db26206e53934ec02eb7b489a00",
    spotify: "4usBxmpmHRVy92QbcWk0M7",
    genre: "dutch hip hop,dutch pop",
    popularity: "43",
  },
  {
    name: "Jody Bernal",
    image: "https://i.scdn.co/image/425b4c7b78b1f73910a33eb7b15c56cc6a07281e",
    spotify: "7oKJmnPaABXLPkw3gT7rIa",
    genre: "",
    popularity: "43",
  },
  {
    name: "Whiney",
    image: "https://i.scdn.co/image/75ab659f6dea19c4d943e481fcee0ed1baf6d131",
    spotify: "4YTBo7qadslqj8V8FMRuqK",
    genre: "drum and bass,liquid funk,uk dnb",
    popularity: "43",
  },
  {
    name: "Sabrina Starke",
    image: "https://i.scdn.co/image/4707f43ca59896072e48d1f863cb209532d28d99",
    spotify: "1wTUsxee6HtnB6Z6QiUCub",
    genre: "dutch pop,dutch r&b,neo soul",
    popularity: "43",
  },
  {
    name: "Ramon Tapia",
    image: "https://i.scdn.co/image/c05f993533c419bedd52bd2e2d73b6a428db1faa",
    spotify: "5BFl4h5TXYSSJsCteTX3s1",
    genre: "belgian techno,deep minimal techno,minimal techno,tech house",
    popularity: "43",
  },
  {
    name: "Tigerlily",
    image: "https://i.scdn.co/image/b8ccdeac41ff65ae6a8719a217b83d1c2b7747c1",
    spotify: "48xCatjXaoohtyOHrHTijG",
    genre: "",
    popularity: "43",
  },
  {
    name: "Jungle By Night",
    image: "https://i.scdn.co/image/a82d13c3164459a3e0fffa6434fd2e1a11ede6c6",
    spotify: "2StcyX3fmelae5agBHIkDO",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "43",
  },
  {
    name: "Klubbheads",
    image: "https://i.scdn.co/image/fe10e13bc6aa69825a8c19c638e49ccdf51b1b93",
    spotify: "2j9KNQNo5B2mQ1isoa0eIe",
    genre: "bubble trance,eurodance",
    popularity: "43",
  },
  {
    name: "Brynny",
    image: "https://i.scdn.co/image/9829e1e37941e14f4cf25a61ec82ca0fbf8ee1b9",
    spotify: "7zpktFUPT54c6O46zTgmgh",
    genre: "melbourne bounce international",
    popularity: "43",
  },
  {
    name: "Aftershock",
    image: "https://i.scdn.co/image/f8b135cb1ecfa09fba72ef8d24025acdb65d5aca",
    spotify: "6KlY7jizsLWQcXR1F2Sn9j",
    genre: "hardstyle,rawstyle",
    popularity: "43",
  },
  {
    name: "Oski",
    image: "https://i.scdn.co/image/d7914fb7d6899f0ab747e6b04010945d04b2e91d",
    spotify: "7ERTOmWXRyme5WJUpXVVSl",
    genre: "bass trap,brostep,electronic trap,vapor twitch,zapstep",
    popularity: "43",
  },
  {
    name: "De Kraaien",
    image: "https://i.scdn.co/image/cc09f4676817e96a072db5776fb636a38dd90772",
    spotify: "2TZJIIHDLfgdMLFejURyKf",
    genre: "nederlandse hardstyle",
    popularity: "43",
  },
  {
    name: "Nicole Atkins",
    image: "https://i.scdn.co/image/bda1c92a8f45f67daa773eb3b99c93e94ea125fc",
    spotify: "4ab2tQaaTr2TnairelOwvO",
    genre: "indie folk,new americana",
    popularity: "43",
  },
  {
    name: "Amp Fiddler",
    image: "https://i.scdn.co/image/bc2f45c016d602a534969290ec97f2d337be6048",
    spotify: "39g75EmRFeFbvHhsGjUpLU",
    genre: "broken beat,deep house,indie jazz,indie soul,neo r&b,neo soul",
    popularity: "43",
  },
  {
    name: "Yung Internet",
    image: "https://i.scdn.co/image/f7a66406fe947f95ca8b0d6f151c908e23aa155b",
    spotify: "2XxoalhYJxXjU56POu1q7V",
    genre: "dutch hip hop",
    popularity: "43",
  },
  {
    name: "Gazzo",
    image: "https://i.scdn.co/image/ef350ac593078db939db0ff77eca62f550a0140f",
    spotify: "5st4KKihmnSMLRsxWOs2x3",
    genre: "pop edm",
    popularity: "43",
  },
  {
    name: "ATRIP",
    image: "https://i.scdn.co/image/f08bacd94db3dc115adec4525f237bf246444e9a",
    spotify: "4fu0Er7pG6kZZa7Awf3NMI",
    genre: "bass house,electro house",
    popularity: "43",
  },
  {
    name: "The Pitcher",
    image: "https://i.scdn.co/image/9127de1d5babfecef9fdd04fd3cd58e2a1bfd4fd",
    spotify: "1QsT3VKbdtjMxXoy9myb2X",
    genre: "classic hardstyle,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "43",
  },
  {
    name: "Bryan Kearney",
    image: "https://i.scdn.co/image/3744af55765a37398fa405203581c542dd7428c8",
    spotify: "5fBbVsFxoa0jDCqocaEdBx",
    genre:
      "progressive house,progressive uplifting trance,trance,uplifting trance",
    popularity: "43",
  },
  {
    name: "Sybil",
    image: "https://i.scdn.co/image/fbcadface35cb35152863cf6a06c80b4b3dd9859",
    spotify: "1EbIfIjVcauDatNO4vagL1",
    genre: "diva house,hip house",
    popularity: "43",
  },
  {
    name: "Crack Cloud",
    image: "https://i.scdn.co/image/8b3255e6cd49b230d3cf01d61897f897c3ab329e",
    spotify: "10butpS2A0V5nRIu2YDrKI",
    genre: "canadian post-punk,chamber psych,dance-punk,garage psych",
    popularity: "43",
  },
  {
    name: "Mees Salomé",
    image: "https://i.scdn.co/image/6b5e84455399ced50dc0fe2c09062773b43010ec",
    spotify: "3vcY5vaGqSQF6UA9N2iC4L",
    genre: "deep techno",
    popularity: "43",
  },
  {
    name: "Faberyayo",
    image: "https://i.scdn.co/image/45aed2137ad1b0f9f52e604349a7b71c9ff1dbe6",
    spotify: "3tSNYodPp4woMbWy6XZQG0",
    genre: "dutch hip hop",
    popularity: "43",
  },
  {
    name: "Hypnotic Brass Ensemble",
    image: "https://i.scdn.co/image/26e3ac5def5628531a5b4936d84684ca1302adc9",
    spotify: "4wvPcMJk7L9Rbw9Qh4kBeH",
    genre: "brass band,second line,street band",
    popularity: "43",
  },
  {
    name: "Dustycloud",
    image: "https://i.scdn.co/image/cb326fcbd3799953bbfebde2d90b581748027a08",
    spotify: "5O9MafawyW4O2WhJQKXj2d",
    genre: "bass house,deep groove house,electro house",
    popularity: "43",
  },
  {
    name: "Ecstatic",
    image: "https://i.scdn.co/image/e5814243fe05ca96e3708cd9aaafa2f8eb667dca",
    spotify: "7tEAlsvmuaVnKQyswnonem",
    genre: "euphoric hardstyle,hardstyle,rawstyle",
    popularity: "43",
  },
  {
    name: "Woenzelaar",
    image: "https://i.scdn.co/image/ee4b1f57ca388de9146f0f29f601d53ca4191339",
    spotify: "5q3cyUYQTJUOSZ6Sciduxv",
    genre: "dutch hip hop",
    popularity: "43",
  },
  {
    name: "Rickyxsan",
    image: "https://i.scdn.co/image/d9504d444d973222737e508ea0465912e57cf03b",
    spotify: "0lqxqV3IhQXO5czq1d0ZfJ",
    genre: "bass trap,brostep,electro house,electronic trap,zapstep",
    popularity: "43",
  },
  {
    name: "Tiamat",
    image: "https://i.scdn.co/image/5af72db90567baf46dae08323ce1f45923340789",
    spotify: "5SwHKKNKYToC1YzWVNWAIN",
    genre:
      "doom metal,gothic metal,neoclassical darkwave,swedish death metal,swedish doom metal,swedish metal,symphonic black metal",
    popularity: "43",
  },
  {
    name: "Jehst",
    image: "https://i.scdn.co/image/bca0a2fee6a989f1c3904fd0cc294c8503184237",
    spotify: "70KRtY1QWEurUeM3wuzpG1",
    genre: "conscious hip hop,uk alternative hip hop,uk hip hop",
    popularity: "43",
  },
  {
    name: "David Tort",
    image: "https://i.scdn.co/image/ef2ea0324ff127269e6c0ae3c1889280f6c481fe",
    spotify: "7Mlrzwh665lRUOEV1ZWyWu",
    genre:
      "big room,circuit,disco house,edm,electro house,funky tech house,house,progressive electro house,progressive house,tech house,tribal house",
    popularity: "43",
  },
  {
    name: "Swallow The Sun",
    image: "https://i.scdn.co/image/7b9421f3ae306e5ccbcec682c9a9f5e74c1c8ded",
    spotify: "0ulKlNlo0iPx5ZS6VMTHWQ",
    genre:
      "doom metal,finnish death metal,finnish doom metal,finnish metal,gothic metal,melodic death metal,metal",
    popularity: "43",
  },
  {
    name: "Wallis Bird",
    image: "https://i.scdn.co/image/6cd3e91468870f42f6e6b95817df08954e462cd4",
    spotify: "0aogyPVqx5tlIkR0BHAehX",
    genre: "irish singer-songwriter",
    popularity: "43",
  },
  {
    name: "Justin Martin",
    image: "https://i.scdn.co/image/4942dff75b5a93b847990479ac169818bd04048e",
    spotify: "4FN8WHqUbwkd97WEjoCu7B",
    genre: "bass house,house",
    popularity: "43",
  },
  {
    name: "Coyote Kisses",
    image: "https://i.scdn.co/image/084cd5fbe2373683ab40d971a21e9b7319f1872a",
    spotify: "1wnrdpW8B0rNCtX5uOSIVL",
    genre: "catstep,complextro,electro house,glitch hop",
    popularity: "43",
  },
  {
    name: "Chris Liebing",
    image: "https://i.scdn.co/image/c4957d4470193dc7f15a3b86baa0a17a9ad9f575",
    spotify: "21444lX8gpmOX36icLmbFI",
    genre:
      "frankfurt electronic,german techno,minimal techno,schranz,tech house,techno",
    popularity: "43",
  },
  {
    name: "Ownglow",
    image: "https://i.scdn.co/image/1d2e707e3e3c68339330deeec7d98aa4cf3b80f4",
    spotify: "5y0Z76say1n6Vj2mQnUHNj",
    genre: "drum and bass,liquid funk,stateside dnb",
    popularity: "43",
  },
  {
    name: "Alan Braxe",
    image: "https://i.scdn.co/image/16b2ac478290228d7be814a7bb3851336d507c2a",
    spotify: "24JRvbKfTcF2x7c2kCCJrW",
    genre: "disco house,filter house,nu disco",
    popularity: "43",
  },
  {
    name: "Figure",
    image: "https://i.scdn.co/image/8d22c58f944423f91bfa22cd768e15ed4c7c77f3",
    spotify: "5mADpqv2E8KIHDmEhH7wmr",
    genre: "brostep,edm,electro house,electronic trap,filthstep,zapstep",
    popularity: "43",
  },
  {
    name: "Alpharock",
    image: "https://i.scdn.co/image/4035861d5360b553bd495618eb189fbe3601e8db",
    spotify: "629Fs7UJp6tWqOYZi8t8ET",
    genre: "big room,deep big room,edm,electro house,sky room",
    popularity: "43",
  },
  {
    name: "Mark Reeve",
    image: "https://i.scdn.co/image/16ebd1123422f7beae95c2de3d64c709d5e0ff39",
    spotify: "58zZkWGb6qvx0AJ6L3ttlZ",
    genre: "deep minimal techno,frankfurt electronic,tech house",
    popularity: "43",
  },
  {
    name: "Last Train",
    image: "https://i.scdn.co/image/f5e6faacc21e50fb5a704c67d4c23ffbb80687b4",
    spotify: "4S47feOS2ATuhc7Ao5ilfG",
    genre: "rock alternatif francais",
    popularity: "43",
  },
  {
    name: "Mystic Prophecy",
    image: "https://i.scdn.co/image/152fc09b80672fccb7a586eb41bb603334ad5259",
    spotify: "5kUzPpkPyNpxRYd66c8nYG",
    genre:
      "german metal,melodic metal,metal,neo classical metal,neo-trad metal,power metal,progressive metal,speed metal",
    popularity: "43",
  },
  {
    name: "Hundreds",
    image: "https://i.scdn.co/image/7f8cabd1c849a9dc71ab4dd8f060de99db5de775",
    spotify: "7mTyxMGqsoIl6ofVdtjfux",
    genre: "german indie",
    popularity: "43",
  },
  {
    name: "Tom Enzy",
    image: "https://i.scdn.co/image/7394aac6125bed4c087e744e2b70b273b9a789c3",
    spotify: "6Nva7JhU0nL9SZ8ZvJni6O",
    genre: "sky room",
    popularity: "43",
  },
  {
    name: "Abstract Orchestra",
    image: "https://i.scdn.co/image/cca35a8a000e7ad32c95dabcad7db2ab920b5326",
    spotify: "4u3JZVJYDq2F3KgnUFw9dp",
    genre: "alternative hip hop",
    popularity: "43",
  },
  {
    name: "Red City Radio",
    image: "https://i.scdn.co/image/3bbb27b607fbd9df44518ac205afce1d1cf1f618",
    spotify: "6SSXfZGnJaNajWRPGHq4JL",
    genre: "melodic hardcore,ok indie,orgcore,skate punk",
    popularity: "43",
  },
  {
    name: "Aversions Crown",
    image: "https://i.scdn.co/image/d471f587bc763e09cffac7495787ea01bc004f1e",
    spotify: "6OITsYO1BqjC0VIF6yGFOc",
    genre:
      "australian metal,brutal deathcore,deathcore,melodic metalcore,progressive deathcore",
    popularity: "43",
  },
  {
    name: "The Haggis Horns",
    image: "https://i.scdn.co/image/77ebeadb28e99bc59b969d163b15f79c1a40614a",
    spotify: "5teuZRCtxzfuYW98XOwtxu",
    genre:
      "afrobeat,bboy,brass band,brit funk,funk,instrumental funk,modern funk",
    popularity: "43",
  },
  {
    name: "Die Kassierer",
    image: "https://i.scdn.co/image/ab67616d0000b273da0199fac2004b46aebedc3e",
    spotify: "2rkUO6EuQHFdR9rrakgfJR",
    genre: "german punk,german rock",
    popularity: "43",
  },
  {
    name: "Will Hoge",
    image: "https://i.scdn.co/image/bf41496c2569bb2903964ceb026cd2c8edf9faa0",
    spotify: "6a8DSomMqspxk3s3WlBjNT",
    genre: "acoustic pop,heartland rock,neo mellow",
    popularity: "43",
  },
  {
    name: "Matt Lange",
    image: "https://i.scdn.co/image/ee37d600f44ca739a4ed7de4db514a5f448e1e4f",
    spotify: "2AmHV6vxRxvHdlxSHxnHE9",
    genre: "progressive house,progressive trance,progressive trance house",
    popularity: "43",
  },
  {
    name: "Yukno",
    image: "https://i.scdn.co/image/e372c95da6a8d6beb3d48a4c1fd28d4387bc8e0b",
    spotify: "01JZtu3hMY7lmY36RCqzIl",
    genre: "austrian indie,german indie",
    popularity: "43",
  },
  {
    name: "Sean Tyas",
    image: "https://i.scdn.co/image/0833780349f9f748d443ae60e7c296e5e6fa0110",
    spotify: "4zqERoiO42cNiA3pPDWnvN",
    genre:
      "deep uplifting trance,progressive house,progressive trance,progressive uplifting trance,tech trance,trance,uplifting trance",
    popularity: "43",
  },
  {
    name: "Morgan Delt",
    image: "https://i.scdn.co/image/f3119cf4d572f596f0f2f18b4a867b4f655df1e6",
    spotify: "29ITaP4nYGDlz54m7pLJL1",
    genre: "indie garage rock,neo-psychedelic",
    popularity: "43",
  },
  {
    name: "Jaakko Eino Kalevi",
    image: "https://i.scdn.co/image/e419ea2d1178819918ac97396a73b8f505084125",
    spotify: "20o7mwLphfnviZKGPw1gi3",
    genre: "experimental pop,finnish electro,finnish indie",
    popularity: "43",
  },
  {
    name: "Crossnaders",
    image: "https://i.scdn.co/image/a49fd16867e49889071cdcdee7870386588a72aa",
    spotify: "0SFycBapbIhuPacbhzDxI2",
    genre: "deep big room,dutch edm",
    popularity: "43",
  },
  {
    name: "Pietju Bell",
    image: "https://i.scdn.co/image/ab67616d0000b273da6a7c6862177f8ecae71415",
    spotify: "1u93ZA92GfXqLgNv4x8uJv",
    genre: "dutch hip hop",
    popularity: "43",
  },
  {
    name: "Ozomatli",
    image: "https://i.scdn.co/image/f776f565544b4dc72bba265acc4fe76a7570a061",
    spotify: "1An0HCtDktvCBDdFEu7HC0",
    genre: "latin alternative",
    popularity: "43",
  },
  {
    name: "Arkham Knights",
    image: "https://i.scdn.co/image/b4afc50f32bf8dcf7c0189a8d39baf2734579cbe",
    spotify: "3WdwrzOYFNin96n7i4WXoh",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "43",
  },
  {
    name: "Blackbriar",
    image: "https://i.scdn.co/image/a9391b513eed60be96d815c503b4f693c5f4e67a",
    spotify: "6PXQUX3BYTSVj7LcvviOmI",
    genre:
      "dutch metal,gothic metal,gothic symphonic metal,slayer,symphonic metal",
    popularity: "43",
  },
  {
    name: "Iorie",
    image: "https://i.scdn.co/image/e1a46989352b3a71198a786fdd372fad32460678",
    spotify: "1ruewEJphCPPAOSjowo9AH",
    genre: "ethnotronica,organic house",
    popularity: "43",
  },
  {
    name: "Smokey Joe & The Kid",
    image: "https://i.scdn.co/image/ab67616d0000b2732756269e2a7d862276af7807",
    spotify: "3dITsREBtJGzkh8z3AXWKQ",
    genre: "electro swing,nu jazz",
    popularity: "43",
  },
  {
    name: "Diskord",
    image: "https://i.scdn.co/image/01c3189703de7d8d06c43619296ca8430bb3c7a5",
    spotify: "3o8BMojuQONFOJ0cJ0qOEc",
    genre: "bass trap",
    popularity: "43",
  },
  {
    name: "Dabbla",
    image: "https://i.scdn.co/image/af3ce14c02155b0b52025653fcf2de4f0c171ebe",
    spotify: "2JMVlpvihBQpxNhy6XUOZ1",
    genre: "uk alternative hip hop,uk hip hop",
    popularity: "43",
  },
  {
    name: "Factor B",
    image: "https://i.scdn.co/image/dd6a82d90b3740f16f3d1c1d77777c1a38282256",
    spotify: "4OUavLWUepaSy6MNjkNS3g",
    genre: "progressive house,progressive trance,trance,uplifting trance",
    popularity: "43",
  },
  {
    name: "D-Train",
    image: "https://i.scdn.co/image/992222766accc6c2364b6d65cbbba5e8eae20a8c",
    spotify: "4gQEXxzqwNmQwjU0Wc0Ioe",
    genre: "boogie,disco,electro,funk,popping,post-disco,quiet storm",
    popularity: "43",
  },
  {
    name: "GAIKA",
    image: "https://i.scdn.co/image/928d0e285bcf50801badb36cff388e838dad562d",
    spotify: "543QE1sqcqcNAL8JSK4Jzd",
    genre: "deconstructed club,escape room,fluxwork,vogue",
    popularity: "43",
  },
  {
    name: "Charli Brix",
    image: "https://i.scdn.co/image/28eeed22501b6758016ba76e6e4e34b0a9e50d4a",
    spotify: "27Sc6g0Utbc8hvWrzTFVc8",
    genre: "uk dnb",
    popularity: "43",
  },
  {
    name: "Finnebassen",
    image: "https://i.scdn.co/image/66a54006b02bf252f0f3d4d097a2f299d2099075",
    spotify: "3Ckt7DNBcLi93B2LGyKYzy",
    genre: "deep disco house,groove room",
    popularity: "43",
  },
  {
    name: "Falcons",
    image: "https://i.scdn.co/image/2b4ddec2e2a78d4592d82b3c8165734f99551da9",
    spotify: "7lm68Uw3UZDD1vlAWpLeDL",
    genre: "vapor twitch",
    popularity: "43",
  },
  {
    name: "Masked Intruder",
    image: "https://i.scdn.co/image/64241644a68eeecbe9394a439250c3568fa85ac9",
    spotify: "4qUFkkArfii3qNG8TnbPfc",
    genre: "modern ska punk,orgcore,power-pop punk,skate punk",
    popularity: "43",
  },
  {
    name: "Raw Roets",
    image: "https://i.scdn.co/image/86adceabc1135f110b3d5363f6375462a9f4b627",
    spotify: "3K0u138EjCuhbWEwUnGwmu",
    genre: "dutch hip hop,dutch trap pop",
    popularity: "43",
  },
  {
    name: "Bella Boo",
    image: "https://i.scdn.co/image/8767b9cd218d70c34998504bf79286676ac2b39a",
    spotify: "1Rwokb27xxRMZC0zWA8i6C",
    genre: "float house,swedish electronic,swedish house",
    popularity: "43",
  },
  {
    name: "Infinity Ink",
    image: "https://i.scdn.co/image/39395f23f53d9431f0ae54bfa4e0ed2cbbc0cbaa",
    spotify: "4aulLg9UvpHY9dIRqr30Qh",
    genre: "deep disco house,house",
    popularity: "43",
  },
  {
    name: "Holy Fuck",
    image: "https://i.scdn.co/image/b924c966ed5adcfd5e2bc694cc80ef7e92552f24",
    spotify: "6Q0gMZJNIebNFFaJeonc11",
    genre:
      "alternative dance,chamber psych,dance-punk,electronic rock,electronica,new rave",
    popularity: "43",
  },
  {
    name: "Holding Absence",
    image: "https://i.scdn.co/image/c289770a984bc36f3088e962134491a771c975f1",
    spotify: "2tl280wIokrLjabzrSKTgU",
    genre: "melodic hardcore,metalcore",
    popularity: "43",
  },
  {
    name: "Geju",
    image: "https://i.scdn.co/image/9914c5230df9601437a17f5644d974a925ac70d5",
    spotify: "33AlE9XaZmnAtfWFhjNL5e",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "43",
  },
  {
    name: "Squid",
    image: "https://i.scdn.co/image/8ba8592cb6399bfb79c2f525a1849d1d68b0c204",
    spotify: "685XjGzGztyivfR3fAjoxo",
    genre:
      "brighton indie,chamber psych,english indie rock,uk post-punk revival",
    popularity: "43",
  },
  {
    name: "Loc-Dog",
    image: "https://i.scdn.co/image/2be73f23bb9dfd3e64cfa2cb6edaa0bbe78418b1",
    spotify: "4y0G11kIVcUrvbJjIeRttg",
    genre: "russian hip hop,russian trap",
    popularity: "43",
  },
  {
    name: "ERRdeKa",
    image: "https://i.scdn.co/image/f682b7c25fc4f421e5cad1c9bf3c49977778637e",
    spotify: "0SynfeDjp6cRbduvtjry7n",
    genre: "german cloud rap,german hip hop,indie deutschrap",
    popularity: "43",
  },
  {
    name: "Undercatt",
    image: "https://i.scdn.co/image/1cbac940e6739b6e38403ec2c4896d0709899e2b",
    spotify: "5HRGFSrlJruRPZNPbsy57r",
    genre: "italian techno",
    popularity: "43",
  },
  {
    name: "Andrea Oliva",
    image: "https://i.scdn.co/image/b2e157c30d39bf6e97d9bf580dd3151e8288d5c9",
    spotify: "6oqv4rbOMlOZNOUoDFgBSp",
    genre: "house,minimal tech house,swiss house,tech house",
    popularity: "43",
  },
  {
    name: "Amine Edge & DANCE",
    image: "https://i.scdn.co/image/3eb7343e7445ac050afe938713833529e73ee490",
    spotify: "7si9pFZZlPdZPeOclH9vgm",
    genre: "deep groove house,french tech house,house",
    popularity: "42",
  },
  {
    name: "Billy The Kit",
    image: "https://i.scdn.co/image/2b993c28f472173b14e61d23cb31535c3e2d2249",
    spotify: "7mHUbNIflNX99gowiCMCwZ",
    genre: "",
    popularity: "42",
  },
  {
    name: "Moomin",
    image: "https://i.scdn.co/image/dad63e3c4e07c4089962043e09193c77305d6168",
    spotify: "5GyUtaUuEnR7uhRF3jDj4s",
    genre: "deep house,deep soul house,float house",
    popularity: "42",
  },
  {
    name: "FractaLL",
    image: "https://i.scdn.co/image/0821f264c59acbf1c375695d9691fe9e19f5a784",
    spotify: "7aohnUnt4vWtzvhBSZTAbF",
    genre: "brazilian edm",
    popularity: "42",
  },
  {
    name: "Julian Jeweil",
    image: "https://i.scdn.co/image/07b8103dac3a68ed9014abcb6eda41970e5baeac",
    spotify: "3C046bLxNmvBQyaucinAhf",
    genre:
      "dark techno,deep minimal techno,french techno,minimal techno,tech house",
    popularity: "42",
  },
  {
    name: "Trobi",
    image: "https://i.scdn.co/image/2984f71ec81d9c678193b274108c6bdccbd84816",
    spotify: "0MBLQbpbPvJ4oXM0Cj4aKR",
    genre: "dutch edm,pop edm",
    popularity: "42",
  },
  {
    name: "Klangstof",
    image: "https://i.scdn.co/image/7943585a27beff999f86e51a16cdd3485f5591ef",
    spotify: "25lIYhqIj0R1AnnmqsTrtO",
    genre: "dutch indie,dutch indie rock,vapor soul",
    popularity: "42",
  },
  {
    name: "Doozie",
    image: "https://i.scdn.co/image/2d1ba07b06d0a0770fc0bbf0acc6ec603f80bd22",
    spotify: "094tZMLXkYiIpf6u2XAaX1",
    genre: "",
    popularity: "42",
  },
  {
    name: "Tim Akkerman",
    image: "https://i.scdn.co/image/84a75e8f2a105edb3dcb059bf3c5693f43869684",
    spotify: "1mdYzJv7Z90aiNlfBvoI9u",
    genre: "dutch pop,dutch rock",
    popularity: "42",
  },
  {
    name: "DeWolff",
    image: "https://i.scdn.co/image/390dea0f971a21cffca6f965f35d2b5e4109bcf5",
    spotify: "1OHnmln4huMiBLyxBHNx0k",
    genre: "dutch americana,dutch blues,dutch indie,dutch rock",
    popularity: "42",
  },
  {
    name: "Orkestrated",
    image: "https://i.scdn.co/image/926736017befe8c51b2eee93c0781135b1ec1a72",
    spotify: "52VqIv9iDcmGRrg9tzsEF0",
    genre: "melbourne bounce,melbourne bounce international",
    popularity: "42",
  },
  {
    name: "Audiofreq",
    image: "https://i.scdn.co/image/33505556fb1a5e3c16f87e7ba0b7a18c31868ddd",
    spotify: "0hHKtZEXHNsXfgrNgU7Zkl",
    genre: "classic hardstyle,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "42",
  },
  {
    name: "The Notwist",
    image: "https://i.scdn.co/image/3a2355a56cd2464ccdea7554b38dcf0073ea0a05",
    spotify: "1o4xLcugkCtDDOw7POAMha",
    genre: "german indie",
    popularity: "42",
  },
  {
    name: "Edu Imbernon",
    image: "https://i.scdn.co/image/02da69373769d588f5d450da7e52eb971497b16b",
    spotify: "0Vr0xxcbllx4JWHHxio088",
    genre: "organic house,spanish techno,tech house",
    popularity: "42",
  },
  {
    name: "Ejeca",
    image: "https://i.scdn.co/image/b12727a47078627c89cfd73583ef241761a698a4",
    spotify: "0tSC9Vot7WlR1MsLBqQ9HX",
    genre: "deep house,house,irish electronic,minimal tech house",
    popularity: "42",
  },
  {
    name: "Scott H. Biram",
    image: "https://i.scdn.co/image/1879b97fc8040c6ae21bafef933a2c4d73de22ad",
    spotify: "6wpI4AEN6UO7ksNN23RGEf",
    genre:
      "alternative country,alternative roots rock,austin singer-songwriter,deathgrass,garage punk blues,new americana,one-person band,outlaw country,punk blues,roots americana,san marcos tx indie",
    popularity: "42",
  },
  {
    name: "Sem Thomasson",
    image: "https://i.scdn.co/image/4d7b6053aa2c082688682e6fd89e40ece888daf5",
    spotify: "33IPzv8gRj1LFh0NGkFMBQ",
    genre: "belgian edm",
    popularity: "42",
  },
  {
    name: "Mees Dierdorp",
    image: "https://i.scdn.co/image/ffb28fcf9b6cd50859f9f6cba1920a6716ca5d9b",
    spotify: "2dUsAHSrnsFvNpNpAV4aGI",
    genre: "organic electronic,organic house",
    popularity: "42",
  },
  {
    name: "Lisa Lois",
    image: "https://i.scdn.co/image/909ea0b0a266bf94fc147caa89a8672afe90134a",
    spotify: "1dGsUN9Hwx78H6MdDquxLL",
    genre: "dutch pop,dutch rock",
    popularity: "42",
  },
  {
    name: "Simina Grigoriu",
    image: "https://i.scdn.co/image/bd3a671d430be7591aba326cd96ccbeea3167f49",
    spotify: "1PjzNHCXycxUqsP2yqFqhU",
    genre: "deep euro house",
    popularity: "42",
  },
  {
    name: "Elekfantz",
    image: "https://i.scdn.co/image/c71ae847b3101cb20462e1073e9e99befe1f6b86",
    spotify: "2qPvJviDwokwrQtNzR1Udv",
    genre: "brazilian edm",
    popularity: "42",
  },
  {
    name: "Dennis Quin",
    image: "https://i.scdn.co/image/87eb6b27a8506b50702a13073199db6ed1452c1c",
    spotify: "1iaGffGcjxdzSFkwfCN2Ul",
    genre: "deep groove house,dutch tech house",
    popularity: "42",
  },
  {
    name: "Stanton Warriors",
    image: "https://i.scdn.co/image/303ec9f6a955cc919f3ace5cbfb9c86acd666a23",
    spotify: "7GeAzBsalYANXTi1ReOm1R",
    genre: "big beat,breakbeat,bristol electronic,nu skool breaks",
    popularity: "42",
  },
  {
    name: "Die Sterne",
    image: "https://i.scdn.co/image/8165aa79c36f5b6db9a48e1cade466019f971c23",
    spotify: "7hVoi7crxYOHIayk4v9x4Q",
    genre:
      "german indie,german pop,german rock,hamburger schule,liedermacher,neue deutsche welle",
    popularity: "42",
  },
  {
    name: "Robert Ellis",
    image: "https://i.scdn.co/image/a7021762c85cd4369c58271c2d432226df930e05",
    spotify: "6XtG9W2KkPiQ6n1rlIvTJE",
    genre:
      "alternative country,deep new americana,indie folk,new americana,stomp and holler",
    popularity: "42",
  },
  {
    name: "Rob Dekay",
    image: "https://i.scdn.co/image/3318b94bfa0c05fc6192b7a77a4c621c1cdc272b",
    spotify: "5JoatGOLXYnVYfHA3WUfSI",
    genre: "dutch pop",
    popularity: "42",
  },
  {
    name: "Moritz Garth",
    image: "https://i.scdn.co/image/20660bd6dbd73dcbb4188a365ca41f00c3d048ac",
    spotify: "1WAFrFBTxCQljp8iidU9sn",
    genre: "german pop",
    popularity: "42",
  },
  {
    name: "Marthe Wang",
    image: "https://i.scdn.co/image/adc0de8e513843af9a3a3a2aa5ec47af0ab99faf",
    spotify: "1C5w8BJZv0qoTGCFiVlfyZ",
    genre: "norwegian indie,norwegian pop",
    popularity: "42",
  },
  {
    name: "C-Rock",
    image: "https://i.scdn.co/image/2944079a8626e5504214ab546a5545fa96c98909",
    spotify: "1ENM3yaBNTP1lsZrr67Efy",
    genre: "",
    popularity: "42",
  },
  {
    name: "Riot Shift",
    image: "https://i.scdn.co/image/406c3718b6f916ad210ec6f3cc19c4ac9e3baaad",
    spotify: "5J3RIw3YwgyXeosItjR9GY",
    genre: "rawstyle,uptempo hardcore,xtra raw",
    popularity: "42",
  },
  {
    name: "Radio Slave",
    image: "https://i.scdn.co/image/ee8637e290989df72fa396f164fffa98bdbd6e85",
    spotify: "4rzWjR3L3M54c6I25NzdM3",
    genre: "microhouse,minimal tech house,minimal techno,tech house,techno",
    popularity: "42",
  },
  {
    name: "Julia Zahra",
    image: "https://i.scdn.co/image/cf17c92d6e9be912644d28beb841457415b06ac9",
    spotify: "57QuHq7IzyUgZsgl0g5fMI",
    genre: "dutch pop",
    popularity: "42",
  },
  {
    name: "RayRay",
    image: "https://i.scdn.co/image/4b5e3506db85036a331bd6a8099b2d48a215b087",
    spotify: "4FS6bomikvJR2E9JHNwiAM",
    genre: "chinese electropop,taiwan electronic",
    popularity: "42",
  },
  {
    name: "Digitzz",
    image: "https://i.scdn.co/image/f5719501ffee46be97aca18575a4d43001c2fd62",
    spotify: "4MCQBhrvHrufVxrKk5c5U3",
    genre: "",
    popularity: "42",
  },
  {
    name: "Gotu Jim",
    image: "https://i.scdn.co/image/180b963cc226373dd420952215c5496289448ae7",
    spotify: "5rpTehBPpr3mo7L0ZDZhrQ",
    genre: "dutch hip hop",
    popularity: "42",
  },
  {
    name: "Twilight Force",
    image: "https://i.scdn.co/image/ffb6921114cf1528cf66c8f75240cc49b749f2c9",
    spotify: "0tO6ALWmduAbneXoHmnl2T",
    genre:
      "melodic metal,power metal,swedish power metal,symphonic metal,symphonic power metal",
    popularity: "42",
  },
  {
    name: "First State",
    image: "https://i.scdn.co/image/0aa2042d9a198929b9bddc56235ca565dac9652f",
    spotify: "5FKABVMDKiED2mhi8bFSVx",
    genre:
      "dutch trance,progressive house,progressive trance,trance,uplifting trance",
    popularity: "42",
  },
  {
    name: "Greyhounds",
    image: "https://i.scdn.co/image/54fa05c6fea72a7643803e502ae20409fbb5dbc7",
    spotify: "1FcTd89N9ESEOsIDD883Kp",
    genre: "deep new americana,funk",
    popularity: "42",
  },
  {
    name: "Kadavar",
    image: "https://i.scdn.co/image/3d78d5b04969bd0c7988abbe3af3e8ad97ce95c1",
    spotify: "0FfuujZJUa7Z2JzhhiPI2z",
    genre:
      "german hard rock,german stoner rock,psychedelic doom,retro metal,space rock,stoner rock",
    popularity: "42",
  },
  {
    name: "Dubloadz",
    image: "https://i.scdn.co/image/afcc4c833a1935dff1c99c95d819ced18d7cf5da",
    spotify: "4akLvvJyLbJxlbpSXHTLvT",
    genre: "brostep,electro house,electronic trap,zapstep",
    popularity: "42",
  },
  {
    name: "M.A.N.D.Y.",
    image: "https://i.scdn.co/image/fffddc266065bfe64520d28227a01d1be568a58c",
    spotify: "20O4Ik25BbWfWBz0kZtsxX",
    genre: "microhouse,minimal techno,tech house",
    popularity: "42",
  },
  {
    name: "Brutus",
    image: "https://i.scdn.co/image/7008b58cebd9a5875bce5cbc679b935df69c5aff",
    spotify: "7m63GptZSke3jGqCxR4rom",
    genre: "belgian indie,belgian indie rock,belgian metal,gaian doom",
    popularity: "42",
  },
  {
    name: "Nikki Lane",
    image: "https://i.scdn.co/image/45d2fc3b66ff842f7754a240dd21e35b4632d148",
    spotify: "2kWeFaiHBskk8oqky3KHcR",
    genre: "new americana,outlaw country",
    popularity: "42",
  },
  {
    name: "Chris Schweizer",
    image: "https://i.scdn.co/image/3066bce54de5290cc76af829b8f9009d770e1711",
    spotify: "2OEfOu8gvperJc2LcqGsjc",
    genre:
      "deep uplifting trance,progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "42",
  },
  {
    name: "Infekt",
    image: "https://i.scdn.co/image/a5b29578afc26cb455419c85c9c84aa744774a65",
    spotify: "3I6KMDdmPiLE5UQ4XF8Kpl",
    genre: "brostep,zapstep",
    popularity: "42",
  },
  {
    name: "Ramzoid",
    image: "https://i.scdn.co/image/4375999197a3d78689aba6de042555e129326488",
    spotify: "2Ci3Sflo2BfC77wTwn2hbH",
    genre: "future bass,gaming edm,vapor twitch",
    popularity: "42",
  },
  {
    name: "Giocatori",
    image: "https://i.scdn.co/image/1cc24b68f35d31d0e32fde663a81e15a3e1872cc",
    spotify: "2kF9vCHjfQGcgc8UeHD319",
    genre: "",
    popularity: "42",
  },
  {
    name: "Max Mutzke",
    image: "https://i.scdn.co/image/8f0fd2941003cbe1d811ae68c88986334c699a5a",
    spotify: "2XTN4g2qnzFw0TG2NHuQxl",
    genre: "german pop",
    popularity: "42",
  },
  {
    name: "Orkidea",
    image: "https://i.scdn.co/image/b1aaf30a06a9fb20ab23989ae85c8b4984a12582",
    spotify: "0aXrPFaq0OZY0Iv87lEWR7",
    genre:
      "finnish edm,progressive house,progressive trance,trance,uplifting trance",
    popularity: "42",
  },
  {
    name: "77 Bombay Street",
    image: "https://i.scdn.co/image/217b26bf980bd86e714a33087279b0a0feda716a",
    spotify: "0mrnxWCuoCp6q8iSoWEijn",
    genre: "mundart,swiss alternative rock,swiss indie,swiss rock",
    popularity: "42",
  },
  {
    name: "Ferry Tayle",
    image: "https://i.scdn.co/image/1aa36d1a5ce1666820ab00310a2157c7dfae44b6",
    spotify: "6duWCqMhaEvKA0P0MVs0zQ",
    genre:
      "deep uplifting trance,progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "42",
  },
  {
    name: "Kobosil",
    image: "https://i.scdn.co/image/8c07f29e400cd50038ba36145fed877c582dce8a",
    spotify: "2ZvIFwl0BuQgHqWvDE80hC",
    genre: "industrial techno,minimal dub",
    popularity: "42",
  },
  {
    name: "MC Livid",
    image: "https://i.scdn.co/image/ab67616d0000b273c1409385b431ee7d6e46fb99",
    spotify: "3GvnEADrxf9LST8avbLuMe",
    genre: "",
    popularity: "42",
  },
  {
    name: "Dario Rodriguez",
    image: "https://i.scdn.co/image/789ad1e7d7394a8b1e7aabfb2c52a09aca44d009",
    spotify: "2hWrmZhAfziW6WnBytCCUv",
    genre: "",
    popularity: "42",
  },
  {
    name: "Andres Campo",
    image: "https://i.scdn.co/image/fe4514208a3ceeb3eb38038b45101533865d2bd6",
    spotify: "0vkvkNBVrXTfgkuPqI7JgL",
    genre: "spanish techno",
    popularity: "42",
  },
  {
    name: "Shelter Boy",
    image: "https://i.scdn.co/image/5d7f115b5de8f99cb3726e29c91e0a1d6de6adab",
    spotify: "0pTrkIFjUhNNHIV3YhtPfV",
    genre: "german indie",
    popularity: "42",
  },
  {
    name: "Till Von Sein",
    image: "https://i.scdn.co/image/cc286f912f762c8e4c5fb0cef8442a60595176f7",
    spotify: "5gRHhAWRxjeshuTGcFfEkI",
    genre: "minimal tech house",
    popularity: "42",
  },
  {
    name: "Sharam Jey",
    image: "https://i.scdn.co/image/3182925eff1c5aa8533851fd37fb367ff8d544e6",
    spotify: "0k4tYg6N84bhZcd6tfNWXt",
    genre: "deep uplifting trance,nu disco",
    popularity: "42",
  },
  {
    name: "Ruthless",
    image: "https://i.scdn.co/image/77d999eedfe0acad030958e2faf1b5ace931e500",
    spotify: "0xMCuSqF7uPefaatWnEx7F",
    genre: "",
    popularity: "42",
  },
  {
    name: "Ashley Henry",
    image: "https://i.scdn.co/image/914f8a9e624d3039a472f2459aa0ae3d24f8d3da",
    spotify: "64bpQRbx4Nw2r7oIg1SAzw",
    genre: "british jazz,indie jazz,indie soul,neo r&b,uk contemporary jazz",
    popularity: "42",
  },
  {
    name: "Xenia Rubinos",
    image: "https://i.scdn.co/image/a1daf02f39c939399af159b18ce89417d4e4808c",
    spotify: "17UUkxLWmRP5P47W5kwVVb",
    genre: "brooklyn indie,lo star",
    popularity: "42",
  },
  {
    name: "Valentine",
    image: "https://i.scdn.co/image/16f3e081194571b0e4354fd7d376132293c44db5",
    spotify: "4K3iYJtLjJcsfUlODo4bzS",
    genre: "",
    popularity: "42",
  },
  {
    name: "The Meteors",
    image: "https://i.scdn.co/image/ab67616d0000b273cd9187880b78534016312040",
    spotify: "7a2sloQlmdKSmj3fwMMpg9",
    genre: "psychobilly,pub rock,rockabilly",
    popularity: "42",
  },
  {
    name: "Xique-Xique",
    image: "https://i.scdn.co/image/4a543e9708afeb53b6d22d628102d1653f053c3f",
    spotify: "5LuhrBhGclMzHlYK4mDLLp",
    genre:
      "ethnotronica,latintronica,musica eletronica brasileira,organic electronic,organic house",
    popularity: "42",
  },
  {
    name: "H2O",
    image: "https://i.scdn.co/image/e7fbc127b509768c29649f8a016c5ce8a127bf73",
    spotify: "4mQm8gcXNNyzNQRqYKTKqo",
    genre:
      "hardcore,hardcore punk,melodic hardcore,nyhc,punk,skate punk,straight edge",
    popularity: "42",
  },
  {
    name: "Luca Testa",
    image: "https://i.scdn.co/image/c59997a50379fa9d83194d531b2b4439977b260f",
    spotify: "0Dzj2bn9ivDSjvJVSKL4q7",
    genre: "deep big room,sky room",
    popularity: "42",
  },
  {
    name: "Vinchenzo",
    image: "https://i.scdn.co/image/0c53713ee03e1ec7ee0d9279c36a2a040aaf70a4",
    spotify: "6Jc18GpeJVDe3HWhfrQ0Bu",
    genre: "dutch pop",
    popularity: "42",
  },
  {
    name: "Manuel Riva",
    image: "https://i.scdn.co/image/25b0de1bb4d2de4602d22010f42d8f1b15923549",
    spotify: "2hkGkEnyudpE42IU4DBt99",
    genre: "groove room,romanian electronic",
    popularity: "42",
  },
  {
    name: "Pete Philly",
    image: "https://i.scdn.co/image/9a1e81628ebb422eb06c3ca99c57fd76e9e15831",
    spotify: "0DD1CBUI4ypYSqvKUyjNoO",
    genre: "dutch hip hop,dutch r&b",
    popularity: "42",
  },
  {
    name: "Sparkz",
    image: "https://i.scdn.co/image/ab67616d0000b273e03fa329871e5d368cbc6dd2",
    spotify: "3wKN85pgXHwvP8mTt7dVJf",
    genre: "manchester hip hop",
    popularity: "42",
  },
  {
    name: "Tenderlonious",
    image: "https://i.scdn.co/image/d74cbf4e7d6f76939e0a22f3850b54ad3a573034",
    spotify: "5D1w6T6H7pnRDQZIrhwlxo",
    genre: "british jazz,broken beat,indie jazz,uk contemporary jazz",
    popularity: "42",
  },
  {
    name: "Defeater",
    image: "https://i.scdn.co/image/bbfff97d1fd9627a844dd41cbb988c8513d1ad3f",
    spotify: "1L3hqVCHSL1Ajy3m0z1bAT",
    genre: "alternative emo,boston hardcore,chaotic hardcore,melodic hardcore",
    popularity: "42",
  },
  {
    name: "Room Eleven",
    image: "https://i.scdn.co/image/d43375210880820c2eb284a915ccb9d62200973b",
    spotify: "1fnqrUzStcFzRdTybhaOdT",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "42",
  },
  {
    name: "Seun Kuti",
    image: "https://i.scdn.co/image/4e93f1eee67f84fe02b4361bbe9e772c1ebacda5",
    spotify: "1GQur7dDvAWhKT9u9YwBJZ",
    genre: "afrobeat,afropop,world",
    popularity: "42",
  },
  {
    name: "Chris Schwarzwalder",
    image: "",
    spotify: "3sk8zK5h24R74rFUdV8qcL",
    genre: "",
    popularity: "42",
  },
  {
    name: "Gundelach",
    image: "https://i.scdn.co/image/cb7653572e77654df98a388db4b4e36b092c3f06",
    spotify: "2TUtwEDqoXZOapCTgMrcvj",
    genre: "danish electropop,norwegian indie,norwegian pop",
    popularity: "42",
  },
  {
    name: "Bellecour",
    image: "https://i.scdn.co/image/1d4db2093f3d1cf5d1dac43f8338145f1f4d0f1b",
    spotify: "1PiNBMw3iIaG021gWeidUY",
    genre: "bass house,electro house",
    popularity: "42",
  },
  {
    name: "DJ Holiday",
    image: "https://i.scdn.co/image/8a7c5a2cb1068438b8bba4c60a1c589f63032515",
    spotify: "6Q4MFlysvdbBeEhoKgAUbY",
    genre: "atl trap",
    popularity: "42",
  },
  {
    name: "Dent May",
    image: "https://i.scdn.co/image/a4f782d635adc0067230beb2c0fcabbff61b913b",
    spotify: "34me8hAxavRmcDIwhxa3b7",
    genre: "indie fuzzpop,mississippi indie",
    popularity: "42",
  },
  {
    name: "Michael Woods",
    image: "https://i.scdn.co/image/dce57235a19e7289c3cbb70f7486cd693d4d5040",
    spotify: "3G1QoWkaZ1CUnTLUb0CqtC",
    genre: "progressive electro house,progressive house",
    popularity: "42",
  },
  {
    name: "ANOTR",
    image: "https://i.scdn.co/image/21d3ca6153b3226054f1b137badbf6f4f233d63f",
    spotify: "4p5WgeiPSPpqPDs7T6OkWf",
    genre: "dutch tech house,house,minimal tech house",
    popularity: "41",
  },
  {
    name: "Octo Octa",
    image: "https://i.scdn.co/image/7018923c6e167d95bf2be6130f1e6ff71424acf8",
    spotify: "2GH8Mzo3Ur1AdOnGUUpt17",
    genre:
      "art pop,bass music,deep house,electronica,float house,future garage,microhouse,outsider house,transpop",
    popularity: "41",
  },
  {
    name: "Ilario Alicante",
    image: "https://i.scdn.co/image/d9b2fefafb877b7efe952ce561e89868b41fcf75",
    spotify: "4dCGOzY3HL7dZnQ8XU7DDD",
    genre: "minimal tech house,minimal techno,tech house",
    popularity: "41",
  },
  {
    name: "Daniël Lohues",
    image: "https://i.scdn.co/image/bb6ef4a1af46f1b9277642af395d35814cf6e69a",
    spotify: "5hmWcPzWxojagG5Q8IMrI6",
    genre: "dutch indie,dutch pop,dutch rock,nederpop,streektaal",
    popularity: "41",
  },
  {
    name: "David Gravell",
    image: "https://i.scdn.co/image/daba16da4a11cfb2f6fad79cd7c90a2c55b331c2",
    spotify: "66B0qssqmVQXJGf9cmTNKi",
    genre: "progressive uplifting trance,trance,uplifting trance",
    popularity: "41",
  },
  {
    name: "Dynamite MC",
    image: "https://i.scdn.co/image/a166ee78debce76d64a666fac8528c0d38f00797",
    spotify: "5RBFw1UkHw2NBsZFtheDEl",
    genre: "drum and bass",
    popularity: "41",
  },
  {
    name: "Funkerman",
    image: "https://i.scdn.co/image/216304c30f1ed1be2a983c289e95a24ab6e9421e",
    spotify: "7ljL11SRgjkdqO8NqjJBVU",
    genre: "disco house,dutch tech house",
    popularity: "41",
  },
  {
    name: "Seth Schwarz",
    image: "https://i.scdn.co/image/91edc667cddaa73c07e30d77acfe5aa8ac5ce848",
    spotify: "0zUt9PboFsELRcvO7UWarr",
    genre: "german house",
    popularity: "41",
  },
  {
    name: "The Black Madonna",
    image: "https://i.scdn.co/image/55c7feca361bb60ccc10ce1f0dffff27655c3357",
    spotify: "2nNEvsyPzLwKVZrfkwLpNK",
    genre: "electra",
    popularity: "41",
  },
  {
    name: "Gene Farris",
    image: "https://i.scdn.co/image/6b1bab97ee7010c7c8c19ade8a39e3b6166e2e3d",
    spotify: "49qOEODA3n8HiVUY4uwJbU",
    genre: "chicago house,disco house,house",
    popularity: "41",
  },
  {
    name: "Luuk Van Dijk",
    image: "https://i.scdn.co/image/5fb5d48f12995701b0f343a027d2b36bcd265ae8",
    spotify: "1KFfk3NtblIJtGEqyiR31t",
    genre: "dutch tech house,house",
    popularity: "41",
  },
  {
    name: "Lisa Miskovsky",
    image: "https://i.scdn.co/image/3978e28ee9dd273b0f53b1a1a87917a1872b9c27",
    spotify: "5J0dXmqEYctfFsmcakqZFH",
    genre: "europop,swedish pop",
    popularity: "41",
  },
  {
    name: "Jochen Miller",
    image: "https://i.scdn.co/image/cd7cbf9cac3edccb3e165ae2631b1d1f32f6b214",
    spotify: "4I22x3YxEveEfbtVDj54H3",
    genre: "big room,dutch trance,progressive house,trance,uplifting trance",
    popularity: "41",
  },
  {
    name: "MC Mota",
    image: "https://i.scdn.co/image/3ff93c5f51162a1e1c90f0d62afaf787778e3837",
    spotify: "2kUNDOK5StemhF8zfPju2p",
    genre: "belgian edm",
    popularity: "41",
  },
  {
    name: "Hugh Hardie",
    image: "https://i.scdn.co/image/653180771efd44dcf2f97d02f9e4011b78aaa205",
    spotify: "0ZlH3VG6iAeC1KVzNz6rqW",
    genre: "drum and bass,liquid funk",
    popularity: "41",
  },
  {
    name: "Animal Trainer",
    image: "https://i.scdn.co/image/1c1e471632942f2f43b4591aad5e2e449a0ef000",
    spotify: "2bfx0bw0uVRyfikzS3h5Mg",
    genre: "deep euro house,swiss house,tech house",
    popularity: "41",
  },
  {
    name: "Serge Devant",
    image: "https://i.scdn.co/image/291454a96eaad22e64ed19f4b8a5e985094602b5",
    spotify: "41ZhnBiaqeoe6asIzVDvqP",
    genre: "organic house",
    popularity: "41",
  },
  {
    name: "Omnium Gatherum",
    image: "https://i.scdn.co/image/53cb4a6bc9bacce55931fb39b8ee2b07cc3eaee3",
    spotify: "52xuvlUvnxqH0xzxGPKXSu",
    genre:
      "finnish death metal,finnish metal,melodic death metal,melodic metal",
    popularity: "41",
  },
  {
    name: "Sharam",
    image: "https://i.scdn.co/image/8c80dcd4fe0e6a0304bcfd81fb2af4ca35c09d53",
    spotify: "7rVEQZBDtYmToQaYOQJCm2",
    genre: "disco house",
    popularity: "41",
  },
  {
    name: "Dixon",
    image: "https://i.scdn.co/image/0e1d3c09088e067648972689351ea5461d3098f8",
    spotify: "3wc57nV2fGEoM8x4xPK1O9",
    genre: "german house",
    popularity: "41",
  },
  {
    name: "Opgezwolle",
    image: "https://i.scdn.co/image/8b7a72178ca851fbd93ac0c8d40cd557ac0cffe1",
    spotify: "0lYZJXC0yZWGt1HdzZUd7L",
    genre: "dutch hip hop,dutch rock",
    popularity: "41",
  },
  {
    name: "Joey Dale",
    image: "https://i.scdn.co/image/027b5ed7a72d54f10fa05635d62910c1995ffce5",
    spotify: "3QjbhhPrW6clls3VPRGkXu",
    genre:
      "big room,deep big room,electro house,progressive electro house,sky room",
    popularity: "41",
  },
  {
    name: "Mark Villa",
    image: "https://i.scdn.co/image/bb97e5b3fbcbb982bd31acc69d569dcdcaacd888",
    spotify: "5WClIOxkXF0aG93CLEC96i",
    genre: "sky room",
    popularity: "41",
  },
  {
    name: "KATERINA",
    image: "https://i.scdn.co/image/ab67616d0000b273659c6d73e812ab07e0bbe9d4",
    spotify: "5EcSLRqj4lq4zbacatpZJC",
    genre: "",
    popularity: "41",
  },
  {
    name: "Michael Klein",
    image: "https://i.scdn.co/image/fcf268019559769882126c3bffe01b17b6804d93",
    spotify: "1CIuNl1eWjkoPrhWdMK8L6",
    genre: "frankfurt electronic",
    popularity: "41",
  },
  {
    name: "Maxim Lany",
    image: "https://i.scdn.co/image/d92e7607aa28f65d09392a45055e49f648228def",
    spotify: "3yGz81qZItOli1RL5vgUeB",
    genre: "belgian edm",
    popularity: "41",
  },
  {
    name: "Poppy Ackroyd",
    image: "https://i.scdn.co/image/0715b8754ea06a667b5fb4499bbcee67ac8944e6",
    spotify: "5q3wKuiaCK8BRPZQSvehFd",
    genre: "bow pop,compositional ambient,focus,neo-classical",
    popularity: "41",
  },
  {
    name: "La Sra. Tomasa",
    image: "https://i.scdn.co/image/039dee9fd12450e8a3be53bf7f05e5ad56e3f995",
    spotify: "51CWOiWc0Ell65542Yr4Dv",
    genre: "reggae catala,rumba catalana",
    popularity: "41",
  },
  {
    name: "DV8",
    image: "https://i.scdn.co/image/ab67616d0000b2730e17f7973d20e390ec4cbf0a",
    spotify: "3C2rdG9aJ0CBfFSKmdzcTf",
    genre: "",
    popularity: "41",
  },
  {
    name: "Jens Hult",
    image: "https://i.scdn.co/image/51b5645ef2101c321ba45945f712a07b6522577a",
    spotify: "0BL04H8MiD3g762tT3lQXu",
    genre: "swedish idol pop,swedish pop",
    popularity: "41",
  },
  {
    name: "Aquarium",
    image: "https://i.scdn.co/image/6824b30c4efcf39fe1c6b3594b7a096e58ccd7c0",
    spotify: "3nAumcukmBxn8y7Su8RagW",
    genre: "classic russian rock,russian rock",
    popularity: "41",
  },
  {
    name: "Tina Dico",
    image: "https://i.scdn.co/image/5f54985f9ac45f1b4d74fdb9ae1ff1633888a164",
    spotify: "6AHLjrNUzvqs8jg5JntmeL",
    genre: "folk-pop",
    popularity: "41",
  },
  {
    name: "Lowkey",
    image: "https://i.scdn.co/image/62b7202b62e0a9e658977d657c1a50f6255f8093",
    spotify: "7lNJ1ZVAHcx6V4HqC68xRY",
    genre: "conscious hip hop,grime,political hip hop",
    popularity: "41",
  },
  {
    name: "Darren Porter",
    image: "https://i.scdn.co/image/5977f28104fc956253aaaa499fdc934eab98a9b0",
    spotify: "04b2pmUXaBL8wHacSaOplA",
    genre:
      "progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "41",
  },
  {
    name: "Frente Cumbiero",
    image: "https://i.scdn.co/image/5438e75cdf3e016a937d64149c9e6f2de43e83e0",
    spotify: "7r6KiZDjtZqBWp5jaDgxA6",
    genre: "chicha,cumbia,nu-cumbia",
    popularity: "41",
  },
  {
    name: "Martin Roth",
    image: "https://i.scdn.co/image/e31630e7f49de48a9b9123f4cef12190f84bbaf9",
    spotify: "4LoSbPey3kklzX5f2KEks1",
    genre: "progressive house",
    popularity: "41",
  },
  {
    name: "Telefon Tel Aviv",
    image: "https://i.scdn.co/image/e49a37cfcd54604e3804f79066da3d60d0da4d50",
    spotify: "53N4oJpWtmnB0KGLLserGC",
    genre:
      "drill and bass,electronica,glitch,indietronica,intelligent dance music,microhouse",
    popularity: "41",
  },
  {
    name: "Aleksandir",
    image: "https://i.scdn.co/image/0f47d2d21c7a93ca2ef1a3586f10ae88b9c99e3c",
    spotify: "671aO7xxWHFDZ4Y115H89b",
    genre: "ambient house,float house",
    popularity: "41",
  },
  {
    name: "El Mundo",
    image: "https://i.scdn.co/image/1b87f76cb8482a32954f5a57d42712bb26c78729",
    spotify: "2P98rkELDQVyC1olsD2Cej",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "41",
  },
  {
    name: "Kevin Knapp",
    image: "https://i.scdn.co/image/beba261154c91ee8b60ccc7c0973927a60257163",
    spotify: "1qhZdOpfyWk2RbhTCpbAkv",
    genre: "",
    popularity: "41",
  },
  {
    name: "Soul Clap",
    image: "https://i.scdn.co/image/66de9a41220fb56ea46689837a7acf4ea1fd6974",
    spotify: "0PEfTatx7R08s3nFrn9teD",
    genre: "boston electronic,deep disco house",
    popularity: "41",
  },
  {
    name: "Vertical Mode",
    image: "https://i.scdn.co/image/ab67616d0000b27383e6f614ebdfa35bae8d547d",
    spotify: "4wwpaTO20ncf1JS1OnsR9o",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "41",
  },
  {
    name: "Superlover",
    image: "https://i.scdn.co/image/c007e724872679af64ad32ded84ea077ca4d2769",
    spotify: "4OxEbB5MV7rDnbYtWUL1UO",
    genre: "german house",
    popularity: "41",
  },
  {
    name: "Pantha Du Prince",
    image: "https://i.scdn.co/image/0b5c65392b3a7d46e792fbcd674bced849d4c28f",
    spotify: "7Go2Fj2YWEQkYBqTVQArYi",
    genre: "electronica,hamburg electronic,microhouse,minimal techno",
    popularity: "41",
  },
  {
    name: "LOUDPVCK",
    image: "https://i.scdn.co/image/e1ad0c2c485d82f662161d9f3c00b34d52297b17",
    spotify: "0rQ0WMIrOt6MzfiGaNWh3D",
    genre: "bass trap,brostep,electronic trap",
    popularity: "41",
  },
  {
    name: "Phlegmatic Dogs",
    image: "https://i.scdn.co/image/590688221da0a78cac6ae2caadf15998e930c3ea",
    spotify: "3g5Lhsq7cSJEK39BzKgIUe",
    genre: "bass house,electro house",
    popularity: "41",
  },
  {
    name: "Het Zesde Metaal",
    image: "https://i.scdn.co/image/f4143c4988ca64c6f1a908588c0c7178c138aa8f",
    spotify: "0BqOXpkslA5Kxud9UXi2yG",
    genre: "belgian rock,classic belgian pop,kleinkunst",
    popularity: "41",
  },
  {
    name: "Patrick Sweany",
    image: "https://i.scdn.co/image/55c71c0c24741e5dfab2575c21a4089ef379b5f0",
    spotify: "35mDUnsSVfkJpgjIXHsPC5",
    genre: "deep new americana,modern blues rock",
    popularity: "41",
  },
  {
    name: "Rafa Barrios",
    image: "https://i.scdn.co/image/977327909c7567259478b1dcb92642c821da1f26",
    spotify: "6nl0PkJi7Xog1gon9f6WIl",
    genre: "latin tech house",
    popularity: "41",
  },
  {
    name: "Saul Williams",
    image: "https://i.scdn.co/image/655a1fd740046fa33167e5be8ef984ca6d5c38f7",
    spotify: "11K0HIZKfdB6ez0VhIgxPm",
    genre:
      "alternative hip hop,conscious hip hop,industrial hip hop,lgbtq+ hip hop,slam poetry",
    popularity: "41",
  },
  {
    name: "Emika",
    image: "https://i.scdn.co/image/171e6882a86dcbfc5c133ef890a5fa4776307362",
    spotify: "50Gx1SNB4vH2V7peIiYD4S",
    genre: "",
    popularity: "41",
  },
  {
    name: "Guy J",
    image: "https://i.scdn.co/image/39ca845ab482a54859d274c72d22dcf71392bfa1",
    spotify: "7Em4kWZ5atMYknHwSkp3gD",
    genre: "israeli techno,organic house,tech house",
    popularity: "41",
  },
  {
    name: "Laolu",
    image: "https://i.scdn.co/image/864f643f76914b82ce902417dc27bb7ba64212f2",
    spotify: "53PSeUFq8tMZc0zdd1oUTG",
    genre: "",
    popularity: "41",
  },
  {
    name: "Maite Hontelé",
    image: "https://i.scdn.co/image/e405db9cea3bb7869323dd709ac19fdb6645ac42",
    spotify: "1Pe4MoTbike2NZeexUUBrU",
    genre: "modern salsa,salsa colombiana,salsa international",
    popularity: "41",
  },
  {
    name: "GMS",
    image: "https://i.scdn.co/image/ab67616d0000b27362a061fb227c87c5a6a15348",
    spotify: "1jLsr1sNO2WshuzmSibSIt",
    genre: "full on,psychedelic trance",
    popularity: "41",
  },
  {
    name: "Thyron",
    image: "https://i.scdn.co/image/a2087b0bcb593438e8b18c76235bbdfa320ec849",
    spotify: "75jOSvJYkVT21xz5yll1xM",
    genre: "hardstyle,rawstyle,uptempo hardcore",
    popularity: "41",
  },
  {
    name: "Tightill",
    image: "https://i.scdn.co/image/1b7397a9b7abeb37992206086e32351ad5400006",
    spotify: "1IFH0F0gJflXkbdsCIngr8",
    genre: "german cloud rap,indie deutschrap",
    popularity: "41",
  },
  {
    name: "Jack Parow",
    image: "https://i.scdn.co/image/69a9a48a6d38df2a032e6a13caddad9122dacdbc",
    spotify: "2zzOTg1SHx5vuqgcexJRxA",
    genre:
      "african rock,south african alternative,south african hip hop,south african pop",
    popularity: "41",
  },
  {
    name: "Tre Burt",
    image: "https://i.scdn.co/image/c3151269ab8a77fb3b95ff5c691649141e8bcd19",
    spotify: "5e5Zm5z8OPycf55hgDxKIc",
    genre: "alternative country,deep new americana,indie folk",
    popularity: "41",
  },
  {
    name: "Andy Summers",
    image: "https://i.scdn.co/image/f99147e6d64c5343fac5212529d4853f24e23ffc",
    spotify: "3rHBApuFwaJy65f7vWQJLr",
    genre: "jazz fusion",
    popularity: "41",
  },
  {
    name: "Sinkane",
    image: "https://i.scdn.co/image/f5dcc1f7de296dbfd0951174dec11f172e2c35c7",
    spotify: "0ip3L7jX2aq8T1VTJRFZ9w",
    genre: "sudanese pop",
    popularity: "41",
  },
  {
    name: "Krafty Kuts",
    image: "https://i.scdn.co/image/cc71fbcb22deee596cad70d7d05514ec6d5e7360",
    spotify: "6Ebt7JHILWJCE7aR7JLFB2",
    genre: "big beat,breakbeat,nu skool breaks",
    popularity: "41",
  },
  {
    name: "Keywest",
    image: "https://i.scdn.co/image/2620599f9c38842ad29fd1641e15fcf866c758fa",
    spotify: "5n9E5vGRtLsPzqk39eA29T",
    genre: "irish pop",
    popularity: "41",
  },
  {
    name: "Fort Romeau",
    image: "https://i.scdn.co/image/eb7d0ddfe78f78cc3631f2435d77b9cd09acf48e",
    spotify: "5MKqWyqq5CStK7AhkTvzQF",
    genre: "deep house,float house,microhouse,tech house",
    popularity: "41",
  },
  {
    name: "Sesto Sento",
    image: "https://i.scdn.co/image/ab67616d0000b273d0d96a967e70f18d7c19c616",
    spotify: "1mFl3WqgDgAirBKMnoYLLN",
    genre: "full on,psychedelic trance",
    popularity: "41",
  },
  {
    name: "Lirical",
    image: "https://i.scdn.co/image/fcbe2c7ec0e3c660cdb72f0f73840250a791e25e",
    spotify: "2H0j2bWQRjJWzcGIjnl7nX",
    genre: "dutch moombahton",
    popularity: "41",
  },
  {
    name: "Nubiyan Twist",
    image: "https://i.scdn.co/image/20fa9be0dbac0ac26a5bf2c6a7b56147d009a749",
    spotify: "5HNkGissAKlCv88sus7rVO",
    genre: "indie jazz,indie soul,neo r&b,uk contemporary jazz",
    popularity: "41",
  },
  {
    name: "Full Of Hell",
    image: "https://i.scdn.co/image/7bc4786f69918cffabe5c0d4f76cb7b7614f97ce",
    spotify: "1i5rlthy5CmAYWaFOB0jhz",
    genre: "chaotic hardcore,noisecore,post-doom metal,powerviolence",
    popularity: "41",
  },
  {
    name: "Just Emma",
    image: "https://i.scdn.co/image/239699317c498701fdc0b131794bf995273fe90f",
    spotify: "44I8GQC5kYJZe882xberrg",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "41",
  },
  {
    name: "The Pack a.d.",
    image: "https://i.scdn.co/image/00be1d607cbe2c911fe2cfe5197c8492a7bffd59",
    spotify: "2gbOUPIhea9nrCmAeZBgpo",
    genre:
      "canadian garage rock,garage rock,garage rock revival,modern alternative rock,modern blues rock,punk blues,vancouver indie",
    popularity: "41",
  },
  {
    name: "Chris Robinson Brotherhood",
    image: "https://i.scdn.co/image/755aabcab55a5465b03cf35f8208025e08aa1dbe",
    spotify: "7Jgf8XBIsOlXS1XOTOwz4A",
    genre: "blues rock,jam band",
    popularity: "41",
  },
  {
    name: "Minhtendo",
    image: "https://i.scdn.co/image/ab67616d0000b27391d29f76e021a2bbe9257f58",
    spotify: "0LO0TMeNpSpHtpddtiliRm",
    genre: "",
    popularity: "41",
  },
  {
    name: "Milo Meskens",
    image: "https://i.scdn.co/image/123c0963aff9b1933f86d36a8fb67e10dbf6b316",
    spotify: "2os0uvECng2MYlxDj5iEbc",
    genre: "belgian pop",
    popularity: "41",
  },
  {
    name: "Luude",
    image: "https://i.scdn.co/image/3ca9e0893ab47ec74ce4f6e54eeb680d616ec3d2",
    spotify: "20cmhoGvN0eyzhmsHJH1Mg",
    genre: "aussietronica",
    popularity: "41",
  },
  {
    name: "Robert Abigail",
    image: "https://i.scdn.co/image/caf366b8c3f8d93918f808205c162333fca167eb",
    spotify: "19XebWXDJ92dgKr1E4fn1O",
    genre: "belgian edm",
    popularity: "41",
  },
  {
    name: "Krowdexx",
    image: "https://i.scdn.co/image/1328f4743fd66ffdd13113044d42fe9ea326f96d",
    spotify: "7Ecbym3UD6q848BAse6Qeb",
    genre: "hardstyle,rawstyle,uptempo hardcore",
    popularity: "41",
  },
  {
    name: "Teitur",
    image: "https://i.scdn.co/image/456f4c1f4e464f4f838829ff4180bdb0a78cd704",
    spotify: "1lrjRRYpYP8kVTlHLShjJM",
    genre: "faroese pop",
    popularity: "41",
  },
  {
    name: "Joe Pug",
    image: "https://i.scdn.co/image/f74303d96edcbcc3c3850dd688f3aced317fd1ea",
    spotify: "17cssIaAwAcgC9nZZliixv",
    genre: "deep new americana,indie folk,new americana,stomp and holler",
    popularity: "41",
  },
  {
    name: "Dauwd",
    image: "https://i.scdn.co/image/5b8dfb3965ae97de6248ca39264ef9c6ad902f5b",
    spotify: "25TUFIkK2VpEjl6GnzrcEp",
    genre:
      "ambient house,bass music,electronica,float house,future garage,microhouse,substep,wonky",
    popularity: "41",
  },
  {
    name: "Culprate",
    image: "https://i.scdn.co/image/a4fbb45c37ca7d33ceedcf54de2acf2f5ff64923",
    spotify: "7q7puZ5wtpfQe3doDb4834",
    genre: "brostep,filthstep",
    popularity: "41",
  },
  {
    name: "Daniel Lemma",
    image: "https://i.scdn.co/image/fd9115b0002ac43a00568c8e23c073a8c46f558c",
    spotify: "14ch8ZI4tN3IlWAAchEKeS",
    genre: "swedish soul",
    popularity: "41",
  },
  {
    name: "Dum Dum Girls",
    image: "https://i.scdn.co/image/550eede7068153f24c76500004ce3413cd028ba6",
    spotify: "65ewrL6LvcNGMMRVlksNGS",
    genre: "la indie,noise pop,nu gaze",
    popularity: "41",
  },
  {
    name: "DV8 Rocks!",
    image: "https://i.scdn.co/image/ab67616d0000b273ddd0e45dabede53b3ff21804",
    spotify: "5NUaGHWxd57phABMyucacm",
    genre: "",
    popularity: "41",
  },
  {
    name: "Dee Dee Bridgewater",
    image: "https://i.scdn.co/image/e6b45550b11ef74552a64a20a799bddf92e5862d",
    spotify: "2H3xDjMmp31iLmsgXxLFyI",
    genre: "contemporary vocal jazz,jazz blues,vocal jazz",
    popularity: "41",
  },
  {
    name: "Davey Asprey",
    image: "https://i.scdn.co/image/59d96f27c898376a8040667c57178f1e46ce9b8e",
    spotify: "7luLRXGBygBN8vUO8T9uHf",
    genre:
      "progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "41",
  },
  {
    name: "Shary-An",
    image: "https://i.scdn.co/image/6c631a435fdd2379bb51b4e5dd3b4d04db923a48",
    spotify: "4YJo8C4fQjZXRewIuH6rnc",
    genre: "",
    popularity: "41",
  },
  {
    name: "Betsie Larkin",
    image: "https://i.scdn.co/image/da88d92702b6878d222f37a136eaf469540257ad",
    spotify: "60pOmdZFfpHQdN9QOnMJcP",
    genre: "deep uplifting trance,vocal trance",
    popularity: "41",
  },
  {
    name: "The Pretty Things",
    image: "https://i.scdn.co/image/c54ecd7b42b982b97397a08a1e4b5ed4f831036e",
    spotify: "5U16QlMnlSAhkQxBZpLyLO",
    genre:
      "art rock,blues rock,british blues,british invasion,classic garage rock,classic rock,country rock,experimental,folk rock,freakbeat,merseybeat,protopunk,psychedelic rock,pub rock",
    popularity: "41",
  },
  {
    name: "Technasia",
    image: "https://i.scdn.co/image/0c7e53ef7595808d323880bc90be08142514c3a9",
    spotify: "0rnKlPis7AQgoIe2NEVWa5",
    genre: "french tech house,minimal techno,techno",
    popularity: "40",
  },
  {
    name: "diMaro",
    image: "https://i.scdn.co/image/40e4534e714a2c1a0e8509645fa954831b4005f5",
    spotify: "2cCkEcNkCDJEeX6aT7LdUb",
    genre: "belgian edm",
    popularity: "40",
  },
  {
    name: "Lester Williams",
    image: "https://i.scdn.co/image/9abb2249a027e3671ff249424420fde1c4b8b88c",
    spotify: "3V3FoZVMIZkrolqMyZk2Fd",
    genre: "belgian edm,deep big room",
    popularity: "40",
  },
  {
    name: "Barja",
    image: "https://i.scdn.co/image/d93394f14b34a0ecfcf776c152f0ab511eb33a25",
    spotify: "5uBR08vndaYNR50ZqRWthK",
    genre: "brazilian edm",
    popularity: "40",
  },
  {
    name: "Dr Rude",
    image: "https://i.scdn.co/image/2f8e9666ffb55911a05b5ab701892beb8d2a8117",
    spotify: "5akubyqg9eYtnCtDEeJz2s",
    genre: "hardstyle,rawstyle",
    popularity: "40",
  },
  {
    name: "Moxie",
    image: "https://i.scdn.co/image/ab67616d0000b273113318a0e2caaa51f0ca28e4",
    spotify: "3E30ZSiwKkH5metTilWgZn",
    genre: "",
    popularity: "40",
  },
  {
    name: "Typhoon",
    image: "https://i.scdn.co/image/e48bf7dad917d592606898dfbc20976338035b14",
    spotify: "6p6WlxIkeWH8yOYvciFfVl",
    genre: "chamber pop,portland indie,stomp and holler",
    popularity: "40",
  },
  {
    name: "Daniel Romano",
    image: "https://i.scdn.co/image/33721af3a980828a3f44be21ed13ad108939a773",
    spotify: "2kTXvMOmrHVjVewErG5kHD",
    genre:
      "alternative country,canadian americana,canadian country,canadian singer-songwriter,deep new americana,indie folk,new americana",
    popularity: "40",
  },
  {
    name: "Handsome Poets",
    image: "https://i.scdn.co/image/a9085712e8ddd52d21211b9fc99fa277ec8a0fd4",
    spotify: "35QzzTbrIC5pc3BgxyVGS5",
    genre: "dutch indie,dutch indie rock,dutch rock",
    popularity: "40",
  },
  {
    name: "Henry Saiz",
    image: "https://i.scdn.co/image/35fc209791c8b1e201ff998c4fae079ff80d364f",
    spotify: "1f5QPXLfjlzlG77lCkdl0W",
    genre: "organic house,spanish techno,tech house",
    popularity: "40",
  },
  {
    name: "Requiem",
    image: "https://i.scdn.co/image/ab67616d0000b2730460646fac9d6bee35106dbd",
    spotify: "7ExhZknNhpqrJcwB9JZY8T",
    genre: "",
    popularity: "40",
  },
  {
    name: "John Talabot",
    image: "https://i.scdn.co/image/d6b535e59b01f4a2c8da04f6c5dcd93d3183311b",
    spotify: "1YvN5uOGQkHVUUlZUcnotD",
    genre: "balearic,electronica,float house,microhouse",
    popularity: "40",
  },
  {
    name: "Aparde",
    image: "https://i.scdn.co/image/bfaf91d9f6fdf12370a5f2608aa00ee5600e21ed",
    spotify: "2EX6hgMIUZhPty734qcBaS",
    genre: "",
    popularity: "40",
  },
  {
    name: "Heatbeat",
    image: "https://i.scdn.co/image/5e940ed566f6373bec39d6ba9ffdbdaf477ce391",
    spotify: "4FuFFzlzYgn3Yu2rxLhvdN",
    genre:
      "deep uplifting trance,progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "40",
  },
  {
    name: "Hydraulix",
    image: "https://i.scdn.co/image/7818ac3394ba2f840436ad493b4299201fbac392",
    spotify: "0v6pkn5nWfqK3vgeg0gl0W",
    genre: "",
    popularity: "40",
  },
  {
    name: "Unsenses",
    image: "https://i.scdn.co/image/cd7c5f6e3fd72522aaaffb8fe72c4908cd027d4d",
    spotify: "5ezp2WTBB8rewVCdTKGO1F",
    genre: "euphoric hardstyle,hardstyle",
    popularity: "40",
  },
  {
    name: "Krakota",
    image: "https://i.scdn.co/image/58c77ea3eadaf5f24ddf107f49dc546b7f0eceed",
    spotify: "6NkoAm5Dd1wguz0ATgZKlF",
    genre: "deep dnb,liquid funk",
    popularity: "40",
  },
  {
    name: "Ibranovski",
    image: "https://i.scdn.co/image/d0e6f7e90b5a4cb651bced1c18451b4970d60e1d",
    spotify: "5ASWBtbVe1yfxjrCuREQ4p",
    genre: "bass house,deep big room,electro house,electronic trap,sky room",
    popularity: "40",
  },
  {
    name: "Tom Trago",
    image: "https://i.scdn.co/image/651ad61408e35822896989450a3fe01198b884ba",
    spotify: "2vUpX2Zq1DBdCHuoEnmzkK",
    genre: "dutch house",
    popularity: "40",
  },
  {
    name: "Carmada",
    image: "https://i.scdn.co/image/7dbd6d7933cda7676a15162c8e14364adbf8dc5a",
    spotify: "4R3mzuQZhfwDkjdE1wx31O",
    genre: "aussietronica",
    popularity: "40",
  },
  {
    name: "Jennie Lena",
    image: "https://i.scdn.co/image/f90a100724860a70ea4f2281c3cdf1c0ba6dbac1",
    spotify: "69YjsiBzjT9ZPbngJlO0Rm",
    genre: "dutch pop",
    popularity: "40",
  },
  {
    name: "CcL",
    image: "https://i.scdn.co/image/ab67616d0000b273d8302f01aec509d7257e30ee",
    spotify: "4lBNPDw8J0hvKqZ1jB5Snq",
    genre: "",
    popularity: "40",
  },
  {
    name: "Marcus Worgull",
    image: "https://i.scdn.co/image/7fa2ac48500302d502d71efb61a034d48b09d0ec",
    spotify: "4N2PiVgTuh2rxhc3HGVKAG",
    genre: "german house",
    popularity: "40",
  },
  {
    name: "Onderkoffer",
    image: "https://i.scdn.co/image/812d694229d778db57534f54ddc95e0e998548d9",
    spotify: "6gce3osfgmB2RCMqoKfwFe",
    genre: "",
    popularity: "40",
  },
  {
    name: "Jeremias",
    image: "https://i.scdn.co/image/237136403f9c7bf657c80c3ff9154a31b26c26d7",
    spotify: "1QWZE0CuKISG4P68ykP56E",
    genre: "ecuadorian pop,pop reggaeton",
    popularity: "40",
  },
  {
    name: "Silje Nergaard",
    image: "https://i.scdn.co/image/c946a2940b9380701d7c31745d9fbdc2de72f76b",
    spotify: "3hCQUVIcg8nWvkZToF4rqc",
    genre: "contemporary vocal jazz,norwegian jazz,swedish jazz,vocal jazz",
    popularity: "40",
  },
  {
    name: "Kira Puru",
    image: "https://i.scdn.co/image/7396dd3609d63c217d6df02fa7cbef0d012558fc",
    spotify: "4tqKQAZcPhjqMmHaVRGHaY",
    genre: "australian electropop,australian pop",
    popularity: "40",
  },
  {
    name: "Sam Blans",
    image: "https://i.scdn.co/image/690b6f0bbc0b533f0fd8d28b46e537ca7c4a7f2a",
    spotify: "3aqsqogSTXrUJdcnFySUMi",
    genre: "basshall,dutch moombahton,dutch trap pop",
    popularity: "40",
  },
  {
    name: "ANGELZ",
    image: "https://i.scdn.co/image/3e9497d5d08427daa6cc3e77e08bebe3425a6ed0",
    spotify: "7tbMem2T4rnyYKXiUYJPCn",
    genre: "bass house,electro house",
    popularity: "40",
  },
  {
    name: "Tine Thing Helseth",
    image: "https://i.scdn.co/image/6c4fde0dd7d670e7f6d5b09f6a747807b199a54e",
    spotify: "6FbYyIZHMrBfvFJ8bidDcQ",
    genre: "classical performance,classical trumpet",
    popularity: "40",
  },
  {
    name: "Timomatic",
    image: "https://i.scdn.co/image/e678eaf70ddde5abec320a86a507f59edf4d9fa8",
    spotify: "3jEg5HvT2cuJQDjwjZxTb0",
    genre: "australian pop",
    popularity: "40",
  },
  {
    name: "JazziDisciples",
    image: "https://i.scdn.co/image/0df74891bb8ff8d173bd24a04cbd03608eb22a04",
    spotify: "0Mu3PMBPwtQh5iggGTmudK",
    genre: "afro house,amapiano,kwaito house,south african pop",
    popularity: "40",
  },
  {
    name: "Shimza",
    image: "https://i.scdn.co/image/f923f5ec2abbb02125875faf4c1cc88ad05faac5",
    spotify: "0WHbjg8hVel1R9kq5794HX",
    genre: "afro house,kwaito house",
    popularity: "40",
  },
  {
    name: "Brian Cross",
    image: "https://i.scdn.co/image/9b97cec6794ceba8e2128a631e7bfb01402affaf",
    spotify: "6hKA4fRHqmcL8WYEmJfCaY",
    genre: "",
    popularity: "40",
  },
  {
    name: "Trippin Jaguar",
    image: "https://i.scdn.co/image/e5dd2f44b9407fb5692e72be7fc0e37ea852b053",
    spotify: "6Fxw93ezsZRlLdYWxyHqO0",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "40",
  },
  {
    name: "Truth",
    image: "https://i.scdn.co/image/1da826cf7e256b6a51fe23e2fbd230c8e358b2e0",
    spotify: "0ZDCCJSvjcdJZH9hOl1uYc",
    genre: "deep dubstep,dubstep,nz dnb,nz electronic",
    popularity: "40",
  },
  {
    name: "Shogun",
    image: "https://i.scdn.co/image/bf1fc9e9bf65a5d4898c0bb2a495244098a876cf",
    spotify: "6diiyZ15AVZoSxzAyjIYJT",
    genre:
      "deep uplifting trance,progressive house,progressive uplifting trance,trance,uplifting trance",
    popularity: "40",
  },
  {
    name: "Polynation",
    image: "https://i.scdn.co/image/055ec8a4bb1fa94263b3353313f9c251967c2470",
    spotify: "4Rcol4u0q89lypqKI83GDz",
    genre: "ambient house,electronica,organic electronic",
    popularity: "40",
  },
  {
    name: "Loco Dice",
    image: "https://i.scdn.co/image/5e8041cae1fd68ea9ae53cb2f514efda451ee3bd",
    spotify: "4rbw4Z9Hjn6n9x5oYzZe7P",
    genre:
      "german techno,microhouse,minimal tech house,minimal techno,tech house",
    popularity: "40",
  },
  {
    name: "Kid de Blits",
    image: "https://i.scdn.co/image/082535022271458132419d8b902df0945f013b31",
    spotify: "5geBneZf2rfQaLDUVkQBFn",
    genre: "dutch hip hop",
    popularity: "40",
  },
  {
    name: "Sneijder",
    image: "https://i.scdn.co/image/c10c92429733ccbc06f2111ce37b30ad02ec5fb4",
    spotify: "4zllvElH16KlgTqRstwYIb",
    genre:
      "deep uplifting trance,progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "40",
  },
  {
    name: "Nino Brown",
    image: "https://i.scdn.co/image/ab67616d0000b273961d8e5fdb65fa4570faceff",
    spotify: "2OT8Y69ZmFlwMCmqXNJMih",
    genre: "chicano rap",
    popularity: "40",
  },
  {
    name: "Hard Rock Sofa",
    image: "https://i.scdn.co/image/38d910546ba8b1a9a0941e1b6a9cdcf87fa9c2fe",
    spotify: "6iBOcuDTJKItKor6YfzZa9",
    genre: "big room,edm,electro house,progressive electro house",
    popularity: "40",
  },
  {
    name: "Brian Kennedy",
    image: "https://i.scdn.co/image/ab67616d0000b2737df86b82b46a8366e859fffe",
    spotify: "4xZbU7XXrgG0U2e3MIEXmS",
    genre: "irish singer-songwriter",
    popularity: "40",
  },
  {
    name: "Nu:Tone",
    image: "https://i.scdn.co/image/ab67616d0000b2739b4c52f85f227508375e69c6",
    spotify: "7pDBRy9uWy1zq5b0uXIABQ",
    genre: "drum and bass,drumfunk,jump up,liquid funk,uk dnb",
    popularity: "40",
  },
  {
    name: "Jaimi Faulkner",
    image: "https://i.scdn.co/image/df3ba65d8cf857b5196db8b838fca9fc8759c9e3",
    spotify: "1J6JaPeWiuT4oEa4oiEALf",
    genre: "",
    popularity: "40",
  },
  {
    name: "Flashmob",
    image: "https://i.scdn.co/image/3b957b5737507e48dd98f06575c4ca873869d859",
    spotify: "7xo0kZGwplHhSh8ORbToS8",
    genre: "italian tech house",
    popularity: "40",
  },
  {
    name: "Brushy One String",
    image: "https://i.scdn.co/image/ab67616d0000b273a7eb7e4119ffac4ff922413a",
    spotify: "5XV7hYBGbvqHRFDBj2fTfO",
    genre: "",
    popularity: "40",
  },
  {
    name: "Kapelle Petra",
    image: "https://i.scdn.co/image/c3861141d1952881c9dc84d0739d5c7b5f105f31",
    spotify: "0AqWbspCaJBnrvCcOi8OXe",
    genre: "german indie,german pop,german rock,liedermacher",
    popularity: "40",
  },
  {
    name: "Gab Rhome",
    image: "https://i.scdn.co/image/2cde3edcc8116f51d1c49594cd62a9ff2fc5860a",
    spotify: "3VXMcHmS4xk3cacv4oXWKI",
    genre: "arab electronic,canadian house,ethnotronica,organic house",
    popularity: "40",
  },
  {
    name: "Deep Dish",
    image: "https://i.scdn.co/image/b7d6c9093e6b1f0b22a6e50decf55481f8ef9616",
    spotify: "720JYpdCgHuTmDeryW0wEA",
    genre: "disco house,diva house,tribal house,vocal house",
    popularity: "40",
  },
  {
    name: "Orlando Julius",
    image: "https://i.scdn.co/image/ca6fff9bfd4af29fb07e212f17416fb082a4e9ca",
    spotify: "5nmP3vKUqynlECpm2ura7L",
    genre: "afro-funk,afrobeat,afropop,highlife",
    popularity: "40",
  },
  {
    name: "Erin Rae",
    image: "https://i.scdn.co/image/ea0f0523872fc29a89ec5414b6b5388e447c83ea",
    spotify: "167VlZ0C0ewQbgKexRFcs6",
    genre: "indie folk,nashville americana,new americana",
    popularity: "40",
  },
  {
    name: "Milliarden",
    image: "https://i.scdn.co/image/39807c04343978008a2cc0fea66b9eadf261666f",
    spotify: "1GltDYqF7Pl8qKkIuN85GA",
    genre: "german indie,german pop,german punk rock,german rock",
    popularity: "40",
  },
  {
    name: "HAAi",
    image: "https://i.scdn.co/image/106988e09d0050716bb050cfdebb89def6371e0c",
    spotify: "0pkLgeB9j465x1QB2kRoy4",
    genre: "float house",
    popularity: "40",
  },
  {
    name: "Midnight Magic",
    image: "https://i.scdn.co/image/2a6c299147b9d863ba9e609e40b5766454e528cb",
    spotify: "3KuNrap7xPWVJCyBHAE4le",
    genre: "balearic,nu disco",
    popularity: "40",
  },
  {
    name: "Terravita",
    image: "https://i.scdn.co/image/6e8a67d2414edd16824b9769ec768665970ae4a4",
    spotify: "34krK3AW06onvB0x7mfkkN",
    genre: "brostep,filthstep,jump up,zapstep",
    popularity: "40",
  },
  {
    name: "Made In June",
    image: "https://i.scdn.co/image/c8228acfefc67e2b4e557b321e10a35d1de380a0",
    spotify: "0EJYJn2XaMcUMJHtduNwM2",
    genre: "dutch edm",
    popularity: "40",
  },
  {
    name: "Andy the Core",
    image: "https://i.scdn.co/image/349a8377a726a7d14e95fe7015861f138dccfea9",
    spotify: "3GEDzLFDpKR3tsq72ZRTP7",
    genre: "frenchcore,rawstyle,uptempo hardcore",
    popularity: "40",
  },
  {
    name: "Laibach",
    image: "https://i.scdn.co/image/73ae6f1ee283de7b482ea456ec197eefc5be436a",
    spotify: "7l4LQfvN4yz8zbK4WY0AAg",
    genre:
      "ebm,electro-industrial,experimental,industrial,industrial metal,industrial rock,martial industrial,slovenian indie,slovenian rock",
    popularity: "40",
  },
  {
    name: "Symba",
    image: "https://i.scdn.co/image/694798e34ebec585ab6497a7d28b439d399abde5",
    spotify: "06S3fr7xEES7e3QPXhu3ay",
    genre: "",
    popularity: "40",
  },
  {
    name: "Sascha Funke",
    image: "https://i.scdn.co/image/84141f6aa44e92cefdb31c1831fb6e625acc5bda",
    spotify: "1dDTkRz9WVOQr63enjJ1Yd",
    genre: "german techno,microhouse,minimal techno,tech house",
    popularity: "40",
  },
  {
    name: "Fokke Simons",
    image: "https://i.scdn.co/image/9f6a2a9c930ef2b0aa959a12772abfa983a2ba64",
    spotify: "6bdx9tCkHEg9ff61hu7xkI",
    genre: "",
    popularity: "40",
  },
  {
    name: "James Holden",
    image: "https://i.scdn.co/image/ee19817aa51d87a860b1cb2f3aa25f346ab6a74d",
    spotify: "15e0X6NuMsVuHi7AZhcfyI",
    genre:
      "chamber psych,electronica,microhouse,minimal techno,modular synth,uk experimental electronic",
    popularity: "40",
  },
  {
    name: "Froukje",
    image: "https://i.scdn.co/image/7066273df0a802e5e1659abb7c011f73e7d54544",
    spotify: "0uBVyPbLZRDNEBiA4fZUlp",
    genre: "dutch pop",
    popularity: "40",
  },
  {
    name: "Mani Orrason",
    image: "https://i.scdn.co/image/47118a5f06a10dcdf329ceb338c63baf0b57b922",
    spotify: "6Xy8dw47s5ZgDlr0isOLV2",
    genre: "german indie,icelandic indie",
    popularity: "40",
  },
  {
    name: "Jamaram",
    image: "https://i.scdn.co/image/159fa6d733c73b489eb05d16d3d2f93ad53b9596",
    spotify: "1ZorPJMjMj569PdFp8Ildc",
    genre: "german reggae",
    popularity: "40",
  },
  {
    name: "Toxpack",
    image: "https://i.scdn.co/image/3f498ec357ba636ed385a7d6bf728d790a716e66",
    spotify: "6g9QlNjjtL5nBdiCERG4Ro",
    genre: "german oi,german rock",
    popularity: "40",
  },
  {
    name: "Matt Dusk",
    image: "https://i.scdn.co/image/d5d33125df8836a4c86d09aadfac593ef36ea9b4",
    spotify: "1UbA3tvm40VqUsiFlJaPCs",
    genre: "contemporary vocal jazz",
    popularity: "40",
  },
  {
    name: "Dave Roelvink",
    image: "https://i.scdn.co/image/207d623c0b56084724eebc9bde2412c0017e8671",
    spotify: "0awqQLsNMZU3cFOVYKzFoe",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "40",
  },
  {
    name: "Bixiga 70",
    image: "https://i.scdn.co/image/422d27be534e11a4fddac8b7a0242e3f72515c4d",
    spotify: "6rUeHFntOV8tgpoUJvEthU",
    genre:
      "afrobeat brasileiro,afrofuturismo brasileiro,baile pop,brazilian indie,instrumental funk,latin afrobeat,nova mpb",
    popularity: "40",
  },
  {
    name: "Afriquoi",
    image: "https://i.scdn.co/image/a9e3d311feaede03afa142031b8876969c7a8859",
    spotify: "2WEEw0QrAOyeMHpeXnDqQT",
    genre: "african electronic",
    popularity: "40",
  },
  {
    name: "Bobina",
    image: "https://i.scdn.co/image/5e81204da0cf876fb56d06f1113d1513946e688f",
    spotify: "7H63wD8xWXAKdYVjZmE90B",
    genre:
      "deep uplifting trance,progressive house,progressive trance,progressive uplifting trance,russian trance,trance,uplifting trance",
    popularity: "40",
  },
  {
    name: "Karmon",
    image: "https://i.scdn.co/image/19c9fc09ce2c26c5166ebe35f61b7672571460a2",
    spotify: "5D23i7SCIXNP6GRHte99Md",
    genre: "deep disco house",
    popularity: "40",
  },
  {
    name: "Rotting Out",
    image: "https://i.scdn.co/image/1fc8c0480626e6e009b38503a6354f5319b3b464",
    spotify: "7tjMOkm52H3Qiz3ty2tbNw",
    genre:
      "alternative emo,chaotic hardcore,hardcore,melodic hardcore,metallic hardcore,straight edge",
    popularity: "40",
  },
  {
    name: "Signum",
    image: "https://i.scdn.co/image/39ddabfbfb4743b584d69a18985ec2639d44c907",
    spotify: "3UJW5QFKMNUAE4rcW3j9WZ",
    genre: "dutch trance,hard house,trance,uplifting trance",
    popularity: "40",
  },
  {
    name: "Jess Bays",
    image: "https://i.scdn.co/image/6ef4948b12cc70c6af0def9e31a8473b6c831f61",
    spotify: "5xEJ7FQOtIUMLdnKyZrvPB",
    genre: "",
    popularity: "40",
  },
  {
    name: "Ben Caplan",
    image: "https://i.scdn.co/image/fd7954dedbee8d2b489a88117e683f7bb4f5d7d2",
    spotify: "5eKwTB9ociIYxmAsVR0kXp",
    genre: "canadian americana,canadian folk,halifax indie",
    popularity: "40",
  },
  {
    name: "Hans Teeuwen",
    image: "https://i.scdn.co/image/ea176cde8f4392101dd73c4df21b5c4cf6d5716c",
    spotify: "7HHVKYQo7uk2347GOmPoPD",
    genre: "dutch cabaret,dutch rock",
    popularity: "40",
  },
  {
    name: "The Legends",
    image: "https://i.scdn.co/image/65aa778ceb5e931f524c8428d52d845cef8742dd",
    spotify: "0GSCJJOY6dLofAwE68vMPd",
    genre: "swedish indie pop",
    popularity: "40",
  },
  {
    name: "Sons Of Kemet",
    image: "https://i.scdn.co/image/39b67c2aa91481ecc8c58c422eddd69eab0feeca",
    spotify: "3pvRbmrqOyFxB2Eext4Dki",
    genre:
      "afrofuturism,british jazz,contemporary jazz,indie jazz,progressive jazz fusion",
    popularity: "40",
  },
  {
    name: "Get Well Soon",
    image: "https://i.scdn.co/image/1547e4b7f2d0170af1d3e4d0ee514ecc0beba8d1",
    spotify: "747B3lhFN6MsexRBAdYC9s",
    genre: "german indie",
    popularity: "40",
  },
  {
    name: "Pallbearer",
    image: "https://i.scdn.co/image/5b947b67806e8faf4aab60d10315494d2d62fbe4",
    spotify: "2yeEmsTQMNHBlS5dhWtuD1",
    genre: "doom metal,drone metal,epic doom,post-doom metal,psychedelic doom",
    popularity: "40",
  },
  {
    name: "Luka Bloom",
    image: "https://i.scdn.co/image/9236bd5b60652de53fb604365362dbdbd1ebc4ec",
    spotify: "39E69agNUFWOZEzO24bjpo",
    genre: "irish singer-songwriter",
    popularity: "40",
  },
  {
    name: "Sóley",
    image: "https://i.scdn.co/image/ea58629a0236f78d576be5e320ec025e51abb2d5",
    spotify: "7DtlawO7T5bsgq81EeHxwh",
    genre: "icelandic indie,icelandic pop",
    popularity: "40",
  },
  {
    name: "Will Varley",
    image: "https://i.scdn.co/image/571512cc47e709c5c9f740295aa89eec5b124032",
    spotify: "6sKGpXFS8bI6lKbRfhl52T",
    genre: "kent indie",
    popularity: "40",
  },
  {
    name: "KUSO GVKI",
    image: "https://i.scdn.co/image/363e3bd2ac0d7f7f54807acc316b0c70951f5436",
    spotify: "2kHPYRgRjUw4IlwS2N6FsS",
    genre: "indie deutschrap",
    popularity: "40",
  },
  {
    name: "Vibronics",
    image: "https://i.scdn.co/image/6656d46e0b34a7401460c2f963dc5dff0078d1f2",
    spotify: "1nLw9CVpFRIjloeNQZteT3",
    genre: "dub,dub reggae,uk dub,uk reggae",
    popularity: "40",
  },
  {
    name: "Dries Roelvink",
    image: "https://i.scdn.co/image/ab67616d0000b273c06fb1e40847fc9434eb24ce",
    spotify: "2eIeNd8ZrIkk8R4q3zud09",
    genre: "levenslied",
    popularity: "40",
  },
  {
    name: "Klopfgeister",
    image: "https://i.scdn.co/image/65be638e44702abdd1698f6a3915f7d06d162a56",
    spotify: "41LAOu9bAFfHPoLygR0uwg",
    genre: "german trance,progressive psytrance",
    popularity: "40",
  },
  {
    name: "Osrin",
    image: "https://i.scdn.co/image/e7beeddc28db03726a1e8a887d11b8706371290d",
    spotify: "70c48bioArCGTsN9pH04NT",
    genre: "swedish tropical house",
    popularity: "40",
  },
  {
    name: "Caius",
    image: "https://i.scdn.co/image/3b96510a052a885420d977e2d6493052935007df",
    spotify: "4IQxLwHL2e8JRPQ1kbMuwi",
    genre: "danish electropop",
    popularity: "40",
  },
  {
    name: "Fred Hersch Trio",
    image: "https://i.scdn.co/image/e10a85fc2b7290016ff6762c09c6a90d13eb8e72",
    spotify: "6iBvBotxtLvyFZoUPytqgP",
    genre: "contemporary jazz,contemporary post-bop,jazz trio",
    popularity: "40",
  },
  {
    name: "Amarfis y La Banda De Atakke",
    image: "https://i.scdn.co/image/ab67616d0000b273112983f0a86f21df820f27e2",
    spotify: "2xkpXmyV2GO5tX3AMdS5zl",
    genre: "merengue,tropical",
    popularity: "40",
  },
  {
    name: "Kill The Buzz",
    image: "https://i.scdn.co/image/3068f0d523b53a573a3dfa8baf4f7e8e67728f34",
    spotify: "0QZSzSj4BDYFARD2hZ7oNI",
    genre:
      "big room,deep big room,electro house,progressive electro house,sky room",
    popularity: "39",
  },
  {
    name: "Avalon Emerson",
    image: "https://i.scdn.co/image/311cf8e3353d3f8bcad65a5d320d33c39e6d473a",
    spotify: "4yrO1N273PlTaixa4BNwBz",
    genre: "electra,float house",
    popularity: "39",
  },
  {
    name: "Juicy M",
    image: "https://i.scdn.co/image/59ef0eb702d7bca5c587032da6e7ca82824b9fcf",
    spotify: "6klooWKc13AOY1BVfE0Tm6",
    genre: "deep big room,sky room,ukrainian electronic",
    popularity: "39",
  },
  {
    name: "Punish",
    image: "https://i.scdn.co/image/bbe1bdc342ccb543df3af304319231497a8fd0a8",
    spotify: "6kxe5ZNak3q4fkhE9V7WO1",
    genre: "",
    popularity: "39",
  },
  {
    name: "Kommil Foo",
    image: "https://i.scdn.co/image/0d2fc48c7305301539532b466f9eda7cf78ca703",
    spotify: "68X7EQtVYHuUAYoFilK3wE",
    genre:
      "belgian pop,belgian rock,classic belgian pop,kleinkunst,vlaamse cabaret",
    popularity: "39",
  },
  {
    name: "The Galaxy",
    image: "https://i.scdn.co/image/3463a97fa5f06faef29c5085791abe81c5acbe70",
    spotify: "1a7aOqigZ5aWIaagMLlHC4",
    genre: "",
    popularity: "39",
  },
  {
    name: "Nicole Moudaber",
    image: "https://i.scdn.co/image/00acd41a682f198e336ad158c3de7207f2641173",
    spotify: "7ixDtqtITfqx5lZQGh5gKe",
    genre: "arab electronic,electra,minimal techno,tech house,techno",
    popularity: "39",
  },
  {
    name: "Josh Wink",
    image: "https://i.scdn.co/image/d44f496ff84d6df581ff6775f043af1655d218c4",
    spotify: "6DQLkRykAsF6paJnlIMX4H",
    genre: "chicago house,minimal techno,tech house,techno",
    popularity: "39",
  },
  {
    name: "Sigvart Dagsland",
    image: "https://i.scdn.co/image/4024980f1b6b3a1bed4ba65fe34c46c080b6655a",
    spotify: "29L5k8hE8bAaRJpj13SmyA",
    genre:
      "classic norwegian pop,norwegian gospel,norwegian indie,norwegian pop",
    popularity: "39",
  },
  {
    name: "Justin OH",
    image: "https://i.scdn.co/image/b3727d671419af7f24ab7ea304aefcf66e9c6578",
    spotify: "5x2u5vpKBhviWQlni8VM8L",
    genre: "catstep",
    popularity: "39",
  },
  {
    name: "Olav Basoski",
    image: "https://i.scdn.co/image/85d90b0c2964ce13024795531430f5566b828fdb",
    spotify: "6FyRbuLLpPFzeI63apcfLi",
    genre: "disco house",
    popularity: "39",
  },
  {
    name: "Kate NV",
    image: "https://i.scdn.co/image/2c24e8765390269a7452656721dd2fc79e65b444",
    spotify: "1OkYyMwTFtCIl6Jn664Xtx",
    genre:
      "art pop,chamber psych,electra,experimental ambient,experimental pop,fourth world,freak folk,russian electronic",
    popularity: "39",
  },
  {
    name: "Leonie Meijer",
    image: "https://i.scdn.co/image/27a526ee49109eaf6fb0b3d689f5c308246c4c37",
    spotify: "2yAKMlQWwUyDSDly68F3ve",
    genre: "dutch pop",
    popularity: "39",
  },
  {
    name: "Kevin Saunderson",
    image: "https://i.scdn.co/image/fed8485088052a605a3ce8ab39e4589268954903",
    spotify: "0jS6VTFGujWxinY5TSQwOG",
    genre: "acid house,chicago house,detroit techno,techno",
    popularity: "39",
  },
  {
    name: "Popof",
    image: "https://i.scdn.co/image/580044b3a4f7be3a20dfaddf026b1fbbce48148b",
    spotify: "4f2K0RSYyxP4TUyZu1azYB",
    genre: "french tech house,french techno,minimal techno,tech house",
    popularity: "39",
  },
  {
    name: "Joseph Capriati",
    image: "https://i.scdn.co/image/8203abeb851f7744776668ae7f67f207bc6cbfae",
    spotify: "7onsqSWPufMm5ZnUCECDpf",
    genre: "deep minimal techno,italian techno,minimal techno,techno",
    popularity: "39",
  },
  {
    name: "Larry and His Flask",
    image: "https://i.scdn.co/image/ae080cebce04f1fd5c76bd0c2c80fe93ac04b674",
    spotify: "5rx7lpIuya41ws2oWXRiGu",
    genre: "folk punk",
    popularity: "39",
  },
  {
    name: "Jackal",
    image: "https://i.scdn.co/image/a0571c6ba655c18a3f3a624ba0504d4e7bae6ace",
    spotify: "5pTAtfO5NRMgj3zsT721WO",
    genre: "bass trap,electronic trap,vapor twitch",
    popularity: "39",
  },
  {
    name: "Oslo Gospel Choir",
    image: "https://i.scdn.co/image/677ceb703cf4a5b4ccb9ac1a495e84c534fb632d",
    spotify: "4e2YUhdd1EKare0kqDSP8j",
    genre:
      "christelijk,classic norwegian pop,gospel singers,norsk lovsang,norwegian gospel",
    popularity: "39",
  },
  {
    name: "Mavi Phoenix",
    image: "https://i.scdn.co/image/2f645725bd0c7d6ea4ad198ef5284e9fecff17c1",
    spotify: "0Lt05xaSe2ACmAiSkIdcSm",
    genre: "austrian indie,austrian pop,german indie,indie electropop",
    popularity: "39",
  },
  {
    name: "Freez",
    image: "https://i.scdn.co/image/654bed28fc78dc9a840162bd7cfec37bf9e2139a",
    spotify: "3s9uvZsEo51nyIRIHBp71l",
    genre: "",
    popularity: "39",
  },
  {
    name: "The Satan",
    image: "https://i.scdn.co/image/edcfdd47297d552d4fd5af84d8357bd7df4718eb",
    spotify: "4XCq6wVD10ui7rkXScdWvP",
    genre: "uptempo hardcore",
    popularity: "39",
  },
  {
    name: "Boy Teddy",
    image: "https://i.scdn.co/image/ab67616d0000b27397c8149c061b12a9a16987d9",
    spotify: "14W9ZwBj7ccu21CPJtenCh",
    genre: "kizomba,portuguese pop",
    popularity: "39",
  },
  {
    name: "GENIUS",
    image: "https://i.scdn.co/image/99dd60d12a0e6bfa332c53c4726f50d6b4f5ae2e",
    spotify: "7kog8MoLtYQRVTZCiIOtZZ",
    genre: "",
    popularity: "39",
  },
  {
    name: "JUDGE",
    image: "https://i.scdn.co/image/03f3c0bceeb1596ef2a394312e3cfc3f23bb2f5b",
    spotify: "1QyROiT6mJDfdLKRZ9HBIz",
    genre: "",
    popularity: "39",
  },
  {
    name: "Thierry Von Der Warth",
    image: "https://i.scdn.co/image/c72b84b0eff948c9a2adac22d3dbdfd69b5875fc",
    spotify: "2mF9PcfpN8vxRtCfra8hz1",
    genre: "",
    popularity: "39",
  },
  {
    name: "Gregor Tresher",
    image: "https://i.scdn.co/image/94811555d4e10fc6928d436a6fc4a01bb291818c",
    spotify: "3vy8oQAubj1IykJLLqvVFC",
    genre:
      "frankfurt electronic,german techno,microhouse,minimal techno,tech house",
    popularity: "39",
  },
  {
    name: "Carmouflage Rose",
    image: "https://i.scdn.co/image/d0a0fb6d83d219014eb93dce94b6e754850581ae",
    spotify: "31h66YPpyZlmecPqCaeS4H",
    genre: "australian hip hop",
    popularity: "39",
  },
  {
    name: "Kenny Dope",
    image: "https://i.scdn.co/image/09c819c67cda05279fc1456b890bc0d45b572eb4",
    spotify: "1TrfxjXu8quyDw05p2bacX",
    genre: "",
    popularity: "39",
  },
  {
    name: "Doorly",
    image: "https://i.scdn.co/image/4e92f3441219e100eea37786f426bb734a791e2c",
    spotify: "4uUZsrxHK6peebj1rpawBa",
    genre: "uk house",
    popularity: "39",
  },
  {
    name: "Lauren Ruth Ward",
    image: "https://i.scdn.co/image/4508cc86096b143e186932ca4530277a766593bf",
    spotify: "6RFGwX2bAZqXSeXfdqzXUY",
    genre: "baltimore indie",
    popularity: "39",
  },
  {
    name: "Nick Monaco",
    image: "https://i.scdn.co/image/21642ee92b795b832d2597e76f2f2fd8617e004a",
    spotify: "0fsDVdEDqPmn5CISll6OIQ",
    genre: "",
    popularity: "39",
  },
  {
    name: "Henrik B",
    image: "https://i.scdn.co/image/2c1ad10ed97c2dbfcce71401a2a9b815c3132c74",
    spotify: "1qM7ddO1J0S7eGGnuVmEXn",
    genre: "big room,progressive electro house",
    popularity: "39",
  },
  {
    name: "Paces",
    image: "https://i.scdn.co/image/72896d7bc8beaaa5983fe8849ea112bcbe53199a",
    spotify: "5xO9868Xc1mjAzmaN1efoK",
    genre: "australian dance",
    popularity: "39",
  },
  {
    name: "Richie Hawtin",
    image: "https://i.scdn.co/image/31b74ec59f2d99b8b7ca281792f47b0d836f01f1",
    spotify: "3AhwIUus3pIaA3CvYBEtpy",
    genre:
      "acid house,canadian electronic,detroit techno,microhouse,minimal techno,tech house,techno",
    popularity: "39",
  },
  {
    name: "Mike Hawkins",
    image: "https://i.scdn.co/image/1302a056070d6c2dff82f701b3db523ff666b6e4",
    spotify: "0eW2N88UpBG0giW7LJOaY2",
    genre: "danish electronic,deep big room",
    popularity: "39",
  },
  {
    name: "Terekke",
    image: "https://i.scdn.co/image/b95ac9c97ae339ba7100f620f060ebd0e1b9652b",
    spotify: "0VkQxm6BXV8KqEFmUpg5Lu",
    genre:
      "experimental ambient,float house,fourth world,lo-fi house,outsider house",
    popularity: "39",
  },
  {
    name: "Jiri11",
    image: "https://i.scdn.co/image/661028ba7cdc46562f49d56e9fdcfbb5496ba6a3",
    spotify: "6RxMqY900Xpza3Kh9j86Mn",
    genre: "",
    popularity: "39",
  },
  {
    name: "Wehbba",
    image: "https://i.scdn.co/image/e67e0331b0edaa58d6a6bcd0fbc3ad5de9e78969",
    spotify: "2UzAShzs3DO53bSZqvf8Ri",
    genre:
      "brazilian techno,deep minimal techno,minimal techno,tech house,techno",
    popularity: "39",
  },
  {
    name: "Skinto",
    image: "https://i.scdn.co/image/324b55356c2845cf191ad5bdd233698e9dfe6506",
    spotify: "7pCceRnt5WCHV1TJKCthzg",
    genre: "",
    popularity: "39",
  },
  {
    name: "Metz",
    image: "https://i.scdn.co/image/9f473ac593c34c323ac202675198da8411b87448",
    spotify: "18TNVFTJ6WfeicsMRrdJHI",
    genre:
      "canadian punk,dance-punk,garage psych,indie punk,modern alternative rock,noise rock,post-hardcore",
    popularity: "39",
  },
  {
    name: "Luke Million",
    image: "https://i.scdn.co/image/076ebd1bb06687e5bac09f277ded87e94aa56b4d",
    spotify: "1khu4DLsGK5MWLbUlfKkgz",
    genre: "nu disco",
    popularity: "39",
  },
  {
    name: "Otoboke Beaver",
    image: "https://i.scdn.co/image/318d763f184bffbc5d1d5d74e6bfd60a78577acc",
    spotify: "0HutkALC7kq2L8b9bnZUkq",
    genre: "j-punk,japanese girl punk,japanese pop punk,japanese punk rock",
    popularity: "39",
  },
  {
    name: "Silque",
    image: "https://i.scdn.co/image/0e015883d00611335a96f5d34750c818d1910990",
    spotify: "78KwNsjhjWzZYejeBTtsNW",
    genre: "dutch edm",
    popularity: "39",
  },
  {
    name: "Dandara",
    image: "https://i.scdn.co/image/06c0ba0cbed273c9cf8dfb7d0a438a9c8523e12b",
    spotify: "6h2EcimpzT4Ft2t2vfjEt4",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "39",
  },
  {
    name: "Cristina Branco",
    image: "https://i.scdn.co/image/850557a34ac832a88fba110fcf176268fda979ad",
    spotify: "0Naz1mk7F25xrk44Ugd8nd",
    genre: "fado,morna",
    popularity: "39",
  },
  {
    name: "Just Blaze",
    image: "https://i.scdn.co/image/cb397016365c3df9f4b580eb54f6d645365e8b7c",
    spotify: "2gpPCu8rjzdobGqDZJpHiR",
    genre: "",
    popularity: "39",
  },
  {
    name: "FIGHT CLVB",
    image: "https://i.scdn.co/image/05df26b0b309ed2417b9e355064e6367555782a4",
    spotify: "7d6RF1h3kPu6Ij0RXcTeJg",
    genre: "electronic trap",
    popularity: "39",
  },
  {
    name: "Greg Wilson",
    image: "https://i.scdn.co/image/819b120a54ef74b255f4bc7d1376cfcf9da930f1",
    spotify: "5b8TksKkFbG2NoVG8d8YDN",
    genre: "balearic",
    popularity: "39",
  },
  {
    name: "Mattanja Joy Bradley",
    image: "https://i.scdn.co/image/b4d13c0f5b07bc78927b96b874393b927bf6ff80",
    spotify: "6u9tyg6IXImKbuB5J12ush",
    genre: "dutch singer-songwriter",
    popularity: "39",
  },
  {
    name: "Daniël Busser",
    image: "https://i.scdn.co/image/781cf22928bdbd16b7e7a1746cd6513d89175463",
    spotify: "0r0RFyxSpdl13hE2e0W0Qx",
    genre: "belgian hip hop",
    popularity: "39",
  },
  {
    name: "Len Faki",
    image: "https://i.scdn.co/image/21a2d70505dd667e37e51815599f6213c1ec6abb",
    spotify: "3fI3Z6NnYoeSQjcqPQDbM4",
    genre: "minimal techno,tech house,techno",
    popularity: "39",
  },
  {
    name: "Psychemagik",
    image: "https://i.scdn.co/image/b565f5d12c09328f48a7dcdbe2c1f13087cde9fd",
    spotify: "3Mo1LckxhZk6jwf3pjamD0",
    genre: "balearic,uk house",
    popularity: "39",
  },
  {
    name: "Hector Plimmer",
    image: "https://i.scdn.co/image/c1139616f49250177dce094cc6861412022963d9",
    spotify: "7K64vyGna9ILfEEWnLKFEV",
    genre: "indie jazz,uk contemporary jazz",
    popularity: "39",
  },
  {
    name: "Luminite",
    image: "https://i.scdn.co/image/e2807d51d373a0a51d2f6c9b4e599b3f1b7c4254",
    spotify: "56uBktjCLyONyLAgE7VBq1",
    genre: "hardstyle,rawstyle,uptempo hardcore,xtra raw",
    popularity: "39",
  },
  {
    name: "Cryogenic",
    image: "https://i.scdn.co/image/ab67616d0000b27354a5ff5f5755e47e22b3eb6b",
    spotify: "3JkD7HM6gEzgOMm9kwzunN",
    genre: "uptempo hardcore",
    popularity: "39",
  },
  {
    name: "Wally A$M",
    image: "https://i.scdn.co/image/63b7c9146308d8553a2fd28f7bf8bdea6f8669f0",
    spotify: "5sKJpW8V9gGDpLIaBYbr8x",
    genre: "dutch hip hop",
    popularity: "39",
  },
  {
    name: "Zara McFarlane",
    image: "https://i.scdn.co/image/27b5059e663d1c0064c1b12a4579fd2a98ac0934",
    spotify: "2KwROtmoJfRcQHqDMiV6uo",
    genre: "indie jazz,uk contemporary jazz",
    popularity: "39",
  },
  {
    name: "Guy Mantzur",
    image: "https://i.scdn.co/image/cd3cfb5fa26f799238beb9d1fa65585f059ef3b6",
    spotify: "2DUa456repGwOOrcDKzcRP",
    genre: "focus trance,israeli techno,organic house",
    popularity: "39",
  },
  {
    name: "Dolly Dots",
    image: "https://i.scdn.co/image/ab67616d0000b27316658ac61542fd36cb77a81a",
    spotify: "7jQDCbxYM9t8bLCd2n8ONI",
    genre: "dutch pop,nederpop",
    popularity: "39",
  },
  {
    name: "Sem Vox",
    image: "https://i.scdn.co/image/9c4a3bea25267a95c211a4ac168952c33d3e4e8a",
    spotify: "4j6FBtbchyfFhBrCw9eT45",
    genre: "deep big room,sky room",
    popularity: "39",
  },
  {
    name: "Ricardo Moreno",
    image: "https://i.scdn.co/image/15d55637b87fc8f6da981e7fb1a83e10c582c544",
    spotify: "3508HjNdwnzSespkyxLOUt",
    genre: "",
    popularity: "39",
  },
  {
    name: "Dennis Dies Das",
    image: "https://i.scdn.co/image/e060ca2efe4dae01f5fb2971200ffd0784edc0de",
    spotify: "30ttvzupq5sM6n9NBx6uBx",
    genre: "",
    popularity: "39",
  },
  {
    name: "Blu Mar Ten",
    image: "https://i.scdn.co/image/c8df38eb00c944c8014f571a983b01d3502617c5",
    spotify: "5mGqZFvzU9FRNkcI3Y0A2V",
    genre: "drum and bass,drumfunk,liquid funk",
    popularity: "39",
  },
  {
    name: "Auntie Flo",
    image: "https://i.scdn.co/image/9f36472e0c6104fd5808fc327e5af045f8c9f97f",
    spotify: "6XYOjW5wxf5V9hwAR58o4d",
    genre: "organic electronic,scottish electronic",
    popularity: "39",
  },
  {
    name: "Nomi Ruiz",
    image: "https://i.scdn.co/image/c3fa7df6999315b8d0aec469e9f991adb06f770e",
    spotify: "5VNCplADfySxatpXe5jjDM",
    genre: "",
    popularity: "39",
  },
  {
    name: "Jay Reeve",
    image: "https://i.scdn.co/image/13cd7dfd5df74a8a69bdda91134a00ce1d374dd7",
    spotify: "5AVdeI8lS5HS9VGV8AUyS4",
    genre: "euphoric hardstyle,hardstyle,rawstyle",
    popularity: "39",
  },
  {
    name: "Lyambiko",
    image: "https://i.scdn.co/image/2cf340c7dfa9e18484decf48710f3257fcedc1bf",
    spotify: "6ffhnheAv6MHO3B0ybBpnK",
    genre: "contemporary vocal jazz,vocal jazz",
    popularity: "39",
  },
  {
    name: "Tiger Stripes",
    image: "https://i.scdn.co/image/ad95a16be5b5460c548a658d56d8fcb7d680ddfb",
    spotify: "5L56gAwU2WofuHHOpLC0BU",
    genre: "deep techno,house,swedish electronic,swedish techno,tech house",
    popularity: "39",
  },
  {
    name: "Just Friends",
    image: "https://i.scdn.co/image/5c5d873dd9effef1903d4f3bd70489e26d50884c",
    spotify: "5489Aao4KjbdU9l5CUadOa",
    genre: "diy emo,indie punk",
    popularity: "39",
  },
  {
    name: "Dead Letter Circus",
    image: "https://i.scdn.co/image/ec6a67c35e06fef8e546667da64dd9a4a81b102a",
    spotify: "3NW2VkBpoHFv327eSuH490",
    genre: "australian alternative rock,djent",
    popularity: "39",
  },
  {
    name: "Angger Dimas",
    image: "https://i.scdn.co/image/3f6fdea99fae1e10fbcf7bd16ec5abd3deafdffa",
    spotify: "5tuOpj3ofDA06hxQjvjdGZ",
    genre: "indonesian edm",
    popularity: "39",
  },
  {
    name: "Whiskey Shivers",
    image: "https://i.scdn.co/image/93e006b0d9679217a0c02dd2f5116d1ad7169bb1",
    spotify: "2N91y9Uko6gWwugdCpxJYH",
    genre: "austin americana,deathgrass,new americana",
    popularity: "39",
  },
  {
    name: "Mark Pritchard",
    image: "https://i.scdn.co/image/1b0abc5eee111184ee7de6328ad15c66cb9631d6",
    spotify: "7wDfZhaCORLgP3K62R3MJK",
    genre: "australian experimental,bass music,wonky",
    popularity: "39",
  },
  {
    name: "PULSE",
    image: "https://i.scdn.co/image/bd20c7cd8d2d744279a4fa38b0fb420cdfa15f41",
    spotify: "7KUllKhPR9wB7WdMqxk59h",
    genre: "traprun",
    popularity: "39",
  },
  {
    name: "Hatikwa",
    image: "https://i.scdn.co/image/62849c9995004e496a4e34a9c0c7e3658569f17e",
    spotify: "59iFYzojTKG1HTSyGSauhk",
    genre: "german trance",
    popularity: "39",
  },
  {
    name: "Lunatic",
    image: "https://i.scdn.co/image/6ae3a266309966d7139aafd5f1ace3e65d8edac2",
    spotify: "5kqBRKui1p5FL2nvUDKvia",
    genre: "",
    popularity: "39",
  },
  {
    name: "Solo Banton",
    image: "https://i.scdn.co/image/ab67616d0000b273f0afa658af2f6bd96ccd36e5",
    spotify: "3LYPkUrgqHouiqK6ltJg2d",
    genre: "dub reggae,uk dub",
    popularity: "39",
  },
  {
    name: "Alexandre Bergheau",
    image: "https://i.scdn.co/image/e64bfe43c85d2880e45f90ea7113f3b26d97a12c",
    spotify: "67ZSnsSlSHDh8BU9BVHChm",
    genre: "progressive uplifting trance",
    popularity: "39",
  },
  {
    name: "Lunar C",
    image: "https://i.scdn.co/image/7e1d6d22dbcb0e76add31be7f3365e443254cee9",
    spotify: "46UwhbFeBTomehI8g7tGFu",
    genre: "grime,uk alternative hip hop,uk hip hop",
    popularity: "39",
  },
  {
    name: "Buscemi",
    image: "https://i.scdn.co/image/14cf4e224fb5eb423b96477ce8a7820f3bd24589",
    spotify: "7kgD97FmexIhZQETIJgGVn",
    genre: "belgian pop,belgian rock",
    popularity: "39",
  },
  {
    name: "Ruby Rushton",
    image: "https://i.scdn.co/image/ab67616d0000b273c525110a8b388b9a254a7014",
    spotify: "6DO2Eyazl6ToBSvp7OGLuF",
    genre: "indie jazz,uk contemporary jazz",
    popularity: "39",
  },
  {
    name: "Greg Dela",
    image: "https://i.scdn.co/image/b98abffd07bd5f129a2caa33884f30059c373a34",
    spotify: "2vC91kjQ1yhQIRqYe3GRyo",
    genre: "",
    popularity: "39",
  },
  {
    name: "R-Wan",
    image: "https://i.scdn.co/image/b0e8b268f91869abd50e53ad5640d88d0333b161",
    spotify: "5ExJMjaxrM6EW2IJKToYd4",
    genre: "",
    popularity: "38",
  },
  {
    name: "Daniel Arends",
    image: "https://i.scdn.co/image/ab67616d0000b273333ba33dd424c16c1811e36f",
    spotify: "5iFBpFXi1RhJ4k6fXMIFGK",
    genre: "dutch cabaret",
    popularity: "38",
  },
  {
    name: "D-wayne",
    image: "https://i.scdn.co/image/2d8307aed98cae4557338c824bd99329c7a1ad32",
    spotify: "7s8qj3Bzbzoyw1t1y88GuX",
    genre: "deep big room,dutch edm",
    popularity: "38",
  },
  {
    name: "Deniz Bul",
    image: "https://i.scdn.co/image/7ad2a535b91b9e9963a4b4925302bb2106e1e2b8",
    spotify: "4H267HByup3kdzVdYLhp21",
    genre: "",
    popularity: "38",
  },
  {
    name: "Mightyfools",
    image: "https://i.scdn.co/image/37cbb8de6c51424db109ce8a4501194648cbc9d9",
    spotify: "5XJWi5Ev0zwaRiXnN8Oo5O",
    genre: "electro house,fidget house",
    popularity: "38",
  },
  {
    name: "Roy Rosenfeld",
    image: "https://i.scdn.co/image/0f43fbe48a935686af7c48ff5a8c67a657bd3e9b",
    spotify: "4YklksA8yDtpluCCh945Sk",
    genre: "israeli techno,organic house",
    popularity: "38",
  },
  {
    name: "Farrago",
    image: "https://i.scdn.co/image/dfd0c7e3d906e1064fc3885c078ef95e2280ca43",
    spotify: "40dlsb5MBbRdrB2hf8XnvU",
    genre: "belgian techno",
    popularity: "38",
  },
  {
    name: "Jack Beats",
    image: "https://i.scdn.co/image/176e1d37e95f75ec6a32c93e910f7c182fff48d3",
    spotify: "5dUIQXIt7WeBKpETFZyTFW",
    genre: "bass house,electro house,fidget house",
    popularity: "38",
  },
  {
    name: "Magnus Lindgren",
    image: "https://i.scdn.co/image/f9a99b8a6d62f000c0e35fd5b9f83e9937961ca8",
    spotify: "1ai1y07cRSewaRoOsQ4BfN",
    genre: "swedish jazz",
    popularity: "38",
  },
  {
    name: "YokoO",
    image: "https://i.scdn.co/image/64c6479e64e775f2bb42e26522d4fd970ea6081f",
    spotify: "45fzhLbHZdBIgOGQT6M5zr",
    genre: "ethnotronica,french tech house,organic house",
    popularity: "38",
  },
  {
    name: "Stereo Total",
    image: "https://i.scdn.co/image/eda8080da557f084d872b1b2f1f59360ceadb890",
    spotify: "662bj9rCw8Twt6JDAMmMDb",
    genre: "electroclash",
    popularity: "38",
  },
  {
    name: "Supergaande",
    image: "https://i.scdn.co/image/c1b98868625ec401e79ed454db3b3ec10620c91d",
    spotify: "1ZhwEGHgNZCnEFPrlWFTMM",
    genre: "dutch hip hop",
    popularity: "38",
  },
  {
    name: "The Firm",
    image: "https://i.scdn.co/image/10fcb8f667ff35352d3bea69eaf7bb462cae5732",
    spotify: "4rPZAvpw9ObVO3HFGWSHwt",
    genre: "supergroup",
    popularity: "38",
  },
  {
    name: "Marco Carola",
    image: "https://i.scdn.co/image/f09f191f2f9144e7a8bf58310f0c5f2a46949f08",
    spotify: "2p8O7NCyfWf1sIZamrU9N1",
    genre: "italian techno,minimal techno,techno",
    popularity: "38",
  },
  {
    name: "Mochakk",
    image: "https://i.scdn.co/image/2a76db94a68406e07ba11adf360c3fdf53ecbfd2",
    spotify: "0rTh1tAdrEbdKZBTiiAQSo",
    genre: "brazilian edm",
    popularity: "38",
  },
  {
    name: "Paul de Munnik",
    image: "https://i.scdn.co/image/d5b7b5bac65ea7e1826cc57774bf1de24135aecd",
    spotify: "1HFg9B0Jvwqzqiuqg9cASk",
    genre: "",
    popularity: "38",
  },
  {
    name: "Zuco 103",
    image: "https://i.scdn.co/image/1b77ce51e539b52049fe67f147eabe7b87fd20f5",
    spotify: "7m5FwndSbCRd5vJvgviUCA",
    genre: "electro jazz,nu jazz,sambass",
    popularity: "38",
  },
  {
    name: "Anneke Van Giersbergen",
    image: "https://i.scdn.co/image/cf6d0ec52b9dc3013e7324021476dfe7fe30d054",
    spotify: "6TZqJnkAytY8HFQBEdDF8v",
    genre: "gothic symphonic metal",
    popularity: "38",
  },
  {
    name: "Yori",
    image: "https://i.scdn.co/image/6ff375b6f81ff766bc95b2624f636d23fff2b370",
    spotify: "0nxksNcuF79AzWMSqBYejk",
    genre: "",
    popularity: "38",
  },
  {
    name: "Mark Sherry",
    image: "https://i.scdn.co/image/0fdf819beaa48d4621e4e23761299d05909a96a9",
    spotify: "3mvBDVwojbFc7hmDIgoIHH",
    genre:
      "deep uplifting trance,hard trance,progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "38",
  },
  {
    name: "Montell2099",
    image: "https://i.scdn.co/image/d98ef48c1aa36e3eeb37f180d6568ca6330850ac",
    spotify: "47MGg5VHBSS5yHRuMGt6b0",
    genre: "electronic trap,vapor twitch",
    popularity: "38",
  },
  {
    name: "Ben Klock",
    image: "https://i.scdn.co/image/b0177ac5cd78a4faf2eda2a630038ec8704b7dd0",
    spotify: "1vJHfCreWAS46V8RZ67ojo",
    genre: "german techno,minimal techno,techno",
    popularity: "38",
  },
  {
    name: "Ben Miller Band",
    image: "https://i.scdn.co/image/532f59b568fe1f5eabde0dde608970485fcb4c4d",
    spotify: "692LYMl7s0bV6X3iduX5rG",
    genre: "lo star,modern blues rock",
    popularity: "38",
  },
  {
    name: "Jonny Nash",
    image: "https://i.scdn.co/image/a58ba26a796c5ba02dad7c2a214ce852909cac58",
    spotify: "4VnaEWTHIwbqbDCwNPpfde",
    genre: "ambient,balearic,experimental ambient,float house,fourth world",
    popularity: "38",
  },
  {
    name: "Villem",
    image: "https://i.scdn.co/image/4a136b4e37588cb2ddeac48f51a8f9be8bf681c4",
    spotify: "3mupfXo95OeusJKhAJVCUf",
    genre: "deep liquid bass,drum and bass,drumfunk,liquid funk,uk dnb",
    popularity: "38",
  },
  {
    name: "Jacco Gardner",
    image: "https://i.scdn.co/image/6dd2d38d3a4dce95be9ee2d8277935ddbed54527",
    spotify: "5RfKXXQQn2OhZiT5iSggZn",
    genre: "baroque pop,dutch indie rock,neo-psychedelic,psychedelic pop",
    popularity: "38",
  },
  {
    name: "Allure",
    image: "https://i.scdn.co/image/278e37da161c598989ba866fd21d76778694d7df",
    spotify: "1VPr8y4GGZJBtWyaoLdYUT",
    genre: "",
    popularity: "38",
  },
  {
    name: "Will Knox",
    image: "https://i.scdn.co/image/ae05d8af28af6c9050f5f0e2400776a64e48d4ad",
    spotify: "2e0OOXFJ610jkry76XceeS",
    genre: "dutch singer-songwriter,indie singer-songwriter",
    popularity: "38",
  },
  {
    name: "James Dymond",
    image: "https://i.scdn.co/image/d4b6891529068a7018954f9241319c19d3a5aabd",
    spotify: "65cUCIwyx5xtC5HoXh6eOs",
    genre:
      "deep uplifting trance,progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "38",
  },
  {
    name: "Kate Simko",
    image: "https://i.scdn.co/image/7b9556d897cd811a20849931b1f67ad28228638b",
    spotify: "2KXLSIzI7CY7AJg5ARUOSb",
    genre: "minimal tech house",
    popularity: "38",
  },
  {
    name: "John Roberts",
    image: "https://i.scdn.co/image/431e689166989c7bc9556ddc8b856c89d7aa121c",
    spotify: "5HGXZdpWmmXoDqbCCsBlYt",
    genre: "",
    popularity: "38",
  },
  {
    name: "Doug Seegers",
    image: "https://i.scdn.co/image/af42e917b5944cc6589c2c7477675cda95ebef0c",
    spotify: "2WO6GcXH1rWwzge9wOnuxm",
    genre: "",
    popularity: "38",
  },
  {
    name: "Dexcell",
    image: "https://i.scdn.co/image/4e8a9322a065a1707e11eb4e99c52308d529b330",
    spotify: "30OaLZeQTMJHvuH3TIMUPz",
    genre: "liquid funk",
    popularity: "38",
  },
  {
    name: "James Watss",
    image: "https://i.scdn.co/image/e6c597b2886bb14877fe772385869ae89507bfa2",
    spotify: "0V7K6XaL7jDs1oUWUvgXNs",
    genre: "dutch hip hop,dutch pop,dutch trap pop",
    popularity: "38",
  },
  {
    name: "Amy Root",
    image: "https://i.scdn.co/image/7e3890795df9302ad7ac57b3f0ece591bc05e66f",
    spotify: "25BkQ40MvbdCyNbX8DJd73",
    genre: "dutch experimental electronic",
    popularity: "38",
  },
  {
    name: "Dog Eat Dog",
    image: "https://i.scdn.co/image/ab67616d0000b2733cbccf38eaa5bf720a8c3505",
    spotify: "3K6gIioKTRy1TWaoJlHMgx",
    genre: "funk metal,rap rock",
    popularity: "38",
  },
  {
    name: "Bo Saris",
    image: "https://i.scdn.co/image/d07d5533af977c9748781224e2fc7c6446bf1eb5",
    spotify: "5iFyVnPvgc3b4bduxnqn6l",
    genre: "minimal tech house",
    popularity: "38",
  },
  {
    name: "Linguistics",
    image: "https://i.scdn.co/image/5ab401fc7ab9c0984a18c600a9bc4c6246407d69",
    spotify: "5ez11adLi95kAPuxh0RefJ",
    genre: "",
    popularity: "38",
  },
  {
    name: "sumthin sumthin",
    image: "https://i.scdn.co/image/878593a51e8e3d43aa6c55c7d0a4334834848865",
    spotify: "2a8ez0A2owcYhFki9860sm",
    genre: "electronic trap,future bass,vapor twitch",
    popularity: "38",
  },
  {
    name: "Johnny Rakete",
    image: "https://i.scdn.co/image/8098e87ec34a90141d2240345f29e8b202d5bbe9",
    spotify: "6Wn5DZufsJX62U43H7RAxd",
    genre: "german cloud rap,indie deutschrap",
    popularity: "38",
  },
  {
    name: "Dale Watson",
    image: "https://i.scdn.co/image/fb207569bff53246d75083deb1e69b682984e1de",
    spotify: "67meObnM9NdAyCO373aaEp",
    genre:
      "bakersfield sound,country rock,memphis americana,outlaw country,roots americana,texas country",
    popularity: "38",
  },
  {
    name: "Protohype",
    image: "https://i.scdn.co/image/c269cac19886f8f1b3047a5aecf18eb546dd9afa",
    spotify: "7KG6QgP9Xb87ybAr9C24qw",
    genre: "brostep,filthstep,zapstep",
    popularity: "38",
  },
  {
    name: "Dan Stone",
    image: "https://i.scdn.co/image/42ed040a383ecbcd2348de797cfef240331689c3",
    spotify: "5AqacAhvN8JCsr00Qk9tb7",
    genre:
      "progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "38",
  },
  {
    name: "Jonah Tolchin",
    image: "https://i.scdn.co/image/93110eb7b444f8b21bb190da8ea97cd28a430ae9",
    spotify: "66jsWaGhzSpHH1KRF34Oq3",
    genre: "deep new americana,new americana",
    popularity: "38",
  },
  {
    name: "LUXXURY",
    image: "https://i.scdn.co/image/6a91e204ab17ad857b2ef2393fe682e4256dd438",
    spotify: "562q9ntuNSaVyt1bvPa77z",
    genre: "nu disco,solipsynthm",
    popularity: "38",
  },
  {
    name: "Franzi Harmsen",
    image: "https://i.scdn.co/image/f2742bb34447d4f8a44dfab8136cc2d676c377d2",
    spotify: "37ctEiNvHyyUL9KDjRUV0W",
    genre: "",
    popularity: "38",
  },
  {
    name: "Lea Porcelain",
    image: "https://i.scdn.co/image/ae8fe7e887b3261a3042323a453611220efaccc1",
    spotify: "4HsBBgi3DDsy0w29W5yevl",
    genre: "german post-punk",
    popularity: "38",
  },
  {
    name: "Mad Sin",
    image: "https://i.scdn.co/image/eed74a26f650840a7479c723036b8db732d8229c",
    spotify: "0KeXahyB2g6PPQMG7sImjB",
    genre: "",
    popularity: "38",
  },
  {
    name: "Megalodon",
    image: "https://i.scdn.co/image/4616531368a4bbb2175a0f49c1b201fd019ccd55",
    spotify: "2tXUcirItGbDNvLpApQT3z",
    genre: "brostep,deathstep,electro house,filthstep,zapstep",
    popularity: "38",
  },
  {
    name: "Symbolic",
    image: "https://i.scdn.co/image/e1f7432a9d6c70ac78cf1a7d1735962b6c8e45ba",
    spotify: "0oUwhzCzcC6VAaKSFG55U3",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "38",
  },
  {
    name: "LAXX",
    image: "https://i.scdn.co/image/79163450d1ab84da4f0119b2fc41e20f77b80754",
    spotify: "2kDv96OSt2CHxn9zx3pBwx",
    genre:
      "bass trap,brostep,electro house,electronic trap,minimal dubstep,zapstep",
    popularity: "38",
  },
  {
    name: "Elevven",
    image: "https://i.scdn.co/image/ff8b868e3be653083db90afb9a756a2b6e1f1847",
    spotify: "1x72oeaWJ5kdXMXZoq0Icu",
    genre: "progressive house,progressive trance",
    popularity: "38",
  },
  {
    name: "Victory",
    image: "https://i.scdn.co/image/26b5f22ac346a903345e805070c0dbb07d9a77f3",
    spotify: "16lrbkOHEyh1SXN2FP9Xmr",
    genre: "",
    popularity: "38",
  },
  {
    name: "The Midnight Hour",
    image: "https://i.scdn.co/image/8a2b552da26f2fed2bebd4cb806fb52a7809f394",
    spotify: "1S5jf5XWhQTMjGZQxCH0AJ",
    genre: "indie jazz",
    popularity: "38",
  },
  {
    name: "Tempers",
    image: "https://i.scdn.co/image/b44081e28fc7f15a3f8a47006d8272089cf31b73",
    spotify: "0yIDrFWDGrnVk3FPLJmsX2",
    genre: "dark post-punk,grave wave",
    popularity: "38",
  },
  {
    name: "Bjarki",
    image: "https://i.scdn.co/image/da485c90dfbb864e4bb9d6ea0ee0d3aa0a57c2f8",
    spotify: "6FtSCON62H1CEJtN39y9yI",
    genre: "icelandic electronic,minimal dub",
    popularity: "38",
  },
  {
    name: "Jacob Dinesen",
    image: "https://i.scdn.co/image/c56243970d76f1ccd79fcc0991cfd726daa41eb0",
    spotify: "0yXCyc8MNNuv0YCWpxeg0a",
    genre: "danish rock",
    popularity: "38",
  },
  {
    name: "Juicy Gay",
    image: "https://i.scdn.co/image/ee0057ee2bc1e6eb1e2f565c9e7f5a1761b71c12",
    spotify: "5K9JM7CuDCYOLPStuNakwH",
    genre: "german cloud rap,indie deutschrap",
    popularity: "38",
  },
  {
    name: "Imarhan",
    image: "https://i.scdn.co/image/fce8be20d97c7fa55571ad59a3c8ecf29cb36ac3",
    spotify: "1KQ1687z0hWSabx0YswG54",
    genre: "afropop,tuareg guitar,world",
    popularity: "38",
  },
  {
    name: "Actress",
    image: "https://i.scdn.co/image/150bdafa74b963265ac98a119a4ce0608303faa2",
    spotify: "3bg5rmICvmA8dmYVAdKGYH",
    genre:
      "art pop,bass music,deconstructed club,dub techno,experimental pop,float house,fluxwork,footwork,future garage,hauntology,intelligent dance music,microhouse,outsider house,wonky",
    popularity: "38",
  },
  {
    name: "GENTS",
    image: "https://i.scdn.co/image/e2fad299542481d6070ad7f8f80c7c399220cf42",
    spotify: "7zOVGL0VYcCqXgN1tEMp9d",
    genre: "danish indie pop,neo-synthpop",
    popularity: "38",
  },
  {
    name: "NightFunk",
    image: "https://i.scdn.co/image/a7388c4fd28e8ebb48c66287a0067aa38c1a9efd",
    spotify: "1UgUBnYpGyrYfGIfkMp08O",
    genre: "funky tech house",
    popularity: "38",
  },
  {
    name: "Billy Davis",
    image: "https://i.scdn.co/image/1107ef53e4cfc6dfc905434036afff7a712af1e7",
    spotify: "1faxe25Wp3Nk43xVVxsdSB",
    genre: "australian r&b",
    popularity: "38",
  },
  {
    name: "Faces on TV",
    image: "https://i.scdn.co/image/af6774e2746c38e2629cbd82c3ce49aa4efdb423",
    spotify: "3lLMK7bxYJxcaeThcvL8NJ",
    genre: "belgian indie,belgian indie rock",
    popularity: "38",
  },
  {
    name: "Peaking Lights",
    image: "https://i.scdn.co/image/afaa95804ec5df947842066ccbe47e0e6d5fe73f",
    spotify: "54ECAJjvSyZGTWUgyt5tqc",
    genre: "chamber psych,chillwave,experimental pop,freak folk",
    popularity: "38",
  },
  {
    name: "Alpha Portal",
    image: "https://i.scdn.co/image/ad4c93fd455c5fd8ee785d31c52135d369d0cd61",
    spotify: "0QByA8eXXasgGpYEFwgnI6",
    genre: "forest psy,psychedelic trance",
    popularity: "38",
  },
  {
    name: "Crisis Era",
    image: "https://i.scdn.co/image/8975f2151543e21a03f392ffb6a59e708b30c827",
    spotify: "4G6enmlHQQ4ktgVMIR9op0",
    genre: "",
    popularity: "38",
  },
  {
    name: "Michael Mendoza",
    image: "https://i.scdn.co/image/30cf4329fb51aa16ec2974095731ebdfb7782c74",
    spotify: "6BIhlaTDQjE12D2xHCxTZ2",
    genre: "",
    popularity: "38",
  },
  {
    name: "Duguneh",
    image: "https://i.scdn.co/image/6c9974bf7087ef492729a42aced494a6ebb086b1",
    spotify: "6xwzq2cu4SORZ4ol1zD1Al",
    genre: "",
    popularity: "38",
  },
  {
    name: "MC Focus",
    image: "https://i.scdn.co/image/7ab9b350d7f10deabefa1dbd59094c0027ebbf3e",
    spotify: "2WZK4ltsxqMCsLbsjzfGyY",
    genre: "",
    popularity: "38",
  },
  {
    name: "Canteca de macao",
    image: "https://i.scdn.co/image/1102c0aba16cdf1b6ab6da64c414248072cc82a3",
    spotify: "66xBjuCrzVfhXXvmLxF2UL",
    genre: "flamenco,flamenco fusion",
    popularity: "38",
  },
  {
    name: "Husman",
    image: "https://i.scdn.co/image/44555e17b67ba4e235c57442dc44843252c10695",
    spotify: "38IfmizrHTCxFjd8UKhWnp",
    genre: "deep big room,progressive uplifting trance,sky room",
    popularity: "38",
  },
  {
    name: "Physika",
    image: "https://i.scdn.co/image/432d76cf9da40d099b2b6219cc7502bfab882b51",
    spotify: "52NpY0nQvHw021b9j9Ke3y",
    genre: "hardstyle,rawstyle",
    popularity: "38",
  },
  {
    name: "Lydmor",
    image: "https://i.scdn.co/image/e2763519e8b93de7bc026dd9797f8cfe253be267",
    spotify: "5aubywQASFk4xdR0fVTxFR",
    genre: "danish electropop",
    popularity: "38",
  },
  {
    name: "The Toasters",
    image: "https://i.scdn.co/image/5fe9947ece1ceb847e3c09e407d3cda1bb754e7f",
    spotify: "5TefXCuvQWtRxpWfDdKmNj",
    genre: "euroska,ska,ska punk,ska revival,traditional ska",
    popularity: "38",
  },
  {
    name: "Brillz",
    image: "https://i.scdn.co/image/4f7dc63c2bc510ac585742d0798d90e3de3afc30",
    spotify: "26Pe1UkFeUi8pqFaTS1JCq",
    genre: "bass trap,electronic trap",
    popularity: "38",
  },
  {
    name: "Daxson",
    image: "https://i.scdn.co/image/0b4bae58450443515d8d6539fff3c24d312cd09f",
    spotify: "4WwMR8h0vztJLNgiL5ZFqW",
    genre: "progressive trance",
    popularity: "38",
  },
  {
    name: "Alabaster DePlume",
    image: "https://i.scdn.co/image/8dcd7c992f677beb7e1e6140537a0c6fcf82f57f",
    spotify: "3LfKt6bEMIfFIEryeai8Mm",
    genre: "indie jazz,uk contemporary jazz",
    popularity: "38",
  },
  {
    name: "Fisherman",
    image: "https://i.scdn.co/image/dbd810b14de0a24e580828b40aea226756bff700",
    spotify: "0vykncECxuxH5RqOMt6IIg",
    genre: "",
    popularity: "38",
  },
  {
    name: "A Wilhelm Scream",
    image: "https://i.scdn.co/image/1b0bf6fe453ddac068dc5aa0d10e4dd397746808",
    spotify: "6v7mkDKyZ50l4Jiqwx2JLg",
    genre: "fast melodic punk,melodic hardcore,orgcore,punk,skate punk",
    popularity: "38",
  },
  {
    name: "Superpitcher",
    image: "https://i.scdn.co/image/e543a6764eed593a108f9f6c0af1bdbea4c00a44",
    spotify: "55BdmUTmTmoUNOFQxm54k5",
    genre: "cologne electronic,microhouse,minimal techno",
    popularity: "38",
  },
  {
    name: "Nico Stojan",
    image: "https://i.scdn.co/image/fd9afc496645f363dc618d10610894dfc189cd80",
    spotify: "1SuKmGtjsRRJcGhTspfUnd",
    genre: "deep euro house,organic electronic,organic house",
    popularity: "38",
  },
  {
    name: "Anna Burch",
    image: "https://i.scdn.co/image/4901be8079de11dee648b7961c2fc3a8e69ac479",
    spotify: "26OB2jqYqL7pNslVtu4VGt",
    genre:
      "chamber pop,chamber psych,detroit indie,garage psych,indie folk,indie rock",
    popularity: "38",
  },
  {
    name: "Crack Ignaz",
    image: "https://i.scdn.co/image/ff8afac0c6216f62685e04bbdd7536f0fa561243",
    spotify: "1RzvREvTenKGPYk6laaGdD",
    genre: "german cloud rap,indie deutschrap",
    popularity: "38",
  },
  {
    name: "Jansons",
    image: "https://i.scdn.co/image/55dcd361e02cfe4e21ddfd62ed67180bdac4a845",
    spotify: "0gztzLIt9uRDJd4Jl9TSLY",
    genre: "uk tech house",
    popularity: "38",
  },
  {
    name: "Amenra",
    image: "https://i.scdn.co/image/315f98c3fdc74602b8602aa7897aad168f4d992c",
    spotify: "0N1jE1EIrhZjvQSfuLupUu",
    genre:
      "atmospheric sludge,belgian metal,drone metal,post-doom metal,post-metal,post-rock",
    popularity: "38",
  },
  {
    name: "Sven Väth",
    image: "https://i.scdn.co/image/b4fe1cc6073c8f440fd275f2c1b889b29180431e",
    spotify: "5TQaBSTOSypp7S4jfSnN3F",
    genre:
      "frankfurt electronic,german techno,minimal techno,tech house,techno",
    popularity: "37",
  },
  {
    name: "Shanti Celeste",
    image: "https://i.scdn.co/image/f8a359a10e6c26f890535c012bdda63bc8d02261",
    spotify: "3CkM2290WOa2ESzhlu5mzM",
    genre: "electra,float house,fluxwork,outsider house",
    popularity: "37",
  },
  {
    name: "Bob Wayne",
    image: "https://i.scdn.co/image/ab67616d0000b2736cbebaf9ea765a053e6ec492",
    spotify: "6LWREZSd4429wq2MHt3KC4",
    genre: "deathgrass,truck-driving country",
    popularity: "37",
  },
  {
    name: "Hector Couto",
    image: "https://i.scdn.co/image/8ea02b3aef7baa39fcc69342bfe0249fe82a598a",
    spotify: "4TeakFq7Xbpo0ihpTQrekM",
    genre: "funky tech house,latin tech house,minimal tech house,tech house",
    popularity: "37",
  },
  {
    name: "Marika Rossa",
    image: "https://i.scdn.co/image/fe360b32e0d50d1487cf4393537aa3d8465f663c",
    spotify: "4yKd2ditzVgjUGOTCXhYy3",
    genre: "dark techno,ukrainian electronic",
    popularity: "37",
  },
  {
    name: "Amsterdam Klezmer Band",
    image: "https://i.scdn.co/image/1ad38779cc53823505f9f9aafc4ac26b9f6621e6",
    spotify: "2vMBszTQ5H66LhDEM3mSvl",
    genre: "balkan brass,klezmer",
    popularity: "37",
  },
  {
    name: "Blaudzun",
    image: "https://i.scdn.co/image/1ee0283f61b5896b891dcca246d065ea4dc6e920",
    spotify: "1A6zWJwn4XmdZZgob3wYPM",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "37",
  },
  {
    name: "Sam Divine",
    image: "https://i.scdn.co/image/93a9b35160cc47a7f4e732be8aea2d0ede160eac",
    spotify: "029RjYsk0DU8LKC92sUyXZ",
    genre: "",
    popularity: "37",
  },
  {
    name: "The Amazing Stroopwafels",
    image: "https://i.scdn.co/image/ab67616d0000b27302f178f091ae8ba9ce80a7db",
    spotify: "4j32y3UVJaypInH9lOKcZ4",
    genre: "dutch rock,nederpop",
    popularity: "37",
  },
  {
    name: "Eva Eastwood",
    image: "https://i.scdn.co/image/425377e26256ca33a4beefb4e0b8a7a464cce4e4",
    spotify: "0Oab0T0VwxapaYLWgHFWhH",
    genre: "dansband,danspunk,rockabilly,swedish country,swedish rockabilly",
    popularity: "37",
  },
  {
    name: "Jordan Suckley",
    image: "https://i.scdn.co/image/a756b89ed1196f9a9ba54ad75dae097f10b7ab2d",
    spotify: "25jGdT0Q5ld9D9Lajg8JpD",
    genre:
      "progressive trance,progressive uplifting trance,tech trance,trance,uplifting trance",
    popularity: "37",
  },
  {
    name: "Dj Thera",
    image: "https://i.scdn.co/image/f785d65e2c1d33b6236731cd926e77114816e1d0",
    spotify: "3wnWv1CbRJ0JuDgOcsBPfd",
    genre: "classic hardstyle,hardstyle,rawstyle",
    popularity: "37",
  },
  {
    name: "Elliott BROOD",
    image: "https://i.scdn.co/image/3aec9604a4c6719322c6de9bc4ce4c872ec3659e",
    spotify: "51RfVK8q11xKW7bi7bcMpJ",
    genre: "canadian americana,canadian indie,canadian singer-songwriter",
    popularity: "37",
  },
  {
    name: "VanVelzen",
    image: "https://i.scdn.co/image/49a93edbd18c3e6b7913eb64bff8bbc0a03d34c0",
    spotify: "3Lq6Tb3SbS4n6dVuCx0Zzi",
    genre: "dutch pop,dutch rock",
    popularity: "37",
  },
  {
    name: "Luigi Madonna",
    image: "https://i.scdn.co/image/2eb9fa3d7dae00a74636c6e6190b1a2d07f98b68",
    spotify: "16LyZ7r3rzPJqljgvz0fvq",
    genre: "deep minimal techno,italian techno,minimal techno,tech house",
    popularity: "37",
  },
  {
    name: "Boris Smith",
    image: "https://i.scdn.co/image/597d305b5dfea0ad1e5f7696df88543ab0df1d5c",
    spotify: "5kz5IXAF2jqboBHGITZvWx",
    genre: "",
    popularity: "37",
  },
  {
    name: "Jim van der Zee",
    image: "https://i.scdn.co/image/3c3ac537e9443a95d236196ab97bccc548cc3c74",
    spotify: "7CjnYXSrc2CkcgptzVsxDm",
    genre: "dutch pop,dutch singer-songwriter",
    popularity: "37",
  },
  {
    name: "Rakka",
    image: "https://i.scdn.co/image/006a66de9c2513126db0646b69621b75e98644b4",
    spotify: "2GNfI7g7glAR1JBuvU0vL5",
    genre: "",
    popularity: "37",
  },
  {
    name: "Skating Polly",
    image: "https://i.scdn.co/image/1fe55e679412d40ee362e01da71347a56a38ab4b",
    spotify: "1ST6hERy8rGdwUaNAZxfG9",
    genre: "indie punk,ok indie,okc indie,riot grrrl",
    popularity: "37",
  },
  {
    name: "Sandeville",
    image: "https://i.scdn.co/image/16790a00bc829cd656a5773684d9be389c7aef77",
    spotify: "2l3hKaFThCf5oYsFUv25RH",
    genre: "brazilian house",
    popularity: "37",
  },
  {
    name: "Ticon",
    image: "https://i.scdn.co/image/a38e560b6bcfa6d143945f9412cd1af93f68bd0e",
    spotify: "1UjhKEWO8s7Vvidh2LzwZ1",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "37",
  },
  {
    name: "Sander Kleinenberg",
    image: "https://i.scdn.co/image/692fdb39e4c9aa97be45a6c268401eaf715a280b",
    spotify: "3CfH3WZPzbk5mNDWXpGIy6",
    genre: "classic progressive house,dutch edm",
    popularity: "37",
  },
  {
    name: "The Mauskovic Dance Band",
    image: "https://i.scdn.co/image/c1eb6350e78c7b29b4f24088990b7f3d51e06626",
    spotify: "02riqGdWw4EdqKJzOeWRZS",
    genre: "dutch indie rock,latin afrobeat",
    popularity: "37",
  },
  {
    name: "DJ Python",
    image: "https://i.scdn.co/image/ff1f7b021883fcfd8e14d8401c679d78df9721a7",
    spotify: "1LoZxxInSyuVFKSMAB4BPl",
    genre:
      "ambient house,art pop,bass music,deconstructed club,float house,fluxwork,intelligent dance music,microhouse,outsider house",
    popularity: "37",
  },
  {
    name: "Bummelkasten",
    image: "https://i.scdn.co/image/ab67616d0000b2738ba1aaf88b157453fe12482d",
    spotify: "3QTPj4dzAbanx0RJ20CW1S",
    genre: "kindermusik,kleine hoerspiel",
    popularity: "37",
  },
  {
    name: "Matthias Tanzmann",
    image: "https://i.scdn.co/image/a718aed7f0c51044b5e6d84f0b89d7ad56431e46",
    spotify: "6bxLLapj6NByiP5cr6jMeK",
    genre:
      "german house,german techno,leipzig electronic,minimal tech house,minimal techno,tech house",
    popularity: "37",
  },
  {
    name: "Gaudium",
    image: "https://i.scdn.co/image/74756f88f339cf1b0442ea062eb11b461911e83e",
    spotify: "7DSaZpbJCzUcTX1D2oglwg",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "37",
  },
  {
    name: "Flinke Namen",
    image: "https://i.scdn.co/image/11c1527bb537856fe2128836ec08134d60dfb5c3",
    spotify: "1pl6zHy7TssEvPr4d6hMgK",
    genre: "dutch hip hop",
    popularity: "37",
  },
  {
    name: "Motorpsycho",
    image: "https://i.scdn.co/image/c73ce85952e49f3a8aba851166152622e046df48",
    spotify: "2bNIAjyL3hFCuQBQqhPN4T",
    genre:
      "jazz metal,norwegian alternative rock,norwegian contemporary jazz,norwegian experimental,norwegian prog,norwegian psychedelic,norwegian rock",
    popularity: "37",
  },
  {
    name: "Luca Agnelli",
    image: "https://i.scdn.co/image/3de214ee35a4a2a03a4a6f51c025dfa9430b9a3f",
    spotify: "4gF60Mys5KoWdQrf0bhRWq",
    genre: "dark techno,italian techno,tech house",
    popularity: "37",
  },
  {
    name: "TWERL",
    image: "https://i.scdn.co/image/50208d595aa30424bea653673543f4cc13ff60d4",
    spotify: "3pJlam8yODJN1AEzmTVGko",
    genre: "traprun",
    popularity: "37",
  },
  {
    name: "Moscoman",
    image: "https://i.scdn.co/image/8dee47d51c8f3e243c7312f406dd4020b8469e1c",
    spotify: "44F8g3iM4NgU5cisocTlTQ",
    genre: "dark disco,float house,israeli techno",
    popularity: "37",
  },
  {
    name: "Tricklebolt",
    image: "https://i.scdn.co/image/b4255357a34ed8097f8a353de3b0455ba556e8f5",
    spotify: "1ZAx1trsNb2poWyQOgrw8w",
    genre: "dutch rock",
    popularity: "37",
  },
  {
    name: "Funk D",
    image: "https://i.scdn.co/image/5f0d54e6a9a05d417c04bc79740d4e400334d59a",
    spotify: "7hNmGpSTmHpCWP377St0bk",
    genre: "dutch house",
    popularity: "37",
  },
  {
    name: "Kimberose",
    image: "https://i.scdn.co/image/d61d26b09fd11ac454e81a130b58244e48c6b467",
    spotify: "6CpNuq0rsIj6Il313E6lKL",
    genre: "",
    popularity: "37",
  },
  {
    name: "Victor Porfidio",
    image: "https://i.scdn.co/image/30f5f6cb5095c9e81efeac549f0e7732d39e8d3d",
    spotify: "39sM7R1IvQMQPTEB3SY8h9",
    genre: "sky room",
    popularity: "37",
  },
  {
    name: "Dax J",
    image: "https://i.scdn.co/image/8a06a668479a976993fb122181680b65cdb5c603",
    spotify: "2zJJIWKT0LiwdxcwW9RajQ",
    genre: "minimal dub",
    popularity: "37",
  },
  {
    name: "Oolacile",
    image: "https://i.scdn.co/image/633053c69031ec924fb9bb549f888c7ee260227d",
    spotify: "3z8SEnYy9gIRNrSVNJieXx",
    genre: "brostep,canadian electronic,zapstep",
    popularity: "37",
  },
  {
    name: "DJ Flash",
    image: "https://i.scdn.co/image/7ccc3c4a96ad378c9ade0e06e216d34ae79875f5",
    spotify: "00SMMqx16Zxt7osuqbv3aW",
    genre: "",
    popularity: "37",
  },
  {
    name: "Stooki Sound",
    image: "https://i.scdn.co/image/69ddc0c9f312ae08763c0497dcd215e12ef73b3b",
    spotify: "6ky7h0ow6NQgAnsoN2AB7h",
    genre: "bass trap,electronic trap",
    popularity: "37",
  },
  {
    name: "AmsterdamSoundSystem",
    image: "https://i.scdn.co/image/d51d7c8393e05d93c5cb32590afdbda568161613",
    spotify: "2VY0tBQrNd2J2ZLZsjToB9",
    genre: "",
    popularity: "37",
  },
  {
    name: "Akua Naru",
    image: "https://i.scdn.co/image/25ddf8143b8afc3a3916055f48d920fafdca4baf",
    spotify: "2xxyuUOZJxayJDF6SxLG2K",
    genre: "jazz rap",
    popularity: "37",
  },
  {
    name: "Sam Outlaw",
    image: "https://i.scdn.co/image/436e86a562a5a2b0a55b29456ef763d8305d195a",
    spotify: "7H7Gnji0UkEt9bWGPRP55r",
    genre: "",
    popularity: "37",
  },
  {
    name: "Dugong Jr",
    image: "https://i.scdn.co/image/2ba39d101867c76dd3e592354ff5134935d71519",
    spotify: "5CJyoIE9kMfWbFbdVk721i",
    genre: "vapor twitch",
    popularity: "37",
  },
  {
    name: "Latmun",
    image: "https://i.scdn.co/image/6b5251c5f7723fb163496923bd2affe8e33a5f54",
    spotify: "2z9DWWfNONyl2nyy1GNSi0",
    genre: "house,uk tech house",
    popularity: "37",
  },
  {
    name: "Marcel Dettmann",
    image: "https://i.scdn.co/image/bda6b1e209c4f988612d371578dcbeead07e895b",
    spotify: "1sxHp39RqBEE01pgVqsdyP",
    genre: "minimal dub,minimal techno,techno",
    popularity: "37",
  },
  {
    name: "David Forbes",
    image: "https://i.scdn.co/image/2cd43583f64d70024161c501520cd84cc2d8d7ee",
    spotify: "3kwdB3aUfg0uneHczX2vTG",
    genre:
      "deep uplifting trance,progressive house,progressive trance,progressive uplifting trance,trance,uplifting trance",
    popularity: "37",
  },
  {
    name: "Antifuchs",
    image: "https://i.scdn.co/image/e3fae4d39bccc5e943bfcfee5502578700e43dc7",
    spotify: "5cPSq1945RxgQSIHkxp3Jq",
    genre: "",
    popularity: "37",
  },
  {
    name: "Moombahteam",
    image: "https://i.scdn.co/image/920d5e6dd16ce6021488aa3678168efd2b2ae853",
    spotify: "1CgCgQ7D7MDeHsgHLHHm8x",
    genre: "moombahton",
    popularity: "37",
  },
  {
    name: "Black Light Smoke",
    image: "https://i.scdn.co/image/ab67616d0000b2734feb45427455c969378c6eac",
    spotify: "6tBzfm9cIQVj3JFJnF2QTm",
    genre: "dark disco",
    popularity: "37",
  },
  {
    name: "Wild Whens",
    image: "https://i.scdn.co/image/46d9fae773b720bc60ff6ffb0e985393d1738b2c",
    spotify: "0GxIJscyTLtsH0wDF2Robf",
    genre: "norwegian country",
    popularity: "37",
  },
  {
    name: "Possessed by Paul James",
    image: "https://i.scdn.co/image/3ffd815a91c9fdc8ea50d10f5312dadd7f8e3b56",
    spotify: "3OKWUEJ7JsoqJdsgtviUvk",
    genre:
      "alternative country,deathgrass,deep new americana,garage punk blues,new americana,one-person band,roots americana,stomp and holler",
    popularity: "37",
  },
  {
    name: "Tamikrest",
    image: "https://i.scdn.co/image/fb76a06a302afd985d4af275b2ca75b6ff45404a",
    spotify: "6nZ1wn9URV4oWk4UKuG872",
    genre: "afropop,desert blues,malian blues,mande pop,tuareg guitar,world",
    popularity: "37",
  },
  {
    name: "Elk Road",
    image: "https://i.scdn.co/image/8af118571271ba66091d2adfee449588a220e50a",
    spotify: "3gR7KNFNsKnMg85WPOyAka",
    genre: "aussietronica",
    popularity: "37",
  },
  {
    name: "Audiojack",
    image: "https://i.scdn.co/image/2931517c828ffd4611062fd080424628a67d3345",
    spotify: "3Uvzk4iffO4mvchgRNJjbs",
    genre: "deep disco house,minimal tech house,minimal techno,tech house",
    popularity: "37",
  },
  {
    name: "Berget Lewis",
    image: "https://i.scdn.co/image/ab67616d0000b273ac15e90df02b006e170fa9fc",
    spotify: "56EYDRc4IlffrNZyE5vtOx",
    genre: "",
    popularity: "37",
  },
  {
    name: "Shanty",
    image: "https://i.scdn.co/image/ab67616d0000b2734540ce5eae0f0cc3944880e0",
    spotify: "7d2iWImkHTGIJ1upSfN45E",
    genre: "indonesian pop",
    popularity: "37",
  },
  {
    name: "Ruffian",
    image: "https://i.scdn.co/image/ab67616d0000b273f6aaa4a4600b2b76f3012f26",
    spotify: "6UY2DjySuGLS8Rvdi8ArnM",
    genre: "",
    popularity: "37",
  },
  {
    name: "Madeaux",
    image: "https://i.scdn.co/image/9b05ba5204c8a44705272321991f612f2b355b70",
    spotify: "1LTDQMVIIdgiJePJvUkBA3",
    genre: "vapor twitch",
    popularity: "37",
  },
  {
    name: "DJ Rebel",
    image: "https://i.scdn.co/image/7b0f8ec41648a59e56c498799168bc35eb688155",
    spotify: "0xP4NHjOAiPVmDkmMhAgu6",
    genre: "",
    popularity: "37",
  },
  {
    name: "Jason Eady",
    image: "https://i.scdn.co/image/d2cebe2cd95b77994d1ae9c7e88d586d89a8f73d",
    spotify: "78xCXcmrzDgoRkinWE0uUV",
    genre: "red dirt,roots americana,texas country",
    popularity: "37",
  },
  {
    name: "Backtrack",
    image: "https://i.scdn.co/image/3360e0ce7b74d155e0e1e89baad7f03dd1cc3541",
    spotify: "71N7xIvnaOFGetZL5nhWsl",
    genre: "melodic hardcore,metallic hardcore,nyhc,straight edge",
    popularity: "37",
  },
  {
    name: "AIROD",
    image: "https://i.scdn.co/image/97634da96eb08e17ffba9687ba12172e2c9ff13f",
    spotify: "3oPI0nOC7MHooFy5qDsFrv",
    genre: "french techno,minimal dub,raw techno",
    popularity: "37",
  },
  {
    name: "Guerilla Toss",
    image: "https://i.scdn.co/image/459fc611dfd3002e180602f5c8671897fc475286",
    spotify: "2PlLrStX2yK6CzyRi3TKnO",
    genre: "boston rock",
    popularity: "37",
  },
  {
    name: "Tim Vantol",
    image: "https://i.scdn.co/image/a05a27f3cf8c830b663cecb30cb7052f50f4ab5a",
    spotify: "1a1kfqTA5XiOHLhDFgZhSd",
    genre: "acoustic punk,dutch americana",
    popularity: "37",
  },
  {
    name: "Flowidus",
    image: "https://i.scdn.co/image/bd786663be3d430777f67696553a8b68870d7356",
    spotify: "410Yzyq0DmhJImIxqy5wOC",
    genre: "nz electronic",
    popularity: "37",
  },
  {
    name: "Rave Radio",
    image: "https://i.scdn.co/image/676734b41fc86a9a1432831f635cf74d3a52e51e",
    spotify: "7JrHNXd3zMD7xTFFhvnoyN",
    genre: "",
    popularity: "37",
  },
  {
    name: "Antiserum",
    image: "https://i.scdn.co/image/432bad55d594a3be3895eca21020d4a6b25a97fb",
    spotify: "2oZVtrCwHyCZlIWAwy3VBn",
    genre: "electronic trap,zapstep",
    popularity: "37",
  },
  {
    name: "Yoav",
    image: "https://i.scdn.co/image/814d7d2a3c535fcf85f1f6871975cb75bafe148d",
    spotify: "2TUFDVa7aZJ4O9U0qjrSJH",
    genre: "",
    popularity: "37",
  },
  {
    name: "a balladeer",
    image: "https://i.scdn.co/image/d92e2a9c216ba3a652c49b82026c04308f222993",
    spotify: "5MUNbMtqB3EOKxwSJBVJ1U",
    genre: "dutch indie,dutch rock",
    popularity: "37",
  },
  {
    name: "Pythius",
    image: "https://i.scdn.co/image/570b75ece81c17dbe6841b511ed81144ef70c57b",
    spotify: "0CRJK2gwHjs3IKm4uhjNTR",
    genre: "darkstep,neurofunk",
    popularity: "37",
  },
  {
    name: "Roberto Fonseca",
    image: "https://i.scdn.co/image/4d6b3ec7f9d49660aa98c0ccf18b56dc52167442",
    spotify: "0Yi6vOMIP1cqp8WppadgOu",
    genre: "cuban alternative,jazz cubano",
    popularity: "37",
  },
  {
    name: "Terror Bass",
    image: "https://i.scdn.co/image/e0d0e920d0e8f0e9bf92456021e200c84f97de37",
    spotify: "2ZYwKcrJntZhXiqsDg73P7",
    genre: "myanmar indie",
    popularity: "37",
  },
  {
    name: "DVNA",
    image: "https://i.scdn.co/image/d3e08be57e060b2028a0be2b393e4fbb2e29abce",
    spotify: "6yADvjIe1epS2B0tUJcfu1",
    genre: "australian alternative pop",
    popularity: "37",
  },
  {
    name: "The Mahones",
    image: "https://i.scdn.co/image/923d948bf9a7b63ee241e75b1a10588ac5d8a3bc",
    spotify: "1aTLhV7R5gUjrR60ubjz6V",
    genre: "canadian celtic,canadian punk,celtic punk,kingston on indie",
    popularity: "37",
  },
  {
    name: "Sylence",
    image: "https://i.scdn.co/image/ab67616d0000b2736aeb5109c4b1a1b613058de7",
    spotify: "0H6s1CbpvyZpA3hmZmuDxh",
    genre: "euphoric hardstyle,hardstyle",
    popularity: "37",
  },
  {
    name: "Nicki Bluhm",
    image: "https://i.scdn.co/image/4554798fa013107f894d3f6577e7400bc541b5b9",
    spotify: "0Ti7wMIMMaYKv582YN47Hh",
    genre: "nashville singer-songwriter",
    popularity: "37",
  },
  {
    name: "Tacocat",
    image: "https://i.scdn.co/image/e5e884c6366e97bf4232802d4ce20affd3f0e4f9",
    spotify: "3h0MN1neFknEvlYKxFmSQW",
    genre: "indie punk,indie surf,power-pop punk,riot grrrl,seattle indie",
    popularity: "37",
  },
  {
    name: "GotSome",
    image: "https://i.scdn.co/image/00c8cf720976d4a09b6c5dba4c21c9eca3417c01",
    spotify: "5eALE6GKSAiBNMyqpsqoeX",
    genre: "uk dance",
    popularity: "37",
  },
  {
    name: "Umoja",
    image: "https://i.scdn.co/image/d19ed3b3a48bcd76fe6346b83b0c83c4f70367bf",
    spotify: "6PuOeFpvcL6TYcRmEJKbdw",
    genre: "organic electronic",
    popularity: "37",
  },
  {
    name: "Fresh Coast",
    image: "https://i.scdn.co/image/5d041264029f8b8300c2283a0d6d0a1e696ae4a8",
    spotify: "6AiABQVLpWNCWDhBmYbRqG",
    genre: "",
    popularity: "37",
  },
  {
    name: "Archie Hamilton",
    image: "https://i.scdn.co/image/07731d62846074c691f9dad6edaf09c271c39fbc",
    spotify: "0DfYCARYRJ4vlSWlief3jv",
    genre: "minimal tech house,tech house,uk tech house",
    popularity: "37",
  },
  {
    name: "Juliet Sikora",
    image: "https://i.scdn.co/image/5b57f619da1a5c5ef5448825108f3f5f928674dd",
    spotify: "27dP6YOr1pGNXLpHRLjvYx",
    genre: "german tech house",
    popularity: "37",
  },
  {
    name: "Skinny Finsta",
    image: "https://i.scdn.co/image/cfe58269e638eb5d96044c95acdf12f085f28148",
    spotify: "394mHNdHlxgIz0xV21uPU5",
    genre: "german cloud rap,german underground rap,indie deutschrap",
    popularity: "37",
  },
  {
    name: "Kyrill & Redford",
    image: "https://i.scdn.co/image/29809a729ee407d64a53801edd85775897c5cdc3",
    spotify: "0f5EJHjvS8LiVLYYZwKa80",
    genre: "ethnotronica,groove room",
    popularity: "37",
  },
  {
    name: "Skinny Pelembe",
    image: "https://i.scdn.co/image/f50d7bf4679f098744bb3dd842c26ec6b3862be2",
    spotify: "1ZxriNuHn6Upjf3U97nnUN",
    genre: "indie jazz",
    popularity: "37",
  },
  {
    name: "Carla dal Forno",
    image: "https://i.scdn.co/image/20e1152c51387691455c53f9b9276fda47b801ed",
    spotify: "6FVxEgfQsGrJ0BogIOYCd6",
    genre:
      "art pop,chamber psych,electra,experimental pop,fourth world,freak folk,new isolationism,outsider house",
    popularity: "37",
  },
  {
    name: "JVST SAY YES",
    image: "https://i.scdn.co/image/ef4cbd3b4bbffa81dd373c9d2bc4d1c30bb6f45d",
    spotify: "7hwJ1s846DVAe2m0OIGupg",
    genre: "bass house,electro house",
    popularity: "37",
  },
  {
    name: "Warmduscher",
    image: "https://i.scdn.co/image/aabbcc98030c1392a93c4036ebcd1364cff3126f",
    spotify: "1CWwXncu9sk7EIdbvqcquR",
    genre: "chamber psych",
    popularity: "37",
  },
  {
    name: "Steve Allen",
    image: "https://i.scdn.co/image/f66916990135e3ccf3364e5f290cfac630f48d05",
    spotify: "5oM9MmVWGFrIcVyojUVwcJ",
    genre: "uplifting trance",
    popularity: "37",
  },
  {
    name: "YellowStraps",
    image: "https://i.scdn.co/image/1c5c778f2daf17bf2014ef5a14b43adb7d268812",
    spotify: "772hWD0N94gYjnVhrqE7lx",
    genre: "neo r&b",
    popularity: "37",
  },
  {
    name: "Paco Osuna",
    image: "https://i.scdn.co/image/8d59030b84e12ece036cab40e6923c9d9cd6a68d",
    spotify: "6vdIozDDsH4uJEAHN8tyS3",
    genre: "minimal techno,spanish techno",
    popularity: "36",
  },
  {
    name: "Ricardo Villalobos",
    image: "https://i.scdn.co/image/95504d0676d64e6c8b0413d2a679778e943f9c22",
    spotify: "0s2YIpNnjdf0FY4tNrF8Y4",
    genre: "german techno,microhouse,minimal techno,tech house",
    popularity: "36",
  },
  {
    name: "Brigitte Kaandorp",
    image: "https://i.scdn.co/image/ab67616d0000b2738cd7903f03be1885c3ca5eb7",
    spotify: "5vNPN3m7kQRZFuk3TGUJ5U",
    genre: "dutch cabaret,dutch rock",
    popularity: "36",
  },
  {
    name: "5NAPBACK",
    image: "https://i.scdn.co/image/0675b05d715836aa5b711850a593eded06e9d590",
    spotify: "0ERCrnTOTP6m7KbCLTliEj",
    genre: "belgian edm,moombahton",
    popularity: "36",
  },
  {
    name: "Rene Amesz",
    image: "https://i.scdn.co/image/25450153e3ea995c3c22749e2767a08c692354df",
    spotify: "0s122QsNac4WSqoVsFD60m",
    genre: "circuit,funky tech house,house,tech house",
    popularity: "36",
  },
  {
    name: "Derrick May",
    image: "https://i.scdn.co/image/ab67616d0000b27301f8402b66249ae5a32d7f25",
    spotify: "0v6N0xV7AfHHKVcgUOjC51",
    genre: "acid house,chicago house,detroit techno,minimal techno,techno",
    popularity: "36",
  },
  {
    name: "Lowriderz",
    image: "https://i.scdn.co/image/8dd866734cfb32912d94790c34bec115a9de4fde",
    spotify: "6r2jFoPfqDkcIFa0WlQTg6",
    genre: "belgian edm",
    popularity: "36",
  },
  {
    name: "Eli Escobar",
    image: "https://i.scdn.co/image/f9bdfee748af26c5039aa21bab07485190fe4d2c",
    spotify: "3J8gnwzixjNXj5gM6a7h93",
    genre: "deep house,nu disco",
    popularity: "36",
  },
  {
    name: "Ophidian",
    image: "https://i.scdn.co/image/ab67616d0000b273aedc15edbc055adaca465c6a",
    spotify: "1LgLuJSqAJJ6v5RCvjUiQh",
    genre:
      "gabba,happy hardcore,hardcore techno,industrial hardcore,speedcore,uptempo hardcore",
    popularity: "36",
  },
  {
    name: "Hodge",
    image: "",
    spotify: "28QI7cI1JmBvJY7sMFQrTx",
    genre: "korean ost",
    popularity: "36",
  },
  {
    name: "Overmono",
    image: "https://i.scdn.co/image/9e99ab00c7f4c3d17a33bb7170e71d51b5b22d9e",
    spotify: "01PnN11ovfen6xUOHfNpn3",
    genre: "bass music,float house,outsider house",
    popularity: "36",
  },
  {
    name: "Robert Hood",
    image: "https://i.scdn.co/image/80e69460c725961c1d7efebd2941687f6981c5f1",
    spotify: "5ipQlfnpRCtyOuhYqvPvQ8",
    genre:
      "acid house,chicago house,dark disco,detroit techno,dub techno,electro,microhouse,minimal dub,minimal techno,outsider house,tech house,techno",
    popularity: "36",
  },
  {
    name: "Caterina Barbieri",
    image: "https://i.scdn.co/image/ee1a74fe84807da93d29942e9b7ed3fc0ad4600f",
    spotify: "61WgG5fz5ilJrMne7tE1zu",
    genre:
      "ambient,art pop,deconstructed club,drone,electra,experimental ambient,experimental synth,fluxwork,fourth world,italian experimental,modular synth,new isolationism,outsider house",
    popularity: "36",
  },
  {
    name: "Christian Smith",
    image: "https://i.scdn.co/image/e447d22c5acdae03c8211dbea9df074228fad669",
    spotify: "0Z2EpubIhxnq4B6PV0I8n3",
    genre:
      "deep minimal techno,minimal techno,swedish techno,tech house,techno",
    popularity: "36",
  },
  {
    name: "Emanuel Satie",
    image: "https://i.scdn.co/image/b12cc075e1f760c27ec467955bcce15e1b7758ef",
    spotify: "3veg7sFGWTk62Ecwj6mzij",
    genre: "german tech house",
    popularity: "36",
  },
  {
    name: "Lucati",
    image: "https://i.scdn.co/image/9e7e2ac75be363fb89ca103f75625b4c60d4a7e2",
    spotify: "6l6CFc2kr864voPxTDcYZn",
    genre: "bass house",
    popularity: "36",
  },
  {
    name: "Brame & Hamo",
    image: "https://i.scdn.co/image/c82f5fbf58057b5e66d90b77ba927212c3cb2ae7",
    spotify: "0GH3NHvWddE49Egn2D5aRg",
    genre: "deep house,float house,irish electronic",
    popularity: "36",
  },
  {
    name: "Anile",
    image: "https://i.scdn.co/image/4f07cfb799f9c3783abf1debe4bb47b43f33c6f8",
    spotify: "4EFQ72yLfJfWI3eEz59fkY",
    genre: "drum and bass,drumfunk,liquid funk,uk dnb",
    popularity: "36",
  },
  {
    name: "Los Suruba",
    image: "https://i.scdn.co/image/597d8989d1db8f185a8c1a26fdb9a7aa96cf9ef1",
    spotify: "5ChHWvFPh4raexx461QFhS",
    genre: "",
    popularity: "36",
  },
  {
    name: "Hollis Brown",
    image: "https://i.scdn.co/image/d560d485d6162b9d243ba5c6c40bb33f5b521eea",
    spotify: "4Ayh1SXnVpYPCVR4190RXw",
    genre: "deep new americana,modern blues rock",
    popularity: "36",
  },
  {
    name: "Dwson",
    image: "https://i.scdn.co/image/16a6f606bd04461d86a887189fa71d0e5301bc11",
    spotify: "60ZIrIA1iT9NStXmdAuhjR",
    genre: "afro house,kwaito house",
    popularity: "36",
  },
  {
    name: "Staffan Hellstrand",
    image: "https://i.scdn.co/image/9f0a172420d1206dc2b863e1fee8a6e3ef20b03a",
    spotify: "0smhbmfhr1L1vFZskdZIsl",
    genre: "classic swedish pop",
    popularity: "36",
  },
  {
    name: "distinkt",
    image: "https://i.scdn.co/image/11f80a459d073c09653ab2f4d8f901b5d02d481a",
    spotify: "55hWlrQE8eBgArfN6nAWug",
    genre: "bass house",
    popularity: "36",
  },
  {
    name: "Flava",
    image: "https://i.scdn.co/image/b5c61455560e33059e1e1d88bbcd9293584da352",
    spotify: "3fDucEtXKiKEEgyCnRYg58",
    genre: "",
    popularity: "36",
  },
  {
    name: "Sonic Species",
    image: "https://i.scdn.co/image/e055cd9022beed5f0ef7334566d2a02f261cac46",
    spotify: "0RB2HADLaxeaZAlNus7vVG",
    genre: "full on,progressive psytrance,psychedelic trance",
    popularity: "36",
  },
  {
    name: "Godlands",
    image: "https://i.scdn.co/image/634dd13e3a52530ece005ee78abfedbdc4794c6f",
    spotify: "2BW6zD5lzOxdEFWrgsHMq8",
    genre: "electra",
    popularity: "36",
  },
  {
    name: "Ruben Hein",
    image: "https://i.scdn.co/image/c315f6fa2cfdc1c50aff48ee23f5662fe07d02dd",
    spotify: "2O4jyeF4uyGLsGcjY49zbS",
    genre: "dutch pop,dutch r&b",
    popularity: "36",
  },
  {
    name: "Lister",
    image: "https://i.scdn.co/image/78f851428fe3e203abad71995dcf6778a06f9154",
    spotify: "3PVaZbavVE6omwXa3SNLmI",
    genre: "",
    popularity: "36",
  },
  {
    name: "Sizarr",
    image: "https://i.scdn.co/image/c273311a09124bf2b3b509546a99c2bf1e097545",
    spotify: "50C86uojThm4vE2gsFqhxI",
    genre: "german indie",
    popularity: "36",
  },
  {
    name: "Approachable Members of Your Local Community",
    image: "https://i.scdn.co/image/5000bb77033bf920448a585a322a074048f54478",
    spotify: "2Tk2sOxCRRtUX77c1V6Ifb",
    genre: "australian alternative pop",
    popularity: "36",
  },
  {
    name: "Neilio",
    image: "https://i.scdn.co/image/ab67616d0000b27303f99d6008580495aca85781",
    spotify: "2wgZcTOArO4znVZzjKkiOH",
    genre: "catstep,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "36",
  },
  {
    name: "Gekkenhuys",
    image: "https://i.scdn.co/image/1364cb6dd1285fce4cd114133e2858812ccaf8aa",
    spotify: "0vp689eodFw3Fh2ctawZGB",
    genre: "carnaval,nederlandse hardstyle",
    popularity: "36",
  },
  {
    name: "Anna Depenbusch",
    image: "https://i.scdn.co/image/dc4b44d1f427cb0dfeea776039256ec08e682135",
    spotify: "6mB7S9U5pYT983t2bVzmED",
    genre: "german pop,german rock,german singer-songwriter,liedermacher",
    popularity: "36",
  },
  {
    name: "Spitnoise",
    image: "https://i.scdn.co/image/ab67616d0000b2737293937e39f4497fc86c0dd7",
    spotify: "29kB8Ku9QQNmrl3yZw6Xxl",
    genre: "uptempo hardcore",
    popularity: "36",
  },
  {
    name: "Clarian",
    image: "https://i.scdn.co/image/3392ede84da4b373ef3e69cf4f7255bc0b44786d",
    spotify: "2polW59xyLfTDB4E5Ig7Xa",
    genre: "tech house",
    popularity: "36",
  },
  {
    name: "Vels Trio",
    image: "https://i.scdn.co/image/ab67616d0000b2731067bc9d61a37c9432b0d840",
    spotify: "68ZVpxiS12BeN3EgBgXW0l",
    genre: "british jazz,indie jazz,modern jazz trio,uk contemporary jazz",
    popularity: "36",
  },
  {
    name: "Harleighblu",
    image: "https://i.scdn.co/image/e21f4febde36a12a07c62b97814cb3eb3ae408e6",
    spotify: "4cEYh7S0lnB9zj30tzPorE",
    genre: "british soul",
    popularity: "36",
  },
  {
    name: "Das Moped",
    image: "https://i.scdn.co/image/0a015f34dc5d6c957d739e5978fbfffc67f53d5c",
    spotify: "3JwwCZUNR8yoUDsNbmY86a",
    genre: "german indie,german indie rock",
    popularity: "36",
  },
  {
    name: "Animato",
    image: "https://i.scdn.co/image/d639c9ee6700a64016f31a24d7bdecc36d420eb6",
    spotify: "3EbiMr7AC6OqfPcrEHPVtL",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "36",
  },
  {
    name: "Amartey",
    image: "https://i.scdn.co/image/dbf704108c4a0bea092f5f79332b73534fb72786",
    spotify: "2yVIMZ3tHWSmoP3ZLwJmJu",
    genre: "dutch trap pop",
    popularity: "36",
  },
  {
    name: "Robin Roxette",
    image: "https://i.scdn.co/image/b19620709ebcdbe695638bfb311b636bd3c5a8ad",
    spotify: "1brrW50XBilcXfvh02W8jV",
    genre: "dutch moombahton",
    popularity: "36",
  },
  {
    name: "Get The Shot",
    image: "https://i.scdn.co/image/1afcbc3b2cc143a26eb4daf9374ee7e9895798c6",
    spotify: "47YTOUaDKlPoDHr00r5Wu2",
    genre: "canadian hardcore",
    popularity: "36",
  },
  {
    name: "Richy Ahmed",
    image: "https://i.scdn.co/image/adda1b49480989506e9b00190d433c56edb1c907",
    spotify: "1ac5NUFh98sMs0DGX4xlSt",
    genre: "deep disco house,house,minimal tech house",
    popularity: "36",
  },
  {
    name: "First Blood",
    image: "https://i.scdn.co/image/be59d27f4d6b8f63f74b42681643d7a908d03936",
    spotify: "4z2rZXnFuTCl75Vpb26Eg0",
    genre: "beatdown,hardcore,straight edge,vegan straight edge",
    popularity: "36",
  },
  {
    name: "Horisont",
    image: "https://i.scdn.co/image/2f96bc870771ecc17362e9c0832a2d1afeeeb273",
    spotify: "1tPw1T8FYkf9GoxQeTzIgU",
    genre: "psychedelic doom,retro metal,space rock,swedish stoner rock",
    popularity: "36",
  },
  {
    name: "Vaudou Game",
    image: "https://i.scdn.co/image/792f4dae65cabb9b5cf8eadd1bfdd76afac52e69",
    spotify: "7MEH1SUDgj0NU6gDjDXokz",
    genre: "afrobeat,afropop,togolese pop",
    popularity: "36",
  },
  {
    name: "Bobby Rock",
    image: "https://i.scdn.co/image/4fbdba0417c44b577637c1c3cadc86309de17b8f",
    spotify: "7taXPPoSqkAxuFE603JD2k",
    genre: "dutch edm",
    popularity: "36",
  },
  {
    name: "Kaiser Quartett",
    image: "https://i.scdn.co/image/78f76f14a44b16a6828c2fcad37469d29c05721e",
    spotify: "2VTqmf8ZEe2Y4cKztXkr9D",
    genre: "modern string quartet",
    popularity: "36",
  },
  {
    name: "Joshua Ray Walker",
    image: "https://i.scdn.co/image/7e5387bd7f67716e21d77c73cee344990f1e4f6e",
    spotify: "5SlqleEyFgUYZEZCJ5juDr",
    genre: "alternative country,roots americana",
    popularity: "36",
  },
  {
    name: "Gramophonedzie",
    image: "https://i.scdn.co/image/a860a875bc23d02895c202f34b6ad2f88c34fef7",
    spotify: "7jHmmW2bBagmzr76ZJW8Bc",
    genre: "electro swing",
    popularity: "36",
  },
  {
    name: "The New Shining",
    image: "https://i.scdn.co/image/0783028dd98e9e8d93638bc1f84893c198927a7e",
    spotify: "6Y4SgUdlzTgSbmKba01ncJ",
    genre: "rotterdam indie",
    popularity: "36",
  },
  {
    name: "Midas Hutch",
    image: "https://i.scdn.co/image/78381256587e045f961512a42f0efbee1bb658ec",
    spotify: "3sN7A6NULbpDrV5bAD9B6g",
    genre: "dutch pop",
    popularity: "36",
  },
  {
    name: "Kaia Kater",
    image: "https://i.scdn.co/image/3c0c2873ef8036b6eece7a04fbf6d92ffab2279b",
    spotify: "3SIjUKYSRchIKIoFO9vBjm",
    genre:
      "alternative americana,canadian americana,canadian folk,canadian singer-songwriter,new americana",
    popularity: "36",
  },
  {
    name: "Cláudio Ismael",
    image: "https://i.scdn.co/image/ab67616d0000b27342f9672bba2013eac1a78070",
    spotify: "5EoiaFh1ngnwqgcptsXRTo",
    genre: "kizomba",
    popularity: "36",
  },
  {
    name: "Dee Montero",
    image: "https://i.scdn.co/image/5611625d2853f9e59fec510c746c641960a7b75c",
    spotify: "46RoK8NBTMTyu23GiHqbCr",
    genre: "organic house,progressive house",
    popularity: "36",
  },
  {
    name: "Oceans of Slumber",
    image: "https://i.scdn.co/image/1a18186ae1fa80ff12bedeed0465c4f9c1a9ad50",
    spotify: "2JSza6IRxLr1Ez3wqKd0SY",
    genre: "gaian doom,slayer",
    popularity: "36",
  },
  {
    name: "Mad Mac",
    image: "https://i.scdn.co/image/3a8904397f3f1a06d8e263cc36269584694727bb",
    spotify: "2pEPovaOzi7hYStoDK5WxM",
    genre: "",
    popularity: "36",
  },
  {
    name: "Konradsen",
    image: "https://i.scdn.co/image/da35491e006f633f9aed4b8039fc89e1b19a570c",
    spotify: "59CWeBMEzwj6U2HhTVLJ3O",
    genre: "norwegian contemporary jazz,norwegian indie,oslo indie",
    popularity: "36",
  },
  {
    name: "Kaiser Franz Josef",
    image: "https://i.scdn.co/image/8912315ba9810763f42bc4aa53df50895e4b9bf7",
    spotify: "2BjP65TFh41pjLvCvR7vJj",
    genre: "austrian metal",
    popularity: "36",
  },
  {
    name: "Milan Knol",
    image: "https://i.scdn.co/image/cc152dce67115123cd214290177fc210fb3d8039",
    spotify: "3QPrW2AxSYf8F6cSqPceLZ",
    genre: "",
    popularity: "36",
  },
  {
    name: "India Jordan",
    image: "https://i.scdn.co/image/3bd1015557a3af18458c02c26e162e9619a39383",
    spotify: "5RMLpCv3ic2KtGnqJ7eMG4",
    genre: "experimental techno",
    popularity: "36",
  },
  {
    name: "Colin Blunstone",
    image: "https://i.scdn.co/image/81d6cb7fced66fdbb8f6e1b9b5cf3ca83bcebb7f",
    spotify: "27DCwiPx5ocQsf4K43SlIL",
    genre: "classic uk pop",
    popularity: "36",
  },
  {
    name: "Need For Mirrors",
    image: "https://i.scdn.co/image/374b066ef6d766d5814787135b7da7a636896f57",
    spotify: "0bR5osQX9Kn0wmtUPQQhze",
    genre:
      "deep liquid bass,drum and bass,drumfunk,jump up,jungle,liquid funk,neurofunk,uk dnb",
    popularity: "36",
  },
  {
    name: "Kate Elsworth",
    image: "https://i.scdn.co/image/27cf777e6061b1d355a6d1a56c76a385fc111739",
    spotify: "3lHI0h5NymKIJmDOxqHIgJ",
    genre: "australian dance",
    popularity: "36",
  },
  {
    name: "Gardna",
    image: "https://i.scdn.co/image/9205001f4f3cada7a279d030c0f0f0fdfbcf3fe3",
    spotify: "4thIP9ruwthrnBaBU9Wz8U",
    genre: "ragga jungle",
    popularity: "36",
  },
  {
    name: "King King",
    image: "https://i.scdn.co/image/7a78ec87bd48fb5832fa130ab584d7e21218cae3",
    spotify: "4SXsNXgRundFdewI58vbZT",
    genre: "modern blues rock,modern hard rock",
    popularity: "36",
  },
  {
    name: "SRVD",
    image: "https://i.scdn.co/image/ab67616d0000b273eb5e630f97aed93e3e31ce67",
    spotify: "2nhdOVEJpiDFkwcaBxpWCP",
    genre: "",
    popularity: "36",
  },
  {
    name: "Richie Stephens",
    image: "https://i.scdn.co/image/fa140bee319c98f2e62f3b6ead5e3e33ad7b3343",
    spotify: "6vHXmFLRCxvJPquxCpCl7c",
    genre:
      "deep ragga,lovers rock,old school dancehall,reggae fusion,roots reggae",
    popularity: "36",
  },
  {
    name: "Oranssi Pazuzu",
    image: "https://i.scdn.co/image/c46907b82c51ea91bc8eff4229d107f05abea6da",
    spotify: "3XFQRe2FsSOjrODygK4caW",
    genre:
      "atmospheric black metal,avant-garde metal,blackgaze,chaotic black metal,cosmic black metal,dark jazz,drone metal,finnish black metal,finnish psychedelic rock,post-black metal,post-doom metal,post-metal,sci-fi metal,voidgaze",
    popularity: "36",
  },
  {
    name: "Armoo",
    image: "https://i.scdn.co/image/4320fed29e0b54c8521dba346cd0e7bb5b5444b6",
    spotify: "6U5q52OFnYBPAB4NQZDhCR",
    genre: "dutch trap pop",
    popularity: "36",
  },
  {
    name: "The Hempolics",
    image: "https://i.scdn.co/image/18f801914d7a1785825d473a028ad1a0fa8c0fd6",
    spotify: "6gTdfUDImVBjuPjAHZGHUS",
    genre: "uk reggae",
    popularity: "36",
  },
  {
    name: "Manu Delago",
    image: "https://i.scdn.co/image/687e05f0a869e9a7c390fc5d0ea190a0f7f079bd",
    spotify: "08LrhaMKwKuGbB9XHBEjXF",
    genre: "hangpan,new tribe",
    popularity: "36",
  },
  {
    name: "Melissa Lopes",
    image: "https://i.scdn.co/image/ab67616d0000b2737704f69dab94371b2dd15f5a",
    spotify: "67qIVZfLi2zNpwqyrrOMCP",
    genre: "dutch pop,dutch trap pop",
    popularity: "36",
  },
  {
    name: "Rockywhereyoubeen",
    image: "https://i.scdn.co/image/ccd8492d5f754c73ae046f1d476cea59c1d4a8f1",
    spotify: "5pieMKHiTXhVZEmlMT0ij7",
    genre: "dutch hip hop",
    popularity: "36",
  },
  {
    name: "Sofia Dragt",
    image: "https://i.scdn.co/image/b34fee21716db94d5e9bb35adac7d709db1ca3fb",
    spotify: "6SbjUvOLEYreFr16Gvn8kv",
    genre: "",
    popularity: "36",
  },
  {
    name: "Modern Color",
    image: "https://i.scdn.co/image/04f79cd1d51cec02eef5289bc466d7df84f09c40",
    spotify: "6bayHl2VHbIseMg1jby37l",
    genre: "american shoegaze",
    popularity: "36",
  },
  {
    name: "Mdou Moctar",
    image: "https://i.scdn.co/image/7d37593e58fd3e7a5e2bf0f17fa2cc28a772e27e",
    spotify: "48dgx7iGqLQ3E5KO3pzd94",
    genre: "desert blues,tuareg guitar",
    popularity: "36",
  },
  {
    name: "Joey Cape",
    image: "https://i.scdn.co/image/ab6772690000c46c342bf170bfddfd87acf650d4",
    spotify: "47LEGQCc9FShxKmbod8u7e",
    genre: "melodic hardcore,skate punk",
    popularity: "36",
  },
  {
    name: "Wisdom In Chains",
    image: "https://i.scdn.co/image/e8cff39560640d555340cedd6b777e411fe8b031",
    spotify: "4dtEJEODoOpnmnjnsNDaSd",
    genre: "hardcore,pennsylvania hardcore,straight edge",
    popularity: "36",
  },
  {
    name: "Future Palace",
    image: "https://i.scdn.co/image/67ff213c3eab61474cfdf2b8963bd0bf83ab399f",
    spotify: "4QnuZOyl4C9d1keyOZXJ21",
    genre: "german post-hardcore",
    popularity: "36",
  },
  {
    name: "Lillie Mae",
    image: "https://i.scdn.co/image/b549488ac23381490ec6148cc796db4bd35975bd",
    spotify: "32bF8EkwKNXBZyEo371paF",
    genre:
      "nashville americana,nashville indie,nashville singer-songwriter,new americana",
    popularity: "36",
  },
  {
    name: "Che Sudaka",
    image: "https://i.scdn.co/image/349885a494b66e5634df0ae2d2fd0b01f73fd6c9",
    spotify: "0jnrXJGvpD9mcWSlf0zTGU",
    genre: "latin alternative",
    popularity: "36",
  },
  {
    name: "Dirty Beaches",
    image: "https://i.scdn.co/image/2ecc187703596a3693ef4778f9360a478e167f9b",
    spotify: "7JRs0G0kHZTBs0Lo7qOjL8",
    genre: "nu gaze,one-person band,quebec indie",
    popularity: "36",
  },
  {
    name: "Cashmiri",
    image: "",
    spotify: "0lknEH8Gf3hoAjVKayWDb7",
    genre: "",
    popularity: "36",
  },
  {
    name: "Peter Koelewijn",
    image: "https://i.scdn.co/image/ab67616d0000b2735d632784f043c89204a8cd2f",
    spotify: "3oavnC2N25caTse16Gj8HR",
    genre: "dutch rock,levenslied,nederpop",
    popularity: "36",
  },
  {
    name: "Russ Ballard",
    image: "https://i.scdn.co/image/5df9eb0d0cb5b130c3c330cdcd60499c937e776d",
    spotify: "1TOvAjOdz0YBx2wVRlBvFA",
    genre: "album rock",
    popularity: "36",
  },
  {
    name: "Tina Naderer",
    image: "https://i.scdn.co/image/ae6220165bb3fc38ea5b0b6ba4c791112f790dad",
    spotify: "48a7nVFcbbNSpsOHtpWnt2",
    genre: "austrian pop",
    popularity: "36",
  },
  {
    name: "Aziz Wrijving",
    image: "https://i.scdn.co/image/d516f662549d18bd624824e301ef0a22c69c8552",
    spotify: "1T3gGSbIoc9onQ9rfCbZXw",
    genre: "basshall,dutch trap pop,surinamese pop",
    popularity: "36",
  },
  {
    name: "Kid Noize",
    image: "https://i.scdn.co/image/d243a017021afcd408b9a9b150dcd1fe4d7ace99",
    spotify: "1nSBihjWQgnAwxnd65XPdN",
    genre: "belgian pop",
    popularity: "36",
  },
  {
    name: "Jenna G",
    image: "https://i.scdn.co/image/684cf34b4f2c78150e21b5aa198fca31f64b5a98",
    spotify: "4uQD4KYQjo6uYeNhLyvIUe",
    genre: "drum and bass,liquid funk",
    popularity: "36",
  },
  {
    name: "Dany Bpm",
    image: "https://i.scdn.co/image/3f36d3112098a4800a2f69f36b1d3df1a63834a8",
    spotify: "3E6p5In4n4lbmS6oVipW8R",
    genre: "makina",
    popularity: "36",
  },
  {
    name: "Michigan Rattlers",
    image: "https://i.scdn.co/image/ae0b57e0be9b402e42e78821862338cb198929f3",
    spotify: "6X28JIfV57XfgqBpdAML7E",
    genre: "deep new americana",
    popularity: "36",
  },
  {
    name: "Zoo Brazil",
    image: "https://i.scdn.co/image/c990a33c3da14a38a4201a542f3acc3b18e8c9c5",
    spotify: "7KXpXc29g9x7kFBnM2HcrM",
    genre: "swedish house,tech house",
    popularity: "36",
  },
  {
    name: "Raja Ram",
    image: "https://i.scdn.co/image/3ffc82701e3c82f053b99841090f8cd560fb81b3",
    spotify: "5jBTxtjj3Y3cDgoqWbFJxy",
    genre: "",
    popularity: "36",
  },
  {
    name: "Boogshe",
    image: "https://i.scdn.co/image/ee278c0f0f60e145ee5634963a3210a29afeebb5",
    spotify: "0XugtaijoMOUdu6eVWPtX3",
    genre: "",
    popularity: "35",
  },
  {
    name: "Andre Manuel",
    image: "https://i.scdn.co/image/ab67616d0000b273e6041af3e949d4267bfa3787",
    spotify: "1qv8VOCmWfmKg7aZcF2BT6",
    genre: "streektaal",
    popularity: "35",
  },
  {
    name: "Prunk",
    image: "https://i.scdn.co/image/5b92fca1f397dcca4726fd011e11b67eee582f17",
    spotify: "6FJfLfGO9X2AVNz0sFscrG",
    genre: "dutch tech house,minimal tech house",
    popularity: "35",
  },
  {
    name: "Kutski",
    image: "https://i.scdn.co/image/633e1f80ac0c6f020e8bd7d55f4bf7a672df3a46",
    spotify: "49PZ7FFeHPdNJlOd76pmdr",
    genre: "",
    popularity: "35",
  },
  {
    name: "Cat Carpenters",
    image: "https://i.scdn.co/image/7c5b9984fff35f68286a3bdac0134de821e4444a",
    spotify: "3J6Hgog3u0WQPf69kJvu0o",
    genre: "dutch house",
    popularity: "35",
  },
  {
    name: "German Brigante",
    image: "https://i.scdn.co/image/85addf6e749985465fd67f02b807ef39ad42182d",
    spotify: "2h7fN6KOZVgWQ39sYK0jJm",
    genre: "latin tech house,minimal techno",
    popularity: "35",
  },
  {
    name: "Nathan Micay",
    image: "https://i.scdn.co/image/5143428d1e735b8f0dc35ad5eb965c9165a4b170",
    spotify: "6U7MOIhacysUEnfJ41WfhC",
    genre: "canadian house,experimental house,float house",
    popularity: "35",
  },
  {
    name: "GAWP",
    image: "https://i.scdn.co/image/9329b1fe0e47fd411d4351239895e263cdbe4279",
    spotify: "7nRbEJhGU1wq3sEuQelrzb",
    genre: "bass house",
    popularity: "35",
  },
  {
    name: "Thijs Boontjes",
    image: "https://i.scdn.co/image/11bac6dbec5b78d07ef84779c1f70b3fd95c42d6",
    spotify: "7Hx2t9BIWDlr3Bpd6eWmei",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "35",
  },
  {
    name: "Zwart Licht",
    image: "https://i.scdn.co/image/63cc41ea3ed8856f70a0ecc61621d1090f5c65c9",
    spotify: "0w8HhtFVgF0tqeiFGFRaiZ",
    genre: "dutch hip hop",
    popularity: "35",
  },
  {
    name: "Jesse Perez",
    image: "https://i.scdn.co/image/1a46b269772ebfb4fe1164638eeff7f4f8147f1a",
    spotify: "28tbqi7xhIZs8RRGdeCy8d",
    genre: "",
    popularity: "35",
  },
  {
    name: "Traumer",
    image: "https://i.scdn.co/image/f9531471c8c8786376f9e0fc6273acf0a7876c23",
    spotify: "55qp3isnfx4ZKPHw5oP4eh",
    genre: "french techno,minimal tech house",
    popularity: "35",
  },
  {
    name: "Heideroosjes",
    image: "https://i.scdn.co/image/117aa6a2caf215b424afa1561debd51d4f4732dc",
    spotify: "3gmW7lOonf6IfBxEE1VBBJ",
    genre: "dutch punk,dutch punk rock,dutch rock",
    popularity: "35",
  },
  {
    name: "Binkbeats",
    image: "https://i.scdn.co/image/4e7511678be6d9c97dfc14491a0a89ee41557cf8",
    spotify: "7exctwYNULoOlBmGGUwIzd",
    genre: "dutch experimental electronic,jazztronica",
    popularity: "35",
  },
  {
    name: "David Keno",
    image: "https://i.scdn.co/image/4338aeab7c9f114d23f748ea1dacb77d88a41eb3",
    spotify: "0cWqRMk3D45eG7PpILb4OL",
    genre: "tech house",
    popularity: "35",
  },
  {
    name: "One More Time",
    image: "https://i.scdn.co/image/ab67616d0000b273ea07e580dfdcccb344da5b20",
    spotify: "1rul5bbgdYqUTi9TgifzVq",
    genre: "europop",
    popularity: "35",
  },
  {
    name: "The Cool Quest",
    image: "https://i.scdn.co/image/70b87744e8c8e4dbbea5e9ab3dd1db895d82d556",
    spotify: "7eW7XlHPEaGBY5JION7Vw9",
    genre: "",
    popularity: "35",
  },
  {
    name: "Paddy Casey",
    image: "https://i.scdn.co/image/9775e6d1537c2342188520661a3aa630eb54a79b",
    spotify: "3t61q4MDXG8a22cRCv1ghZ",
    genre: "irish rock,irish singer-songwriter",
    popularity: "35",
  },
  {
    name: "Matthew Dekay",
    image: "https://i.scdn.co/image/ff0c4115bfcc5eeaf08807c90d0b7dcc7dc75b34",
    spotify: "1ehDqG6bFGAurxlAJeQgNT",
    genre: "deep progressive trance,organic electronic,organic house",
    popularity: "35",
  },
  {
    name: "Louis XIV",
    image: "https://i.scdn.co/image/0e4ae7b23d03fcdf7ae8106b196fbbf5e8201ae5",
    spotify: "60NKN6tZYKbkjX1qpFQIqF",
    genre: "dance-punk,garage rock revival",
    popularity: "35",
  },
  {
    name: "Yahtzel",
    image: "https://i.scdn.co/image/a790d957eda3a2bf2fca4af277b344ad0b8189db",
    spotify: "1zlKMq4vfH4f037a8JjKlq",
    genre: "",
    popularity: "35",
  },
  {
    name: "Tapesh",
    image: "https://i.scdn.co/image/0287faeb12b563df0eebe46698e5e26dfe6e7471",
    spotify: "3QFCVNPqeV1hpZRh0dbLat",
    genre: "dusseldorf electronic",
    popularity: "35",
  },
  {
    name: "Noise Cartel",
    image: "https://i.scdn.co/image/d7821e70d59ce0fcf79e8a51efb93ed92702dcc5",
    spotify: "5yDz8X7IIvH7PheEXbo3VN",
    genre: "carnaval,nederlandse hardstyle",
    popularity: "35",
  },
  {
    name: "James Marvel",
    image: "https://i.scdn.co/image/675f58ffd0e60244098ff6c5eccc42db9e435f98",
    spotify: "0PvM7YGil23rlj6bXdv8kZ",
    genre: "",
    popularity: "35",
  },
  {
    name: "Bleep Bloop",
    image: "https://i.scdn.co/image/7e1c7a1391839779945e3971a5ab15f832c09863",
    spotify: "4yimrbAH3tCaYHxuwksfY6",
    genre: "electronic trap,experimental bass,glitch hop",
    popularity: "35",
  },
  {
    name: "Roberto Capuano",
    image: "https://i.scdn.co/image/daf97ff54b623a7ff2757aee8af43f5290082347",
    spotify: "2XWr3TCJUE6XBKd6BQrAc1",
    genre: "deep minimal techno,italian techno",
    popularity: "35",
  },
  {
    name: "Audiofly",
    image: "https://i.scdn.co/image/51da9386916acd0667371a0ff89698b56165d24e",
    spotify: "7JfTEfBRAB8ccDajaHdMlT",
    genre: "deep disco house,minimal tech house,tech house",
    popularity: "35",
  },
  {
    name: "Der Dritte Raum",
    image: "https://i.scdn.co/image/72fa01b4eefcc1ab1b433724af11ceafa06a8b96",
    spotify: "5RZGHff3PE1rPUKOpDIqaO",
    genre: "classic progressive house,german techno,minimal techno,tech house",
    popularity: "35",
  },
  {
    name: "Boston 168",
    image: "https://i.scdn.co/image/ba99c6886cc1a949b6d10ad5a40599ec516cb333",
    spotify: "2C5ZMi6drXQAbj9LNhzZo0",
    genre: "acid techno,italian techno,minimal dub",
    popularity: "35",
  },
  {
    name: "Royalston",
    image: "https://i.scdn.co/image/cfa7f58fa90f77d380a9cb852f00de0a65997fdc",
    spotify: "192sKI0OYrv2EUJnSME4bL",
    genre: "deep liquid bass,drum and bass,liquid funk",
    popularity: "35",
  },
  {
    name: "Definition",
    image: "https://i.scdn.co/image/76e4a820f2ff9acaace53d3f1688a084989b5cbc",
    spotify: "7KT19dObRj1T5OgnyQFm4C",
    genre: "melodic techno",
    popularity: "35",
  },
  {
    name: "Volkoder",
    image: "https://i.scdn.co/image/3eb96146a1372b32f51c3db2cd827f8fbc6bae96",
    spotify: "5SwGFGfUlV6Dan4ygjF5CU",
    genre: "brazilian edm",
    popularity: "35",
  },
  {
    name: "Stefano Noferini",
    image: "https://i.scdn.co/image/45ce019ca29a000d83dd459f4428ddb84a32f6fe",
    spotify: "4IVlorYhuVoIUWg6HVx6DK",
    genre: "funky tech house,italian tech house,tech house",
    popularity: "35",
  },
  {
    name: "Nicky Night Time",
    image: "https://i.scdn.co/image/54cacbed5d8267ea607bcd952fbc68b8e1e54fe4",
    spotify: "7eonsju0gRRDsBvySAYDiY",
    genre: "deep groove house",
    popularity: "35",
  },
  {
    name: "Outlander",
    image: "https://i.scdn.co/image/bc88fc5ebe9ddbaf81030d1945ed5ca5156dd60d",
    spotify: "719QNv2dpubOiMYaxydbVq",
    genre: "chinese hip hop",
    popularity: "35",
  },
  {
    name: "Ilgen-Nur",
    image: "https://i.scdn.co/image/f1b1fa23c3fa71d844086e4073585fba898490af",
    spotify: "4FjRuMCcbAdiYBr47QE3xX",
    genre: "german indie,stuttgart indie",
    popularity: "35",
  },
  {
    name: "Vincent Malin",
    image: "https://i.scdn.co/image/c65f1047f90f165b9598f523e696f97434c668e2",
    spotify: "05gLAfcZRjyxxr96ebcqbG",
    genre: "german pop",
    popularity: "35",
  },
  {
    name: "Raynor Bruges",
    image: "https://i.scdn.co/image/45f3c3f6035e954910a3d64489eec3a0eccc1033",
    spotify: "390dAON46Qa1AFrtCFnj8B",
    genre: "basshall,dutch trap pop",
    popularity: "35",
  },
  {
    name: "Wouter Hamel",
    image: "https://i.scdn.co/image/ef1b92dcb2876391b85afc283649b7280dc8721e",
    spotify: "7eK4wPcMgmSIxcGBS2lJl0",
    genre: "dutch pop,dutch rock",
    popularity: "35",
  },
  {
    name: "Logic1000",
    image: "https://i.scdn.co/image/ab67616d0000b27360c5db3e60f782a570eeb753",
    spotify: "2EFsfh1zewsSWhDINv7j1I",
    genre: "ukg revival",
    popularity: "35",
  },
  {
    name: "Izabel",
    image: "https://i.scdn.co/image/87bb857dc60d4cc28e9fc1415f095d9d6e4aa2c4",
    spotify: "3YTr9y6XOl88xxHv246Vlf",
    genre: "",
    popularity: "35",
  },
  {
    name: "Dustbowl Revival",
    image: "https://i.scdn.co/image/13bf273f13c8b4b706be60a83212696609aa3e43",
    spotify: "3cB0nIIeIGSuMlw6rnu1dm",
    genre: "alternative americana,deep new americana",
    popularity: "35",
  },
  {
    name: "Lucky Date",
    image: "https://i.scdn.co/image/6c4653695888a9e9ad6be544dd46d10ecfb6cf06",
    spotify: "6nNKPNNjOy3my0IYO8l0v4",
    genre: "complextro,deep big room,electro house",
    popularity: "35",
  },
  {
    name: "Steve Bug",
    image: "https://i.scdn.co/image/fb8a64b68e94d4ba2b0a1e52d35c9998c7974bb7",
    spotify: "4SoC2HfA0nGk3xCJ3hRG3J",
    genre:
      "german house,german techno,microhouse,minimal tech house,minimal techno,tech house",
    popularity: "35",
  },
  {
    name: "Bokassa",
    image: "https://i.scdn.co/image/eb52df7a7c6b86cc245b1f1dda35cd9a54637649",
    spotify: "3QgBKy7myJIAIMe1A1y7uq",
    genre: "norwegian hardcore,norwegian punk rock,norwegian rock",
    popularity: "35",
  },
  {
    name: "Station Earth",
    image: "https://i.scdn.co/image/9dafbe4f8adbab6edde7b8f9839dc64068937132",
    spotify: "1G9FmqZJybVEOXqMOR5usy",
    genre: "",
    popularity: "35",
  },
  {
    name: "EAUXMAR",
    image: "https://i.scdn.co/image/ac9156953f197035f46748f2d6adbcac69e337b6",
    spotify: "6jjKAAi2ahf5gQ37k7rJya",
    genre: "dutch edm",
    popularity: "35",
  },
  {
    name: "Nie und Nimmer",
    image: "https://i.scdn.co/image/5dd67fd2c4bf09f917726c25bf6d6281bb782d2f",
    spotify: "5sF5Etprqoh9ufF3ap2eZY",
    genre: "german pop,german pop rock,german singer-songwriter",
    popularity: "35",
  },
  {
    name: "DMX Krew",
    image: "https://i.scdn.co/image/75c798a319e6c11bcba22d743cb75feb1b94ea09",
    spotify: "4W1v5X4x0ObMOJVJreZX3k",
    genre: "braindance,drill and bass,electro,intelligent dance music,techno",
    popularity: "35",
  },
  {
    name: "Thijs Borsten",
    image: "https://i.scdn.co/image/ab67616d0000b2735932d199de7eb28860d37f5e",
    spotify: "2rXcix5yePOodUVqDUiRKh",
    genre: "muziek voor kinderen",
    popularity: "35",
  },
  {
    name: "Partiboi69",
    image: "https://i.scdn.co/image/bbbcd259c6de69060fcac2bce8970147f5074baf",
    spotify: "0CutULGVZ24wOr1HHYoEOL",
    genre: "",
    popularity: "35",
  },
  {
    name: "Lish",
    image: "https://i.scdn.co/image/ab67616d0000b273b69b4ac90b752bcbcdab0614",
    spotify: "2BXaOtgdcQpnHYFfmCvEcA",
    genre: "",
    popularity: "35",
  },
  {
    name: "Meridian Brothers",
    image: "https://i.scdn.co/image/5e730aa9bc37cb4e86ac2d85d1f19dd8e93216c4",
    spotify: "08Y6RNx87Eolrcq1aLM6ow",
    genre: "colombian rock,latin afrobeat,latintronica",
    popularity: "35",
  },
  {
    name: "Johannes Albert",
    image: "https://i.scdn.co/image/bcedc53d58981c686a3e9604d4e3146a935caf62",
    spotify: "5FMcKm7A4LRwIJnkzuKZFt",
    genre: "deep soul house,float house",
    popularity: "35",
  },
  {
    name: "Dinamarca",
    image: "https://i.scdn.co/image/4d1d93c67ba3dedaca02f902f79995247a2a185e",
    spotify: "4YFGNIynoM4Kq6f4VcZ7SX",
    genre: "deconstructed club,escape room,hyperpop,vogue",
    popularity: "35",
  },
  {
    name: "Deetron",
    image: "https://i.scdn.co/image/6ccd5d19457b83226bb72cb3a1ff2534c9485ad8",
    spotify: "0d4nL4lAEkHJIqLZSHBuav",
    genre: "swiss techno,techno",
    popularity: "35",
  },
  {
    name: "Charleon",
    image: "https://i.scdn.co/image/24dba95aeefb011315a767fd4faede3c026f4a7c",
    spotify: "197faNV22JRdMv3xmmPz4p",
    genre: "",
    popularity: "35",
  },
  {
    name: "Alexandr Misko",
    image: "https://i.scdn.co/image/ccd7bb5bc83498621810825798010f0c123a6253",
    spotify: "5ZtuBRCHqXY3bSD2BRSYNC",
    genre: "fingerstyle",
    popularity: "35",
  },
  {
    name: "Liu Fang",
    image: "https://i.scdn.co/image/e83b6d39994f32b9f57ea36f81b68776e2561ba7",
    spotify: "1ect1Z6G04KAAxe3Jcb9Kg",
    genre: "chinese traditional,pipa",
    popularity: "35",
  },
  {
    name: "Shades",
    image: "https://i.scdn.co/image/f0dcb8a14bf1d8535bcfda09c636f1f6648a8f73",
    spotify: "3hZYcnuncZYCJzqO9pwpAK",
    genre: "deep dubstep,electronic trap,halftime dnb",
    popularity: "35",
  },
  {
    name: "Mielo",
    image: "https://i.scdn.co/image/38902a2ab7923aa95462068312bfc20c53893327",
    spotify: "4bGN5XDSLCLYd01uQqR3JA",
    genre: "",
    popularity: "35",
  },
  {
    name: "Bob Geldof",
    image: "https://i.scdn.co/image/1e3ab66882b2175c4d8d21ae87ddbe2c50d36928",
    spotify: "6bvtY9dkfSa5yKuogd2aLU",
    genre: "irish singer-songwriter",
    popularity: "35",
  },
  {
    name: "Pip Blom",
    image: "https://i.scdn.co/image/137e53d239f41d70f9609c2c738cb0ac35986374",
    spotify: "6zWJfH1TTmIqEi7EV35HGr",
    genre:
      "chamber psych,dutch indie,dutch indie rock,dutch rock,english indie rock",
    popularity: "35",
  },
  {
    name: "Hi! Spencer",
    image: "https://i.scdn.co/image/654cf1e799c4b6521401f2b998908e1d959fdb8e",
    spotify: "1ZsBmcVGsvjkptybP7nVkE",
    genre: "german punk rock,german rock",
    popularity: "35",
  },
  {
    name: "Nick Warren",
    image: "https://i.scdn.co/image/95080c6f7bfb8bff880f1431bf1ad3a062a23f75",
    spotify: "7aY9PtsNws5AdwbdktfbaN",
    genre: "bristol electronic,tech house",
    popularity: "35",
  },
  {
    name: "Andy Bianchini",
    image: "https://i.scdn.co/image/0eef58faf67632e980a2f6b148ef268a2b07718e",
    spotify: "2j3ss5ZwVoRqRuDWHP7U5P",
    genre: "",
    popularity: "35",
  },
  {
    name: "Nymfo",
    image: "https://i.scdn.co/image/ab249129d44cc2a9bc095e837dbfcd86e4dbad01",
    spotify: "2Pdhwac5oHsY95PeUq6VBS",
    genre: "drumfunk,dutch dnb,liquid funk,neurofunk",
    popularity: "35",
  },
  {
    name: "Tertia May",
    image: "https://i.scdn.co/image/44ff37c82b66b93e51cc0732218174b8a95d3ff0",
    spotify: "2l5D9yWJD8XtjzTMCKUown",
    genre: "alternative r&b,indie r&b,uk contemporary r&b",
    popularity: "35",
  },
  {
    name: "Crematory",
    image: "https://i.scdn.co/image/287b49991090e26d29108afdc999bbd30cbeef67",
    spotify: "4q2uhIfBHCNlwXYvQdnzvS",
    genre: "gothic metal,neue deutsche harte",
    popularity: "35",
  },
  {
    name: "Rey Tranquilo",
    image: "https://i.scdn.co/image/960e6a34c78b1156b5b79b878da995effafd3cb1",
    spotify: "4U1kk7u9hKz9ui3SsgJ1Nq",
    genre: "",
    popularity: "35",
  },
  {
    name: "BOMBSQUAD",
    image: "https://i.scdn.co/image/ab67616d0000b27338ff415aee91742e0dfd005c",
    spotify: "7fyZZzdEhPZmZWrqrYS0tl",
    genre: "",
    popularity: "35",
  },
  {
    name: "Pia Douwes",
    image: "https://i.scdn.co/image/ab67616d0000b2734133e616cc2bd84827c206ad",
    spotify: "4AnH8j5U6hu4IdrsNpnk4l",
    genre: "german show tunes",
    popularity: "35",
  },
  {
    name: "Victor Calderone",
    image: "https://i.scdn.co/image/4db5fde9de6cc60f638a9f21ab1c06b525824dce",
    spotify: "2vSlQJ6UWFVWZQPzUaaMGI",
    genre: "tribal house,vocal house",
    popularity: "35",
  },
  {
    name: "GEOTHEORY",
    image: "https://i.scdn.co/image/a8163705ab179447e614ec5d3c416b9f67450daa",
    spotify: "3iIFBDnPEFpR6PCF0Tuh6w",
    genre: "future bass,vapor twitch",
    popularity: "35",
  },
  {
    name: "When Saints Go Machine",
    image: "https://i.scdn.co/image/b25467589b862f0c42cbb532259b7d788dcd971e",
    spotify: "0E7PsXA3qAN3NCycrWDFaf",
    genre: "danish electropop,danish pop",
    popularity: "35",
  },
  {
    name: "BeauDamian",
    image: "https://i.scdn.co/image/7a99958bea18a992bde32f67b617faf18c6898c0",
    spotify: "5VjPvMZB9D6b9XEeXMg8SB",
    genre: "future bass,vapor twitch",
    popularity: "35",
  },
  {
    name: "Somnium Sound",
    image: "https://i.scdn.co/image/cf85d6c91463ee77fa0e8a3d72f2830eb6b17432",
    spotify: "7f7uTajAqbXruaAKcdaOZr",
    genre: "brostep,zapstep",
    popularity: "35",
  },
  {
    name: "Woody van Eyden",
    image: "https://i.scdn.co/image/a22c938be0e7d2f4f69018671cd194572fae26c8",
    spotify: "4G2mPOOfWyqNO338GJTOK5",
    genre: "bubble trance,progressive trance,uplifting trance",
    popularity: "35",
  },
  {
    name: "The Jane Doze",
    image: "",
    spotify: "74Tg0IEjUqkz3dfUTv6Lp2",
    genre: "",
    popularity: "35",
  },
  {
    name: "Trade Wind",
    image: "https://i.scdn.co/image/101cc4864f1d984b1fdee2d849fadb1b825e7fd7",
    spotify: "3FCfL4lKWE7vm3mCcOd570",
    genre: "melodic hardcore",
    popularity: "35",
  },
  {
    name: "Jon Rundell",
    image: "https://i.scdn.co/image/8f3dffc69eb96805acb6ca0ce026780591024b50",
    spotify: "5R3JcY1fbHrWgWKxIz9hsG",
    genre: "",
    popularity: "35",
  },
  {
    name: "Luca Musto",
    image: "https://i.scdn.co/image/35a5ce002fe013a4b7f93b4665dad14a7383ed3f",
    spotify: "2TPJeKBObMEOKpR33TYgvh",
    genre: "ethnotronica,organic house",
    popularity: "35",
  },
  {
    name: "NEEL",
    image: "https://i.scdn.co/image/293e4d953c2cc31f3974b859cb2fe2404df498ea",
    spotify: "2hWmchSndu9Vb5xajwswBR",
    genre: "",
    popularity: "35",
  },
  {
    name: "nthng",
    image: "https://i.scdn.co/image/ab67616d0000b273afaf1903e1841b7939d9cecf",
    spotify: "1V0EQCS8125xaDrR4ZURGO",
    genre: "float house,minimal dub",
    popularity: "35",
  },
  {
    name: "Tim Hox",
    image: "https://i.scdn.co/image/86eadc67947254bd3a02d2ee43255d20eed32dc9",
    spotify: "64ydm7vEEBjvH4AeC1slRM",
    genre: "",
    popularity: "35",
  },
  {
    name: "Coloray",
    image: "https://i.scdn.co/image/306a9b281a436cb7da9680deb26d7c505528cb08",
    spotify: "6a3p6ZKDkTzrVbloxkD73E",
    genre: "",
    popularity: "35",
  },
  {
    name: "Victorius",
    image: "https://i.scdn.co/image/824c4329e4fc273d6e9396c2382ea1ea8cb2d901",
    spotify: "2INeE2VBbawRQNI6ezc4lN",
    genre: "melodic metal,symphonic power metal",
    popularity: "35",
  },
  {
    name: "Bill Laurance",
    image: "https://i.scdn.co/image/4b26a1537ba4914918c89a208c15578c3eca179f",
    spotify: "2QjVv1gkLn8XkQxVndgLHF",
    genre: "contemporary jazz,indie jazz",
    popularity: "35",
  },
  {
    name: "Suzi Wu",
    image: "https://i.scdn.co/image/55ed5181dc2af36763f1f0c336948734f7653445",
    spotify: "0AZ01mYEHgw7ZwKIbgEjBi",
    genre: "",
    popularity: "35",
  },
  {
    name: "Black Peaks",
    image: "https://i.scdn.co/image/249b6ae6617aad3626392805d1d72c09e749e513",
    spotify: "76Se0uC5hM5u1R410UHAFp",
    genre: "british alternative rock,modern alternative rock",
    popularity: "35",
  },
  {
    name: "The Dickies",
    image: "https://i.scdn.co/image/021f7d9f34dcfd74bf9997ef12dbc1d74f85a275",
    spotify: "3xWO6nOrnGGL9hfB2vWxLI",
    genre: "early us punk,hardcore punk,punk",
    popularity: "35",
  },
  {
    name: "Joey Beltram",
    image: "https://i.scdn.co/image/7fbdab62e71b7d8740e8b9ca73b84d99742f419b",
    spotify: "4OW0w5K2UNaWtbpRqzWqI0",
    genre: "acid house,chicago house,electro,hardcore techno,techno",
    popularity: "35",
  },
  {
    name: "Nomade Orquestra",
    image: "https://i.scdn.co/image/918980bc3bf004fbc4ca44569b8f76c51a961bb6",
    spotify: "0empAFasxmO94e7zJOurTf",
    genre: "afrobeat brasileiro,afrofuturismo brasileiro,latin afrobeat",
    popularity: "35",
  },
  {
    name: "Los Bitchos",
    image: "https://i.scdn.co/image/9a8ee64e256074ff7b156492a85aa6dba0285632",
    spotify: "07b9qW7pabKGO29JPWXn9m",
    genre: "",
    popularity: "35",
  },
  {
    name: "Matija",
    image: "https://i.scdn.co/image/0e2a255094679fbc9d331270938473446328b192",
    spotify: "0AT9xOpJni8J7sM4UNrrt9",
    genre: "german indie,german indie rock,munich indie",
    popularity: "35",
  },
  {
    name: "Babel-Ish",
    image: "https://i.scdn.co/image/c64b8b8fec7d216035be472739b577e10e6046c1",
    spotify: "1fVUzi8EF2oGNzPuP7g7EG",
    genre: "basshall,dutch trap pop",
    popularity: "35",
  },
  {
    name: "Two Can",
    image: "https://i.scdn.co/image/93ca558038938ac78442fd607ee2905a4b1c51a2",
    spotify: "0hxUFYLIObXLtdmYlCQ6bR",
    genre: "deep tropical house",
    popularity: "35",
  },
  {
    name: "Niereich",
    image: "https://i.scdn.co/image/ab67616d0000b273a76744dcf48c4eb1d261e533",
    spotify: "1qwho0JFtd5Pn2ixKKE389",
    genre:
      "austrian techno,dark minimal techno,german dark minimal techno,tech house",
    popularity: "35",
  },
  {
    name: "Tristen",
    image: "https://i.scdn.co/image/52d496ffa11ebef18b1a0a88d1a1c348d5afff63",
    spotify: "136eH4t69aKT2UuS36z3Qo",
    genre: "nashville indie",
    popularity: "35",
  },
  {
    name: "Marble Sounds",
    image: "https://i.scdn.co/image/eb6a8d555dd6df7da091ab1fcba8cc1a417685bf",
    spotify: "4oPsvVmYV90ryTGgyskkbp",
    genre: "belgian indie,belgian rock",
    popularity: "35",
  },
  {
    name: "YesYou",
    image: "https://i.scdn.co/image/b233029ab5c3fab334d082a97acbfe945500df53",
    spotify: "22qas00XuS5sVfW0YaR5Wd",
    genre: "australian indie",
    popularity: "35",
  },
  {
    name: "The Wanton Bishops",
    image: "https://i.scdn.co/image/4a73ee926bf80cbf4877dc24f239d6dd64c2b7ed",
    spotify: "7gN2pFFXjxG72z9rb0PCqe",
    genre: "lebanese indie,modern blues rock,modern hard rock",
    popularity: "35",
  },
  {
    name: "Cobra Skulls",
    image: "https://i.scdn.co/image/ab67616d0000b273be5ccb08eceabf4c69bedef2",
    spotify: "3uXqKijByMgBlaqhMoaZRa",
    genre: "",
    popularity: "35",
  },
  {
    name: "Victor Niglio",
    image: "https://i.scdn.co/image/3268938260c31412fdaa6d82965fd3db27f07e75",
    spotify: "1KAvgimTLG9YZew4b9B4bG",
    genre: "electronic trap",
    popularity: "35",
  },
  {
    name: "Benjamin Bates",
    image: "https://i.scdn.co/image/eb70b97e613f8dea497b3d803967d7290578c13c",
    spotify: "2zk6outptAdZh4zvEjLk8W",
    genre: "",
    popularity: "34",
  },
  {
    name: "Lennert Wolfs",
    image: "https://i.scdn.co/image/4227e5468121645d20d5dc009b148a6081a7b59b",
    spotify: "0T4Qr97ftW9NtSvoyqBvAt",
    genre: "",
    popularity: "34",
  },
  {
    name: "D-Rashid",
    image: "https://i.scdn.co/image/a6f24d87ffbba392f90470195f8783bebdc26d60",
    spotify: "3BAbtGcpq9F6a7TJyw9krT",
    genre: "dutch house",
    popularity: "34",
  },
  {
    name: "Kenneth G",
    image: "https://i.scdn.co/image/f8af6f08e860414a95028f50952e05f77ef7659d",
    spotify: "3qqvCq7mFIy9UfaXoj5w1w",
    genre: "dutch house",
    popularity: "34",
  },
  {
    name: "Doctor Dru",
    image: "https://i.scdn.co/image/92013405d69abfb21aea153c933f1fc9e35b5e75",
    spotify: "3vjQVx1KiW9b8VpbRMWfpl",
    genre: "deep disco house,hamburg electronic",
    popularity: "34",
  },
  {
    name: "Carlos Valdes",
    image: "",
    spotify: "0SVwY1wz7nbKqR3wHlSB5c",
    genre: "",
    popularity: "34",
  },
  {
    name: "Elias Mazian",
    image: "https://i.scdn.co/image/dfec8ecc191b9bb492b75e27d56a5909584d1a8e",
    spotify: "5bcee1i2yLpnhwm5Nbz3vU",
    genre: "lo-fi house",
    popularity: "34",
  },
  {
    name: "Marc Houle",
    image: "https://i.scdn.co/image/a8528e829c93742382f16aebbc247196d8dc79ed",
    spotify: "50b6p8UF5dHfvjaN3GduG3",
    genre: "canadian electronic,german techno,minimal techno,tech house",
    popularity: "34",
  },
  {
    name: "Bernd Stelter",
    image: "https://i.scdn.co/image/7f53faf5f4b9f04e2a02a83fc034ed471a777dc5",
    spotify: "5nW65hqNZ9m6WGkdG9xjlD",
    genre: "german rock,kabarett,karneval,kolsche karneval",
    popularity: "34",
  },
  {
    name: "Dan Shake",
    image: "https://i.scdn.co/image/5f8640c2b84f5560b12e84c0e2627cea82fd2b2c",
    spotify: "7wxLYZxFPf1HWPIaGesxAg",
    genre: "float house",
    popularity: "34",
  },
  {
    name: "Matias Aguayo",
    image: "https://i.scdn.co/image/f081a7dd10d4a5c3c07e98187d62f8754414089b",
    spotify: "7daexEpVdKDbvlUHZ2rWbe",
    genre: "cologne electronic,electronica chilena,microhouse",
    popularity: "34",
  },
  {
    name: "Remco Beekwilder",
    image: "https://i.scdn.co/image/21a0019a25ec3317f175a542b4efd9c8973e3309",
    spotify: "093To89xljIKjuy5VguaP4",
    genre: "minimal dub",
    popularity: "34",
  },
  {
    name: "Michael Amani",
    image: "https://i.scdn.co/image/141c4657c28b29745c6955cb74c67cb8045ddd35",
    spotify: "2NXXWnN62QbWBGoHCyKrTn",
    genre: "belgian edm",
    popularity: "34",
  },
  {
    name: "Activator",
    image: "https://i.scdn.co/image/8645d53e98ed22882600aa690c9d4c5ebc560776",
    spotify: "56b0LX6dOgCwQUcXlW0oO9",
    genre: "classic hardstyle,rawstyle",
    popularity: "34",
  },
  {
    name: "Tami Neilson",
    image: "https://i.scdn.co/image/8c3627eb63976288b4e032db463d95e803a35fe0",
    spotify: "4PmC63uE7ZLY5TI3p0PGd3",
    genre: "nz folk,nz pop,nz singer-songwriter",
    popularity: "34",
  },
  {
    name: "Unni Wilhelmsen",
    image: "https://i.scdn.co/image/7374aae396482c42ac21ba20bf1c1cb0ee6d2334",
    spotify: "4KxwaZDBWJJSk22fmmK3gp",
    genre: "classic norwegian pop,norwegian pop",
    popularity: "34",
  },
  {
    name: "Anna Stadling",
    image: "https://i.scdn.co/image/43aa6d0bfed8cc80843b7dfd7f69eaaed26d051e",
    spotify: "15xSyYUeEIQphb7lnNojQs",
    genre: "classic swedish pop",
    popularity: "34",
  },
  {
    name: "Beatrice Dillon",
    image: "https://i.scdn.co/image/ab6772690000c46cc1bb478914b04ab14771a246",
    spotify: "14H1XUmtWYzRHCQDkoee97",
    genre:
      "art pop,chamber psych,deconstructed club,electra,experimental pop,experimental synth,float house,fluxwork,fourth world,freak folk,microhouse,outsider house",
    popularity: "34",
  },
  {
    name: "DJ SODA",
    image: "https://i.scdn.co/image/2fb39e0408f96a269c225005338f20f82cdcae57",
    spotify: "6wcoqJ63l11D2yV9ViqIZA",
    genre: "",
    popularity: "34",
  },
  {
    name: "Rebekka Bakken",
    image: "https://i.scdn.co/image/2045e407c07901ade61695b878e81f9e2e53d5d6",
    spotify: "3oY7VC1i7SwfO1EhOIlc0t",
    genre: "vocal jazz",
    popularity: "34",
  },
  {
    name: "Badsista",
    image: "https://i.scdn.co/image/187a228b0d7fd1b5325143529b2c41b48539f3f8",
    spotify: "6ytQ6P4WfkF9aEi2rvgTDO",
    genre: "brazilian techno",
    popularity: "34",
  },
  {
    name: "LYZZA",
    image: "https://i.scdn.co/image/da5376dc1fb83aaa11adc019c78354fbcd8e58ec",
    spotify: "57xaBKepmdqQ6BjXkiHa4B",
    genre: "deconstructed club,escape room,hyperpop,trap queen",
    popularity: "34",
  },
  {
    name: "My Bubba",
    image: "https://i.scdn.co/image/52ad43e8bc353bc2551b5e765e2c89c3bacdf609",
    spotify: "09VsCALGBjeVE3pq9k085d",
    genre: "icelandic folk",
    popularity: "34",
  },
  {
    name: "Robbie Rise",
    image: "https://i.scdn.co/image/16a404b0beb0d067d9b0b32b4b7f802d57c4b681",
    spotify: "7I3KcpUt82lD7bA5J7qQ8A",
    genre: "",
    popularity: "34",
  },
  {
    name: "Zen Freeman",
    image: "https://i.scdn.co/image/d62744f179b3aac771ffcb3b51c378a3f790b36a",
    spotify: "6WIXrNpbpGraLXs5vhEYJG",
    genre: "",
    popularity: "34",
  },
  {
    name: "Intwine",
    image: "https://i.scdn.co/image/ab67616d0000b27304edad247513aea0ea8d44ae",
    spotify: "3ebEQtwWOjTTFAWjnDkrfr",
    genre: "dutch rock",
    popularity: "34",
  },
  {
    name: "Abbath",
    image: "https://i.scdn.co/image/7cde591a10a6a85ca851546cebbd9d8d9c0029f8",
    spotify: "1epGwdbjU7JSGVBHlqptpx",
    genre: "",
    popularity: "34",
  },
  {
    name: "K-Lone",
    image: "https://i.scdn.co/image/cd7e0d360adb3f35f0ddd36e88685222a045a298",
    spotify: "6VC4hWnnMMmOxpH6KsAXBU",
    genre:
      "bass music,deep dubstep,float house,fourth world,microhouse,outsider house,uk experimental electronic",
    popularity: "34",
  },
  {
    name: "Nervosa",
    image: "https://i.scdn.co/image/86bdf6b5e55b7371eea688699db3b07afc3eae04",
    spotify: "5D9d9xyLNQu32QVD9t4YqH",
    genre:
      "brazilian death metal,brazilian metal,brazilian thrash metal,mexican metal,slayer",
    popularity: "34",
  },
  {
    name: "Dwight Dissels",
    image: "https://i.scdn.co/image/1a18a2db4b7c183e1143a9b4ffe81746f0047faa",
    spotify: "6mJqqz8Dra13cr75NGhC7f",
    genre: "dutch pop",
    popularity: "34",
  },
  {
    name: "Matt Watkins",
    image: "https://i.scdn.co/image/5ddf37e408b51889d66d0632bec64d0384d7322c",
    spotify: "1lSoVfWwjKoGadIT3tlYRg",
    genre: "melbourne bounce,melbourne bounce international",
    popularity: "34",
  },
  {
    name: "Marike Jager",
    image: "https://i.scdn.co/image/b32899c1ea3d857fca008355e0cbf26e24664e9a",
    spotify: "1DvjWYF9T7H6CuQ7udKLYF",
    genre: "dutch indie,dutch singer-songwriter",
    popularity: "34",
  },
  {
    name: "Mézigue",
    image: "https://i.scdn.co/image/ab67616d0000b2734dee89a31070c6e042ee5062",
    spotify: "7B8eMhFI61FTQYeLSERF0l",
    genre: "",
    popularity: "34",
  },
  {
    name: "Nachtbraker",
    image: "https://i.scdn.co/image/7f6e904af520f655e845a98d0faf8b49912d75b6",
    spotify: "4mS8v6OGLE0fegaoJL1IVw",
    genre: "float house",
    popularity: "34",
  },
  {
    name: "Capital Candy",
    image: "https://i.scdn.co/image/f80ccae52665f2b37dfa222b546a71479e9663ba",
    spotify: "2svfe1pMwteF5HCoBP4Q9a",
    genre: "basshall,dutch trap pop",
    popularity: "34",
  },
  {
    name: "Spidergawd",
    image: "https://i.scdn.co/image/ab67616d0000b2739d931dbf6e84ea632a080acc",
    spotify: "6Gr63lomKREePH5mtvVWNh",
    genre: "norwegian psychedelic,norwegian rock",
    popularity: "34",
  },
  {
    name: "Kobus Engels",
    image: "https://i.scdn.co/image/0f02712423e0e497fba4aa4d44a320b9aa473400",
    spotify: "31ceTfWruX9GVw1VjR30ke",
    genre: "carnaval",
    popularity: "34",
  },
  {
    name: "Pacific Avenue",
    image: "https://i.scdn.co/image/2b6b9ac109b961f60442f4b117c1a8da4686d366",
    spotify: "0I31FkQFn7gxEVAsWGNjvZ",
    genre: "australian garage punk,australian indie rock",
    popularity: "34",
  },
  {
    name: "Palmistry",
    image: "https://i.scdn.co/image/1c29a785994fc55470ab029dc2b26d0eebb2ee12",
    spotify: "4qm6T9pMFiyCDHFTHZchrY",
    genre: "hyperpop",
    popularity: "34",
  },
  {
    name: "Jenniffer Kae",
    image: "https://i.scdn.co/image/6a31ad858e057b69948c536215b4d9816670b4a4",
    spotify: "7s12cq7LvagVKZN1MWHHNw",
    genre: "german pop",
    popularity: "34",
  },
  {
    name: "Quincy Wilson",
    image: "https://i.scdn.co/image/7987c9c8ce69815e6eb397ef70a4cc67efd4141f",
    spotify: "0IEylhPcz2amlQVvThyIwT",
    genre: "",
    popularity: "34",
  },
  {
    name: "Pitto",
    image: "https://i.scdn.co/image/421c6b002bb55186ccc0c2b264c2d901e371bed9",
    spotify: "4qGSmvW1ZXE9qeXUdoFuTG",
    genre: "",
    popularity: "34",
  },
  {
    name: "Gyedu-Blay Ambolley",
    image: "https://i.scdn.co/image/ab67616d0000b273ac5ffee64a1772cb6f4d17f6",
    spotify: "3K7G8Czqv2acbaWlxFfjbj",
    genre: "afrobeat,afropop,highlife",
    popularity: "34",
  },
  {
    name: "NuKid",
    image: "https://i.scdn.co/image/67f380ea955f2a5f01494c7267ccc333516c9623",
    spotify: "1VV86JiVdv8JodqySpTq4R",
    genre: "bass house",
    popularity: "34",
  },
  {
    name: "House Of Lords",
    image: "https://i.scdn.co/image/68101dd7fec589c7e1abdaddf308ba7f97b9d0d8",
    spotify: "0iu8uY2sqeWpiwxcdwOonn",
    genre:
      "album rock,glam metal,hard rock,melodic hard rock,modern hard rock,sleaze rock",
    popularity: "34",
  },
  {
    name: "Mavis Acquah",
    image: "https://i.scdn.co/image/ab67616d0000b273dddf5f5cb8505d7199e17b9d",
    spotify: "3MOsOjjMai9Q0QRxqOoozw",
    genre: "",
    popularity: "34",
  },
  {
    name: "Bad Decisions",
    image: "https://i.scdn.co/image/aa8f17717d310df5901c4dd417c06b15b66d7f64",
    spotify: "3GTclJDhrh2C4k8VveMhM6",
    genre: "",
    popularity: "34",
  },
  {
    name: "Dead Players",
    image: "https://i.scdn.co/image/ab67616d0000b273c2c664060aa9006ec2fc88a1",
    spotify: "5S7OeviuUa6HadKplgMqum",
    genre: "uk alternative hip hop,uk hip hop",
    popularity: "34",
  },
  {
    name: "Psycroptic",
    image: "https://i.scdn.co/image/28a502ab2ece21a441ec5370d549a3988eaef8b8",
    spotify: "2O8ZayBAqBqoXujSAAx7pm",
    genre:
      "australian metal,brutal death metal,death metal,technical brutal death metal,technical death metal",
    popularity: "34",
  },
  {
    name: "Seth Troxler",
    image: "https://i.scdn.co/image/d6034619ce5c6ffebcd660b3e97458b27f88ba74",
    spotify: "3JkLFcTej6tdwZoQT6Nx4B",
    genre: "detroit house,detroit techno,minimal tech house",
    popularity: "34",
  },
  {
    name: "LO-FI LE-VI",
    image: "https://i.scdn.co/image/5a36919b3d698d3e9933889ce42dcf0416ffb78f",
    spotify: "3HitWnKrqivUZgOBLj4SJ6",
    genre: "dutch indie",
    popularity: "34",
  },
  {
    name: "Full Crate x Mar",
    image: "https://i.scdn.co/image/0ab7e526fcbf23efa27a2e7f11f85ce946f6ea06",
    spotify: "6jNOJmB6z7VATJ062NlwCd",
    genre: "dutch pop",
    popularity: "34",
  },
  {
    name: "De Ambassade",
    image: "https://i.scdn.co/image/3237f3cca8e0d41f8d6c264b9dc08e3d19f7c211",
    spotify: "0GZYFERImx0KoJ1tpN1iuT",
    genre: "dutch indie rock",
    popularity: "34",
  },
  {
    name: "Vibe Tribe",
    image: "https://i.scdn.co/image/0cbeeed936c612af19275e53a745969e052be85d",
    spotify: "0B4Z8L32aIQLItb34i3Dt9",
    genre: "full on,psychedelic trance",
    popularity: "34",
  },
  {
    name: "The Van Jets",
    image: "https://i.scdn.co/image/4acba98a23ace752568912f227dc2ef1f5f1a3a6",
    spotify: "4FTPrxr5zwdfmh46OLnNhn",
    genre: "belgian indie,belgian indie rock,belgian rock",
    popularity: "34",
  },
  {
    name: "Maissouille",
    image: "https://i.scdn.co/image/7bfa6a8ad2e7ae369388b5972758ed611e3ce37d",
    spotify: "1aQbGaag8KEI8kKtY37UQU",
    genre: "frenchcore,speedcore,tekno",
    popularity: "34",
  },
  {
    name: "Zoot Woman",
    image: "https://i.scdn.co/image/849cfbb067eb944f9703e65d62f33309a5dc5cfc",
    spotify: "25w2vpqq7dYleBAqMx7Ijx",
    genre: "alternative dance,dance-punk,electroclash,new rave,reading indie",
    popularity: "34",
  },
  {
    name: "Jared Dylan",
    image: "https://i.scdn.co/image/ca77e7dcce8b9f6fd98ee102ccbaeb0eabe2c7c4",
    spotify: "5lDUVqxXYEOAf12p0N2kVT",
    genre: "",
    popularity: "34",
  },
  {
    name: "Laid Blak",
    image: "https://i.scdn.co/image/ab67616d0000b273cbf09bdef92a9e756ee75e81",
    spotify: "3QM7x03GglGPjt0Ori7JAK",
    genre: "uk reggae",
    popularity: "34",
  },
  {
    name: "Joy Wellboy",
    image: "https://i.scdn.co/image/c1f52ace6ab3db736fdb44779528fae0e51d9ec4",
    spotify: "61G7yQtFBGRRbJlohUvlPG",
    genre: "organic house",
    popularity: "34",
  },
  {
    name: "Rex The Dog",
    image: "https://i.scdn.co/image/318c162e2f50068315ddf212e7d1950491a9a6b5",
    spotify: "5zbQoW1WWTzvITE8w4ckoC",
    genre: "electroclash,electrofox,filter house",
    popularity: "34",
  },
  {
    name: "The Straikerz",
    image: "https://i.scdn.co/image/8da7913915939845d35a00f496abe82424f58f3f",
    spotify: "23YqfnxHhNcTMAkU4hxl1l",
    genre: "hardstyle,rawstyle,uptempo hardcore",
    popularity: "34",
  },
  {
    name: "Man Or Astro-Man?",
    image: "https://i.scdn.co/image/6b94ec53510ddcc51c443d981d43d9e84cfe4c54",
    spotify: "3z3lEz2qH5h6qJa8DYukxY",
    genre:
      "alabama indie,instrumental rock,instrumental surf,surf music,surf punk",
    popularity: "34",
  },
  {
    name: "Phil Weeks",
    image: "https://i.scdn.co/image/35e49839c861992e0083599070178758ea3b86d2",
    spotify: "0ruxrxTRHzfO8KsLLNPNkK",
    genre: "minimal tech house",
    popularity: "34",
  },
  {
    name: "Lubomyr Melnyk",
    image: "https://i.scdn.co/image/c5c52b97e43028b6480d8c7cd424f2daac2fce49",
    spotify: "0G9qoAVEY16XVywzpxP4wP",
    genre: "compositional ambient,minimalism,post-minimalism",
    popularity: "34",
  },
  {
    name: "Morena Leraba",
    image: "https://i.scdn.co/image/8fa52aba565446495da2a4b65b1d2c31e9eb3b42",
    spotify: "2aUErDeR4aoZDvy9ZYMhzO",
    genre: "south african electronic",
    popularity: "34",
  },
  {
    name: "Tomas Heredia",
    image: "https://i.scdn.co/image/16ade0b58b902dabbe0baee0d34e3c4b8f171a76",
    spotify: "0MxxbjQyul7WXUFy0O6qiu",
    genre: "deep uplifting trance,progressive trance",
    popularity: "34",
  },
  {
    name: "Arja Saijonmaa",
    image: "https://i.scdn.co/image/705a7f93fce32d81f07033ce5cac07b78df6a36f",
    spotify: "7eoFSuG70jwEpxd1LdKNxK",
    genre: "classic finnish pop,classic swedish pop",
    popularity: "34",
  },
  {
    name: "The Allman Betts Band",
    image: "https://i.scdn.co/image/8a0cf932700f195326fbcda9d48e6e277354259c",
    spotify: "7bVESn103RkOzPhvjpuQTT",
    genre: "southern rock",
    popularity: "34",
  },
  {
    name: "1-800 GIRLS",
    image: "https://i.scdn.co/image/fddf0a0e30b456ece5ed8556a232578ab358735d",
    spotify: "67yGrC4QoCSD0g7YMcGIgJ",
    genre: "float house,lo-fi house",
    popularity: "34",
  },
  {
    name: "Siege",
    image: "https://i.scdn.co/image/cbcf206f7f122fbc27efb18769290744a86bf707",
    spotify: "3Y7jEjvZAosFRghJl62VNd",
    genre: "funky tech house,thrash core",
    popularity: "34",
  },
  {
    name: "Floyd Lavine",
    image: "https://i.scdn.co/image/5f57c1b5ef2e19c49b4351e424c1dc1d894628c2",
    spotify: "5VjxZ6Ik0cmnVlXZ3in6nw",
    genre: "afro house",
    popularity: "34",
  },
  {
    name: "Krama",
    image: "https://i.scdn.co/image/d0dbf1779e6ea760b6082a33bea09c4eb0e1e61f",
    spotify: "6fz3m9HgQ3s7171AZHvk0j",
    genre: "progressive psytrance",
    popularity: "34",
  },
  {
    name: "Andreas Henneberg",
    image: "https://i.scdn.co/image/7cf1a6086b8c1859d175cdfeebcbb384f030d07b",
    spotify: "32fCH0Z7B8ydcz40ybZdqg",
    genre: "deep euro house,german tech house,minimal techno,tech house",
    popularity: "34",
  },
  {
    name: "The Disaster Area",
    image: "https://i.scdn.co/image/d8d63a77e226621a71cf766983a65068f583ae4c",
    spotify: "5cNBtvhQCLKWInveVFe49O",
    genre: "german metalcore,german post-hardcore",
    popularity: "34",
  },
  {
    name: "Kris Barras Band",
    image: "https://i.scdn.co/image/d258060e0c19bae958d08c9e4d180766f8bf9207",
    spotify: "241MOvr69jR2U48FW5WbKv",
    genre: "modern blues rock,modern hard rock,nwocr",
    popularity: "34",
  },
  {
    name: "A Guy Called Gerald",
    image: "https://i.scdn.co/image/fc3bdfbf2a7a478e4ea13715778f5c5346922d1a",
    spotify: "1TV0WTE9ukywcLGMh4j4iU",
    genre: "acid house,atmospheric dnb,drum and bass,madchester,techno",
    popularity: "34",
  },
  {
    name: "Ale Mora",
    image: "https://i.scdn.co/image/b5e4a51f08ffd6adb9a501b1bc97f5eb4135d346",
    spotify: "6bsbLjG9kdODP0wVaM1WXM",
    genre: "sky room",
    popularity: "34",
  },
  {
    name: "Mark Van Dale",
    image: "https://i.scdn.co/image/de1e42e0ba633b336feb0dd3280bb351a4f436a9",
    spotify: "4lrgowzoVnAbOBI0LRFyzy",
    genre: "dutch trance",
    popularity: "33",
  },
  {
    name: "Paul Ritch",
    image: "https://i.scdn.co/image/76627805a911a4c0ba565bf57b2b587c14b9cb93",
    spotify: "5qjsbSnuBPdr2cWMFQP8Tb",
    genre: "acid techno,french techno,minimal techno",
    popularity: "33",
  },
  {
    name: "DJ Irwan",
    image: "https://i.scdn.co/image/11e5a5f38cec34ab7f6b0460d6564ec34071f3e2",
    spotify: "5mlOB1I0uLUTGCXY5IEpmD",
    genre: "",
    popularity: "33",
  },
  {
    name: "Patrick Laureij",
    image: "https://i.scdn.co/image/ab67616d0000b2736666727d80d239ecc7abc8dc",
    spotify: "7nQYhSPLt2frvIIR09d0jX",
    genre: "dutch cabaret",
    popularity: "33",
  },
  {
    name: "Koen Groeneveld",
    image: "https://i.scdn.co/image/54329e333ff485dcdca11736c8bc670c6383a563",
    spotify: "1z62XaHX2iYbxLARSBLoua",
    genre: "dark techno,deep minimal techno,funky tech house,house,tech house",
    popularity: "33",
  },
  {
    name: "cormac",
    image: "https://i.scdn.co/image/488c39a5cec142f002875faf7f10e5d48908656f",
    spotify: "4WSAshDz3phGlZFt8nOLVo",
    genre: "",
    popularity: "33",
  },
  {
    name: "Leon Bolier",
    image: "https://i.scdn.co/image/d380881c706fd7548cfa3ad270913e0d2129bc7e",
    spotify: "4iqg3LlZiqAElJOXJtC11H",
    genre: "deep progressive trance,dutch trance",
    popularity: "33",
  },
  {
    name: "Merlo",
    image: "https://i.scdn.co/image/52fa0ebf171050c985d8eb1f955996a4a74be4e7",
    spotify: "1YX87zmgrIixFXtlKROxmx",
    genre: "",
    popularity: "33",
  },
  {
    name: "Zuli",
    image: "https://i.scdn.co/image/fe25658b078a36d4f1c9582baee6c6cf747cd303",
    spotify: "1G14LkkXuagHSuNKWUKkQd",
    genre: "",
    popularity: "33",
  },
  {
    name: "Claw Boys Claw",
    image: "https://i.scdn.co/image/7c31db288db9cd704b4bcab529bb22735875cfb5",
    spotify: "5t378xBMytAymycG84zIPv",
    genre: "dutch blues,dutch indie,dutch rock",
    popularity: "33",
  },
  {
    name: "Carel Kraayenhof",
    image: "https://i.scdn.co/image/197153a305dd6b13b34c5676a752023aeaaae3cd",
    spotify: "12TNXxHqXaIwJjgd6C9O4X",
    genre: "bandoneon,classical accordion",
    popularity: "33",
  },
  {
    name: "Roosbeef",
    image: "https://i.scdn.co/image/ac47f3a481c79b3788f7a350bd0b01023078e574",
    spotify: "5W6gRzU3M4IpIWjy8D52i5",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "33",
  },
  {
    name: "Forest Drive West",
    image: "https://i.scdn.co/image/9c00432f9982beb25b9ddde9eaafb8923644bbe2",
    spotify: "0K1lHu1BP65Z1DErnljxUw",
    genre:
      "bass music,breaks,drumfunk,dub techno,experimental techno,float house,outsider house",
    popularity: "33",
  },
  {
    name: "Chumpion",
    image: "https://i.scdn.co/image/abae3f69e8ce818be17888aac167ba9d88e49382",
    spotify: "5GW0wfiA8Hly7xkiEJZ0BQ",
    genre: "",
    popularity: "33",
  },
  {
    name: "Gallowstreet",
    image: "https://i.scdn.co/image/22a26dfcbb07dd1d29fda51232baa06bbadb2e1c",
    spotify: "5PBhzgMrQywioo7dPuXzvm",
    genre: "street band",
    popularity: "33",
  },
  {
    name: "Fur Coat",
    image: "https://i.scdn.co/image/528d71db7e34f8e7f15e03edbe778365bc76fa5e",
    spotify: "26J5ZprV3p7jv4fHTmpXsB",
    genre: "deep disco house",
    popularity: "33",
  },
  {
    name: "Hanggai",
    image: "https://i.scdn.co/image/ab67616d0000b2734e2dcda376e0df3086ef88a5",
    spotify: "2m4rcnifN39Q2ix2vbpLlx",
    genre: "mongolian folk,throat singing",
    popularity: "33",
  },
  {
    name: "Hasse de Moor",
    image: "https://i.scdn.co/image/effcb9cb87b159e5513e57d89683aab491ca6855",
    spotify: "6DUflJztMaLRxX7uychqx4",
    genre: "dutch edm",
    popularity: "33",
  },
  {
    name: "Manuals",
    image: "https://i.scdn.co/image/07410bd297c0e5708bca72995e4e93b90d44f6c4",
    spotify: "5bvEoXzMCyh9cuwQu0Tvvo",
    genre: "",
    popularity: "33",
  },
  {
    name: "Bare Jams",
    image: "https://i.scdn.co/image/cde3c8e4346d27461ad2c57d68bb94d37e954a77",
    spotify: "3oI2CfnF8Oy1rT22ZB176e",
    genre: "uk reggae",
    popularity: "33",
  },
  {
    name: "Gianni Marino",
    image: "https://i.scdn.co/image/ded845b89d5592e5ac711819c2cbb04e6f9f5071",
    spotify: "4IhMfdQPtmo8NvYhnjetcY",
    genre: "dutch edm",
    popularity: "33",
  },
  {
    name: "Simple Symmetry",
    image: "https://i.scdn.co/image/0cfd18c5d95a7b9a44408c820432e65c4fe82faa",
    spotify: "36oy3scxRLRqG8uptf04vG",
    genre: "dark disco,russian electronic",
    popularity: "33",
  },
  {
    name: "Emok",
    image: "https://i.scdn.co/image/32680dae32afdf4314f457eec6333bf824660d82",
    spotify: "0n7N0GtNzbN6xgx7J14pWg",
    genre: "",
    popularity: "33",
  },
  {
    name: "Karoline Krüger",
    image: "https://i.scdn.co/image/08de1d2e97e70a785ec72ca4b763cbcaecdbf45b",
    spotify: "2Y2lJvGNGi4b2Bnikx4Onm",
    genre: "classic norwegian pop",
    popularity: "33",
  },
  {
    name: "Sarah Davachi",
    image: "https://i.scdn.co/image/09b4288a1df5460065955a0646da6c26f75fee2a",
    spotify: "2Swn6We5XXpyDz1YxRkprA",
    genre:
      "ambient,art pop,canadian experimental,compositional ambient,drone,drone ambient,electra,experimental ambient,experimental synth,fourth world,modular synth,sound art",
    popularity: "33",
  },
  {
    name: "Andreas Dorau",
    image: "https://i.scdn.co/image/4b699cac63a55c8772966084538719bb1c39f0fa",
    spotify: "7sbhauFwWAowzbg8yrm6wK",
    genre: "neue deutsche welle",
    popularity: "33",
  },
  {
    name: "System Overload",
    image: "https://i.scdn.co/image/94bad33eec7131705046795401d9089646cd5ec2",
    spotify: "2AlQBkucn6HkL30qRmyOmW",
    genre: "uptempo hardcore",
    popularity: "33",
  },
  {
    name: "Elias Chainboy",
    image: "https://i.scdn.co/image/ab67616d0000b27372ba2b4651a0aad4c55ca996",
    spotify: "6WazHLWoHm0CwxCS5XM6f4",
    genre: "",
    popularity: "33",
  },
  {
    name: "Vanilla Ace",
    image: "https://i.scdn.co/image/8d3840e1c92100b8f8b6c5fe77c2e8bf6053f375",
    spotify: "5RsczpoJXjqTqZLToj3nRn",
    genre: "bass house",
    popularity: "33",
  },
  {
    name: "Rina Mushonga",
    image: "https://i.scdn.co/image/f2dee932480ae9171dee3bae22274a1509053c9e",
    spotify: "1GFkwGetxvXluztDxPShGo",
    genre: "experimental pop",
    popularity: "33",
  },
  {
    name: "Anna Järvinen",
    image: "https://i.scdn.co/image/751b092c913f0eed481997661798ba852669df69",
    spotify: "70vrcQugFAOAtOFIW1wcyR",
    genre: "swedish indie folk,swedish jazz",
    popularity: "33",
  },
  {
    name: "Ralvero",
    image: "https://i.scdn.co/image/0771ab2e9e844ef217dc396cc1b4a4da75ed4c20",
    spotify: "1NtMiyzk7AhY2SGkdPkafX",
    genre:
      "big room,deep big room,dutch house,electro house,progressive electro house,sky room",
    popularity: "33",
  },
  {
    name: "Ntjam Rosie",
    image: "https://i.scdn.co/image/68ffc494b407c224f98cd4996fc662d408604adf",
    spotify: "44XhJ4fcKrMzrVr6WpF69R",
    genre: "dutch pop,neo soul",
    popularity: "33",
  },
  {
    name: "Delaney Davidson",
    image: "https://i.scdn.co/image/37b81db4a602d38322528d496528e4f9a06493f8",
    spotify: "5gKjq94Zz8p953ddbd9bRP",
    genre: "gothic americana,nz folk,nz singer-songwriter",
    popularity: "33",
  },
  {
    name: "Nandu",
    image: "https://i.scdn.co/image/f473c8a31dd1aee587c63ac8206374ad5678cc74",
    spotify: "5Kf73Whb7MShPJMFlvv8k0",
    genre: "neo r&b",
    popularity: "33",
  },
  {
    name: "Blindsmyth",
    image: "https://i.scdn.co/image/a3b2ebe041c358833e31b6a56273bea7ec3ca375",
    spotify: "316jj0bjhfXGHGBEraGy7P",
    genre: "experimental pop",
    popularity: "33",
  },
  {
    name: "Stef Classens",
    image: "https://i.scdn.co/image/adabcf3631193ec36de39325ea91973d172c1e6a",
    spotify: "2GIBqEMeHWoMZuxlmyc3ac",
    genre: "dutch singer-songwriter",
    popularity: "33",
  },
  {
    name: "Dave DK",
    image: "https://i.scdn.co/image/7096ee8d3f15f763be89f315d0ad019b4b194aa5",
    spotify: "0tkgaQKFblaI5WZaV8WPA1",
    genre: "german techno,minimal tech house",
    popularity: "33",
  },
  {
    name: "Brandt Brauer Frick",
    image: "https://i.scdn.co/image/4dfbf02db2e5481afcf5e3e2a9ce11af3b4e4801",
    spotify: "29TG40TGDvrOFQZM4adBf7",
    genre: "german electronica",
    popularity: "33",
  },
  {
    name: "Mirco Caruso",
    image: "https://i.scdn.co/image/1762d0a50021a89b4b7395f74df73203270e3dfa",
    spotify: "7LmbxbfMk0vQuPR7q6nJEl",
    genre: "swiss house",
    popularity: "33",
  },
  {
    name: "Qoiet",
    image: "https://i.scdn.co/image/ab67616d0000b27328216362691b833f4c83faf3",
    spotify: "7vlBJhLIORnTMtC9ZKcTFo",
    genre: "deathstep,zapstep",
    popularity: "33",
  },
  {
    name: "Don Vie",
    image: "https://i.scdn.co/image/fdb3084ac80d52e9d8fce71e21993207d13d8908",
    spotify: "4Od1RfBS9rKJYiaBreT0NW",
    genre: "dutch moombahton",
    popularity: "33",
  },
  {
    name: "Deluzion",
    image: "https://i.scdn.co/image/9ebd94b75d22682cee261df25a00f70c5785e740",
    spotify: "3r40SMXcvhhDUE1xhU8MSB",
    genre: "hardstyle,rawstyle",
    popularity: "33",
  },
  {
    name: "Icicle",
    image: "https://i.scdn.co/image/db0b533f7846ddad35a4ce849eaf011825314bae",
    spotify: "7zoCV6yevWc39GUz2v1jqg",
    genre: "drum and bass,drumfunk,dutch dnb,liquid funk,neurofunk",
    popularity: "33",
  },
  {
    name: "Paul Mayson",
    image: "https://i.scdn.co/image/ca88cafe0eacc006bfbca5cbb2a4769805866587",
    spotify: "2aSbTqzj52OymR8fEx4dca",
    genre: "",
    popularity: "33",
  },
  {
    name: "Henry X",
    image: "https://i.scdn.co/image/be1a20bbcecf984a6a18aced76824308c69a1f67",
    spotify: "7IqCBWPW8KoYk9ZBJsATSA",
    genre: "dutch r&b",
    popularity: "33",
  },
  {
    name: "Nhan Solo",
    image: "https://i.scdn.co/image/e41047933a259efac45a46a0417b3b0bc4a696f9",
    spotify: "1UhosJtmQlT9oJi38Zd2SU",
    genre: "deep disco house",
    popularity: "33",
  },
  {
    name: "FM Belfast",
    image: "https://i.scdn.co/image/64dcf53edd71bcc32ee16cee8d7b8e0d07535197",
    spotify: "22V3XeUvqBmVzu82JdKFWi",
    genre: "icelandic electronic,icelandic pop,metropopolis",
    popularity: "33",
  },
  {
    name: "Joyride",
    image: "https://i.scdn.co/image/888afb0dccdf804d39369873cca79c444d5447e3",
    spotify: "18SsMvVnPQe1U7ORxeb4bx",
    genre: "",
    popularity: "33",
  },
  {
    name: "Kirby Brown",
    image: "https://i.scdn.co/image/86ce4083f2ecab0874ec0472bdfc5b4c4aced6e6",
    spotify: "1pe81cUBCGxM11cnOq17kr",
    genre: "modern folk rock",
    popularity: "33",
  },
  {
    name: "Parallells",
    image: "https://i.scdn.co/image/564ef038185d1d21eee11f3de0f7657cee5b2f54",
    spotify: "0vUlarTf6Zl87ewxRbFd9f",
    genre: "",
    popularity: "33",
  },
  {
    name: "Dazers",
    image: "https://i.scdn.co/image/8f14a565fb03e874e6c21543d593efcf002013d0",
    spotify: "3OuKwjd3qKLWANtBWDWrur",
    genre: "",
    popularity: "33",
  },
  {
    name: "Layfullstop",
    image: "https://i.scdn.co/image/785d456b59d70c798cd3270e5340f162d7ce050b",
    spotify: "44KO1So8LqWGobs7xNCqe9",
    genre: "manchester hip hop",
    popularity: "33",
  },
  {
    name: "Julien-K",
    image: "https://i.scdn.co/image/7aebaefe70c75f73ad9b1d214bba18e79ed87f12",
    spotify: "6a82pdlhS6SsAq7HDUSZKN",
    genre: "industrial metal",
    popularity: "33",
  },
  {
    name: "The Vanguard Project",
    image: "https://i.scdn.co/image/466ed20c762e55c6d1d2020b85167ef0d05ac600",
    spotify: "4dS6XMUu4xeN5rLmWIqbYa",
    genre: "liquid funk,uk dnb",
    popularity: "33",
  },
  {
    name: "Selina Mour",
    image: "https://i.scdn.co/image/c67ef41d8677be560279d6cf008beb94070085df",
    spotify: "1zYkThtxlEsHksItd3YHlb",
    genre: "",
    popularity: "33",
  },
  {
    name: "Vera Sola",
    image: "https://i.scdn.co/image/83153c4bbf66300125d6a582a23228038e62db45",
    spotify: "6QZsje9QjfKHObQDmX6k0y",
    genre: "alternative americana",
    popularity: "33",
  },
  {
    name: "Scot Project",
    image: "https://i.scdn.co/image/639ee47dc76af9b6bba5d7a672250203eed462ab",
    spotify: "39zQTkZegu3XxkHNRbQmaG",
    genre: "german trance,hard trance,tech trance",
    popularity: "33",
  },
  {
    name: "Sandra van Nieuwland",
    image: "https://i.scdn.co/image/40276055a1638d7d17e7b76fb2862c0071023d08",
    spotify: "255PaovXNzjBcODZn42QgC",
    genre: "dutch idol pop,dutch pop",
    popularity: "33",
  },
  {
    name: "Hannes Bieger",
    image: "https://i.scdn.co/image/da7d60ab140e6502fa8f2fd67a48c89263d14e30",
    spotify: "3t6NA1aXgEgmkhKGf2bsP9",
    genre: "melodic techno",
    popularity: "33",
  },
  {
    name: "Jesse Dayton",
    image: "https://i.scdn.co/image/38b8b7f95d14d1e71664c52cea83dd9a16aae30c",
    spotify: "1NXXAtaI7ZYLazlZy2bXGa",
    genre: "alternative roots rock,roots americana",
    popularity: "33",
  },
  {
    name: "The Vintage Caravan",
    image: "https://i.scdn.co/image/06f5ace253236d0a52b3126ea7f51e9898a48a19",
    spotify: "61MH29rMIyOfuK7KXQznzX",
    genre: "icelandic rock",
    popularity: "33",
  },
  {
    name: "Kondi Band",
    image: "https://i.scdn.co/image/ab67616d0000b2735bc1e3f8c1b9a31c643586fb",
    spotify: "2IPZPCen311aH09425TKpF",
    genre: "african electronic,indie jazz",
    popularity: "33",
  },
  {
    name: "Dom Flemons",
    image: "https://i.scdn.co/image/a30a2ea96ebf8f022abb5cc36099438d696bc0d5",
    spotify: "79ScU9PMzW9i0jw67b5kVb",
    genre: "modern old-time",
    popularity: "33",
  },
  {
    name: "Capsize",
    image: "https://i.scdn.co/image/ffa7a7ec29bf9631c4c18ae5adb8e41d8fc88b20",
    spotify: "3Nt2h0gWNi9cxuLeNjOsET",
    genre: "melodic hardcore",
    popularity: "33",
  },
  {
    name: "Philemon",
    image: "https://i.scdn.co/image/373570882bf63d8c0eafed01b610b0bca6cfe3a6",
    spotify: "641A1vX028KtSk8ElLriH2",
    genre: "",
    popularity: "33",
  },
  {
    name: "Nick Thayer",
    image: "https://i.scdn.co/image/ab67616d0000b27329095b5d37aded57a25f7b28",
    spotify: "2OebTWrIkx0bL4zoJzG7SK",
    genre: "breakbeat,nu skool breaks",
    popularity: "33",
  },
  {
    name: "Gai Barone",
    image: "https://i.scdn.co/image/88313958633749611bc47474d6776c9261f3470c",
    spotify: "6ITKskiAcS4w9egVKClT7e",
    genre: "italian trance,progressive house",
    popularity: "33",
  },
  {
    name: "Alderliefste",
    image: "https://i.scdn.co/image/ee50a6f3e36a17e894d96dbfc32c65ca8e5ebc4a",
    spotify: "5J8ns43YpsiTRsG45N1cDi",
    genre: "dutch pop",
    popularity: "33",
  },
  {
    name: "Cheyenne Giles",
    image: "https://i.scdn.co/image/d8a03241352d08458becd16e5b7ef335b23ccde0",
    spotify: "2FoyDZAnGzikijRdXrocmj",
    genre: "",
    popularity: "33",
  },
  {
    name: "Honeyfeet",
    image: "https://i.scdn.co/image/3c1a3a77803dcf4facdaf20d1dc0fb56b1843af4",
    spotify: "46lakDQFKyegkH9x9WZtJV",
    genre: "manchester indie",
    popularity: "33",
  },
  {
    name: "Lion Sphere",
    image: "https://i.scdn.co/image/09998038af37c86cec053c16d6be0a1131858d9d",
    spotify: "0z3YxKBfeFgP4PK1JQAdTw",
    genre: "german indie",
    popularity: "33",
  },
  {
    name: "Alsarah & The Nubatones",
    image: "https://i.scdn.co/image/d8b2ca43349adaf0efc417c5376b86dcbfe748a1",
    spotify: "7xGVP8NTuOKRVkNMl2fv7n",
    genre: "arab alternative,nubian traditional,sudanese pop",
    popularity: "33",
  },
  {
    name: "Zen Mechanics",
    image: "https://i.scdn.co/image/6fbbd7fa5bd951a4a908627c8ef022e742e77c4f",
    spotify: "0HlOk15cW7PeziVcItQLco",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "33",
  },
  {
    name: "Desolated",
    image: "https://i.scdn.co/image/ab67616d0000b273585cf83a4028d7f49088d375",
    spotify: "4aJzQA930qk1ZLTxZDllh6",
    genre: "beatdown,metallic hardcore,uk beatdown,ukhc",
    popularity: "33",
  },
  {
    name: "Mathilde Santing",
    image: "https://i.scdn.co/image/5e57cbd08cebc44455d463a807ca9e0e6ffaa73f",
    spotify: "1Sx5j4cpUvTklSXRUPrY41",
    genre: "dutch pop,dutch rock",
    popularity: "33",
  },
  {
    name: "Dans Dans",
    image: "https://i.scdn.co/image/70ff3174801bcc8fc25a85d5ac59af504a99eedb",
    spotify: "5x3LMsfwbAiYZy5lAqgM2m",
    genre: "belgian indie,belgian modern jazz",
    popularity: "33",
  },
  {
    name: "Will Samson",
    image: "https://i.scdn.co/image/4e4693bb41314a52f10926b7ccb7d166c5519b27",
    spotify: "6VBJxxPZ84ty9nR1nFkNNx",
    genre: "experimental folk",
    popularity: "33",
  },
  {
    name: "Dr Meaker",
    image: "https://i.scdn.co/image/5fe7c0e06fd737fa53624fb8ed4f1676343bb541",
    spotify: "2Tz73u31G8f4nUjtPOketU",
    genre: "bristol electronic,drum and bass,jump up,jungle,liquid funk,uk dnb",
    popularity: "33",
  },
  {
    name: "James Teej",
    image: "https://i.scdn.co/image/83f6736ee9409f821536ae0f3ca3b4f574c3f2bb",
    spotify: "7lx2Fs8ftKfXxOVPVHtbwK",
    genre: "deep disco house,minimal tech house",
    popularity: "33",
  },
  {
    name: "KOKOKO!",
    image: "https://i.scdn.co/image/4f767299fbb21069d13f1171f00e544b1a4867dd",
    spotify: "4hkOCqpKuf6KFaQeTGfYNw",
    genre: "african electronic",
    popularity: "33",
  },
  {
    name: "Layla",
    image: "https://i.scdn.co/image/ab67616d0000b273ce8df4288c66cd5aca23734b",
    spotify: "04BsVprJtIhl2C4fgPEz4W",
    genre: "",
    popularity: "33",
  },
  {
    name: "Mademoiselle Luna",
    image: "https://i.scdn.co/image/6eecfcfa72f5c3611e1d93b7c640485f8c122a66",
    spotify: "5FkM4LE4c2SUBJypuw0r9M",
    genre: "",
    popularity: "33",
  },
  {
    name: "Dagoba",
    image: "https://i.scdn.co/image/da0e3d115f70799e837ed923cc1952b23599ced7",
    spotify: "1iZlQG09PwkMVMumsvgFj4",
    genre: "cyber metal,french metal,groove metal,melodic death metal",
    popularity: "33",
  },
  {
    name: "Hackney Colliery Band",
    image: "https://i.scdn.co/image/8f821ee516f2d48cfcb0173f2ebcbd6fc49b4e75",
    spotify: "6DFW6tKSBia9Af9JcNymCi",
    genre: "brass band,street band",
    popularity: "33",
  },
  {
    name: "Hazem Beltagui",
    image: "https://i.scdn.co/image/8b883147528d4d3bee324c6a7f2d6e75c37a9fac",
    spotify: "7gEm6pYZGiAIBAbf2xfqd8",
    genre: "progressive uplifting trance",
    popularity: "33",
  },
  {
    name: "Bajillionaire",
    image: "https://i.scdn.co/image/f18dea8df26919b42c4fabb06453d2628ab0f638",
    spotify: "1GPMjJFlpnO6hOHBhsX0qW",
    genre: "australian electropop",
    popularity: "33",
  },
  {
    name: "Joep Mencke",
    image: "https://i.scdn.co/image/c0dab5df58966781434752e0cf747360fbb5ef8b",
    spotify: "0GapyFJVUjxdA2a4NlnhRm",
    genre: "organic electronic",
    popularity: "33",
  },
  {
    name: "Ina Regen",
    image: "https://i.scdn.co/image/ea9b2ead8cf25e92c0189b642a6bce49f47f817f",
    spotify: "0vkI0xLkitnhjnvOK5REnW",
    genre: "austropop",
    popularity: "33",
  },
  {
    name: "Wargirl",
    image: "https://i.scdn.co/image/17f61b4727bda170d040f521e6e0dd3de9f293e9",
    spotify: "7eoJsJZip1IYk8p5o9fvsO",
    genre: "",
    popularity: "33",
  },
  {
    name: "Vandalism",
    image: "https://i.scdn.co/image/55032d4108254d007b8e93b26852be93b4a27244",
    spotify: "1ScZSjoYAihNNm9qlhzDnL",
    genre: "australian dance",
    popularity: "33",
  },
  {
    name: "Estasia",
    image: "https://i.scdn.co/image/aef5b15fa518f173a24524bc79880d060390a9cb",
    spotify: "74hAeTlsTNzxpyczUGnkM2",
    genre: "uptempo hardcore",
    popularity: "33",
  },
  {
    name: "Mortality Rate",
    image: "https://i.scdn.co/image/f8ca6030a3ea2a309a1283bdc3f1cdc2934d1b34",
    spotify: "18DaTNmWI7nYhXkXQZEZev",
    genre: "metallic hardcore",
    popularity: "33",
  },
  {
    name: "Ramiro Lopez",
    image: "https://i.scdn.co/image/dfb7e410e28bf50e370d7edbb6c413cc1d3cfb3b",
    spotify: "3jYkj7h3rgKs5irWBPxjrr",
    genre: "deep tech house,latin tech house,spanish techno",
    popularity: "33",
  },
  {
    name: "Seth Walker",
    image: "https://i.scdn.co/image/a4b6a1ef7aefca3fb1eff851d92a3544a1af5942",
    spotify: "3Bl4eNAFJkXXi0ewcjgGP9",
    genre: "modern blues",
    popularity: "33",
  },
  {
    name: "Ellen Ten Damme",
    image: "https://i.scdn.co/image/bec3f9c2ccc0b7d8e6fc94ed384fb06c41d1dbcb",
    spotify: "3DbOvEIWluNeH6rhPuFexv",
    genre: "dutch cabaret,dutch pop,dutch rock",
    popularity: "33",
  },
  {
    name: "Mouse On Mars",
    image: "https://i.scdn.co/image/ab6772690000c46c7c68754d5ddf57d10973e346",
    spotify: "4ZgIWfyg9BkcqnJJ2xVR3f",
    genre:
      "deep idm,drill and bass,dusseldorf electronic,dusseldorf indie,german electronica,indie electronica,intelligent dance music,microhouse",
    popularity: "33",
  },
  {
    name: "Marcel Woods",
    image: "https://i.scdn.co/image/f6a5511bb54d313631eeff507ebad5e696b4522e",
    spotify: "03kG9mdI2xdVCLOsFt26GR",
    genre: "trance",
    popularity: "32",
  },
  {
    name: "Eris Drew",
    image: "https://i.scdn.co/image/ab67616d0000b2738556197c8832c8f617a54334",
    spotify: "4VKbZ8lm0Bm1AbtzAbBdpO",
    genre: "experimental house,float house",
    popularity: "32",
  },
  {
    name: "Nico Morano",
    image: "https://i.scdn.co/image/8546d531d6df294e32b5c35f2aabb0bb20014e05",
    spotify: "4tgKBxZIclHP0c2Tp8yyyz",
    genre: "",
    popularity: "32",
  },
  {
    name: "Johan Gielen",
    image: "https://i.scdn.co/image/762c50a910c0e665090e643cc91824af00cc6a3b",
    spotify: "2eSSc4YqhlEw0e11E9oQhP",
    genre: "trance",
    popularity: "32",
  },
  {
    name: "upsammy",
    image: "https://i.scdn.co/image/e491050c50053d4df32f60aa3d257eac00e32a5d",
    spotify: "2orXY2oMFNUtiNrNMDyreV",
    genre: "bleep techno,deconstructed club,experimental house,float house",
    popularity: "32",
  },
  {
    name: "Jensen Interceptor",
    image: "https://i.scdn.co/image/ab67616d0000b2733ff0b57f65b8e117a3cca62e",
    spotify: "30eE9RmXxzCcZKTf4N2O0e",
    genre: "destroy techno,electro,ghettotech",
    popularity: "32",
  },
  {
    name: "Team TNT",
    image: "https://i.scdn.co/image/c97aba14d1ff1a3ece85c2fc0e10b19147335388",
    spotify: "20yOdhlM9VXNEGLGrxilPZ",
    genre: "",
    popularity: "32",
  },
  {
    name: "Rigmor Gustafsson",
    image: "https://i.scdn.co/image/d305a9af61b8050048fe18e873095e934a583df6",
    spotify: "4PVhLylgFzJbW165GuwMzU",
    genre: "swedish jazz,vocal jazz",
    popularity: "32",
  },
  {
    name: "Ida Engberg",
    image: "https://i.scdn.co/image/bd536d14a220fb5d4e4cdc349bfc34b1d0d405bc",
    spotify: "5psccYjSTbvey4GWul62EB",
    genre: "electra,swedish electronic,swedish techno",
    popularity: "32",
  },
  {
    name: "MC DL",
    image: "https://i.scdn.co/image/3ca35cd07305ef3e96f003a137d174e74675595c",
    spotify: "44S9ml6dQeSqLHFpHkudWc",
    genre: "",
    popularity: "32",
  },
  {
    name: "Robin and the Backstabbers",
    image: "https://i.scdn.co/image/3769d9406634dab9dfc62218c1e39aac2aaa1d4a",
    spotify: "7y2DXdRackYULQq4qsCxpL",
    genre: "romanian indie,romanian rock",
    popularity: "32",
  },
  {
    name: "Konstantin Sibold",
    image: "https://i.scdn.co/image/384ee044c543b4c4eee560f1d32fdda58eb55670",
    spotify: "5Ls75umF4lBOQVp3pJAlbW",
    genre: "",
    popularity: "32",
  },
  {
    name: "Amanda Ginsburg",
    image: "https://i.scdn.co/image/f1782812840452a074c3eab7e061f21cc9127c10",
    spotify: "0WnqhdeUWBRldiZFW83Ahj",
    genre: "swedish jazz",
    popularity: "32",
  },
  {
    name: "Legendary Shack Shakers",
    image: "https://i.scdn.co/image/84160348291837c52f4f75525b3f07e9473c039f",
    spotify: "00sR4i1EQSQrNjSVJkeqYl",
    genre: "gothic americana,psychobilly",
    popularity: "32",
  },
  {
    name: "Brondo",
    image: "https://i.scdn.co/image/ddb98aa4b18ea5fe671055153e18213eb65ffb7b",
    spotify: "3ZPe4CPLJYAczbPKYQOJey",
    genre: "",
    popularity: "32",
  },
  {
    name: "Ramzi",
    image: "https://i.scdn.co/image/b816061e810e87271e3bb874afd9c3cf1f6f1f65",
    spotify: "7sOe0BpnYTaGhBB6V6DAmo",
    genre: "",
    popularity: "32",
  },
  {
    name: "Wibi Soerjadi",
    image: "https://i.scdn.co/image/ab67616d0000b2734b6277a3ebb00cc03e8cb755",
    spotify: "2WzRYQ7st0eR2lbMUy14rP",
    genre: "",
    popularity: "32",
  },
  {
    name: "Whitney Rose",
    image: "https://i.scdn.co/image/f2dcf338932ac916e215b6b331e7382171ccfcf4",
    spotify: "1kltSDXx78MGhHmxbe35tx",
    genre:
      "alternative country,austin singer-songwriter,canadian contemporary country,deep new americana,indie folk,new americana,roots americana",
    popularity: "32",
  },
  {
    name: "Okain",
    image: "https://i.scdn.co/image/7aef017f8e0576c3e672c2a0955bfe520fd02ef8",
    spotify: "15VGXHJGiStKhJtghHznI8",
    genre: "french tech house,minimal tech house",
    popularity: "32",
  },
  {
    name: "Indecent Noise",
    image: "https://i.scdn.co/image/bd50294dca2402abb3c73056b431760272a28a4d",
    spotify: "6g3WgXMkGuNv3fKtXvz6wA",
    genre: "progressive uplifting trance,uplifting trance",
    popularity: "32",
  },
  {
    name: "Curtis Alto",
    image: "https://i.scdn.co/image/0ec8dcb476894c6b42640062851f60b3f5bbed79",
    spotify: "7exL8IAyYuSdXxAGN1iuhx",
    genre: "belgian edm",
    popularity: "32",
  },
  {
    name: "Roger Martinez",
    image: "https://i.scdn.co/image/ab67616d0000b273abac24cd3a796b8016e4044e",
    spotify: "1d2tVLWZAh4W9GHe9WYMLd",
    genre: "",
    popularity: "32",
  },
  {
    name: "dBridge",
    image: "https://i.scdn.co/image/9347e68f8838b0faf33ac3cace369a80edc925d6",
    spotify: "4G1BTcGLvvsItegHSvBH0y",
    genre:
      "bass music,deep dubstep,drum and bass,drumfunk,liquid funk,minimal dnb,uk dnb",
    popularity: "32",
  },
  {
    name: "Devarsity",
    image: "https://i.scdn.co/image/53dfcd5d94507e5da9add7f61d70caa90687c894",
    spotify: "4muTG0t1zTFCv3WoxqTIQJ",
    genre: "dutch moombahton",
    popularity: "32",
  },
  {
    name: "Postman",
    image: "https://i.scdn.co/image/c69690f5c32ed3930682d6d720a2a7dc2b37639e",
    spotify: "5iRCIlHew6I5giq5pzjcxX",
    genre: "",
    popularity: "32",
  },
  {
    name: "Lydia Loveless",
    image: "https://i.scdn.co/image/b26daf99f70d0859b3acc6166d5c7c872b7c1d66",
    spotify: "4aZmKktp90vPbhbdgf2fpn",
    genre: "alternative country,alternative roots rock,roots rock",
    popularity: "32",
  },
  {
    name: "Mystique",
    image: "https://i.scdn.co/image/f287b519903978d21d6c8ae326089f713419e37c",
    spotify: "4AoBOahip88ITtaZKPaC6y",
    genre: "belgian edm",
    popularity: "32",
  },
  {
    name: "Fehrplay",
    image: "https://i.scdn.co/image/e30d12ce1c35aaaf80756ec96d9fdd37c9a067c5",
    spotify: "6HcVFayEV6B5xgp59WXKbF",
    genre: "big room,progressive house,progressive trance",
    popularity: "32",
  },
  {
    name: "AB Syndrom",
    image: "https://i.scdn.co/image/0281f872ab2d7f0e4084d73611cfd2e8e5a183f4",
    spotify: "6L8qZVWC4sWuYRSDXMLpsc",
    genre: "german indie,german indie pop",
    popularity: "32",
  },
  {
    name: "Tara Nome Doyle",
    image: "https://i.scdn.co/image/e1d4dc15bb4a8107692a92f7f81962db58e00d5f",
    spotify: "4juPbQZA8Z5lkQYtd4pNmv",
    genre: "german indie folk",
    popularity: "32",
  },
  {
    name: "Aaaron",
    image: "https://i.scdn.co/image/1df88f651ca396b00f05676a29166b04ef422f1a",
    spotify: "6sAjR3KTv3ndbi77RmREoj",
    genre: "",
    popularity: "32",
  },
  {
    name: "Bassekou Kouyate",
    image: "https://i.scdn.co/image/4a3c394f5bb5cc6d31716a3f461396236edc2c08",
    spotify: "2reknFuZPFjVat474Q35SQ",
    genre: "afropop,desert blues,malian blues,mande pop,ngoni,world",
    popularity: "32",
  },
  {
    name: "Ni Liv",
    image: "https://i.scdn.co/image/ab67616d0000b273913d05e4ebb677a401fa48de",
    spotify: "2Qq1PMkFTXS2p3tcVWs8nG",
    genre: "danseband,norwegian country",
    popularity: "32",
  },
  {
    name: "Shock Elias",
    image: "https://i.scdn.co/image/099c50c356f71237ad8dd7e8dd2340046b79fc8a",
    spotify: "2mIOimqNnPGF7Jce7kUbvX",
    genre: "",
    popularity: "32",
  },
  {
    name: "EDDIETHEHOST",
    image: "https://i.scdn.co/image/4fca2c963524805554e4179f37317e69d566df53",
    spotify: "0nwxXY2qeimJ9WkQKitxUg",
    genre: "",
    popularity: "32",
  },
  {
    name: "Luca Sestak",
    image: "https://i.scdn.co/image/b6d5dcd802edd6508b6cdc4fa2758a0be73f8b61",
    spotify: "5ypQRq934XJmh9eXioqKiQ",
    genre: "boogie-woogie,piano blues",
    popularity: "32",
  },
  {
    name: "Playground Zer0",
    image: "https://i.scdn.co/image/5f4405ce768ae6053cffb9a5d402bb523bc929fb",
    spotify: "42W0DbppiuIZYntWRUJJnD",
    genre: "",
    popularity: "32",
  },
  {
    name: "Martin Buttrich",
    image: "https://i.scdn.co/image/f49cc37a74b52c823cdeed93f290f1dd49b79308",
    spotify: "2bP72uOaVvJ2syINURI42n",
    genre:
      "german techno,microhouse,minimal tech house,minimal techno,tech house",
    popularity: "32",
  },
  {
    name: "Bas Roos",
    image: "https://i.scdn.co/image/95f52e817da670792d34b242b94b077c1c29420c",
    spotify: "0A95zGmlvqQIdDFCuacPqe",
    genre: "dutch house",
    popularity: "32",
  },
  {
    name: "Sebastian Mullaert",
    image: "https://i.scdn.co/image/9704bc56ee380309a888c70cf4232b3517ec3395",
    spotify: "5cKPK8DCxX1R5PwQOU1huv",
    genre: "microhouse,swedish electronic",
    popularity: "32",
  },
  {
    name: "Mario Batkovic",
    image: "https://i.scdn.co/image/505dffb6398b5fabaa146f38cec0b09b2f50df27",
    spotify: "3lLjSS7VP84aQ1fwX3Vbqz",
    genre: "bern indie,post-minimalism",
    popularity: "32",
  },
  {
    name: "Narnia",
    image: "https://i.scdn.co/image/3d548f01a351f74a7a5a788b73697e77d88979de",
    spotify: "5bodTAJqKphEDB3ItIq4Hc",
    genre:
      "christian metal,christian power metal,christian rock,neo classical metal,swedish power metal",
    popularity: "32",
  },
  {
    name: "1914",
    image: "https://i.scdn.co/image/ab67616d0000b273d5821e84a061053971369cfa",
    spotify: "0IpKWttPlwhd7Cevxsh1Bz",
    genre: "ukrainian metal",
    popularity: "32",
  },
  {
    name: "Denney",
    image: "https://i.scdn.co/image/e5b284d394acb091f95942d12916ee0d9fb1d778",
    spotify: "7vm3musYjzfqoMloVCEF7v",
    genre: "uk tech house",
    popularity: "32",
  },
  {
    name: "Zakes Bantwini",
    image: "https://i.scdn.co/image/f8eef25594de84b3e86d731b60d291978d7c0d76",
    spotify: "5mZLaYqN0ZkjxfeUUmiuqL",
    genre: "deep house,gqom,kwaito house",
    popularity: "32",
  },
  {
    name: "Mahsa Vahdat",
    image: "https://i.scdn.co/image/cf74aa2a3881848dcb2772c3072893d94f9d1ea1",
    spotify: "6zhA5Vu3mPLVuSCf3RVtxH",
    genre: "classic persian pop,persian alternative,persian traditional",
    popularity: "32",
  },
  {
    name: "Florian Kruse",
    image: "https://i.scdn.co/image/1ea78dc3b73b7103fc5e960914aac70297cce11a",
    spotify: "7GhGgxIAhzJxZXvF1bEYZ8",
    genre: "deep techno",
    popularity: "32",
  },
  {
    name: "Wreck Reality",
    image: "https://i.scdn.co/image/e2efe2432800d351426e224f487b280db80ce366",
    spotify: "7Dn5YtJZi2nozyzpXy9yBR",
    genre: "",
    popularity: "32",
  },
  {
    name: "Marco Faraone",
    image: "https://i.scdn.co/image/da6ea9c797df1a01204fbd258527d783f984f8bf",
    spotify: "00IUMN7pWAU2jYWcdOt5c3",
    genre: "dark techno,deep tech house,italian techno",
    popularity: "32",
  },
  {
    name: "Sofia Portanet",
    image: "https://i.scdn.co/image/418eee37e3b52961c8d0a0a8ae8f49dedf023762",
    spotify: "6QtH2p5QkuzncnyK1Uu2EZ",
    genre: "german indie",
    popularity: "32",
  },
  {
    name: "Ducky",
    image: "https://i.scdn.co/image/54899f3633e8621a2693e655548f839c4de4336b",
    spotify: "5e1I1C0g7epGwRxDGZ4tt9",
    genre: "electra",
    popularity: "32",
  },
  {
    name: "Vakula",
    image: "https://i.scdn.co/image/14403e848d0e92f4e17b6e347e16f4ec5a49bb96",
    spotify: "71LM30jsskgKlpbBHDliB8",
    genre: "deep soul house,ukrainian experimental",
    popularity: "32",
  },
  {
    name: "Mika Setzer",
    image: "https://i.scdn.co/image/e6509869cc03a6090cac2f3d7c5a4cf0426a1042",
    spotify: "5TQQFW7KAFFsrhA255xjZx",
    genre: "",
    popularity: "32",
  },
  {
    name: "Nick Curly",
    image: "https://i.scdn.co/image/2abe8273e81c52234b55570eb72eb8d7eb82fd8c",
    spotify: "5WI60lKXG4mP2OPyt8pyQ2",
    genre: "minimal tech house,tech house",
    popularity: "32",
  },
  {
    name: "Young Lyxx",
    image: "https://i.scdn.co/image/99df9446eff280c26b12f9f62d8c3c7d5ff291ed",
    spotify: "1KaPSJ1xlpywMSGiK1Qftk",
    genre: "new orleans rap",
    popularity: "32",
  },
  {
    name: "Dilemma",
    image: "https://i.scdn.co/image/8987540724d78afbf9f9249638eefcef38c0853b",
    spotify: "5zr0OMejpKsgx5IfyNWHlZ",
    genre: "",
    popularity: "32",
  },
  {
    name: "Fetsum",
    image: "https://i.scdn.co/image/ab67616d0000b273e503d073fc7c228e90f61bf6",
    spotify: "6woLhP7pzj8pbWsZ5VUOck",
    genre: "",
    popularity: "32",
  },
  {
    name: "PHCK",
    image: "https://i.scdn.co/image/3de6223e6669def521a693b37e52c80ce3cdade9",
    spotify: "6lT9HcARJpVR1bij9Qo6Fk",
    genre: "organic electronic,organic house",
    popularity: "32",
  },
  {
    name: "Enzo Siragusa",
    image: "https://i.scdn.co/image/497fab01aca0ac3b76a7f1bf53291b79a37a0a1d",
    spotify: "3tXRNjxWCFyWyJdjMwtaSX",
    genre: "minimal tech house,tech house,uk house",
    popularity: "32",
  },
  {
    name: "Martin Hederos",
    image: "https://i.scdn.co/image/21ad16bb3b673abf35b1720648e22812ddb34681",
    spotify: "0KrueSPl32yXv6KbERkUBL",
    genre: "swedish jazz",
    popularity: "32",
  },
  {
    name: "Jace Mek",
    image: "https://i.scdn.co/image/687b37d72952bca622dea3382754344f37cc24a3",
    spotify: "67dClEyrx8SQ6gqe7r8PR4",
    genre: "bass house",
    popularity: "32",
  },
  {
    name: "Fairmont",
    image: "https://i.scdn.co/image/ec88a14ea3d7a07cb356b6eb75393d0bbb8f4ad7",
    spotify: "2Ch5FKvelQEglFpISkr7Po",
    genre: "microhouse,minimal techno",
    popularity: "32",
  },
  {
    name: "Samba Touré",
    image: "https://i.scdn.co/image/91facd3e6c5f38454b40029f0f24f5e0d62e3b05",
    spotify: "3XHp0LmHYLkVBPsH3B66zi",
    genre: "afropop,desert blues,malian blues,mande pop,world",
    popularity: "32",
  },
  {
    name: "Dave Clarke",
    image: "https://i.scdn.co/image/663aa6efe7418708e7fe8caa60ebaf2e7856a46e",
    spotify: "6Fr9aJBxyMOkTFF0b9JZrQ",
    genre: "acid house,minimal techno,techno",
    popularity: "32",
  },
  {
    name: "Zupermaria",
    image: "https://i.scdn.co/image/efa7fc55e7cc056f455e5d510b28bf250b9a5f2f",
    spotify: "5COfgHyIX1sSJv38S01Mz7",
    genre: "norwegian pop,norwegian pop rap",
    popularity: "32",
  },
  {
    name: "Minor Science",
    image: "https://i.scdn.co/image/0b8e6b8071395e83c30e8df10c184d50153c806b",
    spotify: "7xkfvmfvOfMBZmIGKaLtzi",
    genre:
      "bass music,deconstructed club,experimental techno,float house,microhouse,outsider house",
    popularity: "32",
  },
  {
    name: "Cicada Rhythm",
    image: "https://i.scdn.co/image/ade6e0276cb5b1d37af4939b574994b36631767b",
    spotify: "3Ks6VJR2RbM1Yhlux5xh76",
    genre: "deep new americana",
    popularity: "32",
  },
  {
    name: "Romeo Blanco",
    image: "https://i.scdn.co/image/f8da06858314282add1cbce3216e58a3e88ebb5d",
    spotify: "7oVSEUsFMvqBPpVKuRFSXQ",
    genre: "big room",
    popularity: "32",
  },
  {
    name: "X-Pander",
    image: "https://i.scdn.co/image/e861da282d037639acba39a6894cd559117ebba0",
    spotify: "5BD89DInX2q6j9laqzi79K",
    genre: "hardstyle,rawstyle,uptempo hardcore",
    popularity: "32",
  },
  {
    name: "ZDS",
    image: "https://i.scdn.co/image/bddb166cab18ce274faf1e38507ca44a908e49e5",
    spotify: "5JWq7Qs3NyKX13mLUdRui5",
    genre: "",
    popularity: "32",
  },
  {
    name: "Crocodiles",
    image: "https://i.scdn.co/image/917142fbe25f287124360b4a02e48eff3ba8de22",
    spotify: "1Z4Erxt5wSXH0gbOsVJUMv",
    genre: "noise pop,nu gaze",
    popularity: "32",
  },
  {
    name: "Anica Russo",
    image: "https://i.scdn.co/image/045c9c65505ead7971736f70f6b6fc334d698bc1",
    spotify: "7sosL0rffvNlG2SE0fyZJX",
    genre: "",
    popularity: "32",
  },
  {
    name: "Barbagallo",
    image: "https://i.scdn.co/image/ab67616d0000b273f172e1eb652133837b0be5e3",
    spotify: "6s6G7IGye7b8hnTMG2bMPz",
    genre: "",
    popularity: "32",
  },
  {
    name: "Jesse Malin",
    image: "https://i.scdn.co/image/60b1a94c6aefaf5447f2e358ab5891e7ae9c6de0",
    spotify: "6zKkaqMGGmaKLUSLTcsrls",
    genre: "alternative country,deep new americana,roots rock",
    popularity: "32",
  },
  {
    name: "Slimez",
    image: "https://i.scdn.co/image/267b62269599a7c141854b79bd9758a2d559e2ed",
    spotify: "59mbb7AEcpSMejoZph92tr",
    genre: "",
    popularity: "32",
  },
  {
    name: "5K HD",
    image: "https://i.scdn.co/image/d795cad3561d3f8475d850ad72dff79fc28ef423",
    spotify: "6ZMLkcfjNwPGCAlL7LvMyr",
    genre: "austrian indie,austrian pop,glitch pop",
    popularity: "32",
  },
  {
    name: "Imperial State Electric",
    image: "https://i.scdn.co/image/235937b85a2b4b22bc7f8a750d63c9d888c03346",
    spotify: "3r66hAPAD8S98YBno8a5fD",
    genre: "",
    popularity: "32",
  },
  {
    name: "Scenic Route to Alaska",
    image: "https://i.scdn.co/image/291949f822e70ab2376871720281332c805aab49",
    spotify: "4tUP4gz64sNmLHP1M2eLI5",
    genre: "canadian indie,edmonton indie",
    popularity: "32",
  },
  {
    name: "Helena Hauff",
    image: "https://i.scdn.co/image/05e40c509f6d5541c249bb08832dce072363b9d3",
    spotify: "1JcefSOP7bcWEluL0iEIaN",
    genre: "electra",
    popularity: "31",
  },
  {
    name: "Carlo Lio",
    image: "https://i.scdn.co/image/be91a6e07520fece68c72c0c5366469349dec1cc",
    spotify: "51NwQz5MA32kigUGYjdA3z",
    genre: "canadian electronic,canadian house,tech house",
    popularity: "31",
  },
  {
    name: "Apster",
    image: "https://i.scdn.co/image/97ac608af943e1f01488aa38da85882cb58e7029",
    spotify: "0bi8sypegPFiP6Rd9gdkyz",
    genre: "big room,dutch house",
    popularity: "31",
  },
  {
    name: "Objekt",
    image: "https://i.scdn.co/image/8c7087db34f7ac6a34fa458c50971a149547d262",
    spotify: "44z1nVVXZE8d4njcQmQLWc",
    genre:
      "bass music,deconstructed club,float house,footwork,future garage,mandible,outsider house",
    popularity: "31",
  },
  {
    name: "Re.You",
    image: "https://i.scdn.co/image/e8cd80ded433878fd72f5686a46441fba46ca6b3",
    spotify: "3AE5c8fBFJYdxXHCSXAyVx",
    genre: "deep disco house,organic house",
    popularity: "31",
  },
  {
    name: "Phiso",
    image: "https://i.scdn.co/image/7ca34d66545711a02e2672706ebd5920b3cbd546",
    spotify: "7csjnVvI7V4mm9e7fvqRdC",
    genre: "brostep,zapstep",
    popularity: "31",
  },
  {
    name: "Tim Knol",
    image: "https://i.scdn.co/image/fada385fd9a14bc6f4771a4f426c603efc416eb9",
    spotify: "5iwR7L3O96vO8rVXXuLf5K",
    genre: "dutch americana,dutch indie,dutch indie rock,dutch pop,dutch rock",
    popularity: "31",
  },
  {
    name: "Damiano von Erckert",
    image: "https://i.scdn.co/image/991654520c92f7493f464ea109320f226ce98198",
    spotify: "28Y1hMhuru402KjzFJDegi",
    genre: "",
    popularity: "31",
  },
  {
    name: "The Mono Jacks",
    image: "https://i.scdn.co/image/dc51c8101c7f34aba244ccf2588c647fba49f20c",
    spotify: "28oQSgNZXIuCrcZXXJ2KXO",
    genre: "romanian indie,romanian rock",
    popularity: "31",
  },
  {
    name: "Satoshi Tomiie",
    image: "https://i.scdn.co/image/5eb485fc7279a27a7b1acfc92f49f08fa2d36008",
    spotify: "3TrAOZvW0MzZeKZRFnU7Ul",
    genre: "classic progressive house,japanese electronic",
    popularity: "31",
  },
  {
    name: "Francesca Lombardo",
    image: "https://i.scdn.co/image/b22ca9d583274d31e9504b1e94cbb77defd110b0",
    spotify: "53k6hml77TQV6Eub3zdbju",
    genre: "electra",
    popularity: "31",
  },
  {
    name: "Hackensaw Boys",
    image: "https://i.scdn.co/image/6781acaf6a22be10a7f87b63de057763ac68be4e",
    spotify: "0PPMo9gDxneTAzxeF1MU3J",
    genre: "banjo,bluegrass,new americana,progressive bluegrass",
    popularity: "31",
  },
  {
    name: "leeSA",
    image: "https://i.scdn.co/image/ab67616d0000b273178ceef86b86f580bb558bdc",
    spotify: "3GBMe03XlFR2vgpeepaaGY",
    genre: "",
    popularity: "31",
  },
  {
    name: "Francis Harris",
    image: "https://i.scdn.co/image/cd0f45f3fe280ce2161bfd56da3942c0e6d9abcb",
    spotify: "3pTGFfv4bHpC2MO7LS9S6W",
    genre: "ambient house,float house",
    popularity: "31",
  },
  {
    name: "Anders Lundin",
    image: "https://i.scdn.co/image/cd746eafc8b373ca40e57cb1b5150c33ca25e4d1",
    spotify: "6ocdSdvNpA88kKJSnvecKT",
    genre: "barnmusik",
    popularity: "31",
  },
  {
    name: "Tasker",
    image: "https://i.scdn.co/image/ab67616d0000b273782c40fff23b0828c16c5805",
    spotify: "4GQRAVwht11iG3QAsm7SVv",
    genre: "",
    popularity: "31",
  },
  {
    name: "Giovanca",
    image: "https://i.scdn.co/image/ab67616d0000b273d7c298f0b151245921dc672a",
    spotify: "1GHgheljbmRBI1NgiDkQ98",
    genre: "",
    popularity: "31",
  },
  {
    name: "Frenchfaces",
    image: "https://i.scdn.co/image/0c7f422a089553bda116afd7fa0d599cfb8e20a5",
    spotify: "6Tf1ph6zYjnvC9dmw9174m",
    genre: "uptempo hardcore",
    popularity: "31",
  },
  {
    name: "Le Le",
    image: "https://i.scdn.co/image/5481c1709b54a6065d9dc173ad22025018071826",
    spotify: "3YuaD2BHlGFFAjR0btz7JB",
    genre: "dutch hip hop",
    popularity: "31",
  },
  {
    name: "Lazy Rich",
    image: "https://i.scdn.co/image/4c06617ab34584845395c748add4d02bc96ae61b",
    spotify: "2kzHE6VuSE8S4PTIjBQfM5",
    genre: "complextro,electro house,melbourne bounce",
    popularity: "31",
  },
  {
    name: "Night Bass",
    image: "https://i.scdn.co/image/d584a8ab883b1c2f721cd1c1458236efda86b7f2",
    spotify: "5r8uFFa8SgWYY9otnRmLlw",
    genre: "bass house,electro house",
    popularity: "31",
  },
  {
    name: "Arnej",
    image: "https://i.scdn.co/image/23f0b11665fb20139a4d50278e19666d2acdb1b2",
    spotify: "2h6LBe1v9fSvc62fYum0CA",
    genre: "progressive house,trance,uplifting trance",
    popularity: "31",
  },
  {
    name: "Ryan Sheridan",
    image: "https://i.scdn.co/image/6e66cca7a14b374e80e61d1531fb139be7d7af8a",
    spotify: "2kIKzdNBjtzSRxXrfkWi1R",
    genre: "irish rock",
    popularity: "31",
  },
  {
    name: "Donkey Rollers",
    image: "https://i.scdn.co/image/84f622fbc65c534e8be94c4b837d8589b675179f",
    spotify: "42B9mEQV8cJNFLMtU8RTvR",
    genre: "classic hardstyle,rawstyle",
    popularity: "31",
  },
  {
    name: "Kangding Ray",
    image: "https://i.scdn.co/image/9dbcf9ec37a0182508ecd6cf745b56619e89f7f1",
    spotify: "20UWNE4rEU7YMO0GHq4F26",
    genre: "dub techno,glitch,mandible,microhouse",
    popularity: "31",
  },
  {
    name: "Tiefschwarz",
    image: "https://i.scdn.co/image/4fb3a11dc73f58267b20578a16db250ff379015d",
    spotify: "6f2k5CwVLvTy0rgw6Q8B4Q",
    genre: "german house,german techno,microhouse,minimal techno,tech house",
    popularity: "31",
  },
  {
    name: "Nastia",
    image: "https://i.scdn.co/image/bf6f54f5fbc5ead18d0eade8246fbe9471334cec",
    spotify: "6AV6IkyeHw74Dw7STTfY27",
    genre: "malaysian indie,malaysian pop",
    popularity: "31",
  },
  {
    name: "Ruede Hagelstein",
    image: "https://i.scdn.co/image/190a194f8b4baa0f663dae8707802ca5d49e4561",
    spotify: "49VV6EX7Tz4JNKeimVEoxQ",
    genre: "german house,german techno",
    popularity: "31",
  },
  {
    name: "KAKU",
    image: "https://i.scdn.co/image/23a15ad74542836c23e435639a24de6bc06e7fbc",
    spotify: "1Cw0X67YSU7ugUFyPPd8mr",
    genre: "",
    popularity: "31",
  },
  {
    name: "Joe Ghost",
    image: "https://i.scdn.co/image/7ef5c7179a0cf7c53ff83e0d1e668f8c50f2289b",
    spotify: "2hsDR10j6idVS8ZNc3Lg4p",
    genre: "canadian electronic",
    popularity: "31",
  },
  {
    name: "Alex Agnew",
    image: "https://i.scdn.co/image/ab67616d0000b2731b34369fc61fe2499636604b",
    spotify: "45vCZAnHti5gj6EmGZ12PR",
    genre: "vlaamse cabaret",
    popularity: "31",
  },
  {
    name: "Oum Shatt",
    image: "https://i.scdn.co/image/ab67616d0000b273e5d07a7b3fe78993923080e4",
    spotify: "3lQXHxiyVJnxHfRznEpgAT",
    genre: "german alternative rock",
    popularity: "31",
  },
  {
    name: "Bit Funk",
    image: "https://i.scdn.co/image/c99c313d8b29762049007b7f4b540fe287258dcd",
    spotify: "3QzHXIuwKTQzOhgA3F8mN1",
    genre: "",
    popularity: "31",
  },
  {
    name: "Lostly",
    image: "https://i.scdn.co/image/84629e3b418945fc8618fd8ac77ce9556922a96e",
    spotify: "39YXQGcflynecg2L3APfqf",
    genre: "uplifting trance",
    popularity: "31",
  },
  {
    name: "De Likt",
    image: "https://i.scdn.co/image/da667627428e340b35bafff5f52fdcc8fc3fe55a",
    spotify: "6gts99IY4QwNnrXNkh7Gr3",
    genre: "dutch rock,rotterdam indie",
    popularity: "31",
  },
  {
    name: "Ian Thomas",
    image: "https://i.scdn.co/image/4abfd83bcae1e0e6100e1d30be860ffee2661e0f",
    spotify: "0z4w0e7EPjD6Mxi1jPPIiu",
    genre: "",
    popularity: "31",
  },
  {
    name: "Oscar Danielson",
    image: "https://i.scdn.co/image/c9b66b1ae4cc735078ea1ca3a96ff7222b4393b9",
    spotify: "1MrlpnrM5jFgwSqYwul5HY",
    genre: "swedish singer-songwriter",
    popularity: "31",
  },
  {
    name: "Shannon McNally",
    image: "https://i.scdn.co/image/66d107226e6b7e59aca26d75d9e4b784bca3660a",
    spotify: "7MnItka0A4PsGNVzO7Ad0T",
    genre:
      "alternative americana,alternative country,folk,lilith,new americana",
    popularity: "31",
  },
  {
    name: "JB Meijers",
    image: "https://i.scdn.co/image/d746d82cfd6a9d63512df1a755625d3065b926a3",
    spotify: "1uKhiQS1fHFh3VUBR5cm75",
    genre: "",
    popularity: "31",
  },
  {
    name: "Essaie Pas",
    image: "https://i.scdn.co/image/cd4aa6373ce5fb0ee8742027ef089d7046ff2161",
    spotify: "2yNAWB78hJG1gSrodV5QSP",
    genre: "dark post-punk,grave wave,minimal wave",
    popularity: "31",
  },
  {
    name: "Eric Steckel",
    image: "https://i.scdn.co/image/811f342279e91de58aa2f0cbcd8deb194bd07b29",
    spotify: "1Nszrfn8SpD5v19xCpaVbk",
    genre: "modern blues,modern blues rock,power blues-rock",
    popularity: "31",
  },
  {
    name: "Cory Branan",
    image: "https://i.scdn.co/image/f6b2c6a52734dbdb6910c6231eb94d8a582ab09e",
    spotify: "0uzmoK3E1j2Cvl9XkFs1JR",
    genre: "alternative country,anti-folk,memphis indie,roots rock",
    popularity: "31",
  },
  {
    name: "New Madrid",
    image: "https://i.scdn.co/image/3734d15c17e1f3fe34057931c14b8bf0d228cb13",
    spotify: "0jaTIcOjgmYpF1sfudFAsW",
    genre: "",
    popularity: "31",
  },
  {
    name: "Shiraz Lane",
    image: "https://i.scdn.co/image/8ca6df95d49adec89d1814ff0ea029c7974aa48b",
    spotify: "0TTu3zbvW4iFfls1GDbyGk",
    genre:
      "finnish hard rock,finnish power metal,new wave of glam metal,sleaze rock",
    popularity: "31",
  },
  {
    name: "Kita Menari",
    image: "https://i.scdn.co/image/ad19152d48ee068a33d530bbb5ada808f37dd327",
    spotify: "1noOoapXyyCG1nYTH436qw",
    genre: "",
    popularity: "31",
  },
  {
    name: "Oysterband",
    image: "https://i.scdn.co/image/d37bdaaa27f85e97c2a9e9fdd166ca1de2fa9051",
    spotify: "4qL0mXWhInJHho86HqOEn7",
    genre: "british folk,celtic rock,traditional british folk",
    popularity: "31",
  },
  {
    name: "Death Before Dishonor",
    image: "https://i.scdn.co/image/ab67616d0000b27327137d336160bfce67e983e7",
    spotify: "0BIBoMLD3B0gptcCP0b9K5",
    genre: "beatdown,boston hardcore,hardcore,straight edge",
    popularity: "31",
  },
  {
    name: "Quivver",
    image: "https://i.scdn.co/image/b763145f16c49612d30ea5a27a5d05294058c6d0",
    spotify: "1LhfSHiX3eOHTjTLVfhYGD",
    genre: "classic progressive house,tech house",
    popularity: "31",
  },
  {
    name: "La Mambanegra",
    image: "https://i.scdn.co/image/90a71939ba9e31ef45fa4d04737002c86d356ad6",
    spotify: "1TCrJDPaqtcTkAEcSl0kBZ",
    genre: "folclor afrocolombiano",
    popularity: "31",
  },
  {
    name: "Steve Lawler",
    image: "https://i.scdn.co/image/c284bf25aaab97224aae3b3c6b2b48adea1e0d9e",
    spotify: "0NDuRCSLSH0Ii5An4U6HME",
    genre: "tech house,tribal house",
    popularity: "31",
  },
  {
    name: "Curly Strings",
    image: "https://i.scdn.co/image/ab67616d0000b2730dd9de83445f3c58fb91a231",
    spotify: "6HI8rcJysSSJjctsRIwMub",
    genre: "estonian folk,estonian pop,estonian rock",
    popularity: "31",
  },
  {
    name: "Pattern Drama",
    image: "https://i.scdn.co/image/a4696e52b133d98f8d09877c1f769eb7a3dd9256",
    spotify: "0NOTKMhONUvL0OVDCRVCdW",
    genre: "organic electronic",
    popularity: "31",
  },
  {
    name: "Impala Ray",
    image: "https://i.scdn.co/image/bb4ff887c8d97ac2585d28dd0effb7dc726eaca1",
    spotify: "7zfWvoQrsXPCmJVVneRxub",
    genre: "german indie,munich indie",
    popularity: "31",
  },
  {
    name: "Geck-O",
    image: "https://i.scdn.co/image/a560e9603b851f1c0a180730e86095350b8c1c7b",
    spotify: "5TfuDjIGoKIDy1c7l0DBsB",
    genre: "classic hardstyle,rawstyle",
    popularity: "31",
  },
  {
    name: "Kai Schumacher",
    image: "https://i.scdn.co/image/4ed6f5a2292a5f3633d255676ea805d4745bb4e7",
    spotify: "1eLXOYXUMsXM6BSDibcJ7A",
    genre: "neo-classical",
    popularity: "31",
  },
  {
    name: "Caleb Elliott",
    image: "https://i.scdn.co/image/d8238ff391a7928d88f6c8dcdb8eddd9ba9d00bd",
    spotify: "0ubsTbLcwOTtBgs9AqYafk",
    genre: "indie folk,lafayette indie",
    popularity: "31",
  },
  {
    name: "GOSTO",
    image: "https://i.scdn.co/image/662b341f7f7e613251d7914eea84b36ce8c5d336",
    spotify: "5CEZ2102fh2JlfPrsBdSeJ",
    genre: "dutch pop",
    popularity: "31",
  },
  {
    name: "John F.M.",
    image: "https://i.scdn.co/image/ab67616d0000b2736080caeb9db126a4284e17b0",
    spotify: "0vscEUhV9isTMclPcVz7zr",
    genre: "detroit house",
    popularity: "31",
  },
  {
    name: "Rummelsnuff",
    image: "https://i.scdn.co/image/f5132195404e1df81caed906d53154228d23e0c6",
    spotify: "0DxIuWeKbaYIMxkZKxyC9Y",
    genre: "",
    popularity: "31",
  },
  {
    name: "Exploded View",
    image: "https://i.scdn.co/image/ab6772690000c46c5bba79be560202ebe166f003",
    spotify: "4NE1CVLnv7AmiqvU4w1kUQ",
    genre: "chamber psych,garage psych,german shoegaze,neo-kraut",
    popularity: "31",
  },
  {
    name: "Martha Tilston",
    image: "https://i.scdn.co/image/99404d5536eaded9add54f0905b542b75c806f58",
    spotify: "7qYuquYwhkc9HEa9tV3QXM",
    genre: "cornwall indie",
    popularity: "31",
  },
  {
    name: "Harvey McKay",
    image: "https://i.scdn.co/image/ab67616d0000b273161b1ed915673bca553f02fe",
    spotify: "6qB9lDPQ6tFbI1gZcSawCS",
    genre: "deep minimal techno,scottish techno,tech house",
    popularity: "31",
  },
  {
    name: "Corridor",
    image: "https://i.scdn.co/image/28ae514ae1d32d131346c65ba26ae13f8598677b",
    spotify: "4nn9uUq4K1vStqxe8t1CD4",
    genre: "garage psych,indie quebecois",
    popularity: "31",
  },
  {
    name: "KMLN",
    image: "https://i.scdn.co/image/3e078d678c2afc1fea46595df0d739181055b727",
    spotify: "1BtFGRlmJS53FJaX8ESSS7",
    genre: "ethnotronica,organic house",
    popularity: "31",
  },
  {
    name: "Djeckman",
    image: "https://i.scdn.co/image/d42407b426a3a762b181a5694b866c796a0b4173",
    spotify: "0sOfQJh2Cgr8Uak5F6dO0F",
    genre: "",
    popularity: "31",
  },
  {
    name: "Thomas Datt",
    image: "https://i.scdn.co/image/ab67616d0000b2734093967202451462cf8d2283",
    spotify: "6tYu6xSFpTZDKewbIrhhV3",
    genre: "",
    popularity: "31",
  },
  {
    name: "King Britt",
    image: "https://i.scdn.co/image/0a3bf345ed18eaa69e7886ec7be9399b1497d3f8",
    spotify: "3dLfgaGJjjkkF1OUNiEput",
    genre: "broken beat",
    popularity: "31",
  },
  {
    name: "LunaKorpz",
    image: "https://i.scdn.co/image/abaef43d5886e6a531531952db918b72993bc9bd",
    spotify: "2OSIL8pcABTROov8XT74z1",
    genre: "uptempo hardcore",
    popularity: "31",
  },
  {
    name: "Jungle Brown",
    image: "https://i.scdn.co/image/10b0023d17aeed227c5bfd32155e8f818afdc8a5",
    spotify: "6bhnsbtlnSzYIRPkHrKe3I",
    genre: "uk alternative hip hop",
    popularity: "31",
  },
  {
    name: "Kayhan Kalhor",
    image: "https://i.scdn.co/image/a42b1a2d28a614f4926020538e45476bde66167a",
    spotify: "5sarhkyrBmQFnOJe2HrMBH",
    genre:
      "arab folk,oriental classical,persian neo-traditional,persian traditional",
    popularity: "31",
  },
  {
    name: "Project Core",
    image: "https://i.scdn.co/image/edb52e8b77e4373c58fa188dbe770041832af2a0",
    spotify: "16cCEbmSAybTJMb5epEDoL",
    genre: "",
    popularity: "31",
  },
  {
    name: "Remy Cooper",
    image: "https://i.scdn.co/image/9378e34207f81130914906889d7ba721e2103a2d",
    spotify: "3beQclZ0k710Qmxs6gYxdI",
    genre: "",
    popularity: "31",
  },
  {
    name: "Marangoni",
    image: "https://i.scdn.co/image/adcd27c7bd4069a2adbe32e2bd0892801ecf09c6",
    spotify: "5faKs5WlfWr7iJdsT6TV7L",
    genre: "",
    popularity: "31",
  },
  {
    name: "Strife",
    image: "https://i.scdn.co/image/ab67616d0000b273355036ae2abe614ac3f2d096",
    spotify: "68qsduRCs8caw95bbF4IDD",
    genre: "hardcore,melodic hardcore,straight edge,vegan straight edge",
    popularity: "31",
  },
  {
    name: "C.Vogt",
    image: "https://i.scdn.co/image/36f08f72303180eeeb8370a7ded9961d59529766",
    spotify: "2XF2p5UcFOtNOB7vj45zEG",
    genre: "",
    popularity: "31",
  },
  {
    name: "Blank Range",
    image: "https://i.scdn.co/image/583db8edd33251c3306cd256b65727366be41d7d",
    spotify: "4TKZQfojfl4wUDO3Mql65t",
    genre: "deep new americana",
    popularity: "31",
  },
  {
    name: "Perto",
    image: "https://i.scdn.co/image/92f10bb1838ca29fe4f015e361105e06598c6ace",
    spotify: "2mJFvqmuu604a4BwGllJQV",
    genre: "",
    popularity: "31",
  },
  {
    name: "Dan Sartain",
    image: "https://i.scdn.co/image/4797a9c47d2017823875ff8e4c3fe8907ea2fefb",
    spotify: "6AZ4TQhtH9GsoTFe2CxR2n",
    genre: "alabama indie,punk blues",
    popularity: "31",
  },
  {
    name: "Blaine Stranger",
    image: "https://i.scdn.co/image/6f44ee7e360adb9387646a578623017a1adeaf67",
    spotify: "4ZKZR4BBx5EaP4T3slUd1j",
    genre: "",
    popularity: "31",
  },
  {
    name: "La Fleur",
    image: "https://i.scdn.co/image/657c0e12fabef9168ec768d08fe650175ca613f0",
    spotify: "5bt7DkWw4iHzjzRF2d9scU",
    genre: "swedish electronic,swedish techno",
    popularity: "31",
  },
  {
    name: "DJ Wout",
    image: "https://i.scdn.co/image/10b47ea8ae5cbab76d224b12a0342b7a326a5b94",
    spotify: "4DoFxXS61UmzqXU629KVyK",
    genre: "belgian dance",
    popularity: "31",
  },
  {
    name: "Stephen Steinbrink",
    image: "https://i.scdn.co/image/6b0cb221e7ad733f6bb74d73ee104ea0a82e7d96",
    spotify: "5i74r8NAl9N4v6S3C9mgcc",
    genre: "",
    popularity: "31",
  },
  {
    name: "Osiah",
    image: "https://i.scdn.co/image/b2ada7290865141ac5bc3a8ca964a9f085452cf9",
    spotify: "4zdj6e05Eh8uLVJ6V0V3Mu",
    genre: "deathcore,progressive deathcore,slamming deathcore",
    popularity: "31",
  },
  {
    name: "AnGy KoRe",
    image: "https://i.scdn.co/image/47927c53b0364e7dc373f3d44d278b5ba29287dc",
    spotify: "2U8kmpV72r6o2i2wEJMgE5",
    genre: "dark techno,deep minimal techno,italian techno,tech house",
    popularity: "31",
  },
  {
    name: "Pieter Derks",
    image: "https://i.scdn.co/image/ab67616d0000b273f84949c0fed5368be0c98088",
    spotify: "4JwlHUgIACGdCcQ3lPZTJr",
    genre: "dutch cabaret",
    popularity: "30",
  },
  {
    name: "Girls Love DJs",
    image: "https://i.scdn.co/image/3b4f87007ae5eb054395ff07b2efd95e23f342ab",
    spotify: "7jree1A6l62YSZ7CHqWZ7q",
    genre: "",
    popularity: "30",
  },
  {
    name: "Dani L. Mebius",
    image: "https://i.scdn.co/image/237a20a3ded6a319987df47a2cb5a86379b9348b",
    spotify: "7ngc403KEvIhqq8rliTPgL",
    genre: "",
    popularity: "30",
  },
  {
    name: "Lady Dammage",
    image: "https://i.scdn.co/image/505ba0bcbd272e982dcc2d2146708671b1e612c5",
    spotify: "3tfuR1hlhOuwBVYzl8dgKE",
    genre: "uptempo hardcore",
    popularity: "30",
  },
  {
    name: "De Sluwe Vos",
    image: "https://i.scdn.co/image/bfa475feecc71e69cbda36514c4242fec306cf66",
    spotify: "6NOaZCnZyowwJiTHbh5dLS",
    genre: "dutch experimental electronic",
    popularity: "30",
  },
  {
    name: "Daniel Karlsson Trio",
    image: "https://i.scdn.co/image/ace1c0a3b5c1cb2a460fea7437162a3724405227",
    spotify: "050olItM6cAiBVEMYC6LQf",
    genre: "swedish jazz",
    popularity: "30",
  },
  {
    name: "Echonomist",
    image: "https://i.scdn.co/image/1b30184a2c5db1a5e502ca9dd03fb02593f8f3d5",
    spotify: "3ujc8l2JVYwGgAPU7KRRl3",
    genre: "greek house,minimal tech house",
    popularity: "30",
  },
  {
    name: "Klubfiller",
    image: "https://i.scdn.co/image/a3b86a5a1742cd42edf36515a6a741b373da1a86",
    spotify: "21CTwCPVk35jNlil50YBJZ",
    genre: "bouncy house,deep happy hardcore,hard house",
    popularity: "30",
  },
  {
    name: "Davoodi",
    image: "https://i.scdn.co/image/39eefc85151fac1bb3685a44a7a81fe9f54f046d",
    spotify: "4Y7wFA5vt2yDW5hbuQSe61",
    genre: "jumpstyle",
    popularity: "30",
  },
  {
    name: "Kimyan Law",
    image: "https://i.scdn.co/image/9c2a3d9a54461e8d3642fecf55f5e919ad49ce59",
    spotify: "4qstV1aoIFSc0eP8imUZQA",
    genre: "austrian dnb,minimal dnb",
    popularity: "30",
  },
  {
    name: "Mr. Wonder",
    image: "https://i.scdn.co/image/ec7045bbaf879825d52777837e7947f96d681238",
    spotify: "4QiglTK7nIOcmayUS1d5XM",
    genre: "",
    popularity: "30",
  },
  {
    name: "Genius Of Time",
    image: "https://i.scdn.co/image/d47d719a638f49cf6f9c156b0c0f983a79744e2d",
    spotify: "1PyOgBv0gb5p75Y6iS6uM2",
    genre: "deep soul house,float house,swedish electronic,swedish house",
    popularity: "30",
  },
  {
    name: "FLING",
    image: "https://i.scdn.co/image/590178d5f132f85730a3bfcf2005486f6542cf3c",
    spotify: "7CF3sdtLggXXGXrsCX8veH",
    genre: "english indie rock,leeds indie,west yorkshire indie",
    popularity: "30",
  },
  {
    name: "In-Phase",
    image: "https://i.scdn.co/image/dcaa33c1f502235ae8af02b31ccfe04dac964ca6",
    spotify: "52HrdVaG2eVCSWx762WoKi",
    genre: "classic hardstyle,rawstyle",
    popularity: "30",
  },
  {
    name: "Lost Identity",
    image: "https://i.scdn.co/image/f11cfca5c640213aeb9ffb5c2a2e231be830df64",
    spotify: "5jZCC6U5CO2Ta3JHZIgh8h",
    genre: "",
    popularity: "30",
  },
  {
    name: "Lucille Croft",
    image: "https://i.scdn.co/image/e7ba6ff294e4063a7c8564b6da94bd33ad719963",
    spotify: "270fGluVXrZVyTNECXbrsy",
    genre: "",
    popularity: "30",
  },
  {
    name: "Kids by Nature",
    image: "https://i.scdn.co/image/e853366cfacaf4faa18c086aca90761c76fd5407",
    spotify: "51golTkJ20Iz8lWidVoM0h",
    genre: "",
    popularity: "30",
  },
  {
    name: "Matthew Logan Vasquez",
    image: "https://i.scdn.co/image/28414efaf690f1465291abfcf0d442015bb2ca43",
    spotify: "4ndN8LWSsLWQqbWVJD8miG",
    genre: "modern folk rock",
    popularity: "30",
  },
  {
    name: "Leo Pol",
    image: "https://i.scdn.co/image/25107239830aef28df26f82253170fae8b9cb303",
    spotify: "2PBE0KQEqT34oYjjFyI9Mz",
    genre: "",
    popularity: "30",
  },
  {
    name: "Jungle Boogie",
    image: "",
    spotify: "4uRUX6GQjNbtYK9w0rbO4J",
    genre: "",
    popularity: "30",
  },
  {
    name: "The Yawpers",
    image: "https://i.scdn.co/image/c71c5a7c269a614fbd098d35e963e298cde6dde4",
    spotify: "6MYRV74tUjBf9X4PwTRykW",
    genre: "",
    popularity: "30",
  },
  {
    name: "Cordovas",
    image: "https://i.scdn.co/image/f3c205a2797e0694077fff2f5f2d77d8a5182274",
    spotify: "1wWSNOst6HSnNNUtH4RekE",
    genre: "deep new americana",
    popularity: "30",
  },
  {
    name: "Marie Bergman",
    image: "https://i.scdn.co/image/ab67616d0000b27337c645c7ba1461a423c32b68",
    spotify: "1EF9hLul0ZZcbh7dmXWF99",
    genre: "classic swedish pop",
    popularity: "30",
  },
  {
    name: "Fat Sushi",
    image: "https://i.scdn.co/image/02b891c41519422ab42fc6c0a32f26e4883a2ea0",
    spotify: "1ZEy8yuRy9R9NU42wWqgy7",
    genre: "swiss house",
    popularity: "30",
  },
  {
    name: "Midas 104",
    image: "https://i.scdn.co/image/d33a4ed7f04ebee9718e5de14ce1f7e1e6101d9d",
    spotify: "0DA55Vzg7t4Vl2tKXspXjX",
    genre: "",
    popularity: "30",
  },
  {
    name: "BRUUT!",
    image: "https://i.scdn.co/image/280676be217ad96f31e439dff15061824a0cb80e",
    spotify: "1z5i6osuIDbkLptD9f4gjh",
    genre: "dutch jazz",
    popularity: "30",
  },
  {
    name: "Coeus",
    image: "https://i.scdn.co/image/d15e1f0322185ca9a7b7148dfe257e60e2cbd729",
    spotify: "7yibHBJHi3LZD0uvWAdyya",
    genre: "serbian electronic",
    popularity: "30",
  },
  {
    name: "Masayoshi Fujita",
    image: "https://i.scdn.co/image/a50cf399a9e6326a18d647dc7aa1a4fa8c5b0e9d",
    spotify: "6rp6bzwzVN7UtQVO6ld2vT",
    genre: "ambient,experimental ambient,fourth world,j-ambient",
    popularity: "30",
  },
  {
    name: "MorningMaxwell",
    image: "https://i.scdn.co/image/a349378ffddd5fae56075571bc16d40a00ec110a",
    spotify: "0kvwtYUiypCDaaKKhTD2Pp",
    genre: "",
    popularity: "30",
  },
  {
    name: "Thugfucker",
    image: "https://i.scdn.co/image/214bf97a63241bd9dd7b73af3ea1f1f144d60fe7",
    spotify: "4qSSSfXZFYYw5hU5ywxMcP",
    genre: "deep disco house",
    popularity: "30",
  },
  {
    name: "Ciszak",
    image: "https://i.scdn.co/image/184c03c26868448145e78157dcab69fb62908b3c",
    spotify: "6lf5XKHZHGXxHFPOKSkodA",
    genre: "",
    popularity: "30",
  },
  {
    name: "Wolf + Lamb",
    image: "https://i.scdn.co/image/c73d005085f9a9f0f4675424779b668d1e1cc492",
    spotify: "6HGrNLNAYp8B1B84tLNKH0",
    genre: "",
    popularity: "30",
  },
  {
    name: "Joseph Huber",
    image: "https://i.scdn.co/image/ab67616d0000b273bb3d486d4ebc3391523215b7",
    spotify: "2pzKzgyZZdp2u8e8r3T1qa",
    genre:
      "garage punk blues,gothic americana,midwest americana,milwaukee indie,roots americana",
    popularity: "30",
  },
  {
    name: "Hardfloor",
    image: "https://i.scdn.co/image/67c96a01be9de63ca8417579042e26c5597459a3",
    spotify: "6z9JhbmcTrVKITp9ah4mJk",
    genre:
      "acid house,acid trance,dusseldorf electronic,german techno,minimal techno,techno",
    popularity: "30",
  },
  {
    name: "Grimix",
    image: "https://i.scdn.co/image/7371cd353e706bf3e7d1beb143b4008ea02da970",
    spotify: "29NIvby6mXbv2rirvtYr6a",
    genre: "",
    popularity: "30",
  },
  {
    name: "Massimiliano Pagliara",
    image: "https://i.scdn.co/image/0c6e716887208805a97728828a025346e48b00ea",
    spotify: "6rr6POhpIL25CJFS3o3Dym",
    genre: "balearic,float house",
    popularity: "30",
  },
  {
    name: "Lenny Dee",
    image: "https://i.scdn.co/image/44e5b8f879f2f58d4ebf4fd67b39edc27b2bf296",
    spotify: "33O0lHsxKb6No0NBuFxFbR",
    genre: "gabba,happy hardcore,hardcore techno,industrial hardcore,speedcore",
    popularity: "30",
  },
  {
    name: "JaySounds",
    image: "https://i.scdn.co/image/0a392dacd51ba6527213fd8c120a6342ac2be72c",
    spotify: "7Cye4LP81AKTIKgABMgmUY",
    genre: "",
    popularity: "30",
  },
  {
    name: "Asquith",
    image: "https://i.scdn.co/image/eff1430fdb7431ca18dbbfc8ce1766d60457ad86",
    spotify: "43fmnXKQExCZ0KyHTKwkXv",
    genre: "breaks",
    popularity: "30",
  },
  {
    name: "M.I.K.E. Push",
    image: "https://i.scdn.co/image/b1c4a417364d5dd300c370e8bbd4773d4ca75c19",
    spotify: "1FLWivyoqKrhsxokChtUnI",
    genre: "uplifting trance",
    popularity: "30",
  },
  {
    name: "Wenzday",
    image: "https://i.scdn.co/image/1b4437b9714f4a0191de425a734e9c1ac4bee40d",
    spotify: "1TOclxL64oLeB45DFWFFU2",
    genre: "",
    popularity: "30",
  },
  {
    name: "Koen Kardashian",
    image: "https://i.scdn.co/image/ab67616d0000b273762b3d4f09b87651711d7d28",
    spotify: "7I38FSfG2MNfRmpCSKzUPJ",
    genre: "",
    popularity: "30",
  },
  {
    name: "Jef Neve",
    image: "https://i.scdn.co/image/dc183592b467a194227c2ecf96f46ac6c07e2c8e",
    spotify: "5drkbPiwHU6Kzh1wzYwMAl",
    genre: "belgian modern jazz,belgian rock",
    popularity: "30",
  },
  {
    name: "Herborg Kråkevik",
    image: "https://i.scdn.co/image/e0fe0e2743f89eebdf282244b2a8753706f7d65c",
    spotify: "5uvwGfXbw7uUF9JI0KqKK5",
    genre: "classic norwegian pop",
    popularity: "30",
  },
  {
    name: "Sterre Koning",
    image: "https://i.scdn.co/image/a6c6818c1e5c4e46b601b540e39ab4ec3b21eb19",
    spotify: "3vE2dQ30qWbC54d4K93zlB",
    genre: "",
    popularity: "30",
  },
  {
    name: "Leroy Styles",
    image: "https://i.scdn.co/image/7267cee5b21db9d142d1d3c78427744c2e79774c",
    spotify: "2MoxYOhy9ooC8KRcdgIFif",
    genre: "dutch edm",
    popularity: "30",
  },
  {
    name: "Jonny Fritz",
    image: "https://i.scdn.co/image/4d62bd64a59d9a51554e35fd782af476f8449644",
    spotify: "0dfNZ0xBHU3UipMv5gn9Se",
    genre: "alternative country",
    popularity: "30",
  },
  {
    name: "Orange Grove",
    image: "https://i.scdn.co/image/28b3b984a4c9494409f36f35aa49bd6388320ccc",
    spotify: "1OUTOOUK6WFuwXEIGjT1wx",
    genre: "reggae rock",
    popularity: "30",
  },
  {
    name: "Prins Emanuel",
    image: "https://i.scdn.co/image/ab67616d0000b2736206e691e4092d070e37c212",
    spotify: "1xR6udumbq1hdmMeTKgLUz",
    genre: "malmo indie",
    popularity: "30",
  },
  {
    name: "Brian Deady",
    image: "https://i.scdn.co/image/5f919f88cc038897a309163d434ce9a7bda0c175",
    spotify: "4CMT1do3m86rMAlPUmvGbG",
    genre: "irish pop",
    popularity: "30",
  },
  {
    name: "Bart Claessen",
    image: "https://i.scdn.co/image/f4991bb603c7f5fb05cf3f59b5a073638ffb94be",
    spotify: "6E5ESwox3QUQ4ewUKo9D2c",
    genre: "dutch trance",
    popularity: "30",
  },
  {
    name: "Anfisa Letyago",
    image: "https://i.scdn.co/image/d477671afefd7a937b5c077333c90b25158eb08c",
    spotify: "7icoOm5fKKPo49jVxoj1Cq",
    genre: "",
    popularity: "30",
  },
  {
    name: "Negative Approach",
    image: "https://i.scdn.co/image/ab67616d0000b2735876aee573cf5bf4581c32c2",
    spotify: "1DijMV2W1I2CfGLcarzgav",
    genre:
      "crust punk,hardcore,hardcore punk,powerviolence,punk,straight edge,thrash core",
    popularity: "30",
  },
  {
    name: "Chance McCoy",
    image: "https://i.scdn.co/image/d6bb1181e5e4584e6622be6983a4998b0eef7f1d",
    spotify: "4VcDjGUnE1kwHbsWnvlgya",
    genre: "string band",
    popularity: "30",
  },
  {
    name: "Rony Seikaly",
    image: "https://i.scdn.co/image/74ea20d680c34e59a720725732c692401aa32da2",
    spotify: "4AcGuUg7odrpcPUlrHGezB",
    genre: "",
    popularity: "30",
  },
  {
    name: "Mokoomba",
    image: "https://i.scdn.co/image/1e65b8528a0eec4218f1f2f2dbf9009c6af0cc51",
    spotify: "4JWMsMMZQJX6ZqNMdBiN9I",
    genre: "afropop,zim urban groove",
    popularity: "30",
  },
  {
    name: "Audrey Horne",
    image: "https://i.scdn.co/image/3aa1bf0744ec3b05c0ac1c16866593d072b05273",
    spotify: "7HudjH2VxKdpK8nj2U6yls",
    genre: "norwegian rock",
    popularity: "30",
  },
  {
    name: "Maximono",
    image: "https://i.scdn.co/image/dec35f9255defb22e5e3dabc9280feeaec742edd",
    spotify: "44j7GMM70cxzEZxW1C1BNA",
    genre: "bass house",
    popularity: "30",
  },
  {
    name: "Inhalt Der Nacht",
    image: "https://i.scdn.co/image/bf9b61c3c57e359385f280b2d2d4e75739a4a656",
    spotify: "0rCDBsRMdD2jIAnAf6kbaL",
    genre: "industrial techno,minimal dub",
    popularity: "30",
  },
  {
    name: "Havok Roth",
    image: "https://i.scdn.co/image/e45b9301871efeac5abbe031567960b5c29e8587",
    spotify: "1W5GDN3fdEbY5AORDcJhmK",
    genre: "",
    popularity: "30",
  },
  {
    name: "Rafael Frost",
    image: "https://i.scdn.co/image/f2630196f26e28be3dff2e382b01bc74f622625a",
    spotify: "4vK15XpJWMJwcgP3m5afsI",
    genre: "progressive trance",
    popularity: "30",
  },
  {
    name: "PHI NIX",
    image: "https://i.scdn.co/image/b2b2b95cfdf38384be0a4f0c3a1d799e203909aa",
    spotify: "5eAD22qkgKXFfoP2Z58lU6",
    genre: "",
    popularity: "30",
  },
  {
    name: "Taraf de Haidouks",
    image: "https://i.scdn.co/image/d7de09a10b6b961e652d15bbc003c1302171c704",
    spotify: "7uY0wFgVFV3koB6SwgZmCe",
    genre: "balkan brass,klezmer",
    popularity: "30",
  },
  {
    name: "Darlyn Vlys",
    image: "https://i.scdn.co/image/79f9aa900fc55cbe73c31807607f3f5a53a7974d",
    spotify: "0dpGnP2FznqTc0Ql0E8t2P",
    genre: "deep tech house",
    popularity: "30",
  },
  {
    name: "Jose De Mara",
    image: "https://i.scdn.co/image/f3f51fa3f4738e1bce421dda687b01a80615146a",
    spotify: "7ycNpmCg2CMaCLsOz830lV",
    genre: "",
    popularity: "30",
  },
  {
    name: "Invector",
    image: "https://i.scdn.co/image/d25c20d06a2d8393165f1f8eb623fc8e27caa1ea",
    spotify: "6dzkjHwlCSs5uy93DoiZ1s",
    genre: "hardstyle,rawstyle",
    popularity: "30",
  },
  {
    name: "Alex Niggemann",
    image: "https://i.scdn.co/image/aafe9b4a25775d27f6e9302ff73d030012e2c967",
    spotify: "3clivH1RzWPKKSPhG93ktR",
    genre: "german house,german techno,minimal tech house",
    popularity: "30",
  },
  {
    name: "SevenDoors",
    image: "https://i.scdn.co/image/f834ee6f45c3bb373a5203681be8158dfba69e47",
    spotify: "384y80ug9EcAhAJ0ZRxWKA",
    genre: "deep techno",
    popularity: "30",
  },
  {
    name: "Resonators",
    image: "https://i.scdn.co/image/203e1bee59e0b35006b619f4411d4ce800d066c7",
    spotify: "4j4hyyYOjmJk9Plz7ZaWv9",
    genre: "uk reggae",
    popularity: "30",
  },
  {
    name: "Balbina",
    image: "https://i.scdn.co/image/f20a1d3b409a3298b70a736f341408491168ad89",
    spotify: "4C1nbe81muNg5KuFNh6kxZ",
    genre: "german pop",
    popularity: "30",
  },
  {
    name: "Menno de Jong",
    image: "https://i.scdn.co/image/d6af7be7424f0279f868333e760b7dc4624b90ad",
    spotify: "7g8spsY118RkpEalwhUCYu",
    genre: "dutch trance,progressive house,trance,uplifting trance",
    popularity: "30",
  },
  {
    name: "Vizediktator",
    image: "https://i.scdn.co/image/0b2f47121abcc11ee16c513f41c9e1962ba2a1bc",
    spotify: "7nAIezZHjpkwNCHGbeOpnd",
    genre: "german punk rock",
    popularity: "30",
  },
  {
    name: "Chevrae",
    image: "https://i.scdn.co/image/bdde04ad5f36b10b8cc463122ff68a321cc96bd6",
    spotify: "4CUlAQczcXXqoaBLwWVmfa",
    genre: "",
    popularity: "30",
  },
  {
    name: "Phil Siemers",
    image: "https://i.scdn.co/image/cf12826dc5fb4bded4769dc5a9875b2e21ccbd17",
    spotify: "0tPhB66fGZ0X4G09f72Z8C",
    genre: "",
    popularity: "30",
  },
  {
    name: "MAN POWER",
    image: "",
    spotify: "1BczALpoK6DEtQOHNacr0N",
    genre: "",
    popularity: "30",
  },
  {
    name: "JORDY VAN LOON",
    image: "https://i.scdn.co/image/e7442ca4ce5e2926817e6b21eb5816764b2e0867",
    spotify: "2t2VuXDXvYK3prhPVTEY04",
    genre: "",
    popularity: "30",
  },
  {
    name: "DJ Haus",
    image: "https://i.scdn.co/image/aaae6d2e4763e7f9146561d72bac56b1d06e04eb",
    spotify: "6rcgwmnS7bnZBf7Tywp3fb",
    genre: "uk house",
    popularity: "30",
  },
  {
    name: "Congorock",
    image: "https://i.scdn.co/image/df38643fb5c6a44270bfc6769025d9a0108fef95",
    spotify: "683obsKtbyVNhitubjOZhi",
    genre: "electro house,fidget house",
    popularity: "30",
  },
  {
    name: "Lady Faith",
    image: "https://i.scdn.co/image/83c06494e14ba909891916e7da31428b2b5e47a0",
    spotify: "1va2Hj3SvWvu3L6jAN6k01",
    genre: "hardstyle",
    popularity: "30",
  },
  {
    name: "Steelism",
    image: "https://i.scdn.co/image/de0163968e497559cbc28948c37a02cd68a80240",
    spotify: "4vsRWAlRRT40g7LjHiUMco",
    genre: "nashville indie,steel guitar",
    popularity: "30",
  },
  {
    name: "BiXX",
    image: "https://i.scdn.co/image/64a4afd746fd90edbb055ebb5987699de1bf1e33",
    spotify: "4RiwBL7Ca5pV4qR7gRmEOh",
    genre: "",
    popularity: "30",
  },
  {
    name: "Holy Moly & The Crackers",
    image: "https://i.scdn.co/image/2bfc4999648537f8323210ea474ec05de6e88f90",
    spotify: "73Y01xwhmpeq2qq9KLaRFZ",
    genre: "newcastle indie",
    popularity: "30",
  },
  {
    name: "Sofiane Saidi",
    image: "https://i.scdn.co/image/ab67616d0000b2733e86715653713b1254f61cdf",
    spotify: "6VnkIRZde53ai5TtkMulr4",
    genre: "arab groove",
    popularity: "30",
  },
  {
    name: "Damian Twilt",
    image: "https://i.scdn.co/image/d77ec6164d5b35df4e1a9f14a2332ba162afac10",
    spotify: "5T90XhSYKnmw7heo4vqth0",
    genre: "",
    popularity: "30",
  },
  {
    name: "Omegatypez",
    image: "https://i.scdn.co/image/ab67616d0000b273006a35a5a8e502d2ad74f009",
    spotify: "15TjoFblYf6b1tYhfc6b9x",
    genre: "classic hardstyle,euphoric hardstyle,hardstyle,rawstyle",
    popularity: "30",
  },
  {
    name: "Blackburn",
    image: "https://i.scdn.co/image/ab67616d0000b27327cc73cedd1fbb7b620e290c",
    spotify: "1wvxlk5puIUEeOELqzD1Ia",
    genre: "",
    popularity: "30",
  },
  {
    name: "Frankie Lee",
    image: "https://i.scdn.co/image/5f3d30369ed3c8c1d132d8bf7c8dbb1d67d8bd14",
    spotify: "5YK4Q85VupOqHLBsYaeqoW",
    genre: "deep new americana",
    popularity: "30",
  },
  {
    name: "Adam Ellis",
    image: "https://i.scdn.co/image/e257f01f611fe7c7db46fb9f1d5fbe83bdb3b55a",
    spotify: "5tGHR2wsaFZhRzRPRZDFds",
    genre: "progressive uplifting trance,uplifting trance",
    popularity: "30",
  },
  {
    name: "Shirma Rouse",
    image: "https://i.scdn.co/image/ab67616d0000b27396d60dd493f363ce2c633f18",
    spotify: "1vNl797vEfGx0JnC1eFoH0",
    genre: "",
    popularity: "29",
  },
  {
    name: "Olivier Weiter",
    image: "https://i.scdn.co/image/f71a713dde54d9ae485669e6b846b707b3f54e6b",
    spotify: "32igBIB7PD2T5aJktoB3AS",
    genre: "dutch tech house",
    popularity: "29",
  },
  {
    name: "Secret Cinema",
    image: "https://i.scdn.co/image/bc3e6ebe9f2b93362c07db4a4ff359370976d68a",
    spotify: "6TrT2n9RVox8c9xpffVKyW",
    genre: "german techno",
    popularity: "29",
  },
  {
    name: "Jeffrey Sutorius",
    image: "https://i.scdn.co/image/34a7d198dc308f4cf416793b136fda96f3ff96fc",
    spotify: "2XGg454n1pSdgoqrfcSDbq",
    genre: "",
    popularity: "29",
  },
  {
    name: "Jeroen van Merwijk",
    image: "https://i.scdn.co/image/ab67616d0000b273b8dcbf4ebeb0e7e6ae77ccbf",
    spotify: "41Nu12xhdoHQIxSbqHO2cr",
    genre: "dutch cabaret",
    popularity: "29",
  },
  {
    name: "Dawn Brothers",
    image: "https://i.scdn.co/image/626210c846e89f57dbb96e6117bbaf4c2e930548",
    spotify: "05vyC7M8P5Wr120O1yTv6a",
    genre: "dutch americana,dutch blues,dutch indie,dutch rock,rotterdam indie",
    popularity: "29",
  },
  {
    name: "MATRiXXMAN",
    image: "https://i.scdn.co/image/882d710226ca8d0f214e667ea772dd342b305a5e",
    spotify: "2KYGpc3Hn1KG7uw7CxQB2y",
    genre: "minimal dub",
    popularity: "29",
  },
  {
    name: "Dansado & De Feestneger",
    image: "https://i.scdn.co/image/82c4b8042e101f988f939b4a18eee34d783cfd39",
    spotify: "0haZFq0wo6mrHxEqO2wsRr",
    genre: "",
    popularity: "29",
  },
  {
    name: "Stephanie Struijk",
    image: "https://i.scdn.co/image/fd826cf91c2472b6eac8eee002f5d62f31522da0",
    spotify: "2D2KkoPYCe9SDUQwp6G8ff",
    genre: "dutch pop,dutch singer-songwriter",
    popularity: "29",
  },
  {
    name: "Milo Spykers",
    image: "https://i.scdn.co/image/08ea97112312a04f1cce55c719dda722dbc739b7",
    spotify: "3FGLVtY3sNKFgkkmQ05AXl",
    genre: "belgian techno,raw techno",
    popularity: "29",
  },
  {
    name: "Joey Riot",
    image: "https://i.scdn.co/image/0c48c42cd0058520dacb0152b7f7b6d86c9d16d8",
    spotify: "3xKGhixeP24bKwHQ7yPyXF",
    genre: "bouncy house,happy hardcore,hardcore techno",
    popularity: "29",
  },
  {
    name: "Jennifer Cardini",
    image: "https://i.scdn.co/image/6abc4f92c2e88a3a96cd071d16d4a9dfdfd6342e",
    spotify: "3AN049igIAaoX0fjTCkpnf",
    genre: "french techno",
    popularity: "29",
  },
  {
    name: "Colin Benders",
    image: "https://i.scdn.co/image/2b5fae6b7a1a6754d049510a726aac39454b081c",
    spotify: "0InPKJ21u1TMt0hzF1Y4wz",
    genre: "dutch experimental electronic",
    popularity: "29",
  },
  {
    name: "Sebastian Bronk",
    image: "https://i.scdn.co/image/4383d3e8db154800293caff4e3238efa955ddb51",
    spotify: "4Iau0oBg23all6HbsD98lm",
    genre: "dutch edm",
    popularity: "29",
  },
  {
    name: "Juan Sánchez",
    image: "https://i.scdn.co/image/a26e5b75ca89b02492a54672a3ff2715a32b312a",
    spotify: "7hWXE61toZRP69BB1bQgDe",
    genre: "",
    popularity: "29",
  },
  {
    name: "Dollkraut",
    image: "https://i.scdn.co/image/41696e20f1641ce4e205ed5c92f14abc98a7d882",
    spotify: "0ocSwGS6cbsOhgWvbKZVNT",
    genre: "deep soul house,dutch experimental electronic",
    popularity: "29",
  },
  {
    name: "Dack Janiels",
    image: "https://i.scdn.co/image/df3b0c429ea2c360fd1e95946365f60fb0f1d6b8",
    spotify: "4F8JGeO6bJO7Z309mxHlP0",
    genre: "zapstep",
    popularity: "29",
  },
  {
    name: "Mafalda",
    image: "https://i.scdn.co/image/74e4a5da6fe174dac778c49ab44074d34a2c5698",
    spotify: "0FR7DfKshj8fIey8ptWuQp",
    genre: "",
    popularity: "29",
  },
  {
    name: "SHADED",
    image: "https://i.scdn.co/image/2a69904b92cdeb0a9a1399b4a10a1903665ec031",
    spotify: "46lf9xDBhmOtltUfdKGvbw",
    genre: "pop punk,uk pop punk",
    popularity: "29",
  },
  {
    name: "The Brahms",
    image: "https://i.scdn.co/image/8a78c4dbb12c19c68b66ef84797f7ef3d99ae7d3",
    spotify: "0IVPwrImVEE7gG7WNL7wGQ",
    genre: "dutch indie",
    popularity: "29",
  },
  {
    name: "Bertolf",
    image: "https://i.scdn.co/image/6c599384cde1f058ccb454ec0128a563b8b9994f",
    spotify: "6cs3EabebGIu559XRIpQty",
    genre: "dutch indie,dutch pop,dutch rock",
    popularity: "29",
  },
  {
    name: "Drummakid",
    image: "https://i.scdn.co/image/741641f54727cac0fb8fb309232af176aeaa8937",
    spotify: "1aeGU82zQacdkJrztnB7yF",
    genre: "",
    popularity: "29",
  },
  {
    name: "Chris Chameleon",
    image: "https://i.scdn.co/image/ab67616d0000b273f06f907aee63e940ec7421ac",
    spotify: "7IekiVzQZp0E1FeVc28CdN",
    genre: "african rock,afrikaans,south african pop",
    popularity: "29",
  },
  {
    name: "MC Conrad",
    image: "https://i.scdn.co/image/8434b5c63f216873c7d12fb057bbb7078a8cdfac",
    spotify: "7kmajmVOmbPrFWq3uMHJ3M",
    genre: "atmospheric dnb",
    popularity: "29",
  },
  {
    name: "Streiks & Kratchs",
    image: "https://i.scdn.co/image/41c1280d55c7f8e1ae06fc9b9311bb261663dfaf",
    spotify: "4IeECou6Ya4wjPueZ8BZAV",
    genre: "uptempo hardcore",
    popularity: "29",
  },
  {
    name: "Tuccillo",
    image: "https://i.scdn.co/image/6eaba63eb051e08e0107567a9e0d335e935cc45e",
    spotify: "6EIy9BdHGGzEPbasqwMabi",
    genre: "",
    popularity: "29",
  },
  {
    name: "AFFKT",
    image: "https://i.scdn.co/image/bbf63cbd58a099b80c97e8de1f7e9ca7a9a197bd",
    spotify: "1VCo9PBRImHKuQyiubNSqF",
    genre: "minimal tech house,tech house",
    popularity: "29",
  },
  {
    name: "Galck",
    image: "https://i.scdn.co/image/c20f1637b0c5450e989b491536cd4be0d2ac1d2e",
    spotify: "1DC2PWaBBPDboe4WJeh16b",
    genre: "",
    popularity: "29",
  },
  {
    name: "Isabella Lundgren",
    image: "https://i.scdn.co/image/82710affc2b2feaf943b808fb8f796dab0a6b4bd",
    spotify: "58Ftd7Tzkeve7Ht36LYL2j",
    genre: "swedish jazz",
    popularity: "29",
  },
  {
    name: "Rinkadink",
    image: "https://i.scdn.co/image/77195b15833128c9dbaaae27ecbdafa14b784a9d",
    spotify: "06ldxpPnHY1OEWgxglSHA4",
    genre: "full on,psychedelic trance",
    popularity: "29",
  },
  {
    name: "Lioness",
    image: "https://i.scdn.co/image/0ac05b5a2e55a9ff9f13979e609efb63f911ad67",
    spotify: "5OK6j1BGrNAxZd6pRvgOKF",
    genre: "",
    popularity: "29",
  },
  {
    name: "Stevie Ann",
    image: "https://i.scdn.co/image/5c10e8367c52af7e50c89a8ecc8ac13f5b21b051",
    spotify: "0BLtgRpARRInhUuj2RnpBJ",
    genre: "dutch americana,dutch pop,dutch rock,dutch singer-songwriter",
    popularity: "29",
  },
  {
    name: "Iris Hond",
    image: "https://i.scdn.co/image/ccaa7a470c17b2df7787984b76e9949e7cfcf98f",
    spotify: "1F3I9lXbjp3zfI8F9Ayhk5",
    genre: "",
    popularity: "29",
  },
  {
    name: "Grimm",
    image: "https://i.scdn.co/image/ab67616d0000b273dd905b42afde304f2bb47763",
    spotify: "59ETPeU4mtpBNAyVEM644S",
    genre: "texas latin rap",
    popularity: "29",
  },
  {
    name: "Frederic Robinson",
    image: "https://i.scdn.co/image/2ac7cf1c14aed13759401a81020906cf6a187f3e",
    spotify: "3wCcW4YNnb7qT4wOMBfkfr",
    genre: "munich electronic",
    popularity: "29",
  },
  {
    name: "Love Over Entropy",
    image: "https://i.scdn.co/image/ab67616d0000b2736da7e58164133682a545ca73",
    spotify: "0q6271N8cPFla4UEVC39uq",
    genre: "",
    popularity: "29",
  },
  {
    name: "DJ Maestro",
    image: "https://i.scdn.co/image/3e6aa1a18294605f75712e78b1638708e391f3e6",
    spotify: "5u8Dqz4HUlIdkbHAhJ7y4t",
    genre: "",
    popularity: "29",
  },
  {
    name: "Bram Fidder",
    image: "https://i.scdn.co/image/75d2ba42be607df84929465f0fbbb70315ac5102",
    spotify: "1TNyFVabg1yHOoK44VCPOs",
    genre: "",
    popularity: "29",
  },
  {
    name: "Knut Reiersrud",
    image: "https://i.scdn.co/image/d3d46cb5463ff9988620b3e75650352c2329448a",
    spotify: "6Q8A9S9o98GqVGzDdiwvTH",
    genre: "norwegian blues,norwegian jazz",
    popularity: "29",
  },
  {
    name: "Critical Mass",
    image: "https://i.scdn.co/image/ab67616d0000b273d58519fe38ce45f59a333c28",
    spotify: "3g3kdR5tqPhyxYSaDJBwsx",
    genre: "",
    popularity: "29",
  },
  {
    name: "Christopher Lawrence",
    image: "https://i.scdn.co/image/038284ace2a6797cdf3c10ae54ca99d953586e73",
    spotify: "7FurwsWcdTy84HcxhnYoNQ",
    genre: "trance",
    popularity: "29",
  },
  {
    name: "Inge van Calkar",
    image: "https://i.scdn.co/image/d3def4d7f3df213cc0fe18eb700e4b9c39350ace",
    spotify: "58a6e3KpWCZoIkPvbBv5RP",
    genre: "aarhus indie",
    popularity: "29",
  },
  {
    name: "Jeramiah Ferrari",
    image: "https://i.scdn.co/image/b23588d0e79f2395dcedca495b775729dd4afa0e",
    spotify: "12x3vm8tJaTI7J7WkMFr7i",
    genre: "modern ska punk,uk reggae",
    popularity: "29",
  },
  {
    name: "The Mekanism",
    image: "https://i.scdn.co/image/9d915db3bc8f0580c8d4fb23490b8a7f74b9108f",
    spotify: "28QIgdCMLnz3ZBkFRCkD5h",
    genre: "deep disco house,french tech house",
    popularity: "29",
  },
  {
    name: "Luke Slater",
    image: "https://i.scdn.co/image/0e774218850a3aafe46d27be91badece6b665a44",
    spotify: "5BJa6TIqtoWm8QRRbfRmyt",
    genre: "acid house,microhouse,minimal techno,tech house,techno",
    popularity: "29",
  },
  {
    name: "Vunzige Deuntjes Soundsystem",
    image: "https://i.scdn.co/image/82b6d663cb5c91ea2dbf16c0d799bbb4c0ad1e77",
    spotify: "62YuFBPEU1YLmrYgOdL0Ci",
    genre: "",
    popularity: "29",
  },
  {
    name: "Ben Woods",
    image: "https://i.scdn.co/image/ab67616d0000b27320ecf242bdc2c1610baaf06e",
    spotify: "48aj2Mk8GfONHzoPRfEeCY",
    genre: "",
    popularity: "29",
  },
  {
    name: "Markantonio",
    image: "https://i.scdn.co/image/7488da7cb26fe2d97c068266a0e051acd47fb8ff",
    spotify: "1ZdPbovVpFHo1Uy1FmjklW",
    genre: "italian techno",
    popularity: "29",
  },
  {
    name: "Jazzkantine",
    image: "https://i.scdn.co/image/1d4567fae5ec8313346fed0cb58bac2c85a8548e",
    spotify: "0uJX9YwS8rkQw0mxxD2dMW",
    genre: "jazz rap",
    popularity: "29",
  },
  {
    name: "Bruce Molsky",
    image: "https://i.scdn.co/image/a513f11eebbd6ac57a4288b483efc0802f78b21b",
    spotify: "1MrOuBzSqS0quOvkmMwYfy",
    genre:
      "appalachian folk,bluegrass,modern old-time,old-time,old-time fiddle,progressive bluegrass,string band,traditional folk",
    popularity: "29",
  },
  {
    name: "Kit Sebastian",
    image: "https://i.scdn.co/image/520a40a01611f785ff2a60e94652c5a93680377e",
    spotify: "5GSILaXo4yN4umwJK8eBBY",
    genre: "psychedelic pop",
    popularity: "29",
  },
  {
    name: "Andrew Schulz",
    image: "https://i.scdn.co/image/ab67616d0000b273d353e119e80a433f351c0cb9",
    spotify: "1dQ0zfIVuzARlVGpWkt6ES",
    genre: "new comedy",
    popularity: "29",
  },
  {
    name: "Smoare",
    image: "https://i.scdn.co/image/ab67616d0000b2730ea713f94fd740a697b7ec6a",
    spotify: "2ldwI7d5zWPpXJQNLWm2l2",
    genre: "",
    popularity: "29",
  },
  {
    name: "Data 3",
    image: "https://i.scdn.co/image/ab67616d0000b2737028b4fb05a7e2b1388336eb",
    spotify: "7pyXNcVHZxMzEG7bkf5pPV",
    genre: "deep dnb,uk dnb",
    popularity: "29",
  },
  {
    name: "Kay Slice",
    image: "https://i.scdn.co/image/ae89b4c075827357377624f66aef62fea76867ee",
    spotify: "1mPNT5YwLcCKfjdTwOfSC8",
    genre: "",
    popularity: "29",
  },
  {
    name: "Pegassi",
    image: "https://i.scdn.co/image/f08075a0da141be8f8677cd57fbe0abff690c54e",
    spotify: "2A4uiWrfuBpVFugyvxAt4c",
    genre: "future house",
    popularity: "29",
  },
  {
    name: "Teto Preto",
    image: "https://i.scdn.co/image/ab67616d0000b2736a28eb71614eb021c1cbb8ed",
    spotify: "71SeHRvF7QAnG8kSC9qbW5",
    genre: "baile pop,brazilian techno",
    popularity: "29",
  },
  {
    name: "Doc Brown",
    image: "https://i.scdn.co/image/84ff460e8a0de11ddb6d9db76e2f0fa12813a487",
    spotify: "7usDVD6PDkEOCbHK7Elk7O",
    genre: "uk hip hop",
    popularity: "29",
  },
  {
    name: "Petar Dundov",
    image: "https://i.scdn.co/image/1205cc246bb4a62ce0a29f8d87bcb4c70694ba36",
    spotify: "4mA7iTQqDHoKkuLWJ6Oyn6",
    genre: "croatian electronic",
    popularity: "29",
  },
  {
    name: "Hansen Tomas",
    image: "https://i.scdn.co/image/4c1f330440ff47a0879dd22cb32015a9872185ab",
    spotify: "6LpWW2eQCLzIIJEVys9Xg5",
    genre: "dutch pop",
    popularity: "29",
  },
  {
    name: "Stillbirth",
    image: "https://i.scdn.co/image/bc702d4f641aea206be34faf15c9000e54890754",
    spotify: "3zBRwsfsphAy6eNvh2bPiG",
    genre: "brutal death metal,german death metal,slam death metal",
    popularity: "29",
  },
  {
    name: "Niels Broos",
    image: "https://i.scdn.co/image/411fe44a29ea6df9db779e8dd1732a01d7480092",
    spotify: "3l5Oi9GQp9TE23Kys4OOvv",
    genre: "",
    popularity: "29",
  },
  {
    name: "NiCe7",
    image: "https://i.scdn.co/image/79430c08594cef9e08af3c9de8363785e6054959",
    spotify: "6qBmPOu2NuZtyODRNSfUDw",
    genre: "",
    popularity: "29",
  },
  {
    name: "Kevin Di Serna",
    image: "https://i.scdn.co/image/06f9c5bb2faee4b185ac77f28530f3abf3384d90",
    spotify: "6wktCejPtNcStIDD24buEm",
    genre: "organic house",
    popularity: "29",
  },
  {
    name: "Stimming x Lambert",
    image: "https://i.scdn.co/image/ab67616d0000b273f3e8ffca58485966260bd187",
    spotify: "1TTO5SuWJWgnOOGMdwVvD5",
    genre: "neo-classical",
    popularity: "29",
  },
  {
    name: "Yan Cook",
    image: "https://i.scdn.co/image/9b063d029d493783a2ebb04e4810f15d37733aa5",
    spotify: "7b85knFTqgPmQmbUt77rYy",
    genre: "minimal dub,techno,ukrainian electronic",
    popularity: "29",
  },
  {
    name: "Der Weg einer Freiheit",
    image: "https://i.scdn.co/image/8701977c53df41e44434e5925023a073e4808553",
    spotify: "7e823b0KQoVtLG86Ui5xGD",
    genre: "german black metal,melodic black metal,voidgaze",
    popularity: "29",
  },
  {
    name: "Daniel Dubb",
    image: "https://i.scdn.co/image/f305e5a9166863a78dc0aeafc813d8ebc7682853",
    spotify: "11QbgTgVwwhiM9SU8nanWo",
    genre: "canadian house",
    popularity: "29",
  },
  {
    name: "Junior Carl",
    image: "https://i.scdn.co/image/1c2f8cb1019423fbd368202a13f3b7b464a6ad1c",
    spotify: "0hwvh5OM0k9FLH6wcADPw4",
    genre: "",
    popularity: "29",
  },
  {
    name: "Javi Bora",
    image: "https://i.scdn.co/image/b136e109111b2f71e49e6d16f5c2e842f04f1c53",
    spotify: "55KbYy2WOB2To9rnNkSGZ2",
    genre: "",
    popularity: "29",
  },
  {
    name: "Demuir",
    image: "https://i.scdn.co/image/705ba69cf19811f6f635ff553563ac1754c2ea56",
    spotify: "57fp8oZ2P90tIcOpmAtZEi",
    genre: "canadian house",
    popularity: "29",
  },
  {
    name: "Jenia Tarsol",
    image: "https://i.scdn.co/image/5e4840551c4d826bea0886f26306512531c7c68b",
    spotify: "0K725IR0iw8JfgNts2UzEk",
    genre: "",
    popularity: "29",
  },
  {
    name: "Wang Wen",
    image: "https://i.scdn.co/image/ab67616d0000b273ded52a15f7c97b86fe6e458d",
    spotify: "2graYi1dMY9sdPLIZNV2bq",
    genre:
      "chinese indie,chinese indie rock,chinese post-rock,instrumental post-rock,post-rock",
    popularity: "29",
  },
  {
    name: "Sacha Robotti",
    image: "https://i.scdn.co/image/577e864bbf988ea614e883d52855014c247ad313",
    spotify: "5zheoDzRTIhWzE1j1DttZf",
    genre: "bass house",
    popularity: "29",
  },
  {
    name: "Kaltenkirchen",
    image: "https://i.scdn.co/image/30a9e6a7e3f4ff1a69a7dd803172db4ada68d6c3",
    spotify: "1XuOxeq7zKZTvilwbHdS6v",
    genre: "austrian indie",
    popularity: "29",
  },
  {
    name: "Something Happens",
    image: "https://i.scdn.co/image/4f24a8dc1411f53bf65953bb364f0957e9c99170",
    spotify: "6V7D7M2wECmGR8eBp9r4Kx",
    genre: "irish rock,underground power pop",
    popularity: "29",
  },
  {
    name: "AnnaGrace",
    image: "https://i.scdn.co/image/40cf07b57f2c1f1572b63baf5ef039164a4cf611",
    spotify: "1gGy6vCfc2Q2rAe1uhCCIs",
    genre: "belgian pop",
    popularity: "29",
  },
  {
    name: "Zoro",
    image: "https://i.scdn.co/image/ab67616d0000b273608bf06e9347ec6096017459",
    spotify: "3S3T7zQ5vPdxH6vvh4ipxm",
    genre: "oshare kei",
    popularity: "29",
  },
  {
    name: "Aron Volta",
    image: "https://i.scdn.co/image/ab67616d0000b273f434d93626995857f5d85867",
    spotify: "0kReqfLTBVtOXtdpFFxUzA",
    genre: "minimal tech house",
    popularity: "29",
  },
  {
    name: "Tom Flynn",
    image: "https://i.scdn.co/image/3cf61db0e8e036d06cc9508ceb1182a9a8d3ede3",
    spotify: "3lSeZGCmgYasoeYml0hQY8",
    genre: "",
    popularity: "29",
  },
  {
    name: "Canson",
    image: "https://i.scdn.co/image/ab67616d0000b2734aa09187fb4ed4c1888794f4",
    spotify: "1oP6xp4bo6ZmVJsuMcKdtJ",
    genre: "ethnotronica,organic electronic,organic house",
    popularity: "29",
  },
  {
    name: "Phil Campbell and the Bastard Sons",
    image: "https://i.scdn.co/image/ab6772690000c46c75f9392d59798b88804a2e90",
    spotify: "7fRzvXVDS5fOLD91WQwE6q",
    genre: "modern hard rock,nwocr",
    popularity: "29",
  },
  {
    name: "Mathew Jonson",
    image: "https://i.scdn.co/image/259bca1ff7e0bde6a8b0a861f5b4b1656b707125",
    spotify: "6PTy8QkZxHr7Thp8SPYE71",
    genre: "german techno,microhouse,minimal techno,tech house",
    popularity: "29",
  },
  {
    name: "Sihk",
    image: "https://i.scdn.co/image/5b6c6b82f1935e965bc952011dd11881243f1394",
    spotify: "0GRYh4b8TJ9LQelJhQuKh6",
    genre: "indonesian edm",
    popularity: "29",
  },
  {
    name: "Maarja Nuut",
    image: "https://i.scdn.co/image/c4b4d39e9ef2f6feed888e6dbff1a1fff0d2910f",
    spotify: "0rQSHGbaVqFhj4gcXDAjKy",
    genre: "estonian folk,estonian indie",
    popularity: "29",
  },
  {
    name: "Several Definitions",
    image: "https://i.scdn.co/image/c609d2fa15ebed0ce825f7453c4e2c8be5241d36",
    spotify: "7fgdLbHjlVQE4sZ9L2awDq",
    genre: "swiss house",
    popularity: "29",
  },
  {
    name: "Small World",
    image: "https://i.scdn.co/image/ab67616d0000b273026cb49a4e1d29d7c3bb8be7",
    spotify: "1d6bpJp3mEcOPPuYJ79p59",
    genre: "mod revival",
    popularity: "29",
  },
  {
    name: "Skeletal Remains",
    image: "https://i.scdn.co/image/382f4e03dad4bf7a4bccbee07a91e4d44150576c",
    spotify: "4Rh3NPxVMADeaSIduAsykN",
    genre: "grisly death metal",
    popularity: "29",
  },
  {
    name: "Lee Curtiss",
    image: "https://i.scdn.co/image/ab67616d0000b273d429af0faf3a6ea10105aea6",
    spotify: "5qCdmZXBkJc15PLLbFadVV",
    genre: "minimal tech house",
    popularity: "29",
  },
  {
    name: "Nine Pound Hammer",
    image: "https://i.scdn.co/image/ab67616d0000b2739eedd18b2d68225619fb0b2f",
    spotify: "6eGyO5YgfOaG58AOPjAvKd",
    genre: "",
    popularity: "29",
  },
  {
    name: "Saad Ayub",
    image: "https://i.scdn.co/image/7eb0e2800cef5968a90d5da931d5ce582b175ebb",
    spotify: "2ulEOi17CGvnTNd9RpY9AR",
    genre: "progressive trance",
    popularity: "29",
  },
  {
    name: "Les Filles de Illighadad",
    image: "https://i.scdn.co/image/3d34cc667b96a9b7c83ec84f5522148b8352d3cb",
    spotify: "45EoOvcenErsYkaJUnqjJv",
    genre: "tuareg guitar,western saharan folk",
    popularity: "29",
  },
  {
    name: "Bryan John Appleby",
    image: "https://i.scdn.co/image/b21c26b4f4c381b762492acdd2d96ab0883c9ade",
    spotify: "3qPpwz6S0CbgMz9cGtn02l",
    genre: "stomp and flutter",
    popularity: "29",
  },
  {
    name: "Kommode",
    image: "https://i.scdn.co/image/fe99ec8c76edaf9ad6434e3f0fde025f804a768d",
    spotify: "6wE8mqgNvgr9AMJb3wFfZR",
    genre: "",
    popularity: "29",
  },
  {
    name: "Mental Cruelty",
    image: "https://i.scdn.co/image/86f3a15a7d5a884bf51d0e41f0b7210fde7f3bcd",
    spotify: "2iE1NqruxoSxTvOpTCLkE9",
    genre: "progressive deathcore,slam death metal,slamming deathcore",
    popularity: "29",
  },
  {
    name: "Britta Arnold",
    image: "https://i.scdn.co/image/9763129153a4f788b987918d69cfa685c596b431",
    spotify: "7JpBTUqubY86KynSJr28RN",
    genre: "deep euro house,german house",
    popularity: "28",
  },
  {
    name: "Dorisburg",
    image: "https://i.scdn.co/image/ab67616d0000b273cfd20e99ee51290b780bfb2f",
    spotify: "0OZ1LUrTGxwx0dr71DL7D6",
    genre:
      "ambient techno,float house,swedish electronic,swedish house,swedish techno",
    popularity: "28",
  },
  {
    name: "Micha Wertheim",
    image: "https://i.scdn.co/image/ab67616d0000b273f74e11f5e3253b986ed1402b",
    spotify: "7BbAsA0xSOBnMDmgEBXf7J",
    genre: "dutch cabaret",
    popularity: "28",
  },
  {
    name: "Khidja",
    image: "https://i.scdn.co/image/ab67616d0000b273c1753d4c44f0660621b98d43",
    spotify: "3F5IStbZ3xP51h3oXexjKY",
    genre: "float house,romanian electronic",
    popularity: "28",
  },
  {
    name: "Christopher Paul Stelling",
    image: "https://i.scdn.co/image/d78affb05a281fa0e56e13f009bf12682a4ffc3d",
    spotify: "0uvkj2Pqn60liBxf2a91D4",
    genre: "deep new americana,indie folk",
    popularity: "28",
  },
  {
    name: "45ACIDBABIES",
    image: "https://i.scdn.co/image/86a871e91073b4d57edd4766625e429e819f1e46",
    spotify: "2mTXtWA6MHFws93KAA5rVt",
    genre: "dutch indie rock",
    popularity: "28",
  },
  {
    name: "Gaiser",
    image: "https://i.scdn.co/image/71dcdf9353f526cbac3f96215adf813176ef6f58",
    spotify: "0zNtdoyO2ZA7hhYMNLh48Y",
    genre: "minimal techno,tech house",
    popularity: "28",
  },
  {
    name: "Bobby Burns",
    image: "https://i.scdn.co/image/c97748444891f74007fa809536b3763e024a8870",
    spotify: "6sStop9UgSa41ShCuW7pHd",
    genre: "",
    popularity: "28",
  },
  {
    name: "Ruffneck",
    image: "https://i.scdn.co/image/c7b6047d0299bbe79bcb861f80bef5c5306ccc02",
    spotify: "3aXox59c2JVDCGYgB16WmT",
    genre: "gabba,happy hardcore,hardcore techno",
    popularity: "28",
  },
  {
    name: "Broken Brass",
    image: "https://i.scdn.co/image/497dce90a6d09d448e5e486f9d51f2fd55323d84",
    spotify: "7Ky58iVg3Ek77CZB0yYoSt",
    genre: "",
    popularity: "28",
  },
  {
    name: "Moritz Von Oswald",
    image: "https://i.scdn.co/image/66d056ae071f3b6bbfaf9c561d387006f3ad0d73",
    spotify: "33GGoMV3iYpV5tlsh32N7q",
    genre: "dub techno",
    popularity: "28",
  },
  {
    name: "Alex Roeka",
    image: "https://i.scdn.co/image/36ec845b0577eb84f0a301d9fafd311684014bf7",
    spotify: "7yZlxklSzsDJIpuRRwe6bO",
    genre: "dutch indie",
    popularity: "28",
  },
  {
    name: "Kapok",
    image: "",
    spotify: "4mVVU1syuUR6NcKhprJKYi",
    genre: "",
    popularity: "28",
  },
  {
    name: "VNTM",
    image: "https://i.scdn.co/image/9b8cb9500b7d899eaebd4d94ef7354bcee39c7c4",
    spotify: "3OIINbAKKK2MjCiFEpEft3",
    genre: "dark techno",
    popularity: "28",
  },
  {
    name: "Byron the Aquarius",
    image: "https://i.scdn.co/image/e67b23fdef8f0479e5d99a17d19acbf3e61de823",
    spotify: "6kOYTwdWQF73PXP7WyRsNJ",
    genre: "",
    popularity: "28",
  },
  {
    name: "Third Son",
    image: "https://i.scdn.co/image/870184fe2ee823f9591ea409f32501367b0781b0",
    spotify: "3V0CkmupRFH97LSOafzfbc",
    genre: "",
    popularity: "28",
  },
  {
    name: "Oriental Cravings",
    image: "https://i.scdn.co/image/3b083ede1945c1bc3d81d920e2184ad1fa84e82a",
    spotify: "51N35pGBBHm3u1uFtNhE8b",
    genre: "",
    popularity: "28",
  },
  {
    name: "Santiago Garcia",
    image: "https://i.scdn.co/image/7aaef1a1804590d5e76fddfd85cdf93c1da9a2fe",
    spotify: "4HTu4h0bTZratn5pTBqRjS",
    genre: "house argentino,organic electronic",
    popularity: "28",
  },
  {
    name: "Maisha",
    image: "https://i.scdn.co/image/ab67616d0000b27387a5e4a445bf9651e5fc0cb0",
    spotify: "0AcvE4vSLoL8k0IYMJuAAN",
    genre: "british jazz",
    popularity: "28",
  },
  {
    name: "Jesse Maas",
    image: "https://i.scdn.co/image/4d9cca66d9cb1b8cdd9be0254fdfde4ab42f8a3d",
    spotify: "2eprK9dqUOpKRzI18r7e8G",
    genre: "dutch tech house",
    popularity: "28",
  },
  {
    name: "AWKWARD i",
    image: "https://i.scdn.co/image/7661e365babab3cbe4442ae909925830c51550ab",
    spotify: "7A8U1UZFpc03H6UrSaX9wh",
    genre: "dutch indie",
    popularity: "28",
  },
  {
    name: "Kali Malone",
    image: "https://i.scdn.co/image/ab67616d0000b2738aab29ed5eb80a22f3c9b395",
    spotify: "1I0rODlh5K9pW3JhEla2H9",
    genre:
      "ambient,art pop,drone,experimental ambient,experimental synth,fourth world,new isolationism,sound art,swedish experimental",
    popularity: "28",
  },
  {
    name: "Die Nerven",
    image: "https://i.scdn.co/image/0987fdfd613c1f4504c1d1d01bfc0744e615d3fd",
    spotify: "7rdm7IB4LaHSy1PvRzXnmc",
    genre: "german indie,german post-punk,stuttgart indie",
    popularity: "28",
  },
  {
    name: "Theon Cross",
    image: "https://i.scdn.co/image/ab67616d0000b2731f57079bd63f8023e820e512",
    spotify: "0IFabaHypEH0hMgkx0Gw56",
    genre: "british jazz,experimental jazz,indie jazz,uk contemporary jazz",
    popularity: "28",
  },
  {
    name: "Marco Bailey",
    image: "https://i.scdn.co/image/6f629af799bd9b2abdff95bce4b503bb25676545",
    spotify: "23zJj2W0TQ0SvF4Fwo7mZK",
    genre: "belgian techno,tech house,techno",
    popularity: "28",
  },
  {
    name: "Karakter",
    image: "https://i.scdn.co/image/462178b0db722d446c141200197497bde76889b6",
    spotify: "0D0rrh5OVFbBgSYYOG5jtL",
    genre: "",
    popularity: "28",
  },
  {
    name: "Pyrodox",
    image: "https://i.scdn.co/image/db82267f120850ef803d3afe4f51c5e24030c728",
    spotify: "4qCTqYp2ugnljQtRqy5cEH",
    genre: "",
    popularity: "28",
  },
  {
    name: "The 4 Of Us",
    image: "https://i.scdn.co/image/ab67616d0000b2737c98b02df135795d6f53b074",
    spotify: "1Yr9lXq2m3KO4otqQKcllY",
    genre: "irish rock",
    popularity: "28",
  },
  {
    name: "Akouo",
    image: "https://i.scdn.co/image/736770df583ceee260fe6138c9c5bf9761645ccf",
    spotify: "5L6DQbqDEUmR92z68SjWd9",
    genre: "tassie indie",
    popularity: "28",
  },
  {
    name: "Kennedy Jones",
    image: "https://i.scdn.co/image/6f8875a3c4f6cbf3c062800c19cf8db8da4a2347",
    spotify: "37rNXhsuPTtNWW9cGcIyOo",
    genre: "electronic trap",
    popularity: "28",
  },
  {
    name: "André Bratten",
    image: "https://i.scdn.co/image/7bce6e7cedfe3d2aa12b8baeac07390f7f392dbb",
    spotify: "4JumlwBeaIE16moHUv3xzZ",
    genre: "norwegian space disco",
    popularity: "28",
  },
  {
    name: "Marc Holstege",
    image: "https://i.scdn.co/image/91949e235a881f969008ebb9acf525fb9f9d4bde",
    spotify: "4seeqFihC5Ovh5NfgyifnY",
    genre: "deep techno",
    popularity: "28",
  },
  {
    name: "Lucrecia Dalt",
    image: "https://i.scdn.co/image/2c0e4524a2818aba2bbf69e29153dfec1d6d99cc",
    spotify: "4LC4vkseYrSEDd6MjZvOO9",
    genre: "electra",
    popularity: "28",
  },
  {
    name: "MC Dash",
    image: "https://i.scdn.co/image/ab67616d0000b273b88efac4394ec19098028a04",
    spotify: "531t5fXoLsmwcUGhaVYYk6",
    genre: "",
    popularity: "28",
  },
  {
    name: "The Tibbs",
    image: "https://i.scdn.co/image/9b76e6ed42463813886206cadca22ba4d48f42a8",
    spotify: "2erVTUGh7hd5PQ3qwChdxw",
    genre: "retro soul",
    popularity: "28",
  },
  {
    name: "Otto Normal",
    image: "https://i.scdn.co/image/26073850b960508f5793f2002da5aa101ca4c638",
    spotify: "7zdRERsumyyBMFiDtv0J2H",
    genre: "german indie pop",
    popularity: "28",
  },
  {
    name: "Dear Reader",
    image: "https://i.scdn.co/image/85d170bd09ad4c9e8e17b215e76bc7a52815aeff",
    spotify: "1MkKuWpTPwAoYVkSfXiWSp",
    genre: "",
    popularity: "28",
  },
  {
    name: "We Are Wolves",
    image: "https://i.scdn.co/image/3dd6079ce684bec530edc1953ad61256a444dd7b",
    spotify: "1Mt6gJbSKbLoSXWbgb44LW",
    genre: "quebec indie,rock quebecois",
    popularity: "28",
  },
  {
    name: "VAN HOLZEN",
    image: "https://i.scdn.co/image/26bdeec1a19d3049f30456559ec340c165e9cc27",
    spotify: "6KXCn6HU5WBvHN9uqkwMcn",
    genre: "german alternative rock,german post-hardcore",
    popularity: "28",
  },
  {
    name: "Malice",
    image: "https://i.scdn.co/image/ab67616d0000b2738164ed68984df88886a679e6",
    spotify: "5tN6fQFvbiTYubJ9okxkft",
    genre: "rawstyle",
    popularity: "28",
  },
  {
    name: "Animal Picnic",
    image: "https://i.scdn.co/image/ab67616d0000b2730529d64112d8edc8e24acdb3",
    spotify: "7eMjH8sGNTqZycmrO1P9WD",
    genre: "melodic techno",
    popularity: "28",
  },
  {
    name: "LGHTNNG",
    image: "https://i.scdn.co/image/47711f7dbbc53b926420be5b503fd3d3d1c4c91b",
    spotify: "0WdbXEp4rIU0JYGAcJOK6H",
    genre: "popwave",
    popularity: "28",
  },
  {
    name: "KD Soundsystem",
    image: "https://i.scdn.co/image/d1a57892ff04e7d10efef4737192a517f162b3c7",
    spotify: "7yPOMcYNwv9by1xUxAljPA",
    genre: "basshall",
    popularity: "28",
  },
  {
    name: "Zig Zags",
    image: "https://i.scdn.co/image/5ab170d3f13d2a6f50759ccf0a69298918180f37",
    spotify: "5Na7fSSXoKezg6Q1ebPqs3",
    genre: "new wave of thrash metal",
    popularity: "28",
  },
  {
    name: "Sirus Hood",
    image: "https://i.scdn.co/image/4945617fd045de98965ddbb7cbe7a960f7f264b1",
    spotify: "2lrYf4KiHcMPOYGUGhrzgs",
    genre: "french tech house",
    popularity: "28",
  },
  {
    name: "David Wax Museum",
    image: "https://i.scdn.co/image/539334056c68c3a919160bccbd0fd27d0f59bafd",
    spotify: "41h543BszPTZEEfQRHYc8K",
    genre: "",
    popularity: "28",
  },
  {
    name: "Elkka",
    image: "",
    spotify: "3ZqEiUaMAy1Gk1MdQR7dvs",
    genre: "",
    popularity: "28",
  },
  {
    name: "Bokoedro",
    image: "https://i.scdn.co/image/536d7c79bba7aab7dc026915ca7c6c16342c6d45",
    spotify: "0StPaie1dmyO3i2mdgHBuO",
    genre: "dutch trap",
    popularity: "28",
  },
  {
    name: "MC Raise",
    image: "https://i.scdn.co/image/926b95c797c4248f3e52239e5aa409897aef675e",
    spotify: "36Bocpahok6SYyJhPWnlht",
    genre: "",
    popularity: "28",
  },
  {
    name: "Polar Youth",
    image: "https://i.scdn.co/image/7a0263ac412efe754a5fb1779e8fecb149abbfb6",
    spotify: "48EUMg2SS1VgOyLRzOhwjQ",
    genre: "belgian edm,vapor twitch",
    popularity: "28",
  },
  {
    name: "Jack Of Sound",
    image: "https://i.scdn.co/image/e1a07a715a3f939b1fb5cf7a2ce535525530be98",
    spotify: "3hpMKvVTfeW0Of0XstCrEB",
    genre: "classic hardstyle,hardstyle,rawstyle",
    popularity: "28",
  },
  {
    name: "The Sore Losers",
    image: "https://i.scdn.co/image/42f27fad3ee05bb4ae1266fd6d8d0722686c822e",
    spotify: "1imTkMl8JvvVuU2RZvO8r1",
    genre: "belgian indie,belgian rock",
    popularity: "28",
  },
  {
    name: "Stereocalypse",
    image: "https://i.scdn.co/image/858076dc7b71f869e613ce7fc5d170a72f6851e9",
    spotify: "6Ro7vKas2pkuc19bO3xx2v",
    genre: "italian techno",
    popularity: "28",
  },
  {
    name: "Thee Cool Cats",
    image: "https://i.scdn.co/image/5b9937886c6f38eb701b8082d8659ef33eb34567",
    spotify: "2B8pwCMMgvApPWlixiXAfL",
    genre: "groove room",
    popularity: "28",
  },
  {
    name: "Henny Vrienten",
    image: "https://i.scdn.co/image/ab67616d0000b27334a269d016bd5851c802e289",
    spotify: "3W6yvJOtMHLNQViXsXAqcH",
    genre: "dutch indie,dutch rock",
    popularity: "28",
  },
  {
    name: "Buster Shuffle",
    image: "https://i.scdn.co/image/e0dc8969eeb1e2ebb26c9ca8cea5dfdd322cd739",
    spotify: "52g6DEmghtDNa19ehPw9uM",
    genre: "euroska,modern ska punk,ska revival",
    popularity: "28",
  },
  {
    name: "Baciamolemani",
    image: "https://i.scdn.co/image/79c8f538fd148e3590aabf3bb09dd4fb8c4de513",
    spotify: "0elMvfznA669VcCQ5vb13S",
    genre: "musica etnica",
    popularity: "28",
  },
  {
    name: "Kel Assouf",
    image: "https://i.scdn.co/image/c39e69d99e231ea2de04c723402d8953749680e7",
    spotify: "5mu6VL20oyfrkqOW61w7p9",
    genre: "desert blues,tuareg guitar",
    popularity: "28",
  },
  {
    name: "Kr!z",
    image: "https://i.scdn.co/image/5a6b329deb866315f3a0e4817b40ba2a7b96fd87",
    spotify: "4bVSJoHlXYbzdBrbgqbMxl",
    genre: "belgian techno",
    popularity: "28",
  },
  {
    name: "Kimberlee Ramirez",
    image: "https://i.scdn.co/image/274b4b591dce3d3a58e987e5a641776795c36c39",
    spotify: "5drDrydIsToYA1Bb5kMPFa",
    genre: "",
    popularity: "28",
  },
  {
    name: "Max Gomez",
    image: "https://i.scdn.co/image/a6ca98251affb2e3664bd18451127b35540cf948",
    spotify: "5nm8ML0WhLsR8eJ5PobwyN",
    genre: "",
    popularity: "28",
  },
  {
    name: "Brazza Squad",
    image: "https://i.scdn.co/image/1e6f87bc86af97e45c6b2ff6f6aeba26aeef0483",
    spotify: "0tWa0QgviwjoOnINMQeWKh",
    genre: "brazilian house",
    popularity: "28",
  },
  {
    name: "Dave Seaman",
    image: "https://i.scdn.co/image/cfe10bd67f0d2f8ea04b1ff52c1c8dee46974b5f",
    spotify: "3TjRLW97EAU4w6knKVBl73",
    genre: "classic progressive house,deep techno",
    popularity: "28",
  },
  {
    name: "Balkan Paradise Orchestra",
    image: "https://i.scdn.co/image/43d979d5d1fd769ebc098542aa49d51942c93f39",
    spotify: "5tWhPlOVHAdgPbtzTR95Hs",
    genre: "ska espanol",
    popularity: "28",
  },
  {
    name: "Minutes",
    image: "https://i.scdn.co/image/ab67616d0000b273df146159f6e6cfced0f2703f",
    spotify: "1vAIpFVY4OYBiYqs7IT19y",
    genre: "",
    popularity: "28",
  },
  {
    name: "Jimmy James",
    image: "https://i.scdn.co/image/7db0535baf5c033649bcb1ce7ac2d80bb27f539f",
    spotify: "3wBTuRBjr25nNlyRKNn81D",
    genre: "",
    popularity: "28",
  },
  {
    name: "Glass Museum",
    image: "https://i.scdn.co/image/cd428058a30ddd385117721274b0017604302398",
    spotify: "0bq8ZdJxUOXswye4qT4zzU",
    genre: "belgian modern jazz",
    popularity: "28",
  },
  {
    name: "All Out War",
    image: "https://i.scdn.co/image/07f8eee70bbd221a35d366d5fdd30a9e47acfae0",
    spotify: "34jZDyPFvvXhL4YeBICAiV",
    genre: "beatdown,hardcore,metallic hardcore,vegan straight edge",
    popularity: "28",
  },
  {
    name: "Luna Mae",
    image: "https://i.scdn.co/image/2771381fe0d6084952541d62107382176538a127",
    spotify: "5ownccCPeMuS8uJnAIsjFP",
    genre: "",
    popularity: "28",
  },
  {
    name: "Schlachthofbronx",
    image: "https://i.scdn.co/image/147f9c2aaedacad41709e66cbb6fc64a7f7a908c",
    spotify: "5yE68yjrrpSEjUqykhSpFK",
    genre: "munich electronic",
    popularity: "28",
  },
  {
    name: "Born From Pain",
    image: "https://i.scdn.co/image/80e3d6a31ff8e33a250924c01310dac68e20585c",
    spotify: "29BUhhygenDpPj5pat2oOR",
    genre: "beatdown,hardcore,lowlands hardcore",
    popularity: "28",
  },
  {
    name: "Jameston Thieves",
    image: "https://i.scdn.co/image/ddaa6f6cf1acd6c35a33a57bf68cc68f769e1e42",
    spotify: "6PX9H0VMD5HjAL03EIlr3V",
    genre: "",
    popularity: "28",
  },
  {
    name: "MC Fava",
    image: "https://i.scdn.co/image/df94773ff91a852e4a73bc22b246d7fe0330f01a",
    spotify: "3PRKQmdOhulKAS8mWWIQfj",
    genre: "",
    popularity: "27",
  },
  {
    name: "Randy Katana",
    image: "https://i.scdn.co/image/ab67616d0000b273c69856daef530325a49f95cc",
    spotify: "6XI9c9lZrduWlG80Kky8yr",
    genre: "dutch trance",
    popularity: "27",
  },
  {
    name: "Henry van Loon",
    image: "https://i.scdn.co/image/deaa05692c52ddaeafacac13016977e253229f18",
    spotify: "4oB7gmoefWHRhkcN6BSojF",
    genre: "dutch cabaret",
    popularity: "27",
  },
  {
    name: "Nakadia",
    image: "https://i.scdn.co/image/fa592785fd04a45c05d64d0b8484acf43196aa7f",
    spotify: "1nOdOuoOkOkQ2PaWFxVkLH",
    genre: "",
    popularity: "27",
  },
  {
    name: "JAMBINAI",
    image: "https://i.scdn.co/image/7785f2fb71ba67934a4c85319aafb71358f2b800",
    spotify: "20xwrwSmGSBQLLV0EVRS9M",
    genre: "korean experimental,korean indie rock,korean metal,oriental metal",
    popularity: "27",
  },
  {
    name: "Call Super",
    image: "https://i.scdn.co/image/423d5cb79bf87ae69a92b3a0d0f4a992f0aacdab",
    spotify: "1FVo44KTXqxo3JxXADWTd9",
    genre: "ambient techno,float house",
    popularity: "27",
  },
  {
    name: "Mister and Mississippi",
    image: "https://i.scdn.co/image/30ef86f2f1b64d5bfc8383e0dfe90630be605213",
    spotify: "2NdxSkG49hZxJ6JNt30330",
    genre: "dutch indie",
    popularity: "27",
  },
  {
    name: "Tangarine",
    image: "https://i.scdn.co/image/68ce3b76f836b288b8af1084a4d869ad1338795f",
    spotify: "6M1HAXD9PmL4w7uB5aP659",
    genre: "dutch americana,dutch indie",
    popularity: "27",
  },
  {
    name: "Cosmo Vitelli",
    image: "https://i.scdn.co/image/ab67616d0000b27386d62fe2fc7d7a5f2a01060b",
    spotify: "0mFsbKrHaJDM5DgL8g3Ke3",
    genre: "dark disco",
    popularity: "27",
  },
  {
    name: "Sage Armstrong",
    image: "https://i.scdn.co/image/9acb1be4bdbc6783f14572a2c8caf700b8b8da3e",
    spotify: "1cfwUSXEE2axXJGQfnfVFH",
    genre: "bass house",
    popularity: "27",
  },
  {
    name: "Slice N Dice",
    image: "https://i.scdn.co/image/4ad778424473e71c69bacd7df45f8f74bd8cdca7",
    spotify: "3WidLZ58DQjM525pYif1VW",
    genre: "melbourne bounce,melbourne bounce international",
    popularity: "27",
  },
  {
    name: "Francis Inferno Orchestra",
    image: "https://i.scdn.co/image/0ce6845932aea0f760c3e5fa390ecd5e058a9325",
    spotify: "3OOEKzLNBzkeQWCKun4UXe",
    genre: "deep soul house,float house",
    popularity: "27",
  },
  {
    name: "Awanto 3",
    image: "https://i.scdn.co/image/ab67616d0000b2736a6d0149857bb78736aca350",
    spotify: "7KNjGFK2IZ3cOrHvDCAtMc",
    genre: "deep soul house,float house",
    popularity: "27",
  },
  {
    name: "Sied Van Riel",
    image: "https://i.scdn.co/image/30cea39017c7dd0f78931d581797536c3965309e",
    spotify: "1Cv0KzvQ0KP210KdmQQQUF",
    genre:
      "deep progressive trance,dutch trance,progressive house,progressive uplifting trance,trance,uplifting trance",
    popularity: "27",
  },
  {
    name: "Ben Rodenburg",
    image: "",
    spotify: "4mowRAo05yRs2pH7BfoZEl",
    genre: "",
    popularity: "27",
  },
  {
    name: "Perfect Stranger",
    image: "https://i.scdn.co/image/ab67616d0000b273b2884ad37d67c72ff66f7871",
    spotify: "5u9Gwvcam6HULB4DuEGLnf",
    genre: "progressive psytrance",
    popularity: "27",
  },
  {
    name: "Mike Reverie",
    image: "https://i.scdn.co/image/cc9b687536ce5f65d75f6332f7b0dc5a50dcb41d",
    spotify: "66BGGk95uamfiRchHngiCz",
    genre: "",
    popularity: "27",
  },
  {
    name: "Reboot",
    image: "https://i.scdn.co/image/ab67616d0000b2739a0259b4a3f99516508a4359",
    spotify: "3MUGWsOTNoR1OmZjgdQS3H",
    genre: "frankfurt electronic,minimal tech house",
    popularity: "27",
  },
  {
    name: "Uli Jon Roth",
    image: "https://i.scdn.co/image/c75272544187c86b977a1fa782a454f203632afe",
    spotify: "2VoP4JXyxNPIoYAFdB5ssQ",
    genre: "german hard rock,neo classical metal",
    popularity: "27",
  },
  {
    name: "Jono Toscano",
    image: "https://i.scdn.co/image/78f894ef0739d9fecfe523bb4dacaf35de2ce0e3",
    spotify: "7xooJZQVgMfXKsMYyX9xeV",
    genre: "",
    popularity: "27",
  },
  {
    name: "Petra Berger",
    image: "https://i.scdn.co/image/ab67616d0000b27358e7129e91757e4b6a75cead",
    spotify: "5R9MbfCSz54OIpSunDrGZw",
    genre: "operatic pop",
    popularity: "27",
  },
  {
    name: "KUENTA",
    image: "https://i.scdn.co/image/c59ddd7d9048f0f76755436d15e1d169decf6d49",
    spotify: "3pr6mWxBNnh2OHul3o0A0p",
    genre: "",
    popularity: "27",
  },
  {
    name: "Mathias Kaden",
    image: "https://i.scdn.co/image/7da0f26ce37dd54b053eb7b190ac920fffe1989c",
    spotify: "7gURutUeEed1hWmMVq8E0S",
    genre: "german tech house,german techno,minimal tech house,minimal techno",
    popularity: "27",
  },
  {
    name: "Falco Benz",
    image: "https://i.scdn.co/image/6469ef2ba3ac0c72c4b07b829544693f70e89ebb",
    spotify: "4Lwvp74q2AmvAKhf5ccUol",
    genre: "",
    popularity: "27",
  },
  {
    name: "Roulsen",
    image: "https://i.scdn.co/image/4337e5d37dbb6f097772457e0e402df263892d1c",
    spotify: "60m6PSYd57LzwCPe981VdM",
    genre: "",
    popularity: "27",
  },
  {
    name: "Ronald Van Gelderen",
    image: "https://i.scdn.co/image/ab67616d0000b2737bafb2dc83c6495ed2bc50c8",
    spotify: "73olDgpt0sjoNaCIJJLQ8W",
    genre: "trance",
    popularity: "27",
  },
  {
    name: "Cale Tyson",
    image: "https://i.scdn.co/image/c474226cbe113568af7139dfcba723a78d49e712",
    spotify: "0BU835xMjZ04GXuJSxBrJy",
    genre: "roots americana",
    popularity: "27",
  },
  {
    name: "Shifted",
    image: "https://i.scdn.co/image/07d671c820c402c2c001c50060c708c8f7b42fac",
    spotify: "3quiO6Un8G55TpLqs3gRv8",
    genre:
      "dub techno,minimal dub,new isolationism,outsider house,uk experimental electronic",
    popularity: "27",
  },
  {
    name: "King Unique",
    image: "https://i.scdn.co/image/1c81204640172fd4fd4a7d7cf434ab8b1bc6234e",
    spotify: "3tlQog0LbojvgBfa2AYb7g",
    genre: "",
    popularity: "27",
  },
  {
    name: "Carlota",
    image: "https://i.scdn.co/image/439d3e55b0f4a9dae2defe331eb85f18b7656c69",
    spotify: "7ieDG7FO3bPWJyP7EDYLvH",
    genre: "spanish noise pop",
    popularity: "27",
  },
  {
    name: "Pirupa",
    image: "https://i.scdn.co/image/a01aa34b5f4777338b42b8fe9a1b069b8adb106f",
    spotify: "4UReeTRXK8iKWTmTWMRU60",
    genre: "italian tech house",
    popularity: "27",
  },
  {
    name: "John Reilly",
    image: "https://i.scdn.co/image/ab67616d0000b2734e945bda73295b000d0bd482",
    spotify: "0h7ovzTYZqHVB7hDHqQ3nq",
    genre: "",
    popularity: "27",
  },
  {
    name: "Night Talk",
    image: "https://i.scdn.co/image/472e41dea9c326b2bce85c7cf8a90272f8b4bb4b",
    spotify: "5qBuIjfPbG4jBVCeFnCpQN",
    genre: "swiss techno",
    popularity: "27",
  },
  {
    name: "Merit Hemmingson",
    image: "https://i.scdn.co/image/b79048445147add9fa5788babf45378fd236e5e3",
    spotify: "5xoFJP7qzaMcSAghFZXI4a",
    genre:
      "classic swedish pop,folkmusik,nordic folk,swedish jazz,swedish prog",
    popularity: "27",
  },
  {
    name: "Nahawa Doumbia",
    image: "https://i.scdn.co/image/ab67616d0000b273baed8fc2e08d6674647cb6ea",
    spotify: "0lJ4sCynTDDS2Oot6PEhaV",
    genre:
      "afropop,desert blues,malian blues,mande pop,mbalax,musique mandingue,wassoulou,world",
    popularity: "27",
  },
  {
    name: "Alien Rain",
    image: "https://i.scdn.co/image/ab67616d0000b2732ad6cad31c65ae0a2bf917a8",
    spotify: "7GQjl85wH2NiOpQEFR5QVo",
    genre: "",
    popularity: "27",
  },
  {
    name: "The Nights",
    image: "https://i.scdn.co/image/7c36adf1281600433a5248c73050f20949290132",
    spotify: "2iV6SWJmgUepow3mQmwER9",
    genre: "",
    popularity: "27",
  },
  {
    name: "Willi Carlisle",
    image: "https://i.scdn.co/image/ab67616d0000b273eb446d8914af2509c1e1bad9",
    spotify: "3JXh5RaaZipkV08RQK9L3L",
    genre: "arkansas indie",
    popularity: "27",
  },
  {
    name: "Thomas Gandey",
    image: "https://i.scdn.co/image/e221119eb5d5bd8a013336653cf6b353e6f36ce3",
    spotify: "3sL1rpCWTOOABA0CKuyQcM",
    genre: "",
    popularity: "27",
  },
  {
    name: "Ida Wiklund",
    image: "https://i.scdn.co/image/3349e73c5868213ead73b37b89a46af1effb19dc",
    spotify: "2qqDZS8YzcNw2XQjkr1urQ",
    genre: "swedish folk pop",
    popularity: "27",
  },
  {
    name: "DJ Chuckie",
    image: "https://i.scdn.co/image/ab67616d0000b2739b1ab3f1caa4da1839ae4b2d",
    spotify: "3NwMwlJraqubsJPlKADvjN",
    genre: "",
    popularity: "27",
  },
  {
    name: "Panthera Krause",
    image: "https://i.scdn.co/image/23b04cfbbb0543dfcab3681125d8b2f549c277c2",
    spotify: "6vpvDZ1hqY1GUPUjvyiCjU",
    genre: "float house,leipzig electronic",
    popularity: "27",
  },
  {
    name: "Me And My Drummer",
    image: "https://i.scdn.co/image/c1bd755ce53c31169ddbeedcb84001909869ea1c",
    spotify: "1fXcy4g7D9kG63nFlKoDgf",
    genre: "german indie rock",
    popularity: "27",
  },
  {
    name: "Robert Manos",
    image: "https://i.scdn.co/image/ab67616d0000b2732cf572abb9be6f146b16af10",
    spotify: "2tQEEaWF2J3c8ysLBVpUj4",
    genre: "",
    popularity: "27",
  },
  {
    name: "Vocal Sampling",
    image: "https://i.scdn.co/image/2b5db6f0d8009aaf5fa9d47d03a58b3a884e21b3",
    spotify: "5WNsC1A1Bg1bCkylOw3bpD",
    genre: "",
    popularity: "27",
  },
  {
    name: "2000 And One",
    image: "https://i.scdn.co/image/912efd4f5c13201af8b2abdb36f4413d5b5895dc",
    spotify: "030NUgrxJxZPLc7cXUhgvD",
    genre: "",
    popularity: "27",
  },
  {
    name: "The Hundred In The Hands",
    image: "https://i.scdn.co/image/7f110155cf954e19622c1f3aecedccf31bb5fe9f",
    spotify: "1zFFPge0OhBC34dMGOrvcT",
    genre: "brooklyn indie,metropopolis",
    popularity: "27",
  },
  {
    name: "Audiophonic",
    image: "https://i.scdn.co/image/b767342ca8a9411791ee0782c025a9052cb186ab",
    spotify: "44ryvVYKLCi6LWlS4w81sK",
    genre: "",
    popularity: "27",
  },
  {
    name: "Split Prophets",
    image: "https://i.scdn.co/image/ab67616d0000b27316f48e8084eefd58fcb4a142",
    spotify: "45TbtgtOWA7GFDjDzVczyO",
    genre: "uk alternative hip hop",
    popularity: "27",
  },
  {
    name: "Daniel Maloso",
    image: "https://i.scdn.co/image/ab67616d0000b273ab74a484fa33f93cd296e7ac",
    spotify: "7j5SLy2KUc3LVi3r7xKqIe",
    genre: "deep latin alternative",
    popularity: "27",
  },
  {
    name: "Georg Wadenius",
    image: "https://i.scdn.co/image/ab67616d0000b273cc5fe45cf5f6d65ffe64eddb",
    spotify: "0E6t6iZ7yDudVStHRIMF3e",
    genre: "",
    popularity: "27",
  },
  {
    name: "Normanton Street",
    image: "https://i.scdn.co/image/bc23d97e35200575ac3d9dcaa361e46ba28e51df",
    spotify: "4ij4zQP7zuSs2B7frQti6Y",
    genre: "british soul",
    popularity: "27",
  },
  {
    name: "Kerano",
    image: "https://i.scdn.co/image/441ab280f075c86aeb5ffc38deda06153fe723e5",
    spotify: "6vSwD9yRqzaJ8lmunwIiIH",
    genre: "indian edm",
    popularity: "27",
  },
  {
    name: "METAFO4R",
    image: "https://i.scdn.co/image/629d3784442c8189d0ee9ef51f4c63e7fd54c5e9",
    spotify: "7aTljB6m794yQQAkI6lIvl",
    genre: "",
    popularity: "27",
  },
  {
    name: "An Pierlé",
    image: "https://i.scdn.co/image/ab67616d0000b27329187f730ee784f39af674af",
    spotify: "7CNlFMQD8xxS2Bm8ICos9l",
    genre: "belgian pop,belgian rock",
    popularity: "27",
  },
  {
    name: "Jawhar",
    image: "https://i.scdn.co/image/3ab11d3647c740cf9d03a740fd68369a339bccec",
    spotify: "37ASPH0bOi7XSVBTq8U9Zd",
    genre: "arab alternative",
    popularity: "27",
  },
  {
    name: "Sins Of Insanity",
    image: "https://i.scdn.co/image/6a59e92920e78b5fd1bfc98258d7571d3eda553c",
    spotify: "41jZYjNEye7JGDj0xZELcL",
    genre: "hardstyle,rawstyle,uptempo hardcore",
    popularity: "27",
  },
  {
    name: "Alessandra Roncone",
    image: "https://i.scdn.co/image/8aed5dc0dbec7adf40eb836f58df97bbc22b597e",
    spotify: "7tGyfFJ7b1VYAeQISUoz6p",
    genre: "italian trance",
    popularity: "27",
  },
  {
    name: "James Zabiela",
    image: "https://i.scdn.co/image/fd8ae52a2a4852ad20cf20928941f99ca4f22d84",
    spotify: "15mGoF7xgIMiIasAgrrQPs",
    genre: "uk house",
    popularity: "27",
  },
  {
    name: "Gangthelabel",
    image: "https://i.scdn.co/image/f4a0c8cf09c8a8b818953a3ffa306e02d2f2d748",
    spotify: "0hy63K6mxFey7ZhPPmgtOt",
    genre: "belgian hip hop",
    popularity: "27",
  },
  {
    name: "Snazzback",
    image: "https://i.scdn.co/image/144c262d1ba6dfb12b342a4d65f4b58906eae932",
    spotify: "3bD0qDLbGmvMvbaP8vHr9e",
    genre: "uk contemporary jazz",
    popularity: "27",
  },
  {
    name: "Summer Cannibals",
    image: "https://i.scdn.co/image/1c95af0353ae76d68eda9548c7cff971bc51bc7c",
    spotify: "2KXSm6sLmPwUCXpq4OrHHZ",
    genre: "indie punk,portland indie",
    popularity: "27",
  },
  {
    name: "The Outside Agency",
    image: "https://i.scdn.co/image/5d02117d979a3e310b1039d267d5d4ab3db135dc",
    spotify: "4Gh02gVaInzoBvqEnJFQDS",
    genre:
      "darkstep,doomcore,dutch dnb,gabba,happy hardcore,hardcore techno,industrial hardcore,speedcore,uptempo hardcore",
    popularity: "26",
  },
  {
    name: "Daniel Stefanik",
    image: "https://i.scdn.co/image/ab67616d0000b273dd6f0db30812ded050098170",
    spotify: "20w4lkhgYymklaCG4V6525",
    genre: "leipzig electronic,leipzig indie",
    popularity: "26",
  },
  {
    name: "Michel De Hey",
    image: "https://i.scdn.co/image/65680239fff0d72ff84b4a1d3879f3ff23dda141",
    spotify: "4BY4HaWussT44zj9RiCGzh",
    genre: "dutch tech house",
    popularity: "26",
  },
  {
    name: "Thom Bold",
    image: "https://i.scdn.co/image/7450443b400737006ebe9fcfc7ad933dabd93379",
    spotify: "1BOgDUjXcUv4hlHukDHg1L",
    genre: "",
    popularity: "26",
  },
  {
    name: "Maarten Van Roozendaal",
    image: "https://i.scdn.co/image/ab67616d0000b2738f92b0a78ed2beeff3566d51",
    spotify: "2dM0SnPCpk3KXpJMK8DEwS",
    genre: "dutch singer-songwriter",
    popularity: "26",
  },
  {
    name: "Dj Steaw",
    image: "https://i.scdn.co/image/a88ffdf06e07e26cea67e288b4aa9333ae7aeb76",
    spotify: "718Tju2ByjiEXnhaiUeQZE",
    genre: "deep soul house,minimal tech house",
    popularity: "26",
  },
  {
    name: "Makasi",
    image: "https://i.scdn.co/image/97661123dfe4692d2bae9cde5388635c0f170845",
    spotify: "6eV9xjvttxeYB2iST5hfT6",
    genre: "",
    popularity: "26",
  },
  {
    name: "Dutch Master",
    image: "https://i.scdn.co/image/eb17536a9a04d0ec52abb9b735bac94d2db5218a",
    spotify: "0G6czIsavWpeviDbk6QlS3",
    genre: "classic hardstyle",
    popularity: "26",
  },
  {
    name: "Relativ",
    image: "https://i.scdn.co/image/c99c8372e112a8ff39ac5a5e0537581f37348a3b",
    spotify: "6dv7vvNAE7BmngdTlNPXf7",
    genre: "progressive psytrance,psychedelic trance",
    popularity: "26",
  },
  {
    name: "Andy Whitby",
    image: "https://i.scdn.co/image/3937e49a5657ceaf8f7ca2af6f0b6cbc84b0635c",
    spotify: "0Dl6oKsS2ibxaqWsyJBmXd",
    genre: "bouncy house,hard house",
    popularity: "26",
  },
  {
    name: "Machine Woman",
    image: "https://i.scdn.co/image/aae1924119cf7db23d3d456b8ec5e9880f1328fa",
    spotify: "2a8NONYfrGgsdUUORy4rFa",
    genre: "electra,russian electronic,russian techno",
    popularity: "26",
  },
  {
    name: "Fröken Elvis",
    image: "https://i.scdn.co/image/aa057d9b129989d8dc571a7288125233cd226ebd",
    spotify: "4eJX7IMtVGWAex3qxydIs8",
    genre: "",
    popularity: "26",
  },
  {
    name: "Object Blue",
    image: "https://i.scdn.co/image/8ea52ce8151e2dfb49e717cc254e4849f15e2fae",
    spotify: "51rzklJj6mqBOEXOiOPqY7",
    genre: "uk experimental electronic",
    popularity: "26",
  },
  {
    name: "NSCLT",
    image: "https://i.scdn.co/image/ab67616d0000b2735070f1ca380f20c0150e4bad",
    spotify: "2APqPsoL9PeToCSlgmBcON",
    genre: "hardstyle",
    popularity: "26",
  },
  {
    name: "Cellini",
    image: "https://i.scdn.co/image/95b8516cb658489759ec5707a6eb8f33bf3d58f3",
    spotify: "5wFiSr66v5LC5Lt8MF06n3",
    genre: "",
    popularity: "26",
  },
  {
    name: "Kim Janssen",
    image: "https://i.scdn.co/image/0348aaf64949c1a8f5cc0bee72db6c73281f517a",
    spotify: "59p3YuZWUKjBcwSpeAB9x4",
    genre: "dutch singer-songwriter",
    popularity: "26",
  },
  {
    name: "Luca Bacchetti",
    image: "https://i.scdn.co/image/59ba56b6d1ddadb2a64079b3b60b8ffc0bb3668b",
    spotify: "5RcxHMJklIX1MhY7MgG9NA",
    genre: "minimal tech house",
    popularity: "26",
  },
  {
    name: "Solveig Slettahjell",
    image: "https://i.scdn.co/image/3b8c9aadf59bb4c137a92fc0e79c37041ba06904",
    spotify: "4uhYXIelKBw9dPR7TfX9sG",
    genre: "norwegian jazz",
    popularity: "26",
  },
  {
    name: "Chuckamuck",
    image: "https://i.scdn.co/image/ab67616d0000b27369f597a76233d6bcbfcaebdb",
    spotify: "1566uWDpL81kQ1otrgXO03",
    genre: "german indie,german indie rock",
    popularity: "26",
  },
  {
    name: "Matsoe Matsoe",
    image: "https://i.scdn.co/image/ab67616d0000b273c33a5d95e15e0d7cae5ac92d",
    spotify: "6C8e75Sp96VE2cyEno7pKG",
    genre: "",
    popularity: "26",
  },
  {
    name: "Jonathan Peters",
    image: "https://i.scdn.co/image/c5319608d4793c20e2963a9c06665c12aa150089",
    spotify: "4KhhrxYUjhYz3AYirtxBmD",
    genre: "tribal house,vocal house",
    popularity: "26",
  },
  {
    name: "Mc Sherlock",
    image: "https://i.scdn.co/image/ab67616d0000b2737c1620dc345c1cabd0ed6eac",
    spotify: "5FzEiZOUtBT5yx8AIVCgma",
    genre: "",
    popularity: "26",
  },
  {
    name: "Laksa",
    image: "https://i.scdn.co/image/ab67616d0000b2734efce9dfbb78f42faee73c2a",
    spotify: "6SitppNJBatzwwW1cmuQ3q",
    genre: "experimental techno",
    popularity: "26",
  },
  {
    name: "Orange Skyline",
    image: "https://i.scdn.co/image/51e09283c8f6e69a225dbad7ed594d31c10bb08a",
    spotify: "2khmzZ3jOfcd9tJ821E6Xx",
    genre: "dutch indie",
    popularity: "26",
  },
  {
    name: "Equiknoxx",
    image: "https://i.scdn.co/image/7f5dbbfacdb64133533fd2f06767708d77bdaabc",
    spotify: "6FbXoMCYyZ0YgBY8CzrlS6",
    genre: "",
    popularity: "26",
  },
  {
    name: "D.K.",
    image: "https://i.scdn.co/image/3f3a624cf3da21f80eb0c428139ae8b65a6487b1",
    spotify: "6JGGS3JOcMIxa0QF6pFnzN",
    genre: "float house,fourth world,outsider house",
    popularity: "26",
  },
  {
    name: "Shlomi Aber",
    image: "https://i.scdn.co/image/abd4bf0abac85b61ec0b819de67edfed92c86ab0",
    spotify: "3A8XSMPreJlCBlpSZVHU5J",
    genre: "israeli techno,minimal tech house,spanish techno,tech house",
    popularity: "26",
  },
  {
    name: "Dan August",
    image: "https://i.scdn.co/image/f19563f45953e5d88d6a6d20aae4063c1751dd66",
    spotify: "1kcezCICHGOfUNM7H1kLzQ",
    genre: "",
    popularity: "26",
  },
  {
    name: "Danny Howells",
    image: "https://i.scdn.co/image/1299ee6cfdc69780c7bd2be0d5744e58d8e89994",
    spotify: "404Jr6ogdJwSHAfdwD1AN2",
    genre: "tech house,uk house",
    popularity: "26",
  },
  {
    name: "Cookhouse",
    image: "https://i.scdn.co/image/5680231c420a8aa044c98bb5035d084fcd632ffd",
    spotify: "2WgdUdSR8xudGOXLzSMJ4g",
    genre: "",
    popularity: "26",
  },
  {
    name: "D. Tiffany",
    image: "https://i.scdn.co/image/ab67616d0000b273b86c1a1b73824868efa53066",
    spotify: "2LMaARRMktW5O2umBFaQUu",
    genre: "float house,lo-fi house,outsider house",
    popularity: "26",
  },
  {
    name: "Birth Of Joy",
    image: "https://i.scdn.co/image/14414e5f65d702bf0e781b536320c543e14ea929",
    spotify: "634B8f7S6YwveFT4zunhGB",
    genre: "dutch blues,dutch indie,dutch rock",
    popularity: "26",
  },
  {
    name: "Garrett T. Capps",
    image: "https://i.scdn.co/image/601f3817ca74445ed232637f015046c5b95eb748",
    spotify: "3UfahkMdvHMVKfRJAxA4Tv",
    genre: "alternative country,roots americana,san antonio indie",
    popularity: "26",
  },
  {
    name: "William Djoko",
    image: "https://i.scdn.co/image/adcdf1b3d9f310739913581bc92ec26baf58d787",
    spotify: "4EAeSI62JIrlq6cyxeV3hO",
    genre: "dutch experimental electronic",
    popularity: "26",
  },
  {
    name: "Lanark Artefax",
    image: "https://i.scdn.co/image/f8da3d0efbbde441a985fd8348902fa8cd8504ad",
    spotify: "02fDf7HEPtBZLtPzCyxSR2",
    genre:
      "deconstructed club,fluxwork,mandible,outsider house,scottish electronic,uk experimental electronic",
    popularity: "26",
  },
  {
    name: "Rob Black",
    image: "https://i.scdn.co/image/dac748c059f68c49d66ee5bd8738fdc41ce2d723",
    spotify: "6mVOQan1tOCXwFuyrAffOK",
    genre: "",
    popularity: "26",
  },
  {
    name: "Ceephax Acid Crew",
    image: "https://i.scdn.co/image/ab67616d0000b27382f2892ebdea3cb7f20cec56",
    spotify: "3Q0VPr02bPlokDVsv5T90I",
    genre:
      "acid house,acid idm,braindance,breakcore,deep idm,drill and bass,intelligent dance music",
    popularity: "26",
  },
  {
    name: "Aksak Maboul",
    image: "https://i.scdn.co/image/8f0d2b0bde6e21459142b4e8705c31384a2f9a9b",
    spotify: "6oYWNIrMewoS8GBkN8f58f",
    genre:
      "belgian experimental,canterbury scene,experimental,rock in opposition",
    popularity: "26",
  },
  {
    name: "Loraine James",
    image: "https://i.scdn.co/image/b7c282785287c47be2fd47b6d9fc0a0da8fb447c",
    spotify: "536qHynzDH1QviwhWY9dE3",
    genre: "deconstructed club,outsider house,uk experimental electronic",
    popularity: "26",
  },
  {
    name: "Aafke Romeijn",
    image: "https://i.scdn.co/image/242fab4bd0402c36c4fb19bb558bfe00c7ad7944",
    spotify: "7JXt7NDSPYN39EDLs58huE",
    genre: "dutch indie",
    popularity: "26",
  },
  {
    name: "Mumdance",
    image: "https://i.scdn.co/image/aeb048078e013a6829ecaca8268321fdefc1c0db",
    spotify: "7AqtQ161yX7B1509Pq0F6V",
    genre: "uk experimental electronic,weightless",
    popularity: "26",
  },
  {
    name: "Ex-Terrestrial",
    image: "https://i.scdn.co/image/c7bab324005ae748cc61d53275d2f2fe1796fdc1",
    spotify: "5jmHa0B92ooQvYyIPrb3ET",
    genre: "canadian house,float house,outsider house",
    popularity: "26",
  },
  {
    name: "Alvita",
    image: "https://i.scdn.co/image/2df721e3af2d13155c6b597b274758d33dec58b7",
    spotify: "7pBOITqchmeLdaWJyjAW0N",
    genre: "deep big room,dutch house",
    popularity: "26",
  },
  {
    name: "Soulvation",
    image: "https://i.scdn.co/image/569e6af55e8a1678ad43bb5662753680f90785ba",
    spotify: "5fqQzjUtN4MDsRUOUl29bh",
    genre: "dutch house",
    popularity: "26",
  },
  {
    name: "Horse Lords",
    image: "https://i.scdn.co/image/7d9a414890224685b232da22df766920951b13f9",
    spotify: "0Oslq5zLftqRVwKseBJ7MV",
    genre: "baltimore indie,experimental,freak folk,garage psych,math rock",
    popularity: "26",
  },
  {
    name: "Keizer Jelle",
    image: "https://i.scdn.co/image/55dc4ab3984d9432621c36857e202a254b9fe08e",
    spotify: "2pC7NEmQM0hrC4Rfg4pluI",
    genre: "",
    popularity: "26",
  },
  {
    name: "Avidus",
    image: "https://i.scdn.co/image/38ee6e7ab8de1c2c6555beb4b113577a2397a071",
    spotify: "6v1l56EZ8Wl7gpZhfihaKQ",
    genre: "",
    popularity: "26",
  },
  {
    name: "Applescal",
    image: "https://i.scdn.co/image/9ef8acf44a1077c00c34c9dccb7f0c12c1fc017b",
    spotify: "3OOOyfUshaLXxcMdlGl7H5",
    genre: "microhouse,minimal techno",
    popularity: "26",
  },
  {
    name: "misstress barbara",
    image: "https://i.scdn.co/image/5122e3aa342485779b6219432cee79f341b27ff3",
    spotify: "1Bhw1NGkIlsdVb8NXOymzk",
    genre: "",
    popularity: "26",
  },
  {
    name: "Woody Pines",
    image: "https://i.scdn.co/image/ab67616d0000b273b6496794e7208117b2399d7d",
    spotify: "1loOm8qOhpLtzalvVLPcI8",
    genre: "modern old-time",
    popularity: "26",
  },
  {
    name: "The Voyagers",
    image: "https://i.scdn.co/image/ab67616d0000b273088d0090113b0605eef29bf2",
    spotify: "0kD7FAemiMmweaPtg0XIMq",
    genre: "",
    popularity: "26",
  },
  {
    name: "Roly Porter",
    image: "https://i.scdn.co/image/3eddaf42af44fa2ac9ca53f84c2304f2d14d4ca2",
    spotify: "4RN8pUdphaky5GRL8rUL6P",
    genre:
      "deconstructed club,drone,mandible,new isolationism,sound art,uk experimental electronic",
    popularity: "26",
  },
  {
    name: "James Leg",
    image: "https://i.scdn.co/image/43b729fba546144e21f8c0249160eb3ea5d4e50f",
    spotify: "6jNXAv3sQluGbLUdheWe78",
    genre: "modern blues rock,punk blues",
    popularity: "26",
  },
  {
    name: "Dead Fingers",
    image: "https://i.scdn.co/image/ab67616d0000b273d30fc54ef5f42313f8f738f1",
    spotify: "5TZNvC6pnkFTjNpJWlfwdU",
    genre: "alabama indie,stomp and flutter",
    popularity: "26",
  },
  {
    name: "Djoko",
    image: "https://i.scdn.co/image/43a1bcb120b29482e876d27cf03530364f3c82bc",
    spotify: "5GryKIg2j54ytNwK7JJeGx",
    genre: "",
    popularity: "26",
  },
  {
    name: "Izaline Calister",
    image: "https://i.scdn.co/image/ab67616d0000b27322a5db6bae95523f1e69f40d",
    spotify: "1VBphNSqpOcYc2Fn5wL9AZ",
    genre: "antilliaanse folklore,ritmo kombina",
    popularity: "26",
  },
  {
    name: "Brutality Will Prevail",
    image: "https://i.scdn.co/image/ab67616d0000b27332208c269da90f2d787a8a97",
    spotify: "3Lrq7jnwOegUxvOYbd49fw",
    genre: "beatdown,chaotic hardcore,ukhc",
    popularity: "26",
  },
  {
    name: "Tessela",
    image: "https://i.scdn.co/image/fd2ec6755a1eb4b4aea8ab06f17312305d26e8b9",
    spotify: "1ZgWT8v2NTxXJapNzqJMnd",
    genre: "bass music,future garage",
    popularity: "26",
  },
  {
    name: "N0V3L",
    image: "https://i.scdn.co/image/218731176fbfed78914d5d72a8fc845bbd050c98",
    spotify: "7hB25IiKPmhATGtFwDbylS",
    genre: "canadian post-punk,garage psych,vancouver indie",
    popularity: "26",
  },
  {
    name: "Deserted Fear",
    image: "https://i.scdn.co/image/6b1610666337abe25108b42726176cf7c95f84bd",
    spotify: "3CDoiu519MbxFWcwRFH7cH",
    genre: "german death metal,grisly death metal",
    popularity: "26",
  },
  {
    name: "Slim Shore",
    image: "https://i.scdn.co/image/584163590eb2c055dfb5d0b9cec1354b80add39a",
    spotify: "0g6xDSNn61xcJRSycDRuKk",
    genre: "classic hardstyle,rawstyle",
    popularity: "26",
  },
  {
    name: "Ghalia Benali",
    image: "https://i.scdn.co/image/797c097336f5364680b2b4cd6d153d6f3a591b49",
    spotify: "7BOI7fetZ2yzDpBUiCMyYy",
    genre: "arab folk,belgian modern jazz",
    popularity: "26",
  },
  {
    name: "Gjermund Larsen Trio",
    image: "https://i.scdn.co/image/b52a1e40aad130fda1d7865165aac94d9dc13a8d",
    spotify: "6BtMdMLjwxwV29m5nKItze",
    genre: "danish folk,folkmusik,nordic folk,norwegian folk",
    popularity: "26",
  },
  {
    name: "Black Mirrors",
    image: "https://i.scdn.co/image/906c179feb743ff2f5a37e6485d771971da40b97",
    spotify: "4w33cU2I5e7gbFMpqxFD5w",
    genre: "belgian stoner rock",
    popularity: "26",
  },
  {
    name: "Dirtyloud",
    image: "https://i.scdn.co/image/17a3a5b744742b8e234fb07a53a6fb5a1fd04929",
    spotify: "04iRnEWpMluxmkSZ5oQFZ3",
    genre: "complextro,electro house",
    popularity: "26",
  },
  {
    name: "Gypsy Hill",
    image: "https://i.scdn.co/image/5d724c8b00df894c64012e23fb7fa8d36f675ee1",
    spotify: "5yhampTqXyor0WERIKV7rH",
    genre: "balkan brass",
    popularity: "26",
  },
  {
    name: "Craze",
    image: "https://i.scdn.co/image/e31e3d23b52d28d81ecb63a927ad0c52186f2f20",
    spotify: "1CxiYuhxzUwYDPQSZw076D",
    genre: "",
    popularity: "26",
  },
  {
    name: "Escalandrum",
    image: "https://i.scdn.co/image/3b86c2d6c28d7e5f0511dc65a55f4d90dd9d2d6a",
    spotify: "3QZEbpYuO36TVmqHEbxpkZ",
    genre: "argentine jazz",
    popularity: "26",
  },
  {
    name: "Britta Unders",
    image: "https://i.scdn.co/image/ab67616d0000b2732110e9abfc0ba258163c6fb2",
    spotify: "0Av1m9uxCutCXl2UxztAyg",
    genre: "",
    popularity: "26",
  },
  {
    name: "Sights & Sounds",
    image: "https://i.scdn.co/image/bc07e818e528999f3339f21a4a12662e6cbf70e2",
    spotify: "0XWX7Mq0OUjQZtPxREERBJ",
    genre: "",
    popularity: "26",
  },
  {
    name: "Hermanez",
    image: "https://i.scdn.co/image/ed08f4c08e95d9287e578c3203488693fb1008d8",
    spotify: "4JPGyWMMmaxIRcS4zItdHJ",
    genre: "belgian edm,organic house",
    popularity: "26",
  },
  {
    name: "Laurence Jones",
    image: "https://i.scdn.co/image/9eba0333c178223e80643783ca241bdc8297b540",
    spotify: "2vX8hKHgReZ15YguZe3Zxj",
    genre: "modern blues,modern blues rock",
    popularity: "26",
  },
  {
    name: "Xander De Rycke",
    image: "https://i.scdn.co/image/fd99ae083adfc6267c4be61eddeef829e0beff07",
    spotify: "4n2CrscgDeHXonDhKIPhE9",
    genre: "vlaamse cabaret",
    popularity: "26",
  },
  {
    name: "Total Chaos",
    image: "https://i.scdn.co/image/630e25c0a91862348d575fd32cc97e19885d486d",
    spotify: "1KFz81eR4ZcTBqDQjwkgDP",
    genre: "austrian hip hop,oi,street punk",
    popularity: "26",
  },
  {
    name: "Old Man Markley",
    image: "https://i.scdn.co/image/b42686af48595fb2ebf93a54866c0c1545e7fe29",
    spotify: "29mmbRyCPYV9Ls4BKadNhA",
    genre: "autoharp,folk punk",
    popularity: "26",
  },
  {
    name: "Dimitris Mystakidis",
    image: "https://i.scdn.co/image/7805ee9863b0f052c31113d6349e349d8c52cbd0",
    spotify: "4k4ouEjt2ds7377yrY3mky",
    genre: "entehno,greek indie,greek swing",
    popularity: "26",
  },
  {
    name: "Hardhaus",
    image: "https://i.scdn.co/image/2b428560fa1f9821f53b144e8b1c5a094be34ac9",
    spotify: "1gWZwIXVr79uPHLQmqD1qM",
    genre: "norwegian country",
    popularity: "26",
  },
  {
    name: "Albert af Ekenstam",
    image: "https://i.scdn.co/image/bce03b5dc04dd08774b80536e59b1151cd033a5b",
    spotify: "4c6Qf7d1Zjv5ChEK9TTztG",
    genre: "swedish indie folk,swedish singer-songwriter",
    popularity: "26",
  },
  {
    name: "Dolf Jansen",
    image: "https://i.scdn.co/image/ab67616d0000b273cd336fea1bb19843093df403",
    spotify: "2p2cy4Av12ZHUtEpzik19W",
    genre: "dutch cabaret",
    popularity: "25",
  },
  {
    name: "Christian Burkhardt",
    image: "https://i.scdn.co/image/ce32fc43274a29d6a1031e32d396b24b678903cc",
    spotify: "56zXrFfXFtRh11ChpytOiw",
    genre: "frankfurt electronic,minimal tech house,tech house",
    popularity: "25",
  },
  {
    name: "Willy Monfret",
    image: "https://i.scdn.co/image/f1ea260f67dc7453bdd7d0faea4160e53b11a4e6",
    spotify: "6G7ss93jR1XANkZPyD9mj6",
    genre: "",
    popularity: "25",
  },
  {
    name: "Holger Hecler",
    image: "https://i.scdn.co/image/8a78068da8ecc3feacd88238e122428251b76641",
    spotify: "1ygMrB9ThD8b7ySv4B2MzY",
    genre: "",
    popularity: "25",
  },
  {
    name: "Tsepo",
    image: "https://i.scdn.co/image/ab67616d0000b273e5dcbd6b723eb244917e0172",
    spotify: "2ddrvJRLukdqsvi7HaLTPt",
    genre: "",
    popularity: "25",
  },
  {
    name: "Short Round",
    image: "https://i.scdn.co/image/82f3e06d54e4ae0244f977a55ae1c5d796866b29",
    spotify: "3DpQek7q8k2NE0QHOPwkHq",
    genre: "indian indie",
    popularity: "25",
  },
  {
    name: "Lee Gamble",
    image: "https://i.scdn.co/image/f4d24f3e190984b02328d3ed481605f1b05c2d46",
    spotify: "7rAD9Ws0ihREeDmgPS2ZL8",
    genre:
      "bass music,deconstructed club,intelligent dance music,outsider house,uk experimental electronic,weightless",
    popularity: "25",
  },
  {
    name: "Skitzofrenix",
    image: "https://i.scdn.co/image/0155c04cfa82f55deecbe51fdf541e3b1f88f59e",
    spotify: "6SOHL6NW1koixk317zyiPR",
    genre: "dutch house",
    popularity: "25",
  },
  {
    name: "The Charm The Fury",
    image: "https://i.scdn.co/image/972db66e1e058ae56b94a528cc81786362c00e43",
    spotify: "1AaHt93G0EIiO4Bl4gaEC1",
    genre: "slayer",
    popularity: "25",
  },
  {
    name: "Alamo Race Track",
    image: "https://i.scdn.co/image/a46c1015f910b7629df0bf76f60b66c79b015b91",
    spotify: "3Ta9WBxUkSt6k4UNZ3Z2lX",
    genre: "dutch indie",
    popularity: "25",
  },
  {
    name: "Caine",
    image: "https://i.scdn.co/image/514e2057876a308a24e059e4fd65e4f7ffd05658",
    spotify: "1MQLUcIxIPcvNxf29446Lj",
    genre: "rawstyle",
    popularity: "25",
  },
  {
    name: "Deterrent Man",
    image: "https://i.scdn.co/image/8b6b31563511c5b61df26764261e614c76fe71ed",
    spotify: "5KtFGo8AVOWFZgBhKDxDlR",
    genre: "frenchcore",
    popularity: "25",
  },
  {
    name: "Neverdogs",
    image: "https://i.scdn.co/image/934ecd03c764c72aa3d8a8b0d210b3d9e27a3a77",
    spotify: "3becscfJYJg8fgM4QOcoP5",
    genre: "uk tech house",
    popularity: "25",
  },
  {
    name: "Vandal!sm",
    image: "https://i.scdn.co/image/ab67616d0000b2732a43f9915733e27d0440a0b6",
    spotify: "34gGWxDix1DnDFwFWg4tn4",
    genre: "uptempo hardcore",
    popularity: "25",
  },
  {
    name: "FATA BOOM",
    image: "https://i.scdn.co/image/16b1845a1a2efe78881d0115a35fdb7f5ec06581",
    spotify: "4GioeqLGgBkn9rRB12bor4",
    genre: "",
    popularity: "25",
  },
  {
    name: "De Kift",
    image: "https://i.scdn.co/image/ab67616d0000b27349afaade26bdc6b5eb932c53",
    spotify: "6AcGHSbhFlHaU7KmT5wdnJ",
    genre: "dutch indie,dutch rock",
    popularity: "25",
  },
  {
    name: "Genairo Nvilla",
    image: "https://i.scdn.co/image/49ba7b07f12f47e2bc96ca574a088d2c0e8a8767",
    spotify: "1jcktnRawixaqiP98O8aJm",
    genre: "dutch house",
    popularity: "25",
  },
  {
    name: "Loefah",
    image: "https://i.scdn.co/image/6201a2073277b7c9f752708054c65366d668d64b",
    spotify: "1ICQEDALtLouPV8yEaJXVb",
    genre: "deep dubstep,dubstep",
    popularity: "25",
  },
  {
    name: "Ja, Panik",
    image: "https://i.scdn.co/image/9925e57086b02f4b08c87ea9ee8a864345bfc54b",
    spotify: "3grEqW457YHOwO2LfkPwRX",
    genre: "vienna indie",
    popularity: "25",
  },
  {
    name: "Generik",
    image: "https://i.scdn.co/image/70a86a3806cfa1e9427a028a46bd68944afbb372",
    spotify: "5nzJoECVrmCxkbcLyvDpEI",
    genre: "",
    popularity: "25",
  },
  {
    name: "Austin Lucas",
    image: "https://i.scdn.co/image/82f51f1a25681077563f104d01c1f6c1de684beb",
    spotify: "2xXNqL807BAunM2FdmAixU",
    genre: "folk punk",
    popularity: "25",
  },
  {
    name: "Tusky",
    image: "https://i.scdn.co/image/0d04623897e24dc7359c90f69cfa61bbcc48b1c3",
    spotify: "6XbZ8G0cFqSgUL4FmtiSPr",
    genre: "dutch punk,dutch rock",
    popularity: "25",
  },
  {
    name: "Iguana Death Cult",
    image: "https://i.scdn.co/image/6b2033b45da8ac31930afb3731bf127a3f6dc16f",
    spotify: "3krOZK9c8q5QOdt9QSdEV8",
    genre: "dutch indie,dutch indie rock",
    popularity: "25",
  },
  {
    name: "Nathan Barato",
    image: "https://i.scdn.co/image/db79b39d9b704cb322b516a67886c43161b87789",
    spotify: "33eoqQdCfwtPl1hPS1Xlt4",
    genre: "canadian electronic",
    popularity: "25",
  },
  {
    name: "Scratcha DVA",
    image: "https://i.scdn.co/image/96d74ec7152f32f0673ec243f8f99cf54b533e13",
    spotify: "4RsQj1228RD7TFtUGCKRg7",
    genre: "bass music,footwork,future garage",
    popularity: "25",
  },
  {
    name: "Rayen Panday",
    image: "https://i.scdn.co/image/c7cab4a7a238c198eb7845f7ba4ab017e04cee7a",
    spotify: "01DwAbBulJtVaMEYmEqyiR",
    genre: "",
    popularity: "25",
  },
  {
    name: "TerrorClown",
    image: "https://i.scdn.co/image/e5d1bc8dbc39d68045bd9c76f6dc0f8aae148dc9",
    spotify: "4zL9MTFtg43EJgwarYpPAz",
    genre: "speedcore,uptempo hardcore",
    popularity: "25",
  },
  {
    name: "Ha Ha Tonka",
    image: "https://i.scdn.co/image/df090aeb6f67f81b60261691aca602eb203f642d",
    spotify: "0V8xaun2So5GLeMAC0fpbW",
    genre: "kc indie,springfield mo indie",
    popularity: "25",
  },
  {
    name: "Nordmann",
    image: "https://i.scdn.co/image/933973abffea338ef0e4a858747c2809ba779e94",
    spotify: "0Uox3PUw47qEqroDggrDRE",
    genre: "belgian indie,belgian modern jazz",
    popularity: "25",
  },
  {
    name: "Michael Krebs",
    image: "https://i.scdn.co/image/902569798e88646f4ccc5798a7c510cc61f9dc21",
    spotify: "5GEMeB7XJKRzNlRmfNO4dl",
    genre: "",
    popularity: "25",
  },
  {
    name: "Monoloc",
    image: "https://i.scdn.co/image/a91bd423deb073c9e9ec10650259cb16c1c24792",
    spotify: "6tiDOAkBNxnrDCbuXlEqT1",
    genre: "deep techno,frankfurt electronic,minimal dub",
    popularity: "25",
  },
  {
    name: "The Mysterons",
    image: "https://i.scdn.co/image/b2a8fa636627be63e625b8c94ed0b50b6ceb81dd",
    spotify: "0VuoStDUmutuXoPuTnYeG1",
    genre: "dutch indie",
    popularity: "25",
  },
  {
    name: "Atish",
    image: "https://i.scdn.co/image/e93ee83cea711f24eb58f0b543c0f29fe9254a25",
    spotify: "78RY8tWBNtm7UkMImOTpjT",
    genre: "",
    popularity: "25",
  },
  {
    name: "Electrosoul System",
    image: "https://i.scdn.co/image/13bb34217cc9ba898bd5ddb46bfafb36d64b011c",
    spotify: "0tSNYelLMRA52oDWmw5eU3",
    genre: "drumfunk,liquid funk,russian dnb",
    popularity: "25",
  },
  {
    name: "David Herrero",
    image: "https://i.scdn.co/image/ab67616d0000b27341de823b93da37235615f6f5",
    spotify: "7mNBit6W1boNnvOSVQCB8h",
    genre: "funky tech house,latin tech house",
    popularity: "25",
  },
  {
    name: "The Homesick",
    image: "https://i.scdn.co/image/d61eeb2701b1d015cdd88d1e9a9a2e0e2f9b8430",
    spotify: "6q5SrkgP73lW6VpQnReiaS",
    genre: "chamber psych,dutch indie,dutch indie rock,garage psych",
    popularity: "25",
  },
  {
    name: "Queenz of Piano",
    image: "https://i.scdn.co/image/3b26f2723a6747fc754e3cf40522e2d51a58db81",
    spotify: "17L2cs2P9cHQy3hB7cYLkz",
    genre: "",
    popularity: "25",
  },
  {
    name: "The Headhunters",
    image: "https://i.scdn.co/image/15b8e9ea6642a2a4b7109d414a3f52b473304fd0",
    spotify: "5JzA5RES9AMM9bK3oDyulT",
    genre: "jazz funk",
    popularity: "25",
  },
  {
    name: "Trio Da Kali",
    image: "https://i.scdn.co/image/fbb9486fc37237d0e9057addbc4e979c2388ae02",
    spotify: "1DGgYTjkEw1sxzCBcXqZU5",
    genre: "balafon,ngoni",
    popularity: "25",
  },
  {
    name: "Dazzled Sticks",
    image: "https://i.scdn.co/image/ab67616d0000b273938575af7109755e7f475d4a",
    spotify: "525dXyQLsmxd9Ryw3kFYkW",
    genre: "",
    popularity: "25",
  },
  {
    name: "Two Pauz",
    image: "https://i.scdn.co/image/72ddeec2c9e5f2f652633c0d68d426939a90fc0a",
    spotify: "6YyD55EBlL5bCCjjEoDH4v",
    genre: "belgian edm",
    popularity: "25",
  },
  {
    name: "Meccano Twins",
    image: "https://i.scdn.co/image/0bed8106da1eed2db8d71d06c3e34a9a37ea7e5d",
    spotify: "4SYJNUTeuqa13uUqrRGGgt",
    genre: "dark hardcore,gabba,happy hardcore,hardcore techno",
    popularity: "25",
  },
  {
    name: "Konvent",
    image: "https://i.scdn.co/image/57588a7e64f735aca186d82e2bff98de5ce3f31c",
    spotify: "0GLSraWh95uXS5s8nIuJ8Q",
    genre: "danish death metal,danish metal",
    popularity: "25",
  },
  {
    name: "Ameli Paul",
    image: "https://i.scdn.co/image/fb8560e62fe101428faefe6ecae81984259cc8d2",
    spotify: "2pVs2F50UrSwUthN16rTJc",
    genre: "",
    popularity: "25",
  },
  {
    name: "Richard Fearless",
    image: "https://i.scdn.co/image/485038e72ef8c54061b05a1039b7cfa43d959ea4",
    spotify: "4UaXtuRUnYFu307v3Ew9xY",
    genre: "float house",
    popularity: "25",
  },
  {
    name: "Helena Legend",
    image: "https://i.scdn.co/image/4423afa10ea6746e00ef8270bde897f2da55a7d1",
    spotify: "17t5haQfcZoTTzN3btCMF0",
    genre: "electra",
    popularity: "25",
  },
  {
    name: "Bloodshot Bill",
    image: "https://i.scdn.co/image/ab6772690000c46c2686dc27c8673dde42779ecb",
    spotify: "4hXAGYc0vplYDIfDfD7tnN",
    genre: "canadian rockabilly,garage punk blues,montreal indie,punk blues",
    popularity: "25",
  },
  {
    name: "Terilekst",
    image: "https://i.scdn.co/image/6dd6de0934f07a083caba7922338608d081adc9d",
    spotify: "1KVb90co8u2yV4SfJuKOnc",
    genre: "dutch hip hop",
    popularity: "25",
  },
  {
    name: "Charly Luske",
    image: "https://i.scdn.co/image/ab67616d0000b27384592f14404ba5e715b85682",
    spotify: "3ywMhp8487caLDqLh6fGOl",
    genre: "",
    popularity: "25",
  },
  {
    name: "The Zilzies",
    image: "https://i.scdn.co/image/ef0661172bc30b04beca96790a07c398ff77c61b",
    spotify: "7o2LmdHCny6rcVF3sHAnC2",
    genre: "",
    popularity: "25",
  },
  {
    name: "Liam Wilson",
    image: "https://i.scdn.co/image/a64ed632c8cef8875ee8948d2c12d9867f8447ed",
    spotify: "0cR6WdZTvQ829SkErzUZOC",
    genre: "tech trance",
    popularity: "25",
  },
  {
    name: "Mbongwana Star",
    image: "https://i.scdn.co/image/f483cba35033a87977270892c9137eae76e6b1d0",
    spotify: "2zvrV2uB7FH9HAGsg93cMy",
    genre: "african electronic",
    popularity: "25",
  },
  {
    name: "KO KO MO",
    image: "https://i.scdn.co/image/6a404cf78119ed90963996165cdb87d741821572",
    spotify: "37njHbDvYnaoRWbRwVTdaZ",
    genre: "rock alternatif francais",
    popularity: "25",
  },
  {
    name: "Etapp Kyle",
    image: "https://i.scdn.co/image/6656e55c80867b19c6964706577f60395ef4ba70",
    spotify: "4F4nGwhfwU7cI26FXK9ZlE",
    genre:
      "float house,minimal dub,ukrainian electronic,ukrainian experimental",
    popularity: "25",
  },
  {
    name: "Abramowicz",
    image: "https://i.scdn.co/image/db8d72e23b4037dc194974af94b98ad2a9d60b34",
    spotify: "6rk0B0VcWH7YxKl5b9hoYJ",
    genre: "german punk rock",
    popularity: "25",
  },
  {
    name: "Graveyard Train",
    image: "https://i.scdn.co/image/ab67616d0000b273cd08b0181398edc40877073a",
    spotify: "2RzRCUVzVGeNogy1s5AHOf",
    genre: "gothic americana",
    popularity: "25",
  },
  {
    name: "Zanger Hans",
    image: "https://i.scdn.co/image/ab67616d0000b273ea15e9f8e95ec3aa1b447a66",
    spotify: "4GT2sc9YlamfpbcCBavxxR",
    genre: "",
    popularity: "25",
  },
  {
    name: "Elle Rich",
    image: "https://i.scdn.co/image/01b9a0fa001294c7ac8277a24f4cb0759d255995",
    spotify: "3hYMdlOX4wQqzwmn6alCO6",
    genre: "",
    popularity: "25",
  },
  {
    name: "LondonBridge",
    image: "https://i.scdn.co/image/062f907d6f479c2182463af019b6dfd9ed8808b2",
    spotify: "7pxo7T9W7Mg9LmOoaaiqFC",
    genre: "",
    popularity: "25",
  },
  {
    name: "Staff Benda Bilili",
    image: "https://i.scdn.co/image/ab67616d0000b273621c1f2a3fb4554d1420f492",
    spotify: "18yvYM7OTI5lLkbcz0Daio",
    genre: "afropop,desert blues,world",
    popularity: "25",
  },
  {
    name: "Nicolas Kanza",
    image: "https://i.scdn.co/image/892be03f5e8b893c60c2758c5717910fb5cc066f",
    spotify: "751YCAfHx8dQSUbAN8Q9dl",
    genre: "channel pop",
    popularity: "25",
  },
  {
    name: "15grams",
    image: "https://i.scdn.co/image/06086f0819ce196f2bb225255bd00d9f678a1697",
    spotify: "1O6ddbpGxRTse2V0YEkhNH",
    genre: "",
    popularity: "25",
  },
  {
    name: "Space Of Variations",
    image: "https://i.scdn.co/image/abc4c828fa9d78466c7f6f13b03e3feee2060cb3",
    spotify: "6mcSNYbGthL93gHZEIdsw6",
    genre: "",
    popularity: "25",
  },
  {
    name: "Phrantic",
    image: "https://i.scdn.co/image/79012ae6f9e946928adc1ba1d3337caf1645ad76",
    spotify: "2Bg6vhG3aY7ixxqEGZeos6",
    genre: "classic hardstyle,hardstyle,rawstyle",
    popularity: "25",
  },
  {
    name: "Eneida Marta",
    image: "https://i.scdn.co/image/ab67616d0000b2732a2eccb51819eecffc6d10ca",
    spotify: "0vdtQahAxzU1jvuyer6ppS",
    genre: "gumbe,morna",
    popularity: "25",
  },
  {
    name: "TP4Y",
    image: "https://i.scdn.co/image/ab67616d0000b273f9db31cb2b6800febadc2e55",
    spotify: "7ncXvRgpeELvS692m8N9Ka",
    genre: "dutch pop",
    popularity: "25",
  },
  {
    name: "Anunaku",
    image: "https://i.scdn.co/image/a15ed0e8e1cb3cb92f09aade4562503addf2ba82",
    spotify: "0dAzvKzbG3tMwFeWkjgHrZ",
    genre: "experimental club,float house",
    popularity: "25",
  },
  {
    name: "Frontier Ruckus",
    image: "https://i.scdn.co/image/69f1e307bc445fae00f22aac02b936fd9d35b566",
    spotify: "74r3GBZ9epHon6WM1sU6L7",
    genre:
      "ann arbor indie,banjo,detroit indie,michigan indie,stomp and holler",
    popularity: "25",
  },
  {
    name: "Nikki Hill",
    image: "https://i.scdn.co/image/1439f5abd5c667ae6228abb054aa592ace72c2c9",
    spotify: "28Vn4HKpcOqzagc7tiAxNz",
    genre: "",
    popularity: "25",
  },
  {
    name: "Soccer96",
    image: "https://i.scdn.co/image/aeab056365ec2122aa9eb1f4550fcd6edf6bd774",
    spotify: "5CPQQs8WGfYZjEyRu3mkij",
    genre: "",
    popularity: "25",
  },
  {
    name: "Miss Melera",
    image: "https://i.scdn.co/image/3135f736f5827f6278e906117bf628f9eb6e0afb",
    spotify: "3P7dBiGBrfbqVE1Etbr9f1",
    genre: "deep techno,dutch tech house",
    popularity: "24",
  },
  {
    name: "Arjuna Schiks",
    image: "https://i.scdn.co/image/f9de8ec871d56736829eb9ef6a36eab125b89791",
    spotify: "6xVz6DzyodtQIglpFEZNLd",
    genre: "deep techno",
    popularity: "24",
  },
  {
    name: "Oddjob",
    image: "https://i.scdn.co/image/6d61225ef57d9c471441fd2275d30e95fd9efd00",
    spotify: "47E6nlZGPwspT7lokggm4n",
    genre: "swedish jazz",
    popularity: "24",
  },
  {
    name: "Luca Lozano",
    image: "https://i.scdn.co/image/ab67616d0000b273d2fcd0904ae28899bf5e44c3",
    spotify: "57YTLw15CKLrwSJKUFN5ep",
    genre: "bleep techno",
    popularity: "24",
  },
  {
    name: "Tatanka",
    image: "https://i.scdn.co/image/4b99b0f4027e7326182db5a35087c20905c288db",
    spotify: "5jT111zOggyLsQnj4LunMH",
    genre: "",
    popularity: "24",
  },
  {
    name: "Wouter S",
    image: "https://i.scdn.co/image/f4811910ee42a220fa67557ca07c78be60c6d416",
    spotify: "2FBOvuH967tVxaLwNzJSz1",
    genre: "dutch tech house",
    popularity: "24",
  },
  {
    name: "JoeySuki",
    image: "https://i.scdn.co/image/31c459aa31ccf8dcc39b4cd017ef1d4d056df7c1",
    spotify: "0Xp3PoeuaiJubx3FJIZFDn",
    genre: "big room",
    popularity: "24",
  },
  {
    name: "Puce Mary",
    image: "https://i.scdn.co/image/cea4aff487a1545cc70ef6ec6174f224b83e4679",
    spotify: "2ctwc8mjxxPLK9dbn6jjp6",
    genre:
      "danish experimental,death industrial,deconstructed club,electra,fluxwork,mandible,new isolationism",
    popularity: "24",
  },
  {
    name: "Davide Squillace",
    image: "https://i.scdn.co/image/a6a3619277c31a4f295d128a5f1b06a0e43dad6f",
    spotify: "1wQoXZDTq0UCJhXffsm7Nh",
    genre: "italian techno,minimal tech house",
    popularity: "24",
  },
  {
    name: "Double Pleasure",
    image: "https://i.scdn.co/image/e2a0a38f8de4070e49b42007ae44313ffe31ff90",
    spotify: "4CYj9Ya2aRORv06k26vFcP",
    genre: "",
    popularity: "24",
  },
  {
    name: "Omdat Het Kan Soundsystem",
    image: "https://i.scdn.co/image/a39baf7df69479f1abc55bdd35198eec43ce1578",
    spotify: "6UswNtYporOfYYEfABs4TU",
    genre: "musica andorra",
    popularity: "24",
  },
  {
    name: "Bestien",
    image: "https://i.scdn.co/image/10fbd8594f1d07e34e8346ac2ee86f92cb41d430",
    spotify: "5q3ryXRR3Qb2chLRyHtGfV",
    genre: "jumpstyle",
    popularity: "24",
  },
  {
    name: "Los Pirañas",
    image: "https://i.scdn.co/image/f865de713d3a3acdf9696f6b1be4bc26365fb8b9",
    spotify: "1TWdamQsAiOgB0szQsMSeq",
    genre: "latin afrobeat",
    popularity: "24",
  },
  {
    name: "Goetia",
    image: "https://i.scdn.co/image/98d1b6089b698d39442c85495ffea97f669e3c8c",
    spotify: "0d6TMB4GlRjs4lAKhOBddM",
    genre: "hardcore techno,speedcore,uptempo hardcore",
    popularity: "24",
  },
  {
    name: "Hazelius Hedin",
    image: "https://i.scdn.co/image/ab67616d0000b273a40d53cf50d3dbd1fe6cc1c7",
    spotify: "0PyrhR31Td86FBBtNuEiOf",
    genre: "folkmusik,nordic folk,nyckelharpa,swedish fiddle",
    popularity: "24",
  },
  {
    name: "Rigby",
    image: "https://i.scdn.co/image/751f361cab021d76e4f02c7f7d905050db40120c",
    spotify: "11uVEq37dsx0ZCbwxpu9S3",
    genre: "",
    popularity: "24",
  },
  {
    name: "Subb-an",
    image: "https://i.scdn.co/image/6a2fde66b593feab3634216c7d2b3c0863376f9d",
    spotify: "1GixPUcrjDq3qogmYXbGsh",
    genre: "deep disco house,minimal tech house",
    popularity: "24",
  },
  {
    name: "Andrew Mathers",
    image: "https://i.scdn.co/image/67e6aa066bd85a294a2b956b560d95365a5158a9",
    spotify: "5rjFsTXq2iEMk09Pxtz2U0",
    genre: "",
    popularity: "24",
  },
  {
    name: "Manuel Moreno",
    image: "https://i.scdn.co/image/9d82ef3bbda1341e593d5c8786de67f2f6e0d6a7",
    spotify: "7wHiKFueSgBpkeqBcFexCf",
    genre: "",
    popularity: "24",
  },
  {
    name: "Buttechno",
    image: "https://i.scdn.co/image/ab67616d0000b273abc7b324b58eab6d37c19e7f",
    spotify: "4XbQUkFYWthjpAPp96lHWt",
    genre: "float house,outsider house,russian electronic,russian techno",
    popularity: "24",
  },
  {
    name: "Die Heiterkeit",
    image: "https://i.scdn.co/image/8c2a10bfd638ae26afac629ce167c503bb6c4ecd",
    spotify: "3GB8VNVCarLSDdFbbDsQnF",
    genre: "german indie,german shoegaze,hamburg indie",
    popularity: "24",
  },
  {
    name: "The Idea of North",
    image: "https://i.scdn.co/image/2ee726274c5d691ec83484304efbf18225cf9822",
    spotify: "7vglii3h8p8wNHS2nGkgyh",
    genre: "a cappella",
    popularity: "24",
  },
  {
    name: "TONIO",
    image: "https://i.scdn.co/image/d713d424135a8a9afd9c9670a8f5827236ab0907",
    spotify: "5L4m9egWViNZvDYiu7snIq",
    genre: "",
    popularity: "24",
  },
  {
    name: "The BlueBirds",
    image: "https://i.scdn.co/image/b1c8ed932e876ebcb718942b06a77a10f1d38f34",
    spotify: "1WKVDXahDiNpcTlTf8ltq0",
    genre: "dutch americana,dutch pop",
    popularity: "24",
  },
  {
    name: "Rikke Thomsen",
    image: "https://i.scdn.co/image/58faea3ee5bd11a07650a5a5d41cb31b08b89dd2",
    spotify: "3FmSnpSHBucIuy2G5WeXWE",
    genre: "",
    popularity: "24",
  },
  {
    name: "Definitive",
    image: "https://i.scdn.co/image/5116ddce29df1693b17ee87e89335518e8fb21da",
    spotify: "54jJseP0c0ahtWnKyV58gl",
    genre: "turkish metal",
    popularity: "24",
  },
  {
    name: "Geoff Tate",
    image: "https://i.scdn.co/image/ab67616d0000b273415d6c070f5c3b014b61442d",
    spotify: "3eKlygZ2G8oK9KNjdbqbDA",
    genre: "",
    popularity: "24",
  },
  {
    name: "DADDY LONG LEGS",
    image: "https://i.scdn.co/image/523500ee42e5d226472750fb35bee35b9546363a",
    spotify: "26vp0YsAVautrWTzJXf6Zi",
    genre: "",
    popularity: "24",
  },
  {
    name: "Jason Bouman",
    image: "https://i.scdn.co/image/ab67616d0000b273b4b86646a005142934f1b881",
    spotify: "6V8leN6KKz3E6CCJPHw88m",
    genre: "",
    popularity: "24",
  },
  {
    name: "Saule",
    image: "https://i.scdn.co/image/55f3792957a6398be1bb362acb3a30a59b1fd342",
    spotify: "7oCas0sTR8sRH5lrOed0E8",
    genre: "deep dubstep",
    popularity: "24",
  },
  {
    name: "TRAUDES",
    image: "https://i.scdn.co/image/da304cba193a0135ce42a18750aaecdcefb0a48a",
    spotify: "1i1PgbNnZZ6OFUP6sLDKlL",
    genre: "",
    popularity: "24",
  },
  {
    name: "Love the System",
    image: "https://i.scdn.co/image/b869a1f4a544e1b5afca43da116233cfc58e7f75",
    spotify: "3XzlYuBqLlv7jo0lOFR7gX",
    genre: "modern funk",
    popularity: "24",
  },
  {
    name: "Luca Donzelli",
    image: "https://i.scdn.co/image/8cc030327aa67b02835b76aef9de91c410926b67",
    spotify: "5L2RBjmMKezVGIImlpznWz",
    genre: "italian tech house",
    popularity: "24",
  },
  {
    name: "Industrialyzer",
    image: "https://i.scdn.co/image/5f0bfe730381f533c6c4dda2d70d3b42f78b52e6",
    spotify: "4DcUFiudBGvNDIWDFIdTuJ",
    genre: "dark techno",
    popularity: "24",
  },
  {
    name: "Lisa Lashes",
    image: "https://i.scdn.co/image/d0588fc0a93c80b6850fc979715bfb33f5e1cafb",
    spotify: "60McQZr6bfr1eBpvq9YQz2",
    genre: "hard house",
    popularity: "24",
  },
  {
    name: "Jason James",
    image: "https://i.scdn.co/image/40f6f3ab59b3faacc28a0da61e68addd81c0cd7e",
    spotify: "4a1s7Yutn16VXLKfchhG0X",
    genre: "roots americana,texas country",
    popularity: "24",
  },
  {
    name: "Danny Blue and the Old Socks",
    image: "https://i.scdn.co/image/25620cfb379eda61751a179d9b6624569149ed6f",
    spotify: "5s0rjfjcB5bk1bKAE2azc8",
    genre: "belgian indie",
    popularity: "24",
  },
  {
    name: "Ashley Smith",
    image: "https://i.scdn.co/image/ca225a001605be77fbd461eb05be2b6df74312f0",
    spotify: "328ZXLXlYfj9qKiVpZRqQR",
    genre: "tech trance",
    popularity: "24",
  },
  {
    name: "Kendoll",
    image: "https://i.scdn.co/image/41739f3e0436fcc3c617593bcd41a141618d9629",
    spotify: "17lRBwcCqKBpqgfnUkop3r",
    genre: "bass house,electro house",
    popularity: "24",
  },
  {
    name: "Bukez Finezt",
    image: "https://i.scdn.co/image/66dee2c567544ca4c7c72cf4f7c2878305dec7ab",
    spotify: "7lpT19TLWJN0pPEmUF9FTH",
    genre: "deep dubstep,dubstep,filthstep",
    popularity: "24",
  },
  {
    name: "Mark Jenkyns",
    image: "https://i.scdn.co/image/a8d6bf8ef2ccd907811696dcb49d664fa23a6c6e",
    spotify: "4F5ofqBr0KhcA7LYLFnlJy",
    genre: "uk tech house",
    popularity: "24",
  },
  {
    name: "Studio Braun",
    image: "https://i.scdn.co/image/ab67616d0000b273b06a4c216be8d17e8a7374a4",
    spotify: "45QwJKSP1ORif6jv5ddytP",
    genre: "kabarett",
    popularity: "24",
  },
  {
    name: "Chainska Brassika",
    image: "https://i.scdn.co/image/40c95e9cb8afdaa43a4d0054a1423ae7ae88d0c8",
    spotify: "230GhlinaVbLrWNp99Stta",
    genre: "gypsy fusion,modern ska punk,uk reggae",
    popularity: "24",
  },
  {
    name: "Gigi Lamayne",
    image: "https://i.scdn.co/image/33938ab3a0a4373b90c9499fe0f65a21e921616e",
    spotify: "3405LTbL2jP8J0gVQK3087",
    genre: "south african hip hop",
    popularity: "24",
  },
  {
    name: "Flamingods",
    image: "https://i.scdn.co/image/83b4e65760e8b6fd625decb1b31e47efc1fa3d01",
    spotify: "225FmqaVBffuHcWCN1W5tU",
    genre: "",
    popularity: "24",
  },
  {
    name: "Fumaça Preta",
    image: "https://i.scdn.co/image/21c19a295a4829b905b857d283118bf2c28fbde5",
    spotify: "6EbouBUrGRR3KTE9m6Fcfi",
    genre: "neo-psychedelic",
    popularity: "24",
  },
  {
    name: "Digital Mindz",
    image: "https://i.scdn.co/image/d31a5ad0213e4e4e13be240be310e865d33057bd",
    spotify: "6BPReCUBYOimAPOqJqQXLW",
    genre: "euphoric hardstyle,rawstyle",
    popularity: "24",
  },
  {
    name: "Roman Poncet",
    image: "https://i.scdn.co/image/867c2d75055c84b890cfa769065d9f675d6e7801",
    spotify: "0mdnhQUUBPkV2IcrdU6X0g",
    genre: "french techno",
    popularity: "24",
  },
  {
    name: "Lazy Habits",
    image: "https://i.scdn.co/image/e6e4caa3ccce2188ec4fdce4d9b513071575e135",
    spotify: "3Bwm7GVj1bGNj6fxf80OKP",
    genre: "uk hip hop",
    popularity: "24",
  },
  {
    name: "iiiConic",
    image: "https://i.scdn.co/image/1b7860b2082ab0734deccfc8727367cb78cebfa7",
    spotify: "4U1CbpsDIvwXebLQTBTek9",
    genre: "australian hip hop",
    popularity: "24",
  },
  {
    name: "Dizraeli",
    image: "https://i.scdn.co/image/744478f6797e821a9e198acdae079c6982eb7437",
    spotify: "3xjNFu3aAWJie7LQzDoYNa",
    genre: "bristol indie",
    popularity: "24",
  },
  {
    name: "Ian Fisher",
    image: "https://i.scdn.co/image/663998452f5f02cf6834caee0aac5a2276ffd15c",
    spotify: "0dc3onVb6eTfbaavNfi1Cp",
    genre: "",
    popularity: "24",
  },
  {
    name: "Geppetto & The Whales",
    image: "https://i.scdn.co/image/9cce21acb28e3d274c3f1bc6f7813aef43985e9e",
    spotify: "1DP5eQwlIZCf02bRw2Aq38",
    genre: "belgian indie,belgian rock,ghent indie",
    popularity: "24",
  },
  {
    name: "Mintzkov",
    image: "https://i.scdn.co/image/ddb77a7714de644ea50da39985c565e7afd6df5e",
    spotify: "0WIle18b5uevJXaeivvj2z",
    genre: "belgian rock,dutch indie",
    popularity: "24",
  },
  {
    name: "CJ Ramone",
    image: "https://i.scdn.co/image/5abac1d7d39dbd07a40783cf22a51330661b17a4",
    spotify: "3jVd6Z5yEh5SSdvzkzUbUp",
    genre: "",
    popularity: "24",
  },
  {
    name: "Onipa",
    image: "https://i.scdn.co/image/0bb7e3898d4fa53fcf4732612ecedef273d95c61",
    spotify: "3M4siMIW7Pm9cT4jb1oNb5",
    genre: "afrofuturism",
    popularity: "24",
  },
  {
    name: "Urulu",
    image: "https://i.scdn.co/image/ab67616d0000b273e877ad4edaeb37c8e0969f6a",
    spotify: "7FYaJDT3DVb5xjxv9Ov1HI",
    genre: "deep soul house",
    popularity: "24",
  },
  {
    name: "Heart Of Gold",
    image: "https://i.scdn.co/image/81899159b4211a0b7fd4583f4b84378be5b85421",
    spotify: "4hqo1pdNrZHfPmSmTtMvUZ",
    genre: "",
    popularity: "24",
  },
  {
    name: "Cleveland Watkiss",
    image: "https://i.scdn.co/image/ab67616d0000b273f0c872002af5cf8ded94d5d0",
    spotify: "4O3uTQDgtY11QKfX4VJruc",
    genre: "",
    popularity: "24",
  },
  {
    name: "2nd Phase",
    image: "https://i.scdn.co/image/788a5725658a81694f4db1307025170ad30fef45",
    spotify: "1HR3Xwc78vDFhCv83qGsZ9",
    genre: "progressive uplifting trance",
    popularity: "24",
  },
  {
    name: "Speech Debelle",
    image: "https://i.scdn.co/image/82a2935836fc5f8724a72c37a8c82e1d4c5f7c06",
    spotify: "3i1MgHZrjt5ztR8InGmFsH",
    genre: "lgbtq+ hip hop",
    popularity: "24",
  },
  {
    name: "Imaginary Softwoods",
    image: "https://i.scdn.co/image/3a2ed258bdab97647f710d83ab9ba443a6086342",
    spotify: "7KUvseAKmkJLnTRikLsaPG",
    genre: "ambient,fourth world",
    popularity: "24",
  },
  {
    name: "Holygram",
    image: "https://i.scdn.co/image/39d36211dd42ab0319c48d7c33cd78090732d133",
    spotify: "1baosRAu3VAtZtX8nxVQSj",
    genre: "cologne indie,dark post-punk,german post-punk,german shoegaze",
    popularity: "24",
  },
  {
    name: "Jack Vreeswijk",
    image: "https://i.scdn.co/image/ab67616d0000b273b4c37167f97ddb18dd5db5fc",
    spotify: "2o3s58okSJjEmFQhwdG21v",
    genre: "classic swedish pop,swedish singer-songwriter",
    popularity: "24",
  },
  {
    name: "Saba Lou",
    image: "https://i.scdn.co/image/ab67616d0000b273a27bf1ae287a99a71990f5cf",
    spotify: "4FctzCzQuNPwtblJLp7LFQ",
    genre: "",
    popularity: "24",
  },
  {
    name: "Dustin Zahn",
    image: "https://i.scdn.co/image/ca899d494d28b3c47efcfb1198e92e800c3fadd5",
    spotify: "6ScDJaxsDqmtEB0CZY3WAC",
    genre: "dark techno",
    popularity: "24",
  },
  {
    name: "Excrementory Grindfuckers",
    image: "https://i.scdn.co/image/94e989b17304d94419eceee97bfc2350a762456e",
    spotify: "3LB1BBuItGcDVtmEdmJBLh",
    genre: "pornogrind",
    popularity: "24",
  },
  {
    name: "Henri Herbert",
    image: "https://i.scdn.co/image/ab67616d0000b273579b6b40d091391bb1ce41c8",
    spotify: "0G32pVd2iVT6plLjN1MZOP",
    genre: "",
    popularity: "24",
  },
  {
    name: "Spencer Parker",
    image: "https://i.scdn.co/image/feaf18362640870b61398de705bc910ad63e6ea3",
    spotify: "66D44BTpZF7SqnEOJuJLVo",
    genre: "minimal tech house",
    popularity: "24",
  },
  {
    name: "Kendis",
    image: "https://i.scdn.co/image/436fa7439b8d96584727b4f016dcdac50ddba26b",
    spotify: "1kt0Fgzz4cguWjSDODzXxT",
    genre: "",
    popularity: "24",
  },
  {
    name: "Keita Sano",
    image: "https://i.scdn.co/image/e93b41d4c01cf9c54153c49eea282f4fe7e8c31e",
    spotify: "4dBOdFLRA3l1S7I1eaSYCn",
    genre: "japanese electronic",
    popularity: "24",
  },
  {
    name: "La Inedita",
    image: "https://i.scdn.co/image/427903f4754257268ca9375d95e9d550aa3c9b54",
    spotify: "0iazHkXB3jfE8iVb1IV5AF",
    genre: "peruvian indie",
    popularity: "24",
  },
  {
    name: "Otim Alpha",
    image: "https://i.scdn.co/image/ab67616d0000b2733638fd4c6c6a14aa251d3d42",
    spotify: "07uMqKd2ikfAnQiyF0bNlV",
    genre: "african electronic",
    popularity: "24",
  },
  {
    name: "Happy Camper",
    image: "https://i.scdn.co/image/b8fc72ad67868408b4222064931926deddef29bf",
    spotify: "5DKa6wxmwykF9PwsIm8FXw",
    genre: "dutch indie",
    popularity: "24",
  },
  {
    name: "Tony Wilson",
    image: "https://i.scdn.co/image/ab67616d0000b273683559e4145d9962910d7743",
    spotify: "3nwZKsmOiJjn7x0fS3L5ZR",
    genre: "",
    popularity: "23",
  },
  {
    name: "Sascha Dive",
    image: "https://i.scdn.co/image/590095dd168c0900dbb43357ed2fa3d2786fa5b8",
    spotify: "4xSSlzl6vHXCXN2uJBgYsm",
    genre: "frankfurt electronic,minimal tech house",
    popularity: "23",
  },
  {
    name: "Christopher Rau",
    image: "https://i.scdn.co/image/db401996420746cae8da6ff0d149be8026bf38bd",
    spotify: "383Yhi82VDOiVeSUkmStTK",
    genre:
      "deep soul house,float house,german house,hamburg electronic,minimal tech house",
    popularity: "23",
  },
  {
    name: "The Speed Freak",
    image: "https://i.scdn.co/image/ab67616d0000b273786774192e4e967c9aef9197",
    spotify: "3HtFJOBdchYr7TpB63p6De",
    genre: "frenchcore,gabba,happy hardcore,hardcore techno,speedcore",
    popularity: "23",
  },
  {
    name: "rRoxymore",
    image: "https://i.scdn.co/image/3ea51eadfb37f582e73c7a06231b2c7710f93c4a",
    spotify: "559oW3wcVAW5tcL1DQniyf",
    genre: "experimental electronic",
    popularity: "23",
  },
  {
    name: "The Analogues",
    image: "https://i.scdn.co/image/1ad048f4c04e9e48072b202ec00698725dfb6813",
    spotify: "5kGU4SsIURP34e0AraFpQ2",
    genre: "",
    popularity: "23",
  },
  {
    name: "Roza Terenzi",
    image: "https://i.scdn.co/image/ab67616d0000b2735d0aa8428fb80797b79f428e",
    spotify: "403OOa2mD7jcUgpC8F7Qgs",
    genre: "australian house,experimental techno,float house",
    popularity: "23",
  },
  {
    name: "Marc-Marie Huijbregts",
    image: "https://i.scdn.co/image/ab67616d0000b273a2b310edec4024c34931bc4d",
    spotify: "3cMOQnnYgLrJKRflHbjGib",
    genre: "dutch cabaret",
    popularity: "23",
  },
  {
    name: "Hellfish",
    image: "https://i.scdn.co/image/ab67616d0000b2739f2586d03b8f9aeec11a8c58",
    spotify: "2K3IZSIfctmk8F64c1gwVn",
    genre: "gabba,hardcore techno,speedcore",
    popularity: "23",
  },
  {
    name: "Manu Le Malin",
    image: "https://i.scdn.co/image/ab67616d0000b273fdc7c6bd55a3d6f7a61fb8b4",
    spotify: "1Wv8GjvqB03vEdYaPolQEO",
    genre: "french techno,gabba,hardcore techno,speedcore",
    popularity: "23",
  },
  {
    name: "MC Gee",
    image: "https://i.scdn.co/image/ab67616d0000b273b9ef894e8a8b4b24e33ebe4e",
    spotify: "6ETacqSV8fGQoyJ1dboFlA",
    genre: "",
    popularity: "23",
  },
  {
    name: "DJ Deep",
    image: "https://i.scdn.co/image/b936d8d688db6862cfaf96b4e739ec8d4957bb3f",
    spotify: "3lbzbbtoq31WIRghjdBuuf",
    genre: "french techno",
    popularity: "23",
  },
  {
    name: "Peverelist",
    image: "https://i.scdn.co/image/13a0634db02b769deba76255f21802f41bf85070",
    spotify: "0UrA452V5vJpCW5ezx0YMP",
    genre: "bass music,bristol electronic,dubstep,future garage",
    popularity: "23",
  },
  {
    name: "Louisiana Avenue",
    image: "https://i.scdn.co/image/968c6a6d0532765d098e853542da575603070a62",
    spotify: "4pEprRBao2BlFRs8wl2RIH",
    genre: "",
    popularity: "23",
  },
  {
    name: "Miss Nine",
    image: "https://i.scdn.co/image/6442a1d512643b697479ba324fe4d46f86aeeca4",
    spotify: "4c2u8w0s3mo0iPZ67dGoTH",
    genre: "deep uplifting trance",
    popularity: "23",
  },
  {
    name: "Jake La Botz",
    image: "https://i.scdn.co/image/e0d2b4e112ec408db77f4b4c4b16f29f7040b968",
    spotify: "7pHtidPDRlqg71cTcwjWQX",
    genre: "midwest americana",
    popularity: "23",
  },
  {
    name: "Pedro Cazanova",
    image: "https://i.scdn.co/image/89a7c69d084c26703b48736973271f3a1978573f",
    spotify: "6dNq1m9FnNCqSvRa70jwo3",
    genre: "",
    popularity: "23",
  },
  {
    name: "Pert Near Sandstone",
    image: "https://i.scdn.co/image/a913ec029089d99b17f34624d3eee6c1fe8a6e5f",
    spotify: "5EKtYMQpAdMk23Or1eHCvW",
    genre: "neo-traditional bluegrass",
    popularity: "23",
  },
  {
    name: "Sousou & Maher Cissoko",
    image: "https://i.scdn.co/image/54d1990c07a2894be603b596b01a704ba776d3e7",
    spotify: "3NCqtIPq43NfGwM2pQPwL5",
    genre: "kora",
    popularity: "23",
  },
  {
    name: "Joana Serrat",
    image: "https://i.scdn.co/image/d1e6940a53ff245c5e35aafc8a3c5f431e241357",
    spotify: "1qWhRJpf4PFL9T0RXvIPWi",
    genre: "spanish folk rock,spanish modern rock",
    popularity: "23",
  },
  {
    name: "Imperial Leisure",
    image: "https://i.scdn.co/image/ab67616d0000b273cd56b45ef0109d8b977ef74d",
    spotify: "0BCEwn9PxFIhe99I8KI5wK",
    genre: "modern ska punk,ska,ska punk",
    popularity: "23",
  },
  {
    name: "MC Stretch",
    image: "https://i.scdn.co/image/ab67616d0000b27329d77d2044ecb4182f55bdb4",
    spotify: "6oIpax63yT9ajyekkcqv0L",
    genre: "",
    popularity: "23",
  },
  {
    name: "Tall Tall Trees",
    image: "https://i.scdn.co/image/8e52b57ebfa68666c36170d30f6ad432ba9325b7",
    spotify: "7E4RVv4JRB5EkgWFBmlcKx",
    genre: "asheville indie",
    popularity: "23",
  },
  {
    name: "Alexander Kowalski",
    image: "https://i.scdn.co/image/e00f1d0f7e5ba1adb7e6556c1cb6955578a9649c",
    spotify: "3h6qziz3eTK8pNQ2JSzHPs",
    genre: "german techno,techno",
    popularity: "23",
  },
  {
    name: "The Indien",
    image: "https://i.scdn.co/image/009c3ffd27167788c598ebcf7fa6cab79cd6a30a",
    spotify: "1M6DAgCuvRE1Ct0Tsq74Lb",
    genre: "dutch indie",
    popularity: "23",
  },
  {
    name: "A.ROSE",
    image: "https://i.scdn.co/image/953722f10aae18cd9791afcaf1b9b68e85c33a61",
    spotify: "2OVNpc4uw8YDruLaxNhGB5",
    genre: "",
    popularity: "23",
  },
  {
    name: "Blaxtar",
    image: "https://i.scdn.co/image/eb48ab04e18a7e61ddfffaf31352fa0397930e46",
    spotify: "74Muw2FSN8BK2mMbh2gfZM",
    genre: "dutch hip hop",
    popularity: "23",
  },
  {
    name: "Vic Willems",
    image: "https://i.scdn.co/image/ef362f39175c0b9053946e3d8ab5c502734c8349",
    spotify: "0StW0SKh1kJo8Myzc8ZjCX",
    genre: "",
    popularity: "23",
  },
  {
    name: "TWR72",
    image: "https://i.scdn.co/image/0ff269beb750636502fd311d89708ac48f6ca08a",
    spotify: "3xppiQ1WFn0sPv4ZQJjqzO",
    genre: "destroy techno",
    popularity: "23",
  },
  {
    name: "By The Rivers",
    image: "https://i.scdn.co/image/f05c31fe52008d4e50299b8b100d92ee8b5177fa",
    spotify: "2W5QJSgtiIcdidjRPWQMtc",
    genre: "leicester indie,uk reggae",
    popularity: "23",
  },
  {
    name: "Rocky Wellstack",
    image: "https://i.scdn.co/image/50a174e95a115d1291d66a916a0edce79dd2cc5a",
    spotify: "6QczmxkjIUtne6NCTlq1g9",
    genre: "",
    popularity: "23",
  },
  {
    name: "Maria Solheim",
    image: "https://i.scdn.co/image/fe8ab0164ee96692ba2e133410dbd478e5002484",
    spotify: "50dO3ZgIhCt8OEmmMougtn",
    genre: "norwegian singer-songwriter",
    popularity: "23",
  },
  {
    name: "Delano Smith",
    image: "https://i.scdn.co/image/eff94f5123cf283d0b3d82581defbd14874e8c44",
    spotify: "2HadNlQJIJDPNJMtMQNQU4",
    genre: "deep soul house,detroit house,minimal tech house",
    popularity: "23",
  },
  {
    name: "Rizan Said",
    image: "https://i.scdn.co/image/ab67616d0000b273c7c94fecd773df39e9d10f01",
    spotify: "1XDAb5Gk7iu6k9DSELAIlp",
    genre: "arab groove",
    popularity: "23",
  },
  {
    name: "Lakeway",
    image: "https://i.scdn.co/image/e156ac2c4d05d7424739c9fe2171399c9d38fdcd",
    spotify: "0eZzjmNaCP16Ljd3bYpCPK",
    genre: "",
    popularity: "23",
  },
  {
    name: "Assembler Code",
    image: "https://i.scdn.co/image/ab67616d0000b2738ec7e1a195675b3301235e90",
    spotify: "3yjeLHZHl3hKqJBZ9O7Hdy",
    genre: "",
    popularity: "23",
  },
  {
    name: "Meetsysteem",
    image: "https://i.scdn.co/image/588d416d6269438434e3784779e65b09aa86b7d0",
    spotify: "2Dsv89oyAH1efJDlgDcXlm",
    genre: "dutch indie",
    popularity: "23",
  },
  {
    name: "Iris Kroes",
    image: "https://i.scdn.co/image/903a4d5e02241847e101faf0371da519e6addb54",
    spotify: "4MLV1JBHoYolXAnpKfvQsK",
    genre: "dutch idol pop",
    popularity: "23",
  },
  {
    name: "Toulouse Lautrec",
    image: "https://i.scdn.co/image/ab67616d0000b273f411e9244c09eb00cf3ed183",
    spotify: "0kTJt0nqhTNd5tIuVGvObt",
    genre: "romanian rock",
    popularity: "23",
  },
  {
    name: "Backbeat Soundsystem",
    image: "https://i.scdn.co/image/61124c19e4b3e8fc53a4c30667f9208c2c7bd099",
    spotify: "6BCAqBE7jfsxRA8JLsWPfi",
    genre: "uk reggae",
    popularity: "23",
  },
  {
    name: "Robert Dietz",
    image: "https://i.scdn.co/image/a87e91f220dc64c85ab30ae5d3eba743681e1271",
    spotify: "5WrS4X7vJdNVUXIMZFcDRi",
    genre: "german techno,minimal tech house",
    popularity: "23",
  },
  {
    name: "Shiverz",
    image: "https://i.scdn.co/image/ab67616d0000b273f5db2121ca653e22b59ccafd",
    spotify: "6WWqNylJBXhrOTPCDPGdIE",
    genre: "",
    popularity: "23",
  },
  {
    name: "Ben Hayes",
    image: "https://i.scdn.co/image/5a31c9602b0fcfcc058b842094e6a3c54e5777b6",
    spotify: "73A1Xo6NzkbRB2EIw3dm6R",
    genre: "uk experimental electronic",
    popularity: "23",
  },
  {
    name: "BloodThinnerz",
    image: "https://i.scdn.co/image/089b43f22b4be3dae50f51956e760ea3d7b0f89c",
    spotify: "7FJtzJaDUdI8MnIBXp0G7m",
    genre: "deathstep,zapstep",
    popularity: "23",
  },
  {
    name: "Oakzy B",
    image: "https://i.scdn.co/image/39c5497f3b7758badcf9136b617d3b756e5be7df",
    spotify: "1mYrNYO2m7i30QOWpTfPT9",
    genre: "scottish hip hop",
    popularity: "23",
  },
  {
    name: "New World Punx",
    image: "https://i.scdn.co/image/ab67616d0000b273edd0652d5d45da439e72c8c8",
    spotify: "3q1L1RSYyJ61npcxAIZDlm",
    genre: "",
    popularity: "23",
  },
  {
    name: "Jonathan Kaspar",
    image: "https://i.scdn.co/image/27aa2c719e301101f73a29dd62fa4356b25765f1",
    spotify: "0R3hsihsVWcPQq5H898UP0",
    genre: "",
    popularity: "23",
  },
  {
    name: "Monako",
    image: "https://i.scdn.co/image/53de2983e7bf9c53375cc572c9ee37267d103fe3",
    spotify: "6C2OWSuRcg7cZL4fsAJ3No",
    genre: "hamburg indie",
    popularity: "23",
  },
  {
    name: "John Illsley",
    image: "https://i.scdn.co/image/99fbfe91408aa3a945e0ec7219bcd64ec60ac6e8",
    spotify: "2cvjV6tm8gB3IX2wsSPcA1",
    genre: "",
    popularity: "23",
  },
  {
    name: "Ross The Boss",
    image: "https://i.scdn.co/image/8f4eddab9db2fd542df76a32682959c337d88b8e",
    spotify: "7iOaIkOG63D70TyWiqfn45",
    genre: "melodic metal,metal,neo-trad metal,nwothm,power metal,speed metal",
    popularity: "23",
  },
  {
    name: "Bungalow",
    image: "https://i.scdn.co/image/1fad8b87e883e190a5435bd536f762bbcec29b1c",
    spotify: "6G9mC3mgZJoMoYTUrN7KWU",
    genre: "",
    popularity: "23",
  },
  {
    name: "David Aurel",
    image: "https://i.scdn.co/image/ab67616d0000b2738d0431969f5350ba4dde8d20",
    spotify: "5ge8z61Jq4JIPgiMdAHDzu",
    genre: "",
    popularity: "23",
  },
  {
    name: "Helgi Jonsson",
    image: "https://i.scdn.co/image/ab67616d0000b273e90b2e762781a67c43cbea51",
    spotify: "1AFn9LXe9swmdGrvtV2WGY",
    genre: "icelandic indie",
    popularity: "23",
  },
  {
    name: "Deena Abdelwahed",
    image: "https://i.scdn.co/image/d8dae34249e587b2a0877855e91a0344569ebbb1",
    spotify: "20fUkJZtm2I6zdIuj2XpgV",
    genre:
      "african experimental,arab electronic,deconstructed club,electra,fluxwork",
    popularity: "23",
  },
  {
    name: "Djebali",
    image: "https://i.scdn.co/image/077126116999c0070cb345dbed07a360d2dcd725",
    spotify: "3toliIlT7UChWeuBkRrUnW",
    genre: "deep tech house,minimal tech house",
    popularity: "23",
  },
  {
    name: "Quibus",
    image: "https://i.scdn.co/image/eb6a0b37caf2332bb4d6f00d709287e364e63dd2",
    spotify: "55rtigPkEd4FHbLBF2bwz4",
    genre: "",
    popularity: "23",
  },
  {
    name: "David Alacey",
    image: "",
    spotify: "2KYZhEMVGhlJfolaf0Djsp",
    genre: "",
    popularity: "23",
  },
  {
    name: "Habischman",
    image: "https://i.scdn.co/image/94ef33ef8532980a66034d9da1240d7ac600e3c6",
    spotify: "4X5dfqYyOaZ3ahnJWIkY38",
    genre: "melodic techno",
    popularity: "23",
  },
  {
    name: "Behind Blue Eyes",
    image: "https://i.scdn.co/image/62d67b3b529a9643bb7558ff4b2e9cc6bd805770",
    spotify: "38sJ9IuhdCUDTo3ThJpK3t",
    genre: "uk post-hardcore",
    popularity: "23",
  },
  {
    name: "Darren Emerson",
    image: "https://i.scdn.co/image/76e00b5b50816774fae57b543d9a975065a41c00",
    spotify: "2vePaJjwrZ6zVLAxf6UrCy",
    genre: "",
    popularity: "23",
  },
  {
    name: "Luis Ake",
    image: "https://i.scdn.co/image/eb47487f6350a53b2b54ec38ebed9812c1673dea",
    spotify: "0pC0b44XIewBYzsCzVuytW",
    genre: "stuttgart indie",
    popularity: "23",
  },
  {
    name: "Peter Pardeike",
    image: "https://i.scdn.co/image/a0790820fa7a5ebd541bd7be34e3475352762df1",
    spotify: "0LHjAYNdezU9MWHFYTYAjE",
    genre: "",
    popularity: "23",
  },
  {
    name: "Pheelz",
    image: "https://i.scdn.co/image/8e57505550209d4c2609fbf515825d2ba9cc5cfa",
    spotify: "5Jv1MsZBh0sqokFq7pU8Xg",
    genre: "",
    popularity: "23",
  },
  {
    name: "Anna Reusch",
    image: "https://i.scdn.co/image/94a4e27c40f843f63dd089334a2accf202072141",
    spotify: "0BMS6AqoDN4Fu7QOruxHjh",
    genre: "frankfurt electronic",
    popularity: "23",
  },
  {
    name: "The Erised",
    image: "https://i.scdn.co/image/50ba2a413819de1ab8b3424d39385c321e326ba3",
    spotify: "3dU6nnz41NilxdIuPLZ10b",
    genre: "ukrainian indie,vapor pop",
    popularity: "23",
  },
  {
    name: "Aurora Halal",
    image: "https://i.scdn.co/image/640cd19843a7a3b7fe4eca0aa48abed7f9155dd8",
    spotify: "4I8qgsaz4mQa9ICeCPibIF",
    genre: "",
    popularity: "22",
  },
  {
    name: "Deejay Abstract",
    image: "https://i.scdn.co/image/531abb7a80eed891238d2cce3e46ff84d414824c",
    spotify: "2OzBelMaLdzmBN7tMhgv3G",
    genre: "dutch trap",
    popularity: "22",
  },
  {
    name: "Amotik",
    image: "https://i.scdn.co/image/aaf5f6011676399bb7b08c18eb36a8c5f81753b0",
    spotify: "6EROUCmvQtSuBUkZ9nNOOO",
    genre: "minimal dub",
    popularity: "22",
  },
  {
    name: "Tripped",
    image: "https://i.scdn.co/image/c67bc6eba7466b7012725ec745fe5d1631ba6193",
    spotify: "4NS6tpO6Wi7Z5FVcwS0EZP",
    genre: "belgian techno,speedcore",
    popularity: "22",
  },
  {
    name: "Martijn Fischer",
    image: "https://i.scdn.co/image/2c3ac62e02cee94b776f811ee2f9026f14aa91db",
    spotify: "3XcxxF0DcHXaSKutfg7vng",
    genre: "",
    popularity: "22",
  },
  {
    name: "Angela Groothuizen",
    image: "https://i.scdn.co/image/e3a988b47cfb63ac285c6fd469432ba9a738a2cf",
    spotify: "0KnzYOfspdrPVyea7EZnnX",
    genre: "dutch pop",
    popularity: "22",
  },
  {
    name: "Misja Helsloot",
    image: "https://i.scdn.co/image/c737a6a8ba9c8268f1fc525abb8f3d30387c15ae",
    spotify: "4V0bDVKeoOi3fwzTtjGeOu",
    genre: "dutch trance,uplifting trance",
    popularity: "22",
  },
  {
    name: "Philou Louzolo",
    image: "https://i.scdn.co/image/0acffb5834320c6986ff964e127005523ded82ca",
    spotify: "4zCYbkxFSNb6T2D2vFSg6C",
    genre: "african electronic",
    popularity: "22",
  },
  {
    name: "Sandy Warez",
    image: "https://i.scdn.co/image/5336083f27b00b9f246cb65529e982250202c472",
    spotify: "1oZ7OpE1SHjyUjXgYKaLpM",
    genre: "schranz,speedcore,uptempo hardcore",
    popularity: "22",
  },
  {
    name: "Marc Marzenit",
    image: "https://i.scdn.co/image/7a62f53c197e9b61249cee4ad75e1c27d200b962",
    spotify: "4uZ21B6WfXaKVKizc79gUK",
    genre: "deep progressive trance",
    popularity: "22",
  },
  {
    name: "Jasper James",
    image: "https://i.scdn.co/image/1bae02672054a733b65ab05c1943b0a98597cb09",
    spotify: "0bOR78IANHTrHwd0kezriG",
    genre: "scottish electronic,uk tech house",
    popularity: "22",
  },
  {
    name: "Canshaker Pi",
    image: "https://i.scdn.co/image/163fa872652c3fda4d78f1af158a5bd1a17563c8",
    spotify: "7butkj3jPD2YeHBuWFp19k",
    genre: "dutch indie,dutch indie rock,dutch rock",
    popularity: "22",
  },
  {
    name: "Fernando Lameirinhas",
    image: "https://i.scdn.co/image/ab67616d0000b273c047b4b691902a2d07bf069c",
    spotify: "31ynsqptrL8EAD89ZEaaUR",
    genre: "fado",
    popularity: "22",
  },
  {
    name: "Green Tree",
    image: "https://i.scdn.co/image/81c78a669c7dec0d9cfbe68040b1acb658c1e7a9",
    spotify: "399dNsPs3CGoXu5zEEnTz3",
    genre: "",
    popularity: "22",
  },
  {
    name: "Eric Sidey",
    image: "https://i.scdn.co/image/ab67616d0000b273768b25c16e5984b4bc332d30",
    spotify: "580yhc1UzCZE7EyxORhmLF",
    genre: "",
    popularity: "22",
  },
  {
    name: "Wim Helsen",
    image: "https://i.scdn.co/image/ab67616d0000b2733bda22e1c77124859855b772",
    spotify: "1JSOuhKYzTgWnQ0NKWpvaY",
    genre: "dutch cabaret,vlaamse cabaret",
    popularity: "22",
  },
  {
    name: "Stacey Pullen",
    image: "https://i.scdn.co/image/19e0e0a44624e4878c8af696b6e0ed6ab4b17080",
    spotify: "0GJpYdmVCgg90TkyB1nB1y",
    genre: "detroit house,detroit techno,techno",
    popularity: "22",
  },
  {
    name: "Hiro Kone",
    image: "https://i.scdn.co/image/52f710aa5d162b570c34b6ab7b9ca372707a44f2",
    spotify: "1BCUHvti8crTWtc0h0U4W4",
    genre: "deconstructed club,mandible,new isolationism",
    popularity: "22",
  },
  {
    name: "Thrasher",
    image: "https://i.scdn.co/image/5885c0e6c18e5089f7d82d15722c021478489875",
    spotify: "6zAICutV51dVSHVz7wQSJf",
    genre: "dutch dnb",
    popularity: "22",
  },
  {
    name: "Emilia Amper",
    image: "https://i.scdn.co/image/ab67616d0000b273092d83bb2c124317d1c35d46",
    spotify: "01udy26f60U4sLvs71g2RR",
    genre: "folkmusik,nordic folk,nyckelharpa,swedish fiddle",
    popularity: "22",
  },
  {
    name: "TAPE TOY",
    image: "https://i.scdn.co/image/a984bc28e23b0276d30269afa21f735728c1916c",
    spotify: "6yhSdvAyoNm3RZSmy4Yzbw",
    genre: "dutch rock",
    popularity: "22",
  },
  {
    name: "Karen Gwyer",
    image: "https://i.scdn.co/image/030cdb778d4a7970d60c83e32913c9f9e895e695",
    spotify: "7CIkQIdBUVT7ppXHLSbK3U",
    genre: "electra,uk experimental electronic",
    popularity: "22",
  },
  {
    name: "Spirit Family Reunion",
    image: "https://i.scdn.co/image/89f0f732a1beee99365a80f3153dda4819c922a8",
    spotify: "197bTSwvX2Rav8tkeZ3lQB",
    genre: "modern old-time,new americana",
    popularity: "22",
  },
  {
    name: "Pat Smith",
    image: "https://i.scdn.co/image/0bb6f4f427d52663ba1f166af7e395ccff8c49df",
    spotify: "5wVHYK95Kzjaf8Ecd9s9bS",
    genre: "",
    popularity: "22",
  },
  {
    name: "DJ Plead",
    image: "https://i.scdn.co/image/ab67616d0000b27330b6846b5c4146c7ae2b2f53",
    spotify: "3srk7xv520Ls9D09QMpEJg",
    genre: "organic electronic",
    popularity: "22",
  },
  {
    name: "Marcel Vogel",
    image: "https://i.scdn.co/image/ab67616d0000b27366774ff62747955563559844",
    spotify: "58cSkLlJKQgbPGKph5569D",
    genre: "",
    popularity: "22",
  },
  {
    name: "Downfall Of Gaia",
    image: "https://i.scdn.co/image/d7a4b7dad4535974965e07f7dd886082604b3c9b",
    spotify: "2ZBAmlpAv7mVb9ZqUuHLSg",
    genre:
      "atmospheric sludge,blackened crust,drone metal,german black metal,neo-crust,post-black metal,voidgaze",
    popularity: "22",
  },
  {
    name: "Freek Vonk",
    image: "https://i.scdn.co/image/6e192c9e6d59155ed23770c9e92eae1d9f10fc27",
    spotify: "5Uq17YvC1dHoctFnvxFesp",
    genre: "",
    popularity: "22",
  },
  {
    name: "Torus",
    image: "https://i.scdn.co/image/02f87c80a8f10e1ae22cb36e09cb77eda6ba935c",
    spotify: "4YlNFCrxoTfxFtZwPoGjLW",
    genre: "deconstructed club,new isolationism",
    popularity: "22",
  },
  {
    name: "Tom Tukker",
    image: "https://i.scdn.co/image/4bbcc16a649d0c8377b375e4dea0f568a5d238c1",
    spotify: "17RTZHVyIbvpPCITyHE5jI",
    genre: "",
    popularity: "22",
  },
  {
    name: "The Twins",
    image: "https://i.scdn.co/image/ab67616d0000b273ddac3a7f7c3d54c5cae51514",
    spotify: "2b6vTxclFNi8NuTVx0kYy6",
    genre: "",
    popularity: "22",
  },
  {
    name: "Alex Kidd",
    image: "https://i.scdn.co/image/238208946b3b692d33ecd883378c379041597904",
    spotify: "4SpamvPxHqXBw6pXbbSXdJ",
    genre: "",
    popularity: "22",
  },
  {
    name: "Vandoliers",
    image: "https://i.scdn.co/image/ad174b3dc4b87c34abcf8f4736872ff544b1fada",
    spotify: "0Ti1YY2v4KtYkz7JemXJpE",
    genre: "",
    popularity: "22",
  },
  {
    name: "Compro Oro",
    image: "https://i.scdn.co/image/179c16ee1992854fa3944eb60d463200c3e001c3",
    spotify: "1Bd10SiF1s1INXXIXJ9hvc",
    genre: "belgian modern jazz",
    popularity: "22",
  },
  {
    name: "Alejandro Mosso",
    image: "https://i.scdn.co/image/443a2aab14826eb0a01c29cb195c813ff4bdb4c4",
    spotify: "4u5Ii39u9AXwZL9mluueZr",
    genre: "minimal tech house",
    popularity: "22",
  },
  {
    name: "Sjamsoedin",
    image: "https://i.scdn.co/image/9369926e330e1765b451bf451b81b9a32f48efa0",
    spotify: "1vXLkCDKZAhOyxMud6eZpD",
    genre: "dutch experimental electronic",
    popularity: "22",
  },
  {
    name: "Loudar",
    image: "https://i.scdn.co/image/c3dfea6afe4d7c123d1805d6a6617b4ee9748df9",
    spotify: "28upAbqnpJVHE1SQvf40Cg",
    genre: "",
    popularity: "22",
  },
  {
    name: "Mikey Lion",
    image: "https://i.scdn.co/image/6d98a26a491b03410123d417236da20f219b70dc",
    spotify: "50iz6mQhjUfbM0UjtZxWIp",
    genre: "",
    popularity: "22",
  },
  {
    name: "Stuart Mavis",
    image: "https://i.scdn.co/image/3c8a25184e339c47a9bfa5d90acf1613d67f99d8",
    spotify: "6J3ZPoVNpYpNfMGI5RgUj8",
    genre: "",
    popularity: "22",
  },
  {
    name: "Nailpin",
    image: "https://i.scdn.co/image/ab67616d0000b2737d82326af5c09e10b7fc06ff",
    spotify: "5e5nDiXRvfAfuzX2TBB4Ct",
    genre: "belgian punk,belgian rock",
    popularity: "22",
  },
  {
    name: "Rachèl Louise",
    image: "https://i.scdn.co/image/8eaaabe4356eae4d7f621590cbe2df2d51c478b3",
    spotify: "5qBnUEVyM1b6orwYHQjfYw",
    genre: "dutch pop",
    popularity: "22",
  },
  {
    name: "Prime Suspects",
    image: "https://i.scdn.co/image/ab67616d0000b27350c505b2baca9e90345ccbd8",
    spotify: "5exiOAfwiSG1ee3ZADsDDA",
    genre: "",
    popularity: "22",
  },
  {
    name: "Gypsy Unit",
    image: "https://i.scdn.co/image/ab67616d0000b273b7987ea8d45159f5122501c1",
    spotify: "5YuJkvq3gheq67Te0YM1iL",
    genre: "bristol indie,electro swing",
    popularity: "22",
  },
  {
    name: "Maydien",
    image: "https://i.scdn.co/image/26a0c4a8908d2fb18fea1812138dc35a7cb692a2",
    spotify: "52pcFWBKzTZUCJrBizvl1y",
    genre: "dutch r&b",
    popularity: "22",
  },
  {
    name: "Fountain Of Youth",
    image: "https://i.scdn.co/image/366f35b2bf93030fcf3bb14c18e16c16b294fff8",
    spotify: "4aR00AsAg8FbXkQTrjHhzw",
    genre: "",
    popularity: "22",
  },
  {
    name: "The Tidy Boys",
    image: "https://i.scdn.co/image/12d2a767787ee0b9b637cd81fd197613205074ea",
    spotify: "1CRR7gSk8OeT559LDpP5e0",
    genre: "hard house",
    popularity: "22",
  },
  {
    name: "Larry Gus",
    image: "https://i.scdn.co/image/ef6a031193fcd78b8080cefa3ab8d00b18b3e2d5",
    spotify: "4HDe0w9aBa7w89KYMY43OK",
    genre: "greek indie",
    popularity: "22",
  },
  {
    name: "Ahl Iver",
    image: "https://i.scdn.co/image/119d45face6982811051e1bb28830823b3746756",
    spotify: "0rX7Jq1AcfbVfKZGO2d6pV",
    genre: "",
    popularity: "22",
  },
  {
    name: "Alexkid",
    image: "https://i.scdn.co/image/d0c2112183989fb010e1b299361fd95de56a08ad",
    spotify: "6flQb0ra6sAfLcnBSjQvpl",
    genre: "",
    popularity: "22",
  },
  {
    name: "Pandorum",
    image: "https://i.scdn.co/image/ab67616d0000b273b9a0c7b3c81e2d361d971e1c",
    spotify: "4GoZ6jWWOMDh8VfsFwFBjQ",
    genre: "",
    popularity: "22",
  },
  {
    name: "Redshape",
    image: "https://i.scdn.co/image/338534c37d1875c33b817e2e1d27d2161bca559d",
    spotify: "47v4sY9QC88CBYTtYaW3tQ",
    genre: "dub techno",
    popularity: "22",
  },
  {
    name: "Yael Deckelbaum",
    image: "https://i.scdn.co/image/5a7589089e07a71b0e785c3834c2bcb124d3b9a3",
    spotify: "1mDm3a7s9MFggKUShPdKpj",
    genre: "israeli indie",
    popularity: "22",
  },
  {
    name: "Maid of Ace",
    image: "https://i.scdn.co/image/ab67616d0000b2739bfb4b4b38c92af618ef859e",
    spotify: "6uP4P8qwS11kWUdEGdA1jt",
    genre: "uk diy punk",
    popularity: "22",
  },
  {
    name: "Mystic Bill",
    image: "https://i.scdn.co/image/ab67616d0000b273e15dfb4450b8970f3dc5f19a",
    spotify: "1qBYNcfpwmb1ensiLvWxEV",
    genre: "",
    popularity: "22",
  },
  {
    name: "Tetrameth",
    image: "https://i.scdn.co/image/ab67616d0000b273ca6a5eb5f24695a507e64cbe",
    spotify: "0fECvcmnviTP3IgxFJnL9P",
    genre: "progressive psytrance",
    popularity: "22",
  },
  {
    name: "Vonneke Bonneke",
    image: "https://i.scdn.co/image/8ca4813f5a558152b88d0e971df3484febfd9069",
    spotify: "4FG1eGySAGKqMWk2HiVyAq",
    genre: "",
    popularity: "22",
  },
  {
    name: "Transfarmers",
    image: "https://i.scdn.co/image/ab67616d0000b27305e49546ef41be06d71456d5",
    spotify: "5T0am1hYPBi3eOwYGEgzai",
    genre: "jumpstyle",
    popularity: "22",
  },
  {
    name: "Evil Invaders",
    image: "https://i.scdn.co/image/8cb320736ff74ccad7edb3126b5044e539014183",
    spotify: "4bMhBA9z2oB9MixiL9OXCx",
    genre: "belgian metal,new wave of speed metal,nwothm",
    popularity: "22",
  },
  {
    name: "Guy One",
    image: "https://i.scdn.co/image/ab67616d0000b2734e2c1456a6fc54f26e6bba40",
    spotify: "3vzUquMMBiNQccnjYezeeR",
    genre: "indie jazz",
    popularity: "22",
  },
  {
    name: "Cameo Blush",
    image: "https://i.scdn.co/image/1908d82f157e80d592b23d12278562ee2fc0bfff",
    spotify: "2Lx2CAHHQ2IC1iXjS6Y70v",
    genre: "",
    popularity: "22",
  },
  {
    name: "Tiefblau",
    image: "https://i.scdn.co/image/05a052755c8fdb84372dbbef1a601a6103d4d5fe",
    spotify: "76DPPkKQ42KdUuqnxJN1gY",
    genre: "",
    popularity: "22",
  },
  {
    name: "Sasha Carassi",
    image: "https://i.scdn.co/image/12d3067a1a354502dd762ba980d3a8acca3e6933",
    spotify: "6UFFThDuFiQixrwog0FecB",
    genre: "dark minimal techno,deep minimal techno,italian techno",
    popularity: "22",
  },
  {
    name: "Future Franz",
    image: "https://i.scdn.co/image/ab67616d0000b273441be1e9b337f4f4cebb6b18",
    spotify: "0uo4X47JTsZkyXZvqXvI0d",
    genre: "stuttgart indie",
    popularity: "22",
  },
  {
    name: "No Regular Play",
    image: "https://i.scdn.co/image/ab67616d0000b273ae25b7c735d5e1c187a49688",
    spotify: "4rUgv4gd85D4QKe08WAf8V",
    genre: "deep disco house",
    popularity: "22",
  },
  {
    name: "Hobbit",
    image: "https://i.scdn.co/image/ab67616d0000b27357230429f805429f153762a8",
    spotify: "7lG1Gqdzu4R0fKaBYTkgzs",
    genre: "",
    popularity: "22",
  },
  {
    name: "Sven Weisemann",
    image: "https://i.scdn.co/image/ab67616d0000b273d613e0967e15134494c80b9b",
    spotify: "1MvenC6senxNCufFqueTlr",
    genre: "dub techno,german house",
    popularity: "22",
  },
  {
    name: "Kumbia Boruka",
    image: "https://i.scdn.co/image/ab67616d0000b273caee85beb02c44ac43106c45",
    spotify: "3B7XF3wKmK3NFMO4AGfzd7",
    genre: "",
    popularity: "22",
  },
  {
    name: "Mydy Rabycad",
    image: "https://i.scdn.co/image/a03472b9f8628f0da8780261d5fbd06da6abbd6d",
    spotify: "4xrKDM7KjC81IJWQb84Zhm",
    genre: "czech pop",
    popularity: "22",
  },
  {
    name: "Uto Karem",
    image: "https://i.scdn.co/image/654d73b5199a0b718e74c821fb5248780fb57271",
    spotify: "6KBbbE4QVlVQwFNIXrD8hF",
    genre: "deep minimal techno,tech house",
    popularity: "22",
  },
  {
    name: "Sleeparchive",
    image: "https://i.scdn.co/image/ab67616d0000b273c6fe0b3506dd414fd7f434d6",
    spotify: "71PtLENUznKmVtOe7iAaa8",
    genre:
      "dub techno,microhouse,minimal dub,minimal techno,modular techno,techno",
    popularity: "22",
  },
  {
    name: "Marcel Fengler",
    image: "https://i.scdn.co/image/9f1f045614f4676755068174a7c671fd4677dc10",
    spotify: "3mHW156q5j1Zh0rEgIijxG",
    genre: "german techno",
    popularity: "21",
  },
  {
    name: "Naffz",
    image: "https://i.scdn.co/image/5a619b032b59f3a053fde369a5b40bef8c8328fc",
    spotify: "6bRT33dQceM0epF2kyjnN3",
    genre: "",
    popularity: "21",
  },
  {
    name: "Jordy Dazz",
    image: "https://i.scdn.co/image/61b416a190af0da6ab557f470bf341732b8fe22b",
    spotify: "1H2OBrGc1V7laMLDwzJWFl",
    genre: "big room,deep big room,progressive electro house",
    popularity: "21",
  },
  {
    name: "Mor Elian",
    image: "https://i.scdn.co/image/62295c33ce71b80d97bef7a1eeba27e97650a515",
    spotify: "4nLavg4nn48n7wwx2AIklZ",
    genre: "experimental techno",
    popularity: "21",
  },
  {
    name: "Upercent",
    image: "https://i.scdn.co/image/59990dad360299477b4f3224670752738295738b",
    spotify: "7p4uoSR3Hf9jbuDvdJZPZq",
    genre: "",
    popularity: "21",
  },
  {
    name: "Sydney Blu",
    image: "https://i.scdn.co/image/c524d52f33ee881ad841eb69ed117e37739e5ce3",
    spotify: "2Js5903erwUWbAijR6A8rb",
    genre: "canadian house",
    popularity: "21",
  },
  {
    name: "Toni Rios",
    image: "https://i.scdn.co/image/0c2bec6303e5d2aaca46a3db97f68a1f5f613edf",
    spotify: "7gKUTghSxTDyTk4vRYTJuA",
    genre: "frankfurt electronic",
    popularity: "21",
  },
  {
    name: "Sei2ure",
    image: "https://i.scdn.co/image/ab67616d0000b273b2e50eeaae5e5abd3cf0c4a4",
    spotify: "4f8x3gw9REomgjxI1KdxOA",
    genre: "doomcore,gabba,industrial hardcore,speedcore,uptempo hardcore",
    popularity: "21",
  },
  {
    name: "Lena Willemark",
    image: "https://i.scdn.co/image/fa94e03c4baeb004487f8ceaf31717d1458ecaee",
    spotify: "6wMtEmlrb01e5JqZi62T4y",
    genre: "folkmusik,nordic folk",
    popularity: "21",
  },
  {
    name: "Ingrid Bjørnov",
    image: "https://i.scdn.co/image/9c37d78d61c94672b6d84d8a070554a33a17462b",
    spotify: "0T4YaWeVjwCx7lNK3hbt7S",
    genre: "classic norwegian pop",
    popularity: "21",
  },
  {
    name: "Marc Terenzi",
    image: "https://i.scdn.co/image/af610c5ada9e296aab44c72e542c76a6fb4a4d3f",
    spotify: "14Y9eoPvi9kUXERS6dvuJe",
    genre: "",
    popularity: "21",
  },
  {
    name: "Miss Enemy",
    image: "https://i.scdn.co/image/fc0f48206806a3ace12fec8dcc3a6c09feb00c08",
    spotify: "0zCs1TQIjYoXm0CNHEdpsN",
    genre: "uptempo hardcore",
    popularity: "21",
  },
  {
    name: "Telephones",
    image: "https://i.scdn.co/image/ab67616d0000b2739764f3ea640a4ffa2ad76214",
    spotify: "0A34lofieP2Nj3Gm2hb6pY",
    genre: "norwegian space disco",
    popularity: "21",
  },
  {
    name: "Dr. Lektroluv",
    image: "https://i.scdn.co/image/be5eeb5eef76923d8b738679a875985e25dbe690",
    spotify: "71zryDK7t1BUFnqbOpSqxa",
    genre: "",
    popularity: "21",
  },
  {
    name: "Chamos",
    image: "https://i.scdn.co/image/ab67616d0000b273bcdeed80a1ab8ba241a9be39",
    spotify: "5pfcC4ntJb3rFYKIvFd790",
    genre: "",
    popularity: "21",
  },
  {
    name: "MC Roga",
    image: "",
    spotify: "2ZghcB8YjDWv3KKQRB7pzy",
    genre: "",
    popularity: "21",
  },
  {
    name: "Komfortrauschen",
    image: "https://i.scdn.co/image/73c80854cf2691e570ce71df43a9ae0c969ad358",
    spotify: "6LGTJS9Ct8SmOznEuTr0NE",
    genre: "",
    popularity: "21",
  },
  {
    name: "André Hommen",
    image: "https://i.scdn.co/image/932faff8976f74a73013d65e75d0381f9944262e",
    spotify: "32v3kwTPwTkGVLEbiGhWzu",
    genre: "",
    popularity: "21",
  },
  {
    name: "Steady Rock",
    image: "https://i.scdn.co/image/ec26542eb2f192f877d502ff5e4b5820310133c1",
    spotify: "1sospaXU0jvVDrGqBdX4YM",
    genre: "",
    popularity: "21",
  },
  {
    name: "Locklead",
    image: "https://i.scdn.co/image/2b8e3676ee2da1b5fd136336320a22267cdd7f6e",
    spotify: "14X4Rn0s4EuGtizL0l8IIw",
    genre: "bass house",
    popularity: "21",
  },
  {
    name: "Amastro",
    image: "https://i.scdn.co/image/bf4a61771d695e8f7c17cacb7bab682f7a2022e3",
    spotify: "54NJekzFP93avOuPenoJe7",
    genre: "",
    popularity: "21",
  },
  {
    name: "Reis Fernando",
    image: "https://i.scdn.co/image/7c44d9790367fa72849c06259d1da4bc19f28b47",
    spotify: "6UxDVNLxYTtYP3oa0xzYzl",
    genre: "",
    popularity: "21",
  },
  {
    name: "Jeans Team",
    image: "https://i.scdn.co/image/ab67616d0000b2733863c76fd2d408fef9d4407c",
    spotify: "1LRMX9kwV7AtaeD913IHkD",
    genre: "elektropunk",
    popularity: "21",
  },
  {
    name: "John Acquaviva",
    image: "https://i.scdn.co/image/966d1e65481841ab2ce411019d5e2571cac29a42",
    spotify: "2E4L9G4jTkc647FIq8rYGW",
    genre: "tech house",
    popularity: "21",
  },
  {
    name: "Gunnar Stiller",
    image: "https://i.scdn.co/image/f49bc7fab5350536c83087bdfaa66665a8de3c45",
    spotify: "1ePPtZhIYfoM9ZpfjhlXjb",
    genre: "german tech house",
    popularity: "21",
  },
  {
    name: "Eli Keszler",
    image: "https://i.scdn.co/image/c3570b7e75d907ffcf505ce379c5475649899112",
    spotify: "2YfqCdQFDp4c0s8F5Lkk4z",
    genre: "fourth world,free improvisation,mandible,sound art",
    popularity: "21",
  },
  {
    name: "Muyayo Rif",
    image: "https://i.scdn.co/image/460ee323d239b77737acbdae1a9d73da0f1359d3",
    spotify: "0k3TYsn0wPivYDhHX7HE4C",
    genre: "ska catala",
    popularity: "21",
  },
  {
    name: "Felix Kubin",
    image: "https://i.scdn.co/image/b1254ba9707628211800087ec13549b4ba03a7df",
    spotify: "66BaUCSXtLbyBUvsep9plc",
    genre: "neue deutsche welle",
    popularity: "21",
  },
  {
    name: "Linus Hasselberg",
    image: "https://i.scdn.co/image/8cd45719a1b5344b69310346b9e88f8a14108b3f",
    spotify: "6GgHPXS9vcsCnldsGUyrJL",
    genre: "",
    popularity: "21",
  },
  {
    name: "Artefakt",
    image: "https://i.scdn.co/image/ab67616d0000b2736a294003fc06e1cf21014438",
    spotify: "5q1QQYfkViLOUO9NzjUZCP",
    genre: "minimal dub",
    popularity: "21",
  },
  {
    name: "SUB-human",
    image: "https://i.scdn.co/image/f254afdd0330ba02550be730331095eba4bf272d",
    spotify: "05ekpLtsCMtrb8A9Drhifw",
    genre: "",
    popularity: "21",
  },
  {
    name: "Rita Zipora",
    image: "https://i.scdn.co/image/f5ee65e1c9ea3b0fc05426d145e95eb6ec54a554",
    spotify: "3wj7Ln3eJfxnKbxiCZExkm",
    genre: "dutch singer-songwriter",
    popularity: "21",
  },
  {
    name: "Stereotuners",
    image: "https://i.scdn.co/image/ab67616d0000b273e446f24bd5111920ab0496ff",
    spotify: "5zOy8g7BSZJ8rWVLc08lrv",
    genre: "rawstyle",
    popularity: "21",
  },
  {
    name: "Shonky",
    image: "https://i.scdn.co/image/ab67616d0000b273df68cdc80c5434abdae3ea2b",
    spotify: "1waWwt8cVCJgqLItlQJz14",
    genre: "minimal tech house",
    popularity: "21",
  },
  {
    name: "The Overslept",
    image: "https://i.scdn.co/image/7cdc94930f51fbd55aba0febfef997c3128e5729",
    spotify: "3YcQI3pZQThlfqjtAWRNdM",
    genre: "dutch punk rock",
    popularity: "21",
  },
  {
    name: "Danger Hardcore Team",
    image: "https://i.scdn.co/image/ab67616d0000b27309ac572ee1d6405d089963d6",
    spotify: "5NwV09EZZvlCSgQ5DLQNAz",
    genre: "gabba",
    popularity: "21",
  },
  {
    name: "Paskal Jakobsen",
    image: "https://i.scdn.co/image/ab67616d0000b27303a7b229d646863ce6159b39",
    spotify: "22shUi37uDfZmZQ8H6YuWr",
    genre: "",
    popularity: "21",
  },
  {
    name: "Unrest",
    image: "https://i.scdn.co/image/209f335c84c812ddf8f26935870e842e46a63f7c",
    spotify: "0Hko1NgISX00BkCPOuyVzQ",
    genre: "alternative pop,gbvfi,lo-fi,post-hardcore,slowcore",
    popularity: "21",
  },
  {
    name: "Kenny Larkin",
    image: "https://i.scdn.co/image/a6a2f74b61ffcd39c3fc13c68a2e112a2f70c583",
    spotify: "7A4qanEMCOPcywaqZ01yVV",
    genre: "acid house,chicago house,detroit techno,minimal techno,techno",
    popularity: "21",
  },
  {
    name: "Gourmet",
    image: "https://i.scdn.co/image/6ac23855ef89363998d6d44c83fd657dba2458a5",
    spotify: "47IQJsO7KOeosawUAccOT7",
    genre: "",
    popularity: "21",
  },
  {
    name: "Progressive Brothers",
    image: "https://i.scdn.co/image/0e26ed3a0b06d549ec03d020bc5026fbfceb036d",
    spotify: "49ATHR1LB0svG40PcjjHPP",
    genre: "indian edm",
    popularity: "21",
  },
  {
    name: "Terence Fixmer",
    image: "https://i.scdn.co/image/c82f7be90e01a7085097e89420130f47398326e9",
    spotify: "54yHcfvcrKO91U46rnzHkc",
    genre: "",
    popularity: "21",
  },
  {
    name: "Zentura",
    image: "https://i.scdn.co/image/ab67616d0000b273f01426c1165c8a06caafe1ec",
    spotify: "6uQLAJW9myOPyMnU3bMCnN",
    genre: "progressive psytrance",
    popularity: "21",
  },
  {
    name: "Remcord",
    image: "https://i.scdn.co/image/752d25d4f9e02d833f542e9581111fcabaf762ec",
    spotify: "09iSLnIk5tjj4u4T7nrhmB",
    genre: "melodic techno",
    popularity: "21",
  },
  {
    name: "Mod3rn",
    image: "https://i.scdn.co/image/314853ba3011fd6322840626c4b9a97c72bf5979",
    spotify: "3OhATO8ZqHPfk1cfKSjWWw",
    genre: "",
    popularity: "21",
  },
  {
    name: "Martin Le Vilain",
    image: "https://i.scdn.co/image/ab67616d0000b273f53fc14e82e65a78368b02e2",
    spotify: "59fyBXkrvN1v20d56szs9B",
    genre: "",
    popularity: "21",
  },
  {
    name: "Ammar 808",
    image: "https://i.scdn.co/image/de41741ea3ac81e8596e485d2d6775fa1f5ce211",
    spotify: "0TAPEEcG2NQAfSKkreQWAM",
    genre: "arab groove",
    popularity: "21",
  },
  {
    name: "Alex Mayr",
    image: "https://i.scdn.co/image/b0c700239ca50c75df9c9b01a235f79993353ba6",
    spotify: "5hziJ14wX0TOqfeSSZQNWK",
    genre: "german indie pop,german singer-songwriter",
    popularity: "21",
  },
  {
    name: "The Guru Guru",
    image: "https://i.scdn.co/image/4f0f5dd3c005972925d415c99a5833a11ac11227",
    spotify: "3ysynhoxdKYeqxPbPVzcEX",
    genre: "belgian indie,belgian indie rock",
    popularity: "21",
  },
  {
    name: "Alex Henry Foster",
    image: "https://i.scdn.co/image/a94096ccb9731a57c08ded23a67c9c32cecb3a95",
    spotify: "3xxV7Humr8VBXGhNNbyWoY",
    genre: "",
    popularity: "21",
  },
  {
    name: "Warmland",
    image: "https://i.scdn.co/image/69b93aac2075841fc5f7f863e2254839a4c8a220",
    spotify: "0HtD8SjUM1lm2jP7jAeXu2",
    genre: "icelandic indie",
    popularity: "21",
  },
  {
    name: "Cuff the Duke",
    image: "https://i.scdn.co/image/b3973e4c105432c94238c378284137c62b9fe858",
    spotify: "5WzOiybWm06XimLccSeGS8",
    genre: "canadian indie,ontario indie",
    popularity: "21",
  },
  {
    name: "Lauren Lane",
    image: "https://i.scdn.co/image/3d8416532483a4db4830abadc4be368c21851bf0",
    spotify: "4ZPNmWgbjJCiLxh1MqtyNu",
    genre: "",
    popularity: "21",
  },
  {
    name: "Senora May",
    image: "https://i.scdn.co/image/ab67616d0000b273a9f4622c52d8da456162f5b5",
    spotify: "5zHAQHBRNMEqG5Of2CM0cD",
    genre: "",
    popularity: "21",
  },
  {
    name: "Kali Masi",
    image: "https://i.scdn.co/image/53486e5f47a1fc03af4614da388d4af8a8c8d0da",
    spotify: "0SZcqeYkkVOubIZVZKcsct",
    genre: "midwest emo",
    popularity: "21",
  },
  {
    name: "Nicolas Michaux",
    image: "https://i.scdn.co/image/de19f1993efee15887e24b7967cd13f70296e323",
    spotify: "2J6FSVBM3FWvtzLMMUFUiJ",
    genre: "",
    popularity: "21",
  },
  {
    name: "Broers",
    image: "https://i.scdn.co/image/ab67616d0000b273864e743783a7371610fa1e73",
    spotify: "5TPifE07jtG2uEWlRbqjTc",
    genre: "afrikaans",
    popularity: "21",
  },
  {
    name: "Sophie Auster",
    image: "https://i.scdn.co/image/9473822aa8675b7826020c235ba840bf4a7ecbee",
    spotify: "00ADJx9UolqyBRnMyY8DT6",
    genre: "ectofolk",
    popularity: "21",
  },
  {
    name: "Black Flower",
    image: "https://i.scdn.co/image/0b27bac637d19505597713bc440cb2eb97cfc36c",
    spotify: "3sWzPqn412qggAJRtI6Bvz",
    genre: "belgian modern jazz",
    popularity: "21",
  },
  {
    name: "Carlos Manaça",
    image: "https://i.scdn.co/image/ee3b8f45127eac50c57062f55234e09479e74a53",
    spotify: "4kHtNNtJwxWarOBPnK51Jo",
    genre: "portuguese techno",
    popularity: "21",
  },
  {
    name: "Maiden United",
    image: "https://i.scdn.co/image/ab67616d0000b273a4aa1e354e53205d3697029b",
    spotify: "7HxwV8NK5Ea0UaOPamhuxe",
    genre: "",
    popularity: "21",
  },
  {
    name: "Dangers of the Sea",
    image: "https://i.scdn.co/image/a2db0c505ed51ef4845341e9d48429d499006b52",
    spotify: "0i68HW9KpOPhFKuFNBktyY",
    genre: "danish indie",
    popularity: "21",
  },
  {
    name: "Hot Mouth",
    image: "https://i.scdn.co/image/ab67616d0000b273fd2d335c40b417b541382a81",
    spotify: "7zPb6Li244UG7JHvwGRp43",
    genre: "",
    popularity: "21",
  },
  {
    name: "Steve Norton",
    image: "https://i.scdn.co/image/f5558f5da2a9f48770ddde583515c2e843ce7772",
    spotify: "3PCnJPxTg6LT4q4vWXrxsL",
    genre: "",
    popularity: "21",
  },
  {
    name: "Simone Felice",
    image: "https://i.scdn.co/image/3cff8106b0ac928faeeabd74a768e4d16e41707b",
    spotify: "2tfqowGe1sXV4u2ZUZCW9Q",
    genre: "",
    popularity: "21",
  },
  {
    name: "Renato Ratier",
    image: "https://i.scdn.co/image/ac5b43fbeb36546c2bc6fb613c14081a1f29112b",
    spotify: "4ZZyG1wljM3Yi8xW2Jz34Z",
    genre: "deep techno",
    popularity: "21",
  },
  {
    name: "Supersister",
    image: "https://i.scdn.co/image/ab67616d0000b273031c925ea173a03b7af74752",
    spotify: "41kkmWUEIbjz3iptuGamqY",
    genre:
      "canterbury scene,dutch prog,italian progressive rock,nederpop,progressive rock,symphonic rock,zeuhl",
    popularity: "21",
  },
  {
    name: "Boeboe",
    image: "https://i.scdn.co/image/057a9fd7d2beec68bdebbdec244cbea29d125fe5",
    spotify: "6KvhWUaXr9UGemUf3WSsNL",
    genre: "",
    popularity: "21",
  },
  {
    name: "DJ Stingray",
    image: "https://i.scdn.co/image/2f31e8b8eb9574271e446b99ffd5667dd3aac8f6",
    spotify: "7vZgYqMEApgWpMpXMSJj1o",
    genre: "electro,techno",
    popularity: "20",
  },
  {
    name: "JASSS",
    image: "https://i.scdn.co/image/ab67616d0000b273d8e4d844339bbe4dd008c060",
    spotify: "4reMrexillTAvq1AQr6MzV",
    genre: "electra,experimental electronic,new isolationism",
    popularity: "20",
  },
  {
    name: "Voiski",
    image: "https://i.scdn.co/image/ab67616d0000b27396acf4e52d73fabd7ac84be7",
    spotify: "6YlLUbef5d4ptmxkMKsrlK",
    genre: "acid techno,french techno,melodic techno,outsider house",
    popularity: "20",
  },
  {
    name: "Otto Wunderbar",
    image: "https://i.scdn.co/image/da5ecd1f8b4a75e8c85fce7b0b4ba417c8bb756f",
    spotify: "30kDj8cJixV9yr3xBFLNGX",
    genre: "",
    popularity: "20",
  },
  {
    name: "Demoniak",
    image: "https://i.scdn.co/image/ab67616d0000b273b5fa7ab16f949d2ca5cbed53",
    spotify: "0cYsP5Ut9eMVtFcTvmgcjl",
    genre: "jumpstyle",
    popularity: "20",
  },
  {
    name: "A-Kriv",
    image: "https://i.scdn.co/image/38011cb14e50148486d1f5f2a1ae11860c2152c8",
    spotify: "19rMhAfRlZVYTg4jiXOZCr",
    genre: "frenchcore,uptempo hardcore",
    popularity: "20",
  },
  {
    name: "Paula Tape",
    image: "https://i.scdn.co/image/d00db4e1252656c92f28bb7949944e3ff2f0e14a",
    spotify: "1Yz5x25z5WOjMGQkZ1TwKh",
    genre: "",
    popularity: "20",
  },
  {
    name: "Jamie 3:26",
    image: "https://i.scdn.co/image/3f297dd623e3d7a687223107c973aaeb65e04ecb",
    spotify: "2i3sHUKH86iD6khkNR1Fxi",
    genre: "",
    popularity: "20",
  },
  {
    name: "Hardbouncer",
    image: "https://i.scdn.co/image/b272d6056cad8fbdd2c7c90ca117fd63dcb7ff27",
    spotify: "1ODM6xNS8Osji0prNFRK9H",
    genre: "uptempo hardcore",
    popularity: "20",
  },
  {
    name: "Eric van Sauers",
    image: "https://i.scdn.co/image/ab67616d0000b27332d604be8525b1c7a7680170",
    spotify: "0L26h5xiajmUS477rUs1wE",
    genre: "dutch cabaret",
    popularity: "20",
  },
  {
    name: "Gabber Eleganza",
    image: "https://i.scdn.co/image/1421c74fb772d61a32e4b97e7f88ab314e153127",
    spotify: "4rCySlHzijM0ZiFPx7tUhd",
    genre: "deconstructed club,experimental club",
    popularity: "20",
  },
  {
    name: "Salka Sól",
    image: "https://i.scdn.co/image/ab67616d0000b273ec8bed6fff78126d9ccaf4fe",
    spotify: "0lgsuFM2HtfiRaF64Dyq5L",
    genre: "",
    popularity: "20",
  },
  {
    name: "AXYS",
    image: "https://i.scdn.co/image/044326f17140c182fb73a0b77ffb174f0395f0f7",
    spotify: "0YFzKSeyTbP427lJN7t2Wj",
    genre: "",
    popularity: "20",
  },
  {
    name: "Dead Bronco",
    image: "https://i.scdn.co/image/57974560a605cc60929edb839a1158cca3f04653",
    spotify: "6P7WVoiWFbIPDTifjROfwF",
    genre: "spanish rockabilly",
    popularity: "20",
  },
  {
    name: "Cosmin TRG",
    image: "https://i.scdn.co/image/04971bbc560590cc1f3dad91ba239d7b558af040",
    spotify: "4jRLIIrKvl4rAmir58oDK0",
    genre: "bass music,future garage,romanian electronic",
    popularity: "20",
  },
  {
    name: "Nowaxx",
    image: "https://i.scdn.co/image/886a78a0bdaf7fc01e276ce1466ef6d64b104e8b",
    spotify: "3bvwEKgHJx9jLQGZmkqUg1",
    genre: "",
    popularity: "20",
  },
  {
    name: "Jay Shepheard",
    image: "https://i.scdn.co/image/e97bdc60d306709b3e2520caf7b410ca3ddd0e9e",
    spotify: "7vIEeWvX3ZQz0wIzSWIwdq",
    genre: "minimal tech house",
    popularity: "20",
  },
  {
    name: "Anthony Collins",
    image: "https://i.scdn.co/image/ab67616d0000b27310501edd036560a0a1aa5051",
    spotify: "4kIlPTuKTUdnIZDi2G7Kqi",
    genre: "minimal tech house",
    popularity: "20",
  },
  {
    name: "Kapibara",
    image: "https://i.scdn.co/image/cf554f3309c23f0033753c33d7f065c67d53970c",
    spotify: "4tWG36Cg7E242I26JiklSp",
    genre: "",
    popularity: "20",
  },
  {
    name: "DJs Pareja",
    image: "https://i.scdn.co/image/11fbc9c2bbe72add64ae5959d7ae63c966e76890",
    spotify: "5oTo90z4UYa7QUQ3Je3dQ7",
    genre: "electronica argentina,house argentino",
    popularity: "20",
  },
  {
    name: "Beesmunt Soundsystem",
    image: "https://i.scdn.co/image/ab67616d0000b27362c0c37f8b4a3101b0fa05a7",
    spotify: "5p2DCDgBRjgFrw7blAOrk5",
    genre: "dutch tech house",
    popularity: "20",
  },
  {
    name: "Relapse",
    image: "https://i.scdn.co/image/7c6b383833a6c235e36a4f26f3a7d82fb10878d9",
    spotify: "6FIDsLHMUgxEaL3mWChbXo",
    genre: "deathcore",
    popularity: "20",
  },
  {
    name: "Mario Aureo",
    image: "https://i.scdn.co/image/ab67616d0000b2738917b2a1382893b4e0d1abf2",
    spotify: "5XaiAtWZ9cVOYhD9fjnBXH",
    genre: "",
    popularity: "20",
  },
  {
    name: "Monomyth",
    image: "https://i.scdn.co/image/d778f8cb801104336cc8c3e763156a8bee109da4",
    spotify: "7BIt8dmieIJhheLq5UVQaH",
    genre: "space rock",
    popularity: "20",
  },
  {
    name: "Kamixlo",
    image: "https://i.scdn.co/image/4d30df13b3d94fe1842a97f64138939bb1a6588c",
    spotify: "047OAyUhKioOpwIRFrRVfx",
    genre: "deconstructed club,escape room,fluxwork,grimewave,hyperpop",
    popularity: "20",
  },
  {
    name: "Goldcash",
    image: "https://i.scdn.co/image/00600f8362db6b8ff71ab918f9e953d6eb9ffe7b",
    spotify: "2FilN9uglU0lRzLF7fCfdZ",
    genre: "brazilian edm",
    popularity: "20",
  },
  {
    name: "New Timeless",
    image: "https://i.scdn.co/image/ab67616d0000b2732e28f3b3a7b164cdc808e227",
    spotify: "0cITHw68HPLMChQETduF5D",
    genre: "",
    popularity: "20",
  },
  {
    name: "Luna City Express",
    image: "https://i.scdn.co/image/3a489543f0d79dc31458d2cd78481b1c620864fe",
    spotify: "7AB8teQwx7XLhhNqoWwspp",
    genre: "german tech house,minimal tech house",
    popularity: "20",
  },
  {
    name: "Fabio Florido",
    image: "https://i.scdn.co/image/04a78c06009708b609c2dccc03f5947c458f44bc",
    spotify: "42uH4r4LvmWlHvlQTwucAu",
    genre: "dark techno,italian techno",
    popularity: "20",
  },
  {
    name: "Matt Perriment",
    image: "https://i.scdn.co/image/0c1d2ff31879ce783780e325cfc8a297ceac5a9a",
    spotify: "6sZDpE6FObUEWdKLJxv5IZ",
    genre: "",
    popularity: "20",
  },
  {
    name: "PAX the humanoid",
    image: "https://i.scdn.co/image/f7db307f7feafa9b949607506c84c67403fc09dc",
    spotify: "41RD6qLSaR9TfXKjEiBFuq",
    genre: "",
    popularity: "20",
  },
  {
    name: "Ish K",
    image: "https://i.scdn.co/image/ab67616d0000b2737deca4c88ce1337e5585c79f",
    spotify: "5n7RJOSU4SVSzIwygbXgDl",
    genre: "",
    popularity: "20",
  },
  {
    name: "Fadi Mohem",
    image: "https://i.scdn.co/image/8ea18a5c5df0cd6803608a6ed90356bb23597fd0",
    spotify: "054VxUoJAoxf48TlGoWf75",
    genre: "experimental techno",
    popularity: "20",
  },
  {
    name: "Daan Boom",
    image: "https://i.scdn.co/image/959dd7ddf4b2df3ca58d60adcfac739ed122445c",
    spotify: "56225CKM4N5gqzSgqxEcnz",
    genre: "",
    popularity: "20",
  },
  {
    name: "Angosoundz",
    image: "https://i.scdn.co/image/b5ef6aa5070c13f1fb5ef75001e17a0a9c2d1fe4",
    spotify: "0ElopjAzh4q82I0GBLU7rD",
    genre: "dutch moombahton",
    popularity: "20",
  },
  {
    name: "Velvet Two Stripes",
    image: "https://i.scdn.co/image/48221eebfda5725bd91c98eddf3c9bbc3e21b660",
    spotify: "7pbcgkLjLsiXKYoKvdmW9g",
    genre: "swiss alternative rock",
    popularity: "20",
  },
  {
    name: "Shannen SP",
    image: "",
    spotify: "7hcpmtt4sP0aEMCxypuGfK",
    genre: "",
    popularity: "20",
  },
  {
    name: "Erik Arbores",
    image: "https://i.scdn.co/image/3c560a9dd123224fb77bee54a9e44585ef269020",
    spotify: "6A4JjRYCG77SRJmIBl18JW",
    genre: "deep uplifting trance",
    popularity: "20",
  },
  {
    name: "Dyed Soundorom",
    image: "https://i.scdn.co/image/ab67616d0000b273c4296afb62fbca06bbc60174",
    spotify: "47Vd7Tq85XedkSFBCa3kIw",
    genre: "french techno,minimal tech house",
    popularity: "20",
  },
  {
    name: "Gardens of God",
    image: "https://i.scdn.co/image/5ccf357e85e37e39dc30329799b086bdaee2a087",
    spotify: "5BuzgxcEyA7d2V9R9AnRyM",
    genre: "lithuanian electronic",
    popularity: "20",
  },
  {
    name: "Blake Baxter",
    image: "https://i.scdn.co/image/2b84c9fe30a7033e9311288b2ebc588bf443b1f6",
    spotify: "3ZKUeqiV2UX5sKhOipqw1h",
    genre: "detroit house,detroit techno,proto-techno,techno",
    popularity: "20",
  },
  {
    name: "Kadosh",
    image: "https://i.scdn.co/image/ab67616d0000b27398204201b804244c20701c26",
    spotify: "25Z7ON66VerIXHx1lZISaa",
    genre: "israeli techno",
    popularity: "20",
  },
  {
    name: "Eric Volta",
    image: "https://i.scdn.co/image/ab67616d0000b273426f98b57ae1471bffd55788",
    spotify: "1EGw75Ur0rSPaI2lvVih8f",
    genre: "",
    popularity: "20",
  },
  {
    name: "Spielbergs",
    image: "https://i.scdn.co/image/685a61d0313fd54580d661d4120c0ccacc680136",
    spotify: "1PTXobwsxwhjcIajCjV8u4",
    genre: "oslo indie",
    popularity: "20",
  },
  {
    name: "Huerta",
    image: "https://i.scdn.co/image/501360381aed69aa600d7473b6b563105b93fc07",
    spotify: "5RJa5zWNuVuSfqJB0Jx2ZY",
    genre: "float house",
    popularity: "20",
  },
  {
    name: "Lucas Laufen",
    image: "https://i.scdn.co/image/b2e78013ab7efc407fbd687a119c1c1ce92e264b",
    spotify: "19gboEzhj5N9maAsyg3TkW",
    genre: "",
    popularity: "20",
  },
  {
    name: "Aywy",
    image: "https://i.scdn.co/image/c22ff8daef0c91b3c6b2d990e456c149d58e12f7",
    spotify: "6r38VaW3wElzmIlJ69Cz2L",
    genre: "",
    popularity: "20",
  },
  {
    name: "Tim Easton",
    image: "https://i.scdn.co/image/273036524ee91fdbe529cd82a81da932e6ec3f01",
    spotify: "11ixEVNpyaaCW7VfC7fx8M",
    genre: "alternative country,roots rock",
    popularity: "20",
  },
  {
    name: "Southstylers",
    image: "https://i.scdn.co/image/ab67616d0000b27379a99a6912128084cbf9854b",
    spotify: "6sOgkz45JwQRmQg9MOyB1P",
    genre: "classic hardstyle",
    popularity: "20",
  },
  {
    name: "Ninos Du Brasil",
    image: "https://i.scdn.co/image/82a7c1ee83d44921621aff284689a635c83fb84b",
    spotify: "2ALx5yXpSTe5aPEF2vLeGa",
    genre: "experimental techno",
    popularity: "20",
  },
  {
    name: "The Hotknives",
    image: "https://i.scdn.co/image/ab67616d0000b273e8e456677e37477502679732",
    spotify: "2uoezM6j8nCGupNI3zeMcb",
    genre: "euroska,ska,ska revival,traditional ska",
    popularity: "20",
  },
  {
    name: "Droop Lion",
    image: "https://i.scdn.co/image/ab67616d0000b2736c27129e38d024c3ae638bf3",
    spotify: "40Sl3WyKbGFMCbmrVzOrR4",
    genre: "",
    popularity: "20",
  },
  {
    name: "Invictuz",
    image: "https://i.scdn.co/image/b7e28a0503b5c8dde1d612d393e32f16e6558c84",
    spotify: "2pN6eQ3LBF6BLCC1wxUSpp",
    genre: "rawstyle",
    popularity: "20",
  },
  {
    name: "Pat Krimson",
    image: "https://i.scdn.co/image/5fc524f14cd86dd909fd4a31c36e89bff08f661b",
    spotify: "5eM988kictwqIzMU1Y72tF",
    genre: "",
    popularity: "20",
  },
  {
    name: "Zephyrtone",
    image: "https://i.scdn.co/image/95f435b6a909c5b1d040ec1ddb50f459631688b3",
    spotify: "57GVEttnzshGnLYIJCFeKo",
    genre: "indian edm",
    popularity: "20",
  },
  {
    name: "CS + Kreme",
    image: "https://i.scdn.co/image/ab67616d0000b27318081571634287c51e7afbfc",
    spotify: "6mVIepilotsPjD4ZmlFtE5",
    genre:
      "experimental synth,float house,fourth world,new isolationism,outsider house",
    popularity: "20",
  },
  {
    name: "Abi Wade",
    image: "https://i.scdn.co/image/0e0ce4e779ee6bdfe3ab3c15a026f48eaa5b875e",
    spotify: "5n8QrwmB8PFj5uqJ9nJElU",
    genre: "brighton indie",
    popularity: "20",
  },
  {
    name: "Pattern J",
    image: "https://i.scdn.co/image/ab67616d0000b27347cbf3a016dbff7dbd9bbd9b",
    spotify: "1d4T4OjQ2lg3QQKzU07DLV",
    genre: "frenchcore,speedcore",
    popularity: "20",
  },
  {
    name: "Rossko",
    image: "https://i.scdn.co/image/6049d9c51f6fe63e54490a49bc09a643a1c2e54c",
    spotify: "66xag8HZK2LNxS1YH8g6rh",
    genre: "",
    popularity: "20",
  },
  {
    name: "Laila Biali",
    image: "https://i.scdn.co/image/1cd75417b817fb5edf5132047c9ad3130c18d0e1",
    spotify: "6ioJTe2wSpFulE39iP818I",
    genre: "",
    popularity: "20",
  },
  {
    name: "Hans Dorrestijn",
    image: "https://i.scdn.co/image/ab67616d0000b2731572e2add99050febb60586a",
    spotify: "1UZtomtmgNIaDY3k1tpuN5",
    genre: "dutch cabaret",
    popularity: "19",
  },
  {
    name: "MC Chucky",
    image: "https://i.scdn.co/image/ab67616d0000b27390cfc18751f167cb03db1aa7",
    spotify: "5otFu5fmqPz4iXpQOpy8Sn",
    genre: "",
    popularity: "19",
  },
  {
    name: "Diederik van Vleuten",
    image: "https://i.scdn.co/image/ab67616d0000b273ef994d9d642424985d4bfc27",
    spotify: "6mmdMsSdhEH3w0h3Yc6p1X",
    genre: "dutch cabaret",
    popularity: "19",
  },
  {
    name: "Leona Philippo",
    image: "https://i.scdn.co/image/ab67616d0000b273845f6c7dfd28165bbfa139ff",
    spotify: "5hOxe2xHb5k8hLqFPlMdel",
    genre: "dutch idol pop",
    popularity: "19",
  },
  {
    name: "Dinky",
    image: "https://i.scdn.co/image/ab67616d0000b273d1a52ecb1b6b9064cc84276d",
    spotify: "4ZMYjOvo4ciEwFRqfcHRyU",
    genre: "electronica chilena",
    popularity: "19",
  },
  {
    name: "Ale Möller",
    image: "https://i.scdn.co/image/5bd1d8a562b6123334d319c0be4bd2dc66cf2fc0",
    spotify: "5kWZBRi1mL1QA414GqLllw",
    genre: "folkmusik,hardingfele,nordic folk",
    popularity: "19",
  },
  {
    name: "Cora Novoa",
    image: "https://i.scdn.co/image/6c6c300f29e4a66368dab5c8e6f9c99eec27be25",
    spotify: "3PQuCFd5KBN1aPRUMIBjt7",
    genre: "minimal melodic techno,spanish electronic",
    popularity: "19",
  },
  {
    name: "Joran Van Pol",
    image: "https://i.scdn.co/image/f95122702cbef7fc434037a8e9324bee50dd5d79",
    spotify: "4hQrSolpkEEfXjl5vPSfIi",
    genre: "dutch tech house",
    popularity: "19",
  },
  {
    name: "Kolonien",
    image: "https://i.scdn.co/image/70662bb1941dfdf0c9f81dbd2a3b649ba714b15b",
    spotify: "1Grb25RtI3EIYzL2r2yLy4",
    genre: "",
    popularity: "19",
  },
  {
    name: "Behrouz",
    image: "https://i.scdn.co/image/59f84c9766282831222f76618be25f60827d60c9",
    spotify: "1L6IBprFjkR2f4P1xEBSf7",
    genre: "",
    popularity: "19",
  },
  {
    name: "Conny Bloom",
    image: "https://i.scdn.co/image/9f9ff4ba4a08c5457c6f6af5cbd216d085b9d169",
    spotify: "4h11aQM6HqMZjxa6DCC44n",
    genre: "swedish hard rock",
    popularity: "19",
  },
  {
    name: "Arnaud Le Texier",
    image: "https://i.scdn.co/image/adce8f60e290a814cb0fe439074500e712a7d535",
    spotify: "7Gj9kZNsS1xUZTERqOpxmB",
    genre: "acid techno,minimal dub,minimal tech house",
    popularity: "19",
  },
  {
    name: "FeR BR",
    image: "https://i.scdn.co/image/62afe7ccd1f8a488fec736890dd6d03339592a72",
    spotify: "78fAtGKcAeu68c4mPLo9Q9",
    genre: "re:techno",
    popularity: "19",
  },
  {
    name: "Skoften Sloopservice",
    image: "https://i.scdn.co/image/ab67616d0000b273311a8de7902ecebb8a0bc257",
    spotify: "7AfM80GvEJwIzxf2zocMtQ",
    genre: "",
    popularity: "19",
  },
  {
    name: "Hannah Holland",
    image: "https://i.scdn.co/image/16fab67cb397e3fbc8a38008626860d7dfe4ffe6",
    spotify: "3paxIyAbBuTSw8RDF22vHs",
    genre: "",
    popularity: "19",
  },
  {
    name: "Christoph De Babalon",
    image: "https://i.scdn.co/image/ab67616d0000b27360971810a9735d46eed8310c",
    spotify: "4ZrzdbajcxLidPJDPZomzz",
    genre: "breakcore,digital hardcore,drill and bass,intelligent dance music",
    popularity: "19",
  },
  {
    name: "Mareena",
    image: "",
    spotify: "1Rvh9XnnNiEREexjlwyGvZ",
    genre: "",
    popularity: "19",
  },
  {
    name: "Want Want",
    image: "https://i.scdn.co/image/624edc3b67d0abdd10a9af60bbbe8bf0aa292dda",
    spotify: "6BI7Q7baifGDSR8nmdUURi",
    genre: "dutch rock",
    popularity: "19",
  },
  {
    name: "Anthony Attalla",
    image: "https://i.scdn.co/image/a115287df4808b336a6e349284f2312180298593",
    spotify: "6UmrPT15mLI5ALbsDqwsQv",
    genre: "arab electronic",
    popularity: "19",
  },
  {
    name: "Kid Culture",
    image: "https://i.scdn.co/image/ab67616d0000b2736bcb9ad72c0ffa10bb474b75",
    spotify: "1WOeFdxhwqnF92RUwekEeu",
    genre: "deep tech house",
    popularity: "19",
  },
  {
    name: "Rocky Tilbor",
    image: "https://i.scdn.co/image/03157bf2afdcc93dfc117c9f47eadf26eeedab33",
    spotify: "0dTvTtHgS6T5e9mOMdk8jO",
    genre: "",
    popularity: "19",
  },
  {
    name: "Mulder",
    image: "https://i.scdn.co/image/ab67616d0000b273aa27f7ebd4e55881fb4fd1bf",
    spotify: "2JEj10kSfWAKVrgYLqnnFi",
    genre: "carnaval,drum and bass",
    popularity: "19",
  },
  {
    name: "David Kochs",
    image: "https://i.scdn.co/image/a5dd411b86e6d4515f70c63bd83a125c0793d01d",
    spotify: "59FBgWtPAe1RKnBbVOWEWP",
    genre: "",
    popularity: "19",
  },
  {
    name: "Polar Inertia",
    image: "https://i.scdn.co/image/ab67616d0000b2736b7f5021917af5fc74c28ae3",
    spotify: "0WStQnW9WLEG01RKPDB0oy",
    genre: "french techno,minimal dub",
    popularity: "19",
  },
  {
    name: "Seek N Destroy",
    image: "https://i.scdn.co/image/137332bfc8a24f138b7666d1aeedcdbdd5ac35ab",
    spotify: "2H0GPTuTiQnmbzifsIE3hB",
    genre: "",
    popularity: "19",
  },
  {
    name: "IDIOTAPE",
    image: "https://i.scdn.co/image/9c6f246b6199c4feabc750458fe791eb0e87ef82",
    spotify: "0OmQCkk1rR3DJ0Y2NRxp6Z",
    genre: "k-indie,korean electronic",
    popularity: "19",
  },
  {
    name: "GospelbeacH",
    image: "https://i.scdn.co/image/2ba4d168e01bc7001af28c133b7bcc9f5caee548",
    spotify: "22DqYr3VzrlKqTY54Jo20d",
    genre: "neo-psychedelic",
    popularity: "19",
  },
  {
    name: "Rimer London",
    image: "https://i.scdn.co/image/ab67616d0000b273dc82c84531045e95e5b5bb8e",
    spotify: "4Kdb6rwgdSPx0P2AUhvdee",
    genre: "",
    popularity: "19",
  },
  {
    name: "Cosmic Force",
    image: "https://i.scdn.co/image/ab67616d0000b273eb7b5b32df53814c37457eec",
    spotify: "4oQa8Muhaby3w9AhvcwBM8",
    genre: "electro",
    popularity: "19",
  },
  {
    name: "Hubert Kirchner",
    image: "https://i.scdn.co/image/ab67616d0000b273c00fcd19e2b81e01eaa9f214",
    spotify: "5iVp5gQknGUHKjA7b0YIIN",
    genre: "deep techno",
    popularity: "19",
  },
  {
    name: "Chymera",
    image: "https://i.scdn.co/image/9f873d95e05dc5cb61796dd275d4e5a413563e03",
    spotify: "4Okdpsv48mLytzodoV8jcC",
    genre: "irish electronic",
    popularity: "19",
  },
  {
    name: "Gold Class",
    image: "https://i.scdn.co/image/74951b5791e44f8695295bfe04d5f5afcc0bf069",
    spotify: "1RTevYhzs4M9S7bMehGa4h",
    genre: "melbourne indie",
    popularity: "19",
  },
  {
    name: "Dave Till",
    image: "https://i.scdn.co/image/ab67616d0000b27303c466540b1cdc1c2581e21c",
    spotify: "2GVU8YDIX1urxOOybKe8oS",
    genre: "",
    popularity: "19",
  },
  {
    name: "Retaliation",
    image: "https://i.scdn.co/image/9a9f2fcfbd8903663131ec6522cae82dca597d6a",
    spotify: "33WbKYUz0YIPwtO0HKTJX7",
    genre: "grindcore,hardstyle,rawstyle",
    popularity: "19",
  },
  {
    name: "Msafiri Zawose",
    image: "https://i.scdn.co/image/1db5e62e974b3a4157fdf398ca26f7acdd4023f8",
    spotify: "11ouELfzx4OsUjTQNlOa8w",
    genre: "african electronic",
    popularity: "19",
  },
  {
    name: "Mitchell Yard",
    image: "https://i.scdn.co/image/f97355ce8d57abfb5518aa3c42cd3fb03e928de8",
    spotify: "6uBNJwADs2esWMFezi5Eb2",
    genre: "",
    popularity: "19",
  },
  {
    name: "Lee van Dowski",
    image: "https://i.scdn.co/image/cfea08bbb24d2e0ab711fad95297e9fd4d7b755b",
    spotify: "0AJXTSXK0tm1nNb0VU4bt2",
    genre: "minimal tech house,swiss techno",
    popularity: "19",
  },
  {
    name: "Scram C Baby",
    image: "https://i.scdn.co/image/950411eb7bb0ae6629b1fb50b50cdb9d852d21d6",
    spotify: "1WNlmn5QHt21IxtWJ43ZHe",
    genre: "dutch indie",
    popularity: "19",
  },
  {
    name: "Alma Negra",
    image: "https://i.scdn.co/image/f4154a359d949f5cc38271fcb0a6dde604f4689e",
    spotify: "574U9VlIOZIzbqrQ3cDbBP",
    genre: "",
    popularity: "19",
  },
  {
    name: "Die! Die! Die!",
    image: "https://i.scdn.co/image/09e1c2110722a5f2d6d7d5ff30a91ccab87e5eef",
    spotify: "3sw1EdLe5kwbLA6sIGflwW",
    genre: "dunedin indie,kiwi rock,nz indie,nz punk",
    popularity: "19",
  },
  {
    name: "David Dam",
    image: "https://i.scdn.co/image/ab67616d0000b27360812b7fc2402f09192dff24",
    spotify: "6O8lFWabi7RdeT4KPKr4Zs",
    genre: "dutch idol pop",
    popularity: "19",
  },
  {
    name: "David Numwami",
    image: "https://i.scdn.co/image/967fa201882b032044b39f08bdcbde7b4a21b0ea",
    spotify: "2uKChU7eHSda8R79iR9rel",
    genre: "",
    popularity: "19",
  },
  {
    name: "Kry Wolf",
    image: "https://i.scdn.co/image/2d2a401447be3f3b9e5ff248f6d7f8a799486a25",
    spotify: "34cO9ZE1CDN4O7bmpjIJs8",
    genre: "bass house",
    popularity: "19",
  },
  {
    name: "Blankface",
    image: "https://i.scdn.co/image/ca562fe7436fa6bb9d44dd468b085f13c1548e36",
    spotify: "0wBTYeI6551XR1lhbxRQnV",
    genre: "",
    popularity: "19",
  },
  {
    name: "Adam Faucett",
    image: "https://i.scdn.co/image/ab67616d0000b273aa2431511118d85a6c83916f",
    spotify: "7KKfgYWNAbHHNOWmgpdn0M",
    genre: "arkansas indie,little rock indie",
    popularity: "19",
  },
  {
    name: "Blackfoot Gypsies",
    image: "https://i.scdn.co/image/ca6c798e512a7272eec447112b45bbec5dd81f9d",
    spotify: "4wTY4zovD9wK63Wi4WhxGN",
    genre: "modern blues rock",
    popularity: "19",
  },
  {
    name: "Lake Haze",
    image: "https://i.scdn.co/image/2d96f4ff3295e95c56d7acc6a28311916b903c28",
    spotify: "2MtRL570s7Y5I9BOVPN9cN",
    genre: "braindance",
    popularity: "19",
  },
  {
    name: "Rumbaristas",
    image: "https://i.scdn.co/image/af91bdf6ce625787865af9f1eecfa234322d321a",
    spotify: "1lCsy1LgNCjBXrmfoAFvUr",
    genre: "",
    popularity: "19",
  },
  {
    name: "Wynchester",
    image: "https://i.scdn.co/image/c5a669271caf64a42325db0f55a82fa6b602f57e",
    spotify: "5yLbdZs1VYgE1Jri2LNvJb",
    genre: "",
    popularity: "19",
  },
  {
    name: "Piemont",
    image: "https://i.scdn.co/image/2535f03a3c4e53a7d19a4c78d75e048c765c898f",
    spotify: "2N6aCxMw56t6OuH5Jn23D7",
    genre: "hamburg electronic,minimal techno,organic electronic,tech house",
    popularity: "19",
  },
  {
    name: "Marco Resmann",
    image: "https://i.scdn.co/image/62408be8a6c3344c3cdfc01b903ee3fc44d256e6",
    spotify: "2fC8GMMVIAVPBX2O50Lijm",
    genre: "german tech house",
    popularity: "19",
  },
  {
    name: "No Artificial Colours",
    image: "https://i.scdn.co/image/a7a207b537d5c3c6ebe45609ee50910024af47fa",
    spotify: "3MwGo8NAlHS08lg0M7nTo9",
    genre: "deep disco house",
    popularity: "19",
  },
  {
    name: "Spencer Tarring",
    image: "https://i.scdn.co/image/5eb86933ce70bcf041e38fb231eb7a4a8e9a59d0",
    spotify: "0RZuAvECZuiK1PZ5HMIvcv",
    genre: "",
    popularity: "19",
  },
  {
    name: "Juiceboxxx",
    image: "https://i.scdn.co/image/69626edbfe9f133f03f58f40b269eeb2b16933e2",
    spotify: "0PTyA08B3iE3XUokbUC9k8",
    genre: "bmore,milwaukee hip hop",
    popularity: "19",
  },
  {
    name: "Or:la",
    image: "https://i.scdn.co/image/ab67616d0000b273703a5eae4fba66d20b416adb",
    spotify: "2HMcYonnetvTrEXnwIvchf",
    genre: "irish electronic",
    popularity: "18",
  },
  {
    name: "The DJ Producer",
    image: "https://i.scdn.co/image/ab67616d0000b2735620e4d5315c1d623b9a9f8a",
    spotify: "5K4DYOZmv58mpArt4NCumc",
    genre: "doomcore,gabba,hardcore techno,industrial hardcore,speedcore",
    popularity: "18",
  },
  {
    name: "Abstract Division",
    image: "https://i.scdn.co/image/36a01296bff65f7c920a9f9762a00d2c77c033dd",
    spotify: "6vJQQlRxEwIOVYv2NrmODp",
    genre: "minimal dub",
    popularity: "18",
  },
  {
    name: "Djipe",
    image: "https://i.scdn.co/image/ab67616d0000b2737761124bf6c8442a163d981b",
    spotify: "2ryXW39uQFig8qnQHaMVvh",
    genre: "industrial hardcore",
    popularity: "18",
  },
  {
    name: "Delta Funktionen",
    image: "https://i.scdn.co/image/2292c2a9b52490b4fa5c1bd3edac4e5f56f76226",
    spotify: "53IfD3QieElrbwdMkNxX6G",
    genre: "acid techno,minimal dub,outsider house",
    popularity: "18",
  },
  {
    name: "Kris Baha",
    image: "https://i.scdn.co/image/4137b3125243e82dbb816f5f846d17632516a5f6",
    spotify: "4Z91fAnagtMpEwyvz7Vva1",
    genre: "ebm",
    popularity: "18",
  },
  {
    name: "Romperayo",
    image: "https://i.scdn.co/image/a61ec7f751147a551d3c1a0bace7aefc1981c241",
    spotify: "1Ey12Gi2P3PNPBsz39cncu",
    genre: "latin afrobeat",
    popularity: "18",
  },
  {
    name: "Johnny de Mol",
    image: "https://i.scdn.co/image/86af192e2d603857a7a0ea7154f8a2cf87906f07",
    spotify: "59h5GyVAAhZM4BepH9TaFb",
    genre: "",
    popularity: "18",
  },
  {
    name: "Pessimist",
    image: "https://i.scdn.co/image/ab67616d0000b2737a7121a5315588978bd058f4",
    spotify: "4EdGRco8RTYP53yxr6WI9T",
    genre: "german thrash metal",
    popularity: "18",
  },
  {
    name: "Black Merlin",
    image: "https://i.scdn.co/image/ab67616d0000b273cc9d50d499d970562629aa39",
    spotify: "63YnT4fynoWkgFZBwVdjvD",
    genre: "experimental techno",
    popularity: "18",
  },
  {
    name: "Olaf Stuut",
    image: "https://i.scdn.co/image/cfb9dc1e18b4fcf4712a3f0802d94570a6463208",
    spotify: "6yk6Kw36FxYkKJpbdA84th",
    genre: "",
    popularity: "18",
  },
  {
    name: "Ray Okpara",
    image: "https://i.scdn.co/image/4cf1d47fe439df64182e6266250c1b4ac6de3500",
    spotify: "6EhZghoXSCh77ZwpkKwnfn",
    genre: "minimal tech house",
    popularity: "18",
  },
  {
    name: "DJ Richard",
    image: "https://i.scdn.co/image/ab67616d0000b2736dd0ec3686e53a6b659ca7cf",
    spotify: "4Z0NecXmUvbtKVYHjNGnYC",
    genre: "",
    popularity: "18",
  },
  {
    name: "John Kho",
    image: "https://i.scdn.co/image/f0378b11292ceaf07fc2ae466bec8994e31ce9cf",
    spotify: "0VchsYZoaIrsXSCaJwKWlY",
    genre: "",
    popularity: "18",
  },
  {
    name: "The Girls",
    image: "https://i.scdn.co/image/ab67616d0000b2730f20476ba06c71a321ba530d",
    spotify: "4O5HTw3xKD1c8iSrjplBGU",
    genre: "",
    popularity: "18",
  },
  {
    name: "Painbringer",
    image: "https://i.scdn.co/image/c3ba9beca60c395139c5c2b32ae86bb33de14bb7",
    spotify: "3CpXzpDbtR30ZgbwRtV0QV",
    genre: "dark hardcore",
    popularity: "18",
  },
  {
    name: "Eddyhardcore",
    image: "https://i.scdn.co/image/76cf0b96f3f94d0f663e6bac739f06bc023b988a",
    spotify: "6T6I59qByHSvEZwVu4vlqa",
    genre: "",
    popularity: "18",
  },
  {
    name: "Bonanza",
    image: "https://i.scdn.co/image/c2333f437a3c009b1a612571e02b2ba4fad9222a",
    spotify: "7qiX8MeTrOaWLcJqYBPGIA",
    genre: "folklore boliviano",
    popularity: "18",
  },
  {
    name: "The Venopian Solitude",
    image: "https://i.scdn.co/image/73863ce37b26aa360ad8e91af5ef35bde897dd86",
    spotify: "21sTjUBQjHT0uozvt5vJT9",
    genre: "malaysian indie",
    popularity: "18",
  },
  {
    name: "Ernst Jansz",
    image: "https://i.scdn.co/image/d100fdd0eb91ef03fed4853daf6d75f8f192b91a",
    spotify: "4coHdOCwAsgKoy4WNp9p92",
    genre: "",
    popularity: "18",
  },
  {
    name: "Tarabband",
    image: "https://i.scdn.co/image/ab67616d0000b273d9749b6ee8ea84b92729adb9",
    spotify: "7HMpq7BBo9dLKr1z961pRA",
    genre: "arab alternative,jordanian pop",
    popularity: "18",
  },
  {
    name: "Mc I See",
    image: "https://i.scdn.co/image/bb56b2790e548fb596cdcce3ea7f41cde10ca6b6",
    spotify: "14UOMks6TDblSI50wGAnpb",
    genre: "",
    popularity: "18",
  },
  {
    name: "Karies",
    image: "https://i.scdn.co/image/ab67616d0000b273b6c0c990f8ee42b7a74a0a4c",
    spotify: "2rNs3aF3Froiogj0sO6gEG",
    genre: "german post-punk,neue deutsche welle,stuttgart indie",
    popularity: "18",
  },
  {
    name: "Asonn",
    image: "https://i.scdn.co/image/e68e4cbd6c8672dbacc1347bf256096fef193730",
    spotify: "2rZ1rTP698llVhWZgrkqTx",
    genre: "sky room",
    popularity: "18",
  },
  {
    name: "Het Gezelschap",
    image: "https://i.scdn.co/image/ab67616d0000b27332f57d430fd6ae3ec0eafda4",
    spotify: "6CDZcsG0fNXEjERPKYo4g6",
    genre: "",
    popularity: "18",
  },
  {
    name: "Hallo Venray",
    image: "https://i.scdn.co/image/ef45df34335157c19bd0a4de0b2ea3dc22d2df62",
    spotify: "5HqkqH2X6qlLmHCJFAVn4B",
    genre: "dutch indie,dutch rock",
    popularity: "18",
  },
  {
    name: "Gel Abril",
    image: "https://i.scdn.co/image/b68582d1530aba64c0b8a2e79086018a84b7fdd0",
    spotify: "3HH7PmnlxHcPClsKBuARwv",
    genre: "israeli techno",
    popularity: "18",
  },
  {
    name: "Space Afrika",
    image: "https://i.scdn.co/image/ab67616d0000b273cd83b8cdef0a7bdcf5fcef68",
    spotify: "6cU1HCzqStKzT3NUuaaCO5",
    genre: "afrofuturism,space ambient",
    popularity: "18",
  },
  {
    name: "Autodrive",
    image: "https://i.scdn.co/image/11bbe05df59a938f76a534eae5b96516961d2475",
    spotify: "3Hyef23qLTCYi3waPfCSS1",
    genre: "",
    popularity: "18",
  },
  {
    name: "Bloody Mary",
    image: "https://i.scdn.co/image/ab67616d0000b273cbaca007f45f4f08ec1d4aed",
    spotify: "0qU4ACuOtta4asBwNalSkk",
    genre: "",
    popularity: "18",
  },
  {
    name: "Bass Kleph",
    image: "https://i.scdn.co/image/ab67616d0000b2730d56fbbb442d58355fc3fb0b",
    spotify: "4MG0LJKgAHw48TxPbxB5eE",
    genre: "australian dance",
    popularity: "18",
  },
  {
    name: "Glaskin",
    image: "https://i.scdn.co/image/aa424a77e6c6a6838f1fd1e235de7f729435a244",
    spotify: "6LgoiCHFiaKe3j70f1KUDp",
    genre: "munich electronic",
    popularity: "18",
  },
  {
    name: "Florian Kupfer",
    image: "https://i.scdn.co/image/eb5fd59afa47051fb00801d156275e65b7ba0018",
    spotify: "5nChWRbqHpDiwZcs4ZoKCV",
    genre: "lo-fi house,outsider house",
    popularity: "18",
  },
  {
    name: "Tim Xavier",
    image: "https://i.scdn.co/image/ab67616d0000b273693ac0cc9f5d7591c47fc9eb",
    spotify: "4ZeglFNS1tfY9BjslMot0e",
    genre: "acid techno",
    popularity: "18",
  },
  {
    name: "Sean Miller",
    image: "https://i.scdn.co/image/d56bff59db3ff3256588dc5a0ff58ea6745fd9de",
    spotify: "1GfiwEaxPDWS9m1D1Ma8LV",
    genre: "",
    popularity: "18",
  },
  {
    name: "Romano Nervoso",
    image: "https://i.scdn.co/image/7e4c9a09349161e4c8d9a0bbbed550b3bee8461e",
    spotify: "44KF6kM7O7HaLyLjFk0bnn",
    genre: "",
    popularity: "18",
  },
  {
    name: "Revolvr",
    image: "https://i.scdn.co/image/a3c7bc5ee147aff3efe04ab7b4a2a4c9be572b0a",
    spotify: "3vXI6iIlwugzEdnZVLMK1f",
    genre: "complextro",
    popularity: "18",
  },
  {
    name: "Drunky Daniels",
    image: "https://i.scdn.co/image/4eabe23aaafba560db64a438f27cb0196820d773",
    spotify: "5cUKEZqKoefSSPTe4hVtBb",
    genre: "afrofuturismo brasileiro,brazilian house",
    popularity: "18",
  },
  {
    name: "Davina Moss",
    image: "https://i.scdn.co/image/3c8abc1dea9e0df341543ead2d66b8c9418582a4",
    spotify: "5jfyzrPbhNoNWNdMHI6fYn",
    genre: "spanish techno,uk tech house",
    popularity: "18",
  },
  {
    name: "Eddy Zoëy",
    image: "https://i.scdn.co/image/6d10379475c8bca57fa86358a91cf5e4f90eddb3",
    spotify: "52NijRZsh1go3pqlnDGEEi",
    genre: "",
    popularity: "18",
  },
  {
    name: "Jon Tarifa",
    image: "https://i.scdn.co/image/0c299264be42d0344fd10a4f72e039ad1425a888",
    spotify: "1QCAyWM6UB5r6HadscSUQv",
    genre: "",
    popularity: "18",
  },
  {
    name: "Sonny Wharton",
    image: "https://i.scdn.co/image/cfe661591d1f7ea8f87261f2b82a25f8be554a0c",
    spotify: "4PDIDi6dG4RAhv6bof5jI7",
    genre: "uk tech house",
    popularity: "18",
  },
  {
    name: "Nitrouz",
    image: "https://i.scdn.co/image/ab67616d0000b273cafe5ad513067c5507e99305",
    spotify: "2LWNycSa5dfqLukyKdgQ86",
    genre: "classic hardstyle",
    popularity: "18",
  },
  {
    name: "Hanne Hukkelberg",
    image: "https://i.scdn.co/image/fb8673a05b5d26d9222ef0bbb196a0952a2de527",
    spotify: "0pGsKU60aKi7MK8rQENGwZ",
    genre: "norwegian singer-songwriter",
    popularity: "18",
  },
  {
    name: "Mr.What?",
    image: "https://i.scdn.co/image/ab67616d0000b27366d22a403370eb9e551381d3",
    spotify: "0BVHNPbKV9wOccTCgzBGvo",
    genre: "progressive psytrance",
    popularity: "18",
  },
  {
    name: "Marc Maya",
    image: "https://i.scdn.co/image/ab67616d0000b273db9068be42d4370cfc465091",
    spotify: "40jn3d7NlQEu5yQs1UzQCp",
    genre: "latin tech house",
    popularity: "18",
  },
  {
    name: "Kutmah",
    image: "https://i.scdn.co/image/658959c5cddbca4b5248f02c95ba7fbbd23d7c27",
    spotify: "5Wn9vkJRR8S8Sr7oMdGzvF",
    genre: "wonky",
    popularity: "18",
  },
  {
    name: "33EMYBW",
    image: "https://i.scdn.co/image/ab67616d0000b27377291772a21defba29e2edc1",
    spotify: "0faVPXr9Sui0OWJl2hRDQT",
    genre: "chinese electronic,deconstructed club,fluxwork",
    popularity: "18",
  },
  {
    name: "Steve Rachmad",
    image: "https://i.scdn.co/image/2edca487c65e9852270305f506de4a339ab86929",
    spotify: "4BmzfIGmnyaxu1REssIgPp",
    genre: "dutch tech house,techno",
    popularity: "18",
  },
  {
    name: "Robbie Akbal",
    image: "https://i.scdn.co/image/9fb329bd83766bdb0cf08a1a1941af71cd1d7d4a",
    spotify: "3LvGzX9zs4GCx44NhOWN1H",
    genre: "",
    popularity: "18",
  },
  {
    name: "Paolo Mojo",
    image: "https://i.scdn.co/image/352d5e2741f8edc2d5ac0485f210503e8047be38",
    spotify: "4UyOKyr2Sue7QLElEVpaE6",
    genre: "",
    popularity: "18",
  },
  {
    name: "Niko Zografos",
    image: "https://i.scdn.co/image/3e0d7f6b51b56bda2ac1f55acf4db19536a9f7e6",
    spotify: "0MNLpHylMgkviF4qCu0iGU",
    genre: "",
    popularity: "18",
  },
  {
    name: "Throes + The Shine",
    image: "https://i.scdn.co/image/70f57aec7cfa882941572bc3cff2cfacdbe45705",
    spotify: "25z4NCDwHppxyMeHxDWEVV",
    genre: "portuguese rock",
    popularity: "18",
  },
  {
    name: "Alex Kennon",
    image: "https://i.scdn.co/image/ddb2d4366b9fdd899c11a0705148f1f34e75f289",
    spotify: "1HMBuicB5RnpHxRDR51oMS",
    genre: "",
    popularity: "18",
  },
  {
    name: "Spirit Fest",
    image: "https://i.scdn.co/image/ab6772690000c46c4f3761077db969511e987ce8",
    spotify: "1pa1czQVBBys9koDmNMBRB",
    genre: "munich indie",
    popularity: "18",
  },
  {
    name: "The Logues",
    image: "https://i.scdn.co/image/60bdb72cb72102cba9211be9237dbc1ec6b8163b",
    spotify: "1VqXbsLnbk2AZmoAATfK17",
    genre: "",
    popularity: "18",
  },
  {
    name: "Amanda Andréas",
    image: "https://i.scdn.co/image/940bdd1154c3cf360ccc84885d448c60c1ff18ca",
    spotify: "5OhREmXu5ZLQWGnu6r8cjc",
    genre: "",
    popularity: "18",
  },
  {
    name: "Burning Fik",
    image: "https://i.scdn.co/image/ab67616d0000b2738ce1e6d9b83057807dcba5e3",
    spotify: "1utXhIqL1Gg3iKRCy3T50K",
    genre: "",
    popularity: "18",
  },
  {
    name: "Milton Bradley",
    image: "https://i.scdn.co/image/ab67616d0000b273eb9ff3e9161cfbec38b0a181",
    spotify: "5tXByO6GQCzWa9ifphd8e0",
    genre: "minimal dub",
    popularity: "18",
  },
  {
    name: "Franck Roger",
    image: "https://i.scdn.co/image/552b2ca34a204686b8a2658b7cc15a06df4d7690",
    spotify: "3MufUuGHNXVyi1kuL4mCdL",
    genre: "deep house",
    popularity: "18",
  },
  {
    name: "Wave Pressure",
    image: "https://i.scdn.co/image/69ffc5e46df5dac8e679a4d8b7db17146ad803eb",
    spotify: "3386mzmXn1zbBUmJap05us",
    genre: "euphoric hardstyle,hardstyle",
    popularity: "18",
  },
  {
    name: "Katinka Polderman",
    image: "https://i.scdn.co/image/e2d0eb6f0effc15d8e97e500b760e102350ca81a",
    spotify: "0kKuVOJeuxR28GnobggwUq",
    genre: "dutch cabaret",
    popularity: "17",
  },
  {
    name: "Lenette van Dongen",
    image: "https://i.scdn.co/image/1552dd5a040fdab60e96f96c578a4cb61b4e486d",
    spotify: "5HTOw5osUIVg2noTy58Uym",
    genre: "dutch cabaret",
    popularity: "17",
  },
  {
    name: "Theo Nijland",
    image: "https://i.scdn.co/image/ab67616d0000b273b92df7737ece04a9f08e01f4",
    spotify: "3S6PTk3s73MhjqBt8k7uew",
    genre: "",
    popularity: "17",
  },
  {
    name: "Pete Tha Zouk",
    image: "https://i.scdn.co/image/05bf840dcc9a81deb3c72402859c40b6e520b185",
    spotify: "3KVGfG8xDQWi1MWU1KUbvb",
    genre: "",
    popularity: "17",
  },
  {
    name: "DJ Bart",
    image: "https://i.scdn.co/image/ab67616d0000b273996335fb4d4d5acaa5de46cb",
    spotify: "5udyQZR45UaOgLLrfST1JS",
    genre: "",
    popularity: "17",
  },
  {
    name: "Deathmachine",
    image: "https://i.scdn.co/image/ab67616d0000b27384495edcbfb31d75cf8ceef8",
    spotify: "45v249ZA13O6zMpmg7djby",
    genre: "doomcore,industrial hardcore,speedcore",
    popularity: "17",
  },
  {
    name: "Les Mecs",
    image: "https://i.scdn.co/image/ab67616d0000b2735e4b59a1a93030706901e005",
    spotify: "7l5Q0ZBruKKvPql3GNBL5w",
    genre: "",
    popularity: "17",
  },
  {
    name: "Igneon System",
    image: "https://i.scdn.co/image/37a4c9f2ba1acf99edf56b8b25484e742522e9a6",
    spotify: "2bx5R936CdNRuZLmRiMAI2",
    genre: "industrial hardcore,speedcore",
    popularity: "17",
  },
  {
    name: "Henhouse Prowlers",
    image: "https://i.scdn.co/image/ab67616d0000b273510dff172d36f407df20b492",
    spotify: "5chLjAHz51WiBIKu9cU1LD",
    genre: "string band",
    popularity: "17",
  },
  {
    name: "Butane",
    image: "https://i.scdn.co/image/deffda191c373c2ed926870f81a8b8636e81da1a",
    spotify: "1xIDAQZRSEj6Eopz7zTDRx",
    genre: "minimal tech house",
    popularity: "17",
  },
  {
    name: "Aap uit de Mouw",
    image: "https://i.scdn.co/image/7a5a945a79129721beadf3bee77bc7a2e6048899",
    spotify: "4ORqCFGQfvrsQSwa9HVeu2",
    genre: "",
    popularity: "17",
  },
  {
    name: "Jo Goes Hunting",
    image: "https://i.scdn.co/image/9f130cece3159b5b32feec0db40402236b400489",
    spotify: "2x4XbUCAexNSNcotYSrf4K",
    genre: "",
    popularity: "17",
  },
  {
    name: "Housequake",
    image: "https://i.scdn.co/image/43ea9ae63428179592b7acf9bfb9132e260b01fb",
    spotify: "5WHgifU7J7TBlEygVmAOFi",
    genre: "",
    popularity: "17",
  },
  {
    name: "Daniel Sanchez",
    image: "https://i.scdn.co/image/0f8d19fc066db6fd773f5cb7b9796df20409e7de",
    spotify: "1z8SrJUugimpvBJLUuL9dE",
    genre: "",
    popularity: "17",
  },
  {
    name: "Drive Like Maria",
    image: "https://i.scdn.co/image/61fae7d8546557dd84b63bc682fdf94980dce45e",
    spotify: "1TclF9i1aF7WZuOt8tavqH",
    genre: "dutch indie,dutch rock",
    popularity: "17",
  },
  {
    name: "Peter Horrevorts",
    image: "https://i.scdn.co/image/b92a41011d0df66324084c1fca0cbe968fcc0abf",
    spotify: "5bqiKjcMygXSvBcJFhd8QG",
    genre: "",
    popularity: "17",
  },
  {
    name: "Wavolizer",
    image: "https://i.scdn.co/image/cee0b8217cf41af94f9ff9bd305833f473980d01",
    spotify: "3n8JNh6L06fF33IOT75Cmy",
    genre: "industrial hardcore",
    popularity: "17",
  },
  {
    name: "DJ Bone",
    image: "https://i.scdn.co/image/003c13cd168587593cbaa39de2a15d19f8035077",
    spotify: "5nAtXl2yhbQubn2gT9lhIg",
    genre: "techno",
    popularity: "17",
  },
  {
    name: "Marla Singer",
    image: "https://i.scdn.co/image/ab67616d0000b2731e08c539fd70c52f17496d51",
    spotify: "1fzKF1gRas1o1rIG4xl0iH",
    genre: "minimal dub,raw techno",
    popularity: "17",
  },
  {
    name: "Errorsmith",
    image: "https://i.scdn.co/image/8ba70453358e55d1f6e38ae603f585001661edd9",
    spotify: "0GBfmQlQSoO1OBxO8Y73vB",
    genre: "bleep techno,glitch",
    popularity: "17",
  },
  {
    name: "Bazzookas",
    image: "https://i.scdn.co/image/56ff65edf88f0ee5591d8acbc982795b410b0948",
    spotify: "2Uo9NBX0s6LhWDxa3LaXH9",
    genre: "",
    popularity: "17",
  },
  {
    name: "Wilko Terwijn",
    image: "https://i.scdn.co/image/ab67616d0000b2734af0f5687d9a5367c7e33b0f",
    spotify: "66hVHuG5S3thKqfRIfArBN",
    genre: "dutch cabaret",
    popularity: "17",
  },
  {
    name: "Zo Moeilijk",
    image: "https://i.scdn.co/image/da75485c7608e6325116c434c9da7b7ad7a8ac4a",
    spotify: "1m5UwtiH31Zjg17jP6ps88",
    genre: "dutch hip hop",
    popularity: "17",
  },
  {
    name: "M.E.S.H.",
    image: "https://i.scdn.co/image/19cdbcf763520bd12723f54834f742f20a9b122c",
    spotify: "2Xh0QLRL0qScgK7YKxCdYH",
    genre: "deconstructed club,mandible,new isolationism",
    popularity: "17",
  },
  {
    name: "Bony Macaroni",
    image: "https://i.scdn.co/image/71d6121445121ce2d7f35d799ba55b5c4c698ada",
    spotify: "5RsdlcuYtj4bWyGPVJCuet",
    genre: "dutch indie rock",
    popularity: "17",
  },
  {
    name: "Out of Cookies",
    image: "https://i.scdn.co/image/500a4a5535b74ab3e0ba548d099fef4c72bd1a33",
    spotify: "7k0mRul8b8WdEdWAx44pVr",
    genre: "sky room",
    popularity: "17",
  },
  {
    name: "Kassem Mosse",
    image: "https://i.scdn.co/image/97f1ca62a73a82387ca2b454fbdf8140388909f3",
    spotify: "3PHjnk1kF1jGGUzhubUfjx",
    genre: "leipzig electronic,outsider house",
    popularity: "17",
  },
  {
    name: "Mike Tohr",
    image: "https://i.scdn.co/image/ab67616d0000b2738d6d6ce8baae48635f94dc4e",
    spotify: "1CA9TqR5efbt6FOxakWJB7",
    genre: "",
    popularity: "17",
  },
  {
    name: "D-Passion",
    image: "https://i.scdn.co/image/ab67616d0000b273c94ee726117c2cff50b62ca0",
    spotify: "59zjYul7oWLHvFusYqu324",
    genre: "gabba,hardcore techno,industrial hardcore",
    popularity: "17",
  },
  {
    name: "4shobangers",
    image: "",
    spotify: "3HcSTFQCKrlPFBfaurV3l5",
    genre: "",
    popularity: "17",
  },
  {
    name: "Wallace Vanborn",
    image: "https://i.scdn.co/image/be7e8fa16871f7eb0ca001b92cc54e4b832698e1",
    spotify: "1iQMza4azUNGyqgQ8auRsp",
    genre: "belgian rock,belgian stoner rock",
    popularity: "17",
  },
  {
    name: "Gorgon Sound",
    image: "",
    spotify: "2R2znobqRpjBIFNCHp5mLB",
    genre: "",
    popularity: "17",
  },
  {
    name: "The Wishmaster",
    image: "https://i.scdn.co/image/ab67616d0000b273b96f2d26f12b4aab65a0e27e",
    spotify: "06F6RSEhZkDNezw1cB80cb",
    genre: "dark hardcore,gabba,hardcore techno",
    popularity: "17",
  },
  {
    name: "Slowbody",
    image: "https://i.scdn.co/image/37b6055412da96d4848833ef9402fae2f07f5a13",
    spotify: "7lOshPcj7D4FacV5mzD61a",
    genre: "",
    popularity: "17",
  },
  {
    name: "Caïro Liberation Front",
    image: "https://i.scdn.co/image/e59c4b947b8bd76bb65e841f079158d9b2a4f561",
    spotify: "4ekkoU6ZmScTU9kqw3C09r",
    genre: "dutch experimental electronic",
    popularity: "17",
  },
  {
    name: "Sky H1",
    image: "https://i.scdn.co/image/ab67616d0000b273296ce4f13c105cb26a904090",
    spotify: "4PWm0R7GT00XJa3TIFoUT4",
    genre: "deconstructed club,electra,new isolationism,weightless",
    popularity: "17",
  },
  {
    name: "Fraktus",
    image: "https://i.scdn.co/image/ab67616d0000b273e54e4e5d798c1d6a71ab1920",
    spotify: "01tTwgQnTm0xIgU4Dni3tr",
    genre: "",
    popularity: "17",
  },
  {
    name: "Jozif",
    image: "https://i.scdn.co/image/ab67616d0000b27365ae39483fa378406210df43",
    spotify: "4o5e4EQgqNVOUCbqVnZYXn",
    genre: "",
    popularity: "17",
  },
  {
    name: "Wonderface",
    image: "https://i.scdn.co/image/10941f2195eaec2dd41498fe8438c4a2defdd154",
    spotify: "53OcSRN7UgTxYsWEqvT5oX",
    genre: "",
    popularity: "17",
  },
  {
    name: "Folk Road Show",
    image: "https://i.scdn.co/image/05816790861cd727244fbb3fecde992aaf95d03d",
    spotify: "2ihZ65wn1wxfifD7blxMNH",
    genre: "dutch indie",
    popularity: "17",
  },
  {
    name: "Jan Versteegh",
    image: "https://i.scdn.co/image/ab67616d0000b2731913bd5ccf1f3411d9fde929",
    spotify: "1BkojE5Fnv921XMHkLXdPT",
    genre: "",
    popularity: "17",
  },
  {
    name: "Tom Schilling & The Jazz Kids",
    image: "https://i.scdn.co/image/ab67616d0000b2731fe6b942ff080425684c2581",
    spotify: "30hS8KGcAK62MMpoNWrw36",
    genre: "german indie rock",
    popularity: "17",
  },
  {
    name: "Onur Ozman",
    image: "https://i.scdn.co/image/9ffd84ed612c529cab349f1b4c5b49b123119ecf",
    spotify: "3ILz1VL32yEEaaeHY4mqcd",
    genre: "deep deep house,swiss house",
    popularity: "17",
  },
  {
    name: "Wata Igarashi",
    image: "https://i.scdn.co/image/ab67616d0000b27396acf4e52d73fabd7ac84be7",
    spotify: "7ug2B8FOnKHqwtVlD9vrQX",
    genre: "experimental techno,japanese electronic,japanese techno",
    popularity: "17",
  },
  {
    name: "Alpha Party",
    image: "https://i.scdn.co/image/6375407f4d319ce611b22974af1fa4d19cdc6232",
    spotify: "26QYIxCg5mczSb4syvHyJL",
    genre: "",
    popularity: "17",
  },
  {
    name: "Clayton Cash",
    image: "https://i.scdn.co/image/298c3184e71f24e4ebeedac5bd90c659936ec05e",
    spotify: "3WU8daHnpDsfkoRA1yN6aQ",
    genre: "",
    popularity: "17",
  },
  {
    name: "KRUELTY",
    image: "https://i.scdn.co/image/8e298b0c4b8f2b3d33f69183ec2f5e425105e505",
    spotify: "0R2MCc7Bg2RsZb7nOKpJdU",
    genre: "metallic hardcore",
    popularity: "17",
  },
  {
    name: "Implore",
    image: "https://i.scdn.co/image/c8e0d3c3556506c6bb216d4128427de6399f07be",
    spotify: "6VoXxJxGRpGyEEuUOeGNMG",
    genre: "deathgrind,german grindcore",
    popularity: "17",
  },
  {
    name: "Lee Mead",
    image: "https://i.scdn.co/image/762aeea9ee70ecebe45ba67a300c7e5828e52b3c",
    spotify: "158aRMRtiOmYXfizzGsdGi",
    genre: "west end",
    popularity: "17",
  },
  {
    name: "Notorious Two",
    image: "https://i.scdn.co/image/39fcc512f62a7351602b99a48138616deafe9657",
    spotify: "22mriI4bXFYstGXv7qlq2K",
    genre: "",
    popularity: "17",
  },
  {
    name: "13 Crowes",
    image: "https://i.scdn.co/image/1487e220a9f81970b9b24156bb751c809b22aca5",
    spotify: "7d1O1AxAp2Opr5LdB35aGW",
    genre: "",
    popularity: "17",
  },
  {
    name: "Stermann & Grissemann",
    image: "https://i.scdn.co/image/ab67616d0000b273047fb44fa5b821acfac40921",
    spotify: "2j3UQlAIcPnhZOgsDNApnr",
    genre: "kabarett",
    popularity: "17",
  },
  {
    name: "Human Element",
    image: "https://i.scdn.co/image/6195f6ead09b7e72db8d76a5fea8b317dc794647",
    spotify: "6NFXj0dTYCLcWovn8ySfs3",
    genre: "progressive psytrance",
    popularity: "17",
  },
  {
    name: "Rrrags",
    image: "https://i.scdn.co/image/ab67616d0000b27362654620a9eecde5dbf903b1",
    spotify: "6FU7fXNMEcMh8RuW4IbPSM",
    genre: "nwocr",
    popularity: "17",
  },
  {
    name: "Ridwello",
    image: "https://i.scdn.co/image/e08f8a072d959bf3f981f730fcdb3dba58e3aba7",
    spotify: "2mt91p5SFkDzaJ3IOTXGmz",
    genre: "",
    popularity: "17",
  },
  {
    name: "Ryan Collins",
    image: "https://i.scdn.co/image/fcb138378dd1025ae57d238130bb734e80069f2c",
    spotify: "5JXAq3ukljxYRWkRPXLcjL",
    genre: "",
    popularity: "17",
  },
  {
    name: "DEBBY FRIDAY",
    image: "https://i.scdn.co/image/a7db3638af40aa25792318194c640a5e04f9649f",
    spotify: "5lofelrRCFBwzTF616hSx4",
    genre: "canadian experimental",
    popularity: "17",
  },
  {
    name: "Russ Yallop",
    image: "https://i.scdn.co/image/b600c3a79ce6b11ae935d959da24a7348cb4110d",
    spotify: "23soWSxxN1Sf800L55g7Sw",
    genre: "deep disco house",
    popularity: "17",
  },
  {
    name: "Substance One",
    image: "https://i.scdn.co/image/ab67616d0000b273ecc52f3b7abd66327dc861be",
    spotify: "5VJKYKgArpUDIeyxbwqaVL",
    genre: "",
    popularity: "17",
  },
  {
    name: "Dead Swans",
    image: "https://i.scdn.co/image/ab67616d0000b2733ae6d52e98617f1ee1c910b5",
    spotify: "5Molbqetc1WsKY3oPKTj88",
    genre: "chaotic hardcore,melodic hardcore,ukhc",
    popularity: "17",
  },
  {
    name: "Nomfusi",
    image: "https://i.scdn.co/image/880c3c73a70c98dafb01499547f4f2f0d4126e6b",
    spotify: "2pgwAcEZP1XSHx80lDYipV",
    genre: "",
    popularity: "17",
  },
  {
    name: "Miss Bunty",
    image: "https://i.scdn.co/image/ab67616d0000b273236e16a94e28a4aba756b0ce",
    spotify: "2wrZmXuhj94dOG75OUcP7l",
    genre: "",
    popularity: "16",
  },
  {
    name: "De Vliegende Panters",
    image: "https://i.scdn.co/image/ab67616d0000b2734c62395b1d17ac02ec861786",
    spotify: "4jmwDHMdwFiYkFIiOmBbrG",
    genre: "dutch cabaret",
    popularity: "16",
  },
  {
    name: "Anastasia Kristensen",
    image: "https://i.scdn.co/image/baf77b50b8ecec44eb9b2ba1a78b8775c7e5e4a2",
    spotify: "3cK7x3KOVZFqHKRTZOtwgd",
    genre: "ambient techno,bleep techno,danish electronic,danish techno",
    popularity: "16",
  },
  {
    name: "Sven Ratzke",
    image: "https://i.scdn.co/image/2db7faa5c001a3478560e22d1a5e42f844b00218",
    spotify: "6QMm1cvaThqtUoikVx4Zii",
    genre: "",
    popularity: "16",
  },
  {
    name: "DJ Normal 4",
    image: "https://i.scdn.co/image/ab67616d0000b2732faec6cb43e7f21e233f1019",
    spotify: "51OqqZ5saXIOyjY4Ue0BKR",
    genre: "dusseldorf electronic",
    popularity: "16",
  },
  {
    name: "April Grey",
    image: "https://i.scdn.co/image/1c92380ef8ed1a6158f441dbc55c5d3fc5862350",
    spotify: "1FChgxbpvRx8HCXQlWIZcD",
    genre: "dutch moombahton,dutch trap pop",
    popularity: "16",
  },
  {
    name: "Eva van Manen",
    image: "https://i.scdn.co/image/92d74dff3ce87893b4b668f944fdd1c4038090e3",
    spotify: "39fsjaOkLW4Gq6X6URiWRj",
    genre: "dutch singer-songwriter",
    popularity: "16",
  },
  {
    name: "Anil Aras",
    image: "https://i.scdn.co/image/1e45eb59ebaa0cb5dfb628d452de5086e979a416",
    spotify: "6Ja4lS5NicOn4D0cUFwdbl",
    genre: "dutch tech house",
    popularity: "16",
  },
  {
    name: "Nynke Laverman",
    image: "https://i.scdn.co/image/197a8ba6d957fc7f54029b2d2dd00235f418e5fe",
    spotify: "1mu6MZMiTKM5Lvf00hLttX",
    genre: "",
    popularity: "16",
  },
  {
    name: "Thom Craane",
    image: "https://i.scdn.co/image/ebd5cfe1a560b46c5a44bfcfa470e52bf5f94c13",
    spotify: "32lkvVEPSLXzrfpPKxfZXB",
    genre: "carnaval",
    popularity: "16",
  },
  {
    name: "Rockabilly Fabulous",
    image: "https://i.scdn.co/image/ab67616d0000b27301cd757c0e9d7b2de64bcb0f",
    spotify: "6st3DvkCm9hf1M8F0jxAYU",
    genre: "",
    popularity: "16",
  },
  {
    name: "Amber Broos",
    image: "https://i.scdn.co/image/09aee2320b7132d3ead66c9a4d5b5292b2c4f002",
    spotify: "6WYC0ES42uaiJPtdBKDkIz",
    genre: "",
    popularity: "16",
  },
  {
    name: "Ludwig A.F.",
    image: "https://i.scdn.co/image/c43f94faa2d2ebac456e2129c6a3f1eab0cd53f4",
    spotify: "3Pxzo6Fhgswi6238OggzO5",
    genre: "",
    popularity: "16",
  },
  {
    name: "Superlounge",
    image: "https://i.scdn.co/image/64051d2903418c983378e76b5abff92fe155475d",
    spotify: "5NWToV1LyfU2S7OEQNVVWQ",
    genre: "",
    popularity: "16",
  },
  {
    name: "Ancient Shapes",
    image: "https://i.scdn.co/image/ab67616d0000b273b85af6339e58b13626cb32cf",
    spotify: "3Heoc2fnXqDWMr9E5bt7bs",
    genre: "ontario indie",
    popularity: "16",
  },
  {
    name: "Mella MM",
    image: "",
    spotify: "2ZbKi6TDU4MiFh7J1wReC8",
    genre: "",
    popularity: "16",
  },
  {
    name: "Marien Baker",
    image: "https://i.scdn.co/image/e7e7b3206ea61de0811c4cbc9eac5b0471d338a1",
    spotify: "3Fle4sGQXQGCSHP7RGImWy",
    genre: "",
    popularity: "16",
  },
  {
    name: "Nexuz",
    image: "https://i.scdn.co/image/94af4184df7a5f40b6978e0489f3aa820b9b850f",
    spotify: "3i2LdhBw9kLKmlz2o9QLOP",
    genre: "",
    popularity: "16",
  },
  {
    name: "Qrank",
    image: "https://i.scdn.co/image/ab67616d0000b2739ef5c7d8bdeaf02dc194e902",
    spotify: "4suKJt1ZtEB3XcdsmoV5F8",
    genre: "jumpstyle",
    popularity: "16",
  },
  {
    name: "Bendik Giske",
    image: "https://i.scdn.co/image/714b641cf15e51cc8ed81f360b374af242106ec2",
    spotify: "0IbWsSdsJyNM0I2cVMsl0K",
    genre: "experimental electronic,post-minimalism",
    popularity: "16",
  },
  {
    name: "FREESTYLE MANIACS",
    image: "https://i.scdn.co/image/e88ae6c52e87ec7929397d0c8a694a8cce2d3123",
    spotify: "1NOL0uMJMkgzPLIq3LcLml",
    genre: "",
    popularity: "16",
  },
  {
    name: "Buddy Vedder",
    image: "https://i.scdn.co/image/bd9dd303281d18d296969f50a71818b668e307bd",
    spotify: "4auv1x08hKjgUdpuG3ZM2J",
    genre: "",
    popularity: "16",
  },
  {
    name: "Franz Alice Stern",
    image: "https://i.scdn.co/image/ab67616d0000b273d3361707a31ed2e68f17db4a",
    spotify: "36HOlQ93VrxTjefWBuTg8m",
    genre: "",
    popularity: "16",
  },
  {
    name: "John James",
    image: "https://i.scdn.co/image/2a57a5e999cba22d0fa0d83efd3d7c6a9277940a",
    spotify: "1qRKXSYyUw4PvijxJ3epho",
    genre: "",
    popularity: "16",
  },
  {
    name: "Nuno Dos Santos",
    image: "https://i.scdn.co/image/5bccdf700a850cb95d397df311dc581c35c7b1bf",
    spotify: "6pbyRsrSdph5CB46Z4cTZw",
    genre: "",
    popularity: "16",
  },
  {
    name: "Jeroen Search",
    image: "https://i.scdn.co/image/71def02dc333bbb545664627290727ad8fa8e668",
    spotify: "2t9nXmwTyxsqEEpIdduEfj",
    genre: "minimal dub",
    popularity: "16",
  },
  {
    name: "Lee Reynolds",
    image: "https://i.scdn.co/image/5d3e8bf6996d719ec9770563251c68b4155216d3",
    spotify: "02aQbgZ4VnG6raQsqNgd4p",
    genre: "",
    popularity: "16",
  },
  {
    name: "Kypski",
    image: "https://i.scdn.co/image/e1ada5cfbf858f4822e0199845faebed7da77cfe",
    spotify: "7cQlIEll24mEd0eVdlIODL",
    genre: "dutch experimental electronic",
    popularity: "16",
  },
  {
    name: "Cocodrills",
    image: "https://i.scdn.co/image/9679a65b5564326c639d5eae7a4f7b182f175724",
    spotify: "5CkZdJ21uRyz9wG9KSDJEN",
    genre: "",
    popularity: "16",
  },
  {
    name: "Maher Daniel",
    image: "https://i.scdn.co/image/ab67616d0000b273dbf71a190e6a0527ee31bafe",
    spotify: "7pVmwDOzF9xvr24u9q9BqQ",
    genre: "arab electronic,canadian electronic",
    popularity: "16",
  },
  {
    name: "Dave Lambert",
    image: "https://i.scdn.co/image/ab67616d0000b2735c4334ed130eedbbc0ec7974",
    spotify: "3jwMYm4mXvdubd2FVAHj5n",
    genre: "",
    popularity: "16",
  },
  {
    name: "Eva Maria",
    image: "https://i.scdn.co/image/90e9d379d7a7be655bb3a3ad26fe961826d5649a",
    spotify: "5XBKzJuWynW9omD52rDohy",
    genre: "",
    popularity: "16",
  },
  {
    name: "Iona Fortune",
    image: "https://i.scdn.co/image/c8b3e501d9b51e35f98d850699421646308489d8",
    spotify: "3ufb3ISUA0BvQbwb68lzgH",
    genre:
      "experimental synth,fourth world,mandible,uk experimental electronic",
    popularity: "16",
  },
  {
    name: "Acid Baby Jesus",
    image: "https://i.scdn.co/image/d93dc6af9ed4c00052c1e93948e8326fda4132f2",
    spotify: "7JeNj03cuBwvZOb4sNKNcO",
    genre: "garage pop,greek indie,greek indie rock,greek psychedelic rock",
    popularity: "16",
  },
  {
    name: "Ribongia",
    image: "https://i.scdn.co/image/94bd5688baab3d19b3126343c6c490de0e60bdda",
    spotify: "57B9WzJrtc9gSW3i2ez5vq",
    genre: "",
    popularity: "16",
  },
  {
    name: "África Negra",
    image: "https://i.scdn.co/image/ab67616d0000b27313320829fb639987488edd4a",
    spotify: "1pEC7prcIelHH0enQml4eC",
    genre: "",
    popularity: "16",
  },
  {
    name: "Alex.Do",
    image: "https://i.scdn.co/image/f033bf84deb783a5b41f8a417589f94d4cae0587",
    spotify: "3FCI4uOp833ACQKx4hAQEb",
    genre: "modular techno",
    popularity: "16",
  },
  {
    name: "London Modular Alliance",
    image: "https://i.scdn.co/image/91d10fa0a0a0769d4a45d8ad2c582e6f1c65cf90",
    spotify: "6pK7cjk3pKTznca30ofwjJ",
    genre: "experimental techno,modular synth",
    popularity: "16",
  },
  {
    name: "Ryan Elliott",
    image: "https://i.scdn.co/image/cce99b8ad8fa860dc7673a4132d12a3a4ee7e664",
    spotify: "3SZBUeVJfGLUpAPNEQbBKk",
    genre: "detroit techno",
    popularity: "16",
  },
  {
    name: "Electric Guitars",
    image: "https://i.scdn.co/image/300f9e989e6cd664df335d4fc49f4084c42c4406",
    spotify: "651TiiKlmJjcOE4teleqGf",
    genre: "danish metal",
    popularity: "16",
  },
  {
    name: "Julian Cross",
    image: "https://i.scdn.co/image/2d684aebe495f46ae7337663e41dc544660c54a9",
    spotify: "1TRFjpBEneFJJloCqSC4sG",
    genre: "",
    popularity: "16",
  },
  {
    name: "Frank Fairfield",
    image: "https://i.scdn.co/image/5de719fbd4d2c8e2bd999d4819101878c8884cab",
    spotify: "1r5CdDynBMRzRz29rPZkGz",
    genre: "appalachian folk,modern old-time,old-time",
    popularity: "16",
  },
  {
    name: "Anna Rune",
    image: "https://i.scdn.co/image/94e1714ea9cb0ff5ed95bde76aa8feedbd7b7e78",
    spotify: "2iUxXn7rvltFXTaXcXh1tr",
    genre: "",
    popularity: "16",
  },
  {
    name: "Roos Rebergen",
    image: "https://i.scdn.co/image/ab67616d0000b273135419f9f7f89e75c86ecdf7",
    spotify: "3IUUGmmR8STIAtcg7qfDkZ",
    genre: "dutch indie",
    popularity: "16",
  },
  {
    name: "Suzy V",
    image: "https://i.scdn.co/image/a2e52761e73d33dc47a49cc6a3bf232b9d43b3f4",
    spotify: "7vgvkOOXTiKmmHc2Yw3zM8",
    genre: "",
    popularity: "16",
  },
  {
    name: "Next Of Kin",
    image: "https://i.scdn.co/image/fef377951dd950ea8ef92f503e93b3daa4fe1775",
    spotify: "1zk68XuQOghds4thqgGL8Q",
    genre: "",
    popularity: "16",
  },
  {
    name: "Arp Frique",
    image: "https://i.scdn.co/image/de6eded0530a677ca9c0573bcd1dbece0bcbf844",
    spotify: "2Rm5Fw56mWmB0Pz0JPcOyb",
    genre: "afro-funk",
    popularity: "16",
  },
  {
    name: "Porter Ricks",
    image: "https://i.scdn.co/image/08822a189c11cd2543142c2839d5351b0c301acc",
    spotify: "47yoe54A38qmHti0GlTPXR",
    genre: "dub techno,minimal techno",
    popularity: "16",
  },
  {
    name: "Dream 2 Science",
    image: "https://i.scdn.co/image/ab67616d0000b27307aa86eb812630793f98d390",
    spotify: "3Vm0BsJPeOfMq4KG9jOfVN",
    genre: "",
    popularity: "16",
  },
  {
    name: "Nicholas Müller",
    image: "https://i.scdn.co/image/ab67616d0000b2733653f65ef7456273265c2e02",
    spotify: "5LA6ZZNvQWPFu2hkeGK4Zc",
    genre: "",
    popularity: "16",
  },
  {
    name: "Gérald Genty",
    image: "https://i.scdn.co/image/58b4946d37bf9b5e2062a2deca8afd669192197f",
    spotify: "0WRcJNpzcOgKYwykZo0vWu",
    genre: "french folk pop,nouvelle chanson francaise",
    popularity: "16",
  },
  {
    name: "Winterdagen",
    image: "https://i.scdn.co/image/8a9f9d2f9f351bf40142a83a3ece3e536a18fdf1",
    spotify: "7a7gDKeePieVVQd7P7WBPR",
    genre: "",
    popularity: "16",
  },
  {
    name: "Fanfara Tirana",
    image: "https://i.scdn.co/image/ab67616d0000b2739112ec6ff16a0228c9cb77c7",
    spotify: "78wZBDx4PJcEvuS1T7Vdaf",
    genre: "albanian folk,balkan brass",
    popularity: "16",
  },
  {
    name: "Cobra Effect",
    image: "https://i.scdn.co/image/01af67aaa830ea882d9fbb2feb537bc74c143643",
    spotify: "1OQqnxsfFoETMEByBIQvHK",
    genre: "",
    popularity: "16",
  },
  {
    name: "Lars and the Magic Mountain",
    image: "https://i.scdn.co/image/0a1d1e5cb04f40e789ebce35b7a9ad915ce03ad9",
    spotify: "1Vem7FbnzmwH36evasOuZx",
    genre: "",
    popularity: "16",
  },
  {
    name: "Klaas van der Eerden",
    image: "https://i.scdn.co/image/ab67616d0000b2738c8655730fb794c50cd6be45",
    spotify: "0x7DUsnwtWW5tSNSut1OCf",
    genre: "dutch cabaret",
    popularity: "15",
  },
  {
    name: "Puinhoop Kollektiv",
    image: "https://i.scdn.co/image/bbb134376b3a44bfceb4aac66b97c96cd1bcb4f2",
    spotify: "2YwZY07DCQfzuFiVqy0zhp",
    genre: "",
    popularity: "15",
  },
  {
    name: "Dana Ruh",
    image: "https://i.scdn.co/image/ab67616d0000b273422ff93d64146923cbd48d0b",
    spotify: "0MNEcUdSdPy3a15bQJHJDT",
    genre: "",
    popularity: "15",
  },
  {
    name: "Simo Cell",
    image: "https://i.scdn.co/image/dee6bcaf7043871e07cbba509f794ab639668bc6",
    spotify: "4KxpqghQTX2FlkzsbG3ENk",
    genre: "experimental techno",
    popularity: "15",
  },
  {
    name: "FIT Siegel",
    image: "https://i.scdn.co/image/487757982e5376612c807f20b8dda3d1b659f05e",
    spotify: "7y1rjd6v5ixSJoOKNcRUYg",
    genre: "detroit techno",
    popularity: "15",
  },
  {
    name: "Einzelkind",
    image: "https://i.scdn.co/image/3278564bf4c3f46f1302b06fc61e466438acf9a2",
    spotify: "5yyfjDkPXBeICgtliCpbiy",
    genre: "minimal tech house",
    popularity: "15",
  },
  {
    name: "Tommy Green",
    image: "https://i.scdn.co/image/ab67616d0000b2732a608b9a3c3ffa7f695e31ce",
    spotify: "5FM9tem9D3G9Xx364JKqdu",
    genre: "",
    popularity: "15",
  },
  {
    name: "Beta Librae",
    image: "https://i.scdn.co/image/ab67616d0000b273f18b698ddf687a7202ff4e6d",
    spotify: "5aOx0DSs7guwHbcE4R4FIx",
    genre: "experimental techno",
    popularity: "15",
  },
  {
    name: "Credit 00",
    image: "https://i.scdn.co/image/d09f66e22e0939af9fa0c0b996a8b10d7e00df94",
    spotify: "2F93AqXTcdnHrfvdaceAEj",
    genre: "deep soul house,leipzig electronic",
    popularity: "15",
  },
  {
    name: "Rojdar",
    image: "https://i.scdn.co/image/c63debd9bc3ff5d0414da2e8fb35c983fcda46f4",
    spotify: "2JmtD7WjLBb2Ev8OcOvC6d",
    genre: "",
    popularity: "15",
  },
  {
    name: "Samo DJ",
    image: "https://i.scdn.co/image/ab67616d0000b2736ca563aea6f7fe793b552801",
    spotify: "05442HVVO9EfYoNa8F835e",
    genre: "swedish house",
    popularity: "15",
  },
  {
    name: "Lauren Flax",
    image: "https://i.scdn.co/image/b34fedef3e0137f1387df0df88f45395dcbe414a",
    spotify: "1LUYSrytHIC78JbMgFBIG7",
    genre: "experimental techno",
    popularity: "15",
  },
  {
    name: "The Dubbeez",
    image: "https://i.scdn.co/image/748e8bca50af294fcf2baa63f3d3a1a219379ac6",
    spotify: "5hmzerxoz39BZjmfNe9Cel",
    genre: "",
    popularity: "15",
  },
  {
    name: "Vinylgroover",
    image: "https://i.scdn.co/image/ab67616d0000b2736b3ff72a63c2709b2a7ed29b",
    spotify: "73tpnr17htHxmmACNtwkHs",
    genre: "bouncy house,hard house",
    popularity: "15",
  },
  {
    name: "Smash TV",
    image: "https://i.scdn.co/image/ab67616d0000b2732479dcc6cd0005b9f5db7282",
    spotify: "1VUgV5TXOldN4yUTiIjJbP",
    genre: "",
    popularity: "15",
  },
  {
    name: "Captain Accident",
    image: "https://i.scdn.co/image/ab67616d0000b273887b84578e92bafb331ebd3c",
    spotify: "74mEfXkVf2UJJyrf0YV0TC",
    genre: "uk reggae",
    popularity: "15",
  },
  {
    name: "Sapphire Slows",
    image: "https://i.scdn.co/image/ab67616d0000b2737b8f3be543e3275b3c936653",
    spotify: "74CcyBgc8F82TGCYIhMcao",
    genre: "gauze pop,japanese electronic",
    popularity: "15",
  },
  {
    name: "Luie Hond",
    image: "https://i.scdn.co/image/ab67616d0000b273abfcf0e0caf1141349414243",
    spotify: "2qaNHel738hAqwpBldaFjF",
    genre: "",
    popularity: "15",
  },
  {
    name: "Luminize",
    image: "https://i.scdn.co/image/cc5596b4482b126be852004fe6277a92e15ea00d",
    spotify: "41yDar5IZ2mu0crYz9SEtF",
    genre: "",
    popularity: "15",
  },
  {
    name: "Boef en de Gelogeerde Aap",
    image: "https://i.scdn.co/image/be492cad36fdc5a4f8374edf46fe0e5ec458e95c",
    spotify: "3evPnx06muDkZD3j1m1QZp",
    genre: "dutch hip hop",
    popularity: "15",
  },
  {
    name: "Micheline Van Hautem",
    image: "https://i.scdn.co/image/ab67616d0000b27300f9a008eaa56541ec183eb0",
    spotify: "2IFYuzGswoCAkwrxDGUh5i",
    genre: "",
    popularity: "15",
  },
  {
    name: "Muffin Man",
    image: "https://i.scdn.co/image/ab67616d0000b273110b6044031f82140ae38ec0",
    spotify: "0UQcuwVHsRS6F4hBsz3ltJ",
    genre: "",
    popularity: "15",
  },
  {
    name: "Felbm",
    image: "https://i.scdn.co/image/9539c0981c634dc31cb691186420b3be38f0efc9",
    spotify: "2kjrM4RpZVRBHy3hjgJCr7",
    genre: "",
    popularity: "15",
  },
  {
    name: "Mindustries",
    image: "https://i.scdn.co/image/ab67616d0000b2738994a84a2eddfc0b129f1773",
    spotify: "2jn2poSb6Rz87CA1fXSWtb",
    genre: "doomcore,gabba,hardcore techno,industrial hardcore,speedcore",
    popularity: "15",
  },
  {
    name: "Nadastrom",
    image: "https://i.scdn.co/image/1efa7ef67051fc12ae75be9ac88136bc3e671ca6",
    spotify: "7K24SZIaVAEAuB8UamlagK",
    genre: "bmore,fidget house,moombahton",
    popularity: "15",
  },
  {
    name: "Der Täubling",
    image: "https://i.scdn.co/image/ab67616d0000b273f2489acfd0fa43c6918a131b",
    spotify: "3PlHgRWhyKp9OQv4sAfRyo",
    genre: "",
    popularity: "15",
  },
  {
    name: "Szun Waves",
    image: "https://i.scdn.co/image/01995c587a72247274e0a9e34653c6292cc3dcd0",
    spotify: "0UovNspE5r3Cxdsok7ZUp1",
    genre: "progressive jazz fusion",
    popularity: "15",
  },
  {
    name: "Kodex",
    image: "https://i.scdn.co/image/7d6805ed96c73c9b5ac0b5e0b6eddff8ec508dda",
    spotify: "2C4sIaunCtI1yfnMK8pziM",
    genre: "",
    popularity: "15",
  },
  {
    name: "Maximiljan",
    image: "https://i.scdn.co/image/ab67616d0000b273f534f02513a72f5aa5275c8f",
    spotify: "4fFHMLX80InUpHFW3gDhSm",
    genre: "deep tech house",
    popularity: "15",
  },
  {
    name: "Dan Ghenacia",
    image: "https://i.scdn.co/image/ab67616d0000b273df68cdc80c5434abdae3ea2b",
    spotify: "2ubDepMbxi66BbUBfADkq5",
    genre: "",
    popularity: "15",
  },
  {
    name: "Zanillya",
    image: "https://i.scdn.co/image/0308ca4b50718c2eb7e2b61f000bb2d563094740",
    spotify: "525tLjcAVmE8JpqncIAD7p",
    genre: "",
    popularity: "15",
  },
  {
    name: "Christian Haase",
    image: "https://i.scdn.co/image/238787f7c5c84f4866ab1b0e705479e2369c8552",
    spotify: "0fWw6y9cZnMJXIDoAoXd8Y",
    genre: "",
    popularity: "15",
  },
  {
    name: "Die Türen",
    image: "https://i.scdn.co/image/3c1c2d6c9beb441fb924fdb9abaf0075372cbdd6",
    spotify: "5Q2DijkguiiBhezl9vqzmm",
    genre: "german indie",
    popularity: "15",
  },
  {
    name: "Subp Yao",
    image: "https://i.scdn.co/image/1e8a4ec553be32b54fd8398caae92dc1eba78ac6",
    spotify: "40SkpetJzH3xD9tzWYZYEE",
    genre: "dutch dnb,halftime dnb",
    popularity: "15",
  },
  {
    name: "Gwen Dickey",
    image: "",
    spotify: "6HGXLgm63lfjeZcAGEp9eX",
    genre: "",
    popularity: "15",
  },
  {
    name: "Psycho 44",
    image: "https://i.scdn.co/image/219f5ea67d2d0832be3b70b322827a10728ec137",
    spotify: "3AZ8x7ZjZhdlklySLuROOt",
    genre: "belgian indie,belgian rock",
    popularity: "15",
  },
  {
    name: "Park Jiha",
    image: "https://i.scdn.co/image/ab67616d0000b2731a43d6b535562b39777a0b66",
    spotify: "7aWBbWXYNdvU0319rLIToK",
    genre: "korean experimental,post-minimalism",
    popularity: "15",
  },
  {
    name: "The Demon Dwarf",
    image: "https://i.scdn.co/image/ab67616d0000b27314bce92eecdd112af9b02257",
    spotify: "1v62kzBuOwJMk6WKxGzJLY",
    genre: "uptempo hardcore",
    popularity: "15",
  },
  {
    name: "Aka The Junkies",
    image: "https://i.scdn.co/image/ab67616d0000b273bfde5f0725416e8ce2f75c8f",
    spotify: "6LUyeqtwahwAR7SVigcCPi",
    genre: "",
    popularity: "15",
  },
  {
    name: "Chantal Acda",
    image: "https://i.scdn.co/image/e04de5b5dbed320e513986310709e92e3aabec76",
    spotify: "1QfxBwzzbyqOBWnFWkJ4ps",
    genre: "belgian indie",
    popularity: "15",
  },
  {
    name: "Trupa Trupa",
    image: "https://i.scdn.co/image/19b2cfc0aa258772ba04ab1ea0bf70b3b6d878b3",
    spotify: "3o1PTWLo0K6dO5askAsIhN",
    genre: "polish indie rock,polish noise rock,polish post-punk",
    popularity: "15",
  },
  {
    name: "Moonlight Benjamin",
    image: "https://i.scdn.co/image/02714ab4cfb7e1d3107904ca3c74d70f9e60b645",
    spotify: "6LxshZzgK5fMF4K4yj7FPW",
    genre: "",
    popularity: "15",
  },
  {
    name: "Riley Ella",
    image: "https://i.scdn.co/image/25f28b3deded894650893488d98a57f500459e9c",
    spotify: "7lds2A7vgyyQOfFxT1VzVx",
    genre: "",
    popularity: "15",
  },
  {
    name: "Andreas Vey",
    image: "https://i.scdn.co/image/6f69b4c5b99ab1ad52392cd4ec21b3717b1f3896",
    spotify: "2JtnUZejA6jFRZZuqmlJzs",
    genre: "",
    popularity: "15",
  },
  {
    name: "Track Dogs",
    image: "https://i.scdn.co/image/8f83332525c4fcdeb54ebaeff3b9cf3cab858a32",
    spotify: "5mEAkhc0sVGvWBXhzIJTDB",
    genre: "spanish folk rock",
    popularity: "15",
  },
  {
    name: "Chouk Bwa",
    image: "https://i.scdn.co/image/943260db11ca0672459584787bd156c18c8c95a3",
    spotify: "4ZgPymorgJ2hba9GTtwPHB",
    genre: "",
    popularity: "15",
  },
  {
    name: "Dark Pact",
    image: "https://i.scdn.co/image/7e2b9b53960c5612d8a7ee00caf734d0fc44c456",
    spotify: "2YjrANDR9gCMbNjwI5OWsG",
    genre: "rawstyle",
    popularity: "15",
  },
  {
    name: "Kepi Ghoulie",
    image: "https://i.scdn.co/image/97d1d0b837df4f5a7b37f126120c6f2ba699cb9c",
    spotify: "658GkrDJtppifckfBbynzB",
    genre: "",
    popularity: "15",
  },
  {
    name: "Karl Friedrich",
    image: "",
    spotify: "6GNN9PhhGVpGYIo78L3ryt",
    genre: "",
    popularity: "15",
  },
  {
    name: "Kim Lee",
    image: "https://i.scdn.co/image/cf29a74c5b4a115f4ca48e6f6bff2c2070caccd2",
    spotify: "7oEYjnFApJ4MoaF2GoG3u6",
    genre: "",
    popularity: "15",
  },
  {
    name: "Bloem",
    image: "https://i.scdn.co/image/4a5c954c99cdacf9edab8165d29a1d51f2730eb6",
    spotify: "2QxBVnoL3FUDddzVL3iRez",
    genre: "ethnotronica",
    popularity: "15",
  },
  {
    name: "BRETT NEWSKI",
    image: "https://i.scdn.co/image/54be321ec29a7960b4e9a882595a33e26c870814",
    spotify: "7jukMDCSMJSIcdlsKJ44IW",
    genre: "milwaukee indie",
    popularity: "15",
  },
  {
    name: "Laura Jones",
    image: "https://i.scdn.co/image/ab67616d0000b273d1dc3ef20c7eb20177b260a5",
    spotify: "0EpiUsw9qhnjn8kRDWOzih",
    genre: "deep disco house",
    popularity: "15",
  },
  {
    name: "Jason Little",
    image: "",
    spotify: "6IL0UmNSVKg9p2uA1Tl5zQ",
    genre: "",
    popularity: "15",
  },
  {
    name: "Almighty Mighty",
    image: "https://i.scdn.co/image/804d275441ff0cd7c2b540cc87a4ee6ab6b08168",
    spotify: "5YxvZqiTuoUgqEuXTDhM0e",
    genre: "",
    popularity: "15",
  },
  {
    name: "Jamie Anderson",
    image: "https://i.scdn.co/image/ab67616d0000b273c43a16775b01b1a3350d4894",
    spotify: "3QeUcfxQWae16K2zOaagyG",
    genre: "",
    popularity: "15",
  },
  {
    name: "Database",
    image: "https://i.scdn.co/image/a1acc3f3d6abc49c9712ba7369b98ae47ec88a77",
    spotify: "0WC3MGsrMnUl9kZgk1YM5W",
    genre: "electrofox",
    popularity: "14",
  },
  {
    name: "Violinvasion",
    image: "",
    spotify: "7qzKbJ9PNDRtqQxZeNfecn",
    genre: "",
    popularity: "14",
  },
  {
    name: "Ivan Smagghe",
    image: "https://i.scdn.co/image/cd992c0a8348d37206d34fcaa7c57c54e937ad02",
    spotify: "71bpajvR3380e3XggHAjuY",
    genre: "french techno",
    popularity: "14",
  },
  {
    name: "Stefan Vilijn",
    image: "https://i.scdn.co/image/5cf766a8f7b0ca12239f0940c88daf6e89590f43",
    spotify: "1CnMMEQM2xpwjdtWOQK4zM",
    genre: "dutch house",
    popularity: "14",
  },
  {
    name: "Jasper van Kuijk",
    image: "https://i.scdn.co/image/ab67616d0000b2739c630e1a3ca311d891ba75b7",
    spotify: "1Tml23DPhgnqQG8xbiISZu",
    genre: "dutch cabaret",
    popularity: "14",
  },
  {
    name: "Borusiade",
    image: "https://i.scdn.co/image/ab67616d0000b2733e38dfeaba22ef8336241a60",
    spotify: "0Q7PRNuZqRHUJIL178ihJ8",
    genre: "romanian electronic",
    popularity: "14",
  },
  {
    name: "Joey Daniel",
    image: "https://i.scdn.co/image/d67eee2e51ea15eb16705fa91d88021e12e06f95",
    spotify: "5X3u1LutYUOLTFDpAun1px",
    genre: "dutch tech house",
    popularity: "14",
  },
  {
    name: "Praia Del Sol",
    image: "https://i.scdn.co/image/1a6641949062bab02455f23a36e1d8ba1accb4c4",
    spotify: "4uo6A1n1cfOuvvFqrgH80T",
    genre: "",
    popularity: "14",
  },
  {
    name: "DJ W!LD",
    image: "https://i.scdn.co/image/ab67616d0000b273adfd32beb4c97e826d206103",
    spotify: "2cc1Phkb1W5AvZvteumF6P",
    genre: "deep disco house,minimal tech house",
    popularity: "14",
  },
  {
    name: "F.Noize",
    image: "",
    spotify: "2YrhWtF2cXnEFSNxg8h0cy",
    genre: "",
    popularity: "14",
  },
  {
    name: "John Coffey",
    image: "",
    spotify: "3OlHF5VX9kJd9GgdFhfTN5",
    genre: "",
    popularity: "14",
  },
  {
    name: "Bas Amro",
    image: "https://i.scdn.co/image/ab67616d0000b273b4a5524532b5322f23996ba7",
    spotify: "3C803m3Fw5q2lnNySnWjqM",
    genre: "",
    popularity: "14",
  },
  {
    name: "Rian Treanor",
    image: "https://i.scdn.co/image/d930424be4eaa2c8c284f8c50aee20e61c7ef917",
    spotify: "6un6trkuuP46AZM0kkY8Yx",
    genre: "deconstructed club,uk experimental electronic",
    popularity: "14",
  },
  {
    name: "Stefanie Sargnagel",
    image: "https://i.scdn.co/image/ab67616d0000b27397edc40a5afbc795f9e9677d",
    spotify: "5V9Yobv8e1wy5l7tvxeNrV",
    genre: "",
    popularity: "14",
  },
  {
    name: "Mark Fell",
    image: "https://i.scdn.co/image/b1c273eb24cd3d61df272f977c0309d78ea23ce2",
    spotify: "3IUSkU24GuugkT7GDUlP9b",
    genre:
      "british experimental,glitch,lowercase,mandible,sound art,uk experimental electronic",
    popularity: "14",
  },
  {
    name: "Kazkid",
    image: "https://i.scdn.co/image/b349e571e403a53f41180949df95ad66124d2cb2",
    spotify: "76fIZZHPt37NZC5r3raQxO",
    genre: "",
    popularity: "14",
  },
  {
    name: "Jasper Wolff",
    image: "https://i.scdn.co/image/ab67616d0000b273c487643cb638c65021c6d917",
    spotify: "4lvvDJhmmOCbydE8p75RiL",
    genre: "",
    popularity: "14",
  },
  {
    name: "Broken Brass Ensemble",
    image: "https://i.scdn.co/image/4198c69dfdd642624c80c1c018e7f31b01e7d75b",
    spotify: "0Cdw98R6u5PNvF336SghBN",
    genre: "street band",
    popularity: "14",
  },
  {
    name: "Christiane Rösinger",
    image: "https://i.scdn.co/image/ab67616d0000b2737a5e422d638ac91b838f0c2a",
    spotify: "271LW7GJQOUhbo7PZnS8jM",
    genre: "german indie,hamburger schule",
    popularity: "14",
  },
  {
    name: "Radio Eliza",
    image: "https://i.scdn.co/image/980d95cdb2d65068beceaea6510da8995d71b114",
    spotify: "31cmb92nLDpwsE7wK1OI58",
    genre: "dutch indie",
    popularity: "14",
  },
  {
    name: "Charles Jacques",
    image: "https://i.scdn.co/image/be0b104c3d6c728fd2687f4e9871274bb6d4312b",
    spotify: "0UGnkpuNYNoFQ8Ou4GN8jf",
    genre: "",
    popularity: "14",
  },
  {
    name: "Tomaga",
    image: "https://i.scdn.co/image/28d161e52eecb2a1a584ceccf117c1a4f4b76bd8",
    spotify: "22UtZr56I5MgK9Ru1QfUCj",
    genre: "british industrial,mandible",
    popularity: "14",
  },
  {
    name: "Marco Shuttle",
    image: "https://i.scdn.co/image/15fbe5753094129f07945ca6b9a718b0590a0c35",
    spotify: "2DqPerh6whhlts8Pb0BUJi",
    genre: "experimental techno,italian techno,minimal dub",
    popularity: "14",
  },
  {
    name: "Boogie Beasts",
    image: "https://i.scdn.co/image/0c635df6ee72b3f2862a941726d396c27d8db621",
    spotify: "7vFjqD3P13MLd71yllK5G1",
    genre: "belgian blues",
    popularity: "14",
  },
  {
    name: "Konduku",
    image: "https://i.scdn.co/image/866b176fa6cb2bc00ecf4d367d7f7fd80d13b565",
    spotify: "64v9ctTSV0oUJeZTFBoosp",
    genre: "experimental techno,float house",
    popularity: "14",
  },
  {
    name: "Certain Animals",
    image: "https://i.scdn.co/image/cf024b6acb346550850a6662e0d4543b5c0a0319",
    spotify: "63B62h8zh5sHiv6iCvHMhZ",
    genre: "rotterdam indie",
    popularity: "14",
  },
  {
    name: "Guido Schneider",
    image: "https://i.scdn.co/image/ab67616d0000b273e25b6ee8ef14c4956625d71e",
    spotify: "0gs1lrTmb4oO9FCaFftFQf",
    genre: "german techno",
    popularity: "14",
  },
  {
    name: "Ale Möller Band",
    image: "https://i.scdn.co/image/ab67616d0000b27305c24504d9551e5f26742d10",
    spotify: "2Yr4mLL9uy4kQhz5ISdCYK",
    genre: "folkmusik,nordic folk,swedish fiddle",
    popularity: "14",
  },
  {
    name: "Andrea Belfi",
    image: "https://i.scdn.co/image/178cb6a925b6a13f5b50a06ed3700d595bdd3f0a",
    spotify: "2lktSq1VE3OezchJvi3D8X",
    genre: "italian experimental,modern electroacoustic",
    popularity: "14",
  },
  {
    name: "Susobrino",
    image: "https://i.scdn.co/image/ab1d1182a52ebdd86c0481f844d653989e28d052",
    spotify: "77XvwNYFwIc71Q8314oPyu",
    genre: "belgian modern jazz",
    popularity: "14",
  },
  {
    name: "Death Alley",
    image: "https://i.scdn.co/image/8fa3e38be95378b2f6f734e1e017a0004ccd13aa",
    spotify: "1KXECEUuIe0WcHljWIaDrQ",
    genre: "dutch rock",
    popularity: "14",
  },
  {
    name: "Afterpartees",
    image: "https://i.scdn.co/image/aa956f81c06c8658cb2d9e60cf8e1f028dff1f8a",
    spotify: "5FtnkdycRhdTikTa8XaM02",
    genre: "dutch indie,dutch indie rock",
    popularity: "14",
  },
  {
    name: "The Million Plan",
    image: "https://i.scdn.co/image/ab67616d0000b273f3e35aaae67186abb1bc2789",
    spotify: "0vC62E3Ekqz43SKSzkQm8Q",
    genre: "",
    popularity: "14",
  },
  {
    name: "Abalone Dots",
    image: "https://i.scdn.co/image/ab67616d0000b273ee4c0e5bb1bdda1a38cd5178",
    spotify: "0vIHwSE2PZyBLqfc6KcrAG",
    genre: "swedish americana,swedish country",
    popularity: "14",
  },
  {
    name: "Melanie Ribbe",
    image: "https://i.scdn.co/image/4c3c6714fd2625b04b5df128cc0f0a97338957f1",
    spotify: "0CaIrbAAnshNfwGPwRFhOd",
    genre: "",
    popularity: "14",
  },
  {
    name: "Darkcontroller",
    image: "https://i.scdn.co/image/ab67616d0000b2739357a0ccb057c4975840d790",
    spotify: "6Ckc9fUBtKMbgosqv4bv0b",
    genre: "uptempo hardcore",
    popularity: "14",
  },
  {
    name: "Senor Roar",
    image: "https://i.scdn.co/image/79af5e2f61cb2a14be6c302e6fb6b6f4b8e86294",
    spotify: "7CJmFy2JMKfRhNtzOOis7h",
    genre: "",
    popularity: "14",
  },
  {
    name: "Mr Woodnote",
    image: "https://i.scdn.co/image/2c63ee687c93c934def12ad0ad2d384e294d878b",
    spotify: "0lPBmayZ3eJ7XeMnm97gXc",
    genre: "",
    popularity: "14",
  },
  {
    name: "Philipp Gorbachev",
    image: "https://i.scdn.co/image/616c600a38b2dfa628558630b1107b40ac7dfaf2",
    spotify: "6eY2REoBPKZ4CnJD0sFdfP",
    genre: "russian experimental electronic,russian techno",
    popularity: "14",
  },
  {
    name: "Ruby Boots",
    image: "https://i.scdn.co/image/25541a69e37356ae10d6929a15205b5c1da1f57b",
    spotify: "2iZoBSIlhnD1fI61wGZ14J",
    genre: "australian americana,perth indie",
    popularity: "14",
  },
  {
    name: "Raketen Erna",
    image: "https://i.scdn.co/image/e6770f46fd44e37752f1a1193be98b30c39a20f1",
    spotify: "4H4plH9ob6ZyQmad6gS2Wb",
    genre: "",
    popularity: "14",
  },
  {
    name: "Contagious Madness",
    image: "https://i.scdn.co/image/e2538a3c2093beaf545d193bc98f83dcbb80901b",
    spotify: "7Dknl3VoMj2qklbty0fJxS",
    genre: "",
    popularity: "14",
  },
  {
    name: "Tenfold",
    image: "https://i.scdn.co/image/ce31d7e37c29039e073678b00bf4915c08d26325",
    spotify: "5Z3cYfm62l4JYDIihkXpQc",
    genre: "",
    popularity: "14",
  },
  {
    name: "Reygel & Peri",
    image: "https://i.scdn.co/image/e769f44ae43c416e3678d7ffbdb72bd3219f2215",
    spotify: "6AelSJk1FRDnejKP6nrzy0",
    genre: "",
    popularity: "14",
  },
  {
    name: "Duodisco",
    image: "https://i.scdn.co/image/9ca6f62d37e0944c38d15d9f20c0f83a546d0d2d",
    spotify: "29tAeuzBfdhKqpOkxzzDsF",
    genre: "",
    popularity: "14",
  },
  {
    name: "Goliath",
    image: "https://i.scdn.co/image/237b87e4758b72b944298136850f817b860b9a12",
    spotify: "06JeI57oISyTC08DpFumV0",
    genre: "",
    popularity: "14",
  },
  {
    name: "Manu Desrets",
    image: "https://i.scdn.co/image/f515a6b3618d16e4312928d8fb76b06673a5a08e",
    spotify: "705zRr848qe0fflIMCyofK",
    genre: "house argentino",
    popularity: "14",
  },
  {
    name: "Luxxer",
    image: "https://i.scdn.co/image/ab67616d0000b27314827fc9586ca899cc0d797d",
    spotify: "1rTpCWbfB6VhlaxnlFuSXe",
    genre: "",
    popularity: "14",
  },
  {
    name: "Dragon Suplex",
    image: "https://i.scdn.co/image/ab67616d0000b2731c81fb9e5e6f35274dafd5ab",
    spotify: "02fumhUvM9Qh0cE0oGnXgi",
    genre: "",
    popularity: "14",
  },
  {
    name: "Quinten 909",
    image: "https://i.scdn.co/image/d93f032a19fc5e2fa4771908f072b96a92d1d10a",
    spotify: "0UqtldZFltYMDWnacj9TzS",
    genre: "",
    popularity: "14",
  },
  {
    name: "Sophia Saze",
    image: "https://i.scdn.co/image/15e139c6ef706a222138821135421465ea51384c",
    spotify: "68wEYbQ4kNNAGjhHwbOYTY",
    genre: "experimental techno",
    popularity: "14",
  },
  {
    name: "Steve Nelson",
    image: "https://i.scdn.co/image/ab67616d0000b2734a2faa6bfb44d0717a0542fa",
    spotify: "39kLO9sJGaOhfk9wcsjxzY",
    genre: "jazz vibraphone",
    popularity: "14",
  },
  {
    name: "Tara Brooks",
    image: "https://i.scdn.co/image/ab67616d0000b273a9ada4a472ba0c72344e84a2",
    spotify: "7gCspPoGmiOBuw1IkSxQei",
    genre: "",
    popularity: "14",
  },
  {
    name: "LOLO BX",
    image: "https://i.scdn.co/image/0ce12c1bce422f774743019957fe5f1441db6beb",
    spotify: "1Z948M3nsGim4RWeTTkt6y",
    genre: "",
    popularity: "14",
  },
  {
    name: "Tony Rohr",
    image: "https://i.scdn.co/image/ab67616d0000b273953a52447e8655385111eed9",
    spotify: "3fmttokPNmNXJOAHMWsXbJ",
    genre: "",
    popularity: "14",
  },
  {
    name: "Wild Dark",
    image: "https://i.scdn.co/image/ab67616d0000b273e684e18ef1f9cc4816f7d90f",
    spotify: "4MEYUbUOLX7VIiAsAiXbxL",
    genre: "",
    popularity: "14",
  },
  {
    name: "Liquid Ace",
    image: "https://i.scdn.co/image/ab67616d0000b273b1e99cb244322890e632f59e",
    spotify: "239ghfSDgTjNA8LuxrgI9i",
    genre: "progressive psytrance",
    popularity: "14",
  },
  {
    name: "Bruce Sudano",
    image: "https://i.scdn.co/image/d24939eecaa74f2e2d92875546ca8f2f3e7ce37b",
    spotify: "603Q8uOwTjPYqTTBfwF8pZ",
    genre: "",
    popularity: "14",
  },
  {
    name: "Kings of Salsa",
    image: "https://i.scdn.co/image/ab67616d0000b2737c02ee58ef06ee6736ce9d36",
    spotify: "1NYNcM2vYRU8SbOspDi0Zm",
    genre: "",
    popularity: "14",
  },
  {
    name: "Roos Blufpand",
    image: "https://i.scdn.co/image/83ec2104d6683758efac0c2357b67021ff3999c7",
    spotify: "7J2a0SEgW7QaRHUIGjqgFC",
    genre: "",
    popularity: "14",
  },
  {
    name: "Mark Starr",
    image: "https://i.scdn.co/image/73e64c0bed5ec0e42154158a7b9f933ee1dd217a",
    spotify: "6Pk5JWEHOziytbxreCK9vu",
    genre: "",
    popularity: "14",
  },
  {
    name: "London Nebel",
    image: "https://i.scdn.co/image/ab67616d0000b273f2e4d6e80c5ccb4711291889",
    spotify: "0cwyC8pHkOvEtml1ev25lX",
    genre: "",
    popularity: "14",
  },
  {
    name: "Sky High",
    image: "https://i.scdn.co/image/ebc206418dfbd2887a0092a10624e670369533b2",
    spotify: "7AYg6KxTbJfh5BiFLGLJDq",
    genre: "",
    popularity: "14",
  },
  {
    name: "Ishan Sound",
    image: "https://i.scdn.co/image/3cfd0a88c0468460fa438efa6b14f0d3cb9edee4",
    spotify: "1khmI5tzvFM3QhiAoal6di",
    genre: "bristol electronic,deep dubstep",
    popularity: "14",
  },
  {
    name: "Land of the Giants",
    image: "https://i.scdn.co/image/cc0ab3a5a2a1012a7373cdcf65fb6aff2601ebc4",
    spotify: "5UKImBYKSB37lHvZi1aAzh",
    genre: "devon indie",
    popularity: "14",
  },
  {
    name: "Elliot Galvin",
    image: "https://i.scdn.co/image/9931d289a537c855d0d80f102e17b5e4095dc1e2",
    spotify: "6nEvfSGOFlRcua1pWmpvhL",
    genre: "uk contemporary jazz",
    popularity: "14",
  },
  {
    name: "The Minutes",
    image: "https://i.scdn.co/image/d9cce39d9696448b2e1f83694970d917c4c9a8c6",
    spotify: "3l2H4Rs4vhttLwf57CQBeX",
    genre: "irish rock",
    popularity: "14",
  },
  {
    name: "Kreutziger",
    image: "https://i.scdn.co/image/e834e3dab055e42986c76eaaedbbf6facea23a6c",
    spotify: "09QKdz9LvtnmXNfH4ovj6D",
    genre: "",
    popularity: "14",
  },
  {
    name: "Philippe Elan",
    image: "https://i.scdn.co/image/ab67616d0000b2736f15991e9bcb00bc3e1a954c",
    spotify: "0AXv6zfUIzvuy9stiynf4a",
    genre: "",
    popularity: "14",
  },
  {
    name: "Khaira Arby",
    image: "https://i.scdn.co/image/d7c9107d8fdd0ef679e02321391fbb1445b441a7",
    spotify: "40sVPwf4wiarQJzW2sKEEg",
    genre: "desert blues",
    popularity: "14",
  },
  {
    name: "Shaun Reeves",
    image: "https://i.scdn.co/image/f2d430a9d15e84da5fa4b5b40daf256ef4ca8a8e",
    spotify: "4129HPJPawjUH2ttSXLdTQ",
    genre: "",
    popularity: "14",
  },
  {
    name: "Midori Takada",
    image: "https://i.scdn.co/image/ab67616d0000b273fa0e2f5992545fe5ae3662ac",
    spotify: "3fuab64Hf1xiRGocX1sT1n",
    genre: "japanese experimental",
    popularity: "14",
  },
  {
    name: "Will Lister",
    image: "https://i.scdn.co/image/1b51efd5666946844b0744f1fe8025c3e06d2249",
    spotify: "1odMNU4WdV8g46ku7SgfJz",
    genre: "",
    popularity: "14",
  },
  {
    name: "and.id",
    image: "https://i.scdn.co/image/a2045d3f42cb22538977d7caf1e3c13a05a1d4f9",
    spotify: "2Rf1xEBIVrhKugqmD6cMU3",
    genre: "greek house",
    popularity: "14",
  },
  {
    name: "Courtesy",
    image: "https://i.scdn.co/image/ab67616d0000b2730a3d00a3400e273b34a68437",
    spotify: "51zO5zB74HgVL3QY6nvG2I",
    genre: "",
    popularity: "13",
  },
  {
    name: "Lena Willikens",
    image: "https://i.scdn.co/image/218cc7f2515b7ed3fd1432e6f4807fabbf66c5fc",
    spotify: "6ut6UGbmxITsrTO3byNE2E",
    genre: "cologne electronic",
    popularity: "13",
  },
  {
    name: "Justin Cudmore",
    image: "https://i.scdn.co/image/b0e5b0b3af329e75941e0ed4b9b25e6dd47109df",
    spotify: "25x4ZS7K1jUoBU3u5Ivl3X",
    genre: "experimental techno",
    popularity: "13",
  },
  {
    name: "Tolouse Low Trax",
    image: "https://i.scdn.co/image/ab67616d0000b273c4e76d24c2f47225eb364134",
    spotify: "7kM7puCndDT0O3hr5WIHU9",
    genre: "dusseldorf electronic,german electronica",
    popularity: "13",
  },
  {
    name: "Maison du Malheur",
    image: "https://i.scdn.co/image/4d6f9c7e99dce0cf70eedec03d655a338e29ed22",
    spotify: "6ISRTIzRuBM6FGMDCfP9GZ",
    genre: "",
    popularity: "13",
  },
  {
    name: "Samuel Deep",
    image: "https://i.scdn.co/image/ab67616d0000b273166854e00da430f5cf846d4f",
    spotify: "4vvqJy4SLEx3s70rv5pO6T",
    genre: "dutch tech house",
    popularity: "13",
  },
  {
    name: "Parrish Smith",
    image: "https://i.scdn.co/image/ab67616d0000b273ef550a269b1562b1e30ab62c",
    spotify: "5w7TOAEvABipEVEyVPdB6u",
    genre: "experimental techno",
    popularity: "13",
  },
  {
    name: "Nkisi",
    image: "https://i.scdn.co/image/11764844d1f4c66e266661ea9dce3e64285c8036",
    spotify: "06egMm0xwc1DYUaApCCKiH",
    genre: "uk experimental electronic",
    popularity: "13",
  },
  {
    name: "Boris Werner",
    image: "https://i.scdn.co/image/d51a067a27bc136279425ceaa56d70b4996efc3f",
    spotify: "5HplhWaP0VIc9mDlg4aqVv",
    genre: "minimal tech house",
    popularity: "13",
  },
  {
    name: "Miriam Aida",
    image: "https://i.scdn.co/image/b109c4321a5a58f6f50b600e74f7de2b963db06b",
    spotify: "6Qg9KBZ1bWDA5bzaqroDtJ",
    genre: "",
    popularity: "13",
  },
  {
    name: "Jonny Rock",
    image: "https://i.scdn.co/image/ab67616d0000b2733988ba839439a47ec00733a9",
    spotify: "2ml0DeRBk846pFDiel8CoY",
    genre: "",
    popularity: "13",
  },
  {
    name: "Alexi Delano",
    image: "https://i.scdn.co/image/ab67616d0000b273d73a7c4bff725598be1b5f4b",
    spotify: "3SMK11DciN6CaQAza3Trfa",
    genre: "",
    popularity: "13",
  },
  {
    name: "Dazion",
    image: "https://i.scdn.co/image/ab67616d0000b2733fc118f9131062e104709f5a",
    spotify: "1BnFsKWC2I44DQoMjfIF3e",
    genre: "",
    popularity: "13",
  },
  {
    name: "Ollin Kan",
    image: "https://i.scdn.co/image/87e28a72de86e3893b7f1ae00ce35a9937b96e1a",
    spotify: "207q7yBUhUUMpxkI72Qd4l",
    genre: "",
    popularity: "13",
  },
  {
    name: "The Tailors",
    image: "https://i.scdn.co/image/ab67616d0000b273efc5180c3ff3df6a44f97f24",
    spotify: "6Nw2xtODw51dSnYwDr0ORg",
    genre: "",
    popularity: "13",
  },
  {
    name: "Raw District",
    image: "https://i.scdn.co/image/b3ef8e8bb350215734824be6ab58d478bbc2993c",
    spotify: "1teu5wTpfgfkdUIrgN6REU",
    genre: "",
    popularity: "13",
  },
  {
    name: "Dirrty Berry",
    image: "https://i.scdn.co/image/15037e10a064ad429be6b9001c8e1956b5050f25",
    spotify: "489Brq3U50xzKBwLzbGaAi",
    genre: "",
    popularity: "13",
  },
  {
    name: "Saltzer",
    image: "https://i.scdn.co/image/ab67616d0000b2732fe438e0887950e3952652a2",
    spotify: "6cmBs8IfPNPqekNFkdhMCX",
    genre: "jumpstyle",
    popularity: "13",
  },
  {
    name: "Stephen Triffitt",
    image: "",
    spotify: "4qLUsGYBOPlIlQEiWhHN3R",
    genre: "",
    popularity: "13",
  },
  {
    name: "Nobody Beats The Drum",
    image: "https://i.scdn.co/image/b38aa4f7f703850b4a4b45c09ef55af4efe75aa5",
    spotify: "1BO9YWU0TlIwICfbA1toLI",
    genre: "",
    popularity: "13",
  },
  {
    name: "Whitewater Band",
    image: "https://i.scdn.co/image/1cc012d112851a42c6035499556fd769618cae73",
    spotify: "0Z7de8qjFBesxgR8n38uSB",
    genre: "",
    popularity: "13",
  },
  {
    name: "Interstellar Funk",
    image: "https://i.scdn.co/image/ab67616d0000b27333ab52c3dfe226fdc02d3851",
    spotify: "33DoW58zhBjyyeCdscBybf",
    genre: "float house",
    popularity: "13",
  },
  {
    name: "Snakecharmer",
    image: "https://i.scdn.co/image/3566d6fac725fbe81bbfe1ab0f85239eb823c48b",
    spotify: "2vxNER8eBhtPoGelvNaBrP",
    genre: "",
    popularity: "13",
  },
  {
    name: "Queen Machine",
    image: "https://i.scdn.co/image/ab67616d0000b273e1222977dd3b4760738dd4d4",
    spotify: "4SK9OzAA0K00NVsXAApeUJ",
    genre: "",
    popularity: "13",
  },
  {
    name: "Boris Ross",
    image: "https://i.scdn.co/image/8d16947a738832be7b0f9f674544f220069b2f24",
    spotify: "0srZONNIOpBI4xPLpjt5vv",
    genre: "",
    popularity: "13",
  },
  {
    name: "Tom Tilley",
    image: "https://i.scdn.co/image/82cf5eb447d239d127d699eda5896b3df94b594b",
    spotify: "1wENCgufhKkMyvPC5BlRCy",
    genre: "",
    popularity: "13",
  },
  {
    name: "Jason Chance",
    image: "https://i.scdn.co/image/ab67616d0000b273946785ea7659af5a495431fd",
    spotify: "4ACU7zoQxkKKIQnIPe09rY",
    genre: "funky tech house",
    popularity: "13",
  },
  {
    name: "Physical Therapy",
    image: "https://i.scdn.co/image/ab67616d0000b27379ee41c20f1a2ddf2aa8be03",
    spotify: "3M2OPq6DiaaiLeKnbvkweZ",
    genre: "",
    popularity: "13",
  },
  {
    name: "U-Bahn",
    image: "https://i.scdn.co/image/6a3ff6d1b27283d302868b04d63a694247eb931c",
    spotify: "7xhKjvfcFvKkwgpFu3gVYy",
    genre: "collage pop",
    popularity: "13",
  },
  {
    name: "Escape-ism",
    image: "https://i.scdn.co/image/ab6772690000c46c6f01f97c91890b84a3ab121d",
    spotify: "48TRPVbEYuT05V1bvAR5pq",
    genre: "dc indie",
    popularity: "13",
  },
  {
    name: "Vera Vinter",
    image: "https://i.scdn.co/image/9af86ea9365be6ff3d73509b000e1d07b1ef3552",
    spotify: "4DEPy5DLLFWWmN7J5gnWck",
    genre: "",
    popularity: "13",
  },
  {
    name: "Jayden Jaxx",
    image: "https://i.scdn.co/image/26a1ef6bf71552042d0e1526381f8e719340ab78",
    spotify: "41O0Sb8nBFTzRtHDSlAJzs",
    genre: "sky room",
    popularity: "13",
  },
  {
    name: "Gasper Nali",
    image: "https://i.scdn.co/image/2be1aac94760b46c3d78fb786f25b42fb4faeebe",
    spotify: "1iv2bmWnUifiDuSrZq8FeC",
    genre: "malawian folk",
    popularity: "13",
  },
  {
    name: "Die Dorks",
    image: "https://i.scdn.co/image/a724890738e16ce8b93a5f3e05702f4cb8127bb8",
    spotify: "1l82LuVcSsWhYHKjLNO5xX",
    genre: "",
    popularity: "13",
  },
  {
    name: "Mell Tierra",
    image: "https://i.scdn.co/image/ab67616d0000b2737f80f3e13c1bc4dc0fb63535",
    spotify: "0mRnzQ57yTuNxmAQWqKzYO",
    genre: "",
    popularity: "13",
  },
  {
    name: "Vincent Floyd",
    image: "https://i.scdn.co/image/ab67616d0000b273e438b418b07ba0b8b2ede8b8",
    spotify: "39e6OAHm66cl3EtnQVbW6J",
    genre: "float house",
    popularity: "13",
  },
  {
    name: "Crazy Arm",
    image: "https://i.scdn.co/image/a975deddd7ba251af436aabb35bbebbaa2a79dab",
    spotify: "0k3wZ8LSGquLQDwfW9VrIq",
    genre: "devon indie,uk diy punk",
    popularity: "13",
  },
  {
    name: "Imbibe",
    image: "https://i.scdn.co/image/d4910fc16e6e82cf2948723f39cb758abdbde1dc",
    spotify: "17KVMmnqvKAER3z0CD16cJ",
    genre: "australian electropop",
    popularity: "13",
  },
  {
    name: "The Pollies",
    image: "https://i.scdn.co/image/0dcbd342ff32c14f0775e98651976fd7bc63da2f",
    spotify: "598trStGjYePaRmeDHip8u",
    genre: "deep new americana,southern americana",
    popularity: "13",
  },
  {
    name: "Ducked Ape",
    image: "https://i.scdn.co/image/3376158d5073bd479521b6a3fa66ceeff1fc8ab8",
    spotify: "1Lpj9eQh51y06BS2d7CrM3",
    genre: "",
    popularity: "13",
  },
  {
    name: "Smagghe & Cross",
    image: "https://i.scdn.co/image/12dd3a9558488fb50a3fa5d606c4874624c52eb6",
    spotify: "4aLw2jqSywRPpArQOZD0UV",
    genre: "experimental ambient",
    popularity: "13",
  },
  {
    name: "WaqWaq Kingdom",
    image: "https://i.scdn.co/image/480e678d90919e6cf1cb99cd8a5825ef7e4b24d1",
    spotify: "4in9NY36a5EllSTje5liC5",
    genre: "japanese electronic",
    popularity: "13",
  },
  {
    name: "Holland Baroque",
    image: "https://i.scdn.co/image/a554e9f16b8020d8c6730c0ed77cc8331b31e414",
    spotify: "3RgDcTU4WaY4o15XIisFxl",
    genre: "baroque ensemble",
    popularity: "13",
  },
  {
    name: "Lowtec",
    image: "https://i.scdn.co/image/ab67616d0000b2732800afa669b139250e7ef8fc",
    spotify: "6IW76sJ0SzZo0iXZTqwt5o",
    genre: "leipzig electronic",
    popularity: "13",
  },
  {
    name: "Little Thief",
    image: "https://i.scdn.co/image/01cdb18fa65717d516c45642e8d2f3cfc6dcff94",
    spotify: "24umwqg4cKhhOe3oAi3U5q",
    genre: "",
    popularity: "13",
  },
  {
    name: "Vuurwerk",
    image: "https://i.scdn.co/image/c29d1dc52c7049b01d5f337bb30a0df6fb363726",
    spotify: "2Vr7IwaY4BE6FEe9rS6qwr",
    genre: "belgian pop",
    popularity: "13",
  },
  {
    name: "The Gents",
    image: "https://i.scdn.co/image/76d259b0257267fbcf04632a7c7662fdf68ef1df",
    spotify: "6dWJvRTsfmxYqdp1t3TvoP",
    genre: "mod revival",
    popularity: "13",
  },
  {
    name: "Eran Aviner",
    image: "https://i.scdn.co/image/6f34b90860fad4e6a82c8519925738a06eb73906",
    spotify: "1MoItnWeHG97AtVPNQnYM9",
    genre: "belgian techno",
    popularity: "13",
  },
  {
    name: "Bazar Blå",
    image: "https://i.scdn.co/image/209f108db3d5327edf58702098af823f37956209",
    spotify: "4JETLQUlzaCISfJ9XNab7H",
    genre: "folkmusik,nordic folk,nyckelharpa",
    popularity: "13",
  },
  {
    name: "New York Brass Band",
    image: "https://i.scdn.co/image/ab67616d0000b2735e5e1661bc536e266eee7302",
    spotify: "64TTxwe7TtriyQxMQKT6Ei",
    genre: "street band",
    popularity: "13",
  },
  {
    name: "Rhadoo",
    image: "https://i.scdn.co/image/6e46316a9dbb39e26168f25756b0a8c073a2e3fe",
    spotify: "7w06C58Y8rJF6mJNLFrGaS",
    genre: "rominimal",
    popularity: "13",
  },
  {
    name: "Zopelar",
    image: "https://i.scdn.co/image/ecaba908103e1b3b166537ee3b7df665bea9a47a",
    spotify: "0Qr2iLEeyLhd9rLHH1piYb",
    genre: "brazilian techno",
    popularity: "13",
  },
  {
    name: "Gunnar Haslam",
    image: "https://i.scdn.co/image/1a1b3c1d9a8f16f296e16612af41d38aed77e5fb",
    spotify: "6psbxBiuEGVqnA6WA63OiH",
    genre: "acid techno,outsider house",
    popularity: "12",
  },
  {
    name: "MC JR",
    image: "https://i.scdn.co/image/ab67616d0000b273ea533bcf935ef4ec9a514aa2",
    spotify: "4ugLleC6uEq1L9RFEGi1fm",
    genre: "",
    popularity: "12",
  },
  {
    name: "Valentino Mora",
    image: "https://i.scdn.co/image/e9ff10ec12d662d88ce24a651e0889666b66b293",
    spotify: "1U9VJ1tPataidARB8IBkAk",
    genre: "experimental techno",
    popularity: "12",
  },
  {
    name: "Alessandro Adriani",
    image: "https://i.scdn.co/image/6c06864b2e756f08917757ce63522ef7352dcb5c",
    spotify: "1QmkIcm4Jnh0ewzxHRlwAU",
    genre: "experimental techno,italian experimental",
    popularity: "12",
  },
  {
    name: "Al Twisted",
    image: "https://i.scdn.co/image/6bf50c1e861bc86fac72d4e9878457003bdb5da9",
    spotify: "2QT5fKMTmGk3hkpNCzLHgy",
    genre: "",
    popularity: "12",
  },
  {
    name: "Low Jack",
    image: "https://i.scdn.co/image/ab67616d0000b27390c6da5488904dd504d15236",
    spotify: "6hFiRAyHR8aJ9I5yXvXuAG",
    genre: "",
    popularity: "12",
  },
  {
    name: "Alex Prospect",
    image: "https://i.scdn.co/image/ccc0c21962b5c9f69692da7f560c0a4c517f4229",
    spotify: "2OdmgtFZnABsVojSTsq0YN",
    genre: "",
    popularity: "12",
  },
  {
    name: "Lutto Lento",
    image: "https://i.scdn.co/image/c8d11989420e41084e1d444f1bd78da1cafcfdd9",
    spotify: "5u7ZnbVxxcImkr5fx8GJta",
    genre: "polish experimental electronic",
    popularity: "12",
  },
  {
    name: "The Junkies",
    image: "https://i.scdn.co/image/84b2dedfb996289ae2092255f871a8db9f5b1a36",
    spotify: "2L8pMMIXx2mPDRlmx3QIJG",
    genre: "",
    popularity: "12",
  },
  {
    name: "Secretsundaze",
    image: "https://i.scdn.co/image/4ace820e33aaf294cc787477c7c934c6df05b9d6",
    spotify: "02BIejIClQYx1GJ8LNywB2",
    genre: "",
    popularity: "12",
  },
  {
    name: "Sheila and The Kit",
    image: "https://i.scdn.co/image/ab67616d0000b27300d0465017cff9f9cb9d43b1",
    spotify: "3EYBjavx2VfeoBhQjwMz74",
    genre: "",
    popularity: "12",
  },
  {
    name: "Talismann",
    image: "https://i.scdn.co/image/ab67616d0000b27397b7c34f4892efa8e736ccd5",
    spotify: "6EbNaM2bFGGDaPKTNG1PT2",
    genre: "",
    popularity: "12",
  },
  {
    name: "The Punisher",
    image: "https://i.scdn.co/image/ab67616d0000b273111dfa551051884343139bdd",
    spotify: "04G86bE80jBhRVfH7SvQyJ",
    genre: "",
    popularity: "12",
  },
  {
    name: "Dan Beaumont",
    image: "https://i.scdn.co/image/ab67616d0000b273244adc0bb3560224093f465a",
    spotify: "0FT25lb0i4NRpNiDkrrsyn",
    genre: "",
    popularity: "12",
  },
  {
    name: "Ocobar",
    image: "https://i.scdn.co/image/ab67616d0000b273c2bbc3c418334c27f5c66fbc",
    spotify: "12hvecoyeh1Go3v5x3xK3w",
    genre: "",
    popularity: "12",
  },
  {
    name: "Ronald Snijders",
    image: "https://i.scdn.co/image/ab67616d0000b27317cf59b388aa0848c2f4e848",
    spotify: "7vKJahL19XOj5K7XYTqtW6",
    genre: "jazz flute",
    popularity: "12",
  },
  {
    name: "Pieternel",
    image: "https://i.scdn.co/image/0eb9ac3c11bd0806a582f1f3c796adb1988a974b",
    spotify: "5JzvmJdkliw2nERmKleDuS",
    genre: "dutch americana",
    popularity: "12",
  },
  {
    name: "Korfbal",
    image: "https://i.scdn.co/image/a14061563aee05bdae374040b345ede76f6bdef1",
    spotify: "4IsJdCMinyBhfuJj1OpoVP",
    genre: "dutch indie rock",
    popularity: "12",
  },
  {
    name: "Gierige Gasten",
    image: "https://i.scdn.co/image/ab67616d0000b273a0399735aec2abf5260b6278",
    spotify: "1GfGX6fO8YeFkyWkj5h4Sr",
    genre: "",
    popularity: "12",
  },
  {
    name: "Javi Redondo",
    image: "https://i.scdn.co/image/ab67616d0000b2732ab88058fbdfbdabeac5c4a0",
    spotify: "3sfZrnSyYWKIvdWIDuBaUy",
    genre: "",
    popularity: "12",
  },
  {
    name: "Until The Dawn",
    image: "https://i.scdn.co/image/ab67616d0000b27311bd78c19c74cee62d6c7e42",
    spotify: "4B2kWiatS3jDKpCt9NTYcJ",
    genre: "",
    popularity: "12",
  },
  {
    name: "X-Mind",
    image: "",
    spotify: "3PMvlz4hsBHTHz5KZknUbD",
    genre: "",
    popularity: "12",
  },
  {
    name: "Taras Van De Voorde",
    image: "https://i.scdn.co/image/c53883c7ef8cfe39d67bea82ba49dab9fca8278f",
    spotify: "04RW5k54zYrwvfKm3YELgT",
    genre: "dutch tech house",
    popularity: "12",
  },
  {
    name: "Solemn Eye",
    image: "https://i.scdn.co/image/fdada841397bc17531659e7c40ce6d1f2d063857",
    spotify: "0RNtEjpe87tzJ8JX3Agddx",
    genre: "",
    popularity: "12",
  },
  {
    name: "Brawther",
    image: "https://i.scdn.co/image/ab67616d0000b27362691c47782f985f5b849150",
    spotify: "6UV6mehn2Fs0ropWUpGWtI",
    genre: "deep soul house",
    popularity: "12",
  },
  {
    name: "Anthony Pappa",
    image: "https://i.scdn.co/image/3ad2fee32ce9dd0e889568e2bdc7455a2f4215f3",
    spotify: "7AjadUCPS3CyVaeyQYySfd",
    genre: "",
    popularity: "12",
  },
  {
    name: "Deliluh",
    image: "https://i.scdn.co/image/ab67616d0000b27373f8f9396bd0d7a022da4372",
    spotify: "3CrJg0SS35MCzokYBNKlHE",
    genre: "canadian post-punk,canadian psychedelic rock",
    popularity: "12",
  },
  {
    name: "Steph Cameron",
    image: "https://i.scdn.co/image/59cde32e34d1cc83c70497fe1bcd5fba269dd739",
    spotify: "1MxwQN5SzvTlYtw8MIgdbw",
    genre: "canadian folk,canadian singer-songwriter",
    popularity: "12",
  },
  {
    name: "Mr. M!X",
    image: "https://i.scdn.co/image/da5d60126a54d196073682545f45285595fd1ed6",
    spotify: "0zhRD0lNXII4Fq1tcrtadg",
    genre: "",
    popularity: "12",
  },
  {
    name: "The Black Heart Rebellion",
    image: "https://i.scdn.co/image/b8371e428d633d36afebd62c64c63222ed7a326e",
    spotify: "0PfKHvjXVreik1Mushff0B",
    genre: "belgian experimental,skramz",
    popularity: "12",
  },
  {
    name: "Shari Vari",
    image: "https://i.scdn.co/image/ab67616d0000b2730ef6077adcbfb82e2e32774e",
    spotify: "3QKOVQPzPNggh9PzUDKhPy",
    genre: "",
    popularity: "12",
  },
  {
    name: "Mindek",
    image: "https://i.scdn.co/image/28479623609baeefc9edef6133d3210ba2e50015",
    spotify: "1CKvZxCyOAnNUgz0Vx8ko9",
    genre: "",
    popularity: "12",
  },
  {
    name: "Decibelles",
    image: "https://i.scdn.co/image/e327c7a01cd9422ca0c04602d73d26cf2f875f19",
    spotify: "6jRtQcvGq3pGsmdL5t3rBm",
    genre: "french punk",
    popularity: "12",
  },
  {
    name: "Herzog",
    image: "https://i.scdn.co/image/bf6a00f6bfcbfa41ad0059bdf6e00fb119a6d9c6",
    spotify: "2RjwZtvMYkOTg9jZAKXqTi",
    genre: "cleveland indie",
    popularity: "12",
  },
  {
    name: "St. Tropez",
    image: "https://i.scdn.co/image/ab67616d0000b2733ba63894e98e577f08d3ccb5",
    spotify: "52kH1s8ccwrmOO6OcJyJXl",
    genre: "modern alternative rock",
    popularity: "12",
  },
  {
    name: "Kenny Glasgow",
    image: "https://i.scdn.co/image/ab67616d0000b273a55440b2b98d2814766f0b67",
    spotify: "6AYA1vVqIkYngOSSWu8Zbb",
    genre: "canadian electronic",
    popularity: "12",
  },
  {
    name: "Stefany June",
    image: "https://i.scdn.co/image/543a021b2f20004e4bb3434ac91e3df686d57307",
    spotify: "1NkAcgpdxBDxnDKEOveREA",
    genre: "",
    popularity: "12",
  },
  {
    name: "Charity Strike",
    image: "https://i.scdn.co/image/1c73f7d794ae7d39acc2887a613b9ed847e4b0be",
    spotify: "2sVnJjPH9eu8KMZN3sHKQm",
    genre: "",
    popularity: "12",
  },
  {
    name: "Gianni Mae",
    image: "https://i.scdn.co/image/1ff5ddecc4e517f80f7b0698a774fbb9e437fd4e",
    spotify: "7A9eAxRYEABqRd2Us9v6xn",
    genre: "",
    popularity: "12",
  },
  {
    name: "BLOW 3.0",
    image: "https://i.scdn.co/image/748d829cc93498469416d17d6c7a865f0d0a04e6",
    spotify: "1jKTdWp8Z7hWdrubqKtMV3",
    genre: "experimental jazz",
    popularity: "12",
  },
  {
    name: "Swedish Death Candy",
    image: "https://i.scdn.co/image/c4368a76f49902e73ed1ba420665ce9c5583f923",
    spotify: "2m9hzV15mGuKuGzSJ2dkNT",
    genre: "indie psychedelic rock",
    popularity: "12",
  },
  {
    name: "King Ayisoba",
    image: "https://i.scdn.co/image/ab67616d0000b27322b15b2bcd851902806bec24",
    spotify: "6TQgRLQia206d3QvleDxen",
    genre: "highlife,hiplife",
    popularity: "12",
  },
  {
    name: "Enzyme X",
    image: "https://i.scdn.co/image/ab67616d0000b273876062158953cf6fe49233f9",
    spotify: "4ynHg3AYoiVq9zaNIERQYd",
    genre: "doomcore,gabba,hardcore techno,industrial hardcore,speedcore",
    popularity: "12",
  },
  {
    name: "Heavy Times",
    image: "https://i.scdn.co/image/ab67616d0000b273241f8d0ad695663e126b8412",
    spotify: "2gBgrL7vpTikBYBXoTj46K",
    genre: "garage pop",
    popularity: "12",
  },
  {
    name: "Cocaine Piss",
    image: "https://i.scdn.co/image/a42c2fe2f46a1479a0d242aab7f1355f666702bf",
    spotify: "1QD8XaLDuEgLV7vLMbrC4E",
    genre: "belgian hardcore,belgian indie,belgian indie rock",
    popularity: "12",
  },
  {
    name: "Du og jeg og vi 2-3-4",
    image: "https://i.scdn.co/image/6348f1f562ba91f0c233ddf6a974ee732cfe6570",
    spotify: "3jq1KE6RqWrLa2bqmnaatj",
    genre: "",
    popularity: "12",
  },
  {
    name: "Jon Hester",
    image: "https://i.scdn.co/image/1f43120f2f5ebd1c2db44bcbf7a89cf3ee1d310d",
    spotify: "0GYMBKQycrXx5fNodtVKLO",
    genre: "",
    popularity: "12",
  },
  {
    name: "London Elektricity Big Band",
    image: "https://i.scdn.co/image/ab67616d0000b27302739f28cc7d25af2647115a",
    spotify: "6sW9ONvs2pFlOPFwpaCM9a",
    genre: "uk dnb",
    popularity: "12",
  },
  {
    name: "Downside",
    image: "https://i.scdn.co/image/ab67616d0000b273677d23a9b9a4a5e6443285a2",
    spotify: "3upiaUvGyVaWE5gJPlyZ4y",
    genre: "",
    popularity: "12",
  },
  {
    name: "DeWalta",
    image: "https://i.scdn.co/image/0fcba57a96859c8d8f74111c2789622df7924d42",
    spotify: "2udp7bOzct3MZ2hmfMmz4f",
    genre: "minimal tech house",
    popularity: "12",
  },
  {
    name: "Tasseomancy",
    image: "https://i.scdn.co/image/d3f4ff99f2f6730697bb22d4a16b5589104435cb",
    spotify: "73c0SZ3V9Wrevmu71mGS9g",
    genre: "",
    popularity: "12",
  },
  {
    name: "Dinopha",
    image: "",
    spotify: "6niouZ3oxaXCQXEhkPJjpy",
    genre: "",
    popularity: "12",
  },
  {
    name: "Barely Autumn",
    image: "https://i.scdn.co/image/27960c15a16e3236ea694a26451309a1ceae420d",
    spotify: "69lKYBdYFPAaKp82vfwxpx",
    genre: "belgian indie",
    popularity: "12",
  },
  {
    name: "Drumcell",
    image: "https://i.scdn.co/image/27dd0beff41f1386a7b04f38e1738f14f4a02274",
    spotify: "3b9LxiX2zs6VCevlXRBCP8",
    genre: "industrial techno",
    popularity: "12",
  },
  {
    name: "Bryan Fury",
    image: "https://i.scdn.co/image/ab67616d0000b2733d65e1c9efd129b8c53a9c91",
    spotify: "6VQhIMcg9gN5mAjr9IvUvO",
    genre: "doomcore,hardcore techno,industrial hardcore,speedcore",
    popularity: "12",
  },
  {
    name: "André Galluzzi",
    image: "https://i.scdn.co/image/fb80893ed3ae1161daf760eb83ff95cff01eed3a",
    spotify: "1V9PJvMVxLIxhCdHCn8SC6",
    genre: "",
    popularity: "11",
  },
  {
    name: "Illesnoise",
    image: "https://i.scdn.co/image/ab67616d0000b273b5a79c7260c68d0d8cb60fa3",
    spotify: "7tmzapGahF1Yn0EKKzbxq3",
    genre: "",
    popularity: "11",
  },
  {
    name: "Johanna Knutsson",
    image: "https://i.scdn.co/image/608b77c53873c23de49ac5e0c89bb120bb2ebd83",
    spotify: "1YPkdEe6cWHDZpaCZ2gHh7",
    genre: "swedish electronic",
    popularity: "11",
  },
  {
    name: "Sjannies",
    image: "https://i.scdn.co/image/91ce783e53e0ecb32be603d0cf6d2e56ca1cfdeb",
    spotify: "7todEuDBgq4zy42k9P6CX1",
    genre: "",
    popularity: "11",
  },
  {
    name: "Nina Black",
    image: "https://i.scdn.co/image/ab67616d0000b2732c944ab29cfb8f60c51cb684",
    spotify: "2EzAcTOVLhaXPtyhF0sMmL",
    genre: "",
    popularity: "11",
  },
  {
    name: "Hilde Louise Asbjørnsen",
    image: "https://i.scdn.co/image/ed6243f708fa7d64620751efe941f98c4ee918a5",
    spotify: "0XF6KRFMk624XUnttYcJq0",
    genre: "",
    popularity: "11",
  },
  {
    name: "Charl Delemarre",
    image: "https://i.scdn.co/image/d256abbe5fbe0453912b2a6d51afb1667ef981ee",
    spotify: "0oRi6sn4Y87hbWoOrcT0LH",
    genre: "dutch singer-songwriter",
    popularity: "11",
  },
  {
    name: "The Ragtime Rumours",
    image: "https://i.scdn.co/image/ab67616d0000b2739845cebe089e5a369e1bb07c",
    spotify: "71eh4Ia3oMTC8dJkqYN4ZB",
    genre: "",
    popularity: "11",
  },
  {
    name: "Johnny Dowd",
    image: "https://i.scdn.co/image/aaf03c654b5ef206e290637aae23e31e872c6152",
    spotify: "37XGRhnYWhiV6o2jPB8nxt",
    genre: "gothic americana",
    popularity: "11",
  },
  {
    name: "CHOK DEE",
    image: "https://i.scdn.co/image/ab67616d0000b2731b7d172dc6a6a4a36fcd0daa",
    spotify: "57LGCtAeOFA9A7Z36SD0WF",
    genre: "uptempo hardcore",
    popularity: "11",
  },
  {
    name: "Photonz",
    image: "https://i.scdn.co/image/ab67616d0000b2738e7d0cbfd4facc83a9f069a5",
    spotify: "5iHhqWHlTz7xcTro2US2ol",
    genre: "experimental techno",
    popularity: "11",
  },
  {
    name: "Pink Oculus",
    image: "https://i.scdn.co/image/39d1c1abcfccd061fe8c2d0f2515539f2bcb0c7d",
    spotify: "0Fgve0HNaQEPK4xupHohzg",
    genre: "dutch r&b",
    popularity: "11",
  },
  {
    name: "Tiny Legs Tim",
    image: "https://i.scdn.co/image/66757b7be91cdd7d4fb9a3009e7d1604952b1f7e",
    spotify: "4F53NO14Tp1HxpwXryx7FD",
    genre: "belgian blues,belgian singer-songwriter,ghent indie",
    popularity: "11",
  },
  {
    name: "Troy Pierce",
    image: "https://i.scdn.co/image/7c48e36875ced1678956833b08649a2a304dfcc2",
    spotify: "3rwgMHVscSaKusde5DZ4an",
    genre: "german techno,minimal techno",
    popularity: "11",
  },
  {
    name: "A Made Up Sound",
    image: "https://i.scdn.co/image/6c2a159aebbcee44d5245147edaaa84e904c939f",
    spotify: "77bG3jpmWXOxpmZcVjPayy",
    genre: "bass music,future garage",
    popularity: "11",
  },
  {
    name: "JP Enfant",
    image: "https://i.scdn.co/image/bb86e8c4d47f8a7d610acd999f43d33ff370ece8",
    spotify: "5Z46nzBeFq12QXJwHlZqM7",
    genre: "",
    popularity: "11",
  },
  {
    name: "Anhatema",
    image: "",
    spotify: "5Ej27nrkSrLROiUDrl6x0e",
    genre: "",
    popularity: "11",
  },
  {
    name: "Anton Pieete",
    image: "https://i.scdn.co/image/ab67616d0000b2739a3fb0a7872f04aec328f79c",
    spotify: "1vDlMbvvi6AoVPz9kjyp0B",
    genre: "",
    popularity: "11",
  },
  {
    name: "E.M.I.L.",
    image: "https://i.scdn.co/image/ab67616d0000b2730abedf0fd4ecc642775344d6",
    spotify: "531RmHBTG1gvEVglG5tKUO",
    genre: "romanian rock",
    popularity: "11",
  },
  {
    name: "Whyt Noyz",
    image: "https://i.scdn.co/image/ab67616d0000b27351eec58c9afc043ab443d1e8",
    spotify: "7kA8HIdGePWku2cScDfvNc",
    genre: "",
    popularity: "11",
  },
  {
    name: "Braunbeck",
    image: "https://i.scdn.co/image/26d950d350c47e5640b9bad4d1ddf065f5df34bc",
    spotify: "6ZoJwIfVR98rJhf6NZwuCT",
    genre: "ethnotronica",
    popularity: "11",
  },
  {
    name: "Eric Cloutier",
    image: "https://i.scdn.co/image/ab67616d0000b273a328298a1d9955d2e92b36b0",
    spotify: "3f4eo0hX1eJqaxAAuAEMAt",
    genre: "detroit techno",
    popularity: "11",
  },
  {
    name: "Jonas Stenberg",
    image: "https://i.scdn.co/image/ab67616d0000b27326ee0a3a11a4e980f07ca2fe",
    spotify: "4CcAvYyDgSCEix5r8EP4F2",
    genre: "",
    popularity: "11",
  },
  {
    name: "Total Recall",
    image: "https://i.scdn.co/image/a2fb5d6ee82776465fc3824a598daa6b08f67334",
    spotify: "4EIEXJSJK58zjsAqjV2uUH",
    genre: "filthstep",
    popularity: "11",
  },
  {
    name: "Nukem",
    image: "https://i.scdn.co/image/a013958569c77d4904598b0eeab8c95feefe32b5",
    spotify: "51TCMBN7KkolnuPSR1MMCX",
    genre: "",
    popularity: "11",
  },
  {
    name: "Matt Firth",
    image: "https://i.scdn.co/image/ab67616d0000b27349f25ab46547cf890d964c32",
    spotify: "1ODwmVJe3ZM96IH1qrp2Ei",
    genre: "",
    popularity: "11",
  },
  {
    name: "Tigerilla",
    image: "https://i.scdn.co/image/cfeda0bba0c0d053818558f2301b5aace846031b",
    spotify: "7LtBIPYVOtaEEiVRr4aPyC",
    genre: "",
    popularity: "11",
  },
  {
    name: "An On Bast",
    image: "https://i.scdn.co/image/61c35417b8d7749e02d0a3c0d5a2509e9cd73e54",
    spotify: "4qIHzBkWUueYNuEl3xCDHs",
    genre: "ambient idm,polish electronica",
    popularity: "11",
  },
  {
    name: "Vivian Buczek",
    image: "https://i.scdn.co/image/ab67616d0000b2732202982f6f4b90751359472a",
    spotify: "7pvJqc7hW0HQjoa89jfDPq",
    genre: "swedish jazz",
    popularity: "11",
  },
  {
    name: "The Visual",
    image: "https://i.scdn.co/image/761b143530a74d76305590f9b7e9ae0325cc12f1",
    spotify: "5bFE4VXlLKRrC8vxZ0QDyh",
    genre: "",
    popularity: "11",
  },
  {
    name: "Critical Choice",
    image: "https://i.scdn.co/image/ab67616d0000b2735dc26100e9b4ee1d2f68b998",
    spotify: "4Qb4eOGk6bj1cVIbDEpCIU",
    genre: "",
    popularity: "11",
  },
  {
    name: "Unclesand",
    image: "https://i.scdn.co/image/c2fca8d57862a61be420b7b28cdfd747f4ca8103",
    spotify: "46N1xodj0DfFh0aymVtuB8",
    genre: "",
    popularity: "11",
  },
  {
    name: "Ukandanz",
    image: "https://i.scdn.co/image/ab67616d0000b273be4a3564f3bfb0e41a6978f2",
    spotify: "6eid2mbg2XPVDyqdRmNIqb",
    genre: "ethio-jazz",
    popularity: "11",
  },
  {
    name: "The Sweet Release of Death",
    image: "https://i.scdn.co/image/dab11d51fcbd6520af88c5c1d4d00235831dc7b9",
    spotify: "1STiw2bw2vI7MHp3Ar1Re7",
    genre: "rotterdam indie",
    popularity: "11",
  },
  {
    name: "Orla Feeney",
    image: "https://i.scdn.co/image/df6c113b0e4d152ba333afae1712df4e8cedf9c6",
    spotify: "04XICzzNGwT1jSPXitnQqD",
    genre: "",
    popularity: "11",
  },
  {
    name: "Julian Maier-Hauff",
    image: "https://i.scdn.co/image/595495cf5fafb7ec960875a1a23dfa8a404261cb",
    spotify: "1iAU1KhwquI5ZSUEdDcZ3E",
    genre: "",
    popularity: "11",
  },
  {
    name: "Magic Island",
    image: "https://i.scdn.co/image/c5d2ffe2cd0359e5627b2b245ed7aa8b0e02f8db",
    spotify: "1gMApXFfTNiIBoe98GRCpU",
    genre: "",
    popularity: "11",
  },
  {
    name: "Riiho",
    image: "https://i.scdn.co/image/ab67616d0000b27361d13466be399076bbcf5490",
    spotify: "6M9ft167NX8iQZk5Csir6X",
    genre: "rawstyle,xtra raw",
    popularity: "11",
  },
  {
    name: "Darwish",
    image: "https://i.scdn.co/image/ab67616d0000b273a177c201f87f5985330bbd9a",
    spotify: "5Gg0ESXKeMxrZ3KhWM7DyK",
    genre: "",
    popularity: "11",
  },
  {
    name: "David Alvarado",
    image: "https://i.scdn.co/image/56580605881a51f539628e8ca3df813da6113195",
    spotify: "1KvKvjbBr8vusmcZxCNhEY",
    genre: "",
    popularity: "11",
  },
  {
    name: "Andy Garvey",
    image: "https://i.scdn.co/image/ab67616d0000b273a2ca652eb4657401ab065a6a",
    spotify: "7yGnQDpuwBRqBvat7gBGUl",
    genre: "australian house",
    popularity: "11",
  },
  {
    name: "Piezo",
    image: "https://i.scdn.co/image/a6cd6974ba65c07b5ede4a7ca9a38c4756edb641",
    spotify: "4vr49Ycb253qEyUuXnlYaM",
    genre: "experimental club",
    popularity: "11",
  },
  {
    name: "Kissogram",
    image: "",
    spotify: "5GCcJPrAxNm7phIxT1lnsZ",
    genre: "elektropunk",
    popularity: "11",
  },
  {
    name: "Reckonwrong",
    image: "https://i.scdn.co/image/0097031671555b8df057e72cf2d152ae79af5115",
    spotify: "3gY33YyX0dYgugN0Smz35w",
    genre: "experimental electronic",
    popularity: "11",
  },
  {
    name: "KING MUD",
    image: "https://i.scdn.co/image/ab67616d0000b273c864b449b52a24fbc408a458",
    spotify: "2ciZ71oCPXDtQfWG7AEGGY",
    genre: "modern blues rock",
    popularity: "11",
  },
  {
    name: "Cenobites",
    image: "https://i.scdn.co/image/74f30b5ea430ed2ead83dfa81723729037b79945",
    spotify: "0CArUY1cbkLW7dSVc8WNLW",
    genre: "psychobilly",
    popularity: "11",
  },
  {
    name: "Mark Blomsteel",
    image: "https://i.scdn.co/image/d968aa21fb56234b75519ff211853d97504c5f0a",
    spotify: "6Fqe2k9vqvUdrSha9wTgXk",
    genre: "",
    popularity: "11",
  },
  {
    name: "Second Woman",
    image: "https://i.scdn.co/image/4e07b6249a5f1b71946c04a0dd1df65e822a5d62",
    spotify: "56limjBRDYQGaBEWLRR72e",
    genre: "mandible",
    popularity: "11",
  },
  {
    name: "Protocol",
    image: "https://i.scdn.co/image/ab67616d0000b27343b95ea3ac60f03517d50bc9",
    spotify: "4TTiDgzYcF30psiJAcB01f",
    genre: "",
    popularity: "11",
  },
  {
    name: "Rino Cerrone",
    image: "https://i.scdn.co/image/b1ffdcce1ff2feb0dae2e0dad3b931f4cc414bd7",
    spotify: "740hOYn1FckwKa5dkuXVdF",
    genre: "",
    popularity: "11",
  },
  {
    name: "Miss Jay",
    image: "",
    spotify: "1IU4hPWrwgn5oJlSNDmL7Y",
    genre: "",
    popularity: "11",
  },
  {
    name: "Gaetano Parisio",
    image: "https://i.scdn.co/image/590ba7501ba7b7aa94f43d4ea859fd1ee3233d9f",
    spotify: "7hE7qgK3cWbO7PbWG32elv",
    genre: "",
    popularity: "11",
  },
  {
    name: "Mindspitter",
    image: "https://i.scdn.co/image/ab67616d0000b273172d38c0838aa392d9b05223",
    spotify: "5zg1yJ5tXluoiwqqQhvLhW",
    genre: "uptempo hardcore",
    popularity: "11",
  },
  {
    name: "Kasai Allstars",
    image: "https://i.scdn.co/image/4fe5bb6467479579c0878815d6fce6146fe1425e",
    spotify: "391GEzsFayFVG5aGEBkrtq",
    genre: "",
    popularity: "11",
  },
  {
    name: "MC Boogshe",
    image: "",
    spotify: "20WTYXc6wDH4TQjKMBZbJ5",
    genre: "",
    popularity: "10",
  },
  {
    name: "E-Craig",
    image: "https://i.scdn.co/image/ab67616d0000b273cebe59cce5a6743861d4909f",
    spotify: "1HHZ9b1hV9xzFd4vjVO83s",
    genre: "",
    popularity: "10",
  },
  {
    name: "Charlotte Bendiks",
    image: "https://i.scdn.co/image/ab67616d0000b2735422edf3f82e990c5ee9dc10",
    spotify: "7mhANPWuF7hzuNZ6OVFbN8",
    genre: "",
    popularity: "10",
  },
  {
    name: "Solid Blake",
    image: "https://i.scdn.co/image/ab67616d0000b273aed8edb6aec969aab870f3b7",
    spotify: "7HUuzFIFu1CIESXaklBXyo",
    genre: "danish techno,experimental techno",
    popularity: "10",
  },
  {
    name: "Pablo Discobar Soundsystem",
    image: "https://i.scdn.co/image/d13512d79e7740a4420cc59963e12a6138ab77ef",
    spotify: "3Lxgi5ai1JXsQdaDczypcq",
    genre: "",
    popularity: "10",
  },
  {
    name: "DJ Yolotanker",
    image: "https://i.scdn.co/image/ab67616d0000b27318717e47a4f4585a09f17c27",
    spotify: "2B4iKosCUY380YgyeSOwNx",
    genre: "",
    popularity: "10",
  },
  {
    name: "Silvia Kastel",
    image: "https://i.scdn.co/image/d8f991d6c374e2a559241751a04c37bb796bb4af",
    spotify: "6h8tDxYF3MIhKQfqVD82e4",
    genre: "electra,italian experimental",
    popularity: "10",
  },
  {
    name: "T-99",
    image: "https://i.scdn.co/image/e9039cb69ef06c3599086cc616a0ce1d7684acce",
    spotify: "4gyAjRYdyX6OLEoNv6H8e6",
    genre: "dutch blues",
    popularity: "10",
  },
  {
    name: "AMONG LYNX",
    image: "https://i.scdn.co/image/06b0671a76be658ab57f7363a785cb533cbdd404",
    spotify: "5fib0YWb44SaGAQeFroJsu",
    genre: "swedish blues",
    popularity: "10",
  },
  {
    name: "The Jerry Hormone Ego Trip",
    image: "https://i.scdn.co/image/0a8d961aa00db3c9bce83c585a76ca6e5213831c",
    spotify: "10OEfjFFnZPqL3KJvr2SFI",
    genre: "rotterdam indie",
    popularity: "10",
  },
  {
    name: "Jerry Leger",
    image: "https://i.scdn.co/image/30ab040ace21629982b9ea47e39843182bf92078",
    spotify: "3GtHH5i1nt9Bb3dr39l4ac",
    genre: "canadian americana,canadian singer-songwriter",
    popularity: "10",
  },
  {
    name: "Drunken Dolly",
    image: "https://i.scdn.co/image/7ddecf46cc47719e994d6fb20bb75e7973bebec1",
    spotify: "6tcb5d5zGoUpXx78j672Fo",
    genre: "celtic punk",
    popularity: "10",
  },
  {
    name: "Kasra V",
    image: "https://i.scdn.co/image/6f7f8a4c37226288cf3fe33a1f592f1159d88fe3",
    spotify: "2OXe3kjSCSigi7rcy6R6lz",
    genre: "",
    popularity: "10",
  },
  {
    name: "Jeff Rushin",
    image: "https://i.scdn.co/image/ab67616d0000b273869a9e0b55189c1f99d29d17",
    spotify: "1EHqfcx3JKMRmrFfWT5qPm",
    genre: "dark techno",
    popularity: "10",
  },
  {
    name: "Bjäran",
    image: "https://i.scdn.co/image/74e17d4448895633df08d9534e55ae56d9ea2cab",
    spotify: "0oGSDz5EC6F1fQpGWTBamu",
    genre: "folkmusik,nordic folk",
    popularity: "10",
  },
  {
    name: "AAPNOOTMIES",
    image: "https://i.scdn.co/image/1c3c638d4c12d7b8f6e608051708487a0b866726",
    spotify: "1YSKaQWXsX9w13ky4K5ckD",
    genre: "",
    popularity: "10",
  },
  {
    name: "Dj. Flugvél Og Geimskip",
    image: "https://i.scdn.co/image/44f61d07978101213df2b6a5648cf76854780486",
    spotify: "1o2bSYi5f5sNMAzxwjvwol",
    genre: "icelandic electronic,icelandic indie",
    popularity: "10",
  },
  {
    name: "Lawrence Le Doux",
    image: "https://i.scdn.co/image/ab67616d0000b273135e7ecc131c6e6b3269c99f",
    spotify: "5As9k4aeJ897xlMRrFp8mE",
    genre: "ambient house",
    popularity: "10",
  },
  {
    name: "Metrist",
    image: "https://i.scdn.co/image/94b125074430168324d8851768f12755c084be0a",
    spotify: "2EaMCfkZ07OvRk0w2UOEwg",
    genre: "uk experimental electronic",
    popularity: "10",
  },
  {
    name: "Sound Freakerz",
    image: "https://i.scdn.co/image/ab67616d0000b27385254313e2490ec921d62bc7",
    spotify: "2bmYP2vyxmdtxePTYg4bLu",
    genre: "",
    popularity: "10",
  },
  {
    name: "CAPSLOCKED",
    image: "https://i.scdn.co/image/ddae5e4197a62b07e94a77e1ded5ca757cffd36a",
    spotify: "4ypQkCZ84GYsc6QRgorYuX",
    genre: "",
    popularity: "10",
  },
  {
    name: "The Cosmic Carnival",
    image: "https://i.scdn.co/image/041cc3ecac8abe1bcac7ef90e56846b7c8a1c90b",
    spotify: "4yGrtaop5Hq5hfRoM3ps8h",
    genre: "dutch americana,dutch indie,rotterdam indie",
    popularity: "10",
  },
  {
    name: "Stefan Vincent",
    image: "https://i.scdn.co/image/ab67616d0000b2738886e9de66c02c255938b348",
    spotify: "1eECz0KFN2y4LI30Eh2xWx",
    genre: "",
    popularity: "10",
  },
  {
    name: "Dave Replay",
    image: "https://i.scdn.co/image/382e751bcfca1d3e3ed492328dc6bf8bae2bc9a9",
    spotify: "5Q8SQMqaQ7raho7aFFj4Mq",
    genre: "",
    popularity: "10",
  },
  {
    name: "Joren Edwards",
    image: "https://i.scdn.co/image/e55c7b4d53772328a46f45decf9b02d66ee5a59e",
    spotify: "3fi8JZsByWFPzBU2gw1zZV",
    genre: "",
    popularity: "10",
  },
  {
    name: "Marutyri",
    image: "https://i.scdn.co/image/dff00c5cc66af244597d6163bc11ebd431525a13",
    spotify: "2SoKrTVqDoyPGOZLoejWCF",
    genre: "",
    popularity: "10",
  },
  {
    name: "Axel Haube",
    image: "https://i.scdn.co/image/d517d85bed36a1f124d03f38b554d297ae4968ab",
    spotify: "750ED9zAnM0KrRgcPpe4r4",
    genre: "",
    popularity: "10",
  },
  {
    name: "natural/electronic.system.",
    image: "https://i.scdn.co/image/ab67616d0000b2736293b933be5e84bb553a32a2",
    spotify: "1OPIJARZlZgVsokh4aVz1S",
    genre: "",
    popularity: "10",
  },
  {
    name: "Konrad Black",
    image: "https://i.scdn.co/image/c414379b37036fab4863b120104f9ef023b34977",
    spotify: "0U6IDk2laxjdSZla9In5v1",
    genre: "canadian house",
    popularity: "10",
  },
  {
    name: "Mystery Affair",
    image: "https://i.scdn.co/image/ab67616d0000b273e7f39ea17125b4add523a16b",
    spotify: "7uC8zxltPgrwtEqWRWwHFv",
    genre: "",
    popularity: "10",
  },
  {
    name: "Phantom/Ghost",
    image: "https://i.scdn.co/image/ab67616d0000b27375b42618fcf06aa3bac2ddb0",
    spotify: "5grqGXJzsEbAf9wuY6eQNy",
    genre: "german indie",
    popularity: "10",
  },
  {
    name: "Electric Pulse",
    image: "https://i.scdn.co/image/ab67616d0000b273521d21ce9e78696052eebfa4",
    spotify: "6ElHP5xW1Gq9jtZvX6fPG0",
    genre: "deep progressive trance",
    popularity: "10",
  },
  {
    name: "Wetware",
    image: "https://i.scdn.co/image/6d5a6babf6a659fa6a34eea7033cbdb182a9f359",
    spotify: "0Lo0R8BfNuOygvnqa48uYG",
    genre: "minimal synth",
    popularity: "10",
  },
  {
    name: "Arno Stolz",
    image: "https://i.scdn.co/image/ab67616d0000b2738cf5cee6e1e68b016874cabd",
    spotify: "5OavtU3WuOUoPAOU6LbLfe",
    genre: "belgian techno",
    popularity: "10",
  },
  {
    name: "Van Dalen",
    image: "https://i.scdn.co/image/ab67616d0000b273753126e4d44d9f66c36db75a",
    spotify: "1i6FKazZ9bYMnWNh5xDuge",
    genre: "",
    popularity: "10",
  },
  {
    name: "Deer Jade",
    image: "https://i.scdn.co/image/817acd6507346bbb9bf8cdc23911ab765fc7afad",
    spotify: "0QJ6lXlYOHexjfIg4CQrgv",
    genre: "",
    popularity: "10",
  },
  {
    name: "Fehler Kuti",
    image: "https://i.scdn.co/image/ab67616d0000b2734f77152b187d482e0380d473",
    spotify: "4Atk4tGFbnI1Rm6RHSlQFZ",
    genre: "",
    popularity: "10",
  },
  {
    name: "Hilbrandt",
    image: "https://i.scdn.co/image/f458d9f080bdb55890bdb893cc0e375fd28624a9",
    spotify: "4CHdj9ENl2KpDHEyEIkyMW",
    genre: "",
    popularity: "10",
  },
  {
    name: "Skyentist",
    image: "https://i.scdn.co/image/c179b1433925e83660c0895c4a494bebda88ba61",
    spotify: "1qtiEyAmKyblkv9okHrz4D",
    genre: "",
    popularity: "10",
  },
  {
    name: "Endseeker",
    image: "https://i.scdn.co/image/7e350298feadafbcd8842463e0014a5640324b9e",
    spotify: "5RLz3WPD2aQh4DP3l7WwLm",
    genre: "german death metal",
    popularity: "10",
  },
  {
    name: "Pedrodollar",
    image: "https://i.scdn.co/image/ab67616d0000b2730dc5614deb4fd84e5fcde372",
    spotify: "0FKAGseHQptVXGZskA8zT0",
    genre: "swedish house",
    popularity: "10",
  },
  {
    name: "Kasper van Kooten",
    image: "https://i.scdn.co/image/ab67616d0000b2733be706d620bb9dce0d53f7a2",
    spotify: "2UdPnhxD5ql2ZQljgUerSj",
    genre: "",
    popularity: "9",
  },
  {
    name: "Markus Fix",
    image: "https://i.scdn.co/image/830b2e574c01a563d94b7c101a85514c203ef42f",
    spotify: "1SJfSLVMU04FYaxHIPowyu",
    genre: "frankfurt electronic,minimal tech house",
    popularity: "9",
  },
  {
    name: "Valesuchi",
    image: "https://i.scdn.co/image/57c92f2460173a1c42a25c24021d978b3810d4a8",
    spotify: "20lLQVCg1N2fCUB7fEg46b",
    genre: "electra,electronica chilena,latintronica",
    popularity: "9",
  },
  {
    name: "Orgel Vreten",
    image: "https://i.scdn.co/image/20f5d08330f167dfca898e4c5553e7413ce534a0",
    spotify: "6YtSDTIvCWVTBWYZuWsDr1",
    genre: "dutch indie",
    popularity: "9",
  },
  {
    name: "Bonaventure",
    image: "https://i.scdn.co/image/57fa576765a155a451b5e4369a24f0d8ff5dac17",
    spotify: "2vVZm24A9XPtXcpaV5nB7K",
    genre: "experimental electronic",
    popularity: "9",
  },
  {
    name: "Miss Hysteria",
    image: "https://i.scdn.co/image/ab67616d0000b273fed880bbe797547751c5d1b9",
    spotify: "429OEtZSORLIdTnbeg8Pwu",
    genre: "dark hardcore,industrial hardcore",
    popularity: "9",
  },
  {
    name: "Stefan Pop",
    image: "https://i.scdn.co/image/ab67616d0000b27333a5bb9196b4af6b948d7fc3",
    spotify: "3Mwyh3T1qtWXUvJY3ZoFUJ",
    genre: "",
    popularity: "9",
  },
  {
    name: "Tijana T",
    image: "",
    spotify: "20WHdc6r6uJC2vtHNqGTGQ",
    genre: "serbian electronic",
    popularity: "9",
  },
  {
    name: "Baer Traa",
    image: "https://i.scdn.co/image/919dc9e133e4d740dc30842b4591184ea72c6690",
    spotify: "770rlC0qChwv8pIKeJdZgW",
    genre: "rotterdam indie",
    popularity: "9",
  },
  {
    name: "MC ID",
    image: "",
    spotify: "71p78rJ0sEwTMlNjqln74R",
    genre: "",
    popularity: "9",
  },
  {
    name: "Code: Pandorum",
    image: "",
    spotify: "6Rh4V1tv1h5nqCVW3yxz5K",
    genre: "",
    popularity: "9",
  },
  {
    name: "Dieter van der Westen",
    image: "https://i.scdn.co/image/4b926e90672523a79ec310e120d1b766ccac603b",
    spotify: "7jzZUwHIipUuNN5sw3Tlnt",
    genre: "dutch americana",
    popularity: "9",
  },
  {
    name: "Face Tomorrow",
    image: "https://i.scdn.co/image/ab67616d0000b2732c7f27d9a68df883404e47bd",
    spotify: "3Ukagkp2AycBy3FsIJ2eCW",
    genre: "rotterdam indie",
    popularity: "9",
  },
  {
    name: "Armageddon Project",
    image: "https://i.scdn.co/image/ab67616d0000b2732dd26604fa712f1530bc3f0a",
    spotify: "4lC83cidpLMZw1KbJqwY6h",
    genre: "doomcore,gabba,hardcore techno,industrial hardcore,speedcore",
    popularity: "9",
  },
  {
    name: "Karim Soliman",
    image: "https://i.scdn.co/image/8f755e2503cf745e5d106b2c839343c26f9d9213",
    spotify: "1MOT23Q8M3ijxPZBDCXrAM",
    genre: "",
    popularity: "9",
  },
  {
    name: "Het Klokhuis",
    image: "https://i.scdn.co/image/c4eb77df93e47d78e4995fff63965b47c5bd8bc2",
    spotify: "0eC8p0NZO7I3myDdn57JFV",
    genre: "",
    popularity: "9",
  },
  {
    name: "Opal Sunn",
    image: "https://i.scdn.co/image/ab67616d0000b2739abc6bef484d1c99335de8f4",
    spotify: "78S74FaXeZ5e7JyMF8Axok",
    genre: "acid techno",
    popularity: "9",
  },
  {
    name: "Chupame El Dedo",
    image: "https://i.scdn.co/image/ab67616d0000b273128f7d444f867fe08a05ed48",
    spotify: "4xuTb7SFiVkESJFuxFk9Qb",
    genre: "",
    popularity: "9",
  },
  {
    name: "Pixvae",
    image: "https://i.scdn.co/image/ab67616d0000b2737908d8c16c7fc66fbe2380e6",
    spotify: "7hUsGcgfTPjKRvb4jXD8P1",
    genre: "",
    popularity: "9",
  },
  {
    name: "Antoine Henaut",
    image: "https://i.scdn.co/image/62fb1b8a741f35cdcc30c210e659c5b556ef5727",
    spotify: "4lKhzEse8TkJBrYBjxWvsk",
    genre: "belgian pop",
    popularity: "9",
  },
  {
    name: "Human Abfall",
    image: "https://i.scdn.co/image/ab67616d0000b2738bf789c4e4938401115bbcd5",
    spotify: "0kitZ7xwIhWMpg9dGZRuni",
    genre: "german post-punk,stuttgart indie",
    popularity: "9",
  },
  {
    name: "Stolen Cult",
    image: "https://i.scdn.co/image/d8236e83c674ca60a7a61fa34b4b21cc58858f2d",
    spotify: "0J8W9wOTBYJiMIAv1wMg9f",
    genre: "doomcore",
    popularity: "9",
  },
  {
    name: "Joop Junior",
    image: "https://i.scdn.co/image/e1ea3a377dfa4b26f4f22eefdde143047728f293",
    spotify: "60yWE69EdDZcvFMISjN2ek",
    genre: "",
    popularity: "9",
  },
  {
    name: "Skinnerbox",
    image: "https://i.scdn.co/image/9b0df4bb82235f57d021d92e68bbc23fd617d250",
    spotify: "3Xcves4cRUVjBauOkiuKQ2",
    genre: "",
    popularity: "9",
  },
  {
    name: "Arthur Lewis",
    image: "https://i.scdn.co/image/ab67616d0000b273f73fc903620c8538d3fedb34",
    spotify: "6EUKLm1g1mJrK2tqfoaEbX",
    genre: "",
    popularity: "9",
  },
  {
    name: "Jesse Porsches",
    image: "https://i.scdn.co/image/e1bb4a4ce5d0d5281f6711f05976bf568f60dbd9",
    spotify: "6IC5AtPI0VNNCnD41s9bT9",
    genre: "aussietronica",
    popularity: "9",
  },
  {
    name: "Toko Telo",
    image: "https://i.scdn.co/image/ab67616d0000b2730a51a2040e6dd15cee9f0421",
    spotify: "3IGPw0OoQumBHFwCkUe1HL",
    genre: "malagasy folk",
    popularity: "9",
  },
  {
    name: "Gunnter",
    image: "https://i.scdn.co/image/43d37cd30390f5a04cb6721459c9d13cc40f9a48",
    spotify: "4aisVJjJjJWbTJZ9cS0KqY",
    genre: "",
    popularity: "9",
  },
  {
    name: "Rude Awakening",
    image: "https://i.scdn.co/image/ab67616d0000b273d4671ac333026327f001ebe5",
    spotify: "7LO0yO4IUG4qwCHiEhXVbQ",
    genre: "industrial hardcore",
    popularity: "9",
  },
  {
    name: "Gabriella Vergilov",
    image: "https://i.scdn.co/image/ab67616d0000b273dae816f8e7e04d5325c431d5",
    spotify: "5WVz5iRPXwCdoKvVxP6xCQ",
    genre: "",
    popularity: "9",
  },
  {
    name: "Belle Adair",
    image: "https://i.scdn.co/image/a36b7003207f8c5a4f51f1b88ef208e9604d07af",
    spotify: "43iDWCN5om0tDMAVplGTaV",
    genre: "alabama indie",
    popularity: "9",
  },
  {
    name: "Jerry Green",
    image: "https://i.scdn.co/image/ab67616d0000b273c8a84b87f536d97531658442",
    spotify: "1sFGb0hp6ydOcCN9fZaNHM",
    genre: "",
    popularity: "9",
  },
  {
    name: "Illegal Brother",
    image: "https://i.scdn.co/image/ab67616d0000b2733e99c2587350f73a5ffe9ab6",
    spotify: "50SUUOSVJrnpcyQovugCYo",
    genre: "",
    popularity: "9",
  },
  {
    name: "MIRA MIRA",
    image: "https://i.scdn.co/image/3ff62e116df1f8e5de2ac4671d0f84b34ccd8436",
    spotify: "5D0GfztMpGYTNbcN27pbGC",
    genre: "",
    popularity: "9",
  },
  {
    name: "Potman Jr.",
    image: "https://i.scdn.co/image/ab67616d0000b273379e22eefced19a5b1fdec1f",
    spotify: "1YEIrR3dKJhxGk9X6DHDvC",
    genre: "",
    popularity: "9",
  },
  {
    name: "Maayan Nidam",
    image: "https://i.scdn.co/image/ab67616d0000b273629500db9fcfa8280902ff94",
    spotify: "6RgNknO2rRfZZzliaq3lxR",
    genre: "",
    popularity: "9",
  },
  {
    name: "Billy Cross",
    image: "https://i.scdn.co/image/ab67616d0000b2737fd03a56c653fab1d97b2971",
    spotify: "1qbNqOWBmjfCXdJxERlvGe",
    genre: "",
    popularity: "9",
  },
  {
    name: "Chris Imler",
    image: "https://i.scdn.co/image/ab67616d0000b27336019364eeae62e8d6039fde",
    spotify: "46UqEw2cEH1SHxSBuSWfVw",
    genre: "german electronica",
    popularity: "9",
  },
  {
    name: "Klitclique",
    image: "https://i.scdn.co/image/ab67616d0000b2733b462d38fac0a25e2c29afb5",
    spotify: "6Lb7wdZn37YOoZpPMt1nde",
    genre: "austrian indie",
    popularity: "9",
  },
  {
    name: "Margaret Dygas",
    image: "https://i.scdn.co/image/1b8e16dfc962e12314e9e02da9d385c48299b741",
    spotify: "6GnLE3Ncm59wsLSqF9divg",
    genre: "",
    popularity: "9",
  },
  {
    name: "Luna Zegers",
    image: "https://i.scdn.co/image/ab67616d0000b273329a64f57542bec92c1cca65",
    spotify: "2CGjLOUiSMA7BJkdwozzEG",
    genre: "",
    popularity: "9",
  },
  {
    name: "Simon Garcia",
    image: "https://i.scdn.co/image/ab67616d0000b27388fccf5db4902f6902b91cf5",
    spotify: "2D39ZwobzkKsPyiYefJ9cd",
    genre: "",
    popularity: "9",
  },
  {
    name: "Alberto Pascual",
    image: "https://i.scdn.co/image/ab67616d0000b2732fc3344f0cab568e72de2bb2",
    spotify: "7AKaUwWfEUdshVv5RFnW2f",
    genre: "deep minimal techno",
    popularity: "9",
  },
  {
    name: "Bob Fosko",
    image: "https://i.scdn.co/image/ab67616d0000b2738d14604bf68c40097b928d55",
    spotify: "4FBvFv5jDOL3hnMnlt3ohX",
    genre: "",
    popularity: "9",
  },
  {
    name: "Dean Owens",
    image: "https://i.scdn.co/image/4a0f3365cfd59615833a2666b74f71d81a0d0660",
    spotify: "7BVMp7zWud1AgHosWacOVl",
    genre: "scottish americana,uk americana",
    popularity: "9",
  },
  {
    name: "Spaceandtime",
    image: "https://i.scdn.co/image/ab67616d0000b273794438fc6b0b576c6c634419",
    spotify: "1oiHYWl6uH8aKLe5Mrz6uP",
    genre: "",
    popularity: "8",
  },
  {
    name: "Rauwkost",
    image: "https://i.scdn.co/image/ab67616d0000b27319461efab98767689af322ac",
    spotify: "0slCaCuP8BE7jAcsAUx8vU",
    genre: "",
    popularity: "8",
  },
  {
    name: "Dennis van der Geest",
    image: "https://i.scdn.co/image/ab67616d0000b273a1fa4db0b1db5d4769df248b",
    spotify: "4NLEdWDi0LpotRDZEPp23o",
    genre: "",
    popularity: "8",
  },
  {
    name: "Yip Roc",
    image: "https://i.scdn.co/image/aa91e79dcd4550d829c2327a7b6fd6bbb6123f56",
    spotify: "5mgMlyl2Z2c50mLyWumwan",
    genre: "dutch indie rock",
    popularity: "8",
  },
  {
    name: "Tijl Beckand",
    image: "https://i.scdn.co/image/ab67616d0000b2737aa08a74843df87d3e444f1c",
    spotify: "2d3f1StpWXP0aCFfaLs2Qp",
    genre: "",
    popularity: "8",
  },
  {
    name: "Flapjackers",
    image: "https://i.scdn.co/image/ab67616d0000b273086d414c548d5fbba05dd878",
    spotify: "4JsJTJzHRrGK74Q8hMLdDB",
    genre: "",
    popularity: "8",
  },
  {
    name: "Remento",
    image: "https://i.scdn.co/image/8b6617aa3a930ab324443141acd40bc67f2ba9cb",
    spotify: "3euvqTrVBFxWcrzYR1QETG",
    genre: "",
    popularity: "8",
  },
  {
    name: "Ruben Vitalis",
    image: "https://i.scdn.co/image/ea5dd4e25d60b7b17313994cd764204ce9d7f2c6",
    spotify: "5HrXqg20qExQu9zkkdPNXu",
    genre: "",
    popularity: "8",
  },
  {
    name: "Sara Ajnnak",
    image: "https://i.scdn.co/image/ab67616d0000b2733b35f1fe7baa98dc7127da3a",
    spotify: "3aaWWlry6ZiMXZxHKSLfa6",
    genre: "sami",
    popularity: "8",
  },
  {
    name: "Serena Butler",
    image: "https://i.scdn.co/image/ab67616d0000b273dcbb8cd88d0d066f2581912a",
    spotify: "6aUGngzJHaXMRleRbs4rxL",
    genre: "ambient techno",
    popularity: "8",
  },
  {
    name: "Steve Duda",
    image: "",
    spotify: "2Xnj7sQ4aE5olUmYQV0QFU",
    genre: "",
    popularity: "8",
  },
  {
    name: "Geluk",
    image: "https://i.scdn.co/image/d94d4301eb084d4c7f03c0fb94392389d6343089",
    spotify: "0JWVbjAuXn2cxromAINYUp",
    genre: "",
    popularity: "8",
  },
  {
    name: "NEMSIS",
    image: "https://i.scdn.co/image/efb491fe14ad82568dd349189ec5c3c0020207b8",
    spotify: "3MPnL7QqlX6t93o5fSme1y",
    genre: "dutch indie rock",
    popularity: "8",
  },
  {
    name: "The Tambles",
    image: "https://i.scdn.co/image/74576f301a50de1924c2dca6ce8b07a7ad0e6512",
    spotify: "4992V7oi0D7PxPKnyDAOYn",
    genre: "",
    popularity: "8",
  },
  {
    name: "Soldiers Of Core",
    image: "https://i.scdn.co/image/366f3ec3ca2c63a85af3f30517f40b0c3ed8c70a",
    spotify: "7wmk4pht9nSBJqgr9lLWo1",
    genre: "uptempo hardcore",
    popularity: "8",
  },
  {
    name: "Cynbel",
    image: "https://i.scdn.co/image/1aa994b1bc6cc9e694f961aecec8754d0d68059a",
    spotify: "2pgrpVJvF7jzdQBdaCdXVn",
    genre: "",
    popularity: "8",
  },
  {
    name: "Miraculous Mule",
    image: "https://i.scdn.co/image/ab67616d0000b273c33a4c91bcb3d81352661b02",
    spotify: "0gCceUhEHn81sIBxwjbGcf",
    genre: "",
    popularity: "8",
  },
  {
    name: "Dorian Gray",
    image: "https://i.scdn.co/image/46a201abd1830f53565698602b4842221564fac9",
    spotify: "0xrUrvBlA5uGT5Sx0Zvg1N",
    genre: "yugoslav rock",
    popularity: "8",
  },
  {
    name: "DJ Vega",
    image: "https://i.scdn.co/image/ab67616d0000b27367c3b8457df804cc58344d6e",
    spotify: "2EAB1TCOZlkmlLGsVajszj",
    genre: "",
    popularity: "8",
  },
  {
    name: "Mike Boddé",
    image: "https://i.scdn.co/image/ab67616d0000b2739a03d5e01306198c850587e1",
    spotify: "3X9REqq5k3qBlsoSwVtgzy",
    genre: "",
    popularity: "8",
  },
  {
    name: "Vitellus",
    image: "https://i.scdn.co/image/f611322f136972b3438ce9467f54d82460740f00",
    spotify: "42UfIWi8fCYS27E9IvnKRe",
    genre: "",
    popularity: "8",
  },
  {
    name: "Robin Martens",
    image: "https://i.scdn.co/image/ac79908a008072d8f1c043a8c85a42bbdec79579",
    spotify: "0km14TPMpsNiqYeG9cREyJ",
    genre: "",
    popularity: "8",
  },
  {
    name: "Needles//Pins",
    image: "https://i.scdn.co/image/04d893b594f8df67433d44097f730c9a0009e379",
    spotify: "1tnM44ynEGnjg0wui9CwLC",
    genre: "vancouver indie,vancouver punk",
    popularity: "8",
  },
  {
    name: "Depaart",
    image: "https://i.scdn.co/image/46d774ec90206d4aee90daad13eca3302973e284",
    spotify: "3as0KqbGidcF0tsY2X0spP",
    genre: "",
    popularity: "8",
  },
  {
    name: "Bry Ortega",
    image: "https://i.scdn.co/image/641274fce4fc4d3454db362d6449a6c117f0b35d",
    spotify: "5MRqoHzAC5aRXIRdMkKPbu",
    genre: "",
    popularity: "8",
  },
  {
    name: "The Black Marble Selection",
    image: "https://i.scdn.co/image/ef20a01059bf0898570c30ffba9a85d568bfe4ea",
    spotify: "3q139I3bj82Y78FYccXfws",
    genre: "dutch indie",
    popularity: "8",
  },
  {
    name: "NoizBoiz",
    image: "https://i.scdn.co/image/e525e98f09d978baa7a6910218d59c7b3f085fac",
    spotify: "4UN9sEXh7q4VOg8MLV9hJ6",
    genre: "dutch underground hip hop",
    popularity: "8",
  },
  {
    name: "Kliffs",
    image: "https://i.scdn.co/image/ab67616d0000b2738607941ac436bcfae40895ac",
    spotify: "3SUCYwCglnvQ1kTaYb3vMS",
    genre: "chamber folk",
    popularity: "8",
  },
  {
    name: "Fat Suit",
    image: "https://i.scdn.co/image/ac7dee21e61623a0a6814412515d14e4097770e6",
    spotify: "3MtamCeFaUTUiU1oymsLft",
    genre: "scottish jazz",
    popularity: "8",
  },
  {
    name: "Jan Vervloet",
    image: "https://i.scdn.co/image/ab67616d0000b2731d1695aee1f47e948bd03a06",
    spotify: "3Wh3NNmiXQb6KzLRWiS8Ps",
    genre: "",
    popularity: "8",
  },
  {
    name: "Soul Sister Dance Revolution",
    image: "https://i.scdn.co/image/ab67616d0000b2737091e8e252405438ca9e2d70",
    spotify: "5sg1IE1k4HJj0WqhQgaFd8",
    genre: "",
    popularity: "8",
  },
  {
    name: "Monolithe Noir",
    image: "https://i.scdn.co/image/7fd581b28361863815b675b84ef894b93fae0241",
    spotify: "2Ne3z7tFrppSwvjE1lsVER",
    genre: "",
    popularity: "8",
  },
  {
    name: "Ron Morelli",
    image: "https://i.scdn.co/image/2ca5cb6631a6a5637ec4535b9af333f5178c9834",
    spotify: "3l8tiiJagegHYKPqCdbnla",
    genre: "mandible,outsider house",
    popularity: "8",
  },
  {
    name: "Julian Perez",
    image: "https://i.scdn.co/image/91c24f5e74a79a92ba0a9e0df2d03f1d689bb64a",
    spotify: "2pMZw333AGGowD4t65HmuC",
    genre: "",
    popularity: "8",
  },
  {
    name: "DeeCoy",
    image: "https://i.scdn.co/image/ab67616d0000b2735969c3f5c94fb7eb821ec1be",
    spotify: "41XhplQeyIkFJ9zPyopG0u",
    genre: "",
    popularity: "8",
  },
  {
    name: "Holly Holden y Su Banda",
    image: "https://i.scdn.co/image/900d7e51e7f1dfdb18f5f5a16ffeac6cfc53d406",
    spotify: "2Ekm7kPxAZ0xVAhWAtVMkc",
    genre: "",
    popularity: "8",
  },
  {
    name: "BKO Quintet",
    image: "https://i.scdn.co/image/ab67616d0000b27314b23913d810322297e8df01",
    spotify: "2rvcky4JeLoH3cY7Qooc44",
    genre: "ngoni",
    popularity: "8",
  },
  {
    name: "Promised Land Sound",
    image: "https://i.scdn.co/image/7598b9ad1136788e7242ed423748c61edde0a7d9",
    spotify: "651Ri3WbmpfzVyA1Ip23Ls",
    genre: "nashville indie",
    popularity: "8",
  },
  {
    name: "Neon Chambers",
    image: "https://i.scdn.co/image/ab67616d0000b2736534523d9d655a1dfcf1abd2",
    spotify: "6F3h08u7QUo3NBwMqWgQeL",
    genre: "",
    popularity: "8",
  },
  {
    name: "Dodecahedron",
    image: "https://i.scdn.co/image/ab67616d0000b2739851b92c409e9d3fa96570d5",
    spotify: "34VHNi4n6j5eDDUdCvB5LB",
    genre: "",
    popularity: "8",
  },
  {
    name: "Robbing Millions",
    image: "https://i.scdn.co/image/27d62914d2aad3cc3312ef141365dc7e802c0b47",
    spotify: "7eTkzoRsUAtKPQzvofAD0G",
    genre: "",
    popularity: "8",
  },
  {
    name: "Fifty Foot Combo",
    image: "https://i.scdn.co/image/ab67616d0000b2738419242ace3f590db3631294",
    spotify: "7GFb7bUQ3uRHOCyGKuqUFD",
    genre: "surf music",
    popularity: "8",
  },
  {
    name: "Eat The Gun",
    image: "https://i.scdn.co/image/8f1827afdca5ec087a010afd083f541b3d8b4b74",
    spotify: "1AzKZcX4D4T17QzioaYTEY",
    genre: "",
    popularity: "8",
  },
  {
    name: "The Beatophonics",
    image: "https://i.scdn.co/image/fe01df23b7635d5c6498adf4947d677180d3d393",
    spotify: "5W05FY5rERtVTBippPjold",
    genre: "",
    popularity: "8",
  },
  {
    name: "Yuli Fershtat",
    image: "https://i.scdn.co/image/f03efa62edd0c374213aa6e5d9ad1584d55f4d8a",
    spotify: "2PizYX0ZXHaSb1msg7PGaw",
    genre: "",
    popularity: "8",
  },
  {
    name: "Dieuf-Dieul De Thies",
    image: "https://i.scdn.co/image/ab67616d0000b273a7380c5c28cef66514cda7ac",
    spotify: "1lQN0WWaqGiqWvaYdCK0sx",
    genre: "",
    popularity: "8",
  },
  {
    name: "The Baghdaddies",
    image: "https://i.scdn.co/image/ab67616d0000b273f9177d120ba665de7788a1a1",
    spotify: "31VvD4fBsqHZ1n2mDy8BtM",
    genre: "gypsy fusion,newcastle indie",
    popularity: "8",
  },
  {
    name: "Distant Echoes",
    image: "https://i.scdn.co/image/5ef8c2978a205271abe60ed066dbfccaea5b5b28",
    spotify: "7nN1DGC0uA1bvDkDBdabt3",
    genre: "italian techno",
    popularity: "8",
  },
  {
    name: "Herr Vogel",
    image: "https://i.scdn.co/image/8771e99dea6d23be1598df120f501a17bbd37e35",
    spotify: "1fjWZq8LJHumtNwZXAnYrs",
    genre: "",
    popularity: "8",
  },
  {
    name: "Arin Tone",
    image: "https://i.scdn.co/image/ab67616d0000b2739bfa1ffe5244275a0d316a63",
    spotify: "5zpOQrzNaX0lqyt7TAvgIK",
    genre: "",
    popularity: "8",
  },
  {
    name: "Tony Cha Cha",
    image: "https://i.scdn.co/image/ab67616d0000b273a788a95d060f6f547c718d06",
    spotify: "7pjaO116ihyHDTB73wc4U0",
    genre: "",
    popularity: "7",
  },
  {
    name: "Dorian Paic",
    image: "https://i.scdn.co/image/ab67616d0000b2737e8ed3c807b6cad8c1f07352",
    spotify: "2ZvGO9toLWz2vnlx2blcKf",
    genre: "",
    popularity: "7",
  },
  {
    name: "Job Sifre",
    image: "https://i.scdn.co/image/03ebee10a8dfc4951e59bf76cbceffa0f91b8918",
    spotify: "1TEUF3vJN9MLk1Ka3uuliZ",
    genre: "dutch experimental electronic",
    popularity: "7",
  },
  {
    name: "Three Little Clouds",
    image: "https://i.scdn.co/image/806f6fe249595f0ef244773d587cbb8818f54d3b",
    spotify: "367IP9w86gKH70VnMC9evp",
    genre: "",
    popularity: "7",
  },
  {
    name: "Ana Helder",
    image: "https://i.scdn.co/image/ab67616d0000b2739f9fdfece84763052c59526a",
    spotify: "0Vuop7XBCBahKJzzdZ7DIc",
    genre: "house argentino",
    popularity: "7",
  },
  {
    name: "Rob Da Rhythm",
    image: "https://i.scdn.co/image/7185cf8f2311903e7485249a6d205219cb1d4bc4",
    spotify: "5fHA7YGF0wj3aAnHTzhzCC",
    genre: "uptempo hardcore",
    popularity: "7",
  },
  {
    name: "Remy Unger",
    image: "https://i.scdn.co/image/ab67616d0000b27308ea1e7c7c93da75e5fb3a22",
    spotify: "5fWjsegoe7zm3YyZE8UNtH",
    genre: "dutch tech house",
    popularity: "7",
  },
  {
    name: "Grand River",
    image: "https://i.scdn.co/image/e72861e1013612550a3b0c20e179bf7cba9c7c9d",
    spotify: "7HtrqYEdzfxQcGct9YBxAO",
    genre: "dutch experimental electronic,experimental electronic",
    popularity: "7",
  },
  {
    name: "Def Toys",
    image: "https://i.scdn.co/image/ab67616d0000b273581e4254c7037e1e0b10f0e0",
    spotify: "7th1m2fuJ5uXNLkOSONhYX",
    genre: "jumpstyle",
    popularity: "7",
  },
  {
    name: "Man With No Shadow",
    image: "https://i.scdn.co/image/ab67616d0000b273f63600ab153259df77dcec1e",
    spotify: "7qycFCG6LDzmd9v5lZY5rh",
    genre: "",
    popularity: "7",
  },
  {
    name: "Conjunto Papa Upa",
    image: "https://i.scdn.co/image/dae7f022b5cc2ed8eeb4860fb0633bc5bfab0765",
    spotify: "4vhCl6MBQvO7FZn1SScoNY",
    genre: "",
    popularity: "7",
  },
  {
    name: "Zwaan",
    image: "https://i.scdn.co/image/ab67616d0000b2739c5a0c64f6b1638a087320f4",
    spotify: "5CtCRVxR6G35Ccfdt4uoMl",
    genre: "",
    popularity: "7",
  },
  {
    name: "Sallyswag",
    image: "https://i.scdn.co/image/d0c21170edcfac54ecfe90b5e5d7a9d7c588b295",
    spotify: "7AnPRlNMrz9W4sq6qHNANB",
    genre: "",
    popularity: "7",
  },
  {
    name: "Apollonia",
    image: "https://i.scdn.co/image/4137faa4a14b94cadc3521b1ca2982b8f8db90d0",
    spotify: "3anL0yEu608Dg2YcVFLUZn",
    genre: "minneapolis sound",
    popularity: "7",
  },
  {
    name: "Maoupa Mazzocchetti",
    image: "https://i.scdn.co/image/ab67616d0000b273f3ff354bdef1b2c4a2a63b55",
    spotify: "2DRMyBNnQGATkVnoy3omna",
    genre: "experimental techno",
    popularity: "7",
  },
  {
    name: "Faradays",
    image: "https://i.scdn.co/image/fe322ddab7a71998557a0e5ae6eff86b757e546c",
    spotify: "7pY3f9cvVm9WNZNGJuohjD",
    genre: "",
    popularity: "7",
  },
  {
    name: "Reverend Deadeye",
    image: "https://i.scdn.co/image/ab67616d0000b27326f2efd7211fd4129c24bba4",
    spotify: "6tPMiI2ut8h9PBwI7TiJSG",
    genre: "garage punk blues",
    popularity: "7",
  },
  {
    name: "Wipneus & Pim",
    image: "https://i.scdn.co/image/ab67616d0000b2731e9d871231a999ddf53aee9e",
    spotify: "2oUdWFumc7UXNdLlLVPieh",
    genre: "",
    popularity: "7",
  },
  {
    name: "Russell Haswell",
    image: "https://i.scdn.co/image/6afefd8b219e88c70367f0a73ed9540a90a52ca9",
    spotify: "3XSqUNNz2pAokwCN3tZ51t",
    genre:
      "british experimental,glitch,mandible,sound art,uk experimental electronic",
    popularity: "7",
  },
  {
    name: "Ketiov",
    image: "https://i.scdn.co/image/554b9460fa74050acc092bcadea780ec8f5398aa",
    spotify: "1MVBKaOHeQDc4bt64MKyHR",
    genre: "",
    popularity: "7",
  },
  {
    name: "MDCIII",
    image: "https://i.scdn.co/image/ab67616d0000b273e3483da815a5c8f05b1c835c",
    spotify: "1zjbmsA3Mq02lYg0Bk0YCU",
    genre: "belgian modern jazz",
    popularity: "7",
  },
  {
    name: "RoulnDoors",
    image: "",
    spotify: "6Zk4epM815XM2zlp8FSNOo",
    genre: "",
    popularity: "7",
  },
  {
    name: "Albert van Abbe",
    image: "https://i.scdn.co/image/aec6ea0777ecab9e23d4ef3a1ebdedbf77ce18cd",
    spotify: "3R16KRF8LX0lMVd8Y23PCO",
    genre: "dutch experimental electronic",
    popularity: "7",
  },
  {
    name: "Neel Kolhatkar",
    image: "https://i.scdn.co/image/ab67616d0000b273069d472eac01197332948f85",
    spotify: "20ITLcUQHzIYRqnEDelFmh",
    genre: "",
    popularity: "7",
  },
  {
    name: "Teen Creeps",
    image: "https://i.scdn.co/image/ab67616d0000b2738a1704ac67774f42aa97dba0",
    spotify: "0btxVtYxoxRhw1qrx8FVhm",
    genre: "belgian indie,belgian indie rock",
    popularity: "7",
  },
  {
    name: "Phreaks of Visions",
    image: "https://i.scdn.co/image/ab67616d0000b273403b628d1587b00c81be5845",
    spotify: "2Bulr1sgI0PxKkltD1hM9d",
    genre: "",
    popularity: "7",
  },
  {
    name: "John Ghost",
    image: "https://i.scdn.co/image/bedd42c1c06824d13f15d05fbb1d1827e02a18f3",
    spotify: "25iP3ZTnO70UKswpiaigYH",
    genre: "belgian modern jazz",
    popularity: "7",
  },
  {
    name: "Fraasie",
    image: "",
    spotify: "5k8nK7KJJkIeWdCjpOFM98",
    genre: "",
    popularity: "7",
  },
  {
    name: "Naive Set",
    image: "https://i.scdn.co/image/da7568b19b1cdca1e9812bb3d0835fc30df8f1c9",
    spotify: "1SPS81Jo8TCGUCiQIEfLYh",
    genre: "dutch indie rock",
    popularity: "7",
  },
  {
    name: "Sofie Livebrant",
    image: "https://i.scdn.co/image/ab67616d0000b273b477910986081576167e3a39",
    spotify: "1W5oB1ITON4qnHnTuWJ8WP",
    genre: "",
    popularity: "7",
  },
  {
    name: "Lakuta",
    image: "https://i.scdn.co/image/ed981c036236c74cb65b47633a7b720156dc87d8",
    spotify: "3ZfvZ0DA9Iz63f1ILXval0",
    genre: "",
    popularity: "7",
  },
  {
    name: "Sigward",
    image: "https://i.scdn.co/image/ab67616d0000b27347a7e5e0163d0167ea2a13cf",
    spotify: "2r5aJTeDFo5H6Squzae1xT",
    genre: "",
    popularity: "7",
  },
  {
    name: "Mitch Rivers",
    image: "https://i.scdn.co/image/79de90cbb95d630ce916380cc490b63c7a1c810d",
    spotify: "60MGr6u8AF2SYwh7zRBV3K",
    genre: "dutch americana",
    popularity: "7",
  },
  {
    name: "Kristin Korb",
    image: "https://i.scdn.co/image/c59030037a92d5f0aeae3d13f8a43219cdf54c67",
    spotify: "4jCdkrPVAoqmEGFYboGKiN",
    genre: "",
    popularity: "7",
  },
  {
    name: "They Say Jump",
    image: "https://i.scdn.co/image/ab67616d0000b27332dacf9940f34356fafefcad",
    spotify: "4dNyRFsNkQImsAf4UJcLxO",
    genre: "",
    popularity: "7",
  },
  {
    name: "Dan Maarten",
    image: "https://i.scdn.co/image/ab67616d0000b273750f5624e2df2c27d488299f",
    spotify: "5eF2oI0TzQGmj6rKjzGCsC",
    genre: "deep tropical house",
    popularity: "7",
  },
  {
    name: "Judith Kiddo",
    image: "https://i.scdn.co/image/1464cac2fd9be71892b5e75736bb46a259d0e139",
    spotify: "0zmgqS8lHVypUSBvUogMgz",
    genre: "",
    popularity: "7",
  },
  {
    name: "John Noseda",
    image: "https://i.scdn.co/image/56e3aeee6c22da629a6755aa84691273c015d1bf",
    spotify: "1GHQDN0HXk1MVl7zyhqlXA",
    genre: "",
    popularity: "7",
  },
  {
    name: "Loudgarden",
    image: "https://i.scdn.co/image/2d91ab783f798087cec4bf392edbee8746c32b31",
    spotify: "6BRFQ18xx1GovYxeqN4I9S",
    genre: "",
    popularity: "7",
  },
  {
    name: "Ifriqiyya Electrique",
    image: "https://i.scdn.co/image/bcc0b266c1bbbcb5caba6ac62795f3f5d0f28aea",
    spotify: "5RNEjRUICLbYLpnwe2RCVg",
    genre: "african experimental",
    popularity: "7",
  },
  {
    name: "System Of Survival",
    image: "https://i.scdn.co/image/368f1ecef761e4af7a74341327b1fa35f43e853d",
    spotify: "6WRIhaYNZus4kIO4jSfvC6",
    genre: "",
    popularity: "7",
  },
  {
    name: "Shapednoise",
    image: "https://i.scdn.co/image/4c2d1d90ba550c5f3175525d49ef79ee95b92112",
    spotify: "18U1MCeHH1JAqRMHp3aPuv",
    genre:
      "deconstructed club,italian experimental,italian industrial,mandible,weightless",
    popularity: "7",
  },
  {
    name: "Octual",
    image: "https://i.scdn.co/image/ab67616d0000b273f97c4a831667fff60bdf817e",
    spotify: "2eFznNfn6XBO8GYhZcxsxY",
    genre: "",
    popularity: "7",
  },
  {
    name: "Guerilla Speakerz",
    image: "https://i.scdn.co/image/ab67616d0000b2731a42e4ac9c7432910eff671d",
    spotify: "5IZPI6EzhMDsGBINqbb4pN",
    genre: "",
    popularity: "7",
  },
  {
    name: "Charlène Darling",
    image: "https://i.scdn.co/image/ab67616d0000b273daccae7368425c45a396b037",
    spotify: "634e9JkTqLCsGmUQDua5mX",
    genre: "",
    popularity: "7",
  },
  {
    name: "Jess Conrad",
    image: "https://i.scdn.co/image/ab67616d0000b273dcb0584affe7a608cba81d20",
    spotify: "5MyiJcLPyyJlVKW9mSHIma",
    genre: "",
    popularity: "7",
  },
  {
    name: "Kabale und Liebe",
    image: "https://i.scdn.co/image/ab67616d0000b27374abc66da55f1af1d75bd23f",
    spotify: "2WTAv3J9W7ZsAUVqY3KpeD",
    genre: "minimal tech house",
    popularity: "7",
  },
  {
    name: "Tri State Corner",
    image: "https://i.scdn.co/image/ab67616d0000b273f3edc3d8444ffd8949666295",
    spotify: "2UDgleCqDJDgz3ZqZanz9u",
    genre: "",
    popularity: "7",
  },
  {
    name: "Eddie Richards",
    image: "https://i.scdn.co/image/ab67616d0000b27381286f481360ab88bf17d6a0",
    spotify: "5tHxPklMwMV5JZcSuOoNLM",
    genre: "uk house",
    popularity: "7",
  },
  {
    name: "Scalpture",
    image: "https://i.scdn.co/image/74a999dad1726b73e66d9e7f015bdeadab64a641",
    spotify: "24ayf6ObGs5kWru2VHRCjv",
    genre: "german death metal",
    popularity: "7",
  },
  {
    name: "Mamihlapinatapai",
    image: "https://i.scdn.co/image/c9bfa8d932e5e02a31161d2e9a38d6df4b88edbd",
    spotify: "04uUTwnXnmClA1mZnFAsOZ",
    genre: "",
    popularity: "7",
  },
  {
    name: "ASK:ME",
    image: "https://i.scdn.co/image/f7e7d4a6aee7946b18efb173104a5864b783600b",
    spotify: "39vA0tgkcBq6RYH8Nn4CzU",
    genre: "",
    popularity: "7",
  },
  {
    name: "Moon Tapes",
    image: "https://i.scdn.co/image/e3a1c7d3db1ba272c1909f08d517e13806b0b22c",
    spotify: "3ldcFTWtteD2ngFojH4acF",
    genre: "dutch indie",
    popularity: "7",
  },
  {
    name: "Bismuth",
    image: "https://i.scdn.co/image/ab67616d0000b273d4c1410cc26ecf76bfd9868b",
    spotify: "3YVXe4scnHrYPxhvmWVOOT",
    genre: "post-doom metal,uk doom metal",
    popularity: "7",
  },
  {
    name: "Project Exile",
    image: "https://i.scdn.co/image/ab67616d0000b273654fd848dd809728e1509143",
    spotify: "2sK3LeKSg12QnoIsRfLCEC",
    genre: "",
    popularity: "7",
  },
  {
    name: "GROOMS",
    image: "https://i.scdn.co/image/244b14fedaf27caa7a51e7c0ef2a031c8a5c1eb6",
    spotify: "483xUSKbGyt1c7FpooIkGC",
    genre: "",
    popularity: "7",
  },
  {
    name: "Silvie Loto",
    image: "https://i.scdn.co/image/c4abfc50aee25ccbfcfe09a875fadf7933189206",
    spotify: "79pt77aQRjnLUoKOGUi7Um",
    genre: "",
    popularity: "7",
  },
  {
    name: "Axefield",
    image: "https://i.scdn.co/image/d9d7976b58ad3536aa2bd6c72e4ca86886c3f2f6",
    spotify: "6ov2mjV4oMELm0kUjTfUnB",
    genre: "dutch experimental electronic",
    popularity: "7",
  },
  {
    name: "Chaos Club",
    image: "https://i.scdn.co/image/4d9fda633cd257a28fd2a1e8bb337f11a5436adf",
    spotify: "09GXiXfYsxOsfXIrbjB1wd",
    genre: "",
    popularity: "7",
  },
  {
    name: "Mountain Bike",
    image: "https://i.scdn.co/image/ab67616d0000b27341175d945799e1093a85570e",
    spotify: "3dQbDFvBipTfeO6nYMnaqh",
    genre: "belgian indie rock",
    popularity: "7",
  },
  {
    name: "Inga Mauer",
    image: "https://i.scdn.co/image/21c22f7ab0ec1a6a25a422ff27873953b651e6f4",
    spotify: "0RGQhzlebTZeQZN3YeBtvO",
    genre: "russian electronic,russian techno",
    popularity: "6",
  },
  {
    name: "Danny Da Costa",
    image: "https://i.scdn.co/image/ab67616d0000b27377de06b60500103ea15b34ef",
    spotify: "7JFxWDZiuMZ7WZmfzXPajS",
    genre: "deep uplifting trance",
    popularity: "6",
  },
  {
    name: "Darko Esser",
    image: "https://i.scdn.co/image/3f1127dcc4489ab741ab5365560a8dbba3364874",
    spotify: "7AqGdFNJPwfxvvxzuriXUK",
    genre: "",
    popularity: "6",
  },
  {
    name: "Loes Luca",
    image: "https://i.scdn.co/image/ab67616d0000b273ba4da1bf621dbbd29c595365",
    spotify: "4A3AinlW20g01spqkdciFs",
    genre: "",
    popularity: "6",
  },
  {
    name: "Some Chemistry",
    image: "https://i.scdn.co/image/3391892bebf7c8c7c97521a135e473bd7b42f294",
    spotify: "4ujyqzIrWa6wJAchupeIEG",
    genre: "dutch trance",
    popularity: "6",
  },
  {
    name: "Snelle Jelle",
    image: "https://i.scdn.co/image/b9c74c033026e367991f43549f9b5a75705a9c7c",
    spotify: "5KcMcyu2b4TvMWOURmSIq7",
    genre: "",
    popularity: "6",
  },
  {
    name: "Chunky Dip",
    image: "https://i.scdn.co/image/51e1a1a2ec0a36dd9a628937f8fb2777ec60c192",
    spotify: "1TmzgTXR9fUhmRuzIgnsV6",
    genre: "",
    popularity: "6",
  },
  {
    name: "Anthony Parasole",
    image: "https://i.scdn.co/image/4cad101e5967e274f363fcafd9fca5f42357987a",
    spotify: "66bQLQsTSlK34m12wjyneM",
    genre: "",
    popularity: "6",
  },
  {
    name: "Stellar Om Source",
    image: "https://i.scdn.co/image/c6871b97be022bef7bb6ae21b221efa372988cf6",
    spotify: "15Tc85pyL5i99s6b4mm9Q7",
    genre: "hauntology",
    popularity: "6",
  },
  {
    name: "Daniel Beasley",
    image: "https://i.scdn.co/image/ab67616d0000b27316800f5abc7676b596bab033",
    spotify: "7kYhdgwYkoEnuE0gBHm3qb",
    genre: "",
    popularity: "6",
  },
  {
    name: "Bongloard",
    image: "https://i.scdn.co/image/9d8c9a2d9d7f5e2196ec37f3237f7cde501e652b",
    spotify: "14irVozeTn0DEdXOdaWxow",
    genre: "dutch indie rock",
    popularity: "6",
  },
  {
    name: "Joshua Walter",
    image: "https://i.scdn.co/image/09001f8b4a6bdd1aec456f9527c4f36af355108e",
    spotify: "4fKrqMVb086b723Zg7f78f",
    genre: "",
    popularity: "6",
  },
  {
    name: "Ringbaan",
    image: "https://i.scdn.co/image/6257ddbc9e5a43178b808f1914be0ad00ee7067e",
    spotify: "76kPwFa9l1mc4BjCXsi1B8",
    genre: "dutch tech house",
    popularity: "6",
  },
  {
    name: "Blind Observatory",
    image: "https://i.scdn.co/image/8561b058147023add9d34756d78520b80cfe9c1c",
    spotify: "3JlBZGsSJuoktExmAh2fgr",
    genre: "",
    popularity: "6",
  },
  {
    name: "Pascal Benjamin",
    image: "https://i.scdn.co/image/97d6f80840ca32d522bb28a6ccb29075f4481c0d",
    spotify: "7nvj7D6g8Y3YZTrpdnR9Ep",
    genre: "",
    popularity: "6",
  },
  {
    name: "Bells of Youth",
    image: "https://i.scdn.co/image/ab67616d0000b2731aae6f2a52907a5f5511a547",
    spotify: "2h6lD7uApRPFdTZPz0mXE3",
    genre: "",
    popularity: "6",
  },
  {
    name: "Oliver Alexander",
    image: "https://i.scdn.co/image/c792bdbedd9a8a42c757f71a677a17ee0554aa8f",
    spotify: "7xZtqbp0nIG7djg5Oq3J05",
    genre: "",
    popularity: "6",
  },
  {
    name: "Matt Green",
    image: "https://i.scdn.co/image/ab67616d0000b273f6ff11cff09e95613e833d7a",
    spotify: "6aWhdLNxp9ZZe733wx8maJ",
    genre: "speedcore",
    popularity: "6",
  },
  {
    name: "Densha Crisis",
    image: "https://i.scdn.co/image/ab67616d0000b273b258fb461bde2bb72d8d069a",
    spotify: "02NkCCahOvRNuxKwbgoZbN",
    genre: "doomcore,industrial hardcore",
    popularity: "6",
  },
  {
    name: "Lords of TEK",
    image: "https://i.scdn.co/image/ab67616d0000b27329d928eef69e086f9c1842fa",
    spotify: "1Fbzqw2ArDiE5nq0KyEN9a",
    genre: "",
    popularity: "6",
  },
  {
    name: "St. Solaire",
    image: "https://i.scdn.co/image/24aa3f0ec1f1ec2013d88ac9da9ce9c84452b3e5",
    spotify: "5QsBtdXbeZMaAjXd7GBPL8",
    genre: "",
    popularity: "6",
  },
  {
    name: "Brass Tacks",
    image: "https://i.scdn.co/image/ab67616d0000b27374b4bce86ef76ea22f348ea1",
    spotify: "2e8T6STHzbqzAg68SxKuik",
    genre: "",
    popularity: "6",
  },
  {
    name: "Statesmen",
    image: "https://i.scdn.co/image/ab67616d0000b27397a89b464d0d8fc8a4875ad4",
    spotify: "50BPPdaEzl0iuzLeG2VrKP",
    genre: "southern gospel",
    popularity: "6",
  },
  {
    name: "Micromakine",
    image: "https://i.scdn.co/image/ab67616d0000b2732ed0d2c55249525a61cc1d9d",
    spotify: "6P5tsjV1zjymHMSHiGt2t6",
    genre: "industrial hardcore",
    popularity: "6",
  },
  {
    name: "Eins Tiefer",
    image: "https://i.scdn.co/image/d18d7b50b05cb1c94987a450dceffdb41f2dd7e7",
    spotify: "5lzN0Ygy22Ud4MwQmF7FOE",
    genre: "",
    popularity: "6",
  },
  {
    name: "Oslo Fagottkor",
    image: "https://i.scdn.co/image/f3e174342e2b8d4c27891e49f9778d9bbacbab8b",
    spotify: "3mLypvJ2JrjNIjFSvGM2kB",
    genre: "",
    popularity: "6",
  },
  {
    name: "Manuel Fischer",
    image: "https://i.scdn.co/image/072a2c6cf95c096e75553902c0cb7f1098537b92",
    spotify: "0QCqyf5VjvrlrpVaCt108w",
    genre: "swiss house",
    popularity: "6",
  },
  {
    name: "DJ Cheeba",
    image: "",
    spotify: "6ljq8natMZwtxCSZ7lywrj",
    genre: "",
    popularity: "6",
  },
  {
    name: "Reto Ardour",
    image: "https://i.scdn.co/image/f18434cd6616f9a0b4d43c991cfc9a347a5e529e",
    spotify: "29FluI1TFyBYE4Qb9bl99D",
    genre: "swiss house",
    popularity: "6",
  },
  {
    name: "MR TC",
    image: "https://i.scdn.co/image/ab67616d0000b2738c9701a9d40b5c526f7e3446",
    spotify: "0zNPeookDUibdliWdEadq6",
    genre: "uk experimental electronic",
    popularity: "6",
  },
  {
    name: "Relaxer",
    image: "https://i.scdn.co/image/ab67616d0000b27369bf33446a86959cc51cf25c",
    spotify: "0oxlFdBLF65Z6JL9R7un1o",
    genre: "",
    popularity: "6",
  },
  {
    name: "Surfdisco",
    image: "https://i.scdn.co/image/5b320cbf8ecbf257e524b77ebdb1746b35812c93",
    spotify: "7nPP00p1P6mzEtxxuoOiHL",
    genre: "melbourne bounce",
    popularity: "6",
  },
  {
    name: "ELLLL",
    image: "https://i.scdn.co/image/df5daa0ad01c16394346400918a810219af36a70",
    spotify: "40W5fNvMZwLnag1FYei0Jk",
    genre: "irish electronic,irish experimental electronic",
    popularity: "6",
  },
  {
    name: "Raf Walschaerts",
    image: "",
    spotify: "3zfz6rg1oOUlAlQT7UAmio",
    genre: "",
    popularity: "6",
  },
  {
    name: "Zita Swoon Group",
    image: "https://i.scdn.co/image/c9c912edd0d9d847d9aef882ebdab0290c894585",
    spotify: "0dOoJj1WKVRcJHlOXvszzE",
    genre: "",
    popularity: "6",
  },
  {
    name: "Prequel Tapes",
    image: "https://i.scdn.co/image/37bb049e82de0344d9c85f2a4b3569be77f88cef",
    spotify: "2TeKdaymfCPccHdHKvVYB1",
    genre: "",
    popularity: "6",
  },
  {
    name: "Brooke Sharkey",
    image: "https://i.scdn.co/image/ab19173733e2be113372c2aa6df879a075a8ec09",
    spotify: "6GKB8m6MY4QJQrLipt5qAc",
    genre: "",
    popularity: "6",
  },
  {
    name: "Revalue",
    image: "https://i.scdn.co/image/db30de1b552d666e51ece90444da29a1c77b5147",
    spotify: "2eEShlidjgx1dZkg4vhZwo",
    genre: "",
    popularity: "6",
  },
  {
    name: "Wolfsbane",
    image: "https://i.scdn.co/image/ab67616d0000b273236517bfc4b2714d1c214fa9",
    spotify: "58mY0RMBlQK2dW650Qeh9v",
    genre: "",
    popularity: "6",
  },
  {
    name: "Anja Rützel",
    image: "https://i.scdn.co/image/ab67616d0000b2737d89bc8c6aefb331855c5735",
    spotify: "6PRT8uaYciu1Xnm7wjnZzh",
    genre: "",
    popularity: "6",
  },
  {
    name: "Jack Cooper",
    image: "https://i.scdn.co/image/ab6772690000c46c10dce7281cc01448c22652c7",
    spotify: "21hYgtQqLSbVGd8WQqKXN2",
    genre: "",
    popularity: "6",
  },
  {
    name: "Inceptum",
    image: "https://i.scdn.co/image/ab67616d0000b2731efd64bc10888ce999e090fb",
    spotify: "3PIM2FZzZdLOaiwR7GJ2cz",
    genre: "",
    popularity: "6",
  },
  {
    name: "Knarsetand",
    image: "https://i.scdn.co/image/50dd46c9c59e3c7f78f31a8e09c1474a44bcb6fc",
    spotify: "0CUZKpXWK5Htsk9GiFVFA5",
    genre: "",
    popularity: "6",
  },
  {
    name: "the endless souls",
    image: "https://i.scdn.co/image/ab67616d0000b273845bd4e730ed43cbe48972d8",
    spotify: "7Eph9Vho0GHxGl2BR3L5TZ",
    genre: "uptempo hardcore",
    popularity: "6",
  },
  {
    name: "Igor Vicente",
    image: "https://i.scdn.co/image/ee109d156b2314a83aae2683f64a7b342cd9b11e",
    spotify: "6UWkq7cMy5GvNwdHmwatYb",
    genre: "belgian techno",
    popularity: "6",
  },
  {
    name: "Maulgruppe",
    image: "https://i.scdn.co/image/ab67616d0000b2736e3bcfcd51236c08aef562da",
    spotify: "0vkfnZMFmD0Z4muwDWN6zv",
    genre: "",
    popularity: "6",
  },
  {
    name: "Murman Tsuladze",
    image: "https://i.scdn.co/image/ab67616d0000b2730b59e5c526520e9fdb958141",
    spotify: "3MYa0XzDObL16bmaVgw15f",
    genre: "",
    popularity: "6",
  },
  {
    name: "Hibakusha",
    image: "https://i.scdn.co/image/360891fbe2480b97e9bf559692c6e4b9a5cbfb62",
    spotify: "1mnpQxVqO8q5dMnRzvDzY6",
    genre: "",
    popularity: "6",
  },
  {
    name: "Mark Lotterman",
    image: "https://i.scdn.co/image/ab67616d0000b27365064303bccb9a778bbfe7f0",
    spotify: "1z6owVBgp185CkDPmzeUBe",
    genre: "",
    popularity: "6",
  },
  {
    name: "Dustin Hertz",
    image: "https://i.scdn.co/image/0a5a5e441742153f085eb9c274c78febba5a6879",
    spotify: "0m8RfJnepqdBeD9qa3sxIE",
    genre: "",
    popularity: "6",
  },
  {
    name: "Roland Appel",
    image: "https://i.scdn.co/image/ab67616d0000b2734d51bbc46f1bf036989c0a39",
    spotify: "7craWbqbwX5tUHoUdFxdle",
    genre: "",
    popularity: "6",
  },
  {
    name: "Andromeda Mega Express Orchestra",
    image: "https://i.scdn.co/image/ab67616d0000b2733d7cd013948699e1fcbaaf2d",
    spotify: "4Q4koPnV7quxOg8yMPQd5Q",
    genre: "experimental big band",
    popularity: "6",
  },
  {
    name: "The Milk Factory",
    image: "https://i.scdn.co/image/23a246b792c2757e4d409144bb0d7183d76bfe76",
    spotify: "0wC564zQY4BubuRD9OXXYe",
    genre: "belgian modern jazz",
    popularity: "6",
  },
  {
    name: "African Salsa Orchestra",
    image: "https://i.scdn.co/image/ab67616d0000b2736ffb060a7dcb17335fb8d037",
    spotify: "3VH5usEbOt4NaUv43fDrmG",
    genre: "",
    popularity: "6",
  },
  {
    name: "Andy Ost",
    image: "https://i.scdn.co/image/0cd53a84d904958a35706c5b2989c4d9904e884d",
    spotify: "6LSmkAcNCHV3n2lYAh3pDk",
    genre: "",
    popularity: "6",
  },
  {
    name: "La Corneille",
    image: "https://i.scdn.co/image/0a7f93f7ed075a13656d7380d105b5e7eea55cdd",
    spotify: "4EclYz0vh2KSmJ5s6NnfFt",
    genre: "",
    popularity: "6",
  },
  {
    name: "Imperial Wax",
    image: "https://i.scdn.co/image/a3769790faaff0d8b34d886aec28a54136779f3e",
    spotify: "0JsgBrolcIXyCnVpVCi2Ri",
    genre: "uk post-punk revival",
    popularity: "6",
  },
  {
    name: "Mike Servito",
    image: "",
    spotify: "05TQmeCxjfNBf1ZRDOMHq8",
    genre: "experimental techno",
    popularity: "5",
  },
  {
    name: "Patrick Russell",
    image: "https://i.scdn.co/image/1bcf04977ba66ee3d214e6b55311f45073cf4254",
    spotify: "0JJBdhvT4OU2tvK3dzXRVt",
    genre: "",
    popularity: "5",
  },
  {
    name: "Frank Lorber",
    image: "https://i.scdn.co/image/ab67616d0000b2737766b41b09ceca0a157390b0",
    spotify: "4BxmnMjj953DHYxAiWjBkf",
    genre: "frankfurt electronic",
    popularity: "5",
  },
  {
    name: "Howard Komproe",
    image: "https://i.scdn.co/image/ab67616d0000b273de0b04c8027394b7f85492e7",
    spotify: "6iNQqbgr2A67Z715la7szP",
    genre: "dutch cabaret",
    popularity: "5",
  },
  {
    name: "Paul Roberts",
    image: "https://i.scdn.co/image/ab67616d0000b2731ca2d075d6fa92d5bd2bff91",
    spotify: "46auEIbPU7AkBU6ZT2P0l6",
    genre: "",
    popularity: "5",
  },
  {
    name: "Soul Shakers",
    image: "https://i.scdn.co/image/f6c29850ce0482ff487c9e686ccc8d9e8182adbb",
    spotify: "4SCNIHP2IAtrRKvaApkWDw",
    genre: "",
    popularity: "5",
  },
  {
    name: "2nd Floor",
    image: "https://i.scdn.co/image/ab67616d0000b27374ebbd5fbb9f8721d740958b",
    spotify: "28F8Kj94mZ2c1BO4Etb3VA",
    genre: "",
    popularity: "5",
  },
  {
    name: "Ingi Visions",
    image: "https://i.scdn.co/image/ab67616d0000b2732514453e5cb9e73fbe4207ac",
    spotify: "7tqioTOpe2sYJZGMw7rId0",
    genre: "",
    popularity: "5",
  },
  {
    name: "Front De Cadeaux",
    image: "https://i.scdn.co/image/ab67616d0000b2736d3b21341301e53bd443b14f",
    spotify: "6U5NyEGFn0luiu0emae0iD",
    genre: "float house",
    popularity: "5",
  },
  {
    name: "Bartoch",
    image: "https://i.scdn.co/image/cbadb99ba3a7a2c0db6a49708c5c5c6f2749f483",
    spotify: "0zOWeClU3XJFTgy5OgXhR6",
    genre: "doomcore",
    popularity: "5",
  },
  {
    name: "Kim Kaos",
    image: "https://i.scdn.co/image/13eef3ed1fa3118359ea2563226b08e76a81f297",
    spotify: "5gZ21jZBLA2iHh8oBTzmjB",
    genre: "",
    popularity: "5",
  },
  {
    name: "Markus Sommer",
    image: "https://i.scdn.co/image/f45c2be2687afa887b539c2dec294b59949764f7",
    spotify: "3o5QkEHDQhYxf41iv5ifUU",
    genre: "",
    popularity: "5",
  },
  {
    name: "Adam Shelton",
    image: "https://i.scdn.co/image/ab67616d0000b273b2674720e912460f8a9cea3e",
    spotify: "1MIalVgaPtijtxHGl0KhTK",
    genre: "",
    popularity: "5",
  },
  {
    name: "Het Monica da Silva Trio",
    image: "https://i.scdn.co/image/ab67616d0000b2735d8be9a4a68eb243d51c31c8",
    spotify: "2R5g78rddsSqLPKKHcl5Jf",
    genre: "",
    popularity: "5",
  },
  {
    name: "K-Fresh",
    image: "https://i.scdn.co/image/ab67616d0000b273ef71b120f95bf2a9b2eab94d",
    spotify: "00jZcL6XFeqCYuXqOzrDsQ",
    genre: "",
    popularity: "5",
  },
  {
    name: "Sweetpea",
    image: "https://i.scdn.co/image/53511a97f217463d45d40382d70d5d853ebd9001",
    spotify: "62wR4mvjXztHU3tQ3Lhxgh",
    genre: "",
    popularity: "5",
  },
  {
    name: "The Mighty Breaks",
    image: "https://i.scdn.co/image/a4f8a3b83148239bcf52a64783e350a912d314df",
    spotify: "3sGXLe1H7gqP6Z3dQJMEuS",
    genre: "dutch indie rock",
    popularity: "5",
  },
  {
    name: "Robocobra Quartet",
    image: "https://i.scdn.co/image/5f5648f5cf115bf0100ffc08930a16a3b036e49d",
    spotify: "1TWFJFIiQbaPOLDqp3he4s",
    genre: "belfast indie,irish modern jazz,northern irish indie",
    popularity: "5",
  },
  {
    name: "Richie Gee",
    image: "https://i.scdn.co/image/ab67616d0000b273e5b4cfa31f3c5c66cbc7d4a4",
    spotify: "5t3QroFr7qpjekft2xRbx9",
    genre: "",
    popularity: "5",
  },
  {
    name: "Jerrymore",
    image: "https://i.scdn.co/image/ab67616d0000b273c8392d4dcc54e5a8890a6134",
    spotify: "0nBjchN5LMhGY0U8otojzO",
    genre: "",
    popularity: "5",
  },
  {
    name: "DONNERWETTER",
    image: "https://i.scdn.co/image/bf16bc4100893e91aa92ef3bd9f5420e61821fad",
    spotify: "45knGfZpDLYlQOHU689F9o",
    genre: "",
    popularity: "5",
  },
  {
    name: "Synaptic Memories",
    image: "https://i.scdn.co/image/ab67616d0000b27306ec171ea8e061bf03581107",
    spotify: "6C76ow4GZVqac7akBNLPrA",
    genre: "doomcore",
    popularity: "5",
  },
  {
    name: "Afro Cluster",
    image: "https://i.scdn.co/image/3b0a1193a56c0f94da5b5dec339a87a2c6c5f600",
    spotify: "4rDXkTJNCLKr6FWS3jgVbU",
    genre: "welsh hip hop",
    popularity: "5",
  },
  {
    name: "Kid Rascal",
    image: "https://i.scdn.co/image/ab67616d0000b273d97c211427f03ac28802e5ae",
    spotify: "1mANvLDwrqCSr84LfS9cdV",
    genre: "jumpstyle",
    popularity: "5",
  },
  {
    name: "The Crowns",
    image: "https://i.scdn.co/image/ab67616d0000b273a15852c005629b4f4ee2c3b0",
    spotify: "0U9Rcmfkei0U9gU6ELdlbX",
    genre: "",
    popularity: "5",
  },
  {
    name: "Iris Menza",
    image: "https://i.scdn.co/image/ab67616d0000b27347ae5411459a7064a6a675c3",
    spotify: "5sCsGvCKjZOQPilf7TbLY6",
    genre: "",
    popularity: "5",
  },
  {
    name: "Inner Heat",
    image: "https://i.scdn.co/image/ab67616d0000b2732d300e0977f1269300138888",
    spotify: "34mRgnZIOXfaWOjlgzo66m",
    genre: "",
    popularity: "5",
  },
  {
    name: "Cliff Coenraad",
    image: "https://i.scdn.co/image/ab67616d0000b273d4be7552f39fa30f3363154c",
    spotify: "0zWBykePAxjP3vWR75wmFL",
    genre: "dutch trance",
    popularity: "5",
  },
  {
    name: "Joris Linssen",
    image: "https://i.scdn.co/image/ab67616d0000b273efc09acced5edeacbcc11af5",
    spotify: "2pujuuS1Ie8XBk4fqPvOZ9",
    genre: "",
    popularity: "5",
  },
  {
    name: "Heart Attack Alley",
    image: "https://i.scdn.co/image/ab67616d0000b27302564d889b908174dbe11c2c",
    spotify: "5MTddA9NHiMcbgiUlAONza",
    genre: "",
    popularity: "5",
  },
  {
    name: "Absent Minded",
    image: "https://i.scdn.co/image/ab67616d0000b273f1d4aee4224f664ec3776233",
    spotify: "3gUTkQQr2TaVNhh48cZfk2",
    genre: "swedish underground rap",
    popularity: "5",
  },
  {
    name: "Marc Antona",
    image: "https://i.scdn.co/image/ab67616d0000b2735df133b9ed6e05d4db6bd456",
    spotify: "3646qH22vPdTBgcw62vK3j",
    genre: "",
    popularity: "5",
  },
  {
    name: "Yves De Mey",
    image: "https://i.scdn.co/image/ded33e2c49b0fb9ca5220de4606dd3d008319776",
    spotify: "5gThGnXmcMlq5iGiBUfk46",
    genre: "mandible",
    popularity: "5",
  },
  {
    name: "Vermelho Wonder",
    image: "https://i.scdn.co/image/e96aec85a9f189f42ed4dd3f3ff3c718f179b42b",
    spotify: "1uJaXZr3h2FXfMTzQmhHpu",
    genre: "post-punk brasileiro",
    popularity: "5",
  },
  {
    name: "Harouna Samake",
    image: "https://i.scdn.co/image/ab67616d0000b273dd064998c7c9ff68adfc1b0e",
    spotify: "7A7SZmiq3z3gYPcO5k6uUl",
    genre: "malian blues",
    popularity: "5",
  },
  {
    name: "Secret Factory",
    image: "https://i.scdn.co/image/ab67616d0000b273f95b205d9a88f0976ab4760d",
    spotify: "1qXKhCrbpUVtwf24RneHyq",
    genre: "",
    popularity: "5",
  },
  {
    name: "Tek Soldierz",
    image: "https://i.scdn.co/image/c6db0497d6c07e45d45e7f65b059a102eb19eae7",
    spotify: "2ClfDDA5mTitP2UwT4mqSe",
    genre: "jumptek",
    popularity: "5",
  },
  {
    name: "Sol Ortega",
    image: "https://i.scdn.co/image/ab67616d0000b273e7e0204076523c2bb4315c4b",
    spotify: "1a8L1wFGuk1SDOmAXhnvmO",
    genre: "techno argentina",
    popularity: "5",
  },
  {
    name: "2owl",
    image: "https://i.scdn.co/image/f844e02c7cabf407529357e84e0b06a22a71acd0",
    spotify: "0IC8UZaOLRxH5yZpeV1VLa",
    genre: "",
    popularity: "5",
  },
  {
    name: "Erlend Viken Trio",
    image: "https://i.scdn.co/image/ab67616d0000b273d3d23709dd1b7378e4dff723",
    spotify: "48W5gLOFzBBBdwnb7qt5sA",
    genre: "old-time fiddle",
    popularity: "5",
  },
  {
    name: "Newmoon",
    image: "https://i.scdn.co/image/ab67616d0000b273897faa1342bf81781703fa92",
    spotify: "1d3vpvW4u4sEjAktu9W5mJ",
    genre: "",
    popularity: "5",
  },
  {
    name: "Terzij de Horde",
    image: "https://i.scdn.co/image/3808721faa66dacdadf57d29903f7a986a4cac62",
    spotify: "41G9cPXKxphLtBQXD0g30o",
    genre: "blackgaze,chaotic black metal,dutch black metal,post-black metal",
    popularity: "5",
  },
  {
    name: "Latin Society",
    image: "https://i.scdn.co/image/ab67616d0000b27340895f9c2ab1e2d25124f737",
    spotify: "1u6kvUV3Uzrdhnlz98rNVC",
    genre: "",
    popularity: "5",
  },
  {
    name: "David Nance",
    image: "https://i.scdn.co/image/0c59db8dad067c15cdd78b25a114a3bcebb5addd",
    spotify: "7p4c2nwJAhBa8pV0tvBRr9",
    genre: "omaha indie",
    popularity: "5",
  },
  {
    name: "KC Jones",
    image: "https://i.scdn.co/image/ab67616d0000b273fafd1a6386e02c32d40a0d4a",
    spotify: "4qiiHcXbQIxJ61sx0xLDb0",
    genre: "",
    popularity: "4",
  },
  {
    name: "Furnace and the Fundamentals",
    image: "https://i.scdn.co/image/9309a5fee15e6ec7a17573856ed56e828ddfef49",
    spotify: "0fE8p9ygu52LFgApd0glZh",
    genre: "",
    popularity: "4",
  },
  {
    name: "Martijn Koning",
    image: "https://i.scdn.co/image/ab67616d0000b273a474e1d0abc8a0cbeea3e5af",
    spotify: "1zVWDgSBadjuSxmF1cmvgU",
    genre: "dutch cabaret",
    popularity: "4",
  },
  {
    name: "Erik van Muiswinkel",
    image: "https://i.scdn.co/image/ab67616d0000b273b9543b832417cd85b389846e",
    spotify: "0MUaWOtZWuPlrkmxakVbfo",
    genre: "",
    popularity: "4",
  },
  {
    name: "Voigtmann",
    image: "https://i.scdn.co/image/ab67616d0000b2736f7e249c1f20d9ce21860712",
    spotify: "4njiUmoMgp7WM5PVGscTvG",
    genre: "",
    popularity: "4",
  },
  {
    name: "SHMLSS",
    image: "https://i.scdn.co/image/ab67616d0000b273721a17c9609269b137abdf15",
    spotify: "2pN1frmxUWTrn5uDFhK3mP",
    genre: "",
    popularity: "4",
  },
  {
    name: "Mondo Leone",
    image: "https://i.scdn.co/image/ab67616d0000b273188301fc94b780debff5a784",
    spotify: "33ZvC3EhHv72QQgN6ns3GL",
    genre: "",
    popularity: "4",
  },
  {
    name: "Section Grabuge",
    image: "https://i.scdn.co/image/ab67616d0000b2738320713b84649a464a245c56",
    spotify: "6aOgrXicbUmC4iCNrzIX9m",
    genre: "",
    popularity: "4",
  },
  {
    name: "The Silverfaces",
    image: "https://i.scdn.co/image/259dd285efe3046d80ed1e742824d6c1c246bbf6",
    spotify: "50bhZ09TTscFlTlOiLYndm",
    genre: "",
    popularity: "4",
  },
  {
    name: "Maykel Piron",
    image: "https://i.scdn.co/image/e98a7b72cfaa2b26569928b4b44785968aafafee",
    spotify: "3ZofUaICtW8tXkjuM26Gxq",
    genre: "",
    popularity: "4",
  },
  {
    name: "Los Paja Brava",
    image: "https://i.scdn.co/image/ab67616d0000b273b6c152e391046dab95345fd6",
    spotify: "3gHd1MfWpuQcXRry3axW4h",
    genre: "",
    popularity: "4",
  },
  {
    name: "Ingo Boss",
    image: "https://i.scdn.co/image/ab67616d0000b27320c9204d466b4e19d256ff11",
    spotify: "0TJBEzQilQoTTCm9rjD0x0",
    genre: "frankfurt electronic",
    popularity: "4",
  },
  {
    name: "Steef de Jong",
    image: "https://i.scdn.co/image/ab67616d0000b273fe03821c0471e1e0dead1228",
    spotify: "3ojh6qeDMvejJRWTHyrrKE",
    genre: "",
    popularity: "4",
  },
  {
    name: "Marc Faenger",
    image: "https://i.scdn.co/image/4a80242a8289cc404ce99ee89308b7a9c4b1947e",
    spotify: "4XYTmL8gaxBbmfV4SfPGEr",
    genre: "",
    popularity: "4",
  },
  {
    name: "Pasquinel",
    image: "https://i.scdn.co/image/27ddde2527a41da2e8f7f5c5450ce45703a5922b",
    spotify: "5ZJKB5dsYtAoYRdBnHDP8S",
    genre: "",
    popularity: "4",
  },
  {
    name: "Warren Fellow",
    image: "https://i.scdn.co/image/f70ad3f198815fda653daa88fc2e31cd7dd3f456",
    spotify: "47uKLqt9PGDphLkqlErRID",
    genre: "",
    popularity: "4",
  },
  {
    name: "Spynex",
    image: "https://i.scdn.co/image/60b1b21368aabf04e7443ff2d12c849a7a7be5a1",
    spotify: "0vflSl8QZ8t4dNLYrmnAh1",
    genre: "",
    popularity: "4",
  },
  {
    name: "Derek Shots",
    image: "https://i.scdn.co/image/46164fdffe508b8fabb0b550ad171fd8771c1c38",
    spotify: "1OoxnWjP2oouYlnecWVa9A",
    genre: "",
    popularity: "4",
  },
  {
    name: "Thunder from Downunder",
    image: "https://i.scdn.co/image/ab67616d0000b273f8e781b90245f3163d5e129d",
    spotify: "6RiiIwGGAwEG0VVNa88JNh",
    genre: "",
    popularity: "4",
  },
  {
    name: "Cera Khin",
    image: "",
    spotify: "49QMv0RvuxcUG8Xk6YweEz",
    genre: "",
    popularity: "4",
  },
  {
    name: "Jenny Berkel",
    image: "https://i.scdn.co/image/8883849e1a965c794feb854a81e6c069651c2221",
    spotify: "4Ff0I4P7d0FLK7Ctwy2pub",
    genre: "",
    popularity: "4",
  },
  {
    name: "Crying Boys Cafe",
    image: "https://i.scdn.co/image/d4b4751ed659e58dd3ed361f43a0bd1dfaad0993",
    spotify: "32X5izgbhmGa8kb4UNWgsX",
    genre: "",
    popularity: "4",
  },
  {
    name: "The Black Cult",
    image: "https://i.scdn.co/image/ab67616d0000b273500b2863304e998bab77cbf7",
    spotify: "0JboXd4xIbX0JkEM2EIyyO",
    genre: "dutch indie rock",
    popularity: "4",
  },
  {
    name: "Biorekk",
    image: "",
    spotify: "2umXnSwooDEDXPbVc5y1HN",
    genre: "",
    popularity: "4",
  },
  {
    name: "LOVE COUPLE",
    image: "https://i.scdn.co/image/c7af000104d6ba029008fb061c102b6df35f8cfd",
    spotify: "057CenvNWsODNvNSLCQ3WV",
    genre: "dutch indie rock",
    popularity: "4",
  },
  {
    name: "SHLTR",
    image: "https://i.scdn.co/image/ab67616d0000b27381b6ceb9f305078984486b78",
    spotify: "3mjRrJOJbI24P7eS0JtmbD",
    genre: "",
    popularity: "4",
  },
  {
    name: "Bottles of Love",
    image: "https://i.scdn.co/image/ab67616d0000b2735326443444ca98cea5b5207c",
    spotify: "7C9M268upj2WPFJWDOHJXm",
    genre: "dutch indie rock",
    popularity: "4",
  },
  {
    name: "Xpansul",
    image: "https://i.scdn.co/image/7081cffdd0590dda7928aa856748b237fbd4a1a1",
    spotify: "4yqhd87saAZqKDGVFeuG3M",
    genre: "",
    popularity: "4",
  },
  {
    name: "MATTIASDECRAENE",
    image: "https://i.scdn.co/image/ab67616d0000b2733b88136965e35167a222eafc",
    spotify: "0j084JRZgfGSEvlV6P4js7",
    genre: "",
    popularity: "4",
  },
  {
    name: "Les Robots",
    image: "https://i.scdn.co/image/ab67616d0000b273782d083075e493cfcbb635ab",
    spotify: "5z4Jupr5lzbGlwmED0B0tJ",
    genre: "",
    popularity: "4",
  },
  {
    name: "Francesco Del Garda",
    image: "",
    spotify: "7AgKl7H19hTtfF4G4gopQz",
    genre: "italian techno",
    popularity: "4",
  },
  {
    name: "William Kouam Djoko",
    image: "https://i.scdn.co/image/ab67616d0000b273f7146e2c77ea7ce97b48857e",
    spotify: "3nFiIWWeLdgWMNNzBZOc47",
    genre: "",
    popularity: "4",
  },
  {
    name: "Alexandra Alden",
    image: "https://i.scdn.co/image/ab67616d0000b2736013ae6fecc4c9366ae8b83f",
    spotify: "5AKalNKZLHUNU2hGBdzFsc",
    genre: "",
    popularity: "4",
  },
  {
    name: "Mamadou Kelly",
    image: "https://i.scdn.co/image/3ab34c8e1d5a7f30c857c48374bdca13aa963eea",
    spotify: "7DovH3P0VMPtH6Es46QtNb",
    genre: "malian blues",
    popularity: "4",
  },
  {
    name: "Soupcans",
    image: "https://i.scdn.co/image/ab67616d0000b27385e7b79634b33c7c95653424",
    spotify: "6MkQPg36fKrDlDuzpwcZPV",
    genre: "",
    popularity: "4",
  },
  {
    name: "Scarlett Etienne",
    image: "https://i.scdn.co/image/ab67616d0000b273a38682009287570d18ec5c8a",
    spotify: "4pngLAvHebzfNOpbpG1RuL",
    genre: "",
    popularity: "4",
  },
  {
    name: "Niels Feijen",
    image: "https://i.scdn.co/image/ab67616d0000b273265cf7a6b8243f6db89a96c1",
    spotify: "6kf670V24ESlcnlMbqn665",
    genre: "",
    popularity: "4",
  },
  {
    name: "Tony Clifton",
    image: "https://i.scdn.co/image/5ccd8bbbef3878389c98089c41b96c7a3cf05b68",
    spotify: "7DAd9qFIkD38hKZDsC4kQm",
    genre: "",
    popularity: "4",
  },
  {
    name: "Clara! y Maoupa",
    image: "https://i.scdn.co/image/ab67616d0000b27322653345c5cfc0b93777163e",
    spotify: "27vqQZX2pCnMsL6gfsVzQ0",
    genre: "",
    popularity: "4",
  },
  {
    name: "Smash Hifi",
    image: "https://i.scdn.co/image/ab67616d0000b273b1bcdd09ec205427bc78aa14",
    spotify: "1o4EIIQRSGVyrGGTQnUwbY",
    genre: "",
    popularity: "4",
  },
  {
    name: "Lekisjazz",
    image: "https://i.scdn.co/image/ab67616d0000b273e8064dd4a9f94c2b2dfd7676",
    spotify: "4Cjz5AoBQexnqHcD9MyFlw",
    genre: "",
    popularity: "4",
  },
  {
    name: "Sandy Kandau",
    image: "https://i.scdn.co/image/ab67616d0000b273956c383a4ff6d8dcd467e13e",
    spotify: "5pqBBiV0bJGedKnGggMiLj",
    genre: "",
    popularity: "4",
  },
  {
    name: "Atlantihda",
    image: "https://i.scdn.co/image/ab67616d0000b27341d59fe43722723245423817",
    spotify: "1SZG3kcP70RjaVKqsyVCAa",
    genre: "",
    popularity: "4",
  },
  {
    name: "Wildkats",
    image: "https://i.scdn.co/image/ab67616d0000b2733fbe7394f713c324eff2c561",
    spotify: "3AIQhcWEyaPRpiu2hFCLhl",
    genre: "",
    popularity: "4",
  },
  {
    name: "Dennis Ruyer",
    image: "https://i.scdn.co/image/b3188c1ff597a187e0a1bf4384ad37db53155e40",
    spotify: "2AVkpBY6UUqFpXlx5SpCll",
    genre: "dutch tech house",
    popularity: "4",
  },
  {
    name: "Daniel Sloss",
    image: "",
    spotify: "2ySQ24N9vnrF1iR7Ke5vfU",
    genre: "",
    popularity: "4",
  },
  {
    name: "David Scuba",
    image: "https://i.scdn.co/image/9705a9681195e7838df3875f23fba53e641fc231",
    spotify: "56AvM0vHNWjKFpV8sg6qsc",
    genre: "",
    popularity: "4",
  },
  {
    name: "Hakuna Matata",
    image: "https://i.scdn.co/image/ab67616d0000b2735cce4ccdf2d592b942d47286",
    spotify: "4ABtxJThOp7CZstPk75xZz",
    genre: "",
    popularity: "4",
  },
  {
    name: "Jay Mocio",
    image: "https://i.scdn.co/image/ab67616d0000b273c01201ef9384ddd623dbf1b6",
    spotify: "7AZtgnLbLwSFr34GF5qvAt",
    genre: "",
    popularity: "4",
  },
  {
    name: "P.A. Hülsenbeck",
    image: "https://i.scdn.co/image/a6b316c17044fe141829e6fb61560c2719d0dd0f",
    spotify: "0pqsdYibSYoERNVDJhqQ8L",
    genre: "german indie",
    popularity: "4",
  },
  {
    name: "Clem Curtis",
    image: "",
    spotify: "7o67vAe1IEhe3icpmFDrN4",
    genre: "",
    popularity: "4",
  },
  {
    name: "Little Dots",
    image: "https://i.scdn.co/image/9fc4539150bcaf3949fd32dc7fa07606cce55964",
    spotify: "27LspB0gK0HM5b6aCAL3cK",
    genre: "belgian indie",
    popularity: "4",
  },
  {
    name: "Mylou Frencken",
    image: "https://i.scdn.co/image/ab67616d0000b2732e13760f49b916002792f8b8",
    spotify: "0jPdKGgmL2SiyoDRKo4DHv",
    genre: "",
    popularity: "3",
  },
  {
    name: "Mark Carter",
    image: "https://i.scdn.co/image/ab67616d0000b273c878b6fe3b290bda3f53ecef",
    spotify: "61ulQkEANyvnbco6TSYxzk",
    genre: "deep smooth jazz",
    popularity: "3",
  },
  {
    name: "Jan Beuving",
    image: "",
    spotify: "3fcoDiFqeKtkM4B7Pd92zU",
    genre: "",
    popularity: "3",
  },
  {
    name: "Femmetastic",
    image: "https://i.scdn.co/image/3389fadddced6798f325fbc7dbe34cffceaadaa4",
    spotify: "389i0y6YSiOksoyegUydHJ",
    genre: "dutch moombahton",
    popularity: "3",
  },
  {
    name: "Veronica Vasicka",
    image: "https://i.scdn.co/image/95a1cd2c555ebbc06cee6b972b5dc12e9a8de09a",
    spotify: "1akVMMowu12xCGReNfz2wr",
    genre: "minimal wave",
    popularity: "3",
  },
  {
    name: "Zitakula",
    image: "https://i.scdn.co/image/14257654de1590d65a4eeab9727fa6f283c2c7b0",
    spotify: "2SHhOH32pXTsSBlm3tVo5H",
    genre: "",
    popularity: "3",
  },
  {
    name: "Boemklatsch",
    image: "https://i.scdn.co/image/ab67616d0000b2734def1ce89d3ef811b026b1be",
    spotify: "7KxXfy9mSTFwwmRazrUlBC",
    genre: "",
    popularity: "3",
  },
  {
    name: "Julien Bracht",
    image: "https://i.scdn.co/image/ab67616d0000b273a16178e5977b352c6e854cbb",
    spotify: "10dTAeheJUqaoY9C0UxdHx",
    genre: "",
    popularity: "3",
  },
  {
    name: "Valvetronic Brassband",
    image: "https://i.scdn.co/image/f335bc4b37f387e34b4dd121e50f75faee92e12d",
    spotify: "0XbLVjYVNnVmy5mwjfI5i1",
    genre: "",
    popularity: "3",
  },
  {
    name: "Paquito Moniz",
    image: "https://i.scdn.co/image/3d66e8479165c4ec4a0928089379a791336ad9f3",
    spotify: "0JkefxbcC1F1iiAaQaZgSZ",
    genre: "",
    popularity: "3",
  },
  {
    name: "Cloaca",
    image: "https://i.scdn.co/image/ab67616d0000b273e411f15282d87887993d960e",
    spotify: "5AIHO1L3ip41d6BrptGefT",
    genre: "atmospheric post-metal",
    popularity: "3",
  },
  {
    name: "Hellter Skellter",
    image: "",
    spotify: "02uKRzctBR0lCdLtNNUqg7",
    genre: "",
    popularity: "3",
  },
  {
    name: "Jasmine Li",
    image: "",
    spotify: "3GwlfYZfa8IX7ZdTcIYSMG",
    genre: "",
    popularity: "3",
  },
  {
    name: "Nathan Surreal",
    image: "https://i.scdn.co/image/8e38fb92ccaf42f324a1a4330114c58354fa6ba1",
    spotify: "6Nv6Bgf2zV57wgrmV267Nn",
    genre: "",
    popularity: "3",
  },
  {
    name: "Masters Of Noise",
    image: "https://i.scdn.co/image/ab67616d0000b273e73ea61253956bbe736d7716",
    spotify: "3HW4LeFRGOqMM9nqkoHXrK",
    genre: "uptempo hardcore",
    popularity: "3",
  },
  {
    name: "Dekoor Close Harmony",
    image: "https://i.scdn.co/image/f6c7b7d48bdb5118eaec6bb13f40abc81ca6aabb",
    spotify: "6Se32nilVIhPFoI3YOH1an",
    genre: "",
    popularity: "3",
  },
  {
    name: "Stennis",
    image: "",
    spotify: "1fCZhw5NoeCcyhRA8VAfot",
    genre: "",
    popularity: "3",
  },
  {
    name: "The Carny Villains",
    image: "https://i.scdn.co/image/ab67616d0000b273a687b7ba8c8748f9d45b761b",
    spotify: "1e7ncS1qI4wvCo2K7OU3t4",
    genre: "",
    popularity: "3",
  },
  {
    name: "House4Pleasure",
    image: "https://i.scdn.co/image/138b5f725ed07cd6f35843181e1527908dacdedd",
    spotify: "4XiYfNTJ5LhbKiVX49L4sq",
    genre: "",
    popularity: "3",
  },
  {
    name: "La Boutique Fantastique",
    image: "https://i.scdn.co/image/ab67616d0000b2731cf4ff53636aae6ef0ffc2eb",
    spotify: "3af76a8RmMIvKVq0WyhPSA",
    genre: "",
    popularity: "3",
  },
  {
    name: "DJ Athome",
    image: "",
    spotify: "3RWyuiVGWriPGGGjbSlruG",
    genre: "",
    popularity: "3",
  },
  {
    name: "Gramrcy",
    image: "https://i.scdn.co/image/ab67616d0000b273ca57535a10e342764d6e30b5",
    spotify: "7a3X8KBiTfkloCTu0i3aXA",
    genre: "",
    popularity: "3",
  },
  {
    name: "Roald Van Oosten",
    image: "https://i.scdn.co/image/ab67616d0000b273ebfdbf6b7d736d1a0269465a",
    spotify: "1njsAwijM92yGp5smfnrv2",
    genre: "",
    popularity: "3",
  },
  {
    name: "Narasirato",
    image: "https://i.scdn.co/image/ab67616d0000b273b4bcca647fb8c0cab03eadb7",
    spotify: "0GyOxltjgDIXGsuOcE4Zbl",
    genre: "solomon islands pop",
    popularity: "3",
  },
  {
    name: "Renee Van Bavel",
    image: "https://i.scdn.co/image/ab67616d0000b273a1b55faff23dbe2428ca0c49",
    spotify: "3fYAQLUgQHcC0UNhkZRGkF",
    genre: "",
    popularity: "3",
  },
  {
    name: "Raffaela Paton",
    image: "https://i.scdn.co/image/ab67616d0000b273efc6d83957abdcdd6d81cf85",
    spotify: "1wDgz7gOwne6dJ7IKOj3fI",
    genre: "dutch idol pop",
    popularity: "3",
  },
  {
    name: "Jay-Roon & The Loose Ends",
    image: "https://i.scdn.co/image/ab67616d0000b273c3263df1bde06b99643e67b4",
    spotify: "1PXhxIy5H0JrV2Ln4phCgp",
    genre: "",
    popularity: "3",
  },
  {
    name: "BlackboxRed",
    image: "https://i.scdn.co/image/3260a750feb97240bfee3341f5991337f98bd2cc",
    spotify: "2fIN4oAhWTB01qj0uV1ODg",
    genre: "",
    popularity: "3",
  },
  {
    name: "Milan W.",
    image: "https://i.scdn.co/image/ab67616d0000b27373c0da595acf05f844b77568",
    spotify: "4ZCux8WXdeKCoARMg1JSok",
    genre: "belgian experimental",
    popularity: "3",
  },
  {
    name: "James Kiedis",
    image: "https://i.scdn.co/image/b55f427f1624a61eb0ffffcb9f12f2e5616bee89",
    spotify: "60fLwfocPBYIdNjG7OvLYp",
    genre: "",
    popularity: "3",
  },
  {
    name: "Working Titles",
    image: "https://i.scdn.co/image/5e7348e81c615acab49c14c74d3f39d6c312f4f5",
    spotify: "5xY5OgzsCmpYmEO6Pd9wTn",
    genre: "",
    popularity: "3",
  },
  {
    name: "Världens Band",
    image: "https://i.scdn.co/image/ab67616d0000b2737e480b6d69ce97fd7335b886",
    spotify: "2u3nnYb1YW16LenBOVYBTD",
    genre: "",
    popularity: "3",
  },
  {
    name: "Lorenzo Bartoletti",
    image: "https://i.scdn.co/image/4b670581dbef8bc08b5343a1b626846f875b1d9b",
    spotify: "58obnNaYHIAadSfICFjQH5",
    genre: "",
    popularity: "3",
  },
  {
    name: "Itraxx",
    image: "https://i.scdn.co/image/ab67616d0000b273960c56e9de03fea481b5fdf6",
    spotify: "269FNF7prcEFGT9i7HK8Px",
    genre: "jumpstyle",
    popularity: "3",
  },
  {
    name: "Leopard Skull",
    image: "https://i.scdn.co/image/e01ab3a00ce21f8c1a80bd589862164e2730268b",
    spotify: "1NeL6nogTdJLIlp3Nc4om6",
    genre: "",
    popularity: "3",
  },
  {
    name: "Frans van Deursen",
    image: "https://i.scdn.co/image/ab4d8dcb1aed62e8632e95fcdf57763e53412760",
    spotify: "0UcQldnO9dX8KXd8MBXk1K",
    genre: "",
    popularity: "3",
  },
  {
    name: "Acoustic Duo",
    image: "",
    spotify: "3N2gmT16Sxu60qlhjOABwU",
    genre: "",
    popularity: "3",
  },
  {
    name: "BMBSQD",
    image: "https://i.scdn.co/image/6b991d16073943811e03d8efbe76a305651a5e72",
    spotify: "0TvLyCHJ3hMpUvOriJUCpA",
    genre: "",
    popularity: "3",
  },
  {
    name: "Even Tuell",
    image: "https://i.scdn.co/image/ab67616d0000b27354215e8d3051d340bb9d32af",
    spotify: "6QXLc7eTHRIqWOOtu27aVK",
    genre: "",
    popularity: "3",
  },
  {
    name: "The Future Dub Project",
    image: "https://i.scdn.co/image/ab67616d0000b27350dab3f76ac38ed591197076",
    spotify: "3UwpB0vkS3GJ7XlsPaAatt",
    genre: "",
    popularity: "3",
  },
  {
    name: "Tom Ruijg",
    image: "https://i.scdn.co/image/ab67616d0000b2732a365d9414c9d0c324ec5391",
    spotify: "4AqMXo7ZPzhyqOBXBbmD5i",
    genre: "",
    popularity: "3",
  },
  {
    name: "Studio Shap Shap",
    image: "https://i.scdn.co/image/ab67616d0000b273f272099a5964b6a2e21df783",
    spotify: "4yU4V7leogO5lcKt07ViYu",
    genre: "",
    popularity: "3",
  },
  {
    name: "The Grey Pants",
    image: "https://i.scdn.co/image/ab67616d0000b27306ebab48c95c99fe508b5861",
    spotify: "6gQ7lK3KKdRqyxQyk4kcS9",
    genre: "",
    popularity: "3",
  },
  {
    name: "B.R.U.C.E.",
    image: "https://i.scdn.co/image/5a82c1da25c3f7d96c995ff1be92eee4f68db3a6",
    spotify: "4NJOkIRxAAHOwzL5oMWN0d",
    genre: "",
    popularity: "3",
  },
  {
    name: "NC Grey",
    image: "https://i.scdn.co/image/54ddec5dbc29ab5e51deae833562249ae9515c61",
    spotify: "0hSitEPfgaCdGEFLxrW4Km",
    genre: "",
    popularity: "3",
  },
  {
    name: "Jack Jameson",
    image: "https://i.scdn.co/image/9a8dbcc1f50dbe76bd26d7acc114f4b88287b485",
    spotify: "7jMQ8wOf8D2TQkIQaALc3T",
    genre: "",
    popularity: "3",
  },
  {
    name: "Tamarin Desert",
    image: "https://i.scdn.co/image/54e5db1ea3b18a849a2b8d854be9c06127fa9b68",
    spotify: "4HbPxopwzv0WXonXY4xqwp",
    genre: "",
    popularity: "3",
  },
  {
    name: "Interchain",
    image: "https://i.scdn.co/image/ab67616d0000b2737479967536ee724e3cba4520",
    spotify: "6vfpN01M7JvQviMVxg2rGv",
    genre: "russian experimental electronic,russian techno",
    popularity: "3",
  },
  {
    name: "TULEGUR",
    image: "https://i.scdn.co/image/a493f07e1e83fa23e1a484bb09598dcf6e8216af",
    spotify: "0jQe16zVZmizBD65xQA2uK",
    genre: "mongolian folk",
    popularity: "3",
  },
  {
    name: "Mirja Regensburg",
    image: "https://i.scdn.co/image/ab67616d0000b2734baff1fd98f2b5f29612e2cb",
    spotify: "3Z2mIPzOS9g6ghUUDG313t",
    genre: "",
    popularity: "3",
  },
  {
    name: "Valentina Magaletti",
    image: "https://i.scdn.co/image/ab67616d0000b273a684ddeff1c4bf445718b154",
    spotify: "0jPLDwuZUzb6qZdfi5XPHz",
    genre: "experimental percussion",
    popularity: "3",
  },
  {
    name: "Different Fountains",
    image: "https://i.scdn.co/image/ab67616d0000b273dbad97a5a313fb965dcadd05",
    spotify: "4DLwz8gH3lrJRt9ELauLe0",
    genre: "",
    popularity: "3",
  },
  {
    name: "Ryan Boldt",
    image: "https://i.scdn.co/image/ab67616d0000b273b4d036f6c617d084abac93c2",
    spotify: "4iAeJMXqbmqD9w0XDh0Hmz",
    genre: "",
    popularity: "3",
  },
  {
    name: "Ian Daniel Kehoe",
    image: "https://i.scdn.co/image/ab67616d0000b273a74fb820c2036270bfb84700",
    spotify: "6UxXQ0MTRzEV1wORgHam5U",
    genre: "",
    popularity: "3",
  },
  {
    name: "Real Farmer",
    image: "https://i.scdn.co/image/ab67616d0000b2730de2c1d4d2afb9ee70df0fc3",
    spotify: "19lSZSwxm5y6ihi5mODLaK",
    genre: "dutch indie rock",
    popularity: "3",
  },
  {
    name: "A001",
    image: "https://i.scdn.co/image/ab67616d0000b273470e61a9538f118a3b8dde3f",
    spotify: "6hAvaw63F6JlkovV4ZF6jV",
    genre: "industrial techno",
    popularity: "3",
  },
  {
    name: "Project Stigma",
    image: "https://i.scdn.co/image/ab67616d0000b27317d57427315c5154c86247f7",
    spotify: "5hdYItUYkGcdorYgbGJn3H",
    genre: "",
    popularity: "3",
  },
  {
    name: "Courtney Mills",
    image: "https://i.scdn.co/image/ab67616d0000b273c9917702df1e22c79a538f75",
    spotify: "3qJDaGfdm8mcxc3GoxvChT",
    genre: "",
    popularity: "3",
  },
  {
    name: "Josey Rebelle",
    image: "https://i.scdn.co/image/ab67616d0000b273d6b6546b74979e77bf115cbe",
    spotify: "4M9tKwx3n9pIBszhn1pmkH",
    genre: "",
    popularity: "2",
  },
  {
    name: "DJ Flava",
    image: "https://i.scdn.co/image/ab67616d0000b273325688002b25f5e0948f9ecd",
    spotify: "0nGJqSO5CcPXCCMlOI4BqK",
    genre: "",
    popularity: "2",
  },
  {
    name: "Barely Legal",
    image: "https://i.scdn.co/image/4a7ce1c8047454c779878248fd85f2994adf8e86",
    spotify: "2YkB8vM5kYQrRmhp1B14IG",
    genre: "",
    popularity: "2",
  },
  {
    name: "Carola Pisaturo",
    image: "https://i.scdn.co/image/ab67616d0000b27326ccb7ff8c5612f550f2438f",
    spotify: "2zytqlMk8jEmAx6DSL3B9E",
    genre: "",
    popularity: "2",
  },
  {
    name: "Derek Plaslaiko",
    image: "https://i.scdn.co/image/ab67616d0000b273ef453da1c41d539504680629",
    spotify: "09w7CzS8u20G6JcnGWQ2GY",
    genre: "",
    popularity: "2",
  },
  {
    name: "Chris Tietjen",
    image: "https://i.scdn.co/image/9efae1ed71922d90017c5f96351a7c0ba1e69539",
    spotify: "6ifNI6ruLvksUQyS4AlEB9",
    genre: "frankfurt electronic",
    popularity: "2",
  },
  {
    name: "Chris DeLuxe",
    image: "https://i.scdn.co/image/ab67616d0000b2733411e21f7a803e3e3187d6b5",
    spotify: "1toL7N8OIfzRQZPAOkPRTC",
    genre: "",
    popularity: "2",
  },
  {
    name: "Noncompliant",
    image: "https://i.scdn.co/image/ab67616d0000b2733a72dcfd6751fc278897c78f",
    spotify: "6VyjTB8GHDqxggO9vtubnP",
    genre: "",
    popularity: "2",
  },
  {
    name: "Dames Voor Na Vieren",
    image: "https://i.scdn.co/image/ab67616d0000b273c8bb702b795ae812727e7270",
    spotify: "3i9xhu7bmy4PGKna3rEcaw",
    genre: "",
    popularity: "2",
  },
  {
    name: "Pasiphae",
    image: "https://i.scdn.co/image/ab67616d0000b273fb85e5b36b6d9284c2e786a0",
    spotify: "6cdLj7RdQzOQTdzIopMy98",
    genre: "",
    popularity: "2",
  },
  {
    name: "Nuria Ghia",
    image: "https://i.scdn.co/image/ab67616d0000b273ae4504f32abcfdf12e6dfd75",
    spotify: "0wbELPGCHgqc4Mknb5j75K",
    genre: "",
    popularity: "2",
  },
  {
    name: "Sjieke Bazen",
    image: "https://i.scdn.co/image/ac8959d8815aeb286cfdc47abf49dc6d605df0f7",
    spotify: "6zsPXxXMlszXny482H1GnN",
    genre: "",
    popularity: "2",
  },
  {
    name: "Cookachoo",
    image: "https://i.scdn.co/image/ab67616d0000b2735e8b2e2054b5d417b2980203",
    spotify: "3iQ47YRdGCRzPFYNoUUv1C",
    genre: "",
    popularity: "2",
  },
  {
    name: "Danny Wade",
    image: "https://i.scdn.co/image/b4ecaea1c59b946b413edb2ea7f8159952a30032",
    spotify: "7AR9ayBXCABq3lYP1xIWss",
    genre: "sky room",
    popularity: "2",
  },
  {
    name: "Stephanie Louwrier",
    image: "https://i.scdn.co/image/ab67616d0000b2739aff83b9c55aa4ce0e8f0986",
    spotify: "7sX4mYbThVOeX0ze2gR9F7",
    genre: "",
    popularity: "2",
  },
  {
    name: "Storksky",
    image: "https://i.scdn.co/image/67f9d930de13643515bba425d10fb6425dbea567",
    spotify: "0QT8bqsePZQ6c3sOaI1laf",
    genre: "",
    popularity: "2",
  },
  {
    name: "Dorona Alberti",
    image: "https://i.scdn.co/image/ab67616d0000b273459aead9ce1c5e5394818b05",
    spotify: "1wfP2eGV4GJVfxKurwHimj",
    genre: "",
    popularity: "2",
  },
  {
    name: "Lewis Spears",
    image: "https://i.scdn.co/image/ab67616d0000b273b95be0c511af0a9257b3c683",
    spotify: "26Re2SFMOSou2Q2R938BeQ",
    genre: "",
    popularity: "2",
  },
  {
    name: "Miss Sugaware",
    image: "https://i.scdn.co/image/ab67616d0000b2731e6303ff487d17b166988ec2",
    spotify: "2ZYn1jwWie72cdFsB6F8lP",
    genre: "",
    popularity: "2",
  },
  {
    name: "Brat Farrar",
    image: "https://i.scdn.co/image/ab67616d0000b273d194de59b303e63f6254a251",
    spotify: "1QsAnPZCSKV63rtANKXRcv",
    genre: "",
    popularity: "2",
  },
  {
    name: "De Nachtdienst",
    image: "https://i.scdn.co/image/0a65398ec04b166f21884a0317d7a235285501b5",
    spotify: "0b9DlifPhLfxX9NIQVQ5yV",
    genre: "",
    popularity: "2",
  },
  {
    name: "A. Brehme",
    image: "https://i.scdn.co/image/ab67616d0000b273f269195b4fc85ae78ae9a01b",
    spotify: "3IxcUzgMO8kZuOxHcdyNn4",
    genre: "",
    popularity: "2",
  },
  {
    name: "Abby Echiverri",
    image: "https://i.scdn.co/image/ab67616d0000b27312f123924df9882a01bf8225",
    spotify: "1y4rizGpa587FUNVn1jZm2",
    genre: "experimental techno",
    popularity: "2",
  },
  {
    name: "Kirsten van Teijn",
    image: "https://i.scdn.co/image/bc648ebdb9c4598d05de3d3396a62d2025757304",
    spotify: "1iU5WfoFN1MPdQieqiUOxD",
    genre: "",
    popularity: "2",
  },
  {
    name: "Marc Dillon",
    image: "https://i.scdn.co/image/ab67616d0000b273b819769f673b1c5bed18387e",
    spotify: "7KX0ip4OV6ZWZFzv6nn8cO",
    genre: "",
    popularity: "2",
  },
  {
    name: "Sjur Hjeltnes",
    image: "https://i.scdn.co/image/ab67616d0000b273e2f51de1a18121f4f38b1b7a",
    spotify: "00mQwnjEdHLqoVBApNy3V3",
    genre: "",
    popularity: "2",
  },
  {
    name: "Lookapony",
    image: "https://i.scdn.co/image/c123a3816ed34f234cae4472c6283ac66e320dfd",
    spotify: "2kVdIz4ICDvB18lm7jtGd5",
    genre: "dutch indie rock",
    popularity: "2",
  },
  {
    name: "Alec Falconer",
    image: "",
    spotify: "3E7E1RG43TpwTzlX4duGp5",
    genre: "",
    popularity: "2",
  },
  {
    name: "The Irish Vikings",
    image: "https://i.scdn.co/image/ab67616d0000b2730b7e774c2cdef122f8bf7e18",
    spotify: "2ImD9OVyc03GIBmfgj1BBl",
    genre: "",
    popularity: "2",
  },
  {
    name: "MC Knowledje",
    image: "https://i.scdn.co/image/8efa33ac8b69ee49803bb32b151e1b28349228c1",
    spotify: "6HgCnpjiJXPjbQoJxCQDMi",
    genre: "",
    popularity: "2",
  },
  {
    name: "Phil Hawkins",
    image: "https://i.scdn.co/image/ab67616d0000b273aea3efd19daf83f9a0109d33",
    spotify: "7zzaFtmb2SdPZ3jtK9fKcH",
    genre: "",
    popularity: "2",
  },
  {
    name: "The Royal Engineers",
    image: "https://i.scdn.co/image/b3743127ef5cd0cb48c39b0049b33e1f92cb3382",
    spotify: "6jmDLPqQTTBYhaYU96E5eG",
    genre: "",
    popularity: "2",
  },
  {
    name: "Mc Gunner",
    image: "",
    spotify: "1M6jhXl2ipDrScLMrZu869",
    genre: "",
    popularity: "2",
  },
  {
    name: "Mode Seven",
    image: "https://i.scdn.co/image/0999519ee8fb49a47fe32f232a88770ad1a85275",
    spotify: "0AfGUXIBXf7eOIvhOocmYY",
    genre: "jumpstyle",
    popularity: "2",
  },
  {
    name: "Blues Brother Castro",
    image: "https://i.scdn.co/image/ab67616d0000b2732d597ae01bf90cf08f052551",
    spotify: "0GCU9DIafDr14utL6uwKCy",
    genre: "dutch indie",
    popularity: "2",
  },
  {
    name: "Backgammon",
    image: "https://i.scdn.co/image/797d5913cdf020676f46b857b3dd7f7c70e3c301",
    spotify: "3Es8fymoDPZtiwmP0ftQOY",
    genre: "",
    popularity: "2",
  },
  {
    name: "H A S T",
    image: "https://i.scdn.co/image/49c2019ec5f7f622ec9bd7737d68c4cbfb5a61d0",
    spotify: "6Yfns5pZJVZxf6hn1gM3AZ",
    genre: "",
    popularity: "2",
  },
  {
    name: "Too Noisy Fish",
    image: "https://i.scdn.co/image/1215324a45f3f55db069049b740a04b0b5f73d2a",
    spotify: "4rGCNIZT4bFg5krJL9g44Y",
    genre: "belgian modern jazz",
    popularity: "2",
  },
  {
    name: "Tommy Ebben",
    image: "https://i.scdn.co/image/ab67616d0000b2731fdefa78b32c7ca267b84c10",
    spotify: "49xGpv8WAC8yHwm2asZRyS",
    genre: "",
    popularity: "2",
  },
  {
    name: "Johan Cyber",
    image: "https://i.scdn.co/image/ab67616d0000b2731bd234a88444bf3694dfa6f0",
    spotify: "32CP7udAc8E4O6c9ZuTNp9",
    genre: "",
    popularity: "2",
  },
  {
    name: "Scott Franka",
    image: "https://i.scdn.co/image/ab67616d0000b2739dc19e2c8ac3d7de6047bf64",
    spotify: "03RDDOfQDA7S1CjhERIKH0",
    genre: "",
    popularity: "2",
  },
  {
    name: "Spirit Valley",
    image: "https://i.scdn.co/image/ab67616d0000b273e808fce38b47e10c21d3f828",
    spotify: "5cDziXUtbTd8HKlOYyzzj3",
    genre: "",
    popularity: "2",
  },
  {
    name: "An Pierlé Quartet",
    image: "https://i.scdn.co/image/ab67616d0000b273908789fee8fe6286235e37a5",
    spotify: "3kQqOgWbhg3EwLNC7rRCum",
    genre: "",
    popularity: "2",
  },
  {
    name: "Jonas Palzer",
    image: "https://i.scdn.co/image/bf171a3bb0b3c5b442f68cabd2598cada36826e8",
    spotify: "2ZTkpmBC59qimZ2mvpr6Kq",
    genre: "experimental house",
    popularity: "2",
  },
  {
    name: "Hozinotik",
    image: "https://i.scdn.co/image/ab67616d0000b273df4ce37c815abdbf198cdf6f",
    spotify: "1p7bTEY28TS13tl4QdiX8E",
    genre: "",
    popularity: "2",
  },
  {
    name: "Amanda Pearcy",
    image: "https://i.scdn.co/image/ab67616d0000b273bdb356c37308da36436c337a",
    spotify: "1US5ondK4jO1GBAEiBnkZh",
    genre: "",
    popularity: "2",
  },
  {
    name: "Mich Walschaerts",
    image: "",
    spotify: "0QyhR1x8q2dqhHeS1sx12V",
    genre: "",
    popularity: "2",
  },
  {
    name: "Grace Dahl",
    image: "https://i.scdn.co/image/90e9a8f64f0844ceb52f5479bc03f00e93d77be3",
    spotify: "0sjYkVBR192ZyleNslaZIB",
    genre: "",
    popularity: "2",
  },
  {
    name: "Color Reporters",
    image: "https://i.scdn.co/image/ab67616d0000b273badaf9ed9b1b92f56b09d75b",
    spotify: "5nXoDYznpKdhitHZepE9RV",
    genre: "",
    popularity: "2",
  },
  {
    name: "DJ Slyngshot",
    image: "https://i.scdn.co/image/313c2e5db11ad926db5c73b99abf5002b22cf8df",
    spotify: "2Y8OggXi8PtBKTRL5J8fDf",
    genre: "frankfurt electronic",
    popularity: "2",
  },
  {
    name: "John Lagora",
    image: "https://i.scdn.co/image/018295617fa7c776c93e808c88b562ff676a7837",
    spotify: "0InanX5BeEplj0E5LkIINA",
    genre: "",
    popularity: "2",
  },
  {
    name: "Jack Tucker",
    image: "",
    spotify: "56tsMvfmfLHgCYl3xpghby",
    genre: "honky tonk",
    popularity: "2",
  },
  {
    name: "Magic Mirror",
    image: "https://i.scdn.co/image/ab67616d0000b2738983ad314f26e2c3d9717a46",
    spotify: "4g5yNXik8TNSAznFsp3AP5",
    genre: "psych gaze",
    popularity: "2",
  },
  {
    name: "Hard Infantry",
    image: "https://i.scdn.co/image/5f17fb2d89473dfecb998e3d028ca1023120d916",
    spotify: "34UmMvC3h7IBuED0FUmSk3",
    genre: "",
    popularity: "2",
  },
  {
    name: "Wasted Bullet",
    image: "https://i.scdn.co/image/ab67616d0000b273fc00d6c9ef23ba70886a85c3",
    spotify: "5WF8dzNeY5pe7jG0gBwYxN",
    genre: "deep melodic metalcore",
    popularity: "2",
  },
  {
    name: "Francesco Robustelli",
    image: "https://i.scdn.co/image/ab67616d0000b273f5cb35faa79daa6eebda2740",
    spotify: "0iUvnR7Oign9QOYKTtDmsa",
    genre: "",
    popularity: "2",
  },
  {
    name: "Namibian Tales",
    image: "https://i.scdn.co/image/ab67616d0000b27348366cec1bbb7e2b7fa9c767",
    spotify: "0ozXF4A23XmPiCs8jSQIwo",
    genre: "namibian pop",
    popularity: "2",
  },
  {
    name: "My Generation",
    image: "https://i.scdn.co/image/ab67616d0000b273e8e4fb4236f7e7016211f690",
    spotify: "3NGMvCaVravz9cgKCPIoz4",
    genre: "",
    popularity: "2",
  },
  {
    name: "Richard Carter",
    image: "https://i.scdn.co/image/810102e62f6b1b0cc9478679bf745217e172be79",
    spotify: "6jlwBcuB3gOuSR4Hb6MmVU",
    genre: "",
    popularity: "2",
  },
  {
    name: "Leo Leal",
    image: "https://i.scdn.co/image/c787958f0dc4d00f745b27459b59351d766fa149",
    spotify: "3AT1caLeXf4YiYWvO9PRex",
    genre: "",
    popularity: "2",
  },
  {
    name: "Not.Your.Regular.Boy.",
    image: "https://i.scdn.co/image/b622b068665261b37d5d32ac75e2b6bce0f04d69",
    spotify: "5ZJM0ylE0CtrDAfwmzFJdO",
    genre: "",
    popularity: "2",
  },
  {
    name: "Vimarida",
    image: "https://i.scdn.co/image/54b31fe59bccaa9b1c7aac939528c726180cdf7d",
    spotify: "0jIggNTy6QN8swREWof06K",
    genre: "",
    popularity: "2",
  },
  {
    name: "John Warwick",
    image: "https://i.scdn.co/image/1d06c3f82c4034c37a363047f5bdb884f4f14def",
    spotify: "5mSMeiHSnYooTtDHJTHlRZ",
    genre: "",
    popularity: "2",
  },
  {
    name: "Trevor Wallace",
    image: "https://i.scdn.co/image/ab67616d0000b273216dedbd12763451acde39f1",
    spotify: "4ql55xiPKpD2qoLEwhWElJ",
    genre: "",
    popularity: "2",
  },
  {
    name: "Jörg Knör",
    image: "https://i.scdn.co/image/ab67616d0000b273f0c4c27c8110edbb3c762a74",
    spotify: "6jKaFTuNAPBBGiJuzmum0m",
    genre: "",
    popularity: "2",
  },
  {
    name: "Ziggy Splynt",
    image: "https://i.scdn.co/image/600366999c6646cbf74c0e8524c62d5ec656d90a",
    spotify: "4oir9P7N9MiPOR415qvhxl",
    genre: "",
    popularity: "2",
  },
  {
    name: "Max Abysmal",
    image: "https://i.scdn.co/image/ab67616d0000b273cfb7b69d80c56a4b843a8b47",
    spotify: "3JLw4wJ3UrYdQZVdopdDam",
    genre: "",
    popularity: "2",
  },
  {
    name: "The Baby Seals",
    image: "https://i.scdn.co/image/ab67616d0000b273b1060a4fe42358e1ba69d1cf",
    spotify: "6dPxlBjTjehWM4VRwl2bmw",
    genre: "east anglia indie",
    popularity: "2",
  },
  {
    name: "Michelle David and The Gospel Sessions",
    image: "",
    spotify: "7IMQkAdlyruPXOdax4rTzB",
    genre: "",
    popularity: "1",
  },
  {
    name: "Tobias Neumann",
    image: "",
    spotify: "3kGgulhCcL75Afz7oeDf4O",
    genre: "",
    popularity: "1",
  },
  {
    name: "Ruthless Mc",
    image: "",
    spotify: "0HFXtpL71uxqIMzlkAm0C4",
    genre: "",
    popularity: "1",
  },
  {
    name: "Gustavo Toker",
    image: "https://i.scdn.co/image/ab67616d0000b273dfdfb98606d52d51d8e68bc0",
    spotify: "50U0zsxvvN1rCoIPkPaTmM",
    genre: "",
    popularity: "1",
  },
  {
    name: "JP Harris and the Tough Choices",
    image: "",
    spotify: "318y3Vaqu8OMt3CsgzqiTA",
    genre: "roots americana",
    popularity: "1",
  },
  {
    name: "Antenes",
    image: "",
    spotify: "0ijP6cT3Od6HRuXfXU1A7P",
    genre: "",
    popularity: "1",
  },
  {
    name: "Eric De Man",
    image: "https://i.scdn.co/image/ab67616d0000b273e5d71ed753e776893503d2c9",
    spotify: "06leg36hSe4nlzO6jK35xt",
    genre: "dutch tech house",
    popularity: "1",
  },
  {
    name: "Paris Lawrence",
    image: "https://i.scdn.co/image/11347618cf4a69e3f59373ebd7697fac1ce4b1d2",
    spotify: "0sI4V22SN3VIjA58kuHiqb",
    genre: "",
    popularity: "1",
  },
  {
    name: "The Irrational Library",
    image: "https://i.scdn.co/image/b33590d187fce853bdf410dc1ea2a900b07d5804",
    spotify: "0X3j5iteqa7amL7MDcGawb",
    genre: "",
    popularity: "1",
  },
  {
    name: "Mika Oki",
    image: "",
    spotify: "62z94HFZ1L7VGAgwjUzKDg",
    genre: "",
    popularity: "1",
  },
  {
    name: "KUDDEDIEREN",
    image: "https://i.scdn.co/image/ab67616d0000b273041591ed21af16fc4c01a573",
    spotify: "2HGq8cNVzto0ZLkQUeD3TG",
    genre: "",
    popularity: "1",
  },
  {
    name: "Mikey Motion",
    image: "https://i.scdn.co/image/ab67616d0000b273c618ebe5b65f9245511c1d82",
    spotify: "26EI7OFplaqcLsVLXAbqAG",
    genre: "",
    popularity: "1",
  },
  {
    name: "Kamagurka",
    image: "https://i.scdn.co/image/ab67616d0000b2732c477bba7380cc922add569e",
    spotify: "19ljWwInALgammoznU9lEi",
    genre: "vlaamse cabaret",
    popularity: "1",
  },
  {
    name: "Ruby Phoenix",
    image: "https://i.scdn.co/image/3e52298f25993af68fc6b5bd6ea43efff99a4c08",
    spotify: "2Z2uLFhhYoOzKs0itthKKe",
    genre: "",
    popularity: "1",
  },
  {
    name: "Bas Dobbelaer",
    image: "https://i.scdn.co/image/ab67616d0000b27316b6f724b8ecc307b4b6cad0",
    spotify: "7rdo5EGP04tRDCzuMFNfG8",
    genre: "",
    popularity: "1",
  },
  {
    name: "Florinsz Janvier",
    image: "https://i.scdn.co/image/ab67616d0000b27348f9c6eaa90ec9472baec460",
    spotify: "3TrYMquyQWtvLrVU9ro39x",
    genre: "",
    popularity: "1",
  },
  {
    name: "Soweto Soul",
    image: "https://i.scdn.co/image/ab67616d0000b273435ce842a5ac957368b9b150",
    spotify: "7MC02ba1ZpwU3uENHcG0AB",
    genre: "",
    popularity: "1",
  },
  {
    name: "Frank Haag",
    image: "https://i.scdn.co/image/ab67616d0000b2733347fe8bc0054bc671e4e954",
    spotify: "62p1aDUd9JydSGFqRSYZVz",
    genre: "",
    popularity: "1",
  },
  {
    name: "Kurkdroog",
    image: "https://i.scdn.co/image/ab67616d0000b273787904916034818514f9fe60",
    spotify: "0P0hEYOEcxJkouounBWcf0",
    genre: "",
    popularity: "1",
  },
  {
    name: "Desert Hearts",
    image: "https://i.scdn.co/image/ab67616d0000b273113b1457ab033ef946665dbf",
    spotify: "7h0PjBmWXxgVosWIokFmYk",
    genre: "northern irish indie",
    popularity: "1",
  },
  {
    name: "A Polaroid View",
    image: "https://i.scdn.co/image/ab67616d0000b273d08048ade69312994fc75238",
    spotify: "3WIEpfogXTPtO4F2a5sDII",
    genre: "",
    popularity: "1",
  },
  {
    name: "Matt Ball",
    image: "https://i.scdn.co/image/ab67616d0000b273ed40ab97416c4e5d3e2a04af",
    spotify: "5Owm3U6wqmL4Vhj3s3HiIY",
    genre: "",
    popularity: "1",
  },
  {
    name: "Gideon Bouwens",
    image: "",
    spotify: "48COg5UwBETqDxk7Ju78nN",
    genre: "",
    popularity: "1",
  },
  {
    name: "Zac DePetro",
    image: "https://i.scdn.co/image/ab67616d0000b27355da0c0c0d26d3ca67fbdbcb",
    spotify: "41VQPmLKwzxZG8c8AYzAHT",
    genre: "",
    popularity: "1",
  },
  {
    name: "Will Oirson",
    image: "https://i.scdn.co/image/ab67616d0000b273a20ad474d4b036bd662bda73",
    spotify: "40UMs8a3Est0r7Z1ogeWyz",
    genre: "",
    popularity: "1",
  },
  {
    name: "Dataklysm",
    image: "https://i.scdn.co/image/ab67616d0000b27352d0bd4252f3d5429fab4cc6",
    spotify: "3sgoUF0nOCLIrL2wAJxaRN",
    genre: "industrial hardcore",
    popularity: "1",
  },
  {
    name: "Kevin Arnemann",
    image: "https://i.scdn.co/image/9147388d53c60c8eb4c04a2158ef5a184a247f75",
    spotify: "6MYfgPjVhyQOx7mMJ7gvl0",
    genre: "",
    popularity: "1",
  },
  {
    name: "Sekula",
    image: "https://i.scdn.co/image/ab67616d0000b273b598fcd1d7def40f29233e56",
    spotify: "1AWY1AtxyeTwbDK9tdcaoT",
    genre: "",
    popularity: "1",
  },
  {
    name: "WANNABEASTAR",
    image: "https://i.scdn.co/image/ab67616d0000b2737a91429d99aa4945a88d101c",
    spotify: "3C6JcVLi0sBwPEEGGfdKrq",
    genre: "",
    popularity: "1",
  },
  {
    name: "Carrie Stacks",
    image: "",
    spotify: "1u6pblD6F5mD4sT6iGHvNE",
    genre: "",
    popularity: "1",
  },
  {
    name: "Mattijs Verhallen",
    image: "",
    spotify: "3yzSm0Ucr0DK80cx2RcOtw",
    genre: "",
    popularity: "1",
  },
  {
    name: "Guild of Stags",
    image: "https://i.scdn.co/image/ab67616d0000b273cddc0ce16f94394f7803abc0",
    spotify: "6qWrwe8yCELCN6D8T1MwF9",
    genre: "",
    popularity: "1",
  },
  {
    name: "D-Ribeiro",
    image: "https://i.scdn.co/image/ab67616d0000b273c34f51b43ee24e2eb1da5272",
    spotify: "0xEpC1kvLauPWL6wET70gg",
    genre: "",
    popularity: "1",
  },
  {
    name: "Colin Waters",
    image: "https://i.scdn.co/image/7af878d7f74a9c9423e108cea5291c74998eb258",
    spotify: "25IdCk19Oby9TgU07GK03Z",
    genre: "",
    popularity: "1",
  },
  {
    name: "Good Things End",
    image: "https://i.scdn.co/image/6c935c4ee931daace0a15ccb7da2b03465246296",
    spotify: "2iEXpZ68gmheY1m1t9O5P8",
    genre: "",
    popularity: "1",
  },
  {
    name: "Jailhouse Jimmy",
    image: "https://i.scdn.co/image/8227649a72b6dc6689b8990032783c791a981a1e",
    spotify: "2KBDTBkDM7YSqgFVREtLzz",
    genre: "",
    popularity: "1",
  },
  {
    name: "Smutfish",
    image: "https://i.scdn.co/image/ab67616d0000b273de15c88e259460bfe7e01d6f",
    spotify: "0Et2yZTnbSTyn0GC2abW5O",
    genre: "",
    popularity: "1",
  },
  {
    name: "Ugur Yurt",
    image: "https://i.scdn.co/image/ab67616d0000b273a4f1ed0d3623d2036f3dfe68",
    spotify: "6ce0TwgGqYarPIidKjnsuC",
    genre: "",
    popularity: "1",
  },
  {
    name: "MC Pryme",
    image: "https://i.scdn.co/image/ab67616d0000b2733542cb82e93dc3cf7d16c21a",
    spotify: "5lWZtunb40JWzyL1opSeLe",
    genre: "",
    popularity: "1",
  },
  {
    name: "Hakim Murphy",
    image: "https://i.scdn.co/image/ab67616d0000b2730256c18ad8eeca41ca3dc439",
    spotify: "6TqSxChIRx8UEyaSNPEpvK",
    genre: "",
    popularity: "1",
  },
  {
    name: "Kevin Arnold",
    image: "",
    spotify: "1Bj2rcwnB35vFM6xM66965",
    genre: "",
    popularity: "1",
  },
  {
    name: "Wil van der Meer",
    image: "https://i.scdn.co/image/182d6b1cd183c89149003740aab2197ae1894caf",
    spotify: "7BqMbLjl47sVa9jEKxPGwZ",
    genre: "",
    popularity: "1",
  },
  {
    name: "Steven Lambke",
    image: "https://i.scdn.co/image/ab67616d0000b2735f6852210c388bf1f67062c1",
    spotify: "42ViayamkigAOVp8yh9cQ2",
    genre: "",
    popularity: "1",
  },
  {
    name: "Silent War",
    image: "https://i.scdn.co/image/ab67616d0000b273fbae5f86b6facb8a87d54f8a",
    spotify: "26S63lPt3gCcNtPr0q4aW9",
    genre: "",
    popularity: "1",
  },
  {
    name: "Sam Kidel",
    image: "https://i.scdn.co/image/ab67616d0000b273c0c65290ef65720278513ecc",
    spotify: "4WCDcsrewDeJhGEkxItinZ",
    genre: "bristol electronic,sound collage,uk experimental electronic",
    popularity: "1",
  },
  {
    name: "Rosie Kate",
    image: "https://i.scdn.co/image/e525cd07fdb5a21c83811e51b7aca953e9109ec1",
    spotify: "0xrLQlrBpNDgPr0DrBmpxg",
    genre: "",
    popularity: "1",
  },
  {
    name: "Danny Benedettini",
    image: "https://i.scdn.co/image/ab67616d0000b2734ce4109c33a1d91de11db2ec",
    spotify: "5kS4QXl5aZKE5xRLCUdhQQ",
    genre: "",
    popularity: "1",
  },
  {
    name: "Claudia Anderson",
    image: "https://i.scdn.co/image/ab67616d0000b2732a4c1c33b5f2f08f026d33fb",
    spotify: "4kvzR95hBiaKYKTrVxKnhA",
    genre: "experimental techno",
    popularity: "1",
  },
  {
    name: "Peter Invasion",
    image: "https://i.scdn.co/image/96b189c0dc3c9ea5998e6c92c3dfec4f46e3833b",
    spotify: "7D4GSXuwe3MjSaohBt8aoE",
    genre: "",
    popularity: "1",
  },
  {
    name: "Rolf Saxer",
    image: "https://i.scdn.co/image/ab67616d0000b2734f16717a299c534af1f40bee",
    spotify: "4okWSmtfUVgqLqHj8BG9Uy",
    genre: "swiss techno",
    popularity: "1",
  },
  {
    name: "Gaby Endo",
    image: "https://i.scdn.co/image/ab67616d0000b2737af78b6891b0e3d901046f98",
    spotify: "5he7yS5IiJHPhOXmUCmsSX",
    genre: "",
    popularity: "1",
  },
  {
    name: "Horses On Fire",
    image: "https://i.scdn.co/image/ab67616d0000b273464e0bb53984aa1a394afda5",
    spotify: "662o3kwuJHcZ3T0wmP5zSy",
    genre: "",
    popularity: "1",
  },
  {
    name: "Baby Galaxy",
    image: "https://i.scdn.co/image/ab67616d0000b273dd09e62cfff5c857acd3f409",
    spotify: "1E6bWysqQXsHfoXVBm9htI",
    genre: "",
    popularity: "1",
  },
  {
    name: "Sturle Dagsland",
    image: "https://i.scdn.co/image/ab67616d0000b27381333fad7eb480588715e8c5",
    spotify: "56nGFSsDs8mAZWFwu5N92p",
    genre: "experimental vocal,norwegian experimental",
    popularity: "1",
  },
  {
    name: "Half Way Station",
    image: "https://i.scdn.co/image/ab67616d0000b273a6b9e3b277f210d99f9f7327",
    spotify: "70PhGQHafbaUqVsZ8BZZFn",
    genre: "rotterdam indie",
    popularity: "1",
  },
  {
    name: "Ethan Johns",
    image: "https://i.scdn.co/image/c67f2c9df7b44fcac2feb55eb595922a85df14cb",
    spotify: "6Ge6AZje6TXJXR0f6wwlrc",
    genre: "uk americana",
    popularity: "1",
  },
  {
    name: "Desudo",
    image: "https://i.scdn.co/image/ab67616d0000b2738424a17848bcd90f3b8eb8ba",
    spotify: "2wDIsuYcHrW7z9lDJZkp2k",
    genre: "",
    popularity: "1",
  },
  {
    name: "Jeroen Meertens",
    image: "https://i.scdn.co/image/209ec1d0a242e16eddfdaf345e384f29df0f0602",
    spotify: "61P0DysszG6c91XSGBI3Ch",
    genre: "",
    popularity: "1",
  },
  {
    name: "Eryk Gee",
    image: "https://i.scdn.co/image/ab67616d0000b2737acc2c1c4194314d5f767525",
    spotify: "42YaS7AhQHfau7qGzRyic3",
    genre: "",
    popularity: "1",
  },
  {
    name: "Angel Molina",
    image: "https://i.scdn.co/image/dd4a46f02609daf994ee4eda9aef42af5aec414c",
    spotify: "5fDFusPakvOEqcZqekKG7J",
    genre: "spanish techno",
    popularity: "1",
  },
  {
    name: "Pete Bandit",
    image: "https://i.scdn.co/image/ab67616d0000b27363df01f422f194ed73be3863",
    spotify: "5mMytxYnYxBvHf0k6ql9Vh",
    genre: "",
    popularity: "1",
  },
  {
    name: "Sweetgodanimals",
    image: "https://i.scdn.co/image/ab67616d0000b273d02b8dc1ed56abd19ded3480",
    spotify: "3cMLqP3LTaIMxUmmvkV9Cq",
    genre: "",
    popularity: "1",
  },
  {
    name: "Sabine Happard",
    image: "https://i.scdn.co/image/ab67616d0000b273922b59405d0470c631439e9a",
    spotify: "5OFaOMsz8yM2DAZjfFbsEn",
    genre: "",
    popularity: "1",
  },
  {
    name: "Ode Maen",
    image: "https://i.scdn.co/image/ab67616d0000b2731b494fe995e8f7f4dca4038a",
    spotify: "2aK6kf70Gxte5OK7VxQ5vS",
    genre: "",
    popularity: "1",
  },
  {
    name: "Tommy Santo",
    image: "https://i.scdn.co/image/fa43a1b04246b1aca06f5289972f36f119ccc68e",
    spotify: "1vcn4WtzeokcrSCoZEJftG",
    genre: "",
    popularity: "0",
  },
  {
    name: "Nathalie Baartman",
    image: "https://i.scdn.co/image/ab67616d0000b2737ac580f74898d39739d201e1",
    spotify: "0slIrafFhMTfInVtwIZn1z",
    genre: "",
    popularity: "0",
  },
  {
    name: "Dennis Davidson",
    image: "https://i.scdn.co/image/ab67616d0000b2730b4b3d882f5b6808066f7546",
    spotify: "1qJCin7WU7cFOmgzuv4lmP",
    genre: "",
    popularity: "0",
  },
  {
    name: "The Petticoats",
    image: "https://i.scdn.co/image/ab67616d0000b2736ffbf3bd0547ffb17fd480d2",
    spotify: "2ryXjsNW0n5FGeLUeCoVmG",
    genre: "",
    popularity: "0",
  },
  {
    name: "Carlos Souffront",
    image: "",
    spotify: "2LikGqL9FQ9txHmYID3nsL",
    genre: "",
    popularity: "0",
  },
  {
    name: "Nathalie Capello",
    image: "",
    spotify: "1srcs6UjveIQeNXTVVDWJx",
    genre: "",
    popularity: "0",
  },
  {
    name: "Terry Toner",
    image: "",
    spotify: "1RpSHno2RujpVpes6GutJ4",
    genre: "",
    popularity: "0",
  },
  {
    name: "Ellen Pieters",
    image: "",
    spotify: "4CMfNEzD9djWDwYiEIJZon",
    genre: "",
    popularity: "0",
  },
  {
    name: "Mikey Nice",
    image: "",
    spotify: "4S2iFKdvWwQWWvbtFAsyAL",
    genre: "",
    popularity: "0",
  },
  {
    name: "Studio Blue",
    image: "https://i.scdn.co/image/ab67616d0000b27339cbb79621356d8f2029c177",
    spotify: "3gRaDO2jQVAmgblaQMFCN8",
    genre: "",
    popularity: "0",
  },
  {
    name: "Celebrate Life",
    image: "https://i.scdn.co/image/ab67616d0000b2737a6f3f42c019755ceb4c3667",
    spotify: "40S2gYYRGegndnqKeIhO6e",
    genre: "",
    popularity: "0",
  },
  {
    name: "Bart van Dishoeck",
    image: "https://i.scdn.co/image/ab67616d0000b273e7f44aa9bfec2e97f9cb3829",
    spotify: "2qLYqXvG2mFXR7IVgbycNf",
    genre: "",
    popularity: "0",
  },
  {
    name: "Sebastian Sleebos",
    image: "https://i.scdn.co/image/ab67616d0000b2737c07ad6c2a8a5fdd14710aaf",
    spotify: "5wKvjLOD03fZ9iIUjRyyuo",
    genre: "",
    popularity: "0",
  },
  {
    name: "Robert Bergman",
    image: "",
    spotify: "4W5YdsRCiTX1iQxo8gK0z9",
    genre: "",
    popularity: "0",
  },
  {
    name: "Gerthein Boersma",
    image: "https://i.scdn.co/image/ab67616d0000b27369ef1476d778dafc545d2f51",
    spotify: "589kc2JuWS8JmfcC9erInu",
    genre: "",
    popularity: "0",
  },
  {
    name: "Papa Lauda",
    image: "https://i.scdn.co/image/ab67616d0000b273a7dd687396f06e77da358e92",
    spotify: "4cybiU9jvv2KRLzI6cMSlt",
    genre: "",
    popularity: "0",
  },
  {
    name: "MC Toxicalz",
    image: "https://i.scdn.co/image/ab67616d0000b273b57def919459f6db300522fe",
    spotify: "3zc3aCkf40Q8xQqv4HrgGZ",
    genre: "",
    popularity: "0",
  },
  {
    name: "The London African Gospel Choir",
    image: "https://i.scdn.co/image/ab67616d0000b273bdd6008f8a1108f9b2d8ca21",
    spotify: "2A6j5HBPZJaoA7azbugBHP",
    genre: "",
    popularity: "0",
  },
  {
    name: "Sam Withers",
    image: "https://i.scdn.co/image/ab67616d0000b27391e2d5523c30bbc69001d6c7",
    spotify: "5akRNjHgiMndI3tqSHN1IX",
    genre: "",
    popularity: "0",
  },
  {
    name: "Kevin Keating",
    image: "https://i.scdn.co/image/ab67616d0000b27350d587df8a03a89e4edb9982",
    spotify: "35m6auM5PpoQ2Dlgmfmew7",
    genre: "",
    popularity: "0",
  },
  {
    name: "Finn Johannsen",
    image: "https://i.scdn.co/image/ab67616d0000b273504978878045c3a6d9ba4f23",
    spotify: "6M4dVnuXA9bNFfQLYB4uww",
    genre: "",
    popularity: "0",
  },
  {
    name: "Black Peppers",
    image: "https://i.scdn.co/image/ab67616d0000b273b7b3d90fb2607941d8d37033",
    spotify: "67BPSKSUuNjEHZ7G3cr49o",
    genre: "",
    popularity: "0",
  },
  {
    name: "Coen Leenheer",
    image: "https://i.scdn.co/image/8803aefd4695727297ecf0d797e8c8e5abcf535f",
    spotify: "7cGtLRe6PX1dW7aXuhc8Lw",
    genre: "",
    popularity: "0",
  },
  {
    name: "Niki Sadeki",
    image: "https://i.scdn.co/image/7ec1529305087ba3a3405098dec12690d2c4d289",
    spotify: "6EPDGWtjFjPHUYlOYsoj14",
    genre: "",
    popularity: "0",
  },
  {
    name: "Wilfried de Jong",
    image: "https://i.scdn.co/image/ab67616d0000b273795ee89b4414d3cf2c97220a",
    spotify: "6keJuuwdpecBYW7apUQVHF",
    genre: "",
    popularity: "0",
  },
  {
    name: "Rene Engel",
    image: "https://i.scdn.co/image/ab67616d0000b27326e946bc49dfe808bc5cc389",
    spotify: "6EnLaxrJ7yKxjW3c6H9Qzh",
    genre: "",
    popularity: "0",
  },
  {
    name: "The Party Group",
    image: "https://i.scdn.co/image/ab67616d0000b273d31878db790caac69d8755e9",
    spotify: "6DFmStthqDDkaZQiApvx9s",
    genre: "",
    popularity: "0",
  },
  {
    name: "Mexican Surf",
    image: "https://i.scdn.co/image/dd583b75a3986de2364d5a82ed92c5ea7f293caa",
    spotify: "6DU91MFzlE3NbfM08D3Nse",
    genre: "dutch indie rock",
    popularity: "0",
  },
  {
    name: "Karsu Dönmez",
    image: "",
    spotify: "4qjo4PLuaGUHgn2J4NSK6R",
    genre: "",
    popularity: "0",
  },
  {
    name: "MC Ad-Apt",
    image: "https://i.scdn.co/image/ab67616d0000b2737ba1a3e192501b252d59220f",
    spotify: "30rJjZheyz0TTjxoX7zwtk",
    genre: "",
    popularity: "0",
  },
  {
    name: "Kevin Kofii",
    image: "https://i.scdn.co/image/ca5cba8ad4423c5186230399e6ad1bd2c95d4c5b",
    spotify: "2CxkuDAdwEsImP1aGV6WWj",
    genre: "",
    popularity: "0",
  },
  {
    name: "Vindla String Quartet",
    image: "https://i.scdn.co/image/ab67616d0000b273dc0a24b1fcf1593976786842",
    spotify: "6coopPlKS3hznJ3tGWPPYp",
    genre: "",
    popularity: "0",
  },
  {
    name: "Flavour Drop",
    image: "https://i.scdn.co/image/c7e1e6aa322177a6bf277c349b2c6e57f15f9c4e",
    spotify: "7GgXsyPOcI5Zc7UQKqCGeu",
    genre: "",
    popularity: "0",
  },
  {
    name: "Michael Thoelen",
    image: "",
    spotify: "21kNBuHGlt3A7W7iEW3uKA",
    genre: "",
    popularity: "0",
  },
  {
    name: "2Shy MC",
    image: "https://i.scdn.co/image/742b81495a1b9b2318a974c803dbe75c1521dddb",
    spotify: "30ng7xkwMyGUGnsGEIWWtb",
    genre: "",
    popularity: "0",
  },
  {
    name: "Joe Craig",
    image: "https://i.scdn.co/image/7d21a36d23c1ffe920156fff5175a6caaa93e3f5",
    spotify: "1R71hBXCaSnEWDdXiidsVO",
    genre: "",
    popularity: "0",
  },
  {
    name: "Robba Rovega",
    image: "https://i.scdn.co/image/ab67616d0000b273746e0bcca7e0b2b491941a5c",
    spotify: "3MBiGPT4m71QY8wDbfw89G",
    genre: "",
    popularity: "0",
  },
  {
    name: "Cheap Charly Men",
    image: "https://i.scdn.co/image/ab67616d0000b2738eb18acf884212ae80d9847f",
    spotify: "15s6JSDxRysKaAMNw3Trme",
    genre: "",
    popularity: "0",
  },
  {
    name: "Lasershow",
    image: "",
    spotify: "0xk0ySCPvuaaCMpdwbC1fO",
    genre: "",
    popularity: "0",
  },
  {
    name: "Harvey Al Dante",
    image: "https://i.scdn.co/image/39a26bf7485c9e3087b12741f2c76c1e9ed03258",
    spotify: "07Hb6eJD2UIbXc26vUBYbV",
    genre: "",
    popularity: "0",
  },
  {
    name: "Nene Dasile",
    image: "https://i.scdn.co/image/ab67616d0000b27315238b042692233cb1e5e965",
    spotify: "0FxgozxFbXwU1fvlRWvOtT",
    genre: "",
    popularity: "0",
  },
  {
    name: "Molly Maguires",
    image: "https://i.scdn.co/image/ab67616d0000b27374538b8745773595f04c8eb1",
    spotify: "0SF1yioJH77XrQq1wGXlN1",
    genre: "",
    popularity: "0",
  },
  {
    name: "ARTIST X",
    image: "https://i.scdn.co/image/03f9123deced7e199b625ab04afbfbd46913599d",
    spotify: "2cpE7hhLD5JaKHVA6loZFk",
    genre: "",
    popularity: "0",
  },
  {
    name: "Beautiful Strangers",
    image: "https://i.scdn.co/image/ab67616d0000b273507073933b06aa5b5ce993e3",
    spotify: "34jDSfjUZq5POVzRxgQIJn",
    genre: "nwocr",
    popularity: "0",
  },
  {
    name: "BlackPeppers",
    image: "https://i.scdn.co/image/ab67616d0000b2731390aa0885115f25963a6796",
    spotify: "2s4DqRtoWnFRAqBV29wXlb",
    genre: "",
    popularity: "0",
  },
  {
    name: "E.T. Explore Me",
    image: "https://i.scdn.co/image/ab67616d0000b273c0e7936f8eb7af3a183177b9",
    spotify: "2URqTl29L651PdZqzEPCUx",
    genre: "",
    popularity: "0",
  },
  {
    name: "The Lumes",
    image: "https://i.scdn.co/image/491baae769573933a98a0f756125a1046936dfa9",
    spotify: "20qV6nfkXjTMiIvIaptSsE",
    genre: "rotterdam indie",
    popularity: "0",
  },
  {
    name: "Thrashmachine",
    image: "",
    spotify: "6GU46TeSBQpF4VT5CwkDxe",
    genre: "",
    popularity: "0",
  },
  {
    name: "Kris Ralph",
    image: "",
    spotify: "2jIj8BFziK4ZUqW867Tuuy",
    genre: "",
    popularity: "0",
  },
  {
    name: "Volition Immanent",
    image: "",
    spotify: "0uyxIVxdjfBcVXbCQVmX0R",
    genre: "",
    popularity: "0",
  },
  {
    name: "Country Cafe",
    image: "https://i.scdn.co/image/ab67616d0000b2737c653afdc3367c3bba988ebd",
    spotify: "0IRueQCAVVTkERbtIREpkj",
    genre: "",
    popularity: "0",
  },
  {
    name: "Sounds Of Harlowe",
    image: "https://i.scdn.co/image/a351464f1f978ac2c57e43b7c4d731ed42892b25",
    spotify: "43mefOQ3yO75n3QrNBdn7q",
    genre: "",
    popularity: "0",
  },
  {
    name: "The Stangs",
    image: "https://i.scdn.co/image/1f629b3b0785ed532c2e462a2c621c1e9562834e",
    spotify: "7y3bThlhhys45PuilLFIzq",
    genre: "",
    popularity: "0",
  },
  {
    name: "Lennaert Maes",
    image: "https://i.scdn.co/image/ab67616d0000b2730aa0e4ebe51839d723fe6bd1",
    spotify: "3M6AVd6C3NV1jsvCqIrvwr",
    genre: "kleinkunst",
    popularity: "0",
  },
  {
    name: "Captain Steel",
    image: "",
    spotify: "3MisdOnSSpMjTN44344s8E",
    genre: "",
    popularity: "0",
  },
  {
    name: "Ian Redman",
    image: "https://i.scdn.co/image/613cdc27a0a28708d5584caa755185ba3d591da6",
    spotify: "5alrveNuQyyaOK9rgOW335",
    genre: "",
    popularity: "0",
  },
  {
    name: "The Royal Hillbilly Club",
    image: "https://i.scdn.co/image/44023ace3fcabb5243109b7e42e9d64baa4b9f27",
    spotify: "4p0PGi4kpKX8vM6WifYISD",
    genre: "",
    popularity: "0",
  },
  {
    name: "The Gwoof",
    image: "https://i.scdn.co/image/d28e6e7cc4ca6f726ef18aea67ee3e653603677f",
    spotify: "1oR7hVP4q9OGdTcoTWYxxs",
    genre: "",
    popularity: "0",
  },
  {
    name: "Milk TV",
    image: "https://i.scdn.co/image/4ca582b14c0088ea57167a4bf146f0bdecdcd329",
    spotify: "6iTicNZlmOqmxbpYxShHsF",
    genre: "",
    popularity: "0",
  },
  {
    name: "Sascha Visser",
    image: "https://i.scdn.co/image/ab67616d0000b273b9a67a9e9f3ff5c8b2c0fb6b",
    spotify: "5AzxP7xg9gd2kbZH1nhexj",
    genre: "",
    popularity: "0",
  },
  {
    name: "Alex Salvador",
    image: "https://i.scdn.co/image/98d13cc4d956099fe5f65bf57ef15a0ef7d93b2f",
    spotify: "1K8Z2ipl0Hte1arvN5Q1Ht",
    genre: "",
    popularity: "0",
  },
  {
    name: "Hannah Rickard and The Relatives",
    image: "https://i.scdn.co/image/ab67616d0000b273ec8591f595047adf447d4f70",
    spotify: "3zPp9fENN2yuQaNutgZnh8",
    genre: "",
    popularity: "0",
  },
  {
    name: "Dichter",
    image: "https://i.scdn.co/image/ab67616d0000b273037702326311260d7a4904ea",
    spotify: "5W8YM8cDAma7wJLu6Jw4sp",
    genre: "",
    popularity: "0",
  },
  {
    name: "Mango Zabba",
    image: "",
    spotify: "1pscj34KkWGiDtI6zJdr2B",
    genre: "",
    popularity: "0",
  },
  {
    name: "Bruno Vansina",
    image: "https://i.scdn.co/image/ab67616d0000b2735769e4ace6808bc98a76c248",
    spotify: "0BHx5O032LVTy0LtQVhufB",
    genre: "belgian modern jazz",
    popularity: "0",
  },
  {
    name: "Catherine ten Bruggencate",
    image: "https://i.scdn.co/image/ab67616d0000b273a2b4c6fb26bc6462cc983db2",
    spotify: "6B7VxHTtgziv8mQDj8wddA",
    genre: "",
    popularity: "0",
  },
  {
    name: "Erwin De Nul",
    image: "",
    spotify: "7FQA1qEnTowNb6zsKYXlPx",
    genre: "",
    popularity: "0",
  },
  {
    name: "Leadbeaters",
    image: "https://i.scdn.co/image/ab67616d0000b2730e4e1a3f845ed02357da23a4",
    spotify: "0NCAW9dP1JyZg0idsKw8Uf",
    genre: "",
    popularity: "0",
  },
  {
    name: "Nathan Anderson",
    image: "https://i.scdn.co/image/ab67616d0000b273aad4ce94134194bc969439fb",
    spotify: "3wB8uSJUR9uMGW3we0itsJ",
    genre: "guitar case",
    popularity: "0",
  },
  {
    name: "Alek et les japonaises",
    image: "",
    spotify: "4GvmVe5wcbgHJgZfW3qq6x",
    genre: "",
    popularity: "0",
  },
  {
    name: "Gerbert Vos",
    image: "https://i.scdn.co/image/131a7a8f62e6111f0078c830d8c5be6d51c688d8",
    spotify: "7ouEf47bHLWC0kXNajbQuy",
    genre: "",
    popularity: "0",
  },
  {
    name: "Umeme Afrorave",
    image: "",
    spotify: "1VKcpPkpPrTIQn2sXQDhFh",
    genre: "",
    popularity: "0",
  },
  {
    name: "Venus Tropicaux",
    image: "https://i.scdn.co/image/ab67616d0000b2735589360f27d17f086f84085d",
    spotify: "2N7vouNh46DkgcVDoOnpy5",
    genre: "",
    popularity: "0",
  },
  {
    name: "Forever Saturday",
    image: "https://i.scdn.co/image/877936266aad20f40586db6940bb3fd1ca1cd327",
    spotify: "5vgXg9qR6sGInrZ9J7LRgs",
    genre: "",
    popularity: "0",
  },
  {
    name: "Ahmet Kaplan",
    image: "https://i.scdn.co/image/ab67616d0000b273e22e87c59fc3ad5d2e9cbb9a",
    spotify: "6gtOQV1zH0wAWwg5hINFJf",
    genre: "",
    popularity: "0",
  },
  {
    name: "Wasdaman",
    image: "https://i.scdn.co/image/75e1689426ececa99d6202db2fb66fa09a750ca2",
    spotify: "76EaqiXHUkopwDTVZ9fTRl",
    genre: "",
    popularity: "0",
  },
  {
    name: "Melvo Baptiste",
    image: "https://i.scdn.co/image/2a6e01851514ae4b43d71ea2521e87207e06cf02",
    spotify: "1QpOH83Mq6hEUPnLudxPw6",
    genre: "",
    popularity: "0",
  },
  {
    name: "Ben Fresh",
    image: "https://i.scdn.co/image/5ff496864717e42a276c41f83dc5bc6b8a4e4748",
    spotify: "0Pe81Yrpee4hNQNNJHQx4j",
    genre: "",
    popularity: "0",
  },
  {
    name: "Sascha Elisah",
    image: "https://i.scdn.co/image/5ec586f103cef6f05884ef1301d6230751064685",
    spotify: "3jlA7m32EncmTv53rbjrTA",
    genre: "",
    popularity: "0",
  },
  {
    name: "Basokin",
    image: "",
    spotify: "4pNYQAGbEFPQfxl9C2N9vR",
    genre: "",
    popularity: "0",
  },
  {
    name: "Marco Franica",
    image: "https://i.scdn.co/image/ab67616d0000b273b866b8abc1e1646ddd174004",
    spotify: "0WBybUp5rjdbzjXknyM5wF",
    genre: "",
    popularity: "0",
  },
  {
    name: "Ivo Gleeman",
    image: "https://i.scdn.co/image/ab67616d0000b2737433908a5e0dc5fc1eb7e8d6",
    spotify: "0XiFbmYlmyCvENzKBDgbbH",
    genre: "",
    popularity: "0",
  },
  {
    name: "Obsequies",
    image: "https://i.scdn.co/image/ab67616d0000b273bfdd069b2a4d804072e33b6d",
    spotify: "0HwpSi2Z6RbDnjDH8QJDFz",
    genre: "",
    popularity: "0",
  },
  {
    name: "AMEKMAR",
    image: "https://i.scdn.co/image/467ab9693b8e6ed0e0cf0fc9d35400360b696f1f",
    spotify: "3oMEjJviKTWvEI5ExmrSZi",
    genre: "",
    popularity: "0",
  },
  {
    name: "Meneer van Dalen",
    image: "https://i.scdn.co/image/ab67616d0000b273621def7b81eddab68f0919a3",
    spotify: "3hs4YZY9zjJWUUIruCpOkn",
    genre: "",
    popularity: "0",
  },
  {
    name: "Colin Sutton",
    image: "https://i.scdn.co/image/ab67616d0000b273717a88e82cbd81ea705cd84d",
    spotify: "1WQ9Rhe3GRMKzhVd4Fe7eV",
    genre: "",
    popularity: "0",
  },
  {
    name: "Terry Nash",
    image: "https://i.scdn.co/image/ab67616d0000b27357ddc4874c3ecf9a0b0dcd08",
    spotify: "1Ueg4UX0gk81YScetw5RPE",
    genre: "",
    popularity: "0",
  },
  {
    name: "Fiesta Cubana",
    image: "",
    spotify: "2vyaI8jgS1MuH3kPHf2Lv3",
    genre: "",
    popularity: "0",
  },
  {
    name: "Gangsta Alliance",
    image: "",
    spotify: "5kcdjHlkuAQ26h2v4sLk7U",
    genre: "",
    popularity: "0",
  },
  {
    name: "Datasmok",
    image: "https://i.scdn.co/image/ab67616d0000b27380506a8d6635b8990323c505",
    spotify: "5lsiGZ9s13aBoktJeY5hW8",
    genre: "",
    popularity: "0",
  },
  {
    name: "Simon Halsberghe",
    image: "https://i.scdn.co/image/ab67616d0000b2733a08ebe315db39c5d0aa4003",
    spotify: "4ofR27LsybAmBkjbicpIaA",
    genre: "",
    popularity: "0",
  },
  {
    name: "Luca Fabiani",
    image: "https://i.scdn.co/image/ab67616d0000b2731abdd7e3ed4abf42e641b9bd",
    spotify: "3ST4maelBCoLgEpHIjpT6d",
    genre: "",
    popularity: "0",
  },
  {
    name: "Freestyle Steve",
    image: "",
    spotify: "1We3ojMbZ7mP5zDLszG4d2",
    genre: "",
    popularity: "0",
  },
  {
    name: "T. Raumschmiere",
    image: "",
    spotify: "3t2ke6TrLmXQDPUBS4eskA",
    genre: "",
    popularity: "0",
  },
  {
    name: "Emily Jeanne",
    image: "",
    spotify: "0trOCpXiAd7eN8evyVZgtC",
    genre: "",
    popularity: "0",
  },
  {
    name: "Aron Friedman",
    image: "https://i.scdn.co/image/ab67616d0000b273b6bcadb75b5df398ceb69df7",
    spotify: "3npuZEAWdWk9QeZk3AQlzP",
    genre: "",
    popularity: "0",
  },
  {
    name: "Imagine Raymond",
    image: "https://i.scdn.co/image/ab67616d0000b273f05ba46687ca7c12f596c761",
    spotify: "01o9eRQ6VkUzcWUm0HUxCo",
    genre: "",
    popularity: "0",
  },
  {
    name: "Disciple Round Table",
    image: "https://i.scdn.co/image/a6205a3fb9a74a60a145fdf9d2cb85961ed704a6",
    spotify: "3xwoHdF1kmT1p9CcaN2q60",
    genre: "",
    popularity: "0",
  },
  {
    name: "Wieke Garcia",
    image: "https://i.scdn.co/image/829efe96c5e6f98b4f435d31ecb61da58d3690f3",
    spotify: "4upv4CFFuybpKbBD8qXNy6",
    genre: "",
    popularity: "0",
  },
  {
    name: "Total Heels",
    image: "https://i.scdn.co/image/ab67616d0000b2731a73267b1a81d1146c9f4d15",
    spotify: "2Asv5Wk37pBHJVxfMCCSY0",
    genre: "",
    popularity: "0",
  },
  {
    name: "Natty Wailer",
    image: "https://i.scdn.co/image/ab67616d0000b27345ef8e8879f83a82d77abcd9",
    spotify: "7xArV29GEjIOM5DA6lDXpK",
    genre: "",
    popularity: "0",
  },
  {
    name: "Danny Owen",
    image: "https://i.scdn.co/image/ab67616d0000b27368ca3cbdd25b0c9c07ce4636",
    spotify: "3pbSsR2aONSjft197ZYiSQ",
    genre: "",
    popularity: "0",
  },
  {
    name: "Nick Lynar",
    image: "https://i.scdn.co/image/ab67616d0000b27319ed09460a61285ac1eb6d72",
    spotify: "4UwwZaPyZse0sOFZGimkd8",
    genre: "",
    popularity: "0",
  },
  {
    name: "Sean Gascoigne",
    image: "https://i.scdn.co/image/6b2c85b69be8dc8adeef0e7ce65960e58aff131f",
    spotify: "5Cp3TpmNrVODpdwwAF0UUH",
    genre: "",
    popularity: "0",
  },
  {
    name: "Bluntspeakers",
    image: "https://i.scdn.co/image/22dd3478e815048a6d986776d09c8665bd46beeb",
    spotify: "1z3dio09h7XL7kOTLon15c",
    genre: "",
    popularity: "0",
  },
  {
    name: "Las Medicinas",
    image: "https://i.scdn.co/image/ab67616d0000b2732791c0a5e53353c2f9538067",
    spotify: "2PRHpfvDs6cDh3I0cCXCtn",
    genre: "",
    popularity: "0",
  },
  {
    name: "Shayne Tino",
    image: "",
    spotify: "29daopHKgDc93bwHo4tQHU",
    genre: "",
    popularity: "0",
  },
  {
    name: "Shane Gobi",
    image: "",
    spotify: "25TbPNe7orhgayovMgp549",
    genre: "",
    popularity: "0",
  },
  {
    name: "Tim Grand",
    image: "",
    spotify: "5s7hwju24qO7raJrUEYsON",
    genre: "",
    popularity: "0",
  },
  {
    name: "Pieter Jansen",
    image: "",
    spotify: "3xCX08An2J10xEEUyVo6S1",
    genre: "",
    popularity: "0",
  },
  {
    name: "S.T. Cordell",
    image: "https://i.scdn.co/image/1ad71d233b145ec23b967b67e943dd41825c8bca",
    spotify: "38DMfsY1xgH0afp9ZPeZPH",
    genre: "",
    popularity: "0",
  },
  {
    name: "Paul Haigh",
    image: "",
    spotify: "09FPNJI1ZLJ3QUtMlFnj5h",
    genre: "",
    popularity: "0",
  },
  {
    name: "Amber Topaz",
    image: "https://i.scdn.co/image/ab67616d0000b273c1d98c10aa3fabfd5ceeead5",
    spotify: "4fFIjukyEg75H1wJ7boLUC",
    genre: "",
    popularity: "0",
  },
  {
    name: "Niels van der Zanden",
    image: "",
    spotify: "4rb5AxjC2ckTQkHXw9NIPc",
    genre: "",
    popularity: "0",
  },
  {
    name: "Nkumba System",
    image: "https://i.scdn.co/image/ab67616d0000b27370d0cb0c05cca79c11063836",
    spotify: "0loywJyQKHumjO5lKkQ8zJ",
    genre: "",
    popularity: "0",
  },
  {
    name: "Han Reiziger",
    image: "",
    spotify: "4TZEeTmcO7R9r2mQj5PJCj",
    genre: "",
    popularity: "0",
  },
  {
    name: "The Jaydes",
    image: "https://i.scdn.co/image/ab67616d0000b27313b8ab67d29244da8c9996b7",
    spotify: "6qovm2koKxA8SZu3bQf0hu",
    genre: "",
    popularity: "0",
  },
  {
    name: "Nathan Homan",
    image: "",
    spotify: "7s9a0v2zdxqNSimcUyjVob",
    genre: "",
    popularity: "0",
  },
  {
    name: "House of Dolls",
    image: "https://i.scdn.co/image/ab67616d0000b273cd4d0bf961a1966f9fb1ce45",
    spotify: "7vLBq7eJkwJQFqE5GGZkg0",
    genre: "",
    popularity: "0",
  },
  {
    name: "Schwarzmann",
    image: "https://i.scdn.co/image/ab67616d0000b273452aaab0ddc3111936de3348",
    spotify: "2auBHUFlXsgCtLHWWEzNSe",
    genre: "",
    popularity: "0",
  },
  {
    name: "Ron Albrecht",
    image: "https://i.scdn.co/image/ab67616d0000b27394bd39a5b8fe766bbdea4ac7",
    spotify: "6Bpr3a3XD8N8WiULyluJ1g",
    genre: "",
    popularity: "0",
  },
  {
    name: "Moombahbaas",
    image: "https://i.scdn.co/image/c4dc971d8d0a5a583d078c5166fae6d3194f2532",
    spotify: "0EVyLj9QkglQqnttaHfzyt",
    genre: "",
    popularity: "0",
  },
  {
    name: "Sandra Timmerman",
    image: "https://i.scdn.co/image/ab67616d0000b27384979e25bed1dae74774b298",
    spotify: "01KETohS6Q317e67eqf3sK",
    genre: "",
    popularity: "0",
  },
  {
    name: "Nakul Krishnamurthy",
    image: "https://i.scdn.co/image/ab67616d0000b2730e1fde0d126dbdc90acdc789",
    spotify: "6YApW8MyaIdpgsIYAopDkg",
    genre: "",
    popularity: "0",
  },
  {
    name: "Anstascia",
    image: "",
    spotify: "2L2O6T1U6F5nut69qxZ88y",
    genre: "",
    popularity: "0",
  },
  {
    name: "Cirrus Minor",
    image: "https://i.scdn.co/image/ab67616d0000b27397445ec0c2042340953941e0",
    spotify: "15LYVQw94HUQcdVp7I5r0M",
    genre: "",
    popularity: "0",
  },
  {
    name: "NEOS Brass",
    image: "https://i.scdn.co/image/ab67616d0000b273ed7d027da0036c40c2ab01f0",
    spotify: "2tMnkLuck9y322Qqys4d5y",
    genre: "",
    popularity: "0",
  },
  {
    name: "Severin Bells",
    image: "https://i.scdn.co/image/ccab985ccedf92efc0bf01cc1e592e912e8dbec7",
    spotify: "4xwC98GtksY11PltmCnagp",
    genre: "",
    popularity: "0",
  },
  {
    name: "Massimo Mephisto",
    image: "https://i.scdn.co/image/ab67616d0000b273202a89813fd900521037ddb5",
    spotify: "4Xtti7RzWYFAUDBBdaD4NI",
    genre: "belgian techno",
    popularity: "0",
  },
  {
    name: "Disco Troopers",
    image: "https://i.scdn.co/image/ab67616d0000b2735b3e32bc7bf6a522783dbd79",
    spotify: "3pRPbgZcq9rJb41tdl8xWK",
    genre: "",
    popularity: "0",
  },
  {
    name: "PsykoKnot",
    image: "https://i.scdn.co/image/a1cb0e0d52129193ebc5b2b3a7a28201adfb4cfe",
    spotify: "6re5LaktEWadERuq77AgyR",
    genre: "",
    popularity: "0",
  },
  {
    name: "Perfect Friction",
    image: "https://i.scdn.co/image/ab67616d0000b273e91631ca5f64281e09425aa7",
    spotify: "0OmKHWWSTApOb8OQbIE5Rb",
    genre: "",
    popularity: "0",
  },
  {
    name: "NONEXISTENT",
    image: "https://i.scdn.co/image/ab67616d0000b273eccbe27be710826195da04c3",
    spotify: "0qcJPKgfZSiyQMCz5omSCx",
    genre: "",
    popularity: "0",
  },
];



// WEBPACK FOOTER //
// src/views/roster/list_2.js